/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Client, OperationContext } from '@urql/core';
import gql from 'graphql-tag';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ActionNodeJobEnvironment: { input: any; output: any; }
  ActionNodeJobStatus: { input: any; output: any; }
  ActionNodeJobTrigger: { input: any; output: any; }
  ActionNodeJobType: { input: any; output: any; }
  AppletCategory: { input: any; output: any; }
  AppletStatus: { input: any; output: any; }
  AppletType: { input: any; output: any; }
  ConsentStatus: { input: any; output: any; }
  CustomAuthMethodType: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DomainType: { input: any; output: any; }
  DomainVerificationStatus: { input: any; output: any; }
  EnvironmentStatus: { input: any; output: any; }
  JSON: { input: any; output: any; }
  PackageType: { input: any; output: any; }
  PasswordRecoveryStatus: { input: any; output: any; }
  PypeEnvironment: { input: any; output: any; }
  RuleCreationType: { input: any; output: any; }
  SolutionType: { input: any; output: any; }
  SolutionVersionStatus: { input: any; output: any; }
  StudioResourceType: { input: any; output: any; }
  Upload: { input: any; output: any; }
  VariableAccessLevel: { input: any; output: any; }
  app_loader_jsonb: { input: any; output: any; }
  app_loader_uuid: { input: any; output: any; }
  float8: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
};

export enum Accept {
  Applicationjson = 'applicationjson',
  Textcsv = 'textcsv'
}

export type Account = {
  __typename?: 'Account';
  accountAuthMethodSettings?: Maybe<Array<Maybe<AccountAuthMethodSettings>>>;
  accountManagerId?: Maybe<Scalars['String']['output']>;
  allChildAccounts?: Maybe<Array<Maybe<Account>>>;
  allParentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customAuthMethods?: Maybe<Array<Maybe<CustomAuthMethod>>>;
  id?: Maybe<Scalars['ID']['output']>;
  immediateChildAccounts?: Maybe<Array<Maybe<Account>>>;
  isManaged?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentAccount?: Maybe<Account>;
  parentId?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  pictureFile?: Maybe<File>;
  projects?: Maybe<PaginatedProjects>;
  roles?: Maybe<PaginatedRoles>;
  settings?: Maybe<Scalars['JSON']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AccountStatus>;
  teams?: Maybe<PaginatedTeams>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<PaginatedUsers>;
  variables?: Maybe<Array<Maybe<Variable>>>;
};


export type AccountProjectsArgs = {
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type AccountRolesArgs = {
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type AccountTeamsArgs = {
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type AccountUsersArgs = {
  queryMetadata?: InputMaybe<QueryMetadata>;
};

export type AccountAuthMethodSettings = {
  __typename?: 'AccountAuthMethodSettings';
  accountId?: Maybe<Scalars['String']['output']>;
  authMethodId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customAuthMethodId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  settings?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountAuthMethodSettingsInput = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
};

export enum AccountStatus {
  Active = 'ACTIVE',
  Locked = 'LOCKED'
}

export type AccountsFilter = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  includeManaged?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnmanaged?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Action = {
  __typename?: 'Action';
  appletInstance?: Maybe<AppletInstance>;
  appletInstanceId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latestVersionWhileCreating?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Scalars['JSON']['output']>;
  package?: Maybe<Package>;
  packageId?: Maybe<Scalars['String']['output']>;
  packageVersion?: Maybe<PackageVersion>;
  packageVersionId?: Maybe<Scalars['String']['output']>;
};

export type ActionCreate = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['String']['input'];
  packageVersionId?: InputMaybe<Scalars['String']['input']>;
};

export type ActionNodeAutoscalingConfig = {
  __typename?: 'ActionNodeAutoscalingConfig';
  maxScale: Scalars['Int']['output'];
  minScale: Scalars['Int']['output'];
  targetRPS: Scalars['Int']['output'];
};

export type ActionNodeAutoscalingConfigInput = {
  maxScale: Scalars['Int']['input'];
  minScale: Scalars['Int']['input'];
  targetRPS: Scalars['Int']['input'];
};

export type ActionNodeAutoscalingInput = {
  live: ActionNodeAutoscalingConfigInput;
  sandbox: ActionNodeAutoscalingConfigInput;
};

export type ActionNodeEnvironmentConfig = {
  __typename?: 'ActionNodeEnvironmentConfig';
  autoscaling: ActionNodeAutoscalingConfig;
  inSync?: Maybe<Scalars['Boolean']['output']>;
  timeoutSeconds: Scalars['Int']['output'];
};

export type ActionNodeJob = {
  __typename?: 'ActionNodeJob';
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  finishedOn?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  jobType?: Maybe<ActionNodeJobTypeEnum>;
  payload?: Maybe<Scalars['JSON']['output']>;
  runtime?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  solution?: Maybe<ActionNodeJobSolution>;
  solutionId?: Maybe<Scalars['String']['output']>;
  solutionVersion?: Maybe<ActionNodeJobSolutionVersion>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ActionNodeJobStatusEnum>;
  trigger?: Maybe<ActionNodeJobTriggerEnum>;
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type ActionNodeJobConnection = {
  __typename?: 'ActionNodeJobConnection';
  nodes: Array<ActionNodeJob>;
  pageInfo: ActionNodeJobPageInfo;
};

/** Boolean expression to compare columns of type "ActionNodeJobEnvironment". All fields are combined with logical 'AND'. */
export type ActionNodeJobEnvironment_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['ActionNodeJobEnvironment']['input']>;
  _gt?: InputMaybe<Scalars['ActionNodeJobEnvironment']['input']>;
  _gte?: InputMaybe<Scalars['ActionNodeJobEnvironment']['input']>;
  _in?: InputMaybe<Array<Scalars['ActionNodeJobEnvironment']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['ActionNodeJobEnvironment']['input']>;
  _lte?: InputMaybe<Scalars['ActionNodeJobEnvironment']['input']>;
  _neq?: InputMaybe<Scalars['ActionNodeJobEnvironment']['input']>;
  _nin?: InputMaybe<Array<Scalars['ActionNodeJobEnvironment']['input']>>;
};

export type ActionNodeJobPageInfo = {
  __typename?: 'ActionNodeJobPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type ActionNodeJobSolution = {
  __typename?: 'ActionNodeJobSolution';
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ActionNodeJobSolutionVersion = {
  __typename?: 'ActionNodeJobSolutionVersion';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export enum ActionNodeJobStatusEnum {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Retrying = 'RETRYING',
  Success = 'SUCCESS',
  TimedOut = 'TIMED_OUT'
}

/** Boolean expression to compare columns of type "ActionNodeJobStatus". All fields are combined with logical 'AND'. */
export type ActionNodeJobStatus_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['ActionNodeJobStatus']['input']>;
  _gt?: InputMaybe<Scalars['ActionNodeJobStatus']['input']>;
  _gte?: InputMaybe<Scalars['ActionNodeJobStatus']['input']>;
  _in?: InputMaybe<Array<Scalars['ActionNodeJobStatus']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['ActionNodeJobStatus']['input']>;
  _lte?: InputMaybe<Scalars['ActionNodeJobStatus']['input']>;
  _neq?: InputMaybe<Scalars['ActionNodeJobStatus']['input']>;
  _nin?: InputMaybe<Array<Scalars['ActionNodeJobStatus']['input']>>;
};

export enum ActionNodeJobTriggerEnum {
  PackagesUpdated = 'PACKAGES_UPDATED',
  ProjectCreated = 'PROJECT_CREATED',
  ProjectDeleted = 'PROJECT_DELETED',
  ProjectUpdated = 'PROJECT_UPDATED',
  RuntimeConfigUpdated = 'RUNTIME_CONFIG_UPDATED',
  SolutionPublished = 'SOLUTION_PUBLISHED',
  Unknown = 'UNKNOWN'
}

/** Boolean expression to compare columns of type "ActionNodeJobTrigger". All fields are combined with logical 'AND'. */
export type ActionNodeJobTrigger_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['ActionNodeJobTrigger']['input']>;
  _gt?: InputMaybe<Scalars['ActionNodeJobTrigger']['input']>;
  _gte?: InputMaybe<Scalars['ActionNodeJobTrigger']['input']>;
  _in?: InputMaybe<Array<Scalars['ActionNodeJobTrigger']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['ActionNodeJobTrigger']['input']>;
  _lte?: InputMaybe<Scalars['ActionNodeJobTrigger']['input']>;
  _neq?: InputMaybe<Scalars['ActionNodeJobTrigger']['input']>;
  _nin?: InputMaybe<Array<Scalars['ActionNodeJobTrigger']['input']>>;
};

export enum ActionNodeJobTypeEnum {
  Build = 'BUILD',
  BuildFunction = 'BUILD_FUNCTION',
  RemoveFunction = 'REMOVE_FUNCTION',
  UpdateConfigs = 'UPDATE_CONFIGS',
  UpdateResources = 'UPDATE_RESOURCES'
}

/** Boolean expression to compare columns of type "ActionNodeJobType". All fields are combined with logical 'AND'. */
export type ActionNodeJobType_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['ActionNodeJobType']['input']>;
  _gt?: InputMaybe<Scalars['ActionNodeJobType']['input']>;
  _gte?: InputMaybe<Scalars['ActionNodeJobType']['input']>;
  _in?: InputMaybe<Array<Scalars['ActionNodeJobType']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['ActionNodeJobType']['input']>;
  _lte?: InputMaybe<Scalars['ActionNodeJobType']['input']>;
  _neq?: InputMaybe<Scalars['ActionNodeJobType']['input']>;
  _nin?: InputMaybe<Array<Scalars['ActionNodeJobType']['input']>>;
};

export type ActionNodePackage = {
  __typename?: 'ActionNodePackage';
  name?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ActionNodePackageInput = {
  name: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type ActionNodePackages = {
  __typename?: 'ActionNodePackages';
  live?: Maybe<Array<Maybe<ActionNodePackage>>>;
  sandbox?: Maybe<Array<Maybe<ActionNodePackage>>>;
};

export type ActionNodePackagesInput = {
  live?: InputMaybe<Array<ActionNodePackageInput>>;
  sandbox?: InputMaybe<Array<ActionNodePackageInput>>;
};

export type ActionNodePresence = {
  __typename?: 'ActionNodePresence';
  count: Scalars['Int']['output'];
  found: Scalars['Boolean']['output'];
  synced: Scalars['Int']['output'];
};

export type ActionNodeResourceValues = {
  __typename?: 'ActionNodeResourceValues';
  cpuRequest?: Maybe<Scalars['Float']['output']>;
  ramRequest?: Maybe<Scalars['Float']['output']>;
};

export type ActionNodeResourceValuesInput = {
  cpuRequest?: InputMaybe<Scalars['Float']['input']>;
  ramRequest?: InputMaybe<Scalars['Float']['input']>;
};

export type ActionNodeResources = {
  __typename?: 'ActionNodeResources';
  live?: Maybe<ActionNodeResourceValues>;
  sandbox?: Maybe<ActionNodeResourceValues>;
};

export type ActionNodeResourcesInput = {
  live?: InputMaybe<ActionNodeResourceValuesInput>;
  sandbox?: InputMaybe<ActionNodeResourceValuesInput>;
};

export type ActionNodeRuntimeConfig = {
  __typename?: 'ActionNodeRuntimeConfig';
  live?: Maybe<ActionNodeEnvironmentConfig>;
  sandbox?: Maybe<ActionNodeEnvironmentConfig>;
};

export type ActionNodeRuntimeStatus = {
  __typename?: 'ActionNodeRuntimeStatus';
  hasActiveResources: Scalars['Boolean']['output'];
  live: ActionNodePresence;
  sandbox: ActionNodePresence;
};

export type ActionNodeTimeoutInput = {
  live: Scalars['Int']['input'];
  sandbox: Scalars['Int']['input'];
};

export type AgentManagerFile = {
  __typename?: 'AgentManagerFile';
  branch?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisationName?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  repositoryName?: Maybe<Scalars['String']['output']>;
  sha?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum AgentRouting {
  ExternalAgent = 'external_agent',
  Freshchat = 'freshchat',
  Nuance = 'nuance',
  Pypestream = 'pypestream',
  Salesforce = 'salesforce'
}

export type AgentRoutingSchema = {
  __typename?: 'AgentRoutingSchema';
  agent_routing?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['JSON']['output']>;
};

export type AgentRoutingSchemas = {
  __typename?: 'AgentRoutingSchemas';
  data?: Maybe<Array<Maybe<AgentRoutingSchema>>>;
};

export type AllTeamsForProject = {
  __typename?: 'AllTeamsForProject';
  accountId?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Maybe<Team>>>;
};

export type AllUsersForProject = {
  __typename?: 'AllUsersForProject';
  accountId?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  date_created?: Maybe<Scalars['Int']['output']>;
  date_updated?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  friendly_name?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
};

export type ApiKeyDetail = {
  __typename?: 'ApiKeyDetail';
  date_created?: Maybe<Scalars['Int']['output']>;
  date_updated?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  friendly_name?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ApiKeyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  friendlyName: Scalars['String']['input'];
};

export type ApiKeyUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeys = {
  __typename?: 'ApiKeys';
  keys?: Maybe<Array<Maybe<ApiKeyDetail>>>;
};

export type Applet = {
  __typename?: 'Applet';
  appletCategory: AppletCategoryEnum;
  appletType: AppletTypeEnum;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<File>;
  id: Scalars['ID']['output'];
  latestVersion?: Maybe<AppletVersion>;
  latestVersionId?: Maybe<Scalars['String']['output']>;
  pkgName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versions?: Maybe<Array<Maybe<AppletVersion>>>;
};

export enum AppletCategoryEnum {
  Integration = 'INTEGRATION',
  Interface = 'INTERFACE',
  Other = 'OTHER'
}

/** Boolean expression to compare columns of type "AppletCategory". All fields are combined with logical 'AND'. */
export type AppletCategory_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['AppletCategory']['input']>;
  _gt?: InputMaybe<Scalars['AppletCategory']['input']>;
  _gte?: InputMaybe<Scalars['AppletCategory']['input']>;
  _in?: InputMaybe<Array<Scalars['AppletCategory']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['AppletCategory']['input']>;
  _lte?: InputMaybe<Scalars['AppletCategory']['input']>;
  _neq?: InputMaybe<Scalars['AppletCategory']['input']>;
  _nin?: InputMaybe<Array<Scalars['AppletCategory']['input']>>;
};

export type AppletInstance = {
  __typename?: 'AppletInstance';
  actions: Array<Maybe<Action>>;
  applet: AppletVersion;
  appletVersionId: Scalars['String']['output'];
  condition?: Maybe<Condition>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['JSON']['output']>;
  projectEnvironmentConfig: ProjectEnvironmentConfig;
  projectEnvironmentConfigId: Scalars['String']['output'];
  shortId?: Maybe<Scalars['String']['output']>;
  status: AppletStatusEnum;
  triggers: Array<Maybe<Trigger>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedByUser?: Maybe<User>;
};

export enum AppletStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "AppletStatus". All fields are combined with logical 'AND'. */
export type AppletStatus_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['AppletStatus']['input']>;
  _gt?: InputMaybe<Scalars['AppletStatus']['input']>;
  _gte?: InputMaybe<Scalars['AppletStatus']['input']>;
  _in?: InputMaybe<Array<Scalars['AppletStatus']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['AppletStatus']['input']>;
  _lte?: InputMaybe<Scalars['AppletStatus']['input']>;
  _neq?: InputMaybe<Scalars['AppletStatus']['input']>;
  _nin?: InputMaybe<Array<Scalars['AppletStatus']['input']>>;
};

export enum AppletTypeEnum {
  Analytics = 'ANALYTICS',
  Custom = 'CUSTOM',
  Pype = 'PYPE'
}

/** Boolean expression to compare columns of type "AppletType". All fields are combined with logical 'AND'. */
export type AppletType_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['AppletType']['input']>;
  _gt?: InputMaybe<Scalars['AppletType']['input']>;
  _gte?: InputMaybe<Scalars['AppletType']['input']>;
  _in?: InputMaybe<Array<Scalars['AppletType']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['AppletType']['input']>;
  _lte?: InputMaybe<Scalars['AppletType']['input']>;
  _neq?: InputMaybe<Scalars['AppletType']['input']>;
  _nin?: InputMaybe<Array<Scalars['AppletType']['input']>>;
};

export type AppletVersion = {
  __typename?: 'AppletVersion';
  applet: Applet;
  appletId: Scalars['String']['output'];
  appletInstances?: Maybe<Array<Maybe<AppletInstance>>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  relatedApplet?: Maybe<Applet>;
  schema: Scalars['JSON']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['String']['output'];
};

export type Asset = {
  __typename?: 'Asset';
  data: Scalars['JSON']['output'];
};

export type AuditLog = {
  __typename?: 'AuditLog';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['String']['output']>;
  applicationId?: Maybe<Scalars['String']['output']>;
  auditLogDetail?: Maybe<AuditLogDetail>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']['output']>;
  relationDetails?: Maybe<Array<Maybe<AuditLogRelationDetail>>>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AuditLogDetail = {
  __typename?: 'AuditLogDetail';
  displayMessage?: Maybe<Scalars['String']['output']>;
};

export type AuditLogRelationDetail = {
  __typename?: 'AuditLogRelationDetail';
  displayMessage?: Maybe<Scalars['String']['output']>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  operation?: Maybe<Scalars['String']['output']>;
};

export type AuditLogsFilter = {
  accountId: Scalars['String']['input'];
  actingUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AuthMethod = {
  __typename?: 'AuthMethod';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
};

export enum AuthMethodTypeEnum {
  Default = 'DEFAULT',
  Oidc = 'OIDC',
  Saml = 'SAML'
}

export type AutoresponderSetting = {
  __typename?: 'AutoresponderSetting';
  enable?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type AutoresponderSettingInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type Autoresponders = {
  __typename?: 'Autoresponders';
  busy?: Maybe<AutoresponderSetting>;
  offline?: Maybe<AutoresponderSetting>;
  technical_error?: Maybe<AutoresponderSetting>;
};

export type AutorespondersInput = {
  busy?: InputMaybe<AutoresponderSettingInput>;
  offline?: InputMaybe<AutoresponderSettingInput>;
  technicalError?: InputMaybe<AutoresponderSettingInput>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type Bot = {
  __typename?: 'Bot';
  data: Scalars['JSON']['output'];
};

export type Bot2Input = {
  actionNodeService?: InputMaybe<Scalars['String']['input']>;
  botTemplateLanguage?: InputMaybe<Scalars['String']['input']>;
  botType?: InputMaybe<Scalars['String']['input']>;
  translateInput?: InputMaybe<Scalars['Boolean']['input']>;
  translateOutput?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BotAssetsInput = {
  assetData: Array<InputMaybe<Scalars['Upload']['input']>>;
};

export type BotManagerCustomer = {
  __typename?: 'BotManagerCustomer';
  data: Scalars['JSON']['output'];
};

export type BotPypesResponseBe = {
  __typename?: 'BotPypesResponseBE';
  agent_routing?: Maybe<Scalars['String']['output']>;
  agent_routing_url?: Maybe<Scalars['String']['output']>;
  agents_can_initiate_chats?: Maybe<Scalars['Boolean']['output']>;
  auto_joinable?: Maybe<Scalars['Boolean']['output']>;
  bot_retry?: Maybe<BotRetryBe>;
  bot_url?: Maybe<Scalars['String']['output']>;
  broadcast_stream_id?: Maybe<Scalars['String']['output']>;
  chat_default_limit?: Maybe<Scalars['Int']['output']>;
  chat_log_http_headers?: Maybe<Scalars['String']['output']>;
  chat_logs_email?: Maybe<Scalars['String']['output']>;
  chat_logs_email_enabled?: Maybe<Scalars['Boolean']['output']>;
  chat_logs_end_point?: Maybe<Scalars['String']['output']>;
  chat_logs_http_enabled?: Maybe<Scalars['Boolean']['output']>;
  checklist_complete?: Maybe<Scalars['Boolean']['output']>;
  company_type?: Maybe<Scalars['String']['output']>;
  config?: Maybe<PypeConfigBe>;
  creation_date?: Maybe<Scalars['Float']['output']>;
  crm_enabled?: Maybe<Scalars['Boolean']['output']>;
  crm_label?: Maybe<Scalars['String']['output']>;
  crm_url?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  encrypted?: Maybe<Scalars['Boolean']['output']>;
  end_comment_display?: Maybe<Scalars['Boolean']['output']>;
  end_comment_required?: Maybe<Scalars['Boolean']['output']>;
  end_tags_display?: Maybe<Scalars['Boolean']['output']>;
  end_tags_required?: Maybe<Scalars['Boolean']['output']>;
  env?: Maybe<SolutionEnvironmentsEnum>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_updated?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo_generated?: Maybe<Scalars['Boolean']['output']>;
  masking_rules?: Maybe<Array<Maybe<SystemMaskingRulesBe>>>;
  mode?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  reroute_limit?: Maybe<Scalars['Int']['output']>;
  sf_deployment?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streams?: Maybe<Array<Maybe<PypeStreamBe>>>;
  system_masking_rules?: Maybe<Array<Maybe<SystemMaskingRulesBe>>>;
  tags_categories?: Maybe<Scalars['JSON']['output']>;
  tags_multiple?: Maybe<Scalars['Boolean']['output']>;
  tags_shortcuts?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  whitelist_domains?: Maybe<Scalars['String']['output']>;
  widget_branding?: Maybe<Scalars['Boolean']['output']>;
  widget_gateway_identifier?: Maybe<Scalars['String']['output']>;
  widget_version?: Maybe<Scalars['Int']['output']>;
};

export type BotRetry = {
  __typename?: 'BotRetry';
  attempts?: Maybe<Scalars['Int']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
};

export type BotRetryBe = {
  __typename?: 'BotRetryBE';
  attempts?: Maybe<Scalars['Int']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
};

export type BotRetryInput = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type BotVersionsInput = {
  basedOn?: InputMaybe<Scalars['String']['input']>;
};

export type BulkPypeUpdateInput = {
  pypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updates?: InputMaybe<PypeUpdateInput>;
};

export type BusinessWidget = {
  __typename?: 'BusinessWidget';
  betaUrl?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  creation_date?: Maybe<Scalars['Date']['output']>;
  custom_pype_css?: Maybe<Scalars['String']['output']>;
  enable_prechat?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_updated?: Maybe<Scalars['Date']['output']>;
  prechat_custom_field1_name?: Maybe<Scalars['String']['output']>;
  prechat_custom_field1_value?: Maybe<Scalars['String']['output']>;
  prechat_custom_field2_name?: Maybe<Scalars['String']['output']>;
  prechat_custom_field2_value?: Maybe<Scalars['String']['output']>;
  prechat_email?: Maybe<Scalars['String']['output']>;
  prechat_firstname?: Maybe<Scalars['String']['output']>;
  prechat_lastname?: Maybe<Scalars['String']['output']>;
  prechat_msg?: Maybe<Scalars['String']['output']>;
  prechat_phone?: Maybe<Scalars['String']['output']>;
  pype_id?: Maybe<Scalars['String']['output']>;
  stream_id?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  whitelist?: Maybe<Scalars['String']['output']>;
  widget_name?: Maybe<Scalars['String']['output']>;
};

export type BusinessWidgetObject = {
  __typename?: 'BusinessWidgetObject';
  widget?: Maybe<BusinessWidget>;
};

export type BusinessWidgetResponse = {
  __typename?: 'BusinessWidgetResponse';
  correlation_id?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<BusinessWidgetObject>>>;
  detail?: Maybe<Scalars['String']['output']>;
  source_action?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ChannelCreationResponse = {
  __typename?: 'ChannelCreationResponse';
  botPypes?: Maybe<Array<Maybe<BotPypesResponseBe>>>;
  channelId?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  pypeId?: Maybe<Scalars['String']['output']>;
  pypeName?: Maybe<Scalars['String']['output']>;
};

export type ChannelSpeechConfig = {
  __typename?: 'ChannelSpeechConfig';
  barge_in?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  stt_model?: Maybe<Scalars['String']['output']>;
  tts_model?: Maybe<Scalars['String']['output']>;
  voice?: Maybe<Scalars['String']['output']>;
};

export type ChannelSpeechConfigInput = {
  bargeIn?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  sttModel: Scalars['String']['input'];
  ttsModel: Scalars['String']['input'];
  voice?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelSpeechCredentialInput = {
  apiKey: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};

export type ChannelSpeechInput = {
  speechConfig: ChannelSpeechConfigInput;
  speechCredentials: Array<ChannelSpeechCredentialInput>;
  speechEnabled: Scalars['Boolean']['input'];
};

export enum ChannelTypesEnum {
  Default = 'Default',
  Voice = 'Voice'
}

export type ChatLogEventBe = {
  __typename?: 'ChatLogEventBE';
  at: Scalars['Float']['output'];
  kind: Scalars['String']['output'];
};

export type ChatLogLineBe = {
  __typename?: 'ChatLogLineBE';
  app?: Maybe<Scalars['String']['output']>;
  at: Scalars['String']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  source: Scalars['JSON']['output'];
};

export type ChatLogRequestBe = {
  __typename?: 'ChatLogRequestBE';
  at: Scalars['Float']['output'];
  lastSaid?: Maybe<Scalars['String']['output']>;
  stopNode?: Maybe<Scalars['Int']['output']>;
  userInput?: Maybe<Scalars['String']['output']>;
};

export type Claims = {
  __typename?: 'Claims';
  envs?: Maybe<Array<Maybe<Env>>>;
  perms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roles?: Maybe<Array<Maybe<GesRole>>>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Condition = {
  __typename?: 'Condition';
  appletInstance?: Maybe<AppletInstance>;
  appletInstanceId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  options?: Maybe<Scalars['JSON']['output']>;
};

export type Config2Input = {
  freshchatApiVersion?: InputMaybe<Scalars['String']['input']>;
  freshchatAuthToken?: InputMaybe<Scalars['String']['input']>;
  freshchatHost?: InputMaybe<Scalars['String']['input']>;
  freshchatRequestTimeout?: InputMaybe<Scalars['String']['input']>;
  integrationHeaders?: InputMaybe<IntegrationHeadersInput>;
  integrationName?: InputMaybe<Scalars['String']['input']>;
  liveagentApiVersion?: InputMaybe<Scalars['String']['input']>;
  liveagentBotVersion?: InputMaybe<Scalars['String']['input']>;
  liveagentButtonId?: InputMaybe<Scalars['String']['input']>;
  liveagentDefaultFields?: InputMaybe<LiveagentDefaultFieldsInput>;
  liveagentDeploymentId?: InputMaybe<Scalars['String']['input']>;
  liveagentHost?: InputMaybe<Scalars['String']['input']>;
  liveagentLanguage?: InputMaybe<Scalars['String']['input']>;
  liveagentOrgId?: InputMaybe<Scalars['String']['input']>;
  liveagentRequestTimeout?: InputMaybe<Scalars['String']['input']>;
  nuanceAuthHost?: InputMaybe<Scalars['String']['input']>;
  nuanceCeapiHost?: InputMaybe<Scalars['String']['input']>;
  nuanceClientId?: InputMaybe<Scalars['String']['input']>;
  nuanceClientSecret?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigInput = {
  abcClientSecret?: InputMaybe<Scalars['String']['input']>;
  abcResponseType?: InputMaybe<Scalars['String']['input']>;
  abcScope?: InputMaybe<Scalars['String']['input']>;
  accessToken?: InputMaybe<Scalars['String']['input']>;
  accountAuthToken?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  accountSid?: InputMaybe<Scalars['String']['input']>;
  agentBotName?: InputMaybe<Scalars['String']['input']>;
  agentLiveChatTimes?: InputMaybe<Scalars['String']['input']>;
  agentName?: InputMaybe<Scalars['String']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  iceBreakers?: InputMaybe<Array<InputMaybe<IceBreakerInput>>>;
  inboxId?: InputMaybe<Scalars['String']['input']>;
  integrator?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  messagingServiceSid?: InputMaybe<Scalars['String']['input']>;
  noEmbed?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  speechConfig?: InputMaybe<SpeechConfigInput>;
  speechCredentials?: InputMaybe<Array<InputMaybe<SpeechCredentialInput>>>;
  twilioConfig?: InputMaybe<TwilioConfigInput>;
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

export type ConsentInfo = {
  __typename?: 'ConsentInfo';
  challenge?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['JSON']['output']>;
  requestUrl?: Maybe<Scalars['String']['output']>;
  requestedAccessTokenAudience?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requestedScope?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  skip?: Maybe<Scalars['Boolean']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export enum ConsentStatusEnum {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Seen = 'SEEN',
  Unknown = 'UNKNOWN'
}

/** Boolean expression to compare columns of type "ConsentStatus". All fields are combined with logical 'AND'. */
export type ConsentStatus_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['ConsentStatus']['input']>;
  _gt?: InputMaybe<Scalars['ConsentStatus']['input']>;
  _gte?: InputMaybe<Scalars['ConsentStatus']['input']>;
  _in?: InputMaybe<Array<Scalars['ConsentStatus']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['ConsentStatus']['input']>;
  _lte?: InputMaybe<Scalars['ConsentStatus']['input']>;
  _neq?: InputMaybe<Scalars['ConsentStatus']['input']>;
  _nin?: InputMaybe<Array<Scalars['ConsentStatus']['input']>>;
};

export type Country2 = {
  __typename?: 'Country2';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  iso3?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type CustomAuthMethod = {
  __typename?: 'CustomAuthMethod';
  accountId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailAttribute?: Maybe<Scalars['String']['output']>;
  entityIssuer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  issuerURL?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<CustomAuthMethodTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usernameAttribute?: Maybe<Scalars['String']['output']>;
};

export type CustomAuthMethodCreateInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  emailAttribute?: InputMaybe<Scalars['String']['input']>;
  entityIssuer?: InputMaybe<Scalars['String']['input']>;
  issuerURL: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  type: CustomAuthMethodTypeEnum;
  usernameAttribute?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomAuthMethodTypeEnum {
  Oidc = 'OIDC',
  Saml = 'SAML'
}

/** Boolean expression to compare columns of type "CustomAuthMethodType". All fields are combined with logical 'AND'. */
export type CustomAuthMethodType_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['CustomAuthMethodType']['input']>;
  _gt?: InputMaybe<Scalars['CustomAuthMethodType']['input']>;
  _gte?: InputMaybe<Scalars['CustomAuthMethodType']['input']>;
  _in?: InputMaybe<Array<Scalars['CustomAuthMethodType']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['CustomAuthMethodType']['input']>;
  _lte?: InputMaybe<Scalars['CustomAuthMethodType']['input']>;
  _neq?: InputMaybe<Scalars['CustomAuthMethodType']['input']>;
  _nin?: InputMaybe<Array<Scalars['CustomAuthMethodType']['input']>>;
};

export type CustomAuthMethodUpdateInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  emailAttribute?: InputMaybe<Scalars['String']['input']>;
  entityIssuer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  issuerURL: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  type: CustomAuthMethodTypeEnum;
  usernameAttribute?: InputMaybe<Scalars['String']['input']>;
};

export type Customer = {
  __typename?: 'Customer';
  avatar?: Maybe<Scalars['String']['output']>;
  botLanguage?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomerBotsInput = {
  actionNodeService?: InputMaybe<Scalars['String']['input']>;
  botName?: InputMaybe<Scalars['String']['input']>;
  botTemplateLanguage?: InputMaybe<Scalars['String']['input']>;
  botType?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerChannel = {
  __typename?: 'CustomerChannel';
  analytics_api_host?: Maybe<Scalars['String']['output']>;
  analytics_api_key?: Maybe<Scalars['String']['output']>;
  analytics_enabled?: Maybe<Scalars['Boolean']['output']>;
  bot_retry?: Maybe<BotRetry>;
  config?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  end_bot?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_update_by?: Maybe<Scalars['String']['output']>;
  last_updated?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pype_id?: Maybe<Scalars['String']['output']>;
  speech_config?: Maybe<ChannelSpeechConfig>;
  speech_enabled?: Maybe<Scalars['Boolean']['output']>;
  start_bot?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  webhook_url?: Maybe<Scalars['String']['output']>;
};

export type CustomerChannelConfigResponse = {
  __typename?: 'CustomerChannelConfigResponse';
  analyticsApiHost?: Maybe<Scalars['String']['output']>;
  analyticsApiKey?: Maybe<Scalars['String']['output']>;
  analyticsDefault?: Maybe<Scalars['String']['output']>;
  analyticsEnabled?: Maybe<Scalars['Boolean']['output']>;
  analyticsTranscriptEnabled?: Maybe<Scalars['Boolean']['output']>;
  botRetry?: Maybe<BotRetry>;
  config?: Maybe<CustomerChannelConfigResponseConfig>;
  endBot?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUpdateBy?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pypeId?: Maybe<Scalars['String']['output']>;
  speechConfig?: Maybe<CustomerChannelConfigResponseSpeechConfig>;
  speechEnabled?: Maybe<Scalars['Boolean']['output']>;
  startBot?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type CustomerChannelConfigResponseConfig = {
  __typename?: 'CustomerChannelConfigResponseConfig';
  twilioVoiceConfig?: Maybe<CustomerChannelConfigResponseTwilioConfig>;
  twilioVoiceId?: Maybe<Scalars['String']['output']>;
};

export type CustomerChannelConfigResponseSpeechConfig = {
  __typename?: 'CustomerChannelConfigResponseSpeechConfig';
  bargeIn?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  sttModel?: Maybe<Scalars['String']['output']>;
  ttsModel?: Maybe<Scalars['String']['output']>;
  voice?: Maybe<Scalars['String']['output']>;
};

export type CustomerChannelConfigResponseTwilioConfig = {
  __typename?: 'CustomerChannelConfigResponseTwilioConfig';
  accountSid?: Maybe<Scalars['String']['output']>;
  authToken?: Maybe<Scalars['String']['output']>;
  elevenlabsAudioModel?: Maybe<Scalars['String']['output']>;
  elevenlabsSimilarity?: Maybe<Scalars['String']['output']>;
  elevenlabsSpeed?: Maybe<Scalars['String']['output']>;
  elevenlabsStability?: Maybe<Scalars['String']['output']>;
  elevenlabsVoiceId?: Maybe<Scalars['String']['output']>;
  elevenlabsVoiceMetadataB64?: Maybe<Scalars['JSON']['output']>;
  enableCallRecording?: Maybe<Scalars['Boolean']['output']>;
  handoffUrl?: Maybe<Scalars['String']['output']>;
  inboundMessageBufferMs?: Maybe<Scalars['Int']['output']>;
  initCallWebhookUrl?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  languagesConfigB64?: Maybe<Scalars['String']['output']>;
  metadataIntegrationInfoB64?: Maybe<Scalars['String']['output']>;
  noAnswerFailoverNode?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  promptMaxRetries?: Maybe<Scalars['Int']['output']>;
  retryPromptPrefix?: Maybe<Scalars['String']['output']>;
  speechModel?: Maybe<Scalars['String']['output']>;
  transcriptionProvider?: Maybe<Scalars['String']['output']>;
  ttsProvider?: Maybe<Scalars['String']['output']>;
  userSilenceTimeout?: Maybe<Scalars['Int']['output']>;
  voiceHandoffOptionsB64?: Maybe<Scalars['String']['output']>;
  welcomeGreeting?: Maybe<Scalars['String']['output']>;
};

export type CustomerInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  botLanguage?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CustomerKey = {
  __typename?: 'CustomerKey';
  clientId?: Maybe<Scalars['ID']['output']>;
  clientSecret?: Maybe<Scalars['ID']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomerKeyInput = {
  clientId: Scalars['ID']['input'];
  clientSecret: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CustomerPackagesInput = {
  actionNodePackages?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerPypesStreamsBotResponse = {
  __typename?: 'CustomerPypesStreamsBotResponse';
  auto_start_with_bot?: Maybe<Scalars['Boolean']['output']>;
  bot_enabled?: Maybe<Scalars['Boolean']['output']>;
  end_chat_bot_enabled?: Maybe<Scalars['Boolean']['output']>;
  end_chat_bot_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  start_chat_bot_enabled?: Maybe<Scalars['Boolean']['output']>;
  start_chat_bot_id?: Maybe<Scalars['String']['output']>;
};

export type CustomerResourcesInput = {
  actionNodeResources?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerStreamBotInput = {
  autoStartWithBot: Scalars['Boolean']['input'];
  botEnabled: Scalars['Boolean']['input'];
  endChatBotEnabled: Scalars['Boolean']['input'];
  endChatBotId: Scalars['String']['input'];
  startChatBotEnabled: Scalars['Boolean']['input'];
  startChatBotId: Scalars['String']['input'];
};

export type CustomersInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultChannelConfigInput = {
  agentRouting?: InputMaybe<Scalars['String']['input']>;
  integrationHeadersAccountId?: InputMaybe<Scalars['String']['input']>;
  integrationHeadersInboxId?: InputMaybe<Scalars['String']['input']>;
  integrationName?: InputMaybe<Scalars['String']['input']>;
};

export type DeployedByUser = {
  __typename?: 'DeployedByUser';
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
};

export type Domain = {
  __typename?: 'Domain';
  id?: Maybe<Scalars['ID']['output']>;
  lastVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<DomainTypeEnum>;
  url?: Maybe<Scalars['String']['output']>;
  verificationStatus?: Maybe<DomainVerificationStatusEnum>;
};

export type DomainInput = {
  type: DomainTypeEnum;
  url: Scalars['String']['input'];
};

export enum DomainTypeEnum {
  Domain = 'DOMAIN',
  SubDomain = 'SUB_DOMAIN'
}

/** Boolean expression to compare columns of type "DomainType". All fields are combined with logical 'AND'. */
export type DomainType_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['DomainType']['input']>;
  _gt?: InputMaybe<Scalars['DomainType']['input']>;
  _gte?: InputMaybe<Scalars['DomainType']['input']>;
  _in?: InputMaybe<Array<Scalars['DomainType']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['DomainType']['input']>;
  _lte?: InputMaybe<Scalars['DomainType']['input']>;
  _neq?: InputMaybe<Scalars['DomainType']['input']>;
  _nin?: InputMaybe<Array<Scalars['DomainType']['input']>>;
};

export enum DomainVerificationStatusEnum {
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

export type DomainVerificationStatusInput = {
  id: Scalars['String']['input'];
  verificationStatus: DomainVerificationStatusEnum;
};

/** Boolean expression to compare columns of type "DomainVerificationStatus". All fields are combined with logical 'AND'. */
export type DomainVerificationStatus_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['DomainVerificationStatus']['input']>;
  _gt?: InputMaybe<Scalars['DomainVerificationStatus']['input']>;
  _gte?: InputMaybe<Scalars['DomainVerificationStatus']['input']>;
  _in?: InputMaybe<Array<Scalars['DomainVerificationStatus']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['DomainVerificationStatus']['input']>;
  _lte?: InputMaybe<Scalars['DomainVerificationStatus']['input']>;
  _neq?: InputMaybe<Scalars['DomainVerificationStatus']['input']>;
  _nin?: InputMaybe<Array<Scalars['DomainVerificationStatus']['input']>>;
};

export type DraftVersionFile = {
  __typename?: 'DraftVersionFile';
  id: Scalars['String']['output'];
  path: Scalars['String']['output'];
  sha: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type Entity = Account | Project | Role | Team | User;

export type EngineRequestBe = {
  __typename?: 'EngineRequestBE';
  at: Scalars['Float']['output'];
  endAt?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<EngineRequestErrorBe>;
  from?: Maybe<Scalars['Int']['output']>;
  notes: Array<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['Int']['output']>>;
  requestId: Scalars['String']['output'];
  steps: Array<EngineStepBe>;
  stopReason?: Maybe<Scalars['String']['output']>;
  stoppedAt?: Maybe<Scalars['Int']['output']>;
};

export type EngineRequestErrorBe = {
  __typename?: 'EngineRequestErrorBE';
  message?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Scalars['Int']['output']>;
};

export type EngineStepBe = {
  __typename?: 'EngineStepBE';
  action?: Maybe<Scalars['String']['output']>;
  actionKind?: Maybe<Scalars['String']['output']>;
  at?: Maybe<Scalars['Float']['output']>;
  failed?: Maybe<Scalars['Boolean']['output']>;
  inputs?: Maybe<Array<Scalars['String']['output']>>;
  kind: Scalars['String']['output'];
  node: Scalars['Int']['output'];
  outputs?: Maybe<Array<Scalars['String']['output']>>;
};

export type Env = {
  __typename?: 'Env';
  customerId?: Maybe<Scalars['String']['output']>;
  envs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EnvBotVersionResponse = {
  __typename?: 'EnvBotVersionResponse';
  data?: Maybe<Scalars['JSON']['output']>;
};

export type Environment = {
  __typename?: 'Environment';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type EnvironmentMapping = {
  __typename?: 'EnvironmentMapping';
  customerId?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type EnvironmentMappingForCreateInput = {
  envId: Scalars['String']['input'];
};

export type EnvironmentRolesUpdate = {
  id: Scalars['ID']['input'];
  rolesToAdd: Array<Scalars['String']['input']>;
  rolesToRemove: Array<Scalars['String']['input']>;
};

export enum EnvironmentStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "EnvironmentStatus". All fields are combined with logical 'AND'. */
export type EnvironmentStatus_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['EnvironmentStatus']['input']>;
  _gt?: InputMaybe<Scalars['EnvironmentStatus']['input']>;
  _gte?: InputMaybe<Scalars['EnvironmentStatus']['input']>;
  _in?: InputMaybe<Array<Scalars['EnvironmentStatus']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['EnvironmentStatus']['input']>;
  _lte?: InputMaybe<Scalars['EnvironmentStatus']['input']>;
  _neq?: InputMaybe<Scalars['EnvironmentStatus']['input']>;
  _nin?: InputMaybe<Array<Scalars['EnvironmentStatus']['input']>>;
};

export type File = {
  __typename?: 'File';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  settings?: Maybe<Scalars['JSON']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type FileInput = {
  mimeType: Scalars['String']['input'];
  originalName: Scalars['String']['input'];
  publicId: Scalars['String']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
  size: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

export type GesEnvironment = {
  __typename?: 'GESEnvironment';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GesRole = {
  __typename?: 'GESRole';
  customerId?: Maybe<Scalars['String']['output']>;
  pypeId?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
};

export type GesUser = {
  __typename?: 'GESUser';
  avatar?: Maybe<Scalars['String']['output']>;
  avatarGenerated?: Maybe<Scalars['Boolean']['output']>;
  browserLanguage?: Maybe<Scalars['String']['output']>;
  countryAlpha2?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  importDetails?: Maybe<Array<Maybe<ImportDetailItem>>>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  lastViewedUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  oktaId?: Maybe<Scalars['String']['output']>;
  passthrough?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  referringSite?: Maybe<Scalars['String']['output']>;
  screenResolution?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  userBrowser?: Maybe<Scalars['String']['output']>;
};

export type GesUserInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  avatarGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  browserLanguage?: InputMaybe<Scalars['String']['input']>;
  countryAlpha2?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  importDetails?: InputMaybe<Array<InputMaybe<ImportDetailItemInput>>>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  lastUpdated?: InputMaybe<Scalars['String']['input']>;
  lastViewedUrl?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  oktaId?: InputMaybe<Scalars['String']['input']>;
  passthrough?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  referringSite?: InputMaybe<Scalars['String']['input']>;
  screenResolution?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userBrowser?: InputMaybe<Scalars['String']['input']>;
};

export type GetVoiceAiAccentsInput = {
  language: Scalars['String']['input'];
};

export type GetVoiceAiProvidersInput = {
  accent?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  modelId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  provider: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetVoiceAiSpeechModelsInput = {
  language?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
};

export type GetVoiceAiVoicesV2Input = {
  accent?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  provider: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GiteaBranch = {
  __typename?: 'GiteaBranch';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type GiteaBranchTip = {
  __typename?: 'GiteaBranchTip';
  isDefault: Scalars['Boolean']['output'];
  isDraft: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sha: Scalars['String']['output'];
};

export type GiteaCommit = {
  __typename?: 'GiteaCommit';
  authorEmail?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  htmlUrl?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  parentShas: Array<Scalars['String']['output']>;
  sha: Scalars['String']['output'];
};

export type GiteaCommitDetail = {
  __typename?: 'GiteaCommitDetail';
  commit: GiteaCommit;
  files: Array<GiteaCommitFile>;
};

export type GiteaCommitFile = {
  __typename?: 'GiteaCommitFile';
  additions: Scalars['Int']['output'];
  deletions: Scalars['Int']['output'];
  isBinary: Scalars['Boolean']['output'];
  isTooLarge: Scalars['Boolean']['output'];
  patch?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  previousPath?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type GiteaCommitGraph = {
  __typename?: 'GiteaCommitGraph';
  branchTips: Array<GiteaBranchTip>;
  commits: Array<GiteaCommit>;
  environmentTips: Array<GiteaEnvironmentTip>;
};

export type GiteaEnvironmentTip = {
  __typename?: 'GiteaEnvironmentTip';
  draftName?: Maybe<Scalars['String']['output']>;
  environment: Scalars['String']['output'];
  sha: Scalars['String']['output'];
  versionName: Scalars['String']['output'];
};

export type GiteaFileCommit = {
  __typename?: 'GiteaFileCommit';
  authorEmail?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  htmlUrl?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  sha: Scalars['String']['output'];
};

export type GiteaFileContent = {
  __typename?: 'GiteaFileContent';
  content?: Maybe<Scalars['String']['output']>;
  isBinary: Scalars['Boolean']['output'];
  mimeType: Scalars['String']['output'];
  path: Scalars['String']['output'];
  sha?: Maybe<Scalars['String']['output']>;
};

export type GiteaTreeEntry = {
  __typename?: 'GiteaTreeEntry';
  id?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  sha?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type HistorySearchBody = {
  bot?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  env?: InputMaybe<Scalars['String']['input']>;
  max_num_entries?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type IceBreakerInput = {
  node?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type ImportDetailItem = {
  __typename?: 'ImportDetailItem';
  level?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ImportDetailItemInput = {
  level?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['Int']['input']>>;
  _eq?: InputMaybe<Array<Scalars['Int']['input']>>;
  _gt?: InputMaybe<Array<Scalars['Int']['input']>>;
  _gte?: InputMaybe<Array<Scalars['Int']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['Int']['input']>>;
  _lte?: InputMaybe<Array<Scalars['Int']['input']>>;
  _neq?: InputMaybe<Array<Scalars['Int']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntegrationHeadersInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  inboxId?: InputMaybe<Scalars['String']['input']>;
  integrationName?: InputMaybe<Scalars['String']['input']>;
};

export type LlmCredential = {
  __typename?: 'LLMCredential';
  apiKey?: Maybe<Scalars['String']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  llmProvider?: Maybe<LlmProvider>;
  llmProviderId?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
};

export type LlmCredentialInput = {
  apiKey: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  llmProviderId: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

export type LlmCredentialLimited = {
  __typename?: 'LLMCredentialLimited';
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  llmProvider?: Maybe<LlmProvider>;
  llmProviderId?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
};

export type LlmProvider = {
  __typename?: 'LLMProvider';
  displayName?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type List = {
  __typename?: 'List';
  data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LiveagentDefaultFieldsInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  languageName?: InputMaybe<Scalars['String']['input']>;
};

export type Locale = {
  __typename?: 'Locale';
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isoCode: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type LocalizationSettings = {
  __typename?: 'LocalizationSettings';
  country?: Maybe<Country2>;
  countryId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Locale>;
  localeId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<TimeZone>;
  timeZoneId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type LocalizationSettingsConfig = {
  __typename?: 'LocalizationSettingsConfig';
  project: LocalizationSettingsEntityConfig;
  user: LocalizationSettingsEntityConfig;
};

export type LocalizationSettingsEntityConfig = {
  __typename?: 'LocalizationSettingsEntityConfig';
  supportedLanguageCodes: Array<Scalars['String']['output']>;
};

export type LoginInfo = {
  __typename?: 'LoginInfo';
  authProviderId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  passwordRecoveryStatus?: Maybe<PasswordRecoveryStatusEnum>;
  recommendedAuthMethod?: Maybe<Scalars['String']['output']>;
  registeredAuthMethods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MaestroAudienceOrg = {
  __typename?: 'MaestroAudienceOrg';
  accountId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentAccountId?: Maybe<Scalars['String']['output']>;
};

export type MaestroClassicImport = {
  __typename?: 'MaestroClassicImport';
  existing: Array<Scalars['String']['output']>;
  failed: Array<Scalars['String']['output']>;
  imported: Array<Scalars['String']['output']>;
  unset: Array<Scalars['String']['output']>;
};

export type MaestroClassicSource = {
  __typename?: 'MaestroClassicSource';
  maestroProjectId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  secretCount: Scalars['Int']['output'];
};

export type MaestroInheritedSecret = {
  __typename?: 'MaestroInheritedSecret';
  /** The backend account id of the org the secret is inherited from. */
  accountId?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pypestreamKey: Scalars['Boolean']['output'];
};

export type MaestroKeyAudience = {
  __typename?: 'MaestroKeyAudience';
  accountIds: Array<Scalars['String']['output']>;
  /** all (every org but accountIds) or selected (only accountIds) */
  mode: Scalars['String']['output'];
};

export type MaestroKeyAudienceInput = {
  accountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mode: Scalars['String']['input'];
};

export type MaestroNamedRef = {
  __typename?: 'MaestroNamedRef';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type MaestroOrgSecret = {
  __typename?: 'MaestroOrgSecret';
  audience?: Maybe<MaestroKeyAudience>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pypestreamKey: Scalars['Boolean']['output'];
  scope: MaestroSecretScope;
  set: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Null when nobody is recorded, or the user no longer exists. */
  updatedBy?: Maybe<MaestroSecretAuthor>;
  /** manager, studio, builder or liveview */
  updatedVia?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  /** Naming rules an item saved before them breaks: reserved_prefix, clash, format. */
  violations: Array<Scalars['String']['output']>;
};

export type MaestroOrgSecretInput = {
  /** Required with pypestreamKey. */
  audience?: InputMaybe<MaestroKeyAudienceInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pypestreamKey?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defaults to the org. */
  scope?: InputMaybe<MaestroSecretScopeInput>;
  value: Scalars['String']['input'];
};

export type MaestroOrgSecretUpdate = {
  audience?: InputMaybe<MaestroKeyAudienceInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  pypestreamKey?: InputMaybe<Scalars['Boolean']['input']>;
  /** Moves the item; a Pypestream key stays at the org. */
  scope?: InputMaybe<MaestroSecretScopeInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MaestroOrgSecrets = {
  __typename?: 'MaestroOrgSecrets';
  inherited: Array<MaestroInheritedSecret>;
  own: Array<MaestroOrgSecret>;
  /** Items of this org's own projects, their applications and agents. */
  scoped: Array<MaestroOrgSecret>;
};

export type MaestroScopeAgent = {
  __typename?: 'MaestroScopeAgent';
  applicationId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type MaestroSecretAuthor = {
  __typename?: 'MaestroSecretAuthor';
  name?: Maybe<Scalars['String']['output']>;
  /** True for Pypestream staff, shown as Pypestream in a customer org. */
  pypestream: Scalars['Boolean']['output'];
};

export type MaestroSecretScope = {
  __typename?: 'MaestroSecretScope';
  agent?: Maybe<MaestroNamedRef>;
  application?: Maybe<MaestroNamedRef>;
  project?: Maybe<MaestroNamedRef>;
  /** org, project, application or agent */
  type: Scalars['String']['output'];
};

export type MaestroSecretScopeInput = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** org, project, application or agent */
  scopeType: Scalars['String']['input'];
};

export type MaestroSecretScopeProject = {
  __typename?: 'MaestroSecretScopeProject';
  agents: Array<MaestroScopeAgent>;
  applications: Array<MaestroNamedRef>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type MaestroSettingsGroup = {
  __typename?: 'MaestroSettingsGroup';
  group: Scalars['String']['output'];
  inherited: MaestroSettingsInherited;
  leaves: Array<Scalars['String']['output']>;
  lockVersion?: Maybe<Scalars['Int']['output']>;
  values?: Maybe<Scalars['JSON']['output']>;
};

export type MaestroSettingsInherited = {
  __typename?: 'MaestroSettingsInherited';
  source?: Maybe<MaestroSettingsSource>;
  values?: Maybe<Scalars['JSON']['output']>;
};

export type MaestroSettingsOverride = {
  __typename?: 'MaestroSettingsOverride';
  /** The backend account id, on org-scope rows only. */
  accountId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scopeType: Scalars['String']['output'];
  values: Scalars['JSON']['output'];
};

export type MaestroSettingsSource = {
  __typename?: 'MaestroSettingsSource';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  root?: Maybe<Scalars['Boolean']['output']>;
  scopeType: Scalars['String']['output'];
};

export type MaskingRuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  regexPatterns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MaskingRules = {
  __typename?: 'MaskingRules';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  regex_patterns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MetabaseDatasetAccessInput = {
  collections: Array<MetabaseFolderRoleInput>;
  dataset: Scalars['String']['input'];
};

export type MetabaseDatasetFolders = {
  __typename?: 'MetabaseDatasetFolders';
  dataset: Scalars['String']['output'];
  groups: Array<MetabaseFolder>;
};

export type MetabaseFolder = {
  __typename?: 'MetabaseFolder';
  dashboardCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MetabaseFolderRoleInput = {
  collectionId: Scalars['Int']['input'];
  roleId: Scalars['ID']['input'];
};

export type MetabaseFolders = {
  __typename?: 'MetabaseFolders';
  datasets: Array<MetabaseDatasetFolders>;
};

export type OperationResult = {
  __typename?: 'OperationResult';
  entityDisplayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  errorDetails?: Maybe<Scalars['String']['output']>;
  succeeded?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderBy = {
  columnName?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationMetadata = {
  __typename?: 'OrganizationMetadata';
  accountId?: Maybe<Scalars['ID']['output']>;
  canManageAccess?: Maybe<Scalars['Boolean']['output']>;
  canManageChildOrganization?: Maybe<Scalars['Boolean']['output']>;
  canManageDeletedData?: Maybe<Scalars['Boolean']['output']>;
  canManageIntegrationData?: Maybe<Scalars['Boolean']['output']>;
  canManageMaestroSecrets?: Maybe<Scalars['Boolean']['output']>;
  canManageMaestroSettings?: Maybe<Scalars['Boolean']['output']>;
  canManageProjects?: Maybe<Scalars['Boolean']['output']>;
  canManageSettings?: Maybe<Scalars['Boolean']['output']>;
  canViewAuditLogs?: Maybe<Scalars['Boolean']['output']>;
  canViewMaestroSecrets?: Maybe<Scalars['Boolean']['output']>;
  canViewMaestroSettings?: Maybe<Scalars['Boolean']['output']>;
  canViewSettings?: Maybe<Scalars['Boolean']['output']>;
  isMember?: Maybe<Scalars['Boolean']['output']>;
  resourceLimits?: Maybe<OrganizationResourceLimits>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type OrganizationResourceLimits = {
  __typename?: 'OrganizationResourceLimits';
  currentUsers?: Maybe<Scalars['Int']['output']>;
  maxUsers?: Maybe<Scalars['Int']['output']>;
};

export type Package = {
  __typename?: 'Package';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latestVersion?: Maybe<PackageVersion>;
  latestVersionId?: Maybe<Scalars['String']['output']>;
  packageTypes?: Maybe<Array<Maybe<PackageTypeEnum>>>;
  pkgName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versions?: Maybe<Array<Maybe<PackageVersion>>>;
};

export enum PackageTypeEnum {
  Action = 'ACTION',
  Condition = 'CONDITION',
  Function = 'FUNCTION',
  Trigger = 'TRIGGER',
  Undefined = 'UNDEFINED'
}

/** Boolean expression to compare columns of type "PackageType". All fields are combined with logical 'AND'. */
export type PackageType_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['PackageType']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['PackageType']['input']>>;
  _eq?: InputMaybe<Array<Scalars['PackageType']['input']>>;
  _gt?: InputMaybe<Array<Scalars['PackageType']['input']>>;
  _gte?: InputMaybe<Array<Scalars['PackageType']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['PackageType']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['PackageType']['input']>>;
  _lte?: InputMaybe<Array<Scalars['PackageType']['input']>>;
  _neq?: InputMaybe<Array<Scalars['PackageType']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['PackageType']['input']>>>;
};

export type PackageVersion = {
  __typename?: 'PackageVersion';
  actions?: Maybe<Array<Maybe<Action>>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isLatestInMinor?: Maybe<Scalars['Boolean']['output']>;
  package: Package;
  packageId: Scalars['String']['output'];
  packageJson?: Maybe<Scalars['JSON']['output']>;
  relatedPackage?: Maybe<Package>;
  schema?: Maybe<Scalars['JSON']['output']>;
  triggers?: Maybe<Array<Maybe<Trigger>>>;
  version: Scalars['String']['output'];
};

export type PaginatedAccounts = {
  __typename?: 'PaginatedAccounts';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<Account>>>;
};

export type PaginatedAuditLogs = {
  __typename?: 'PaginatedAuditLogs';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<AuditLog>>>;
};

export type PaginatedProjectTeams = {
  __typename?: 'PaginatedProjectTeams';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<ProjectTeam>>>;
};

export type PaginatedProjectUsers = {
  __typename?: 'PaginatedProjectUsers';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<ProjectUser>>>;
};

export type PaginatedProjects = {
  __typename?: 'PaginatedProjects';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<Project>>>;
};

export type PaginatedRoleMembers = {
  __typename?: 'PaginatedRoleMembers';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<RoleMember>>>;
};

export type PaginatedRoles = {
  __typename?: 'PaginatedRoles';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<Role>>>;
};

export type PaginatedSolutionDeployments = {
  __typename?: 'PaginatedSolutionDeployments';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<SolutionDeployment>>>;
};

export type PaginatedSolutionDraftVersionComparisons = {
  __typename?: 'PaginatedSolutionDraftVersionComparisons';
  base: SolutionDraftVersionComparison;
  count: Scalars['Int']['output'];
  rows: Array<SolutionDraftVersionComparison>;
};

export type PaginatedSolutionVersions = {
  __typename?: 'PaginatedSolutionVersions';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<SolutionVersion>>>;
};

export type PaginatedTeamMembers = {
  __typename?: 'PaginatedTeamMembers';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<TeamMember>>>;
};

export type PaginatedTeamProjects = {
  __typename?: 'PaginatedTeamProjects';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<TeamProject>>>;
};

export type PaginatedTeamRoles = {
  __typename?: 'PaginatedTeamRoles';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<TeamRole>>>;
};

export type PaginatedTeams = {
  __typename?: 'PaginatedTeams';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<Team>>>;
};

export type PaginatedUserProjects = {
  __typename?: 'PaginatedUserProjects';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<UserProject>>>;
};

export type PaginatedUserRoles = {
  __typename?: 'PaginatedUserRoles';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<UserRole>>>;
};

export type PaginatedUserTeams = {
  __typename?: 'PaginatedUserTeams';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<UserTeam>>>;
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<User>>>;
};

export enum PasswordRecoveryStatusEnum {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

/** Boolean expression to compare columns of type "PasswordRecoveryStatus". All fields are combined with logical 'AND'. */
export type PasswordRecoveryStatus_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['PasswordRecoveryStatus']['input']>;
  _gt?: InputMaybe<Scalars['PasswordRecoveryStatus']['input']>;
  _gte?: InputMaybe<Scalars['PasswordRecoveryStatus']['input']>;
  _in?: InputMaybe<Array<Scalars['PasswordRecoveryStatus']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['PasswordRecoveryStatus']['input']>;
  _lte?: InputMaybe<Scalars['PasswordRecoveryStatus']['input']>;
  _neq?: InputMaybe<Scalars['PasswordRecoveryStatus']['input']>;
  _nin?: InputMaybe<Array<Scalars['PasswordRecoveryStatus']['input']>>;
};

export type PermissionDetail = {
  __typename?: 'PermissionDetail';
  canAssign?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  sectionName?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename?: 'Product';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<ProductName>;
  settings?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ProductName {
  AgentAssist = 'AGENT_ASSIST',
  Analytics = 'ANALYTICS',
  MaestroStudio = 'MAESTRO_STUDIO',
  Organization = 'ORGANIZATION',
  ProStudio = 'PRO_STUDIO'
}

export type Project = {
  __typename?: 'Project';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enableSettingsLink?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  localizationSettings?: Maybe<LocalizationSettings>;
  name: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
  pictureFile?: Maybe<File>;
  projectEnvironmentConfig?: Maybe<Array<Maybe<ProjectEnvironmentConfig>>>;
  projectMetadata?: Maybe<ProjectMetadata>;
  projectProStudioSetting?: Maybe<ProjectProStudioSetting>;
  projectProductSettings?: Maybe<Array<Maybe<ProjectProductSetting>>>;
  shortId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  users?: Maybe<PaginatedUsers>;
  variables?: Maybe<Array<Maybe<Variable>>>;
};

export type ProjectEnvironmentConfig = {
  __typename?: 'ProjectEnvironmentConfig';
  appletInstances?: Maybe<Array<Maybe<AppletInstance>>>;
  description?: Maybe<Scalars['String']['output']>;
  domains?: Maybe<Array<Maybe<Domain>>>;
  environment?: Maybe<Environment>;
  environmentId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  projectId?: Maybe<Scalars['ID']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EnvironmentStatusEnum>;
  variables?: Maybe<Array<Maybe<Variable>>>;
};


export type ProjectEnvironmentConfigAppletInstancesArgs = {
  status?: InputMaybe<AppletStatusEnum>;
};

export type ProjectEnvironmentConfigCreate = {
  description?: InputMaybe<Scalars['String']['input']>;
  domains: Array<DomainInput>;
  name: Scalars['String']['input'];
  status?: InputMaybe<EnvironmentStatusEnum>;
};

export type ProjectMetadata = {
  __typename?: 'ProjectMetadata';
  accountId?: Maybe<Scalars['ID']['output']>;
  projectId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ProjectProStudioSetting = {
  __typename?: 'ProjectProStudioSetting';
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['ID']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
};

export type ProjectProductSetting = {
  __typename?: 'ProjectProductSetting';
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  projectId?: Maybe<Scalars['ID']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
};

export type ProjectRolesUpdate = {
  id: Scalars['ID']['input'];
  metabaseAccess?: InputMaybe<Array<MetabaseDatasetAccessInput>>;
  rolesToAdd: Array<Scalars['String']['input']>;
  rolesToRemove: Array<Scalars['String']['input']>;
};

export type ProjectTeam = {
  __typename?: 'ProjectTeam';
  linkIssues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedToContactCenter?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Maybe<RoleWithSource>>>;
  team?: Maybe<Team>;
};

export type ProjectTeamsWithRoles = {
  __typename?: 'ProjectTeamsWithRoles';
  roles?: Maybe<Array<Maybe<Role>>>;
  team?: Maybe<Team>;
};

export type ProjectUser = {
  __typename?: 'ProjectUser';
  linkedToContactCenter?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Maybe<RoleWithSource>>>;
  user?: Maybe<User>;
};

export type ProjectUsersWithRoles = {
  __typename?: 'ProjectUsersWithRoles';
  roles?: Maybe<Array<Maybe<Role>>>;
  teamRoles?: Maybe<Array<Maybe<ProjectTeamsWithRoles>>>;
  user?: Maybe<User>;
};

export type ProjectsFilter = {
  accountId: Scalars['String']['input'];
};

export type Pype = {
  __typename?: 'Pype';
  agent_routing?: Maybe<Scalars['String']['output']>;
  agent_routing_config?: Maybe<Scalars['JSON']['output']>;
  agent_routing_url?: Maybe<Scalars['String']['output']>;
  autoresponders?: Maybe<Autoresponders>;
  bot_retry?: Maybe<BotRetry>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PypeConfig = {
  __typename?: 'PypeConfig';
  agent_routing?: Maybe<Scalars['String']['output']>;
  bot_retry?: Maybe<BotRetry>;
  config?: Maybe<PypeConfigObject>;
};

export type PypeConfigBe = {
  __typename?: 'PypeConfigBE';
  integration_headers?: Maybe<Scalars['JSON']['output']>;
  integration_name?: Maybe<Scalars['String']['output']>;
};

export type PypeConfigObject = {
  __typename?: 'PypeConfigObject';
  integration_headers?: Maybe<Scalars['JSON']['output']>;
  integration_name?: Maybe<Scalars['String']['output']>;
};

export type PypeConfigurationExternalAgentSchema = {
  __typename?: 'PypeConfigurationExternalAgentSchema';
  integrations?: Maybe<Array<Maybe<PypeConfigurationExternalAgentSchemaIntegrations>>>;
};

export type PypeConfigurationExternalAgentSchemaIntegrations = {
  __typename?: 'PypeConfigurationExternalAgentSchemaIntegrations';
  callbackToken?: Maybe<Scalars['String']['output']>;
  callbackURL?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  integrationFields?: Maybe<Scalars['JSON']['output']>;
  integrationName?: Maybe<Scalars['String']['output']>;
};

export type PypeConnection = {
  __typename?: 'PypeConnection';
  agentRouting?: Maybe<Scalars['String']['output']>;
  agentRoutingUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  environment?: Maybe<SolutionEnvironmentsEnum>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platformId?: Maybe<Scalars['String']['output']>;
  projectProStudioSettingId?: Maybe<Scalars['String']['output']>;
  pypes?: Maybe<Array<Maybe<PypeConnectionPype>>>;
  settings?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PypeConnectionPype = {
  __typename?: 'PypeConnectionPype';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  env?: Maybe<SolutionEnvironmentsEnum>;
  id?: Maybe<Scalars['ID']['output']>;
  pypeConnectionId?: Maybe<Scalars['String']['output']>;
  pypeId?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "PypeEnvironment". All fields are combined with logical 'AND'. */
export type PypeEnvironment_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  _gt?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  _gte?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  _in?: InputMaybe<Array<Scalars['PypeEnvironment']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  _lte?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  _neq?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  _nin?: InputMaybe<Array<Scalars['PypeEnvironment']['input']>>;
};

export type PypeInput = {
  autoresponders?: InputMaybe<AutorespondersInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PypeMetricChecklistItem = {
  __typename?: 'PypeMetricChecklistItem';
  checkChat?: Maybe<Scalars['String']['output']>;
  checkInvite?: Maybe<Scalars['String']['output']>;
  checkLogo?: Maybe<Scalars['String']['output']>;
  checkStream?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  lastUpdate?: Maybe<Scalars['Int']['output']>;
  pypeId?: Maybe<Scalars['String']['output']>;
};

export type PypeMetricDetail = {
  __typename?: 'PypeMetricDetail';
  activeAgentSessions?: Maybe<Scalars['Int']['output']>;
  activeBotSessions?: Maybe<Scalars['Int']['output']>;
  activeSessions?: Maybe<Scalars['Int']['output']>;
  currentQueueSize?: Maybe<Scalars['Int']['output']>;
  currentWaitTime?: Maybe<Scalars['Int']['output']>;
  dailyAgentSessions?: Maybe<Scalars['Int']['output']>;
  dailyAverageQueueSize?: Maybe<Scalars['Int']['output']>;
  dailyAverageQueueTime?: Maybe<Scalars['Int']['output']>;
  dailyAverageResponseTime?: Maybe<Scalars['Int']['output']>;
  dailyBotSessions?: Maybe<Scalars['Int']['output']>;
  dailySubs?: Maybe<Scalars['Int']['output']>;
  dailyUnsubs?: Maybe<Scalars['Int']['output']>;
  expectedQueueTime?: Maybe<Scalars['Int']['output']>;
  hourlyAverageQueueSize?: Maybe<Scalars['Int']['output']>;
  hourlyAverageQueueTime?: Maybe<Scalars['Int']['output']>;
  nonPypystreamActiveSessions?: Maybe<Scalars['Int']['output']>;
  pypeId?: Maybe<Scalars['String']['output']>;
  readMsgCount?: Maybe<Scalars['Int']['output']>;
  totalAverageQueueSize?: Maybe<Scalars['Int']['output']>;
  totalAverageQueueTime?: Maybe<Scalars['Int']['output']>;
  totalAverageResponseTime?: Maybe<Scalars['Int']['output']>;
  totalMsgCount?: Maybe<Scalars['Int']['output']>;
  totalSubs?: Maybe<Scalars['Int']['output']>;
  weeklyAverageResponseTime?: Maybe<Scalars['Int']['output']>;
  weeklySubs?: Maybe<Scalars['Int']['output']>;
  weeklyUnsubs?: Maybe<Scalars['Int']['output']>;
};

export type PypeMetricQueue = {
  __typename?: 'PypeMetricQueue';
  id?: Maybe<Scalars['String']['output']>;
  scheduleEnabled?: Maybe<Scalars['Boolean']['output']>;
  scheduleEnd?: Maybe<Scalars['Int']['output']>;
  scheduleStart?: Maybe<Scalars['Int']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type PypeMetrics = {
  __typename?: 'PypeMetrics';
  checklist?: Maybe<Array<Maybe<PypeMetricChecklistItem>>>;
  metrics?: Maybe<PypeMetricDetail>;
  queues?: Maybe<Array<Maybe<PypeMetricQueue>>>;
};

export type PypeRule = {
  __typename?: 'PypeRule';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pypeRuleGroupId?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  settings?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<RuleCreationTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PypeRuleGroup = {
  __typename?: 'PypeRuleGroup';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectProStudioSettingId?: Maybe<Scalars['String']['output']>;
  pypes?: Maybe<Array<Maybe<PypeRuleGroupPype>>>;
  rules?: Maybe<Array<Maybe<PypeRule>>>;
  settings?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<RuleCreationTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PypeRuleGroupPype = {
  __typename?: 'PypeRuleGroupPype';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  env?: Maybe<SolutionEnvironmentsEnum>;
  id?: Maybe<Scalars['ID']['output']>;
  pypeId?: Maybe<Scalars['String']['output']>;
  pypeRuleGroupId?: Maybe<Scalars['String']['output']>;
};

export type PypeRuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<RuleCreationTypeEnum>;
};

export type PypeRuleUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<RuleCreationTypeEnum>;
};

export type PypeStreamBe = {
  __typename?: 'PypeStreamBE';
  abc_enabled?: Maybe<Scalars['Boolean']['output']>;
  abc_id?: Maybe<Scalars['String']['output']>;
  analytics_api_host?: Maybe<Scalars['String']['output']>;
  analytics_api_key?: Maybe<Scalars['String']['output']>;
  analytics_default?: Maybe<Scalars['String']['output']>;
  analytics_enabled?: Maybe<Scalars['Boolean']['output']>;
  analytics_transcript_enabled?: Maybe<Scalars['Boolean']['output']>;
  auto_joinable?: Maybe<Scalars['String']['output']>;
  auto_start_with_bot?: Maybe<Scalars['Boolean']['output']>;
  awesome_font_icon?: Maybe<Scalars['String']['output']>;
  bot_enabled?: Maybe<Scalars['Boolean']['output']>;
  bot_flag?: Maybe<Scalars['String']['output']>;
  bot_id?: Maybe<Scalars['String']['output']>;
  broadcast_channel?: Maybe<Scalars['String']['output']>;
  broadcast_sms_limit?: Maybe<Scalars['String']['output']>;
  creation_date?: Maybe<Scalars['Float']['output']>;
  csp_account_id?: Maybe<Scalars['String']['output']>;
  csp_agent_bot_token?: Maybe<Scalars['String']['output']>;
  csp_channel_type?: Maybe<Scalars['String']['output']>;
  csp_enabled?: Maybe<Scalars['Boolean']['output']>;
  csp_id?: Maybe<Scalars['String']['output']>;
  csp_inbox_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_chat_bot_enabled?: Maybe<Scalars['Boolean']['output']>;
  end_chat_bot_id?: Maybe<Scalars['String']['output']>;
  fb_access_token?: Maybe<Scalars['String']['output']>;
  fb_bot?: Maybe<Scalars['String']['output']>;
  fb_enabled?: Maybe<Scalars['Boolean']['output']>;
  fb_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  last_updated?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  pype_id?: Maybe<Scalars['String']['output']>;
  sms_enabled?: Maybe<Scalars['Boolean']['output']>;
  sms_id?: Maybe<Scalars['String']['output']>;
  sms_phone_id?: Maybe<Scalars['String']['output']>;
  sms_phone_number?: Maybe<Scalars['String']['output']>;
  sms_token?: Maybe<Scalars['String']['output']>;
  start_chat_bot_enabled?: Maybe<Scalars['Boolean']['output']>;
  start_chat_bot_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stream_name?: Maybe<Scalars['String']['output']>;
  twilio_voice_config?: Maybe<Scalars['JSON']['output']>;
  twilio_voice_enabled?: Maybe<Scalars['Boolean']['output']>;
  twilio_voice_id?: Maybe<Scalars['String']['output']>;
  vaapi_config?: Maybe<Scalars['String']['output']>;
  vaapi_enabled?: Maybe<Scalars['Boolean']['output']>;
  vaapi_id?: Maybe<Scalars['String']['output']>;
  vaapi_integrator?: Maybe<Scalars['String']['output']>;
  widgets?: Maybe<Array<Maybe<PypeWidgetBe>>>;
};

export type PypeUpdateInput = {
  agentRouting?: InputMaybe<Scalars['String']['input']>;
  agentRoutingConfig?: InputMaybe<Scalars['JSON']['input']>;
  agentRoutingUrl?: InputMaybe<Scalars['String']['input']>;
  autoresponders?: InputMaybe<AutorespondersInput>;
  botRetry?: InputMaybe<BotRetryInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  maskingRules?: InputMaybe<Array<InputMaybe<MaskingRuleInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PypeWidgetBe = {
  __typename?: 'PypeWidgetBE';
  beta?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  creation_date?: Maybe<Scalars['Float']['output']>;
  custom_pype_css?: Maybe<Scalars['String']['output']>;
  enable_prechat?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_updated?: Maybe<Scalars['Float']['output']>;
  prechat_custom_field1_name?: Maybe<Scalars['String']['output']>;
  prechat_custom_field1_value?: Maybe<Scalars['String']['output']>;
  prechat_custom_field2_name?: Maybe<Scalars['String']['output']>;
  prechat_custom_field2_value?: Maybe<Scalars['String']['output']>;
  prechat_email?: Maybe<Scalars['String']['output']>;
  prechat_firstname?: Maybe<Scalars['String']['output']>;
  prechat_lastname?: Maybe<Scalars['String']['output']>;
  prechat_msg?: Maybe<Scalars['String']['output']>;
  prechat_phone?: Maybe<Scalars['String']['output']>;
  pype_id?: Maybe<Scalars['String']['output']>;
  stream_id?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  whitelist?: Maybe<Scalars['String']['output']>;
  widget_name?: Maybe<Scalars['String']['output']>;
};

export type QueryMetadata = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  skipPages?: InputMaybe<Scalars['Int']['input']>;
};

export type Role = {
  __typename?: 'Role';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']['output']>;
  teamCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type RoleDefinition = {
  __typename?: 'RoleDefinition';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RoleInstantiationInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  pypeId?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
};

export type RoleMapping = {
  __typename?: 'RoleMapping';
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pypeId?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type RoleMember = {
  __typename?: 'RoleMember';
  id?: Maybe<Scalars['ID']['output']>;
  isMember?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

export type RoleMembersFilter = {
  includeNonMembers: Scalars['Boolean']['input'];
  roleId: Scalars['String']['input'];
};

export type RoleMetadata = {
  __typename?: 'RoleMetadata';
  permissions?: Maybe<Array<Maybe<PermissionDetail>>>;
  roleId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type RoleSource = {
  __typename?: 'RoleSource';
  account: Account;
  description: Scalars['String']['output'];
  project?: Maybe<Project>;
  role: Role;
  team?: Maybe<Team>;
};

export type RoleWithSource = {
  __typename?: 'RoleWithSource';
  role?: Maybe<Role>;
  source?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RolesFilter = {
  accountId: Scalars['String']['input'];
  includeProjectOnlyRoles?: InputMaybe<Scalars['Boolean']['input']>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RolesMetadata = {
  __typename?: 'RolesMetadata';
  accountId?: Maybe<Scalars['ID']['output']>;
  permissions?: Maybe<Array<Maybe<PermissionDetail>>>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum RuleCreationTypeEnum {
  ManuallyCreated = 'MANUALLY_CREATED',
  System = 'SYSTEM'
}

/** Boolean expression to compare columns of type "RuleCreationType". All fields are combined with logical 'AND'. */
export type RuleCreationType_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['RuleCreationType']['input']>;
  _gt?: InputMaybe<Scalars['RuleCreationType']['input']>;
  _gte?: InputMaybe<Scalars['RuleCreationType']['input']>;
  _in?: InputMaybe<Array<Scalars['RuleCreationType']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['RuleCreationType']['input']>;
  _lte?: InputMaybe<Scalars['RuleCreationType']['input']>;
  _neq?: InputMaybe<Scalars['RuleCreationType']['input']>;
  _nin?: InputMaybe<Array<Scalars['RuleCreationType']['input']>>;
};

export enum Set_Data_Action {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type Solution = {
  __typename?: 'Solution';
  botSolutionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultDraftVersion?: Maybe<SolutionVersion>;
  /** The one draft that can never be deleted. A solution may have other, non-default drafts too (isDraft: true on SolutionVersion) — this is only the default one. */
  defaultDraftVersionId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  hasGiteaIntegration?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  latestSolutionDeployment?: Maybe<SolutionDeployment>;
  /** See the doc comment on the latestVersionId field — this is the last publish slot, not the draft. */
  latestSolutionVersion?: Maybe<SolutionVersion>;
  /** Most recently created version slot from a publish attempt (pass or fail) — not the draft. See defaultDraftVersion for the draft. */
  latestVersionId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paginatedSolutionDeployments?: Maybe<PaginatedSolutionDeployments>;
  /** filter restricts rows to DRAFT-only or PUBLISHED-only versions; ALL or omitted returns every version. */
  paginatedSolutionVersions?: Maybe<PaginatedSolutionVersions>;
  projectProStudioSetting?: Maybe<ProjectProStudioSetting>;
  projectProStudioSettingId?: Maybe<Scalars['String']['output']>;
  selectedVersionId?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  solutionDeployments?: Maybe<Array<Maybe<SolutionDeployment>>>;
  solutionVersions?: Maybe<Array<Maybe<SolutionVersion>>>;
  type?: Maybe<SolutionTypeEnum>;
};


export type SolutionLatestSolutionDeploymentArgs = {
  environment: SolutionEnvironmentsEnum;
  status: Scalars['String']['input'];
};


export type SolutionPaginatedSolutionDeploymentsArgs = {
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type SolutionPaginatedSolutionVersionsArgs = {
  filter?: InputMaybe<SolutionVersionFilterEnum>;
  queryMetadata?: InputMaybe<QueryMetadata>;
};

export type SolutionChatEngineTraceBe = {
  __typename?: 'SolutionChatEngineTraceBE';
  requests: Array<EngineRequestBe>;
  truncated: Scalars['Boolean']['output'];
};

export type SolutionChatLogsBe = {
  __typename?: 'SolutionChatLogsBE';
  lines: Array<ChatLogLineBe>;
  truncated: Scalars['Boolean']['output'];
};

export type SolutionChatTranscriptBe = {
  __typename?: 'SolutionChatTranscriptBE';
  chatId: Scalars['String']['output'];
  events: Array<ChatLogEventBe>;
  requests: Array<ChatLogRequestBe>;
};

export type SolutionDeployment = {
  __typename?: 'SolutionDeployment';
  deployedAt?: Maybe<Scalars['DateTime']['output']>;
  deployedBy?: Maybe<DeployedByUser>;
  deploymentRuns?: Maybe<Array<Maybe<SolutionDeploymentRun>>>;
  environment?: Maybe<SolutionEnvironmentsEnum>;
  id?: Maybe<Scalars['ID']['output']>;
  isRepublish?: Maybe<Scalars['Boolean']['output']>;
  solutionVersion?: Maybe<SolutionVersion>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SolutionDeploymentLogStep = {
  __typename?: 'SolutionDeploymentLogStep';
  lines: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: SolutionDeploymentLogStepStatusEnum;
};

export enum SolutionDeploymentLogStepStatusEnum {
  Failure = 'failure',
  Pending = 'pending',
  Running = 'running',
  Skipped = 'skipped',
  Success = 'success'
}

export type SolutionDeploymentLogs = {
  __typename?: 'SolutionDeploymentLogs';
  rawLogs?: Maybe<Scalars['String']['output']>;
  structuredLogs?: Maybe<Array<SolutionDeploymentLogStep>>;
};

export type SolutionDeploymentRun = {
  __typename?: 'SolutionDeploymentRun';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workflows?: Maybe<Array<Maybe<SolutionDeploymentRunWorkflow>>>;
};

export type SolutionDeploymentRunWorkflow = {
  __typename?: 'SolutionDeploymentRunWorkflow';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SolutionDraftVersionComparison = {
  __typename?: 'SolutionDraftVersionComparison';
  comparison?: Maybe<SolutionVersionComparison>;
  draftVersion: SolutionVersion;
  isDefault: Scalars['Boolean']['output'];
};

export type SolutionEnvironmentComparison = {
  __typename?: 'SolutionEnvironmentComparison';
  comparison?: Maybe<SolutionVersionComparison>;
  deployedVersion?: Maybe<SolutionVersion>;
  environment: SolutionEnvironmentsEnum;
  sourceDraftVersion?: Maybe<SolutionVersion>;
};

export enum SolutionEnvironmentsEnum {
  Live = 'live',
  Sandbox = 'sandbox'
}

export type SolutionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<SolutionTypeEnum>;
};

export type SolutionNodeData = {
  __typename?: 'SolutionNodeData';
  analyticsEvent?: Maybe<Scalars['JSON']['output']>;
  answerRequired?: Maybe<Scalars['Boolean']['output']>;
  behaviors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  command?: Maybe<Scalars['String']['output']>;
  cssClassname?: Maybe<Scalars['String']['output']>;
  decisionVariable?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nextNodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nluDisabled?: Maybe<Scalars['Boolean']['output']>;
  nodeInput?: Maybe<Scalars['String']['output']>;
  nodeName?: Maybe<Scalars['String']['output']>;
  nodeNumber?: Maybe<Scalars['String']['output']>;
  nodeTags?: Maybe<Scalars['String']['output']>;
  nodeType?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  parameterInput?: Maybe<Scalars['JSON']['output']>;
  platformFlag?: Maybe<Scalars['String']['output']>;
  richAssetContent?: Maybe<Scalars['JSON']['output']>;
  richAssetType?: Maybe<Scalars['String']['output']>;
  skillTag?: Maybe<Scalars['String']['output']>;
  utterances?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  whatsNext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SolutionS3FileContent = {
  __typename?: 'SolutionS3FileContent';
  content?: Maybe<Scalars['String']['output']>;
  encoding?: Maybe<Scalars['String']['output']>;
  isBinary: Scalars['Boolean']['output'];
  mimeType: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type SolutionS3FileDownloadUrl = {
  __typename?: 'SolutionS3FileDownloadUrl';
  expiresAt: Scalars['DateTime']['output'];
  path: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SolutionS3TreeEntry = {
  __typename?: 'SolutionS3TreeEntry';
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  path: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type SolutionTask = {
  __typename?: 'SolutionTask';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
};

export type SolutionTaskInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export enum SolutionTypeEnum {
  Main = 'main',
  Survey = 'survey'
}

/** Boolean expression to compare columns of type "SolutionType". All fields are combined with logical 'AND'. */
export type SolutionType_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['SolutionType']['input']>;
  _gt?: InputMaybe<Scalars['SolutionType']['input']>;
  _gte?: InputMaybe<Scalars['SolutionType']['input']>;
  _in?: InputMaybe<Array<Scalars['SolutionType']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['SolutionType']['input']>;
  _lte?: InputMaybe<Scalars['SolutionType']['input']>;
  _neq?: InputMaybe<Scalars['SolutionType']['input']>;
  _nin?: InputMaybe<Array<Scalars['SolutionType']['input']>>;
};

export type SolutionUserPresence = {
  __typename?: 'SolutionUserPresence';
  firstSeenAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  pageParams?: Maybe<Scalars['JSON']['output']>;
  pagePath?: Maybe<Scalars['String']['output']>;
  solutionId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SolutionVercelBlobTreeEntry = {
  __typename?: 'SolutionVercelBlobTreeEntry';
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  path: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type SolutionVersion = {
  __typename?: 'SolutionVersion';
  archiveUrl?: Maybe<Scalars['String']['output']>;
  botSolutionVersionId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<File>>>;
  fullyIntegrated?: Maybe<Scalars['Boolean']['output']>;
  hasGiteaIntegration?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  knowledgeAgentContext?: Maybe<Scalars['String']['output']>;
  llmCredential?: Maybe<LlmCredential>;
  llmCredentialId?: Maybe<Scalars['String']['output']>;
  maxOutputTokens?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otherInformation?: Maybe<Scalars['String']['output']>;
  /** The draft this was published from (v# slots) or branched from (non-default drafts). Null for the default draft. */
  parentVersion?: Maybe<SolutionVersion>;
  parentVersionId?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  solutionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SolutionVersionStatusEnum>;
  supervisorName?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<Maybe<SolutionTask>>>;
  temperature?: Maybe<Scalars['Float']['output']>;
  tone?: Maybe<Scalars['String']['output']>;
  topK?: Maybe<Scalars['Float']['output']>;
  topP?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type SolutionVersionComparison = {
  __typename?: 'SolutionVersionComparison';
  aheadCount: Scalars['Int']['output'];
  authorName?: Maybe<Scalars['String']['output']>;
  authorUsername?: Maybe<Scalars['String']['output']>;
  behindCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum SolutionVersionFilterEnum {
  All = 'ALL',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type SolutionVersionInput = {
  botSolutionVersionId?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  files: Array<FileInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  knowledgeAgentContext?: InputMaybe<Scalars['String']['input']>;
  llmCredentialId?: InputMaybe<Scalars['String']['input']>;
  maxOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  otherInformation?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
  tasks: Array<SolutionTaskInput>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
  topK?: InputMaybe<Scalars['Float']['input']>;
  topP?: InputMaybe<Scalars['Float']['input']>;
};

export enum SolutionVersionStatusEnum {
  Active = 'ACTIVE',
  Creating = 'CREATING',
  Publishing = 'PUBLISHING'
}

/** Boolean expression to compare columns of type "SolutionVersionStatus". All fields are combined with logical 'AND'. */
export type SolutionVersionStatus_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['SolutionVersionStatus']['input']>;
  _gt?: InputMaybe<Scalars['SolutionVersionStatus']['input']>;
  _gte?: InputMaybe<Scalars['SolutionVersionStatus']['input']>;
  _in?: InputMaybe<Array<Scalars['SolutionVersionStatus']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['SolutionVersionStatus']['input']>;
  _lte?: InputMaybe<Scalars['SolutionVersionStatus']['input']>;
  _neq?: InputMaybe<Scalars['SolutionVersionStatus']['input']>;
  _nin?: InputMaybe<Array<Scalars['SolutionVersionStatus']['input']>>;
};

export type SolutionVertexCorpus = {
  __typename?: 'SolutionVertexCorpus';
  corpusId?: Maybe<Scalars['String']['output']>;
  corpusName?: Maybe<Scalars['String']['output']>;
  environment: SolutionEnvironmentsEnum;
  fileCount: Scalars['Int']['output'];
  files: Array<VertexCorpusFile>;
};

export type SpeechConfigInput = {
  bargeIn?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  sttModel?: InputMaybe<Scalars['String']['input']>;
  ttsModel?: InputMaybe<Scalars['String']['input']>;
  voice?: InputMaybe<Scalars['String']['input']>;
};

export type SpeechCredentialInput = {
  apiKey: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};

export type Stream = {
  __typename?: 'Stream';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StreamInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type StudioResource = {
  __typename?: 'StudioResource';
  description?: Maybe<Scalars['String']['output']>;
  endNodeNumber?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nodes?: Maybe<Array<Maybe<TemplateNode>>>;
  startNodeNumber?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<StudioResourceTypeEnum>;
};

export enum StudioResourceTypeEnum {
  ActionNode = 'ACTION_NODE',
  MicroAgent = 'MICRO_AGENT'
}

/** Boolean expression to compare columns of type "StudioResourceType". All fields are combined with logical 'AND'. */
export type StudioResourceType_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['StudioResourceType']['input']>;
  _gt?: InputMaybe<Scalars['StudioResourceType']['input']>;
  _gte?: InputMaybe<Scalars['StudioResourceType']['input']>;
  _in?: InputMaybe<Array<Scalars['StudioResourceType']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['StudioResourceType']['input']>;
  _lte?: InputMaybe<Scalars['StudioResourceType']['input']>;
  _neq?: InputMaybe<Scalars['StudioResourceType']['input']>;
  _nin?: InputMaybe<Array<Scalars['StudioResourceType']['input']>>;
};

export type SystemMaskingRulesBe = {
  __typename?: 'SystemMaskingRulesBE';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  regex_patterns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Team = {
  __typename?: 'Team';
  assignedEnvironmentConfigs?: Maybe<Array<Maybe<TeamAccountEnvironmentConfig>>>;
  assignedMembers?: Maybe<Array<Maybe<User>>>;
  assignedProjects?: Maybe<Array<Maybe<Project>>>;
  assignedRoles?: Maybe<Array<Maybe<Role>>>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  defaultAccount?: Maybe<Account>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  memberCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissionsSummary?: Maybe<Array<Maybe<TeamPermissionSummaryItem>>>;
  roleCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type TeamPermissionsSummaryArgs = {
  accountId: Scalars['String']['input'];
};

export type TeamAccountEnvironmentConfig = {
  __typename?: 'TeamAccountEnvironmentConfig';
  id: Scalars['ID']['output'];
  projectEnvironmentConfig?: Maybe<ProjectEnvironmentConfig>;
  roles?: Maybe<Array<Maybe<Role>>>;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  id?: Maybe<Scalars['ID']['output']>;
  isMember?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

export type TeamMembersFilter = {
  excludeOrgAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  excludeSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  includeNonMembers: Scalars['Boolean']['input'];
  teamId: Scalars['String']['input'];
};

export type TeamPermissionSummaryItem = {
  __typename?: 'TeamPermissionSummaryItem';
  accountId?: Maybe<Scalars['ID']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  applicationId?: Maybe<Scalars['ID']['output']>;
  applicationName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  sectionName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Array<Maybe<TeamPermissionSummaryItemSource>>>;
};

export type TeamPermissionSummaryItemSource = {
  __typename?: 'TeamPermissionSummaryItemSource';
  accountId?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
};

export type TeamProductRoles = {
  __typename?: 'TeamProductRoles';
  accountId?: Maybe<Scalars['ID']['output']>;
  hasAgentAssistRoles?: Maybe<Scalars['Boolean']['output']>;
  hasAnalyticsRoles?: Maybe<Scalars['Boolean']['output']>;
  hasMaestroStudioRoles?: Maybe<Scalars['Boolean']['output']>;
  hasOrganizationRoles?: Maybe<Scalars['Boolean']['output']>;
  hasProStudioRoles?: Maybe<Scalars['Boolean']['output']>;
  teamId?: Maybe<Scalars['ID']['output']>;
};

export type TeamProject = {
  __typename?: 'TeamProject';
  accountId?: Maybe<Scalars['ID']['output']>;
  isAssigned?: Maybe<Scalars['Boolean']['output']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['ID']['output']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  teamId?: Maybe<Scalars['ID']['output']>;
};

export type TeamProjectsFilter = {
  includeUnassigned: Scalars['Boolean']['input'];
  teamId: Scalars['String']['input'];
};

export type TeamRole = {
  __typename?: 'TeamRole';
  id?: Maybe<Scalars['ID']['output']>;
  isAssigned?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Role>;
};

export type TeamRolesFilter = {
  includeUnassigned: Scalars['Boolean']['input'];
  teamId: Scalars['String']['input'];
};

export type TeamsFilter = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  includeChildOrgTeams?: InputMaybe<Scalars['Boolean']['input']>;
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TeamsToAddInput = {
  id: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
};

export type TeamsToUpdateInput = {
  id: Scalars['String']['input'];
  roleIdsToRemove: Array<Scalars['String']['input']>;
  rolesToAdd: Array<Scalars['String']['input']>;
};

export type TemplateNode = {
  __typename?: 'TemplateNode';
  answerRequired?: Maybe<Scalars['Boolean']['output']>;
  behaviors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  command?: Maybe<Scalars['String']['output']>;
  cssClassname?: Maybe<Scalars['String']['output']>;
  decisionVariable?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nextNodes?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  nluDisabled?: Maybe<Scalars['Boolean']['output']>;
  nodeInput?: Maybe<Scalars['String']['output']>;
  nodeName?: Maybe<Scalars['String']['output']>;
  nodeNumber?: Maybe<Scalars['Int']['output']>;
  nodeTags?: Maybe<Scalars['String']['output']>;
  nodeType?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  output?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  parameterInput?: Maybe<Scalars['JSON']['output']>;
  platformFlag?: Maybe<Scalars['String']['output']>;
  richAssetType?: Maybe<Scalars['String']['output']>;
  skillTag?: Maybe<Scalars['String']['output']>;
  studioResourceId?: Maybe<Scalars['String']['output']>;
  utterances?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  whatsNext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TimeZone = {
  __typename?: 'TimeZone';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type Trigger = {
  __typename?: 'Trigger';
  appletInstance?: Maybe<AppletInstance>;
  appletInstanceId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latestVersionWhileCreating?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Scalars['JSON']['output']>;
  package?: Maybe<Package>;
  packageId?: Maybe<Scalars['String']['output']>;
  packageVersion?: Maybe<PackageVersion>;
  packageVersionId?: Maybe<Scalars['String']['output']>;
};

export type TriggerCreate = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['String']['input'];
  packageVersionId?: InputMaybe<Scalars['String']['input']>;
};

export type TwilioConfigInput = {
  accountSid?: InputMaybe<Scalars['String']['input']>;
  authToken?: InputMaybe<Scalars['String']['input']>;
  elevenlabsAudioModel?: InputMaybe<Scalars['String']['input']>;
  elevenlabsSimilarity?: InputMaybe<Scalars['String']['input']>;
  elevenlabsSpeed?: InputMaybe<Scalars['String']['input']>;
  elevenlabsStability?: InputMaybe<Scalars['String']['input']>;
  elevenlabsVoiceId?: InputMaybe<Scalars['String']['input']>;
  elevenlabsVoiceMetadataB64?: InputMaybe<Scalars['JSON']['input']>;
  enableCallRecording?: InputMaybe<Scalars['Boolean']['input']>;
  inboundMessageBufferMs?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  languagesConfigB64?: InputMaybe<Scalars['String']['input']>;
  metadataIntegrationInfoB64?: InputMaybe<Scalars['String']['input']>;
  noAnswerFailoverNode?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  promptMaxRetries?: InputMaybe<Scalars['Int']['input']>;
  retryPromptPrefix?: InputMaybe<Scalars['String']['input']>;
  speechModel?: InputMaybe<Scalars['String']['input']>;
  transcriptionProvider?: InputMaybe<Scalars['String']['input']>;
  ttsProvider?: InputMaybe<Scalars['String']['input']>;
  userSilenceTimeout?: InputMaybe<Scalars['Int']['input']>;
  voiceHandoffOptionsB64?: InputMaybe<Scalars['String']['input']>;
  welcomeGreeting?: InputMaybe<Scalars['String']['input']>;
};

export type TwilioConfigInputBe = {
  accountSid?: InputMaybe<Scalars['String']['input']>;
  authToken?: InputMaybe<Scalars['String']['input']>;
  elevenlabsAudioModel?: InputMaybe<Scalars['String']['input']>;
  elevenlabsSimilarity?: InputMaybe<Scalars['String']['input']>;
  elevenlabsSpeed?: InputMaybe<Scalars['String']['input']>;
  elevenlabsStability?: InputMaybe<Scalars['String']['input']>;
  elevenlabsVoiceId?: InputMaybe<Scalars['String']['input']>;
  elevenlabsVoiceMetadataB64?: InputMaybe<Scalars['String']['input']>;
  enableCallRecording?: InputMaybe<Scalars['Boolean']['input']>;
  inboundMessageBufferMs?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  languagesConfigB64?: InputMaybe<Scalars['String']['input']>;
  metadataIntegrationInfoB64?: InputMaybe<Scalars['String']['input']>;
  noAnswerFailoverNode?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  promptMaxRetries?: InputMaybe<Scalars['Int']['input']>;
  retryPromptPrefix?: InputMaybe<Scalars['String']['input']>;
  speechModel?: InputMaybe<Scalars['String']['input']>;
  transcriptionProvider?: InputMaybe<Scalars['String']['input']>;
  ttsProvider?: InputMaybe<Scalars['String']['input']>;
  userSilenceTimeout?: InputMaybe<Scalars['Int']['input']>;
  voiceHandoffOptionsB64?: InputMaybe<Scalars['String']['input']>;
};

export enum Type {
  Apple = 'apple',
  Csp = 'csp',
  Facebook = 'facebook',
  Google = 'google',
  Instagram = 'instagram',
  Sms = 'sms',
  TwilioVoice = 'twilio_voice',
  Vaapi = 'vaapi',
  Whatsapp = 'whatsapp'
}

export type UpdateTeamsProjectAccessInput = {
  projectId: Scalars['String']['input'];
  teamsToAdd?: InputMaybe<Array<InputMaybe<TeamsToAddInput>>>;
  teamsToDelete?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teamsToUpdate?: InputMaybe<Array<InputMaybe<TeamsToUpdateInput>>>;
};

export type UpdateUsersProjectAccessInput = {
  projectId: Scalars['String']['input'];
  usersToAdd?: InputMaybe<Array<InputMaybe<UsersToAddInput>>>;
  usersToDelete?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usersToUpdate?: InputMaybe<Array<InputMaybe<UsersToUpdateInput>>>;
};

export type User = {
  __typename?: 'User';
  assignedEnvironmentConfigs?: Maybe<Array<Maybe<UserAccountEnvironmentConfig>>>;
  assignedProjects?: Maybe<Array<Maybe<Project>>>;
  assignedRoles?: Maybe<Array<Maybe<Role>>>;
  assignedTeams?: Maybe<Array<Maybe<Team>>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  defaultAccount?: Maybe<Account>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kratosIdentity?: Maybe<Scalars['JSON']['output']>;
  lastActiveAt: Scalars['DateTime']['output'];
  lastLoggedInAt?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  listOfAuthMethods?: Maybe<Array<Maybe<UserAuthMethodData>>>;
  localizationSettings?: Maybe<LocalizationSettings>;
  optionalConsentStatus?: Maybe<ConsentStatusEnum>;
  optionalConsentUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  passwordRecoveryStatus?: Maybe<PasswordRecoveryStatusEnum>;
  picture?: Maybe<Scalars['String']['output']>;
  pictureFile?: Maybe<File>;
  requiredConsentStatus?: Maybe<ConsentStatusEnum>;
  requiredConsentUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  sessions?: Maybe<Array<Maybe<UserSession>>>;
  settings?: Maybe<Scalars['JSON']['output']>;
  status: UserStatus;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type UserAccountEnvironmentConfig = {
  __typename?: 'UserAccountEnvironmentConfig';
  id: Scalars['String']['output'];
  projectEnvironmentConfig?: Maybe<ProjectEnvironmentConfig>;
  roles?: Maybe<Array<Maybe<Role>>>;
};

export type UserAuthMethod = {
  __typename?: 'UserAuthMethod';
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isCreationOne?: Maybe<Scalars['Boolean']['output']>;
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AuthMethodTypeEnum>;
};

export type UserAuthMethodData = {
  __typename?: 'UserAuthMethodData';
  accountAuthMethodSettingsId?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isCreationOne?: Maybe<Scalars['Boolean']['output']>;
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AuthMethodTypeEnum>;
};

export type UserLoginInfo = {
  __typename?: 'UserLoginInfo';
  authMethods?: Maybe<Array<Maybe<UserAuthMethod>>>;
  email?: Maybe<Scalars['String']['output']>;
  passwordRecoveryStatus?: Maybe<PasswordRecoveryStatusEnum>;
};

export type UserProductRoles = {
  __typename?: 'UserProductRoles';
  accountId?: Maybe<Scalars['ID']['output']>;
  agentAssistRolesSource?: Maybe<Array<Maybe<RoleSource>>>;
  analyticsRolesSource?: Maybe<Array<Maybe<RoleSource>>>;
  hasAgentAssistRoles?: Maybe<Scalars['Boolean']['output']>;
  hasAnalyticsRoles?: Maybe<Scalars['Boolean']['output']>;
  hasMaestroStudioRoles?: Maybe<Scalars['Boolean']['output']>;
  hasOrganizationRoles?: Maybe<Scalars['Boolean']['output']>;
  hasProStudioRoles?: Maybe<Scalars['Boolean']['output']>;
  maestroStudioRolesSource?: Maybe<Array<Maybe<RoleSource>>>;
  organizationRolesSource?: Maybe<Array<Maybe<RoleSource>>>;
  proStudioRolesSource?: Maybe<Array<Maybe<RoleSource>>>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UserProject = {
  __typename?: 'UserProject';
  accountId?: Maybe<Scalars['ID']['output']>;
  isAssigned?: Maybe<Scalars['Boolean']['output']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['ID']['output']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UserProjectsFilter = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  includeUnassigned: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type UserRole = {
  __typename?: 'UserRole';
  id?: Maybe<Scalars['ID']['output']>;
  isAssigned?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Role>;
};

export type UserRolesFilter = {
  includeUnassigned: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type UserSession = {
  __typename?: 'UserSession';
  authenticatedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Locked = 'LOCKED'
}

export type UserTeam = {
  __typename?: 'UserTeam';
  id?: Maybe<Scalars['ID']['output']>;
  isAssigned?: Maybe<Scalars['Boolean']['output']>;
  team?: Maybe<Team>;
};

export type UserTeamsFilter = {
  includeUnassigned: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type UsersFilter = {
  accountId: Scalars['String']['input'];
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type UsersToAddInput = {
  id: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
};

export type UsersToUpdateInput = {
  id: Scalars['String']['input'];
  roleIdsToRemove: Array<Scalars['String']['input']>;
  rolesToAdd: Array<Scalars['String']['input']>;
};

export type V3BroadcastInput = {
  arrayOfMobileNumbers: Array<InputMaybe<Scalars['String']['input']>>;
  pypestreamUserMsg?: InputMaybe<Scalars['String']['input']>;
  smsUserMsg?: InputMaybe<Scalars['String']['input']>;
};

export type V3BusinessAgent2Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pypeId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type V3BusinessAgentInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pypeId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type V3BusinessWidgetDataInput = {
  beta?: InputMaybe<Scalars['String']['input']>;
  custom_pype_css?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  pype_id?: InputMaybe<Scalars['String']['input']>;
  stream_id?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  widget_name?: InputMaybe<Scalars['String']['input']>;
};

export type V3BusinessWidgetDataResponse = {
  __typename?: 'V3BusinessWidgetDataResponse';
  beta?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  creation_date?: Maybe<Scalars['Date']['output']>;
  custom_pype_css?: Maybe<Scalars['String']['output']>;
  enable_prechat?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_updated?: Maybe<Scalars['Date']['output']>;
  prechat_custom_field1_name?: Maybe<Scalars['String']['output']>;
  prechat_custom_field1_value?: Maybe<Scalars['String']['output']>;
  prechat_custom_field2_name?: Maybe<Scalars['String']['output']>;
  prechat_custom_field2_value?: Maybe<Scalars['String']['output']>;
  prechat_email?: Maybe<Scalars['String']['output']>;
  prechat_firstname?: Maybe<Scalars['String']['output']>;
  prechat_lastname?: Maybe<Scalars['String']['output']>;
  prechat_msg?: Maybe<Scalars['String']['output']>;
  prechat_phone?: Maybe<Scalars['String']['output']>;
  pype_id?: Maybe<Scalars['String']['output']>;
  stream_id?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  whitelist?: Maybe<Scalars['String']['output']>;
  widget_name?: Maybe<Scalars['String']['output']>;
};

export type V3BusinessWidgetInput = {
  authToken?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<V3BusinessWidgetDataInput>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  requestAction?: InputMaybe<Scalars['String']['input']>;
  requestType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type V3BusinessWidgetResponse = {
  __typename?: 'V3BusinessWidgetResponse';
  data?: Maybe<V3BusinessWidgetDataResponse>;
  detail?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  source_action?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type V3ConfigurationCustomerChannel2Input = {
  config?: InputMaybe<ConfigInput>;
  endBot?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pypeId?: InputMaybe<Scalars['String']['input']>;
  startBot?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Type>;
};

export type V3ConfigurationCustomerChannelInput = {
  config?: InputMaybe<ConfigInput>;
  endBot?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  speechEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  startBot?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Type>;
};

export type V3ConfigurationPypeInput = {
  agentRouting?: InputMaybe<AgentRouting>;
  config?: InputMaybe<Config2Input>;
};

export type V3PypeKeysInput = {
  friendlyName?: InputMaybe<Scalars['String']['input']>;
};

export type V6CustomersInfo = {
  __typename?: 'V6CustomersInfo';
  agent_routing?: Maybe<Scalars['String']['output']>;
  agent_routing_config?: Maybe<Scalars['JSON']['output']>;
  agent_routing_url?: Maybe<Scalars['String']['output']>;
  agents_can_initiate_chats?: Maybe<Scalars['Boolean']['output']>;
  auto_joinable?: Maybe<Scalars['Boolean']['output']>;
  bot_retry?: Maybe<BotRetry>;
  bot_url?: Maybe<Scalars['String']['output']>;
  broadcast_stream_id?: Maybe<Scalars['String']['output']>;
  chat_default_limit?: Maybe<Scalars['Int']['output']>;
  chat_log_http_headers?: Maybe<Scalars['String']['output']>;
  chat_logs_email?: Maybe<Scalars['String']['output']>;
  chat_logs_email_enabled?: Maybe<Scalars['Boolean']['output']>;
  chat_logs_end_point?: Maybe<Scalars['String']['output']>;
  chat_logs_http_enabled?: Maybe<Scalars['Boolean']['output']>;
  checklist_complete?: Maybe<Scalars['Boolean']['output']>;
  company_type?: Maybe<Scalars['String']['output']>;
  creation_date?: Maybe<Scalars['Date']['output']>;
  crm_enabled?: Maybe<Scalars['Boolean']['output']>;
  crm_label?: Maybe<Scalars['String']['output']>;
  crm_url?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  encrypted?: Maybe<Scalars['Boolean']['output']>;
  end_comment_display?: Maybe<Scalars['Boolean']['output']>;
  end_comment_required?: Maybe<Scalars['Boolean']['output']>;
  end_tags_display?: Maybe<Scalars['Boolean']['output']>;
  end_tags_required?: Maybe<Scalars['Boolean']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_updated?: Maybe<Scalars['Date']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo_generated?: Maybe<Scalars['Boolean']['output']>;
  masking_rules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mode?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  reroute_limit?: Maybe<Scalars['Int']['output']>;
  sf_deployment?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streams?: Maybe<Array<Maybe<V6Streams>>>;
  system_masking_rules?: Maybe<Array<Maybe<MaskingRules>>>;
  tags_categories?: Maybe<Scalars['JSON']['output']>;
  tags_multiple?: Maybe<Scalars['Boolean']['output']>;
  tags_shortcuts?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  whitelist_domains?: Maybe<Scalars['String']['output']>;
  widget_branding?: Maybe<Scalars['Boolean']['output']>;
  widget_gateway_identifier?: Maybe<Scalars['String']['output']>;
  widget_version?: Maybe<Scalars['Int']['output']>;
};

export type V6CustomersResult = {
  __typename?: 'V6CustomersResult';
  data?: Maybe<Array<Maybe<V6CustomersInfo>>>;
};

export type V6Streams = {
  __typename?: 'V6Streams';
  abc_enabled?: Maybe<Scalars['Boolean']['output']>;
  abc_id?: Maybe<Scalars['String']['output']>;
  analytics_api_host?: Maybe<Scalars['String']['output']>;
  analytics_api_key?: Maybe<Scalars['String']['output']>;
  analytics_default?: Maybe<Scalars['String']['output']>;
  analytics_enabled?: Maybe<Scalars['Boolean']['output']>;
  analytics_transcript_enabled?: Maybe<Scalars['Boolean']['output']>;
  auto_joinable?: Maybe<Scalars['String']['output']>;
  auto_start_with_bot?: Maybe<Scalars['Boolean']['output']>;
  awesome_font_icon?: Maybe<Scalars['String']['output']>;
  bot_enabled?: Maybe<Scalars['Boolean']['output']>;
  bot_flag?: Maybe<Scalars['String']['output']>;
  bot_id?: Maybe<Scalars['String']['output']>;
  broadcast_channel?: Maybe<Scalars['String']['output']>;
  broadcast_sms_limit?: Maybe<Scalars['String']['output']>;
  creation_date?: Maybe<Scalars['Date']['output']>;
  csp_account_id?: Maybe<Scalars['String']['output']>;
  csp_agent_bot_token?: Maybe<Scalars['String']['output']>;
  csp_channel_type?: Maybe<Scalars['String']['output']>;
  csp_enabled?: Maybe<Scalars['Boolean']['output']>;
  csp_id?: Maybe<Scalars['String']['output']>;
  csp_inbox_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_chat_bot_enabled?: Maybe<Scalars['Boolean']['output']>;
  end_chat_bot_id?: Maybe<Scalars['String']['output']>;
  fb_access_token?: Maybe<Scalars['String']['output']>;
  fb_bot?: Maybe<Scalars['String']['output']>;
  fb_enabled?: Maybe<Scalars['Boolean']['output']>;
  fb_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  last_updated?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  pype_id?: Maybe<Scalars['String']['output']>;
  sms_enabled?: Maybe<Scalars['Boolean']['output']>;
  sms_id?: Maybe<Scalars['String']['output']>;
  sms_phone_id?: Maybe<Scalars['String']['output']>;
  sms_phone_number?: Maybe<Scalars['String']['output']>;
  sms_token?: Maybe<Scalars['String']['output']>;
  speech_config?: Maybe<ChannelSpeechConfig>;
  speech_enabled?: Maybe<Scalars['Boolean']['output']>;
  start_chat_bot_enabled?: Maybe<Scalars['Boolean']['output']>;
  start_chat_bot_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stream_name?: Maybe<Scalars['String']['output']>;
  twilio_voice_config?: Maybe<Scalars['String']['output']>;
  twilio_voice_enabled?: Maybe<Scalars['Boolean']['output']>;
  twilio_voice_id?: Maybe<Scalars['String']['output']>;
  vaapi_config?: Maybe<Scalars['String']['output']>;
  vaapi_enabled?: Maybe<Scalars['Boolean']['output']>;
  vaapi_id?: Maybe<Scalars['String']['output']>;
  vaapi_integrator?: Maybe<Scalars['String']['output']>;
  widgets?: Maybe<Array<Maybe<V6Widget>>>;
};

export type V6Widget = {
  __typename?: 'V6Widget';
  beta?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  creation_date?: Maybe<Scalars['Int']['output']>;
  custom_pype_css?: Maybe<Scalars['String']['output']>;
  enable_prechat?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_updated?: Maybe<Scalars['Int']['output']>;
  prechat_custom_field1_name?: Maybe<Scalars['String']['output']>;
  prechat_custom_field1_value?: Maybe<Scalars['String']['output']>;
  prechat_custom_field2_name?: Maybe<Scalars['String']['output']>;
  prechat_custom_field2_value?: Maybe<Scalars['String']['output']>;
  prechat_email?: Maybe<Scalars['String']['output']>;
  prechat_firstname?: Maybe<Scalars['String']['output']>;
  prechat_lastname?: Maybe<Scalars['String']['output']>;
  prechat_msg?: Maybe<Scalars['String']['output']>;
  prechat_phone?: Maybe<Scalars['String']['output']>;
  pype_id?: Maybe<Scalars['String']['output']>;
  stream_id?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  whitelist?: Maybe<Scalars['String']['output']>;
  widget_name?: Maybe<Scalars['String']['output']>;
};

export type ValidatedEnvironmentDomainUrl = {
  __typename?: 'ValidatedEnvironmentDomainUrl';
  intersections?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isValid: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
  validationResult?: Maybe<Scalars['String']['output']>;
};

export type ValidatedEnvironmentDomainUrls = {
  __typename?: 'ValidatedEnvironmentDomainUrls';
  urls?: Maybe<Array<Maybe<ValidatedEnvironmentDomainUrl>>>;
};

export type Variable = {
  __typename?: 'Variable';
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectEnvironmentConfigs?: Maybe<Array<Maybe<ProjectEnvironmentConfig>>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  value: Scalars['String']['output'];
  variableAccessLevel: VariableAccessLevelEnum;
};

export enum VariableAccessLevelEnum {
  Organization = 'ORGANIZATION',
  Project = 'PROJECT'
}

/** Boolean expression to compare columns of type "VariableAccessLevel". All fields are combined with logical 'AND'. */
export type VariableAccessLevel_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['VariableAccessLevel']['input']>;
  _gt?: InputMaybe<Scalars['VariableAccessLevel']['input']>;
  _gte?: InputMaybe<Scalars['VariableAccessLevel']['input']>;
  _in?: InputMaybe<Array<Scalars['VariableAccessLevel']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['VariableAccessLevel']['input']>;
  _lte?: InputMaybe<Scalars['VariableAccessLevel']['input']>;
  _neq?: InputMaybe<Scalars['VariableAccessLevel']['input']>;
  _nin?: InputMaybe<Array<Scalars['VariableAccessLevel']['input']>>;
};

export type VariablesFilter = {
  projectEnvironmentConfigIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectId: Scalars['String']['input'];
  variableKeySearch?: InputMaybe<Scalars['String']['input']>;
};

export type Version = {
  __typename?: 'Version';
  data?: Maybe<Scalars['JSON']['output']>;
  messages?: Maybe<Scalars['String']['output']>;
};

export type VersionBulkTestInput = {
  bulkTestFile: Scalars['Upload']['input'];
};

export type VersionConfigInput = {
  configFile: Scalars['Upload']['input'];
};

export type VersionDeployInput = {
  doVersionBump?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
};

export type VersionGraphInput = {
  multiLanguageData?: InputMaybe<Scalars['String']['input']>;
  templateData?: InputMaybe<Scalars['String']['input']>;
  templateFeatures?: InputMaybe<Scalars['String']['input']>;
  templateType?: InputMaybe<Scalars['String']['input']>;
  templateVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type VersionScriptsInput = {
  scriptFile: Array<InputMaybe<Scalars['Upload']['input']>>;
};

export type VersionSearchNluTrainInput = {
  stopwordsFile?: InputMaybe<Scalars['Upload']['input']>;
  synonymsFile?: InputMaybe<Scalars['Upload']['input']>;
  templateFile: Scalars['Upload']['input'];
};

export type VersionStopwordsInput = {
  stopwords?: InputMaybe<Scalars['String']['input']>;
};

export type VersionTemplatesInput = {
  templateFile: Scalars['Upload']['input'];
};

export type VersionValidateResponse = {
  __typename?: 'VersionValidateResponse';
  data?: Maybe<Scalars['String']['output']>;
};

export type VertexCorporaPage = {
  __typename?: 'VertexCorporaPage';
  corpora: Array<VertexCorpus>;
  /** Pass as pageToken to get the next page; null on the last page. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type VertexCorpus = {
  __typename?: 'VertexCorpus';
  displayName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Parsed from a display name of the form '<solutionId> <live|sandbox>'; null for other corpora. */
  solutionId?: Maybe<Scalars['String']['output']>;
};

export type VertexCorpusFile = {
  __typename?: 'VertexCorpusFile';
  displayName?: Maybe<Scalars['String']['output']>;
  gcsUris: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type VoiceAiAccentsResult = {
  __typename?: 'VoiceAiAccentsResult';
  accents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  language?: Maybe<Scalars['String']['output']>;
};

export type VoiceAiLanguage = {
  __typename?: 'VoiceAiLanguage';
  default_locale?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  locales?: Maybe<Array<Maybe<VoiceAiLanguageLocale>>>;
  name?: Maybe<Scalars['String']['output']>;
  stt_providers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VoiceAiLanguageLocale = {
  __typename?: 'VoiceAiLanguageLocale';
  locale?: Maybe<Scalars['String']['output']>;
  stt_providers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VoiceAiLanguagesResult = {
  __typename?: 'VoiceAiLanguagesResult';
  count?: Maybe<Scalars['Int']['output']>;
  languages?: Maybe<Array<Maybe<VoiceAiLanguage>>>;
};

export type VoiceAiProvider = {
  __typename?: 'VoiceAiProvider';
  accent?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cloned_by_count?: Maybe<Scalars['Int']['output']>;
  date_unix?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptive?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  fiat_rate?: Maybe<Scalars['Int']['output']>;
  free_users_allowed?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  instagram_username?: Maybe<Scalars['String']['output']>;
  is_added_by_user?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  live_moderation_enabled?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notice_period?: Maybe<Scalars['Int']['output']>;
  play_api_usage_character_count_1y?: Maybe<Scalars['Int']['output']>;
  preview_url?: Maybe<Scalars['String']['output']>;
  public_owner_id?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Int']['output']>;
  tiktok_username?: Maybe<Scalars['String']['output']>;
  twitter_username?: Maybe<Scalars['String']['output']>;
  usage_character_count_1y?: Maybe<Scalars['Int']['output']>;
  usage_character_count_7d?: Maybe<Scalars['Int']['output']>;
  use_case?: Maybe<Scalars['String']['output']>;
  verified_languages?: Maybe<Array<Maybe<VoiceAiProviderVerifiedLanguage>>>;
  voice_id?: Maybe<Scalars['String']['output']>;
  youtube_username?: Maybe<Scalars['String']['output']>;
};

export type VoiceAiProviderResult = {
  __typename?: 'VoiceAiProviderResult';
  count?: Maybe<Scalars['Int']['output']>;
  current_page?: Maybe<Scalars['Int']['output']>;
  has_more?: Maybe<Scalars['Boolean']['output']>;
  voices?: Maybe<Array<Maybe<VoiceAiProvider>>>;
};

export type VoiceAiProviderVerifiedLanguage = {
  __typename?: 'VoiceAiProviderVerifiedLanguage';
  accent?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  preview_url?: Maybe<Scalars['String']['output']>;
};

export type VoiceAiSpeechModel = {
  __typename?: 'VoiceAiSpeechModel';
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locales?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  model_id?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
};

export type VoiceAiSpeechModelsResult = {
  __typename?: 'VoiceAiSpeechModelsResult';
  count?: Maybe<Scalars['Int']['output']>;
  speech_models?: Maybe<Array<Maybe<VoiceAiSpeechModel>>>;
};

export type WidgetAppDesign = {
  __typename?: 'WidgetAppDesign';
  config?: Maybe<Scalars['JSON']['output']>;
  schemaVersion?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type WidgetAppDesignInput = {
  config: Scalars['JSON']['input'];
  schemaVersion: Scalars['Int']['input'];
};

export type WidgetAppDesignMetadata = {
  __typename?: 'WidgetAppDesignMetadata';
  revision?: Maybe<Scalars['String']['output']>;
  schemaVersion?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<WidgetAppDesignUpdatedBy>;
};

export type WidgetAppDesignResponse = {
  __typename?: 'WidgetAppDesignResponse';
  config?: Maybe<Scalars['JSON']['output']>;
  metadata?: Maybe<WidgetAppDesignMetadata>;
};

export type WidgetAppDesignUpdatedBy = {
  __typename?: 'WidgetAppDesignUpdatedBy';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Admin_Mutation = {
  __typename?: 'admin_Mutation';
  _?: Maybe<Scalars['Boolean']['output']>;
  addPypeToPypeConnection?: Maybe<PypeConnection>;
  addPypeToPypeRuleGroup?: Maybe<PypeRuleGroup>;
  addUserToAccount?: Maybe<User>;
  assignProjectProductAdminRoles?: Maybe<User>;
  /** Cancels a deployment whose build no runner has started yet (status queued): marks it cancelled and releases the solution's publish lock. Fails with CONFLICT once the build has started or the deployment has finished. The queued Gitea run stops itself before building when a runner eventually starts it. */
  cancelSolutionDeployment?: Maybe<Scalars['Boolean']['output']>;
  completeLogin?: Maybe<Scalars['String']['output']>;
  connectAuthMethod?: Maybe<Scalars['Boolean']['output']>;
  connectProjectToExistingCustomer?: Maybe<Project>;
  copyBots?: Maybe<Scalars['Boolean']['output']>;
  createAccount?: Maybe<Account>;
  createAndConnectProjectToExistingCustomer?: Maybe<Project>;
  createApplet?: Maybe<Applet>;
  createAppletInstance?: Maybe<AppletInstance>;
  createAppletVersion?: Maybe<AppletVersion>;
  createChannel?: Maybe<ChannelCreationResponse>;
  createCorpusesAndUpdateNodeForSolution?: Maybe<Scalars['Boolean']['output']>;
  createCredential?: Maybe<LlmCredential>;
  /** Creates a new, non-default draft from a published version: copies the published version's content (settings, tasks, files, node graph) and creates its Gitea branch from the exact commit on the originating draft that the version was published from. The new draft's parent is that originating draft. sourceVersionId must refer to a published SolutionVersion (isDraft: false) that has a draft parent; name must be a valid Git branch name not already used by a version or branch of the solution. */
  createDraftVersion?: Maybe<SolutionVersion>;
  createMaestroOrgSecret: MaestroOrgSecret;
  createPackage?: Maybe<Package>;
  createProject?: Maybe<Project>;
  createPypeConnection?: Maybe<PypeConnection>;
  createPypeRuleGroup?: Maybe<PypeRuleGroup>;
  createRole?: Maybe<Role>;
  createSolution?: Maybe<Solution>;
  createTeam?: Maybe<Team>;
  createUserIdentity?: Maybe<Scalars['Boolean']['output']>;
  createVariable?: Maybe<Variable>;
  createVertexCorpuses: Array<SolutionVertexCorpus>;
  deactivateAllUserSessions?: Maybe<Scalars['Int']['output']>;
  deactivateUserSession?: Maybe<Scalars['Int']['output']>;
  deleteAccount?: Maybe<Account>;
  deleteAgentManagerFile?: Maybe<Scalars['Boolean']['output']>;
  deleteApplet?: Maybe<Applet>;
  deleteAppletInstance?: Maybe<AppletInstance>;
  deleteAppletVersion?: Maybe<AppletVersion>;
  deleteCredential?: Maybe<LlmCredential>;
  deleteMaestroOrgSecret: Scalars['Boolean']['output'];
  deletePackage?: Maybe<Package>;
  deletePackageVersion?: Maybe<PackageVersion>;
  deleteProject?: Maybe<Scalars['Int']['output']>;
  deletePypeConnection?: Maybe<Scalars['Boolean']['output']>;
  deletePypeRuleGroup?: Maybe<Scalars['Boolean']['output']>;
  deleteRoles?: Maybe<Array<Maybe<OperationResult>>>;
  deleteSolution?: Maybe<Scalars['Boolean']['output']>;
  deleteTeams?: Maybe<Array<Maybe<OperationResult>>>;
  deleteUserIdentity?: Maybe<Scalars['Boolean']['output']>;
  deleteVariable?: Maybe<Variable>;
  /** Starts a background job that deletes the given corpora one by one, throttled to stay under the Vertex RAG per-minute quota. corpusNames are the 'name' values from the vertexCorpora query (projects/<project>/locations/<region>/ragCorpora/<id>). Corpora still referenced by a solution in this environment's database are skipped. Progress is logged. Super-admin only. */
  deleteVertexCorpora?: Maybe<Scalars['Boolean']['output']>;
  deleteVertexCorpuses: Array<SolutionVertexCorpus>;
  falsifyUserActiveSessions?: Maybe<User>;
  finishUserRecoveryProcess?: Maybe<Scalars['Boolean']['output']>;
  handleConsent?: Maybe<Scalars['String']['output']>;
  /** Copies the caller's classic project secrets into the Pypestream org, prefixed PYPESTREAM_. */
  importMaestroOrgClassicSecrets: MaestroClassicImport;
  lockAccount?: Maybe<Account>;
  makeDbSnapshot?: Maybe<Scalars['Boolean']['output']>;
  migrateBots?: Maybe<Scalars['Boolean']['output']>;
  migratePypeSettings?: Maybe<Scalars['Boolean']['output']>;
  /** Publishes a draft: snapshots it onto a version-number slot (new, or the still-failed one from the last attempt) and publishes that snapshot. draftVersionId must refer to a SolutionVersion with isDraft: true. */
  publishSolutionVersion?: Maybe<Scalars['Boolean']['output']>;
  removeDataForSolutionPreview?: Maybe<Scalars['String']['output']>;
  removePypeFromPypeConnection?: Maybe<PypeConnection>;
  removePypeFromPypeRuleGroup?: Maybe<PypeRuleGroup>;
  removeUsersFromAccount?: Maybe<Array<Maybe<OperationResult>>>;
  /** One-off migration step for the solution-versioning redesign: renames every pre-cutover solution's draft branch (and its SolutionVersion row) from vN to draft, in Gitea and the DB together. Super-admin only, fire-and-forget — see rename-legacy-draft-branches.ts. */
  renameLegacyDraftBranches?: Maybe<Scalars['Boolean']['output']>;
  /** Retries an existing deployment in its own environment, with the same publish options (useBotCompiler, runTests) it last ran with; deployments from before those were recorded default both to false. Never creates or touches a version slot. */
  republishSolutionDeployment?: Maybe<Scalars['Boolean']['output']>;
  resetActionNodeRuntimeConfig: Scalars['Boolean']['output'];
  resetMaestroOrgSettings: Scalars['Boolean']['output'];
  setRolesTeams?: Maybe<Scalars['Int']['output']>;
  setRolesUsers?: Maybe<Scalars['Int']['output']>;
  setTeamAccountEnvironmentsRoles?: Maybe<Team>;
  setTeamAccountProjectsRoles?: Maybe<Team>;
  setTeamsMembers?: Maybe<Scalars['String']['output']>;
  setTeamsProjects?: Maybe<Scalars['Int']['output']>;
  setTeamsRoles?: Maybe<Scalars['String']['output']>;
  setUserAccountEnvironmentsRoles?: Maybe<User>;
  setUserAccountProjectsRoles?: Maybe<User>;
  setUserLocalizationSettings?: Maybe<User>;
  setUserPasswordRecoveryStatus?: Maybe<User>;
  setUsersProjects?: Maybe<Scalars['Int']['output']>;
  setUsersRoles?: Maybe<Scalars['Int']['output']>;
  setUsersTeams?: Maybe<Scalars['Int']['output']>;
  startUserRecoveryProcess?: Maybe<Scalars['Boolean']['output']>;
  unlockAccount?: Maybe<Account>;
  updateAccount?: Maybe<Account>;
  updateActionNodeAutoscaling?: Maybe<ActionNodeRuntimeConfig>;
  updateActionNodePackages?: Maybe<ActionNodePackages>;
  updateActionNodeResources?: Maybe<ActionNodeResources>;
  updateActionNodeTimeout?: Maybe<ActionNodeRuntimeConfig>;
  updateAnalyticsDataset: Scalars['JSON']['output'];
  updateAnalyticsForChannel?: Maybe<Scalars['Boolean']['output']>;
  updateApplet?: Maybe<Applet>;
  updateAppletInstance?: Maybe<AppletInstance>;
  updateAppletVersion?: Maybe<AppletVersion>;
  updateCredential?: Maybe<LlmCredential>;
  updateDomainsVerificationStatus?: Maybe<Array<Maybe<Domain>>>;
  updateMaestroOrgSecret: MaestroOrgSecret;
  updateMaestroOrgSettings: MaestroSettingsGroup;
  updatePackage?: Maybe<Package>;
  updateProject?: Maybe<Project>;
  updateProjectEnvironmentConfig?: Maybe<ProjectEnvironmentConfig>;
  updateProjectLocalizationSettings?: Maybe<Project>;
  updatePypeConnection?: Maybe<PypeConnection>;
  updatePypeRuleGroup?: Maybe<PypeRuleGroup>;
  updateRole?: Maybe<Role>;
  updateRoleMembers?: Maybe<Role>;
  updateRoleTeams?: Maybe<Role>;
  updateSolution?: Maybe<Solution>;
  /** Regenerates bot.pif on a draft's branch when its nodes changed since the file's last commit. solutionVersionId picks the draft; the solution's default draft when omitted. */
  updateSolutionPifFile?: Maybe<Scalars['Boolean']['output']>;
  updateSolutionVersion?: Maybe<SolutionVersion>;
  updateTeam?: Maybe<Team>;
  updateTeamMembers?: Maybe<Team>;
  updateTeamProjects?: Maybe<Team>;
  updateTeamRoles?: Maybe<Team>;
  updateTeamsProjectAccess?: Maybe<Scalars['Boolean']['output']>;
  updateUser?: Maybe<User>;
  updateUserLocalizationSettings?: Maybe<User>;
  updateUserProjects?: Maybe<User>;
  updateUserRoles?: Maybe<User>;
  updateUserTeams?: Maybe<User>;
  updateUsersProjectAccess?: Maybe<Scalars['Boolean']['output']>;
  updateVariable?: Maybe<Variable>;
  upsertSolutionUserPresence?: Maybe<SolutionUserPresence>;
  verifyDomain?: Maybe<Scalars['Boolean']['output']>;
};


export type Admin_MutationAddPypeToPypeConnectionArgs = {
  env: SolutionEnvironmentsEnum;
  id: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Admin_MutationAddPypeToPypeRuleGroupArgs = {
  env: SolutionEnvironmentsEnum;
  id: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Admin_MutationAddUserToAccountArgs = {
  accountId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  projectIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  teamIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teamIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIconId?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
};


export type Admin_MutationAssignProjectProductAdminRolesArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_MutationCancelSolutionDeploymentArgs = {
  solutionDeploymentId: Scalars['String']['input'];
};


export type Admin_MutationCompleteLoginArgs = {
  identityId: Scalars['String']['input'];
  loginChallenge: Scalars['String']['input'];
};


export type Admin_MutationConnectAuthMethodArgs = {
  accountAuthMethodSettingsId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Admin_MutationConnectProjectToExistingCustomerArgs = {
  accountId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  productIds: Array<InputMaybe<Scalars['String']['input']>>;
  projectId: Scalars['String']['input'];
};


export type Admin_MutationCopyBotsArgs = {
  payload: Scalars['JSON']['input'];
};


export type Admin_MutationCreateAccountArgs = {
  accountIconId?: InputMaybe<Scalars['String']['input']>;
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  accountName: Scalars['String']['input'];
  customAuthMethods?: InputMaybe<Array<InputMaybe<CustomAuthMethodCreateInput>>>;
  defaultAuthMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  generalSettings?: InputMaybe<Scalars['JSON']['input']>;
  parentAccountId: Scalars['String']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  resourceLimitSettings?: InputMaybe<Scalars['JSON']['input']>;
};


export type Admin_MutationCreateAndConnectProjectToExistingCustomerArgs = {
  accountId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationCreateAppletArgs = {
  appletCategory: AppletCategoryEnum;
  appletType: AppletTypeEnum;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  iconId?: InputMaybe<Scalars['String']['input']>;
  pkgName: Scalars['String']['input'];
  schema: Scalars['JSON']['input'];
  version: Scalars['String']['input'];
  versionDescription?: InputMaybe<Scalars['String']['input']>;
};


export type Admin_MutationCreateAppletInstanceArgs = {
  actions?: InputMaybe<Array<ActionCreate>>;
  appletVersionId: Scalars['String']['input'];
  condition?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Scalars['JSON']['input']>;
  projectEnvironmentConfigId: Scalars['String']['input'];
  status?: InputMaybe<AppletStatusEnum>;
  triggers?: InputMaybe<Array<TriggerCreate>>;
};


export type Admin_MutationCreateAppletVersionArgs = {
  appletId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  schema: Scalars['JSON']['input'];
  version: Scalars['String']['input'];
};


export type Admin_MutationCreateChannelArgs = {
  beta: Scalars['String']['input'];
  botId: Scalars['String']['input'];
  botName: Scalars['String']['input'];
  config?: InputMaybe<DefaultChannelConfigInput>;
  customPypeCss: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  env: SolutionEnvironmentsEnum;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  style: Scalars['String']['input'];
  twilioParams?: InputMaybe<TwilioConfigInputBe>;
  type: ChannelTypesEnum;
};


export type Admin_MutationCreateCorpusesAndUpdateNodeForSolutionArgs = {
  solutionId: Scalars['String']['input'];
  solutionVersionId: Scalars['String']['input'];
};


export type Admin_MutationCreateCredentialArgs = {
  credential: LlmCredentialInput;
};


export type Admin_MutationCreateDraftVersionArgs = {
  name: Scalars['String']['input'];
  sourceVersionId: Scalars['String']['input'];
};


export type Admin_MutationCreateMaestroOrgSecretArgs = {
  accountId: Scalars['String']['input'];
  input: MaestroOrgSecretInput;
};


export type Admin_MutationCreatePackageArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  packageJson: Scalars['JSON']['input'];
  packageTypes: Array<PackageTypeEnum>;
  pkgName: Scalars['String']['input'];
  schema: Scalars['JSON']['input'];
  version: Scalars['String']['input'];
};


export type Admin_MutationCreateProjectArgs = {
  accountId: Scalars['String']['input'];
  countryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  localeId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productIds: Array<InputMaybe<Scalars['String']['input']>>;
  projectEnvironmentConfigs?: InputMaybe<Array<InputMaybe<ProjectEnvironmentConfigCreate>>>;
  projectIconId?: InputMaybe<Scalars['String']['input']>;
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
};


export type Admin_MutationCreatePypeConnectionArgs = {
  agentRouting?: InputMaybe<Scalars['String']['input']>;
  agentRoutingUrl?: InputMaybe<Scalars['String']['input']>;
  environment: SolutionEnvironmentsEnum;
  name: Scalars['String']['input'];
  platformId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
};


export type Admin_MutationCreatePypeRuleGroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  rulesToAdd?: InputMaybe<Array<PypeRuleInput>>;
};


export type Admin_MutationCreateRoleArgs = {
  accountId: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productId: Scalars['String']['input'];
};


export type Admin_MutationCreateSolutionArgs = {
  createDefaultChannels?: InputMaybe<Scalars['Boolean']['input']>;
  projectProStudioSettingId: Scalars['String']['input'];
  solution: SolutionInput;
  version: SolutionVersionInput;
};


export type Admin_MutationCreateTeamArgs = {
  accountId: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Admin_MutationCreateUserIdentityArgs = {
  userId: Scalars['String']['input'];
};


export type Admin_MutationCreateVariableArgs = {
  key: Scalars['String']['input'];
  projectEnvironmentConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  projectId: Scalars['String']['input'];
  value: Scalars['String']['input'];
  variableAccessLevel?: InputMaybe<VariableAccessLevelEnum>;
};


export type Admin_MutationCreateVertexCorpusesArgs = {
  solutionId: Scalars['String']['input'];
};


export type Admin_MutationDeactivateAllUserSessionsArgs = {
  accountId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Admin_MutationDeactivateUserSessionArgs = {
  accountId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


export type Admin_MutationDeleteAccountArgs = {
  id: Scalars['ID']['input'];
};


export type Admin_MutationDeleteAgentManagerFileArgs = {
  filePath: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
};


export type Admin_MutationDeleteAppletArgs = {
  id: Scalars['String']['input'];
};


export type Admin_MutationDeleteAppletInstanceArgs = {
  id: Scalars['String']['input'];
};


export type Admin_MutationDeleteAppletVersionArgs = {
  id: Scalars['String']['input'];
};


export type Admin_MutationDeleteCredentialArgs = {
  id: Scalars['String']['input'];
};


export type Admin_MutationDeleteMaestroOrgSecretArgs = {
  accountId: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};


export type Admin_MutationDeletePackageArgs = {
  id: Scalars['String']['input'];
};


export type Admin_MutationDeletePackageVersionArgs = {
  id: Scalars['String']['input'];
};


export type Admin_MutationDeleteProjectArgs = {
  id: Scalars['String']['input'];
};


export type Admin_MutationDeletePypeConnectionArgs = {
  id: Scalars['String']['input'];
};


export type Admin_MutationDeletePypeRuleGroupArgs = {
  id: Scalars['String']['input'];
};


export type Admin_MutationDeleteRolesArgs = {
  roleIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationDeleteSolutionArgs = {
  solutionId: Scalars['String']['input'];
};


export type Admin_MutationDeleteTeamsArgs = {
  teamIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationDeleteUserIdentityArgs = {
  userId: Scalars['String']['input'];
};


export type Admin_MutationDeleteVariableArgs = {
  id: Scalars['String']['input'];
};


export type Admin_MutationDeleteVertexCorporaArgs = {
  corpusNames: Array<Scalars['String']['input']>;
};


export type Admin_MutationDeleteVertexCorpusesArgs = {
  solutionId: Scalars['String']['input'];
};


export type Admin_MutationFinishUserRecoveryProcessArgs = {
  email: Scalars['String']['input'];
};


export type Admin_MutationHandleConsentArgs = {
  consentChallenge: Scalars['String']['input'];
  grantAudience?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantScope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reject?: InputMaybe<Scalars['Boolean']['input']>;
  remember?: InputMaybe<Scalars['Boolean']['input']>;
  rememberFor?: InputMaybe<Scalars['Int']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};


export type Admin_MutationImportMaestroOrgClassicSecretsArgs = {
  accountId: Scalars['String']['input'];
};


export type Admin_MutationLockAccountArgs = {
  id: Scalars['ID']['input'];
};


export type Admin_MutationMigrateBotsArgs = {
  payload: Scalars['JSON']['input'];
};


export type Admin_MutationMigratePypeSettingsArgs = {
  customerId: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Admin_MutationPublishSolutionVersionArgs = {
  commitMessage?: InputMaybe<Scalars['String']['input']>;
  draftVersionId: Scalars['String']['input'];
  environment: SolutionEnvironmentsEnum;
  runTests?: InputMaybe<Scalars['Boolean']['input']>;
  useBotCompiler?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Admin_MutationRemoveDataForSolutionPreviewArgs = {
  solutionId: Scalars['String']['input'];
};


export type Admin_MutationRemovePypeFromPypeConnectionArgs = {
  env: SolutionEnvironmentsEnum;
  id: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Admin_MutationRemovePypeFromPypeRuleGroupArgs = {
  env: SolutionEnvironmentsEnum;
  id: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Admin_MutationRemoveUsersFromAccountArgs = {
  accountId: Scalars['String']['input'];
  userIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationRepublishSolutionDeploymentArgs = {
  solutionDeploymentId: Scalars['String']['input'];
};


export type Admin_MutationResetActionNodeRuntimeConfigArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_MutationResetMaestroOrgSettingsArgs = {
  accountId: Scalars['String']['input'];
  group: Scalars['String']['input'];
  lockVersion: Scalars['Int']['input'];
};


export type Admin_MutationSetRolesTeamsArgs = {
  accountId: Scalars['String']['input'];
  action: Set_Data_Action;
  roleIds: Array<InputMaybe<Scalars['String']['input']>>;
  teamIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationSetRolesUsersArgs = {
  accountId: Scalars['String']['input'];
  action: Set_Data_Action;
  roleIds: Array<InputMaybe<Scalars['String']['input']>>;
  userIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationSetTeamAccountEnvironmentsRolesArgs = {
  environmentsRolesUpdate: Array<InputMaybe<EnvironmentRolesUpdate>>;
  teamId: Scalars['String']['input'];
};


export type Admin_MutationSetTeamAccountProjectsRolesArgs = {
  projectRolesUpdate: Array<InputMaybe<ProjectRolesUpdate>>;
  teamId: Scalars['String']['input'];
};


export type Admin_MutationSetTeamsMembersArgs = {
  accountId: Scalars['String']['input'];
  action: Set_Data_Action;
  teamIds: Array<InputMaybe<Scalars['String']['input']>>;
  userIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationSetTeamsProjectsArgs = {
  accountId: Scalars['String']['input'];
  action: Set_Data_Action;
  projectIds: Array<InputMaybe<Scalars['String']['input']>>;
  teamIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationSetTeamsRolesArgs = {
  accountId: Scalars['String']['input'];
  action: Set_Data_Action;
  roleIds: Array<InputMaybe<Scalars['String']['input']>>;
  teamIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationSetUserAccountEnvironmentsRolesArgs = {
  environmentsRolesUpdate: Array<InputMaybe<EnvironmentRolesUpdate>>;
  userId: Scalars['String']['input'];
};


export type Admin_MutationSetUserAccountProjectsRolesArgs = {
  isConsolidatingDetails?: InputMaybe<Scalars['Boolean']['input']>;
  projectRolesUpdate: Array<InputMaybe<ProjectRolesUpdate>>;
  userId: Scalars['String']['input'];
};


export type Admin_MutationSetUserLocalizationSettingsArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  localeId?: InputMaybe<Scalars['String']['input']>;
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type Admin_MutationSetUserPasswordRecoveryStatusArgs = {
  passwordRecoveryStatus: PasswordRecoveryStatusEnum;
  userId: Scalars['String']['input'];
};


export type Admin_MutationSetUsersProjectsArgs = {
  accountId: Scalars['String']['input'];
  action: Set_Data_Action;
  projectIds: Array<InputMaybe<Scalars['String']['input']>>;
  userIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationSetUsersRolesArgs = {
  accountId: Scalars['String']['input'];
  action: Set_Data_Action;
  roleIds: Array<InputMaybe<Scalars['String']['input']>>;
  userIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationSetUsersTeamsArgs = {
  accountId: Scalars['String']['input'];
  action: Set_Data_Action;
  teamIds: Array<InputMaybe<Scalars['String']['input']>>;
  userIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationStartUserRecoveryProcessArgs = {
  email: Scalars['String']['input'];
};


export type Admin_MutationUnlockAccountArgs = {
  id: Scalars['ID']['input'];
};


export type Admin_MutationUpdateAccountArgs = {
  accountAuthMethodSettings?: InputMaybe<Array<InputMaybe<AccountAuthMethodSettingsInput>>>;
  accountIconId?: InputMaybe<Scalars['String']['input']>;
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  customAuthMethods?: InputMaybe<Array<InputMaybe<CustomAuthMethodUpdateInput>>>;
  generalSettings?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  resourceLimitSettings?: InputMaybe<Scalars['JSON']['input']>;
};


export type Admin_MutationUpdateActionNodeAutoscalingArgs = {
  autoscaling: ActionNodeAutoscalingInput;
  projectId: Scalars['String']['input'];
};


export type Admin_MutationUpdateActionNodePackagesArgs = {
  packages: ActionNodePackagesInput;
  projectId: Scalars['String']['input'];
};


export type Admin_MutationUpdateActionNodeResourcesArgs = {
  projectId: Scalars['String']['input'];
  resources: ActionNodeResourcesInput;
};


export type Admin_MutationUpdateActionNodeTimeoutArgs = {
  projectId: Scalars['String']['input'];
  timeout: ActionNodeTimeoutInput;
};


export type Admin_MutationUpdateAnalyticsDatasetArgs = {
  datasetId: Scalars['Int']['input'];
  projectId: Scalars['String']['input'];
  updatedFields: Scalars['JSON']['input'];
};


export type Admin_MutationUpdateAnalyticsForChannelArgs = {
  enabled: Scalars['Boolean']['input'];
  env: SolutionEnvironmentsEnum;
  projectId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
};


export type Admin_MutationUpdateAppletArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  iconId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  latestVersionId?: InputMaybe<Scalars['String']['input']>;
};


export type Admin_MutationUpdateAppletInstanceArgs = {
  actions?: InputMaybe<Array<InputMaybe<ActionCreate>>>;
  condition?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<AppletStatusEnum>;
  triggers?: InputMaybe<Array<InputMaybe<TriggerCreate>>>;
};


export type Admin_MutationUpdateAppletVersionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type Admin_MutationUpdateCredentialArgs = {
  credential: LlmCredentialInput;
};


export type Admin_MutationUpdateDomainsVerificationStatusArgs = {
  domains?: InputMaybe<Array<DomainVerificationStatusInput>>;
};


export type Admin_MutationUpdateMaestroOrgSecretArgs = {
  accountId: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  input: MaestroOrgSecretUpdate;
};


export type Admin_MutationUpdateMaestroOrgSettingsArgs = {
  accountId: Scalars['String']['input'];
  group: Scalars['String']['input'];
  lockVersion?: InputMaybe<Scalars['Int']['input']>;
  values: Scalars['JSON']['input'];
};


export type Admin_MutationUpdatePackageArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  latestVersionId?: InputMaybe<Scalars['String']['input']>;
};


export type Admin_MutationUpdateProjectArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  localeId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectIconId?: InputMaybe<Scalars['String']['input']>;
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
};


export type Admin_MutationUpdateProjectEnvironmentConfigArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  domains?: InputMaybe<Array<InputMaybe<DomainInput>>>;
  projectEnvironmentConfigId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  status?: InputMaybe<EnvironmentStatusEnum>;
};


export type Admin_MutationUpdateProjectLocalizationSettingsArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  localeId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  settingsId: Scalars['String']['input'];
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
};


export type Admin_MutationUpdatePypeConnectionArgs = {
  agentRouting?: InputMaybe<Scalars['String']['input']>;
  agentRoutingUrl?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<SolutionEnvironmentsEnum>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};


export type Admin_MutationUpdatePypeRuleGroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rulesToAdd?: InputMaybe<Array<PypeRuleInput>>;
  rulesToDelete?: InputMaybe<Array<Scalars['String']['input']>>;
  rulesToUpdate?: InputMaybe<Array<PypeRuleUpdateInput>>;
};


export type Admin_MutationUpdateRoleArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Admin_MutationUpdateRoleMembersArgs = {
  roleId: Scalars['String']['input'];
  userIdsToAdd: Array<InputMaybe<Scalars['String']['input']>>;
  userIdsToRemove: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationUpdateRoleTeamsArgs = {
  roleId: Scalars['String']['input'];
  teamIdsToAdd: Array<InputMaybe<Scalars['String']['input']>>;
  teamIdsToRemove: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationUpdateSolutionArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  solutionId: Scalars['String']['input'];
  type?: InputMaybe<SolutionTypeEnum>;
};


export type Admin_MutationUpdateSolutionPifFileArgs = {
  solutionId: Scalars['String']['input'];
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
};


export type Admin_MutationUpdateSolutionVersionArgs = {
  version: SolutionVersionInput;
};


export type Admin_MutationUpdateTeamArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  projectIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Admin_MutationUpdateTeamMembersArgs = {
  accountId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
  userIdsToAdd: Array<InputMaybe<Scalars['String']['input']>>;
  userIdsToRemove: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_MutationUpdateTeamProjectsArgs = {
  accountId: Scalars['String']['input'];
  projectIdsToAdd: Array<InputMaybe<Scalars['String']['input']>>;
  projectIdsToRemove: Array<InputMaybe<Scalars['String']['input']>>;
  teamId: Scalars['String']['input'];
};


export type Admin_MutationUpdateTeamRolesArgs = {
  accountId: Scalars['String']['input'];
  roleIdsToAdd: Array<InputMaybe<Scalars['String']['input']>>;
  roleIdsToRemove: Array<InputMaybe<Scalars['String']['input']>>;
  teamId: Scalars['String']['input'];
};


export type Admin_MutationUpdateTeamsProjectAccessArgs = {
  params: UpdateTeamsProjectAccessInput;
};


export type Admin_MutationUpdateUserArgs = {
  accountId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isConsolidatingDetails?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  optionalConsentStatus?: InputMaybe<ConsentStatusEnum>;
  optionalConsentUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  projectIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requiredConsentStatus?: InputMaybe<ConsentStatusEnum>;
  requiredConsentUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<UserStatus>;
  teamIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teamIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIconId?: InputMaybe<Scalars['String']['input']>;
};


export type Admin_MutationUpdateUserLocalizationSettingsArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  localeId?: InputMaybe<Scalars['String']['input']>;
  settingsId: Scalars['String']['input'];
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type Admin_MutationUpdateUserProjectsArgs = {
  accountId: Scalars['String']['input'];
  projectIdsToAdd: Array<InputMaybe<Scalars['String']['input']>>;
  projectIdsToRemove: Array<InputMaybe<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};


export type Admin_MutationUpdateUserRolesArgs = {
  accountId: Scalars['String']['input'];
  roleIdsToAdd: Array<InputMaybe<Scalars['String']['input']>>;
  roleIdsToRemove: Array<InputMaybe<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};


export type Admin_MutationUpdateUserTeamsArgs = {
  accountId: Scalars['String']['input'];
  teamIdsToAdd: Array<InputMaybe<Scalars['String']['input']>>;
  teamIdsToRemove: Array<InputMaybe<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};


export type Admin_MutationUpdateUsersProjectAccessArgs = {
  params: UpdateUsersProjectAccessInput;
};


export type Admin_MutationUpdateVariableArgs = {
  id: Scalars['String']['input'];
  projectEnvironmentConfigIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectEnvironmentConfigIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type Admin_MutationUpsertSolutionUserPresenceArgs = {
  pageParams?: InputMaybe<Scalars['JSON']['input']>;
  pagePath: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Admin_MutationVerifyDomainArgs = {
  id: Scalars['String']['input'];
};

export type Admin_Query = {
  __typename?: 'admin_Query';
  HealthCheck?: Maybe<Scalars['Boolean']['output']>;
  _?: Maybe<Scalars['Boolean']['output']>;
  accountById?: Maybe<Account>;
  accountByShortId?: Maybe<Account>;
  accounts?: Maybe<PaginatedAccounts>;
  actionNodeJob?: Maybe<ActionNodeJob>;
  actionNodeJobs: ActionNodeJobConnection;
  actionNodePackagesByProjectId?: Maybe<ActionNodePackages>;
  actionNodeResourcesByProjectId?: Maybe<ActionNodeResources>;
  actionNodeRuntimeConfigByProjectId?: Maybe<ActionNodeRuntimeConfig>;
  actionNodeRuntimeStatusByProjectId: ActionNodeRuntimeStatus;
  allProducts?: Maybe<Array<Maybe<Product>>>;
  allTeamsForProjectToAdd?: Maybe<Array<Maybe<AllTeamsForProject>>>;
  allToolProducts?: Maybe<Array<Maybe<Product>>>;
  allUsersForProjectToAdd?: Maybe<Array<Maybe<AllUsersForProject>>>;
  appletById?: Maybe<Applet>;
  appletInstanceById?: Maybe<AppletInstance>;
  appletInstanceByShortId?: Maybe<AppletInstance>;
  appletVersions?: Maybe<Array<Maybe<AppletVersion>>>;
  applets?: Maybe<Array<Maybe<Applet>>>;
  assetsFiles?: Maybe<Array<Maybe<AgentManagerFile>>>;
  auditLogById?: Maybe<AuditLog>;
  auditLogs?: Maybe<PaginatedAuditLogs>;
  configsFiles?: Maybe<Array<Maybe<AgentManagerFile>>>;
  countries?: Maybe<Array<Maybe<Country2>>>;
  credentialById?: Maybe<LlmCredential>;
  credentialLimitedById?: Maybe<LlmCredentialLimited>;
  credentials?: Maybe<Array<Maybe<LlmCredential>>>;
  credentialsLimited?: Maybe<Array<Maybe<LlmCredentialLimited>>>;
  currentUser?: Maybe<User>;
  customAssetsFiles?: Maybe<Array<Maybe<AgentManagerFile>>>;
  defaultAuthMethods?: Maybe<Array<Maybe<AuthMethod>>>;
  draftVersionFiles: Array<DraftVersionFile>;
  environmentById?: Maybe<Environment>;
  environments?: Maybe<Array<Maybe<Environment>>>;
  getActionNodeNames: Scalars['JSON']['output'];
  getAllDomains?: Maybe<Array<Maybe<Domain>>>;
  getAnalyticsDatasets: Array<Scalars['JSON']['output']>;
  getConsentInfo?: Maybe<ConsentInfo>;
  getConsentRedirect?: Maybe<Scalars['String']['output']>;
  getCustomerPypes: Array<Scalars['JSON']['output']>;
  getLoginInfo?: Maybe<LoginInfo>;
  getMetabaseFolders?: Maybe<MetabaseFolders>;
  getPresignedUrlForSolutionPreview: Array<Scalars['String']['output']>;
  getSolutionNodeData?: Maybe<Array<Maybe<SolutionNodeData>>>;
  getUserLoginInfo?: Maybe<UserLoginInfo>;
  knowledgeFiles?: Maybe<Array<Maybe<AgentManagerFile>>>;
  locales?: Maybe<Array<Maybe<Locale>>>;
  localizationSettingsConfig?: Maybe<LocalizationSettingsConfig>;
  logout?: Maybe<Scalars['String']['output']>;
  /** The caller's own classic LiveView project, if any. Super-admin, Pypestream org only. */
  maestroOrgClassicSecretsSource?: Maybe<MaestroClassicSource>;
  maestroOrgSecretScopes: Array<MaestroSecretScopeProject>;
  maestroOrgSecrets: MaestroOrgSecrets;
  maestroOrgSettings: MaestroSettingsGroup;
  maestroOrgSettingsOverriddenIn: Array<MaestroSettingsOverride>;
  /** How many orgs a key with this audience reaches. Super-admin, Pypestream org only. */
  maestroPypestreamKeyAudienceCount: Scalars['Int']['output'];
  /** Every customer org a Pypestream key can be shared with. Super-admin, Pypestream org only. */
  maestroPypestreamKeyAudienceOrgs: Array<MaestroAudienceOrg>;
  organizationMetadata?: Maybe<OrganizationMetadata>;
  organizationsMetadata: Array<OrganizationMetadata>;
  packageById?: Maybe<Package>;
  packages?: Maybe<Array<Maybe<Package>>>;
  projectById?: Maybe<Project>;
  projectByShortId?: Maybe<Project>;
  projectDirectTeams?: Maybe<Array<Maybe<ProjectTeamsWithRoles>>>;
  projectDirectUsers?: Maybe<Array<Maybe<ProjectUsersWithRoles>>>;
  projectEnvironmentConfigByAppletInstanceId?: Maybe<ProjectEnvironmentConfig>;
  projectEnvironmentConfigByDomain?: Maybe<ProjectEnvironmentConfig>;
  projectEnvironmentConfigById?: Maybe<ProjectEnvironmentConfig>;
  projectEnvironmentConfigByShortId?: Maybe<ProjectEnvironmentConfig>;
  projectMetadata?: Maybe<ProjectMetadata>;
  projectTeams?: Maybe<PaginatedProjectTeams>;
  projectTeamsFromOtherOrgs?: Maybe<Array<Maybe<ProjectTeamsWithRoles>>>;
  projectUsers?: Maybe<PaginatedProjectUsers>;
  projectUsersFromOtherOrgs?: Maybe<Array<Maybe<ProjectUsersWithRoles>>>;
  projects?: Maybe<PaginatedProjects>;
  providerById?: Maybe<LlmProvider>;
  providers?: Maybe<Array<Maybe<LlmProvider>>>;
  pypeConnectionById?: Maybe<PypeConnection>;
  pypeConnectionsByProjectId?: Maybe<Array<Maybe<PypeConnection>>>;
  pypeRuleGroupById?: Maybe<PypeRuleGroup>;
  pypeRuleGroupsByProjectId?: Maybe<Array<Maybe<PypeRuleGroup>>>;
  roleById?: Maybe<Role>;
  roleMembers?: Maybe<PaginatedRoleMembers>;
  roleMetadata?: Maybe<RoleMetadata>;
  roles?: Maybe<PaginatedRoles>;
  rolesMetadata?: Maybe<RolesMetadata>;
  scriptsFiles?: Maybe<Array<Maybe<AgentManagerFile>>>;
  solutionBotPypes: Array<BotPypesResponseBe>;
  solutionById?: Maybe<Solution>;
  solutionChatEngineTrace: SolutionChatEngineTraceBe;
  solutionChatLogs: SolutionChatLogsBe;
  solutionChatTranscript: SolutionChatTranscriptBe;
  solutionDeploymentById?: Maybe<SolutionDeployment>;
  solutionDeploymentLogs?: Maybe<SolutionDeploymentLogs>;
  solutionDraftVersionComparisons: PaginatedSolutionDraftVersionComparisons;
  solutionEnvironmentComparisons: Array<SolutionEnvironmentComparison>;
  solutionGiteaBranches: Array<GiteaBranch>;
  solutionGiteaCommit: GiteaCommitDetail;
  solutionGiteaCommitGraph: GiteaCommitGraph;
  solutionGiteaFileContent: GiteaFileContent;
  solutionGiteaFileHistory: Array<GiteaFileCommit>;
  solutionGiteaTree: Array<GiteaTreeEntry>;
  solutionS3FileContent: SolutionS3FileContent;
  solutionS3FileDownloadUrl: SolutionS3FileDownloadUrl;
  solutionS3Tree: Array<SolutionS3TreeEntry>;
  solutionVercelBlobTree: Array<SolutionVercelBlobTreeEntry>;
  solutionVersionById?: Maybe<SolutionVersion>;
  solutionVersions?: Maybe<Array<Maybe<SolutionVersion>>>;
  solutionVertexCorpuses: Array<SolutionVertexCorpus>;
  solutions?: Maybe<Array<Maybe<Solution>>>;
  studioResources?: Maybe<Array<Maybe<StudioResource>>>;
  teamById?: Maybe<Team>;
  teamMembers?: Maybe<PaginatedTeamMembers>;
  teamProductRoles?: Maybe<TeamProductRoles>;
  teamProjects?: Maybe<PaginatedTeamProjects>;
  teamRoles?: Maybe<PaginatedTeamRoles>;
  teams?: Maybe<PaginatedTeams>;
  templatesFiles?: Maybe<Array<Maybe<AgentManagerFile>>>;
  timeZones?: Maybe<Array<Maybe<TimeZone>>>;
  userById?: Maybe<User>;
  userProductRoles?: Maybe<UserProductRoles>;
  userProjects?: Maybe<PaginatedUserProjects>;
  userRoles?: Maybe<PaginatedUserRoles>;
  userTeams?: Maybe<PaginatedUserTeams>;
  users?: Maybe<PaginatedUsers>;
  validateProjectEnvironmentUrls?: Maybe<ValidatedEnvironmentDomainUrls>;
  variableById?: Maybe<Variable>;
  variables?: Maybe<Array<Maybe<Variable>>>;
  /** One page of RAG corpora in the configured GCP project and region; each call is a single Vertex API request. pageSize is capped at 100. Super-admin only. */
  vertexCorpora: VertexCorporaPage;
};


export type Admin_QueryAccountByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QueryAccountByShortIdArgs = {
  shortId: Scalars['String']['input'];
};


export type Admin_QueryAccountsArgs = {
  filterCriteria: AccountsFilter;
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryActionNodeJobArgs = {
  id: Scalars['ID']['input'];
};


export type Admin_QueryActionNodeJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobType?: InputMaybe<ActionNodeJobTypeEnum>;
  projectId: Scalars['String']['input'];
  runtime?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActionNodeJobStatusEnum>;
  trigger?: InputMaybe<ActionNodeJobTriggerEnum>;
};


export type Admin_QueryActionNodePackagesByProjectIdArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryActionNodeResourcesByProjectIdArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryActionNodeRuntimeConfigByProjectIdArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryActionNodeRuntimeStatusByProjectIdArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryAllTeamsForProjectToAddArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryAllUsersForProjectToAddArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryAppletByIdArgs = {
  appletId: Scalars['String']['input'];
};


export type Admin_QueryAppletInstanceByIdArgs = {
  appletInstanceId: Scalars['String']['input'];
};


export type Admin_QueryAppletInstanceByShortIdArgs = {
  shortId: Scalars['String']['input'];
};


export type Admin_QueryAppletVersionsArgs = {
  appletId: Scalars['String']['input'];
};


export type Admin_QueryAssetsFilesArgs = {
  solutionId: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
};


export type Admin_QueryAuditLogByIdArgs = {
  id: Scalars['ID']['input'];
};


export type Admin_QueryAuditLogsArgs = {
  filterCriteria: AuditLogsFilter;
  queryMetadata: QueryMetadata;
};


export type Admin_QueryConfigsFilesArgs = {
  solutionId: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
};


export type Admin_QueryCredentialByIdArgs = {
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Admin_QueryCredentialLimitedByIdArgs = {
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Admin_QueryCredentialsArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryCredentialsLimitedArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryCustomAssetsFilesArgs = {
  solutionId: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
};


export type Admin_QueryDraftVersionFilesArgs = {
  draftVersionId: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Admin_QueryEnvironmentByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QueryGetAnalyticsDatasetsArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryGetConsentInfoArgs = {
  consentChallenge: Scalars['String']['input'];
};


export type Admin_QueryGetConsentRedirectArgs = {
  consentChallenge: Scalars['String']['input'];
};


export type Admin_QueryGetCustomerPypesArgs = {
  env: SolutionEnvironmentsEnum;
  projectId: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Admin_QueryGetLoginInfoArgs = {
  email: Scalars['String']['input'];
};


export type Admin_QueryGetMetabaseFoldersArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryGetPresignedUrlForSolutionPreviewArgs = {
  filePaths: Array<Scalars['String']['input']>;
  solutionId: Scalars['String']['input'];
};


export type Admin_QueryGetSolutionNodeDataArgs = {
  solutionId: Scalars['String']['input'];
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
};


export type Admin_QueryGetUserLoginInfoArgs = {
  email: Scalars['String']['input'];
};


export type Admin_QueryKnowledgeFilesArgs = {
  solutionId: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
};


export type Admin_QueryLogoutArgs = {
  logoutChallenge: Scalars['String']['input'];
};


export type Admin_QueryMaestroOrgClassicSecretsSourceArgs = {
  accountId: Scalars['String']['input'];
};


export type Admin_QueryMaestroOrgSecretScopesArgs = {
  accountId: Scalars['String']['input'];
};


export type Admin_QueryMaestroOrgSecretsArgs = {
  accountId: Scalars['String']['input'];
};


export type Admin_QueryMaestroOrgSettingsArgs = {
  accountId: Scalars['String']['input'];
  group: Scalars['String']['input'];
};


export type Admin_QueryMaestroOrgSettingsOverriddenInArgs = {
  accountId: Scalars['String']['input'];
  group: Scalars['String']['input'];
};


export type Admin_QueryMaestroPypestreamKeyAudienceCountArgs = {
  accountId: Scalars['String']['input'];
  audience: MaestroKeyAudienceInput;
};


export type Admin_QueryMaestroPypestreamKeyAudienceOrgsArgs = {
  accountId: Scalars['String']['input'];
};


export type Admin_QueryOrganizationMetadataArgs = {
  accountId: Scalars['String']['input'];
};


export type Admin_QueryOrganizationsMetadataArgs = {
  accountIds: Array<Scalars['String']['input']>;
};


export type Admin_QueryPackageByIdArgs = {
  packageId: Scalars['String']['input'];
};


export type Admin_QueryPackagesArgs = {
  packageTypes?: InputMaybe<Array<InputMaybe<PackageTypeEnum>>>;
};


export type Admin_QueryProjectByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QueryProjectByShortIdArgs = {
  shortId: Scalars['String']['input'];
};


export type Admin_QueryProjectDirectTeamsArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryProjectDirectUsersArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryProjectEnvironmentConfigByAppletInstanceIdArgs = {
  appletInstanceId: Scalars['String']['input'];
};


export type Admin_QueryProjectEnvironmentConfigByDomainArgs = {
  url: Scalars['String']['input'];
};


export type Admin_QueryProjectEnvironmentConfigByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QueryProjectEnvironmentConfigByShortIdArgs = {
  shortId: Scalars['String']['input'];
};


export type Admin_QueryProjectMetadataArgs = {
  accountId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Admin_QueryProjectTeamsArgs = {
  accountId: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryProjectTeamsFromOtherOrgsArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryProjectUsersArgs = {
  accountId: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryProjectUsersFromOtherOrgsArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryProjectsArgs = {
  filterCriteria: ProjectsFilter;
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryProviderByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QueryPypeConnectionByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QueryPypeConnectionsByProjectIdArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryPypeRuleGroupByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QueryPypeRuleGroupsByProjectIdArgs = {
  projectId: Scalars['String']['input'];
};


export type Admin_QueryRoleByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QueryRoleMembersArgs = {
  filterCriteria: RoleMembersFilter;
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryRoleMetadataArgs = {
  roleId: Scalars['String']['input'];
};


export type Admin_QueryRolesArgs = {
  filterCriteria: RolesFilter;
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryRolesMetadataArgs = {
  accountId: Scalars['String']['input'];
};


export type Admin_QueryScriptsFilesArgs = {
  solutionId: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
};


export type Admin_QuerySolutionBotPypesArgs = {
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QuerySolutionChatEngineTraceArgs = {
  chatId: Scalars['String']['input'];
  sinceMs?: InputMaybe<Scalars['Float']['input']>;
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionChatLogsArgs = {
  afterMs?: InputMaybe<Scalars['Float']['input']>;
  chatId: Scalars['String']['input'];
  sinceMs: Scalars['Float']['input'];
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionChatTranscriptArgs = {
  chatId: Scalars['String']['input'];
  sinceMs: Scalars['Float']['input'];
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionDeploymentByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QuerySolutionDeploymentLogsArgs = {
  deploymentId: Scalars['String']['input'];
  deploymentRunId?: InputMaybe<Scalars['String']['input']>;
  deploymentRunWorkflowId?: InputMaybe<Scalars['String']['input']>;
};


export type Admin_QuerySolutionDraftVersionComparisonsArgs = {
  baseDraftVersionId?: InputMaybe<Scalars['String']['input']>;
  queryMetadata?: InputMaybe<QueryMetadata>;
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionEnvironmentComparisonsArgs = {
  baseDraftVersionId?: InputMaybe<Scalars['String']['input']>;
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionGiteaBranchesArgs = {
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionGiteaCommitArgs = {
  sha: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionGiteaCommitGraphArgs = {
  sinceDays?: InputMaybe<Scalars['Int']['input']>;
  solutionId: Scalars['String']['input'];
  unbounded?: InputMaybe<Scalars['Boolean']['input']>;
  untilDays?: InputMaybe<Scalars['Int']['input']>;
};


export type Admin_QuerySolutionGiteaFileContentArgs = {
  branch: Scalars['String']['input'];
  path: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionGiteaFileHistoryArgs = {
  branch: Scalars['String']['input'];
  path: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionGiteaTreeArgs = {
  branch: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionS3FileContentArgs = {
  path: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionS3FileDownloadUrlArgs = {
  path: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionS3TreeArgs = {
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionVercelBlobTreeArgs = {
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionVersionByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QuerySolutionVersionsArgs = {
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionVertexCorpusesArgs = {
  solutionId: Scalars['String']['input'];
};


export type Admin_QuerySolutionsArgs = {
  projectProStudioSettingId: Scalars['String']['input'];
};


export type Admin_QueryTeamByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QueryTeamMembersArgs = {
  filterCriteria: TeamMembersFilter;
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryTeamProductRolesArgs = {
  accountId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type Admin_QueryTeamProjectsArgs = {
  filterCriteria: TeamProjectsFilter;
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryTeamRolesArgs = {
  filterCriteria: TeamRolesFilter;
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryTeamsArgs = {
  filterCriteria: TeamsFilter;
  queryMetadata: QueryMetadata;
};


export type Admin_QueryTemplatesFilesArgs = {
  solutionId: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
};


export type Admin_QueryUserByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QueryUserProductRolesArgs = {
  accountId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Admin_QueryUserProjectsArgs = {
  filterCriteria: UserProjectsFilter;
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryUserRolesArgs = {
  filterCriteria: UserRolesFilter;
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryUserTeamsArgs = {
  filterCriteria: UserTeamsFilter;
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryUsersArgs = {
  filterCriteria: UsersFilter;
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryValidateProjectEnvironmentUrlsArgs = {
  urls: Array<InputMaybe<Scalars['String']['input']>>;
};


export type Admin_QueryVariableByIdArgs = {
  id: Scalars['String']['input'];
};


export type Admin_QueryVariablesArgs = {
  filterCriteria: VariablesFilter;
  queryMetadata?: InputMaybe<QueryMetadata>;
};


export type Admin_QueryVertexCorporaArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type Admin_Subscription = {
  __typename?: 'admin_Subscription';
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type App_Loader_Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type App_Loader_String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type App_Loader_String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "app" */
export type App_Loader_App = {
  __typename?: 'app_loader_app';
  /** An object relationship */
  customer?: Maybe<App_Loader_Customer>;
  customerId: Scalars['app_loader_uuid']['output'];
  /** An array relationship */
  environment: Array<App_Loader_Environment>;
  /** An aggregate relationship */
  environment_aggregate: App_Loader_Environment_Aggregate;
  id: Scalars['app_loader_uuid']['output'];
  name: Scalars['String']['output'];
};


/** columns and relationships of "app" */
export type App_Loader_AppEnvironmentArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Environment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Environment_Order_By>>;
  where?: InputMaybe<App_Loader_Environment_Bool_Exp>;
};


/** columns and relationships of "app" */
export type App_Loader_AppEnvironment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Environment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Environment_Order_By>>;
  where?: InputMaybe<App_Loader_Environment_Bool_Exp>;
};

/** aggregated selection of "app" */
export type App_Loader_App_Aggregate = {
  __typename?: 'app_loader_app_aggregate';
  aggregate?: Maybe<App_Loader_App_Aggregate_Fields>;
  nodes: Array<App_Loader_App>;
};

/** aggregate fields of "app" */
export type App_Loader_App_Aggregate_Fields = {
  __typename?: 'app_loader_app_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_App_Max_Fields>;
  min?: Maybe<App_Loader_App_Min_Fields>;
};


/** aggregate fields of "app" */
export type App_Loader_App_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_App_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "app". All fields are combined with a logical 'AND'. */
export type App_Loader_App_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_App_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_App_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_App_Bool_Exp>>;
  customer?: InputMaybe<App_Loader_Customer_Bool_Exp>;
  customerId?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  environment?: InputMaybe<App_Loader_Environment_Bool_Exp>;
  environment_aggregate?: InputMaybe<App_Loader_Environment_Aggregate_Bool_Exp>;
  id?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  name?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** unique or primary key constraints on table "app" */
export enum App_Loader_App_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppPkey = 'app_pkey'
}

/** input type for inserting data into table "app" */
export type App_Loader_App_Insert_Input = {
  customer?: InputMaybe<App_Loader_Customer_Obj_Rel_Insert_Input>;
  customerId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  environment?: InputMaybe<App_Loader_Environment_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_App_Max_Fields = {
  __typename?: 'app_loader_app_max_fields';
  customerId?: Maybe<Scalars['app_loader_uuid']['output']>;
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Loader_App_Min_Fields = {
  __typename?: 'app_loader_app_min_fields';
  customerId?: Maybe<Scalars['app_loader_uuid']['output']>;
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "app" */
export type App_Loader_App_Mutation_Response = {
  __typename?: 'app_loader_app_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_App>;
};

/** input type for inserting object relation for remote table "app" */
export type App_Loader_App_Obj_Rel_Insert_Input = {
  data: App_Loader_App_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_App_On_Conflict>;
};

/** on_conflict condition type for table "app" */
export type App_Loader_App_On_Conflict = {
  constraint: App_Loader_App_Constraint;
  update_columns?: Array<App_Loader_App_Update_Column>;
  where?: InputMaybe<App_Loader_App_Bool_Exp>;
};

/** Ordering options when selecting data from "app". */
export type App_Loader_App_Order_By = {
  customer?: InputMaybe<App_Loader_Customer_Order_By>;
  customerId?: InputMaybe<App_Loader_Order_By>;
  environment_aggregate?: InputMaybe<App_Loader_Environment_Aggregate_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: app */
export type App_Loader_App_Pk_Columns_Input = {
  id: Scalars['app_loader_uuid']['input'];
};

/** select columns of table "app" */
export enum App_Loader_App_Select_Column {
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "app" */
export type App_Loader_App_Set_Input = {
  customerId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "app" */
export type App_Loader_App_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_App_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_App_Stream_Cursor_Value_Input = {
  customerId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "app" */
export enum App_Loader_App_Update_Column {
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type App_Loader_App_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_App_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_App_Bool_Exp;
};

/** columns and relationships of "conditions" */
export type App_Loader_Conditions = {
  __typename?: 'app_loader_conditions';
  id: Scalars['app_loader_uuid']['output'];
  name: Scalars['String']['output'];
  schema: Scalars['app_loader_jsonb']['output'];
  version: Scalars['String']['output'];
};


/** columns and relationships of "conditions" */
export type App_Loader_ConditionsSchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "conditions" */
export type App_Loader_Conditions_Aggregate = {
  __typename?: 'app_loader_conditions_aggregate';
  aggregate?: Maybe<App_Loader_Conditions_Aggregate_Fields>;
  nodes: Array<App_Loader_Conditions>;
};

/** aggregate fields of "conditions" */
export type App_Loader_Conditions_Aggregate_Fields = {
  __typename?: 'app_loader_conditions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Conditions_Max_Fields>;
  min?: Maybe<App_Loader_Conditions_Min_Fields>;
};


/** aggregate fields of "conditions" */
export type App_Loader_Conditions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Conditions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type App_Loader_Conditions_Append_Input = {
  schema?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "conditions". All fields are combined with a logical 'AND'. */
export type App_Loader_Conditions_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Conditions_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Conditions_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Conditions_Bool_Exp>>;
  id?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  name?: InputMaybe<App_Loader_String_Comparison_Exp>;
  schema?: InputMaybe<App_Loader_Jsonb_Comparison_Exp>;
  version?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** unique or primary key constraints on table "conditions" */
export enum App_Loader_Conditions_Constraint {
  /** unique or primary key constraint on columns "name" */
  ConditionsNameKey = 'conditions_name_key',
  /** unique or primary key constraint on columns "id" */
  ConditionsPkey = 'conditions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type App_Loader_Conditions_Delete_At_Path_Input = {
  schema?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type App_Loader_Conditions_Delete_Elem_Input = {
  schema?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type App_Loader_Conditions_Delete_Key_Input = {
  schema?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "conditions" */
export type App_Loader_Conditions_Insert_Input = {
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Conditions_Max_Fields = {
  __typename?: 'app_loader_conditions_max_fields';
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Conditions_Min_Fields = {
  __typename?: 'app_loader_conditions_min_fields';
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "conditions" */
export type App_Loader_Conditions_Mutation_Response = {
  __typename?: 'app_loader_conditions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Conditions>;
};

/** on_conflict condition type for table "conditions" */
export type App_Loader_Conditions_On_Conflict = {
  constraint: App_Loader_Conditions_Constraint;
  update_columns?: Array<App_Loader_Conditions_Update_Column>;
  where?: InputMaybe<App_Loader_Conditions_Bool_Exp>;
};

/** Ordering options when selecting data from "conditions". */
export type App_Loader_Conditions_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
  schema?: InputMaybe<App_Loader_Order_By>;
  version?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: conditions */
export type App_Loader_Conditions_Pk_Columns_Input = {
  id: Scalars['app_loader_uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type App_Loader_Conditions_Prepend_Input = {
  schema?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
};

/** select columns of table "conditions" */
export enum App_Loader_Conditions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Schema = 'schema',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "conditions" */
export type App_Loader_Conditions_Set_Input = {
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "conditions" */
export type App_Loader_Conditions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Conditions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Conditions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "conditions" */
export enum App_Loader_Conditions_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Schema = 'schema',
  /** column name */
  Version = 'version'
}

export type App_Loader_Conditions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<App_Loader_Conditions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<App_Loader_Conditions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<App_Loader_Conditions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<App_Loader_Conditions_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<App_Loader_Conditions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Conditions_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Conditions_Bool_Exp;
};

/** ordering argument of a cursor */
export enum App_Loader_Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "customer" */
export type App_Loader_Customer = {
  __typename?: 'app_loader_customer';
  /** An object relationship */
  app?: Maybe<App_Loader_App>;
  id: Scalars['app_loader_uuid']['output'];
  /** An array relationship */
  n_applications: Array<App_Loader_N_Application>;
  /** An aggregate relationship */
  n_applications_aggregate: App_Loader_N_Application_Aggregate;
  name: Scalars['String']['output'];
  topLevelDomain: Scalars['String']['output'];
};


/** columns and relationships of "customer" */
export type App_Loader_CustomerN_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Application_Order_By>>;
  where?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type App_Loader_CustomerN_Applications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Application_Order_By>>;
  where?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
};

/** aggregated selection of "customer" */
export type App_Loader_Customer_Aggregate = {
  __typename?: 'app_loader_customer_aggregate';
  aggregate?: Maybe<App_Loader_Customer_Aggregate_Fields>;
  nodes: Array<App_Loader_Customer>;
};

/** aggregate fields of "customer" */
export type App_Loader_Customer_Aggregate_Fields = {
  __typename?: 'app_loader_customer_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Customer_Max_Fields>;
  min?: Maybe<App_Loader_Customer_Min_Fields>;
};


/** aggregate fields of "customer" */
export type App_Loader_Customer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Customer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "customer". All fields are combined with a logical 'AND'. */
export type App_Loader_Customer_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Customer_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Customer_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Customer_Bool_Exp>>;
  app?: InputMaybe<App_Loader_App_Bool_Exp>;
  id?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  n_applications?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
  n_applications_aggregate?: InputMaybe<App_Loader_N_Application_Aggregate_Bool_Exp>;
  name?: InputMaybe<App_Loader_String_Comparison_Exp>;
  topLevelDomain?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer" */
export enum App_Loader_Customer_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientPkey = 'client_pkey'
}

/** input type for inserting data into table "customer" */
export type App_Loader_Customer_Insert_Input = {
  app?: InputMaybe<App_Loader_App_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  n_applications?: InputMaybe<App_Loader_N_Application_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  topLevelDomain?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Customer_Max_Fields = {
  __typename?: 'app_loader_customer_max_fields';
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  topLevelDomain?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Customer_Min_Fields = {
  __typename?: 'app_loader_customer_min_fields';
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  topLevelDomain?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "customer" */
export type App_Loader_Customer_Mutation_Response = {
  __typename?: 'app_loader_customer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Customer>;
};

/** input type for inserting object relation for remote table "customer" */
export type App_Loader_Customer_Obj_Rel_Insert_Input = {
  data: App_Loader_Customer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_Customer_On_Conflict>;
};

/** on_conflict condition type for table "customer" */
export type App_Loader_Customer_On_Conflict = {
  constraint: App_Loader_Customer_Constraint;
  update_columns?: Array<App_Loader_Customer_Update_Column>;
  where?: InputMaybe<App_Loader_Customer_Bool_Exp>;
};

/** Ordering options when selecting data from "customer". */
export type App_Loader_Customer_Order_By = {
  app?: InputMaybe<App_Loader_App_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  n_applications_aggregate?: InputMaybe<App_Loader_N_Application_Aggregate_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
  topLevelDomain?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: customer */
export type App_Loader_Customer_Pk_Columns_Input = {
  id: Scalars['app_loader_uuid']['input'];
};

/** select columns of table "customer" */
export enum App_Loader_Customer_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TopLevelDomain = 'topLevelDomain'
}

/** input type for updating data in table "customer" */
export type App_Loader_Customer_Set_Input = {
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  topLevelDomain?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "customer" */
export type App_Loader_Customer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Customer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Customer_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  topLevelDomain?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "customer" */
export enum App_Loader_Customer_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TopLevelDomain = 'topLevelDomain'
}

export type App_Loader_Customer_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Customer_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Customer_Bool_Exp;
};

/** columns and relationships of "deployment" */
export type App_Loader_Deployment = {
  __typename?: 'app_loader_deployment';
  appId: Scalars['app_loader_uuid']['output'];
  id: Scalars['app_loader_uuid']['output'];
};

/** aggregated selection of "deployment" */
export type App_Loader_Deployment_Aggregate = {
  __typename?: 'app_loader_deployment_aggregate';
  aggregate?: Maybe<App_Loader_Deployment_Aggregate_Fields>;
  nodes: Array<App_Loader_Deployment>;
};

/** aggregate fields of "deployment" */
export type App_Loader_Deployment_Aggregate_Fields = {
  __typename?: 'app_loader_deployment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Deployment_Max_Fields>;
  min?: Maybe<App_Loader_Deployment_Min_Fields>;
};


/** aggregate fields of "deployment" */
export type App_Loader_Deployment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Deployment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "deployment". All fields are combined with a logical 'AND'. */
export type App_Loader_Deployment_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Deployment_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Deployment_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Deployment_Bool_Exp>>;
  appId?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  id?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "deployment" */
export enum App_Loader_Deployment_Constraint {
  /** unique or primary key constraint on columns "id" */
  DeploymentPkey = 'deployment_pkey'
}

/** input type for inserting data into table "deployment" */
export type App_Loader_Deployment_Insert_Input = {
  appId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Deployment_Max_Fields = {
  __typename?: 'app_loader_deployment_max_fields';
  appId?: Maybe<Scalars['app_loader_uuid']['output']>;
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Deployment_Min_Fields = {
  __typename?: 'app_loader_deployment_min_fields';
  appId?: Maybe<Scalars['app_loader_uuid']['output']>;
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
};

/** response of any mutation on the table "deployment" */
export type App_Loader_Deployment_Mutation_Response = {
  __typename?: 'app_loader_deployment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Deployment>;
};

/** on_conflict condition type for table "deployment" */
export type App_Loader_Deployment_On_Conflict = {
  constraint: App_Loader_Deployment_Constraint;
  update_columns?: Array<App_Loader_Deployment_Update_Column>;
  where?: InputMaybe<App_Loader_Deployment_Bool_Exp>;
};

/** Ordering options when selecting data from "deployment". */
export type App_Loader_Deployment_Order_By = {
  appId?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: deployment */
export type App_Loader_Deployment_Pk_Columns_Input = {
  id: Scalars['app_loader_uuid']['input'];
};

/** select columns of table "deployment" */
export enum App_Loader_Deployment_Select_Column {
  /** column name */
  AppId = 'appId',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "deployment" */
export type App_Loader_Deployment_Set_Input = {
  appId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
};

/** Streaming cursor of the table "deployment" */
export type App_Loader_Deployment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Deployment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Deployment_Stream_Cursor_Value_Input = {
  appId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
};

/** update columns of table "deployment" */
export enum App_Loader_Deployment_Update_Column {
  /** column name */
  AppId = 'appId',
  /** column name */
  Id = 'id'
}

export type App_Loader_Deployment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Deployment_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Deployment_Bool_Exp;
};

/** columns and relationships of "environment" */
export type App_Loader_Environment = {
  __typename?: 'app_loader_environment';
  /** An object relationship */
  app?: Maybe<App_Loader_App>;
  appId?: Maybe<Scalars['app_loader_uuid']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['app_loader_uuid']['output'];
  name: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  /** An array relationship */
  target: Array<App_Loader_Target>;
  /** An aggregate relationship */
  target_aggregate: App_Loader_Target_Aggregate;
};


/** columns and relationships of "environment" */
export type App_Loader_EnvironmentTargetArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Target_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Target_Order_By>>;
  where?: InputMaybe<App_Loader_Target_Bool_Exp>;
};


/** columns and relationships of "environment" */
export type App_Loader_EnvironmentTarget_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Target_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Target_Order_By>>;
  where?: InputMaybe<App_Loader_Target_Bool_Exp>;
};

/** aggregated selection of "environment" */
export type App_Loader_Environment_Aggregate = {
  __typename?: 'app_loader_environment_aggregate';
  aggregate?: Maybe<App_Loader_Environment_Aggregate_Fields>;
  nodes: Array<App_Loader_Environment>;
};

export type App_Loader_Environment_Aggregate_Bool_Exp = {
  count?: InputMaybe<App_Loader_Environment_Aggregate_Bool_Exp_Count>;
};

export type App_Loader_Environment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<App_Loader_Environment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<App_Loader_Environment_Bool_Exp>;
  predicate: App_Loader_Int_Comparison_Exp;
};

/** aggregate fields of "environment" */
export type App_Loader_Environment_Aggregate_Fields = {
  __typename?: 'app_loader_environment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Environment_Max_Fields>;
  min?: Maybe<App_Loader_Environment_Min_Fields>;
};


/** aggregate fields of "environment" */
export type App_Loader_Environment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Environment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "environment" */
export type App_Loader_Environment_Aggregate_Order_By = {
  count?: InputMaybe<App_Loader_Order_By>;
  max?: InputMaybe<App_Loader_Environment_Max_Order_By>;
  min?: InputMaybe<App_Loader_Environment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "environment" */
export type App_Loader_Environment_Arr_Rel_Insert_Input = {
  data: Array<App_Loader_Environment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_Environment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "environment". All fields are combined with a logical 'AND'. */
export type App_Loader_Environment_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Environment_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Environment_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Environment_Bool_Exp>>;
  app?: InputMaybe<App_Loader_App_Bool_Exp>;
  appId?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  description?: InputMaybe<App_Loader_String_Comparison_Exp>;
  id?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  name?: InputMaybe<App_Loader_String_Comparison_Exp>;
  path?: InputMaybe<App_Loader_String_Array_Comparison_Exp>;
  target?: InputMaybe<App_Loader_Target_Bool_Exp>;
  target_aggregate?: InputMaybe<App_Loader_Target_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "environment" */
export enum App_Loader_Environment_Constraint {
  /** unique or primary key constraint on columns "id" */
  EnvironmentIdKey = 'environment_id_key',
  /** unique or primary key constraint on columns "id" */
  EnvironmentPkey = 'environment_pkey'
}

/** input type for inserting data into table "environment" */
export type App_Loader_Environment_Insert_Input = {
  app?: InputMaybe<App_Loader_App_Obj_Rel_Insert_Input>;
  appId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  target?: InputMaybe<App_Loader_Target_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type App_Loader_Environment_Max_Fields = {
  __typename?: 'app_loader_environment_max_fields';
  appId?: Maybe<Scalars['app_loader_uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** order by max() on columns of table "environment" */
export type App_Loader_Environment_Max_Order_By = {
  appId?: InputMaybe<App_Loader_Order_By>;
  description?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
  path?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate min on columns */
export type App_Loader_Environment_Min_Fields = {
  __typename?: 'app_loader_environment_min_fields';
  appId?: Maybe<Scalars['app_loader_uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** order by min() on columns of table "environment" */
export type App_Loader_Environment_Min_Order_By = {
  appId?: InputMaybe<App_Loader_Order_By>;
  description?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
  path?: InputMaybe<App_Loader_Order_By>;
};

/** response of any mutation on the table "environment" */
export type App_Loader_Environment_Mutation_Response = {
  __typename?: 'app_loader_environment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Environment>;
};

/** input type for inserting object relation for remote table "environment" */
export type App_Loader_Environment_Obj_Rel_Insert_Input = {
  data: App_Loader_Environment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_Environment_On_Conflict>;
};

/** on_conflict condition type for table "environment" */
export type App_Loader_Environment_On_Conflict = {
  constraint: App_Loader_Environment_Constraint;
  update_columns?: Array<App_Loader_Environment_Update_Column>;
  where?: InputMaybe<App_Loader_Environment_Bool_Exp>;
};

/** Ordering options when selecting data from "environment". */
export type App_Loader_Environment_Order_By = {
  app?: InputMaybe<App_Loader_App_Order_By>;
  appId?: InputMaybe<App_Loader_Order_By>;
  description?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
  path?: InputMaybe<App_Loader_Order_By>;
  target_aggregate?: InputMaybe<App_Loader_Target_Aggregate_Order_By>;
};

/** primary key columns input for table: environment */
export type App_Loader_Environment_Pk_Columns_Input = {
  id: Scalars['app_loader_uuid']['input'];
};

/** select columns of table "environment" */
export enum App_Loader_Environment_Select_Column {
  /** column name */
  AppId = 'appId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Path = 'path'
}

/** input type for updating data in table "environment" */
export type App_Loader_Environment_Set_Input = {
  appId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Streaming cursor of the table "environment" */
export type App_Loader_Environment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Environment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Environment_Stream_Cursor_Value_Input = {
  appId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** update columns of table "environment" */
export enum App_Loader_Environment_Update_Column {
  /** column name */
  AppId = 'appId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Path = 'path'
}

export type App_Loader_Environment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Environment_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Environment_Bool_Exp;
};

export type App_Loader_Jsonb_Cast_Exp = {
  String?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type App_Loader_Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<App_Loader_Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  _eq?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  _gt?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  _gte?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['app_loader_jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the jsonpath return any item for the specified JSON value */
  _jsonb_path_exists?: InputMaybe<Scalars['String']['input']>;
  /** does the jsonpath predicate check return true for the specified JSON value */
  _jsonb_path_match?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  _lte?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  _neq?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['app_loader_jsonb']['input']>>;
};

/** columns and relationships of "latest_schema.anonymous_session" */
export type App_Loader_Latest_Schema_Anonymous_Session = {
  __typename?: 'app_loader_latest_schema_anonymous_session';
  data: Scalars['app_loader_jsonb']['output'];
  session_id: Scalars['app_loader_uuid']['output'];
};


/** columns and relationships of "latest_schema.anonymous_session" */
export type App_Loader_Latest_Schema_Anonymous_SessionDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "latest_schema.anonymous_session" */
export type App_Loader_Latest_Schema_Anonymous_Session_Aggregate = {
  __typename?: 'app_loader_latest_schema_anonymous_session_aggregate';
  aggregate?: Maybe<App_Loader_Latest_Schema_Anonymous_Session_Aggregate_Fields>;
  nodes: Array<App_Loader_Latest_Schema_Anonymous_Session>;
};

/** aggregate fields of "latest_schema.anonymous_session" */
export type App_Loader_Latest_Schema_Anonymous_Session_Aggregate_Fields = {
  __typename?: 'app_loader_latest_schema_anonymous_session_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Latest_Schema_Anonymous_Session_Max_Fields>;
  min?: Maybe<App_Loader_Latest_Schema_Anonymous_Session_Min_Fields>;
};


/** aggregate fields of "latest_schema.anonymous_session" */
export type App_Loader_Latest_Schema_Anonymous_Session_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Latest_Schema_Anonymous_Session_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type App_Loader_Latest_Schema_Anonymous_Session_Append_Input = {
  data?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "latest_schema.anonymous_session". All fields are combined with a logical 'AND'. */
export type App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp>>;
  data?: InputMaybe<App_Loader_Jsonb_Comparison_Exp>;
  session_id?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "latest_schema.anonymous_session" */
export enum App_Loader_Latest_Schema_Anonymous_Session_Constraint {
  /** unique or primary key constraint on columns "session_id" */
  AnonymousSessionPkey = 'anonymous_session_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type App_Loader_Latest_Schema_Anonymous_Session_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type App_Loader_Latest_Schema_Anonymous_Session_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type App_Loader_Latest_Schema_Anonymous_Session_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "latest_schema.anonymous_session" */
export type App_Loader_Latest_Schema_Anonymous_Session_Insert_Input = {
  data?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  session_id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Latest_Schema_Anonymous_Session_Max_Fields = {
  __typename?: 'app_loader_latest_schema_anonymous_session_max_fields';
  session_id?: Maybe<Scalars['app_loader_uuid']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Latest_Schema_Anonymous_Session_Min_Fields = {
  __typename?: 'app_loader_latest_schema_anonymous_session_min_fields';
  session_id?: Maybe<Scalars['app_loader_uuid']['output']>;
};

/** response of any mutation on the table "latest_schema.anonymous_session" */
export type App_Loader_Latest_Schema_Anonymous_Session_Mutation_Response = {
  __typename?: 'app_loader_latest_schema_anonymous_session_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Latest_Schema_Anonymous_Session>;
};

/** on_conflict condition type for table "latest_schema.anonymous_session" */
export type App_Loader_Latest_Schema_Anonymous_Session_On_Conflict = {
  constraint: App_Loader_Latest_Schema_Anonymous_Session_Constraint;
  update_columns?: Array<App_Loader_Latest_Schema_Anonymous_Session_Update_Column>;
  where?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp>;
};

/** Ordering options when selecting data from "latest_schema.anonymous_session". */
export type App_Loader_Latest_Schema_Anonymous_Session_Order_By = {
  data?: InputMaybe<App_Loader_Order_By>;
  session_id?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: latest_schema.anonymous_session */
export type App_Loader_Latest_Schema_Anonymous_Session_Pk_Columns_Input = {
  session_id: Scalars['app_loader_uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type App_Loader_Latest_Schema_Anonymous_Session_Prepend_Input = {
  data?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
};

/** select columns of table "latest_schema.anonymous_session" */
export enum App_Loader_Latest_Schema_Anonymous_Session_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  SessionId = 'session_id'
}

/** input type for updating data in table "latest_schema.anonymous_session" */
export type App_Loader_Latest_Schema_Anonymous_Session_Set_Input = {
  data?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  session_id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
};

/** Streaming cursor of the table "latest_schema_anonymous_session" */
export type App_Loader_Latest_Schema_Anonymous_Session_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Latest_Schema_Anonymous_Session_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Latest_Schema_Anonymous_Session_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  session_id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
};

/** update columns of table "latest_schema.anonymous_session" */
export enum App_Loader_Latest_Schema_Anonymous_Session_Update_Column {
  /** column name */
  Data = 'data',
  /** column name */
  SessionId = 'session_id'
}

export type App_Loader_Latest_Schema_Anonymous_Session_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp;
};

/** columns and relationships of "latest_schema.packages" */
export type App_Loader_Latest_Schema_Packages = {
  __typename?: 'app_loader_latest_schema_packages';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  schema: Scalars['app_loader_jsonb']['output'];
  type: App_Loader_Latest_Schema_Packages_Type_Enum;
  version: Scalars['String']['output'];
};


/** columns and relationships of "latest_schema.packages" */
export type App_Loader_Latest_Schema_PackagesSchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "latest_schema.packages" */
export type App_Loader_Latest_Schema_Packages_Aggregate = {
  __typename?: 'app_loader_latest_schema_packages_aggregate';
  aggregate?: Maybe<App_Loader_Latest_Schema_Packages_Aggregate_Fields>;
  nodes: Array<App_Loader_Latest_Schema_Packages>;
};

/** aggregate fields of "latest_schema.packages" */
export type App_Loader_Latest_Schema_Packages_Aggregate_Fields = {
  __typename?: 'app_loader_latest_schema_packages_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Latest_Schema_Packages_Max_Fields>;
  min?: Maybe<App_Loader_Latest_Schema_Packages_Min_Fields>;
};


/** aggregate fields of "latest_schema.packages" */
export type App_Loader_Latest_Schema_Packages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type App_Loader_Latest_Schema_Packages_Append_Input = {
  schema?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "latest_schema.packages". All fields are combined with a logical 'AND'. */
export type App_Loader_Latest_Schema_Packages_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Latest_Schema_Packages_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Bool_Exp>>;
  id?: InputMaybe<App_Loader_String_Comparison_Exp>;
  name?: InputMaybe<App_Loader_String_Comparison_Exp>;
  schema?: InputMaybe<App_Loader_Jsonb_Comparison_Exp>;
  type?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Enum_Comparison_Exp>;
  version?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** unique or primary key constraints on table "latest_schema.packages" */
export enum App_Loader_Latest_Schema_Packages_Constraint {
  /** unique or primary key constraint on columns "id" */
  PackagesPkey = 'packages_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type App_Loader_Latest_Schema_Packages_Delete_At_Path_Input = {
  schema?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type App_Loader_Latest_Schema_Packages_Delete_Elem_Input = {
  schema?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type App_Loader_Latest_Schema_Packages_Delete_Key_Input = {
  schema?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "latest_schema.packages" */
export type App_Loader_Latest_Schema_Packages_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  type?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Enum>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Latest_Schema_Packages_Max_Fields = {
  __typename?: 'app_loader_latest_schema_packages_max_fields';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Latest_Schema_Packages_Min_Fields = {
  __typename?: 'app_loader_latest_schema_packages_min_fields';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "latest_schema.packages" */
export type App_Loader_Latest_Schema_Packages_Mutation_Response = {
  __typename?: 'app_loader_latest_schema_packages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Latest_Schema_Packages>;
};

/** on_conflict condition type for table "latest_schema.packages" */
export type App_Loader_Latest_Schema_Packages_On_Conflict = {
  constraint: App_Loader_Latest_Schema_Packages_Constraint;
  update_columns?: Array<App_Loader_Latest_Schema_Packages_Update_Column>;
  where?: InputMaybe<App_Loader_Latest_Schema_Packages_Bool_Exp>;
};

/** Ordering options when selecting data from "latest_schema.packages". */
export type App_Loader_Latest_Schema_Packages_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
  schema?: InputMaybe<App_Loader_Order_By>;
  type?: InputMaybe<App_Loader_Order_By>;
  version?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: latest_schema.packages */
export type App_Loader_Latest_Schema_Packages_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type App_Loader_Latest_Schema_Packages_Prepend_Input = {
  schema?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
};

/** select columns of table "latest_schema.packages" */
export enum App_Loader_Latest_Schema_Packages_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Schema = 'schema',
  /** column name */
  Type = 'type',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "latest_schema.packages" */
export type App_Loader_Latest_Schema_Packages_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  type?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Enum>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "latest_schema_packages" */
export type App_Loader_Latest_Schema_Packages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Latest_Schema_Packages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Latest_Schema_Packages_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['app_loader_jsonb']['input']>;
  type?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Enum>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "latest_schema.packages_type" */
export type App_Loader_Latest_Schema_Packages_Type = {
  __typename?: 'app_loader_latest_schema_packages_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "latest_schema.packages_type" */
export type App_Loader_Latest_Schema_Packages_Type_Aggregate = {
  __typename?: 'app_loader_latest_schema_packages_type_aggregate';
  aggregate?: Maybe<App_Loader_Latest_Schema_Packages_Type_Aggregate_Fields>;
  nodes: Array<App_Loader_Latest_Schema_Packages_Type>;
};

/** aggregate fields of "latest_schema.packages_type" */
export type App_Loader_Latest_Schema_Packages_Type_Aggregate_Fields = {
  __typename?: 'app_loader_latest_schema_packages_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Latest_Schema_Packages_Type_Max_Fields>;
  min?: Maybe<App_Loader_Latest_Schema_Packages_Type_Min_Fields>;
};


/** aggregate fields of "latest_schema.packages_type" */
export type App_Loader_Latest_Schema_Packages_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "latest_schema.packages_type". All fields are combined with a logical 'AND'. */
export type App_Loader_Latest_Schema_Packages_Type_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Bool_Exp>>;
  type?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** unique or primary key constraints on table "latest_schema.packages_type" */
export enum App_Loader_Latest_Schema_Packages_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  PackagesTypePkey = 'packages_type_pkey'
}

export enum App_Loader_Latest_Schema_Packages_Type_Enum {
  Condition = 'condition',
  Function = 'function',
  Trigger = 'trigger'
}

/** Boolean expression to compare columns of type "latest_schema_packages_type_enum". All fields are combined with logical 'AND'. */
export type App_Loader_Latest_Schema_Packages_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Enum>;
  _in?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Enum>;
  _nin?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Enum>>;
};

/** input type for inserting data into table "latest_schema.packages_type" */
export type App_Loader_Latest_Schema_Packages_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Latest_Schema_Packages_Type_Max_Fields = {
  __typename?: 'app_loader_latest_schema_packages_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Latest_Schema_Packages_Type_Min_Fields = {
  __typename?: 'app_loader_latest_schema_packages_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "latest_schema.packages_type" */
export type App_Loader_Latest_Schema_Packages_Type_Mutation_Response = {
  __typename?: 'app_loader_latest_schema_packages_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Latest_Schema_Packages_Type>;
};

/** on_conflict condition type for table "latest_schema.packages_type" */
export type App_Loader_Latest_Schema_Packages_Type_On_Conflict = {
  constraint: App_Loader_Latest_Schema_Packages_Type_Constraint;
  update_columns?: Array<App_Loader_Latest_Schema_Packages_Type_Update_Column>;
  where?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "latest_schema.packages_type". */
export type App_Loader_Latest_Schema_Packages_Type_Order_By = {
  type?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: latest_schema.packages_type */
export type App_Loader_Latest_Schema_Packages_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "latest_schema.packages_type" */
export enum App_Loader_Latest_Schema_Packages_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "latest_schema.packages_type" */
export type App_Loader_Latest_Schema_Packages_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "latest_schema_packages_type" */
export type App_Loader_Latest_Schema_Packages_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Latest_Schema_Packages_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Latest_Schema_Packages_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "latest_schema.packages_type" */
export enum App_Loader_Latest_Schema_Packages_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type App_Loader_Latest_Schema_Packages_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Latest_Schema_Packages_Type_Bool_Exp;
};

/** update columns of table "latest_schema.packages" */
export enum App_Loader_Latest_Schema_Packages_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Schema = 'schema',
  /** column name */
  Type = 'type',
  /** column name */
  Version = 'version'
}

export type App_Loader_Latest_Schema_Packages_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<App_Loader_Latest_Schema_Packages_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<App_Loader_Latest_Schema_Packages_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<App_Loader_Latest_Schema_Packages_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<App_Loader_Latest_Schema_Packages_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<App_Loader_Latest_Schema_Packages_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Latest_Schema_Packages_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Latest_Schema_Packages_Bool_Exp;
};

/** columns and relationships of "metadata.analytics" */
export type App_Loader_Metadata_Analytics = {
  __typename?: 'app_loader_metadata_analytics';
  id: Scalars['app_loader_uuid']['output'];
  phApiHost: Scalars['String']['output'];
  phApiKey: Scalars['String']['output'];
  targetId: Scalars['app_loader_uuid']['output'];
};

/** aggregated selection of "metadata.analytics" */
export type App_Loader_Metadata_Analytics_Aggregate = {
  __typename?: 'app_loader_metadata_analytics_aggregate';
  aggregate?: Maybe<App_Loader_Metadata_Analytics_Aggregate_Fields>;
  nodes: Array<App_Loader_Metadata_Analytics>;
};

/** aggregate fields of "metadata.analytics" */
export type App_Loader_Metadata_Analytics_Aggregate_Fields = {
  __typename?: 'app_loader_metadata_analytics_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Metadata_Analytics_Max_Fields>;
  min?: Maybe<App_Loader_Metadata_Analytics_Min_Fields>;
};


/** aggregate fields of "metadata.analytics" */
export type App_Loader_Metadata_Analytics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Metadata_Analytics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "metadata.analytics". All fields are combined with a logical 'AND'. */
export type App_Loader_Metadata_Analytics_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Metadata_Analytics_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Metadata_Analytics_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Metadata_Analytics_Bool_Exp>>;
  id?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  phApiHost?: InputMaybe<App_Loader_String_Comparison_Exp>;
  phApiKey?: InputMaybe<App_Loader_String_Comparison_Exp>;
  targetId?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "metadata.analytics" */
export enum App_Loader_Metadata_Analytics_Constraint {
  /** unique or primary key constraint on columns "id" */
  AnalyticsPkey = 'analytics_pkey'
}

/** input type for inserting data into table "metadata.analytics" */
export type App_Loader_Metadata_Analytics_Insert_Input = {
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  phApiHost?: InputMaybe<Scalars['String']['input']>;
  phApiKey?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Metadata_Analytics_Max_Fields = {
  __typename?: 'app_loader_metadata_analytics_max_fields';
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  phApiHost?: Maybe<Scalars['String']['output']>;
  phApiKey?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['app_loader_uuid']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Metadata_Analytics_Min_Fields = {
  __typename?: 'app_loader_metadata_analytics_min_fields';
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  phApiHost?: Maybe<Scalars['String']['output']>;
  phApiKey?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['app_loader_uuid']['output']>;
};

/** response of any mutation on the table "metadata.analytics" */
export type App_Loader_Metadata_Analytics_Mutation_Response = {
  __typename?: 'app_loader_metadata_analytics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Metadata_Analytics>;
};

/** input type for inserting object relation for remote table "metadata.analytics" */
export type App_Loader_Metadata_Analytics_Obj_Rel_Insert_Input = {
  data: App_Loader_Metadata_Analytics_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_Metadata_Analytics_On_Conflict>;
};

/** on_conflict condition type for table "metadata.analytics" */
export type App_Loader_Metadata_Analytics_On_Conflict = {
  constraint: App_Loader_Metadata_Analytics_Constraint;
  update_columns?: Array<App_Loader_Metadata_Analytics_Update_Column>;
  where?: InputMaybe<App_Loader_Metadata_Analytics_Bool_Exp>;
};

/** Ordering options when selecting data from "metadata.analytics". */
export type App_Loader_Metadata_Analytics_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
  phApiHost?: InputMaybe<App_Loader_Order_By>;
  phApiKey?: InputMaybe<App_Loader_Order_By>;
  targetId?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: metadata.analytics */
export type App_Loader_Metadata_Analytics_Pk_Columns_Input = {
  id: Scalars['app_loader_uuid']['input'];
};

/** select columns of table "metadata.analytics" */
export enum App_Loader_Metadata_Analytics_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PhApiHost = 'phApiHost',
  /** column name */
  PhApiKey = 'phApiKey',
  /** column name */
  TargetId = 'targetId'
}

/** input type for updating data in table "metadata.analytics" */
export type App_Loader_Metadata_Analytics_Set_Input = {
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  phApiHost?: InputMaybe<Scalars['String']['input']>;
  phApiKey?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
};

/** Streaming cursor of the table "metadata_analytics" */
export type App_Loader_Metadata_Analytics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Metadata_Analytics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Metadata_Analytics_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  phApiHost?: InputMaybe<Scalars['String']['input']>;
  phApiKey?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
};

/** update columns of table "metadata.analytics" */
export enum App_Loader_Metadata_Analytics_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PhApiHost = 'phApiHost',
  /** column name */
  PhApiKey = 'phApiKey',
  /** column name */
  TargetId = 'targetId'
}

export type App_Loader_Metadata_Analytics_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Metadata_Analytics_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Metadata_Analytics_Bool_Exp;
};

/** columns and relationships of "metadata.cc_position_option" */
export type App_Loader_Metadata_Cc_Position_Option = {
  __typename?: 'app_loader_metadata_cc_position_option';
  position: Scalars['String']['output'];
};

/** aggregated selection of "metadata.cc_position_option" */
export type App_Loader_Metadata_Cc_Position_Option_Aggregate = {
  __typename?: 'app_loader_metadata_cc_position_option_aggregate';
  aggregate?: Maybe<App_Loader_Metadata_Cc_Position_Option_Aggregate_Fields>;
  nodes: Array<App_Loader_Metadata_Cc_Position_Option>;
};

/** aggregate fields of "metadata.cc_position_option" */
export type App_Loader_Metadata_Cc_Position_Option_Aggregate_Fields = {
  __typename?: 'app_loader_metadata_cc_position_option_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Metadata_Cc_Position_Option_Max_Fields>;
  min?: Maybe<App_Loader_Metadata_Cc_Position_Option_Min_Fields>;
};


/** aggregate fields of "metadata.cc_position_option" */
export type App_Loader_Metadata_Cc_Position_Option_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "metadata.cc_position_option". All fields are combined with a logical 'AND'. */
export type App_Loader_Metadata_Cc_Position_Option_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Bool_Exp>>;
  position?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** unique or primary key constraints on table "metadata.cc_position_option" */
export enum App_Loader_Metadata_Cc_Position_Option_Constraint {
  /** unique or primary key constraint on columns "position" */
  CcPositionOptionPkey = 'cc_position_option_pkey'
}

export enum App_Loader_Metadata_Cc_Position_Option_Enum {
  Left = 'left',
  Right = 'right'
}

/** Boolean expression to compare columns of type "metadata_cc_position_option_enum". All fields are combined with logical 'AND'. */
export type App_Loader_Metadata_Cc_Position_Option_Enum_Comparison_Exp = {
  _eq?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Enum>;
  _in?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Enum>;
  _nin?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Enum>>;
};

/** input type for inserting data into table "metadata.cc_position_option" */
export type App_Loader_Metadata_Cc_Position_Option_Insert_Input = {
  position?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Metadata_Cc_Position_Option_Max_Fields = {
  __typename?: 'app_loader_metadata_cc_position_option_max_fields';
  position?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Metadata_Cc_Position_Option_Min_Fields = {
  __typename?: 'app_loader_metadata_cc_position_option_min_fields';
  position?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "metadata.cc_position_option" */
export type App_Loader_Metadata_Cc_Position_Option_Mutation_Response = {
  __typename?: 'app_loader_metadata_cc_position_option_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Metadata_Cc_Position_Option>;
};

/** on_conflict condition type for table "metadata.cc_position_option" */
export type App_Loader_Metadata_Cc_Position_Option_On_Conflict = {
  constraint: App_Loader_Metadata_Cc_Position_Option_Constraint;
  update_columns?: Array<App_Loader_Metadata_Cc_Position_Option_Update_Column>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Bool_Exp>;
};

/** Ordering options when selecting data from "metadata.cc_position_option". */
export type App_Loader_Metadata_Cc_Position_Option_Order_By = {
  position?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: metadata.cc_position_option */
export type App_Loader_Metadata_Cc_Position_Option_Pk_Columns_Input = {
  position: Scalars['String']['input'];
};

/** select columns of table "metadata.cc_position_option" */
export enum App_Loader_Metadata_Cc_Position_Option_Select_Column {
  /** column name */
  Position = 'position'
}

/** input type for updating data in table "metadata.cc_position_option" */
export type App_Loader_Metadata_Cc_Position_Option_Set_Input = {
  position?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "metadata_cc_position_option" */
export type App_Loader_Metadata_Cc_Position_Option_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Metadata_Cc_Position_Option_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Metadata_Cc_Position_Option_Stream_Cursor_Value_Input = {
  position?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "metadata.cc_position_option" */
export enum App_Loader_Metadata_Cc_Position_Option_Update_Column {
  /** column name */
  Position = 'position'
}

export type App_Loader_Metadata_Cc_Position_Option_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Metadata_Cc_Position_Option_Bool_Exp;
};

/** columns and relationships of "metadata.cc_widget" */
export type App_Loader_Metadata_Cc_Widget = {
  __typename?: 'app_loader_metadata_cc_widget';
  bubbleType?: Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Enum>;
  id: Scalars['app_loader_uuid']['output'];
  launcherTitle: Scalars['String']['output'];
  packageName: Scalars['String']['output'];
  phApiHost: Scalars['String']['output'];
  phApiKey: Scalars['String']['output'];
  position?: Maybe<App_Loader_Metadata_Cc_Position_Option_Enum>;
  targetId: Scalars['app_loader_uuid']['output'];
  websiteToken: Scalars['String']['output'];
};

/** aggregated selection of "metadata.cc_widget" */
export type App_Loader_Metadata_Cc_Widget_Aggregate = {
  __typename?: 'app_loader_metadata_cc_widget_aggregate';
  aggregate?: Maybe<App_Loader_Metadata_Cc_Widget_Aggregate_Fields>;
  nodes: Array<App_Loader_Metadata_Cc_Widget>;
};

/** aggregate fields of "metadata.cc_widget" */
export type App_Loader_Metadata_Cc_Widget_Aggregate_Fields = {
  __typename?: 'app_loader_metadata_cc_widget_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Metadata_Cc_Widget_Max_Fields>;
  min?: Maybe<App_Loader_Metadata_Cc_Widget_Min_Fields>;
};


/** aggregate fields of "metadata.cc_widget" */
export type App_Loader_Metadata_Cc_Widget_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "metadata.cc_widget". All fields are combined with a logical 'AND'. */
export type App_Loader_Metadata_Cc_Widget_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bool_Exp>>;
  bubbleType?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  launcherTitle?: InputMaybe<App_Loader_String_Comparison_Exp>;
  packageName?: InputMaybe<App_Loader_String_Comparison_Exp>;
  phApiHost?: InputMaybe<App_Loader_String_Comparison_Exp>;
  phApiKey?: InputMaybe<App_Loader_String_Comparison_Exp>;
  position?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Enum_Comparison_Exp>;
  targetId?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  websiteToken?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** columns and relationships of "metadata.cc_widget_bubble_type" */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type = {
  __typename?: 'app_loader_metadata_cc_widget_bubble_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "metadata.cc_widget_bubble_type" */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Aggregate = {
  __typename?: 'app_loader_metadata_cc_widget_bubble_type_aggregate';
  aggregate?: Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Aggregate_Fields>;
  nodes: Array<App_Loader_Metadata_Cc_Widget_Bubble_Type>;
};

/** aggregate fields of "metadata.cc_widget_bubble_type" */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Aggregate_Fields = {
  __typename?: 'app_loader_metadata_cc_widget_bubble_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Max_Fields>;
  min?: Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Min_Fields>;
};


/** aggregate fields of "metadata.cc_widget_bubble_type" */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "metadata.cc_widget_bubble_type". All fields are combined with a logical 'AND'. */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp>>;
  type?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** unique or primary key constraints on table "metadata.cc_widget_bubble_type" */
export enum App_Loader_Metadata_Cc_Widget_Bubble_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  CcWidgetBubbleTypePkey = 'cc_widget_bubble_type_pkey'
}

export enum App_Loader_Metadata_Cc_Widget_Bubble_Type_Enum {
  Expanded = 'expanded',
  Standard = 'standard'
}

/** Boolean expression to compare columns of type "metadata_cc_widget_bubble_type_enum". All fields are combined with logical 'AND'. */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Enum>;
  _in?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Enum>;
  _nin?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Enum>>;
};

/** input type for inserting data into table "metadata.cc_widget_bubble_type" */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Max_Fields = {
  __typename?: 'app_loader_metadata_cc_widget_bubble_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Min_Fields = {
  __typename?: 'app_loader_metadata_cc_widget_bubble_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "metadata.cc_widget_bubble_type" */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Mutation_Response = {
  __typename?: 'app_loader_metadata_cc_widget_bubble_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Metadata_Cc_Widget_Bubble_Type>;
};

/** on_conflict condition type for table "metadata.cc_widget_bubble_type" */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_On_Conflict = {
  constraint: App_Loader_Metadata_Cc_Widget_Bubble_Type_Constraint;
  update_columns?: Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Update_Column>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "metadata.cc_widget_bubble_type". */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Order_By = {
  type?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: metadata.cc_widget_bubble_type */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "metadata.cc_widget_bubble_type" */
export enum App_Loader_Metadata_Cc_Widget_Bubble_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "metadata.cc_widget_bubble_type" */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "metadata_cc_widget_bubble_type" */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Metadata_Cc_Widget_Bubble_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "metadata.cc_widget_bubble_type" */
export enum App_Loader_Metadata_Cc_Widget_Bubble_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type App_Loader_Metadata_Cc_Widget_Bubble_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp;
};

/** unique or primary key constraints on table "metadata.cc_widget" */
export enum App_Loader_Metadata_Cc_Widget_Constraint {
  /** unique or primary key constraint on columns "id" */
  CcWidgetPkey = 'cc_widget_pkey'
}

/** input type for inserting data into table "metadata.cc_widget" */
export type App_Loader_Metadata_Cc_Widget_Insert_Input = {
  bubbleType?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Enum>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  launcherTitle?: InputMaybe<Scalars['String']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  phApiHost?: InputMaybe<Scalars['String']['input']>;
  phApiKey?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Enum>;
  targetId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  websiteToken?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Metadata_Cc_Widget_Max_Fields = {
  __typename?: 'app_loader_metadata_cc_widget_max_fields';
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  launcherTitle?: Maybe<Scalars['String']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  phApiHost?: Maybe<Scalars['String']['output']>;
  phApiKey?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['app_loader_uuid']['output']>;
  websiteToken?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Metadata_Cc_Widget_Min_Fields = {
  __typename?: 'app_loader_metadata_cc_widget_min_fields';
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  launcherTitle?: Maybe<Scalars['String']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  phApiHost?: Maybe<Scalars['String']['output']>;
  phApiKey?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['app_loader_uuid']['output']>;
  websiteToken?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "metadata.cc_widget" */
export type App_Loader_Metadata_Cc_Widget_Mutation_Response = {
  __typename?: 'app_loader_metadata_cc_widget_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Metadata_Cc_Widget>;
};

/** input type for inserting object relation for remote table "metadata.cc_widget" */
export type App_Loader_Metadata_Cc_Widget_Obj_Rel_Insert_Input = {
  data: App_Loader_Metadata_Cc_Widget_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_Metadata_Cc_Widget_On_Conflict>;
};

/** on_conflict condition type for table "metadata.cc_widget" */
export type App_Loader_Metadata_Cc_Widget_On_Conflict = {
  constraint: App_Loader_Metadata_Cc_Widget_Constraint;
  update_columns?: Array<App_Loader_Metadata_Cc_Widget_Update_Column>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bool_Exp>;
};

/** Ordering options when selecting data from "metadata.cc_widget". */
export type App_Loader_Metadata_Cc_Widget_Order_By = {
  bubbleType?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  launcherTitle?: InputMaybe<App_Loader_Order_By>;
  packageName?: InputMaybe<App_Loader_Order_By>;
  phApiHost?: InputMaybe<App_Loader_Order_By>;
  phApiKey?: InputMaybe<App_Loader_Order_By>;
  position?: InputMaybe<App_Loader_Order_By>;
  targetId?: InputMaybe<App_Loader_Order_By>;
  websiteToken?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: metadata.cc_widget */
export type App_Loader_Metadata_Cc_Widget_Pk_Columns_Input = {
  id: Scalars['app_loader_uuid']['input'];
};

/** select columns of table "metadata.cc_widget" */
export enum App_Loader_Metadata_Cc_Widget_Select_Column {
  /** column name */
  BubbleType = 'bubbleType',
  /** column name */
  Id = 'id',
  /** column name */
  LauncherTitle = 'launcherTitle',
  /** column name */
  PackageName = 'packageName',
  /** column name */
  PhApiHost = 'phApiHost',
  /** column name */
  PhApiKey = 'phApiKey',
  /** column name */
  Position = 'position',
  /** column name */
  TargetId = 'targetId',
  /** column name */
  WebsiteToken = 'websiteToken'
}

/** input type for updating data in table "metadata.cc_widget" */
export type App_Loader_Metadata_Cc_Widget_Set_Input = {
  bubbleType?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Enum>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  launcherTitle?: InputMaybe<Scalars['String']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  phApiHost?: InputMaybe<Scalars['String']['input']>;
  phApiKey?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Enum>;
  targetId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  websiteToken?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "metadata_cc_widget" */
export type App_Loader_Metadata_Cc_Widget_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Metadata_Cc_Widget_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Metadata_Cc_Widget_Stream_Cursor_Value_Input = {
  bubbleType?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Enum>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  launcherTitle?: InputMaybe<Scalars['String']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  phApiHost?: InputMaybe<Scalars['String']['input']>;
  phApiKey?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Enum>;
  targetId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  websiteToken?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "metadata.cc_widget" */
export enum App_Loader_Metadata_Cc_Widget_Update_Column {
  /** column name */
  BubbleType = 'bubbleType',
  /** column name */
  Id = 'id',
  /** column name */
  LauncherTitle = 'launcherTitle',
  /** column name */
  PackageName = 'packageName',
  /** column name */
  PhApiHost = 'phApiHost',
  /** column name */
  PhApiKey = 'phApiKey',
  /** column name */
  Position = 'position',
  /** column name */
  TargetId = 'targetId',
  /** column name */
  WebsiteToken = 'websiteToken'
}

export type App_Loader_Metadata_Cc_Widget_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Metadata_Cc_Widget_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Metadata_Cc_Widget_Bool_Exp;
};

/** columns and relationships of "metadata.generic" */
export type App_Loader_Metadata_Generic = {
  __typename?: 'app_loader_metadata_generic';
  id: Scalars['app_loader_uuid']['output'];
  packageName: Scalars['String']['output'];
  targetId: Scalars['app_loader_uuid']['output'];
  type?: Maybe<App_Loader_Metadata_Generic_Module_Type_Enum>;
};

/** aggregated selection of "metadata.generic" */
export type App_Loader_Metadata_Generic_Aggregate = {
  __typename?: 'app_loader_metadata_generic_aggregate';
  aggregate?: Maybe<App_Loader_Metadata_Generic_Aggregate_Fields>;
  nodes: Array<App_Loader_Metadata_Generic>;
};

/** aggregate fields of "metadata.generic" */
export type App_Loader_Metadata_Generic_Aggregate_Fields = {
  __typename?: 'app_loader_metadata_generic_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Metadata_Generic_Max_Fields>;
  min?: Maybe<App_Loader_Metadata_Generic_Min_Fields>;
};


/** aggregate fields of "metadata.generic" */
export type App_Loader_Metadata_Generic_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Metadata_Generic_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "metadata.generic". All fields are combined with a logical 'AND'. */
export type App_Loader_Metadata_Generic_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Metadata_Generic_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Metadata_Generic_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Metadata_Generic_Bool_Exp>>;
  id?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  packageName?: InputMaybe<App_Loader_String_Comparison_Exp>;
  targetId?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  type?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "metadata.generic" */
export enum App_Loader_Metadata_Generic_Constraint {
  /** unique or primary key constraint on columns "id" */
  GenericPkey = 'generic_pkey'
}

/** input type for inserting data into table "metadata.generic" */
export type App_Loader_Metadata_Generic_Insert_Input = {
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  type?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Enum>;
};

/** aggregate max on columns */
export type App_Loader_Metadata_Generic_Max_Fields = {
  __typename?: 'app_loader_metadata_generic_max_fields';
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['app_loader_uuid']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Metadata_Generic_Min_Fields = {
  __typename?: 'app_loader_metadata_generic_min_fields';
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['app_loader_uuid']['output']>;
};

/** columns and relationships of "metadata.generic_module_type" */
export type App_Loader_Metadata_Generic_Module_Type = {
  __typename?: 'app_loader_metadata_generic_module_type';
  moduleType: Scalars['String']['output'];
};

/** aggregated selection of "metadata.generic_module_type" */
export type App_Loader_Metadata_Generic_Module_Type_Aggregate = {
  __typename?: 'app_loader_metadata_generic_module_type_aggregate';
  aggregate?: Maybe<App_Loader_Metadata_Generic_Module_Type_Aggregate_Fields>;
  nodes: Array<App_Loader_Metadata_Generic_Module_Type>;
};

/** aggregate fields of "metadata.generic_module_type" */
export type App_Loader_Metadata_Generic_Module_Type_Aggregate_Fields = {
  __typename?: 'app_loader_metadata_generic_module_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Metadata_Generic_Module_Type_Max_Fields>;
  min?: Maybe<App_Loader_Metadata_Generic_Module_Type_Min_Fields>;
};


/** aggregate fields of "metadata.generic_module_type" */
export type App_Loader_Metadata_Generic_Module_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "metadata.generic_module_type". All fields are combined with a logical 'AND'. */
export type App_Loader_Metadata_Generic_Module_Type_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Bool_Exp>>;
  moduleType?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** unique or primary key constraints on table "metadata.generic_module_type" */
export enum App_Loader_Metadata_Generic_Module_Type_Constraint {
  /** unique or primary key constraint on columns "moduleType" */
  GenericModuleTypePkey = 'generic_module_type_pkey'
}

export enum App_Loader_Metadata_Generic_Module_Type_Enum {
  Commonjs = 'commonjs',
  Module = 'module'
}

/** Boolean expression to compare columns of type "metadata_generic_module_type_enum". All fields are combined with logical 'AND'. */
export type App_Loader_Metadata_Generic_Module_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Enum>;
  _in?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Enum>;
  _nin?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Enum>>;
};

/** input type for inserting data into table "metadata.generic_module_type" */
export type App_Loader_Metadata_Generic_Module_Type_Insert_Input = {
  moduleType?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Metadata_Generic_Module_Type_Max_Fields = {
  __typename?: 'app_loader_metadata_generic_module_type_max_fields';
  moduleType?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Metadata_Generic_Module_Type_Min_Fields = {
  __typename?: 'app_loader_metadata_generic_module_type_min_fields';
  moduleType?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "metadata.generic_module_type" */
export type App_Loader_Metadata_Generic_Module_Type_Mutation_Response = {
  __typename?: 'app_loader_metadata_generic_module_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Metadata_Generic_Module_Type>;
};

/** on_conflict condition type for table "metadata.generic_module_type" */
export type App_Loader_Metadata_Generic_Module_Type_On_Conflict = {
  constraint: App_Loader_Metadata_Generic_Module_Type_Constraint;
  update_columns?: Array<App_Loader_Metadata_Generic_Module_Type_Update_Column>;
  where?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "metadata.generic_module_type". */
export type App_Loader_Metadata_Generic_Module_Type_Order_By = {
  moduleType?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: metadata.generic_module_type */
export type App_Loader_Metadata_Generic_Module_Type_Pk_Columns_Input = {
  moduleType: Scalars['String']['input'];
};

/** select columns of table "metadata.generic_module_type" */
export enum App_Loader_Metadata_Generic_Module_Type_Select_Column {
  /** column name */
  ModuleType = 'moduleType'
}

/** input type for updating data in table "metadata.generic_module_type" */
export type App_Loader_Metadata_Generic_Module_Type_Set_Input = {
  moduleType?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "metadata_generic_module_type" */
export type App_Loader_Metadata_Generic_Module_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Metadata_Generic_Module_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Metadata_Generic_Module_Type_Stream_Cursor_Value_Input = {
  moduleType?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "metadata.generic_module_type" */
export enum App_Loader_Metadata_Generic_Module_Type_Update_Column {
  /** column name */
  ModuleType = 'moduleType'
}

export type App_Loader_Metadata_Generic_Module_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Metadata_Generic_Module_Type_Bool_Exp;
};

/** response of any mutation on the table "metadata.generic" */
export type App_Loader_Metadata_Generic_Mutation_Response = {
  __typename?: 'app_loader_metadata_generic_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Metadata_Generic>;
};

/** input type for inserting object relation for remote table "metadata.generic" */
export type App_Loader_Metadata_Generic_Obj_Rel_Insert_Input = {
  data: App_Loader_Metadata_Generic_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_Metadata_Generic_On_Conflict>;
};

/** on_conflict condition type for table "metadata.generic" */
export type App_Loader_Metadata_Generic_On_Conflict = {
  constraint: App_Loader_Metadata_Generic_Constraint;
  update_columns?: Array<App_Loader_Metadata_Generic_Update_Column>;
  where?: InputMaybe<App_Loader_Metadata_Generic_Bool_Exp>;
};

/** Ordering options when selecting data from "metadata.generic". */
export type App_Loader_Metadata_Generic_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
  packageName?: InputMaybe<App_Loader_Order_By>;
  targetId?: InputMaybe<App_Loader_Order_By>;
  type?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: metadata.generic */
export type App_Loader_Metadata_Generic_Pk_Columns_Input = {
  id: Scalars['app_loader_uuid']['input'];
};

/** select columns of table "metadata.generic" */
export enum App_Loader_Metadata_Generic_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PackageName = 'packageName',
  /** column name */
  TargetId = 'targetId',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "metadata.generic" */
export type App_Loader_Metadata_Generic_Set_Input = {
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  type?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Enum>;
};

/** Streaming cursor of the table "metadata_generic" */
export type App_Loader_Metadata_Generic_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Metadata_Generic_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Metadata_Generic_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  type?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Enum>;
};

/** update columns of table "metadata.generic" */
export enum App_Loader_Metadata_Generic_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PackageName = 'packageName',
  /** column name */
  TargetId = 'targetId',
  /** column name */
  Type = 'type'
}

export type App_Loader_Metadata_Generic_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Metadata_Generic_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Metadata_Generic_Bool_Exp;
};

/** columns and relationships of "metadata.pype" */
export type App_Loader_Metadata_Pype = {
  __typename?: 'app_loader_metadata_pype';
  appId?: Maybe<Scalars['app_loader_uuid']['output']>;
  id: Scalars['app_loader_uuid']['output'];
  packageName: Scalars['String']['output'];
  phApiHost?: Maybe<Scalars['String']['output']>;
  phApiKey?: Maybe<Scalars['String']['output']>;
  targetId: Scalars['app_loader_uuid']['output'];
  type: App_Loader_Metadata_Pype_Type_Enum;
};

/** aggregated selection of "metadata.pype" */
export type App_Loader_Metadata_Pype_Aggregate = {
  __typename?: 'app_loader_metadata_pype_aggregate';
  aggregate?: Maybe<App_Loader_Metadata_Pype_Aggregate_Fields>;
  nodes: Array<App_Loader_Metadata_Pype>;
};

/** aggregate fields of "metadata.pype" */
export type App_Loader_Metadata_Pype_Aggregate_Fields = {
  __typename?: 'app_loader_metadata_pype_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Metadata_Pype_Max_Fields>;
  min?: Maybe<App_Loader_Metadata_Pype_Min_Fields>;
};


/** aggregate fields of "metadata.pype" */
export type App_Loader_Metadata_Pype_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Metadata_Pype_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "metadata.pype". All fields are combined with a logical 'AND'. */
export type App_Loader_Metadata_Pype_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Metadata_Pype_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Metadata_Pype_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Metadata_Pype_Bool_Exp>>;
  appId?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  id?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  packageName?: InputMaybe<App_Loader_String_Comparison_Exp>;
  phApiHost?: InputMaybe<App_Loader_String_Comparison_Exp>;
  phApiKey?: InputMaybe<App_Loader_String_Comparison_Exp>;
  targetId?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  type?: InputMaybe<App_Loader_Metadata_Pype_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "metadata.pype" */
export enum App_Loader_Metadata_Pype_Constraint {
  /** unique or primary key constraint on columns "id" */
  PypePkey = 'pype_pkey'
}

/** input type for inserting data into table "metadata.pype" */
export type App_Loader_Metadata_Pype_Insert_Input = {
  appId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  phApiHost?: InputMaybe<Scalars['String']['input']>;
  phApiKey?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  type?: InputMaybe<App_Loader_Metadata_Pype_Type_Enum>;
};

/** aggregate max on columns */
export type App_Loader_Metadata_Pype_Max_Fields = {
  __typename?: 'app_loader_metadata_pype_max_fields';
  appId?: Maybe<Scalars['app_loader_uuid']['output']>;
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  phApiHost?: Maybe<Scalars['String']['output']>;
  phApiKey?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['app_loader_uuid']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Metadata_Pype_Min_Fields = {
  __typename?: 'app_loader_metadata_pype_min_fields';
  appId?: Maybe<Scalars['app_loader_uuid']['output']>;
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  phApiHost?: Maybe<Scalars['String']['output']>;
  phApiKey?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['app_loader_uuid']['output']>;
};

/** response of any mutation on the table "metadata.pype" */
export type App_Loader_Metadata_Pype_Mutation_Response = {
  __typename?: 'app_loader_metadata_pype_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Metadata_Pype>;
};

/** input type for inserting object relation for remote table "metadata.pype" */
export type App_Loader_Metadata_Pype_Obj_Rel_Insert_Input = {
  data: App_Loader_Metadata_Pype_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_Metadata_Pype_On_Conflict>;
};

/** on_conflict condition type for table "metadata.pype" */
export type App_Loader_Metadata_Pype_On_Conflict = {
  constraint: App_Loader_Metadata_Pype_Constraint;
  update_columns?: Array<App_Loader_Metadata_Pype_Update_Column>;
  where?: InputMaybe<App_Loader_Metadata_Pype_Bool_Exp>;
};

/** Ordering options when selecting data from "metadata.pype". */
export type App_Loader_Metadata_Pype_Order_By = {
  appId?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  packageName?: InputMaybe<App_Loader_Order_By>;
  phApiHost?: InputMaybe<App_Loader_Order_By>;
  phApiKey?: InputMaybe<App_Loader_Order_By>;
  targetId?: InputMaybe<App_Loader_Order_By>;
  type?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: metadata.pype */
export type App_Loader_Metadata_Pype_Pk_Columns_Input = {
  id: Scalars['app_loader_uuid']['input'];
};

/** select columns of table "metadata.pype" */
export enum App_Loader_Metadata_Pype_Select_Column {
  /** column name */
  AppId = 'appId',
  /** column name */
  Id = 'id',
  /** column name */
  PackageName = 'packageName',
  /** column name */
  PhApiHost = 'phApiHost',
  /** column name */
  PhApiKey = 'phApiKey',
  /** column name */
  TargetId = 'targetId',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "metadata.pype" */
export type App_Loader_Metadata_Pype_Set_Input = {
  appId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  phApiHost?: InputMaybe<Scalars['String']['input']>;
  phApiKey?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  type?: InputMaybe<App_Loader_Metadata_Pype_Type_Enum>;
};

/** Streaming cursor of the table "metadata_pype" */
export type App_Loader_Metadata_Pype_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Metadata_Pype_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Metadata_Pype_Stream_Cursor_Value_Input = {
  appId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  phApiHost?: InputMaybe<Scalars['String']['input']>;
  phApiKey?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  type?: InputMaybe<App_Loader_Metadata_Pype_Type_Enum>;
};

/** columns and relationships of "metadata.pype_type" */
export type App_Loader_Metadata_Pype_Type = {
  __typename?: 'app_loader_metadata_pype_type';
  name: Scalars['String']['output'];
};

/** aggregated selection of "metadata.pype_type" */
export type App_Loader_Metadata_Pype_Type_Aggregate = {
  __typename?: 'app_loader_metadata_pype_type_aggregate';
  aggregate?: Maybe<App_Loader_Metadata_Pype_Type_Aggregate_Fields>;
  nodes: Array<App_Loader_Metadata_Pype_Type>;
};

/** aggregate fields of "metadata.pype_type" */
export type App_Loader_Metadata_Pype_Type_Aggregate_Fields = {
  __typename?: 'app_loader_metadata_pype_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Metadata_Pype_Type_Max_Fields>;
  min?: Maybe<App_Loader_Metadata_Pype_Type_Min_Fields>;
};


/** aggregate fields of "metadata.pype_type" */
export type App_Loader_Metadata_Pype_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "metadata.pype_type". All fields are combined with a logical 'AND'. */
export type App_Loader_Metadata_Pype_Type_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Metadata_Pype_Type_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Bool_Exp>>;
  name?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** unique or primary key constraints on table "metadata.pype_type" */
export enum App_Loader_Metadata_Pype_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  PypeTypeEnumPkey = 'pype_type_enum_pkey'
}

export enum App_Loader_Metadata_Pype_Type_Enum {
  Default = 'default',
  JsMode = 'jsMode'
}

/** Boolean expression to compare columns of type "metadata_pype_type_enum". All fields are combined with logical 'AND'. */
export type App_Loader_Metadata_Pype_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<App_Loader_Metadata_Pype_Type_Enum>;
  _in?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<App_Loader_Metadata_Pype_Type_Enum>;
  _nin?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Enum>>;
};

/** input type for inserting data into table "metadata.pype_type" */
export type App_Loader_Metadata_Pype_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Metadata_Pype_Type_Max_Fields = {
  __typename?: 'app_loader_metadata_pype_type_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Metadata_Pype_Type_Min_Fields = {
  __typename?: 'app_loader_metadata_pype_type_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "metadata.pype_type" */
export type App_Loader_Metadata_Pype_Type_Mutation_Response = {
  __typename?: 'app_loader_metadata_pype_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Metadata_Pype_Type>;
};

/** on_conflict condition type for table "metadata.pype_type" */
export type App_Loader_Metadata_Pype_Type_On_Conflict = {
  constraint: App_Loader_Metadata_Pype_Type_Constraint;
  update_columns?: Array<App_Loader_Metadata_Pype_Type_Update_Column>;
  where?: InputMaybe<App_Loader_Metadata_Pype_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "metadata.pype_type". */
export type App_Loader_Metadata_Pype_Type_Order_By = {
  name?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: metadata.pype_type */
export type App_Loader_Metadata_Pype_Type_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "metadata.pype_type" */
export enum App_Loader_Metadata_Pype_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "metadata.pype_type" */
export type App_Loader_Metadata_Pype_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "metadata_pype_type" */
export type App_Loader_Metadata_Pype_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Metadata_Pype_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Metadata_Pype_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "metadata.pype_type" */
export enum App_Loader_Metadata_Pype_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type App_Loader_Metadata_Pype_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Metadata_Pype_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Metadata_Pype_Type_Bool_Exp;
};

/** update columns of table "metadata.pype" */
export enum App_Loader_Metadata_Pype_Update_Column {
  /** column name */
  AppId = 'appId',
  /** column name */
  Id = 'id',
  /** column name */
  PackageName = 'packageName',
  /** column name */
  PhApiHost = 'phApiHost',
  /** column name */
  PhApiKey = 'phApiKey',
  /** column name */
  TargetId = 'targetId',
  /** column name */
  Type = 'type'
}

export type App_Loader_Metadata_Pype_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Metadata_Pype_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Metadata_Pype_Bool_Exp;
};

export type App_Loader_Mutation_Root = {
  __typename?: 'app_loader_mutation_root';
  /** delete data from the table: "app" */
  delete_app?: Maybe<App_Loader_App_Mutation_Response>;
  /** delete single row from the table: "app" */
  delete_app_by_pk?: Maybe<App_Loader_App>;
  /** delete data from the table: "conditions" */
  delete_conditions?: Maybe<App_Loader_Conditions_Mutation_Response>;
  /** delete single row from the table: "conditions" */
  delete_conditions_by_pk?: Maybe<App_Loader_Conditions>;
  /** delete data from the table: "customer" */
  delete_customer?: Maybe<App_Loader_Customer_Mutation_Response>;
  /** delete single row from the table: "customer" */
  delete_customer_by_pk?: Maybe<App_Loader_Customer>;
  /** delete data from the table: "deployment" */
  delete_deployment?: Maybe<App_Loader_Deployment_Mutation_Response>;
  /** delete single row from the table: "deployment" */
  delete_deployment_by_pk?: Maybe<App_Loader_Deployment>;
  /** delete data from the table: "environment" */
  delete_environment?: Maybe<App_Loader_Environment_Mutation_Response>;
  /** delete single row from the table: "environment" */
  delete_environment_by_pk?: Maybe<App_Loader_Environment>;
  /** delete data from the table: "latest_schema.anonymous_session" */
  delete_latest_schema_anonymous_session?: Maybe<App_Loader_Latest_Schema_Anonymous_Session_Mutation_Response>;
  /** delete single row from the table: "latest_schema.anonymous_session" */
  delete_latest_schema_anonymous_session_by_pk?: Maybe<App_Loader_Latest_Schema_Anonymous_Session>;
  /** delete data from the table: "latest_schema.packages" */
  delete_latest_schema_packages?: Maybe<App_Loader_Latest_Schema_Packages_Mutation_Response>;
  /** delete single row from the table: "latest_schema.packages" */
  delete_latest_schema_packages_by_pk?: Maybe<App_Loader_Latest_Schema_Packages>;
  /** delete data from the table: "latest_schema.packages_type" */
  delete_latest_schema_packages_type?: Maybe<App_Loader_Latest_Schema_Packages_Type_Mutation_Response>;
  /** delete single row from the table: "latest_schema.packages_type" */
  delete_latest_schema_packages_type_by_pk?: Maybe<App_Loader_Latest_Schema_Packages_Type>;
  /** delete data from the table: "metadata.analytics" */
  delete_metadata_analytics?: Maybe<App_Loader_Metadata_Analytics_Mutation_Response>;
  /** delete single row from the table: "metadata.analytics" */
  delete_metadata_analytics_by_pk?: Maybe<App_Loader_Metadata_Analytics>;
  /** delete data from the table: "metadata.cc_position_option" */
  delete_metadata_cc_position_option?: Maybe<App_Loader_Metadata_Cc_Position_Option_Mutation_Response>;
  /** delete single row from the table: "metadata.cc_position_option" */
  delete_metadata_cc_position_option_by_pk?: Maybe<App_Loader_Metadata_Cc_Position_Option>;
  /** delete data from the table: "metadata.cc_widget" */
  delete_metadata_cc_widget?: Maybe<App_Loader_Metadata_Cc_Widget_Mutation_Response>;
  /** delete data from the table: "metadata.cc_widget_bubble_type" */
  delete_metadata_cc_widget_bubble_type?: Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Mutation_Response>;
  /** delete single row from the table: "metadata.cc_widget_bubble_type" */
  delete_metadata_cc_widget_bubble_type_by_pk?: Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type>;
  /** delete single row from the table: "metadata.cc_widget" */
  delete_metadata_cc_widget_by_pk?: Maybe<App_Loader_Metadata_Cc_Widget>;
  /** delete data from the table: "metadata.generic" */
  delete_metadata_generic?: Maybe<App_Loader_Metadata_Generic_Mutation_Response>;
  /** delete single row from the table: "metadata.generic" */
  delete_metadata_generic_by_pk?: Maybe<App_Loader_Metadata_Generic>;
  /** delete data from the table: "metadata.generic_module_type" */
  delete_metadata_generic_module_type?: Maybe<App_Loader_Metadata_Generic_Module_Type_Mutation_Response>;
  /** delete single row from the table: "metadata.generic_module_type" */
  delete_metadata_generic_module_type_by_pk?: Maybe<App_Loader_Metadata_Generic_Module_Type>;
  /** delete data from the table: "metadata.pype" */
  delete_metadata_pype?: Maybe<App_Loader_Metadata_Pype_Mutation_Response>;
  /** delete single row from the table: "metadata.pype" */
  delete_metadata_pype_by_pk?: Maybe<App_Loader_Metadata_Pype>;
  /** delete data from the table: "metadata.pype_type" */
  delete_metadata_pype_type?: Maybe<App_Loader_Metadata_Pype_Type_Mutation_Response>;
  /** delete single row from the table: "metadata.pype_type" */
  delete_metadata_pype_type_by_pk?: Maybe<App_Loader_Metadata_Pype_Type>;
  /** delete data from the table: "n_analytic_package_configuration" */
  delete_n_analytic_package_configuration?: Maybe<App_Loader_N_Analytic_Package_Configuration_Mutation_Response>;
  /** delete single row from the table: "n_analytic_package_configuration" */
  delete_n_analytic_package_configuration_by_pk?: Maybe<App_Loader_N_Analytic_Package_Configuration>;
  /** delete data from the table: "n_application" */
  delete_n_application?: Maybe<App_Loader_N_Application_Mutation_Response>;
  /** delete single row from the table: "n_application" */
  delete_n_application_by_pk?: Maybe<App_Loader_N_Application>;
  /** delete data from the table: "n_domain" */
  delete_n_domain?: Maybe<App_Loader_N_Domain_Mutation_Response>;
  /** delete single row from the table: "n_domain" */
  delete_n_domain_by_pk?: Maybe<App_Loader_N_Domain>;
  /** delete data from the table: "n_package" */
  delete_n_package?: Maybe<App_Loader_N_Package_Mutation_Response>;
  /** delete single row from the table: "n_package" */
  delete_n_package_by_pk?: Maybe<App_Loader_N_Package>;
  /** delete data from the table: "n_pype_package_configuration" */
  delete_n_pype_package_configuration?: Maybe<App_Loader_N_Pype_Package_Configuration_Mutation_Response>;
  /** delete single row from the table: "n_pype_package_configuration" */
  delete_n_pype_package_configuration_by_pk?: Maybe<App_Loader_N_Pype_Package_Configuration>;
  /** delete data from the table: "target" */
  delete_target?: Maybe<App_Loader_Target_Mutation_Response>;
  /** delete single row from the table: "target" */
  delete_target_by_pk?: Maybe<App_Loader_Target>;
  /** delete data from the table: "target_type" */
  delete_target_type?: Maybe<App_Loader_Target_Type_Mutation_Response>;
  /** delete single row from the table: "target_type" */
  delete_target_type_by_pk?: Maybe<App_Loader_Target_Type>;
  /** insert data into the table: "app" */
  insert_app?: Maybe<App_Loader_App_Mutation_Response>;
  /** insert a single row into the table: "app" */
  insert_app_one?: Maybe<App_Loader_App>;
  /** insert data into the table: "conditions" */
  insert_conditions?: Maybe<App_Loader_Conditions_Mutation_Response>;
  /** insert a single row into the table: "conditions" */
  insert_conditions_one?: Maybe<App_Loader_Conditions>;
  /** insert data into the table: "customer" */
  insert_customer?: Maybe<App_Loader_Customer_Mutation_Response>;
  /** insert a single row into the table: "customer" */
  insert_customer_one?: Maybe<App_Loader_Customer>;
  /** insert data into the table: "deployment" */
  insert_deployment?: Maybe<App_Loader_Deployment_Mutation_Response>;
  /** insert a single row into the table: "deployment" */
  insert_deployment_one?: Maybe<App_Loader_Deployment>;
  /** insert data into the table: "environment" */
  insert_environment?: Maybe<App_Loader_Environment_Mutation_Response>;
  /** insert a single row into the table: "environment" */
  insert_environment_one?: Maybe<App_Loader_Environment>;
  /** insert data into the table: "latest_schema.anonymous_session" */
  insert_latest_schema_anonymous_session?: Maybe<App_Loader_Latest_Schema_Anonymous_Session_Mutation_Response>;
  /** insert a single row into the table: "latest_schema.anonymous_session" */
  insert_latest_schema_anonymous_session_one?: Maybe<App_Loader_Latest_Schema_Anonymous_Session>;
  /** insert data into the table: "latest_schema.packages" */
  insert_latest_schema_packages?: Maybe<App_Loader_Latest_Schema_Packages_Mutation_Response>;
  /** insert a single row into the table: "latest_schema.packages" */
  insert_latest_schema_packages_one?: Maybe<App_Loader_Latest_Schema_Packages>;
  /** insert data into the table: "latest_schema.packages_type" */
  insert_latest_schema_packages_type?: Maybe<App_Loader_Latest_Schema_Packages_Type_Mutation_Response>;
  /** insert a single row into the table: "latest_schema.packages_type" */
  insert_latest_schema_packages_type_one?: Maybe<App_Loader_Latest_Schema_Packages_Type>;
  /** insert data into the table: "metadata.analytics" */
  insert_metadata_analytics?: Maybe<App_Loader_Metadata_Analytics_Mutation_Response>;
  /** insert a single row into the table: "metadata.analytics" */
  insert_metadata_analytics_one?: Maybe<App_Loader_Metadata_Analytics>;
  /** insert data into the table: "metadata.cc_position_option" */
  insert_metadata_cc_position_option?: Maybe<App_Loader_Metadata_Cc_Position_Option_Mutation_Response>;
  /** insert a single row into the table: "metadata.cc_position_option" */
  insert_metadata_cc_position_option_one?: Maybe<App_Loader_Metadata_Cc_Position_Option>;
  /** insert data into the table: "metadata.cc_widget" */
  insert_metadata_cc_widget?: Maybe<App_Loader_Metadata_Cc_Widget_Mutation_Response>;
  /** insert data into the table: "metadata.cc_widget_bubble_type" */
  insert_metadata_cc_widget_bubble_type?: Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Mutation_Response>;
  /** insert a single row into the table: "metadata.cc_widget_bubble_type" */
  insert_metadata_cc_widget_bubble_type_one?: Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type>;
  /** insert a single row into the table: "metadata.cc_widget" */
  insert_metadata_cc_widget_one?: Maybe<App_Loader_Metadata_Cc_Widget>;
  /** insert data into the table: "metadata.generic" */
  insert_metadata_generic?: Maybe<App_Loader_Metadata_Generic_Mutation_Response>;
  /** insert data into the table: "metadata.generic_module_type" */
  insert_metadata_generic_module_type?: Maybe<App_Loader_Metadata_Generic_Module_Type_Mutation_Response>;
  /** insert a single row into the table: "metadata.generic_module_type" */
  insert_metadata_generic_module_type_one?: Maybe<App_Loader_Metadata_Generic_Module_Type>;
  /** insert a single row into the table: "metadata.generic" */
  insert_metadata_generic_one?: Maybe<App_Loader_Metadata_Generic>;
  /** insert data into the table: "metadata.pype" */
  insert_metadata_pype?: Maybe<App_Loader_Metadata_Pype_Mutation_Response>;
  /** insert a single row into the table: "metadata.pype" */
  insert_metadata_pype_one?: Maybe<App_Loader_Metadata_Pype>;
  /** insert data into the table: "metadata.pype_type" */
  insert_metadata_pype_type?: Maybe<App_Loader_Metadata_Pype_Type_Mutation_Response>;
  /** insert a single row into the table: "metadata.pype_type" */
  insert_metadata_pype_type_one?: Maybe<App_Loader_Metadata_Pype_Type>;
  /** insert data into the table: "n_analytic_package_configuration" */
  insert_n_analytic_package_configuration?: Maybe<App_Loader_N_Analytic_Package_Configuration_Mutation_Response>;
  /** insert a single row into the table: "n_analytic_package_configuration" */
  insert_n_analytic_package_configuration_one?: Maybe<App_Loader_N_Analytic_Package_Configuration>;
  /** insert data into the table: "n_application" */
  insert_n_application?: Maybe<App_Loader_N_Application_Mutation_Response>;
  /** insert a single row into the table: "n_application" */
  insert_n_application_one?: Maybe<App_Loader_N_Application>;
  /** insert data into the table: "n_domain" */
  insert_n_domain?: Maybe<App_Loader_N_Domain_Mutation_Response>;
  /** insert a single row into the table: "n_domain" */
  insert_n_domain_one?: Maybe<App_Loader_N_Domain>;
  /** insert data into the table: "n_package" */
  insert_n_package?: Maybe<App_Loader_N_Package_Mutation_Response>;
  /** insert a single row into the table: "n_package" */
  insert_n_package_one?: Maybe<App_Loader_N_Package>;
  /** insert data into the table: "n_pype_package_configuration" */
  insert_n_pype_package_configuration?: Maybe<App_Loader_N_Pype_Package_Configuration_Mutation_Response>;
  /** insert a single row into the table: "n_pype_package_configuration" */
  insert_n_pype_package_configuration_one?: Maybe<App_Loader_N_Pype_Package_Configuration>;
  /** insert data into the table: "target" */
  insert_target?: Maybe<App_Loader_Target_Mutation_Response>;
  /** insert a single row into the table: "target" */
  insert_target_one?: Maybe<App_Loader_Target>;
  /** insert data into the table: "target_type" */
  insert_target_type?: Maybe<App_Loader_Target_Type_Mutation_Response>;
  /** insert a single row into the table: "target_type" */
  insert_target_type_one?: Maybe<App_Loader_Target_Type>;
  /** update data of the table: "app" */
  update_app?: Maybe<App_Loader_App_Mutation_Response>;
  /** update single row of the table: "app" */
  update_app_by_pk?: Maybe<App_Loader_App>;
  /** update multiples rows of table: "app" */
  update_app_many?: Maybe<Array<Maybe<App_Loader_App_Mutation_Response>>>;
  /** update data of the table: "conditions" */
  update_conditions?: Maybe<App_Loader_Conditions_Mutation_Response>;
  /** update single row of the table: "conditions" */
  update_conditions_by_pk?: Maybe<App_Loader_Conditions>;
  /** update multiples rows of table: "conditions" */
  update_conditions_many?: Maybe<Array<Maybe<App_Loader_Conditions_Mutation_Response>>>;
  /** update data of the table: "customer" */
  update_customer?: Maybe<App_Loader_Customer_Mutation_Response>;
  /** update single row of the table: "customer" */
  update_customer_by_pk?: Maybe<App_Loader_Customer>;
  /** update multiples rows of table: "customer" */
  update_customer_many?: Maybe<Array<Maybe<App_Loader_Customer_Mutation_Response>>>;
  /** update data of the table: "deployment" */
  update_deployment?: Maybe<App_Loader_Deployment_Mutation_Response>;
  /** update single row of the table: "deployment" */
  update_deployment_by_pk?: Maybe<App_Loader_Deployment>;
  /** update multiples rows of table: "deployment" */
  update_deployment_many?: Maybe<Array<Maybe<App_Loader_Deployment_Mutation_Response>>>;
  /** update data of the table: "environment" */
  update_environment?: Maybe<App_Loader_Environment_Mutation_Response>;
  /** update single row of the table: "environment" */
  update_environment_by_pk?: Maybe<App_Loader_Environment>;
  /** update multiples rows of table: "environment" */
  update_environment_many?: Maybe<Array<Maybe<App_Loader_Environment_Mutation_Response>>>;
  /** update data of the table: "latest_schema.anonymous_session" */
  update_latest_schema_anonymous_session?: Maybe<App_Loader_Latest_Schema_Anonymous_Session_Mutation_Response>;
  /** update single row of the table: "latest_schema.anonymous_session" */
  update_latest_schema_anonymous_session_by_pk?: Maybe<App_Loader_Latest_Schema_Anonymous_Session>;
  /** update multiples rows of table: "latest_schema.anonymous_session" */
  update_latest_schema_anonymous_session_many?: Maybe<Array<Maybe<App_Loader_Latest_Schema_Anonymous_Session_Mutation_Response>>>;
  /** update data of the table: "latest_schema.packages" */
  update_latest_schema_packages?: Maybe<App_Loader_Latest_Schema_Packages_Mutation_Response>;
  /** update single row of the table: "latest_schema.packages" */
  update_latest_schema_packages_by_pk?: Maybe<App_Loader_Latest_Schema_Packages>;
  /** update multiples rows of table: "latest_schema.packages" */
  update_latest_schema_packages_many?: Maybe<Array<Maybe<App_Loader_Latest_Schema_Packages_Mutation_Response>>>;
  /** update data of the table: "latest_schema.packages_type" */
  update_latest_schema_packages_type?: Maybe<App_Loader_Latest_Schema_Packages_Type_Mutation_Response>;
  /** update single row of the table: "latest_schema.packages_type" */
  update_latest_schema_packages_type_by_pk?: Maybe<App_Loader_Latest_Schema_Packages_Type>;
  /** update multiples rows of table: "latest_schema.packages_type" */
  update_latest_schema_packages_type_many?: Maybe<Array<Maybe<App_Loader_Latest_Schema_Packages_Type_Mutation_Response>>>;
  /** update data of the table: "metadata.analytics" */
  update_metadata_analytics?: Maybe<App_Loader_Metadata_Analytics_Mutation_Response>;
  /** update single row of the table: "metadata.analytics" */
  update_metadata_analytics_by_pk?: Maybe<App_Loader_Metadata_Analytics>;
  /** update multiples rows of table: "metadata.analytics" */
  update_metadata_analytics_many?: Maybe<Array<Maybe<App_Loader_Metadata_Analytics_Mutation_Response>>>;
  /** update data of the table: "metadata.cc_position_option" */
  update_metadata_cc_position_option?: Maybe<App_Loader_Metadata_Cc_Position_Option_Mutation_Response>;
  /** update single row of the table: "metadata.cc_position_option" */
  update_metadata_cc_position_option_by_pk?: Maybe<App_Loader_Metadata_Cc_Position_Option>;
  /** update multiples rows of table: "metadata.cc_position_option" */
  update_metadata_cc_position_option_many?: Maybe<Array<Maybe<App_Loader_Metadata_Cc_Position_Option_Mutation_Response>>>;
  /** update data of the table: "metadata.cc_widget" */
  update_metadata_cc_widget?: Maybe<App_Loader_Metadata_Cc_Widget_Mutation_Response>;
  /** update data of the table: "metadata.cc_widget_bubble_type" */
  update_metadata_cc_widget_bubble_type?: Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Mutation_Response>;
  /** update single row of the table: "metadata.cc_widget_bubble_type" */
  update_metadata_cc_widget_bubble_type_by_pk?: Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type>;
  /** update multiples rows of table: "metadata.cc_widget_bubble_type" */
  update_metadata_cc_widget_bubble_type_many?: Maybe<Array<Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Mutation_Response>>>;
  /** update single row of the table: "metadata.cc_widget" */
  update_metadata_cc_widget_by_pk?: Maybe<App_Loader_Metadata_Cc_Widget>;
  /** update multiples rows of table: "metadata.cc_widget" */
  update_metadata_cc_widget_many?: Maybe<Array<Maybe<App_Loader_Metadata_Cc_Widget_Mutation_Response>>>;
  /** update data of the table: "metadata.generic" */
  update_metadata_generic?: Maybe<App_Loader_Metadata_Generic_Mutation_Response>;
  /** update single row of the table: "metadata.generic" */
  update_metadata_generic_by_pk?: Maybe<App_Loader_Metadata_Generic>;
  /** update multiples rows of table: "metadata.generic" */
  update_metadata_generic_many?: Maybe<Array<Maybe<App_Loader_Metadata_Generic_Mutation_Response>>>;
  /** update data of the table: "metadata.generic_module_type" */
  update_metadata_generic_module_type?: Maybe<App_Loader_Metadata_Generic_Module_Type_Mutation_Response>;
  /** update single row of the table: "metadata.generic_module_type" */
  update_metadata_generic_module_type_by_pk?: Maybe<App_Loader_Metadata_Generic_Module_Type>;
  /** update multiples rows of table: "metadata.generic_module_type" */
  update_metadata_generic_module_type_many?: Maybe<Array<Maybe<App_Loader_Metadata_Generic_Module_Type_Mutation_Response>>>;
  /** update data of the table: "metadata.pype" */
  update_metadata_pype?: Maybe<App_Loader_Metadata_Pype_Mutation_Response>;
  /** update single row of the table: "metadata.pype" */
  update_metadata_pype_by_pk?: Maybe<App_Loader_Metadata_Pype>;
  /** update multiples rows of table: "metadata.pype" */
  update_metadata_pype_many?: Maybe<Array<Maybe<App_Loader_Metadata_Pype_Mutation_Response>>>;
  /** update data of the table: "metadata.pype_type" */
  update_metadata_pype_type?: Maybe<App_Loader_Metadata_Pype_Type_Mutation_Response>;
  /** update single row of the table: "metadata.pype_type" */
  update_metadata_pype_type_by_pk?: Maybe<App_Loader_Metadata_Pype_Type>;
  /** update multiples rows of table: "metadata.pype_type" */
  update_metadata_pype_type_many?: Maybe<Array<Maybe<App_Loader_Metadata_Pype_Type_Mutation_Response>>>;
  /** update data of the table: "n_analytic_package_configuration" */
  update_n_analytic_package_configuration?: Maybe<App_Loader_N_Analytic_Package_Configuration_Mutation_Response>;
  /** update single row of the table: "n_analytic_package_configuration" */
  update_n_analytic_package_configuration_by_pk?: Maybe<App_Loader_N_Analytic_Package_Configuration>;
  /** update multiples rows of table: "n_analytic_package_configuration" */
  update_n_analytic_package_configuration_many?: Maybe<Array<Maybe<App_Loader_N_Analytic_Package_Configuration_Mutation_Response>>>;
  /** update data of the table: "n_application" */
  update_n_application?: Maybe<App_Loader_N_Application_Mutation_Response>;
  /** update single row of the table: "n_application" */
  update_n_application_by_pk?: Maybe<App_Loader_N_Application>;
  /** update multiples rows of table: "n_application" */
  update_n_application_many?: Maybe<Array<Maybe<App_Loader_N_Application_Mutation_Response>>>;
  /** update data of the table: "n_domain" */
  update_n_domain?: Maybe<App_Loader_N_Domain_Mutation_Response>;
  /** update single row of the table: "n_domain" */
  update_n_domain_by_pk?: Maybe<App_Loader_N_Domain>;
  /** update multiples rows of table: "n_domain" */
  update_n_domain_many?: Maybe<Array<Maybe<App_Loader_N_Domain_Mutation_Response>>>;
  /** update data of the table: "n_package" */
  update_n_package?: Maybe<App_Loader_N_Package_Mutation_Response>;
  /** update single row of the table: "n_package" */
  update_n_package_by_pk?: Maybe<App_Loader_N_Package>;
  /** update multiples rows of table: "n_package" */
  update_n_package_many?: Maybe<Array<Maybe<App_Loader_N_Package_Mutation_Response>>>;
  /** update data of the table: "n_pype_package_configuration" */
  update_n_pype_package_configuration?: Maybe<App_Loader_N_Pype_Package_Configuration_Mutation_Response>;
  /** update single row of the table: "n_pype_package_configuration" */
  update_n_pype_package_configuration_by_pk?: Maybe<App_Loader_N_Pype_Package_Configuration>;
  /** update multiples rows of table: "n_pype_package_configuration" */
  update_n_pype_package_configuration_many?: Maybe<Array<Maybe<App_Loader_N_Pype_Package_Configuration_Mutation_Response>>>;
  /** update data of the table: "target" */
  update_target?: Maybe<App_Loader_Target_Mutation_Response>;
  /** update single row of the table: "target" */
  update_target_by_pk?: Maybe<App_Loader_Target>;
  /** update multiples rows of table: "target" */
  update_target_many?: Maybe<Array<Maybe<App_Loader_Target_Mutation_Response>>>;
  /** update data of the table: "target_type" */
  update_target_type?: Maybe<App_Loader_Target_Type_Mutation_Response>;
  /** update single row of the table: "target_type" */
  update_target_type_by_pk?: Maybe<App_Loader_Target_Type>;
  /** update multiples rows of table: "target_type" */
  update_target_type_many?: Maybe<Array<Maybe<App_Loader_Target_Type_Mutation_Response>>>;
};


export type App_Loader_Mutation_RootDelete_AppArgs = {
  where: App_Loader_App_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_App_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Mutation_RootDelete_ConditionsArgs = {
  where: App_Loader_Conditions_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Conditions_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Mutation_RootDelete_CustomerArgs = {
  where: App_Loader_Customer_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Customer_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Mutation_RootDelete_DeploymentArgs = {
  where: App_Loader_Deployment_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Deployment_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Mutation_RootDelete_EnvironmentArgs = {
  where: App_Loader_Environment_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Environment_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Mutation_RootDelete_Latest_Schema_Anonymous_SessionArgs = {
  where: App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Latest_Schema_Anonymous_Session_By_PkArgs = {
  session_id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Mutation_RootDelete_Latest_Schema_PackagesArgs = {
  where: App_Loader_Latest_Schema_Packages_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Latest_Schema_Packages_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type App_Loader_Mutation_RootDelete_Latest_Schema_Packages_TypeArgs = {
  where: App_Loader_Latest_Schema_Packages_Type_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Latest_Schema_Packages_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type App_Loader_Mutation_RootDelete_Metadata_AnalyticsArgs = {
  where: App_Loader_Metadata_Analytics_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Metadata_Analytics_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Mutation_RootDelete_Metadata_Cc_Position_OptionArgs = {
  where: App_Loader_Metadata_Cc_Position_Option_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Metadata_Cc_Position_Option_By_PkArgs = {
  position: Scalars['String']['input'];
};


export type App_Loader_Mutation_RootDelete_Metadata_Cc_WidgetArgs = {
  where: App_Loader_Metadata_Cc_Widget_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Metadata_Cc_Widget_Bubble_TypeArgs = {
  where: App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Metadata_Cc_Widget_Bubble_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type App_Loader_Mutation_RootDelete_Metadata_Cc_Widget_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Mutation_RootDelete_Metadata_GenericArgs = {
  where: App_Loader_Metadata_Generic_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Metadata_Generic_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Mutation_RootDelete_Metadata_Generic_Module_TypeArgs = {
  where: App_Loader_Metadata_Generic_Module_Type_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Metadata_Generic_Module_Type_By_PkArgs = {
  moduleType: Scalars['String']['input'];
};


export type App_Loader_Mutation_RootDelete_Metadata_PypeArgs = {
  where: App_Loader_Metadata_Pype_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Metadata_Pype_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Mutation_RootDelete_Metadata_Pype_TypeArgs = {
  where: App_Loader_Metadata_Pype_Type_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Metadata_Pype_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type App_Loader_Mutation_RootDelete_N_Analytic_Package_ConfigurationArgs = {
  where: App_Loader_N_Analytic_Package_Configuration_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_N_Analytic_Package_Configuration_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Mutation_RootDelete_N_ApplicationArgs = {
  where: App_Loader_N_Application_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_N_Application_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Mutation_RootDelete_N_DomainArgs = {
  where: App_Loader_N_Domain_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_N_Domain_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Mutation_RootDelete_N_PackageArgs = {
  where: App_Loader_N_Package_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_N_Package_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Mutation_RootDelete_N_Pype_Package_ConfigurationArgs = {
  where: App_Loader_N_Pype_Package_Configuration_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_N_Pype_Package_Configuration_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Mutation_RootDelete_TargetArgs = {
  where: App_Loader_Target_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Target_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Mutation_RootDelete_Target_TypeArgs = {
  where: App_Loader_Target_Type_Bool_Exp;
};


export type App_Loader_Mutation_RootDelete_Target_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type App_Loader_Mutation_RootInsert_AppArgs = {
  objects: Array<App_Loader_App_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_App_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_App_OneArgs = {
  object: App_Loader_App_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_App_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_ConditionsArgs = {
  objects: Array<App_Loader_Conditions_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Conditions_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Conditions_OneArgs = {
  object: App_Loader_Conditions_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Conditions_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_CustomerArgs = {
  objects: Array<App_Loader_Customer_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Customer_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Customer_OneArgs = {
  object: App_Loader_Customer_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Customer_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_DeploymentArgs = {
  objects: Array<App_Loader_Deployment_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Deployment_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Deployment_OneArgs = {
  object: App_Loader_Deployment_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Deployment_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_EnvironmentArgs = {
  objects: Array<App_Loader_Environment_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Environment_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Environment_OneArgs = {
  object: App_Loader_Environment_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Environment_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Latest_Schema_Anonymous_SessionArgs = {
  objects: Array<App_Loader_Latest_Schema_Anonymous_Session_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Latest_Schema_Anonymous_Session_OneArgs = {
  object: App_Loader_Latest_Schema_Anonymous_Session_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Latest_Schema_PackagesArgs = {
  objects: Array<App_Loader_Latest_Schema_Packages_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Latest_Schema_Packages_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Latest_Schema_Packages_OneArgs = {
  object: App_Loader_Latest_Schema_Packages_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Latest_Schema_Packages_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Latest_Schema_Packages_TypeArgs = {
  objects: Array<App_Loader_Latest_Schema_Packages_Type_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Latest_Schema_Packages_Type_OneArgs = {
  object: App_Loader_Latest_Schema_Packages_Type_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_AnalyticsArgs = {
  objects: Array<App_Loader_Metadata_Analytics_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Metadata_Analytics_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Analytics_OneArgs = {
  object: App_Loader_Metadata_Analytics_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Metadata_Analytics_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Cc_Position_OptionArgs = {
  objects: Array<App_Loader_Metadata_Cc_Position_Option_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Cc_Position_Option_OneArgs = {
  object: App_Loader_Metadata_Cc_Position_Option_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Cc_WidgetArgs = {
  objects: Array<App_Loader_Metadata_Cc_Widget_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Metadata_Cc_Widget_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Cc_Widget_Bubble_TypeArgs = {
  objects: Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Cc_Widget_Bubble_Type_OneArgs = {
  object: App_Loader_Metadata_Cc_Widget_Bubble_Type_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Cc_Widget_OneArgs = {
  object: App_Loader_Metadata_Cc_Widget_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Metadata_Cc_Widget_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_GenericArgs = {
  objects: Array<App_Loader_Metadata_Generic_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Metadata_Generic_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Generic_Module_TypeArgs = {
  objects: Array<App_Loader_Metadata_Generic_Module_Type_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Generic_Module_Type_OneArgs = {
  object: App_Loader_Metadata_Generic_Module_Type_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Generic_OneArgs = {
  object: App_Loader_Metadata_Generic_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Metadata_Generic_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_PypeArgs = {
  objects: Array<App_Loader_Metadata_Pype_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Metadata_Pype_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Pype_OneArgs = {
  object: App_Loader_Metadata_Pype_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Metadata_Pype_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Pype_TypeArgs = {
  objects: Array<App_Loader_Metadata_Pype_Type_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Metadata_Pype_Type_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Metadata_Pype_Type_OneArgs = {
  object: App_Loader_Metadata_Pype_Type_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Metadata_Pype_Type_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_N_Analytic_Package_ConfigurationArgs = {
  objects: Array<App_Loader_N_Analytic_Package_Configuration_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_N_Analytic_Package_Configuration_OneArgs = {
  object: App_Loader_N_Analytic_Package_Configuration_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_N_ApplicationArgs = {
  objects: Array<App_Loader_N_Application_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_N_Application_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_N_Application_OneArgs = {
  object: App_Loader_N_Application_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_N_Application_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_N_DomainArgs = {
  objects: Array<App_Loader_N_Domain_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_N_Domain_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_N_Domain_OneArgs = {
  object: App_Loader_N_Domain_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_N_Domain_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_N_PackageArgs = {
  objects: Array<App_Loader_N_Package_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_N_Package_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_N_Package_OneArgs = {
  object: App_Loader_N_Package_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_N_Package_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_N_Pype_Package_ConfigurationArgs = {
  objects: Array<App_Loader_N_Pype_Package_Configuration_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_N_Pype_Package_Configuration_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_N_Pype_Package_Configuration_OneArgs = {
  object: App_Loader_N_Pype_Package_Configuration_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_N_Pype_Package_Configuration_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_TargetArgs = {
  objects: Array<App_Loader_Target_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Target_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Target_OneArgs = {
  object: App_Loader_Target_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Target_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Target_TypeArgs = {
  objects: Array<App_Loader_Target_Type_Insert_Input>;
  on_conflict?: InputMaybe<App_Loader_Target_Type_On_Conflict>;
};


export type App_Loader_Mutation_RootInsert_Target_Type_OneArgs = {
  object: App_Loader_Target_Type_Insert_Input;
  on_conflict?: InputMaybe<App_Loader_Target_Type_On_Conflict>;
};


export type App_Loader_Mutation_RootUpdate_AppArgs = {
  _set?: InputMaybe<App_Loader_App_Set_Input>;
  where: App_Loader_App_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_App_By_PkArgs = {
  _set?: InputMaybe<App_Loader_App_Set_Input>;
  pk_columns: App_Loader_App_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_App_ManyArgs = {
  updates: Array<App_Loader_App_Updates>;
};


export type App_Loader_Mutation_RootUpdate_ConditionsArgs = {
  _append?: InputMaybe<App_Loader_Conditions_Append_Input>;
  _delete_at_path?: InputMaybe<App_Loader_Conditions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<App_Loader_Conditions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<App_Loader_Conditions_Delete_Key_Input>;
  _prepend?: InputMaybe<App_Loader_Conditions_Prepend_Input>;
  _set?: InputMaybe<App_Loader_Conditions_Set_Input>;
  where: App_Loader_Conditions_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Conditions_By_PkArgs = {
  _append?: InputMaybe<App_Loader_Conditions_Append_Input>;
  _delete_at_path?: InputMaybe<App_Loader_Conditions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<App_Loader_Conditions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<App_Loader_Conditions_Delete_Key_Input>;
  _prepend?: InputMaybe<App_Loader_Conditions_Prepend_Input>;
  _set?: InputMaybe<App_Loader_Conditions_Set_Input>;
  pk_columns: App_Loader_Conditions_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Conditions_ManyArgs = {
  updates: Array<App_Loader_Conditions_Updates>;
};


export type App_Loader_Mutation_RootUpdate_CustomerArgs = {
  _set?: InputMaybe<App_Loader_Customer_Set_Input>;
  where: App_Loader_Customer_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Customer_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Customer_Set_Input>;
  pk_columns: App_Loader_Customer_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Customer_ManyArgs = {
  updates: Array<App_Loader_Customer_Updates>;
};


export type App_Loader_Mutation_RootUpdate_DeploymentArgs = {
  _set?: InputMaybe<App_Loader_Deployment_Set_Input>;
  where: App_Loader_Deployment_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Deployment_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Deployment_Set_Input>;
  pk_columns: App_Loader_Deployment_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Deployment_ManyArgs = {
  updates: Array<App_Loader_Deployment_Updates>;
};


export type App_Loader_Mutation_RootUpdate_EnvironmentArgs = {
  _set?: InputMaybe<App_Loader_Environment_Set_Input>;
  where: App_Loader_Environment_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Environment_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Environment_Set_Input>;
  pk_columns: App_Loader_Environment_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Environment_ManyArgs = {
  updates: Array<App_Loader_Environment_Updates>;
};


export type App_Loader_Mutation_RootUpdate_Latest_Schema_Anonymous_SessionArgs = {
  _append?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Append_Input>;
  _delete_at_path?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Delete_Elem_Input>;
  _delete_key?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Delete_Key_Input>;
  _prepend?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Prepend_Input>;
  _set?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Set_Input>;
  where: App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Latest_Schema_Anonymous_Session_By_PkArgs = {
  _append?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Append_Input>;
  _delete_at_path?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Delete_Elem_Input>;
  _delete_key?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Delete_Key_Input>;
  _prepend?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Prepend_Input>;
  _set?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Set_Input>;
  pk_columns: App_Loader_Latest_Schema_Anonymous_Session_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Latest_Schema_Anonymous_Session_ManyArgs = {
  updates: Array<App_Loader_Latest_Schema_Anonymous_Session_Updates>;
};


export type App_Loader_Mutation_RootUpdate_Latest_Schema_PackagesArgs = {
  _append?: InputMaybe<App_Loader_Latest_Schema_Packages_Append_Input>;
  _delete_at_path?: InputMaybe<App_Loader_Latest_Schema_Packages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<App_Loader_Latest_Schema_Packages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<App_Loader_Latest_Schema_Packages_Delete_Key_Input>;
  _prepend?: InputMaybe<App_Loader_Latest_Schema_Packages_Prepend_Input>;
  _set?: InputMaybe<App_Loader_Latest_Schema_Packages_Set_Input>;
  where: App_Loader_Latest_Schema_Packages_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Latest_Schema_Packages_By_PkArgs = {
  _append?: InputMaybe<App_Loader_Latest_Schema_Packages_Append_Input>;
  _delete_at_path?: InputMaybe<App_Loader_Latest_Schema_Packages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<App_Loader_Latest_Schema_Packages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<App_Loader_Latest_Schema_Packages_Delete_Key_Input>;
  _prepend?: InputMaybe<App_Loader_Latest_Schema_Packages_Prepend_Input>;
  _set?: InputMaybe<App_Loader_Latest_Schema_Packages_Set_Input>;
  pk_columns: App_Loader_Latest_Schema_Packages_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Latest_Schema_Packages_ManyArgs = {
  updates: Array<App_Loader_Latest_Schema_Packages_Updates>;
};


export type App_Loader_Mutation_RootUpdate_Latest_Schema_Packages_TypeArgs = {
  _set?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Set_Input>;
  where: App_Loader_Latest_Schema_Packages_Type_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Latest_Schema_Packages_Type_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Set_Input>;
  pk_columns: App_Loader_Latest_Schema_Packages_Type_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Latest_Schema_Packages_Type_ManyArgs = {
  updates: Array<App_Loader_Latest_Schema_Packages_Type_Updates>;
};


export type App_Loader_Mutation_RootUpdate_Metadata_AnalyticsArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Analytics_Set_Input>;
  where: App_Loader_Metadata_Analytics_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Analytics_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Analytics_Set_Input>;
  pk_columns: App_Loader_Metadata_Analytics_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Analytics_ManyArgs = {
  updates: Array<App_Loader_Metadata_Analytics_Updates>;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Cc_Position_OptionArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Set_Input>;
  where: App_Loader_Metadata_Cc_Position_Option_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Cc_Position_Option_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Set_Input>;
  pk_columns: App_Loader_Metadata_Cc_Position_Option_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Cc_Position_Option_ManyArgs = {
  updates: Array<App_Loader_Metadata_Cc_Position_Option_Updates>;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Cc_WidgetArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Cc_Widget_Set_Input>;
  where: App_Loader_Metadata_Cc_Widget_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Cc_Widget_Bubble_TypeArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Set_Input>;
  where: App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Cc_Widget_Bubble_Type_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Set_Input>;
  pk_columns: App_Loader_Metadata_Cc_Widget_Bubble_Type_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Cc_Widget_Bubble_Type_ManyArgs = {
  updates: Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Updates>;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Cc_Widget_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Cc_Widget_Set_Input>;
  pk_columns: App_Loader_Metadata_Cc_Widget_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Cc_Widget_ManyArgs = {
  updates: Array<App_Loader_Metadata_Cc_Widget_Updates>;
};


export type App_Loader_Mutation_RootUpdate_Metadata_GenericArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Generic_Set_Input>;
  where: App_Loader_Metadata_Generic_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Generic_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Generic_Set_Input>;
  pk_columns: App_Loader_Metadata_Generic_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Generic_ManyArgs = {
  updates: Array<App_Loader_Metadata_Generic_Updates>;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Generic_Module_TypeArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Set_Input>;
  where: App_Loader_Metadata_Generic_Module_Type_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Generic_Module_Type_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Set_Input>;
  pk_columns: App_Loader_Metadata_Generic_Module_Type_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Generic_Module_Type_ManyArgs = {
  updates: Array<App_Loader_Metadata_Generic_Module_Type_Updates>;
};


export type App_Loader_Mutation_RootUpdate_Metadata_PypeArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Pype_Set_Input>;
  where: App_Loader_Metadata_Pype_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Pype_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Pype_Set_Input>;
  pk_columns: App_Loader_Metadata_Pype_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Pype_ManyArgs = {
  updates: Array<App_Loader_Metadata_Pype_Updates>;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Pype_TypeArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Pype_Type_Set_Input>;
  where: App_Loader_Metadata_Pype_Type_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Pype_Type_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Metadata_Pype_Type_Set_Input>;
  pk_columns: App_Loader_Metadata_Pype_Type_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Metadata_Pype_Type_ManyArgs = {
  updates: Array<App_Loader_Metadata_Pype_Type_Updates>;
};


export type App_Loader_Mutation_RootUpdate_N_Analytic_Package_ConfigurationArgs = {
  _inc?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Inc_Input>;
  _set?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Set_Input>;
  where: App_Loader_N_Analytic_Package_Configuration_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_N_Analytic_Package_Configuration_By_PkArgs = {
  _inc?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Inc_Input>;
  _set?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Set_Input>;
  pk_columns: App_Loader_N_Analytic_Package_Configuration_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_N_Analytic_Package_Configuration_ManyArgs = {
  updates: Array<App_Loader_N_Analytic_Package_Configuration_Updates>;
};


export type App_Loader_Mutation_RootUpdate_N_ApplicationArgs = {
  _inc?: InputMaybe<App_Loader_N_Application_Inc_Input>;
  _set?: InputMaybe<App_Loader_N_Application_Set_Input>;
  where: App_Loader_N_Application_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_N_Application_By_PkArgs = {
  _inc?: InputMaybe<App_Loader_N_Application_Inc_Input>;
  _set?: InputMaybe<App_Loader_N_Application_Set_Input>;
  pk_columns: App_Loader_N_Application_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_N_Application_ManyArgs = {
  updates: Array<App_Loader_N_Application_Updates>;
};


export type App_Loader_Mutation_RootUpdate_N_DomainArgs = {
  _inc?: InputMaybe<App_Loader_N_Domain_Inc_Input>;
  _set?: InputMaybe<App_Loader_N_Domain_Set_Input>;
  where: App_Loader_N_Domain_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_N_Domain_By_PkArgs = {
  _inc?: InputMaybe<App_Loader_N_Domain_Inc_Input>;
  _set?: InputMaybe<App_Loader_N_Domain_Set_Input>;
  pk_columns: App_Loader_N_Domain_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_N_Domain_ManyArgs = {
  updates: Array<App_Loader_N_Domain_Updates>;
};


export type App_Loader_Mutation_RootUpdate_N_PackageArgs = {
  _inc?: InputMaybe<App_Loader_N_Package_Inc_Input>;
  _set?: InputMaybe<App_Loader_N_Package_Set_Input>;
  where: App_Loader_N_Package_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_N_Package_By_PkArgs = {
  _inc?: InputMaybe<App_Loader_N_Package_Inc_Input>;
  _set?: InputMaybe<App_Loader_N_Package_Set_Input>;
  pk_columns: App_Loader_N_Package_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_N_Package_ManyArgs = {
  updates: Array<App_Loader_N_Package_Updates>;
};


export type App_Loader_Mutation_RootUpdate_N_Pype_Package_ConfigurationArgs = {
  _inc?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Inc_Input>;
  _set?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Set_Input>;
  where: App_Loader_N_Pype_Package_Configuration_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_N_Pype_Package_Configuration_By_PkArgs = {
  _inc?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Inc_Input>;
  _set?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Set_Input>;
  pk_columns: App_Loader_N_Pype_Package_Configuration_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_N_Pype_Package_Configuration_ManyArgs = {
  updates: Array<App_Loader_N_Pype_Package_Configuration_Updates>;
};


export type App_Loader_Mutation_RootUpdate_TargetArgs = {
  _set?: InputMaybe<App_Loader_Target_Set_Input>;
  where: App_Loader_Target_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Target_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Target_Set_Input>;
  pk_columns: App_Loader_Target_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Target_ManyArgs = {
  updates: Array<App_Loader_Target_Updates>;
};


export type App_Loader_Mutation_RootUpdate_Target_TypeArgs = {
  _set?: InputMaybe<App_Loader_Target_Type_Set_Input>;
  where: App_Loader_Target_Type_Bool_Exp;
};


export type App_Loader_Mutation_RootUpdate_Target_Type_By_PkArgs = {
  _set?: InputMaybe<App_Loader_Target_Type_Set_Input>;
  pk_columns: App_Loader_Target_Type_Pk_Columns_Input;
};


export type App_Loader_Mutation_RootUpdate_Target_Type_ManyArgs = {
  updates: Array<App_Loader_Target_Type_Updates>;
};

/** columns and relationships of "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_Configuration = {
  __typename?: 'app_loader_n_analytic_package_configuration';
  id: Scalars['Int']['output'];
  /** An array relationship */
  n_packages: Array<App_Loader_N_Package>;
  /** An aggregate relationship */
  n_packages_aggregate: App_Loader_N_Package_Aggregate;
  ph_instance_address: Scalars['String']['output'];
  ph_project_api_key: Scalars['String']['output'];
};


/** columns and relationships of "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_ConfigurationN_PackagesArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Package_Order_By>>;
  where?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
};


/** columns and relationships of "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_ConfigurationN_Packages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Package_Order_By>>;
  where?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
};

/** aggregated selection of "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_Configuration_Aggregate = {
  __typename?: 'app_loader_n_analytic_package_configuration_aggregate';
  aggregate?: Maybe<App_Loader_N_Analytic_Package_Configuration_Aggregate_Fields>;
  nodes: Array<App_Loader_N_Analytic_Package_Configuration>;
};

/** aggregate fields of "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_Configuration_Aggregate_Fields = {
  __typename?: 'app_loader_n_analytic_package_configuration_aggregate_fields';
  avg?: Maybe<App_Loader_N_Analytic_Package_Configuration_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_N_Analytic_Package_Configuration_Max_Fields>;
  min?: Maybe<App_Loader_N_Analytic_Package_Configuration_Min_Fields>;
  stddev?: Maybe<App_Loader_N_Analytic_Package_Configuration_Stddev_Fields>;
  stddev_pop?: Maybe<App_Loader_N_Analytic_Package_Configuration_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<App_Loader_N_Analytic_Package_Configuration_Stddev_Samp_Fields>;
  sum?: Maybe<App_Loader_N_Analytic_Package_Configuration_Sum_Fields>;
  var_pop?: Maybe<App_Loader_N_Analytic_Package_Configuration_Var_Pop_Fields>;
  var_samp?: Maybe<App_Loader_N_Analytic_Package_Configuration_Var_Samp_Fields>;
  variance?: Maybe<App_Loader_N_Analytic_Package_Configuration_Variance_Fields>;
};


/** aggregate fields of "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_N_Analytic_Package_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type App_Loader_N_Analytic_Package_Configuration_Avg_Fields = {
  __typename?: 'app_loader_n_analytic_package_configuration_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "n_analytic_package_configuration". All fields are combined with a logical 'AND'. */
export type App_Loader_N_Analytic_Package_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_N_Analytic_Package_Configuration_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_N_Analytic_Package_Configuration_Bool_Exp>>;
  id?: InputMaybe<App_Loader_Int_Comparison_Exp>;
  n_packages?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
  n_packages_aggregate?: InputMaybe<App_Loader_N_Package_Aggregate_Bool_Exp>;
  ph_instance_address?: InputMaybe<App_Loader_String_Comparison_Exp>;
  ph_project_api_key?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** unique or primary key constraints on table "n_analytic_package_configuration" */
export enum App_Loader_N_Analytic_Package_Configuration_Constraint {
  /** unique or primary key constraint on columns "id" */
  NAnalyticApplicationConfigurationPkey = 'n_analytic_application_configuration_pkey'
}

/** input type for incrementing numeric columns in table "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_Configuration_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_Configuration_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  n_packages?: InputMaybe<App_Loader_N_Package_Arr_Rel_Insert_Input>;
  ph_instance_address?: InputMaybe<Scalars['String']['input']>;
  ph_project_api_key?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_N_Analytic_Package_Configuration_Max_Fields = {
  __typename?: 'app_loader_n_analytic_package_configuration_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  ph_instance_address?: Maybe<Scalars['String']['output']>;
  ph_project_api_key?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Loader_N_Analytic_Package_Configuration_Min_Fields = {
  __typename?: 'app_loader_n_analytic_package_configuration_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  ph_instance_address?: Maybe<Scalars['String']['output']>;
  ph_project_api_key?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_Configuration_Mutation_Response = {
  __typename?: 'app_loader_n_analytic_package_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_N_Analytic_Package_Configuration>;
};

/** input type for inserting object relation for remote table "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_Configuration_Obj_Rel_Insert_Input = {
  data: App_Loader_N_Analytic_Package_Configuration_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_On_Conflict>;
};

/** on_conflict condition type for table "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_Configuration_On_Conflict = {
  constraint: App_Loader_N_Analytic_Package_Configuration_Constraint;
  update_columns?: Array<App_Loader_N_Analytic_Package_Configuration_Update_Column>;
  where?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Bool_Exp>;
};

/** Ordering options when selecting data from "n_analytic_package_configuration". */
export type App_Loader_N_Analytic_Package_Configuration_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
  n_packages_aggregate?: InputMaybe<App_Loader_N_Package_Aggregate_Order_By>;
  ph_instance_address?: InputMaybe<App_Loader_Order_By>;
  ph_project_api_key?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: n_analytic_package_configuration */
export type App_Loader_N_Analytic_Package_Configuration_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "n_analytic_package_configuration" */
export enum App_Loader_N_Analytic_Package_Configuration_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PhInstanceAddress = 'ph_instance_address',
  /** column name */
  PhProjectApiKey = 'ph_project_api_key'
}

/** input type for updating data in table "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_Configuration_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ph_instance_address?: InputMaybe<Scalars['String']['input']>;
  ph_project_api_key?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type App_Loader_N_Analytic_Package_Configuration_Stddev_Fields = {
  __typename?: 'app_loader_n_analytic_package_configuration_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type App_Loader_N_Analytic_Package_Configuration_Stddev_Pop_Fields = {
  __typename?: 'app_loader_n_analytic_package_configuration_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type App_Loader_N_Analytic_Package_Configuration_Stddev_Samp_Fields = {
  __typename?: 'app_loader_n_analytic_package_configuration_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "n_analytic_package_configuration" */
export type App_Loader_N_Analytic_Package_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_N_Analytic_Package_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_N_Analytic_Package_Configuration_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ph_instance_address?: InputMaybe<Scalars['String']['input']>;
  ph_project_api_key?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type App_Loader_N_Analytic_Package_Configuration_Sum_Fields = {
  __typename?: 'app_loader_n_analytic_package_configuration_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "n_analytic_package_configuration" */
export enum App_Loader_N_Analytic_Package_Configuration_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PhInstanceAddress = 'ph_instance_address',
  /** column name */
  PhProjectApiKey = 'ph_project_api_key'
}

export type App_Loader_N_Analytic_Package_Configuration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_N_Analytic_Package_Configuration_Bool_Exp;
};

/** aggregate var_pop on columns */
export type App_Loader_N_Analytic_Package_Configuration_Var_Pop_Fields = {
  __typename?: 'app_loader_n_analytic_package_configuration_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type App_Loader_N_Analytic_Package_Configuration_Var_Samp_Fields = {
  __typename?: 'app_loader_n_analytic_package_configuration_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type App_Loader_N_Analytic_Package_Configuration_Variance_Fields = {
  __typename?: 'app_loader_n_analytic_package_configuration_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "n_application" */
export type App_Loader_N_Application = {
  __typename?: 'app_loader_n_application';
  /** An object relationship */
  customer: App_Loader_Customer;
  customer_id: Scalars['app_loader_uuid']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  n_domains: Array<App_Loader_N_Domain>;
  /** An aggregate relationship */
  n_domains_aggregate: App_Loader_N_Domain_Aggregate;
  /** An array relationship */
  n_packages: Array<App_Loader_N_Package>;
  /** An aggregate relationship */
  n_packages_aggregate: App_Loader_N_Package_Aggregate;
  name: Scalars['String']['output'];
};


/** columns and relationships of "n_application" */
export type App_Loader_N_ApplicationN_DomainsArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Domain_Order_By>>;
  where?: InputMaybe<App_Loader_N_Domain_Bool_Exp>;
};


/** columns and relationships of "n_application" */
export type App_Loader_N_ApplicationN_Domains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Domain_Order_By>>;
  where?: InputMaybe<App_Loader_N_Domain_Bool_Exp>;
};


/** columns and relationships of "n_application" */
export type App_Loader_N_ApplicationN_PackagesArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Package_Order_By>>;
  where?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
};


/** columns and relationships of "n_application" */
export type App_Loader_N_ApplicationN_Packages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Package_Order_By>>;
  where?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
};

/** aggregated selection of "n_application" */
export type App_Loader_N_Application_Aggregate = {
  __typename?: 'app_loader_n_application_aggregate';
  aggregate?: Maybe<App_Loader_N_Application_Aggregate_Fields>;
  nodes: Array<App_Loader_N_Application>;
};

export type App_Loader_N_Application_Aggregate_Bool_Exp = {
  count?: InputMaybe<App_Loader_N_Application_Aggregate_Bool_Exp_Count>;
};

export type App_Loader_N_Application_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<App_Loader_N_Application_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
  predicate: App_Loader_Int_Comparison_Exp;
};

/** aggregate fields of "n_application" */
export type App_Loader_N_Application_Aggregate_Fields = {
  __typename?: 'app_loader_n_application_aggregate_fields';
  avg?: Maybe<App_Loader_N_Application_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_N_Application_Max_Fields>;
  min?: Maybe<App_Loader_N_Application_Min_Fields>;
  stddev?: Maybe<App_Loader_N_Application_Stddev_Fields>;
  stddev_pop?: Maybe<App_Loader_N_Application_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<App_Loader_N_Application_Stddev_Samp_Fields>;
  sum?: Maybe<App_Loader_N_Application_Sum_Fields>;
  var_pop?: Maybe<App_Loader_N_Application_Var_Pop_Fields>;
  var_samp?: Maybe<App_Loader_N_Application_Var_Samp_Fields>;
  variance?: Maybe<App_Loader_N_Application_Variance_Fields>;
};


/** aggregate fields of "n_application" */
export type App_Loader_N_Application_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_N_Application_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "n_application" */
export type App_Loader_N_Application_Aggregate_Order_By = {
  avg?: InputMaybe<App_Loader_N_Application_Avg_Order_By>;
  count?: InputMaybe<App_Loader_Order_By>;
  max?: InputMaybe<App_Loader_N_Application_Max_Order_By>;
  min?: InputMaybe<App_Loader_N_Application_Min_Order_By>;
  stddev?: InputMaybe<App_Loader_N_Application_Stddev_Order_By>;
  stddev_pop?: InputMaybe<App_Loader_N_Application_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<App_Loader_N_Application_Stddev_Samp_Order_By>;
  sum?: InputMaybe<App_Loader_N_Application_Sum_Order_By>;
  var_pop?: InputMaybe<App_Loader_N_Application_Var_Pop_Order_By>;
  var_samp?: InputMaybe<App_Loader_N_Application_Var_Samp_Order_By>;
  variance?: InputMaybe<App_Loader_N_Application_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "n_application" */
export type App_Loader_N_Application_Arr_Rel_Insert_Input = {
  data: Array<App_Loader_N_Application_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_N_Application_On_Conflict>;
};

/** aggregate avg on columns */
export type App_Loader_N_Application_Avg_Fields = {
  __typename?: 'app_loader_n_application_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "n_application" */
export type App_Loader_N_Application_Avg_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
};

/** Boolean expression to filter rows from the table "n_application". All fields are combined with a logical 'AND'. */
export type App_Loader_N_Application_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_N_Application_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_N_Application_Bool_Exp>>;
  customer?: InputMaybe<App_Loader_Customer_Bool_Exp>;
  customer_id?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  id?: InputMaybe<App_Loader_Int_Comparison_Exp>;
  n_domains?: InputMaybe<App_Loader_N_Domain_Bool_Exp>;
  n_domains_aggregate?: InputMaybe<App_Loader_N_Domain_Aggregate_Bool_Exp>;
  n_packages?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
  n_packages_aggregate?: InputMaybe<App_Loader_N_Package_Aggregate_Bool_Exp>;
  name?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** unique or primary key constraints on table "n_application" */
export enum App_Loader_N_Application_Constraint {
  /** unique or primary key constraint on columns "id" */
  NApplicationPkey = 'n_application_pkey'
}

/** input type for incrementing numeric columns in table "n_application" */
export type App_Loader_N_Application_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "n_application" */
export type App_Loader_N_Application_Insert_Input = {
  customer?: InputMaybe<App_Loader_Customer_Obj_Rel_Insert_Input>;
  customer_id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  n_domains?: InputMaybe<App_Loader_N_Domain_Arr_Rel_Insert_Input>;
  n_packages?: InputMaybe<App_Loader_N_Package_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_N_Application_Max_Fields = {
  __typename?: 'app_loader_n_application_max_fields';
  customer_id?: Maybe<Scalars['app_loader_uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "n_application" */
export type App_Loader_N_Application_Max_Order_By = {
  customer_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate min on columns */
export type App_Loader_N_Application_Min_Fields = {
  __typename?: 'app_loader_n_application_min_fields';
  customer_id?: Maybe<Scalars['app_loader_uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "n_application" */
export type App_Loader_N_Application_Min_Order_By = {
  customer_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
};

/** response of any mutation on the table "n_application" */
export type App_Loader_N_Application_Mutation_Response = {
  __typename?: 'app_loader_n_application_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_N_Application>;
};

/** input type for inserting object relation for remote table "n_application" */
export type App_Loader_N_Application_Obj_Rel_Insert_Input = {
  data: App_Loader_N_Application_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_N_Application_On_Conflict>;
};

/** on_conflict condition type for table "n_application" */
export type App_Loader_N_Application_On_Conflict = {
  constraint: App_Loader_N_Application_Constraint;
  update_columns?: Array<App_Loader_N_Application_Update_Column>;
  where?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
};

/** Ordering options when selecting data from "n_application". */
export type App_Loader_N_Application_Order_By = {
  customer?: InputMaybe<App_Loader_Customer_Order_By>;
  customer_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  n_domains_aggregate?: InputMaybe<App_Loader_N_Domain_Aggregate_Order_By>;
  n_packages_aggregate?: InputMaybe<App_Loader_N_Package_Aggregate_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: n_application */
export type App_Loader_N_Application_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "n_application" */
export enum App_Loader_N_Application_Select_Column {
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "n_application" */
export type App_Loader_N_Application_Set_Input = {
  customer_id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type App_Loader_N_Application_Stddev_Fields = {
  __typename?: 'app_loader_n_application_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "n_application" */
export type App_Loader_N_Application_Stddev_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate stddev_pop on columns */
export type App_Loader_N_Application_Stddev_Pop_Fields = {
  __typename?: 'app_loader_n_application_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "n_application" */
export type App_Loader_N_Application_Stddev_Pop_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate stddev_samp on columns */
export type App_Loader_N_Application_Stddev_Samp_Fields = {
  __typename?: 'app_loader_n_application_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "n_application" */
export type App_Loader_N_Application_Stddev_Samp_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
};

/** Streaming cursor of the table "n_application" */
export type App_Loader_N_Application_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_N_Application_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_N_Application_Stream_Cursor_Value_Input = {
  customer_id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type App_Loader_N_Application_Sum_Fields = {
  __typename?: 'app_loader_n_application_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "n_application" */
export type App_Loader_N_Application_Sum_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
};

/** update columns of table "n_application" */
export enum App_Loader_N_Application_Update_Column {
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type App_Loader_N_Application_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<App_Loader_N_Application_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_N_Application_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_N_Application_Bool_Exp;
};

/** aggregate var_pop on columns */
export type App_Loader_N_Application_Var_Pop_Fields = {
  __typename?: 'app_loader_n_application_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "n_application" */
export type App_Loader_N_Application_Var_Pop_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate var_samp on columns */
export type App_Loader_N_Application_Var_Samp_Fields = {
  __typename?: 'app_loader_n_application_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "n_application" */
export type App_Loader_N_Application_Var_Samp_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate variance on columns */
export type App_Loader_N_Application_Variance_Fields = {
  __typename?: 'app_loader_n_application_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "n_application" */
export type App_Loader_N_Application_Variance_Order_By = {
  id?: InputMaybe<App_Loader_Order_By>;
};

/** columns and relationships of "n_domain" */
export type App_Loader_N_Domain = {
  __typename?: 'app_loader_n_domain';
  application_id: Scalars['Int']['output'];
  fqdn: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  n_application: App_Loader_N_Application;
};

/** aggregated selection of "n_domain" */
export type App_Loader_N_Domain_Aggregate = {
  __typename?: 'app_loader_n_domain_aggregate';
  aggregate?: Maybe<App_Loader_N_Domain_Aggregate_Fields>;
  nodes: Array<App_Loader_N_Domain>;
};

export type App_Loader_N_Domain_Aggregate_Bool_Exp = {
  count?: InputMaybe<App_Loader_N_Domain_Aggregate_Bool_Exp_Count>;
};

export type App_Loader_N_Domain_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<App_Loader_N_Domain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<App_Loader_N_Domain_Bool_Exp>;
  predicate: App_Loader_Int_Comparison_Exp;
};

/** aggregate fields of "n_domain" */
export type App_Loader_N_Domain_Aggregate_Fields = {
  __typename?: 'app_loader_n_domain_aggregate_fields';
  avg?: Maybe<App_Loader_N_Domain_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_N_Domain_Max_Fields>;
  min?: Maybe<App_Loader_N_Domain_Min_Fields>;
  stddev?: Maybe<App_Loader_N_Domain_Stddev_Fields>;
  stddev_pop?: Maybe<App_Loader_N_Domain_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<App_Loader_N_Domain_Stddev_Samp_Fields>;
  sum?: Maybe<App_Loader_N_Domain_Sum_Fields>;
  var_pop?: Maybe<App_Loader_N_Domain_Var_Pop_Fields>;
  var_samp?: Maybe<App_Loader_N_Domain_Var_Samp_Fields>;
  variance?: Maybe<App_Loader_N_Domain_Variance_Fields>;
};


/** aggregate fields of "n_domain" */
export type App_Loader_N_Domain_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_N_Domain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "n_domain" */
export type App_Loader_N_Domain_Aggregate_Order_By = {
  avg?: InputMaybe<App_Loader_N_Domain_Avg_Order_By>;
  count?: InputMaybe<App_Loader_Order_By>;
  max?: InputMaybe<App_Loader_N_Domain_Max_Order_By>;
  min?: InputMaybe<App_Loader_N_Domain_Min_Order_By>;
  stddev?: InputMaybe<App_Loader_N_Domain_Stddev_Order_By>;
  stddev_pop?: InputMaybe<App_Loader_N_Domain_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<App_Loader_N_Domain_Stddev_Samp_Order_By>;
  sum?: InputMaybe<App_Loader_N_Domain_Sum_Order_By>;
  var_pop?: InputMaybe<App_Loader_N_Domain_Var_Pop_Order_By>;
  var_samp?: InputMaybe<App_Loader_N_Domain_Var_Samp_Order_By>;
  variance?: InputMaybe<App_Loader_N_Domain_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "n_domain" */
export type App_Loader_N_Domain_Arr_Rel_Insert_Input = {
  data: Array<App_Loader_N_Domain_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_N_Domain_On_Conflict>;
};

/** aggregate avg on columns */
export type App_Loader_N_Domain_Avg_Fields = {
  __typename?: 'app_loader_n_domain_avg_fields';
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "n_domain" */
export type App_Loader_N_Domain_Avg_Order_By = {
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** Boolean expression to filter rows from the table "n_domain". All fields are combined with a logical 'AND'. */
export type App_Loader_N_Domain_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_N_Domain_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_N_Domain_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_N_Domain_Bool_Exp>>;
  application_id?: InputMaybe<App_Loader_Int_Comparison_Exp>;
  fqdn?: InputMaybe<App_Loader_String_Comparison_Exp>;
  id?: InputMaybe<App_Loader_Int_Comparison_Exp>;
  n_application?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
};

/** unique or primary key constraints on table "n_domain" */
export enum App_Loader_N_Domain_Constraint {
  /** unique or primary key constraint on columns "id" */
  NDomainPkey = 'n_domain_pkey'
}

/** input type for incrementing numeric columns in table "n_domain" */
export type App_Loader_N_Domain_Inc_Input = {
  application_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "n_domain" */
export type App_Loader_N_Domain_Insert_Input = {
  application_id?: InputMaybe<Scalars['Int']['input']>;
  fqdn?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  n_application?: InputMaybe<App_Loader_N_Application_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type App_Loader_N_Domain_Max_Fields = {
  __typename?: 'app_loader_n_domain_max_fields';
  application_id?: Maybe<Scalars['Int']['output']>;
  fqdn?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "n_domain" */
export type App_Loader_N_Domain_Max_Order_By = {
  application_id?: InputMaybe<App_Loader_Order_By>;
  fqdn?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate min on columns */
export type App_Loader_N_Domain_Min_Fields = {
  __typename?: 'app_loader_n_domain_min_fields';
  application_id?: Maybe<Scalars['Int']['output']>;
  fqdn?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "n_domain" */
export type App_Loader_N_Domain_Min_Order_By = {
  application_id?: InputMaybe<App_Loader_Order_By>;
  fqdn?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** response of any mutation on the table "n_domain" */
export type App_Loader_N_Domain_Mutation_Response = {
  __typename?: 'app_loader_n_domain_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_N_Domain>;
};

/** on_conflict condition type for table "n_domain" */
export type App_Loader_N_Domain_On_Conflict = {
  constraint: App_Loader_N_Domain_Constraint;
  update_columns?: Array<App_Loader_N_Domain_Update_Column>;
  where?: InputMaybe<App_Loader_N_Domain_Bool_Exp>;
};

/** Ordering options when selecting data from "n_domain". */
export type App_Loader_N_Domain_Order_By = {
  application_id?: InputMaybe<App_Loader_Order_By>;
  fqdn?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  n_application?: InputMaybe<App_Loader_N_Application_Order_By>;
};

/** primary key columns input for table: n_domain */
export type App_Loader_N_Domain_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "n_domain" */
export enum App_Loader_N_Domain_Select_Column {
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  Fqdn = 'fqdn',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "n_domain" */
export type App_Loader_N_Domain_Set_Input = {
  application_id?: InputMaybe<Scalars['Int']['input']>;
  fqdn?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type App_Loader_N_Domain_Stddev_Fields = {
  __typename?: 'app_loader_n_domain_stddev_fields';
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "n_domain" */
export type App_Loader_N_Domain_Stddev_Order_By = {
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate stddev_pop on columns */
export type App_Loader_N_Domain_Stddev_Pop_Fields = {
  __typename?: 'app_loader_n_domain_stddev_pop_fields';
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "n_domain" */
export type App_Loader_N_Domain_Stddev_Pop_Order_By = {
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate stddev_samp on columns */
export type App_Loader_N_Domain_Stddev_Samp_Fields = {
  __typename?: 'app_loader_n_domain_stddev_samp_fields';
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "n_domain" */
export type App_Loader_N_Domain_Stddev_Samp_Order_By = {
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** Streaming cursor of the table "n_domain" */
export type App_Loader_N_Domain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_N_Domain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_N_Domain_Stream_Cursor_Value_Input = {
  application_id?: InputMaybe<Scalars['Int']['input']>;
  fqdn?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type App_Loader_N_Domain_Sum_Fields = {
  __typename?: 'app_loader_n_domain_sum_fields';
  application_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "n_domain" */
export type App_Loader_N_Domain_Sum_Order_By = {
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** update columns of table "n_domain" */
export enum App_Loader_N_Domain_Update_Column {
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  Fqdn = 'fqdn',
  /** column name */
  Id = 'id'
}

export type App_Loader_N_Domain_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<App_Loader_N_Domain_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_N_Domain_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_N_Domain_Bool_Exp;
};

/** aggregate var_pop on columns */
export type App_Loader_N_Domain_Var_Pop_Fields = {
  __typename?: 'app_loader_n_domain_var_pop_fields';
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "n_domain" */
export type App_Loader_N_Domain_Var_Pop_Order_By = {
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate var_samp on columns */
export type App_Loader_N_Domain_Var_Samp_Fields = {
  __typename?: 'app_loader_n_domain_var_samp_fields';
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "n_domain" */
export type App_Loader_N_Domain_Var_Samp_Order_By = {
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate variance on columns */
export type App_Loader_N_Domain_Variance_Fields = {
  __typename?: 'app_loader_n_domain_variance_fields';
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "n_domain" */
export type App_Loader_N_Domain_Variance_Order_By = {
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** columns and relationships of "n_package" */
export type App_Loader_N_Package = {
  __typename?: 'app_loader_n_package';
  analytic_configuration_id?: Maybe<Scalars['Int']['output']>;
  application_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  n_analytic_package_configuration?: Maybe<App_Loader_N_Analytic_Package_Configuration>;
  /** An object relationship */
  n_application: App_Loader_N_Application;
  /** An object relationship */
  n_pype_package_configuration?: Maybe<App_Loader_N_Pype_Package_Configuration>;
  name: Scalars['String']['output'];
  pype_configuration_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "n_package" */
export type App_Loader_N_Package_Aggregate = {
  __typename?: 'app_loader_n_package_aggregate';
  aggregate?: Maybe<App_Loader_N_Package_Aggregate_Fields>;
  nodes: Array<App_Loader_N_Package>;
};

export type App_Loader_N_Package_Aggregate_Bool_Exp = {
  count?: InputMaybe<App_Loader_N_Package_Aggregate_Bool_Exp_Count>;
};

export type App_Loader_N_Package_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<App_Loader_N_Package_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
  predicate: App_Loader_Int_Comparison_Exp;
};

/** aggregate fields of "n_package" */
export type App_Loader_N_Package_Aggregate_Fields = {
  __typename?: 'app_loader_n_package_aggregate_fields';
  avg?: Maybe<App_Loader_N_Package_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_N_Package_Max_Fields>;
  min?: Maybe<App_Loader_N_Package_Min_Fields>;
  stddev?: Maybe<App_Loader_N_Package_Stddev_Fields>;
  stddev_pop?: Maybe<App_Loader_N_Package_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<App_Loader_N_Package_Stddev_Samp_Fields>;
  sum?: Maybe<App_Loader_N_Package_Sum_Fields>;
  var_pop?: Maybe<App_Loader_N_Package_Var_Pop_Fields>;
  var_samp?: Maybe<App_Loader_N_Package_Var_Samp_Fields>;
  variance?: Maybe<App_Loader_N_Package_Variance_Fields>;
};


/** aggregate fields of "n_package" */
export type App_Loader_N_Package_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_N_Package_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "n_package" */
export type App_Loader_N_Package_Aggregate_Order_By = {
  avg?: InputMaybe<App_Loader_N_Package_Avg_Order_By>;
  count?: InputMaybe<App_Loader_Order_By>;
  max?: InputMaybe<App_Loader_N_Package_Max_Order_By>;
  min?: InputMaybe<App_Loader_N_Package_Min_Order_By>;
  stddev?: InputMaybe<App_Loader_N_Package_Stddev_Order_By>;
  stddev_pop?: InputMaybe<App_Loader_N_Package_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<App_Loader_N_Package_Stddev_Samp_Order_By>;
  sum?: InputMaybe<App_Loader_N_Package_Sum_Order_By>;
  var_pop?: InputMaybe<App_Loader_N_Package_Var_Pop_Order_By>;
  var_samp?: InputMaybe<App_Loader_N_Package_Var_Samp_Order_By>;
  variance?: InputMaybe<App_Loader_N_Package_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "n_package" */
export type App_Loader_N_Package_Arr_Rel_Insert_Input = {
  data: Array<App_Loader_N_Package_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_N_Package_On_Conflict>;
};

/** aggregate avg on columns */
export type App_Loader_N_Package_Avg_Fields = {
  __typename?: 'app_loader_n_package_avg_fields';
  analytic_configuration_id?: Maybe<Scalars['Float']['output']>;
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pype_configuration_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "n_package" */
export type App_Loader_N_Package_Avg_Order_By = {
  analytic_configuration_id?: InputMaybe<App_Loader_Order_By>;
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  pype_configuration_id?: InputMaybe<App_Loader_Order_By>;
};

/** Boolean expression to filter rows from the table "n_package". All fields are combined with a logical 'AND'. */
export type App_Loader_N_Package_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_N_Package_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_N_Package_Bool_Exp>>;
  analytic_configuration_id?: InputMaybe<App_Loader_Int_Comparison_Exp>;
  application_id?: InputMaybe<App_Loader_Int_Comparison_Exp>;
  id?: InputMaybe<App_Loader_Int_Comparison_Exp>;
  n_analytic_package_configuration?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Bool_Exp>;
  n_application?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
  n_pype_package_configuration?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Bool_Exp>;
  name?: InputMaybe<App_Loader_String_Comparison_Exp>;
  pype_configuration_id?: InputMaybe<App_Loader_Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "n_package" */
export enum App_Loader_N_Package_Constraint {
  /** unique or primary key constraint on columns "id" */
  NPackagePkey = 'n_package_pkey'
}

/** input type for incrementing numeric columns in table "n_package" */
export type App_Loader_N_Package_Inc_Input = {
  analytic_configuration_id?: InputMaybe<Scalars['Int']['input']>;
  application_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pype_configuration_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "n_package" */
export type App_Loader_N_Package_Insert_Input = {
  analytic_configuration_id?: InputMaybe<Scalars['Int']['input']>;
  application_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  n_analytic_package_configuration?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Obj_Rel_Insert_Input>;
  n_application?: InputMaybe<App_Loader_N_Application_Obj_Rel_Insert_Input>;
  n_pype_package_configuration?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  pype_configuration_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type App_Loader_N_Package_Max_Fields = {
  __typename?: 'app_loader_n_package_max_fields';
  analytic_configuration_id?: Maybe<Scalars['Int']['output']>;
  application_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pype_configuration_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "n_package" */
export type App_Loader_N_Package_Max_Order_By = {
  analytic_configuration_id?: InputMaybe<App_Loader_Order_By>;
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
  pype_configuration_id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate min on columns */
export type App_Loader_N_Package_Min_Fields = {
  __typename?: 'app_loader_n_package_min_fields';
  analytic_configuration_id?: Maybe<Scalars['Int']['output']>;
  application_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pype_configuration_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "n_package" */
export type App_Loader_N_Package_Min_Order_By = {
  analytic_configuration_id?: InputMaybe<App_Loader_Order_By>;
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
  pype_configuration_id?: InputMaybe<App_Loader_Order_By>;
};

/** response of any mutation on the table "n_package" */
export type App_Loader_N_Package_Mutation_Response = {
  __typename?: 'app_loader_n_package_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_N_Package>;
};

/** on_conflict condition type for table "n_package" */
export type App_Loader_N_Package_On_Conflict = {
  constraint: App_Loader_N_Package_Constraint;
  update_columns?: Array<App_Loader_N_Package_Update_Column>;
  where?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
};

/** Ordering options when selecting data from "n_package". */
export type App_Loader_N_Package_Order_By = {
  analytic_configuration_id?: InputMaybe<App_Loader_Order_By>;
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  n_analytic_package_configuration?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Order_By>;
  n_application?: InputMaybe<App_Loader_N_Application_Order_By>;
  n_pype_package_configuration?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Order_By>;
  name?: InputMaybe<App_Loader_Order_By>;
  pype_configuration_id?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: n_package */
export type App_Loader_N_Package_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "n_package" */
export enum App_Loader_N_Package_Select_Column {
  /** column name */
  AnalyticConfigurationId = 'analytic_configuration_id',
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PypeConfigurationId = 'pype_configuration_id'
}

/** input type for updating data in table "n_package" */
export type App_Loader_N_Package_Set_Input = {
  analytic_configuration_id?: InputMaybe<Scalars['Int']['input']>;
  application_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pype_configuration_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type App_Loader_N_Package_Stddev_Fields = {
  __typename?: 'app_loader_n_package_stddev_fields';
  analytic_configuration_id?: Maybe<Scalars['Float']['output']>;
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pype_configuration_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "n_package" */
export type App_Loader_N_Package_Stddev_Order_By = {
  analytic_configuration_id?: InputMaybe<App_Loader_Order_By>;
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  pype_configuration_id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate stddev_pop on columns */
export type App_Loader_N_Package_Stddev_Pop_Fields = {
  __typename?: 'app_loader_n_package_stddev_pop_fields';
  analytic_configuration_id?: Maybe<Scalars['Float']['output']>;
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pype_configuration_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "n_package" */
export type App_Loader_N_Package_Stddev_Pop_Order_By = {
  analytic_configuration_id?: InputMaybe<App_Loader_Order_By>;
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  pype_configuration_id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate stddev_samp on columns */
export type App_Loader_N_Package_Stddev_Samp_Fields = {
  __typename?: 'app_loader_n_package_stddev_samp_fields';
  analytic_configuration_id?: Maybe<Scalars['Float']['output']>;
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pype_configuration_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "n_package" */
export type App_Loader_N_Package_Stddev_Samp_Order_By = {
  analytic_configuration_id?: InputMaybe<App_Loader_Order_By>;
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  pype_configuration_id?: InputMaybe<App_Loader_Order_By>;
};

/** Streaming cursor of the table "n_package" */
export type App_Loader_N_Package_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_N_Package_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_N_Package_Stream_Cursor_Value_Input = {
  analytic_configuration_id?: InputMaybe<Scalars['Int']['input']>;
  application_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pype_configuration_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type App_Loader_N_Package_Sum_Fields = {
  __typename?: 'app_loader_n_package_sum_fields';
  analytic_configuration_id?: Maybe<Scalars['Int']['output']>;
  application_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  pype_configuration_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "n_package" */
export type App_Loader_N_Package_Sum_Order_By = {
  analytic_configuration_id?: InputMaybe<App_Loader_Order_By>;
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  pype_configuration_id?: InputMaybe<App_Loader_Order_By>;
};

/** update columns of table "n_package" */
export enum App_Loader_N_Package_Update_Column {
  /** column name */
  AnalyticConfigurationId = 'analytic_configuration_id',
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PypeConfigurationId = 'pype_configuration_id'
}

export type App_Loader_N_Package_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<App_Loader_N_Package_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_N_Package_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_N_Package_Bool_Exp;
};

/** aggregate var_pop on columns */
export type App_Loader_N_Package_Var_Pop_Fields = {
  __typename?: 'app_loader_n_package_var_pop_fields';
  analytic_configuration_id?: Maybe<Scalars['Float']['output']>;
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pype_configuration_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "n_package" */
export type App_Loader_N_Package_Var_Pop_Order_By = {
  analytic_configuration_id?: InputMaybe<App_Loader_Order_By>;
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  pype_configuration_id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate var_samp on columns */
export type App_Loader_N_Package_Var_Samp_Fields = {
  __typename?: 'app_loader_n_package_var_samp_fields';
  analytic_configuration_id?: Maybe<Scalars['Float']['output']>;
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pype_configuration_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "n_package" */
export type App_Loader_N_Package_Var_Samp_Order_By = {
  analytic_configuration_id?: InputMaybe<App_Loader_Order_By>;
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  pype_configuration_id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate variance on columns */
export type App_Loader_N_Package_Variance_Fields = {
  __typename?: 'app_loader_n_package_variance_fields';
  analytic_configuration_id?: Maybe<Scalars['Float']['output']>;
  application_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pype_configuration_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "n_package" */
export type App_Loader_N_Package_Variance_Order_By = {
  analytic_configuration_id?: InputMaybe<App_Loader_Order_By>;
  application_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  pype_configuration_id?: InputMaybe<App_Loader_Order_By>;
};

/** columns and relationships of "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_Configuration = {
  __typename?: 'app_loader_n_pype_package_configuration';
  analytics_host: Scalars['String']['output'];
  analytics_key: Scalars['String']['output'];
  app_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  n_packages: Array<App_Loader_N_Package>;
  /** An aggregate relationship */
  n_packages_aggregate: App_Loader_N_Package_Aggregate;
};


/** columns and relationships of "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_ConfigurationN_PackagesArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Package_Order_By>>;
  where?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
};


/** columns and relationships of "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_ConfigurationN_Packages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Package_Order_By>>;
  where?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
};

/** aggregated selection of "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_Configuration_Aggregate = {
  __typename?: 'app_loader_n_pype_package_configuration_aggregate';
  aggregate?: Maybe<App_Loader_N_Pype_Package_Configuration_Aggregate_Fields>;
  nodes: Array<App_Loader_N_Pype_Package_Configuration>;
};

/** aggregate fields of "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_Configuration_Aggregate_Fields = {
  __typename?: 'app_loader_n_pype_package_configuration_aggregate_fields';
  avg?: Maybe<App_Loader_N_Pype_Package_Configuration_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_N_Pype_Package_Configuration_Max_Fields>;
  min?: Maybe<App_Loader_N_Pype_Package_Configuration_Min_Fields>;
  stddev?: Maybe<App_Loader_N_Pype_Package_Configuration_Stddev_Fields>;
  stddev_pop?: Maybe<App_Loader_N_Pype_Package_Configuration_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<App_Loader_N_Pype_Package_Configuration_Stddev_Samp_Fields>;
  sum?: Maybe<App_Loader_N_Pype_Package_Configuration_Sum_Fields>;
  var_pop?: Maybe<App_Loader_N_Pype_Package_Configuration_Var_Pop_Fields>;
  var_samp?: Maybe<App_Loader_N_Pype_Package_Configuration_Var_Samp_Fields>;
  variance?: Maybe<App_Loader_N_Pype_Package_Configuration_Variance_Fields>;
};


/** aggregate fields of "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_N_Pype_Package_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type App_Loader_N_Pype_Package_Configuration_Avg_Fields = {
  __typename?: 'app_loader_n_pype_package_configuration_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "n_pype_package_configuration". All fields are combined with a logical 'AND'. */
export type App_Loader_N_Pype_Package_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_N_Pype_Package_Configuration_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_N_Pype_Package_Configuration_Bool_Exp>>;
  analytics_host?: InputMaybe<App_Loader_String_Comparison_Exp>;
  analytics_key?: InputMaybe<App_Loader_String_Comparison_Exp>;
  app_id?: InputMaybe<App_Loader_String_Comparison_Exp>;
  id?: InputMaybe<App_Loader_Int_Comparison_Exp>;
  n_packages?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
  n_packages_aggregate?: InputMaybe<App_Loader_N_Package_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "n_pype_package_configuration" */
export enum App_Loader_N_Pype_Package_Configuration_Constraint {
  /** unique or primary key constraint on columns "id" */
  NPypePackageConfigurationPkey = 'n_pype_package_configuration_pkey'
}

/** input type for incrementing numeric columns in table "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_Configuration_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_Configuration_Insert_Input = {
  analytics_host?: InputMaybe<Scalars['String']['input']>;
  analytics_key?: InputMaybe<Scalars['String']['input']>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  n_packages?: InputMaybe<App_Loader_N_Package_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type App_Loader_N_Pype_Package_Configuration_Max_Fields = {
  __typename?: 'app_loader_n_pype_package_configuration_max_fields';
  analytics_host?: Maybe<Scalars['String']['output']>;
  analytics_key?: Maybe<Scalars['String']['output']>;
  app_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type App_Loader_N_Pype_Package_Configuration_Min_Fields = {
  __typename?: 'app_loader_n_pype_package_configuration_min_fields';
  analytics_host?: Maybe<Scalars['String']['output']>;
  analytics_key?: Maybe<Scalars['String']['output']>;
  app_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_Configuration_Mutation_Response = {
  __typename?: 'app_loader_n_pype_package_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_N_Pype_Package_Configuration>;
};

/** input type for inserting object relation for remote table "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_Configuration_Obj_Rel_Insert_Input = {
  data: App_Loader_N_Pype_Package_Configuration_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_N_Pype_Package_Configuration_On_Conflict>;
};

/** on_conflict condition type for table "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_Configuration_On_Conflict = {
  constraint: App_Loader_N_Pype_Package_Configuration_Constraint;
  update_columns?: Array<App_Loader_N_Pype_Package_Configuration_Update_Column>;
  where?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Bool_Exp>;
};

/** Ordering options when selecting data from "n_pype_package_configuration". */
export type App_Loader_N_Pype_Package_Configuration_Order_By = {
  analytics_host?: InputMaybe<App_Loader_Order_By>;
  analytics_key?: InputMaybe<App_Loader_Order_By>;
  app_id?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  n_packages_aggregate?: InputMaybe<App_Loader_N_Package_Aggregate_Order_By>;
};

/** primary key columns input for table: n_pype_package_configuration */
export type App_Loader_N_Pype_Package_Configuration_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "n_pype_package_configuration" */
export enum App_Loader_N_Pype_Package_Configuration_Select_Column {
  /** column name */
  AnalyticsHost = 'analytics_host',
  /** column name */
  AnalyticsKey = 'analytics_key',
  /** column name */
  AppId = 'app_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_Configuration_Set_Input = {
  analytics_host?: InputMaybe<Scalars['String']['input']>;
  analytics_key?: InputMaybe<Scalars['String']['input']>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type App_Loader_N_Pype_Package_Configuration_Stddev_Fields = {
  __typename?: 'app_loader_n_pype_package_configuration_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type App_Loader_N_Pype_Package_Configuration_Stddev_Pop_Fields = {
  __typename?: 'app_loader_n_pype_package_configuration_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type App_Loader_N_Pype_Package_Configuration_Stddev_Samp_Fields = {
  __typename?: 'app_loader_n_pype_package_configuration_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "n_pype_package_configuration" */
export type App_Loader_N_Pype_Package_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_N_Pype_Package_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_N_Pype_Package_Configuration_Stream_Cursor_Value_Input = {
  analytics_host?: InputMaybe<Scalars['String']['input']>;
  analytics_key?: InputMaybe<Scalars['String']['input']>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type App_Loader_N_Pype_Package_Configuration_Sum_Fields = {
  __typename?: 'app_loader_n_pype_package_configuration_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "n_pype_package_configuration" */
export enum App_Loader_N_Pype_Package_Configuration_Update_Column {
  /** column name */
  AnalyticsHost = 'analytics_host',
  /** column name */
  AnalyticsKey = 'analytics_key',
  /** column name */
  AppId = 'app_id',
  /** column name */
  Id = 'id'
}

export type App_Loader_N_Pype_Package_Configuration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_N_Pype_Package_Configuration_Bool_Exp;
};

/** aggregate var_pop on columns */
export type App_Loader_N_Pype_Package_Configuration_Var_Pop_Fields = {
  __typename?: 'app_loader_n_pype_package_configuration_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type App_Loader_N_Pype_Package_Configuration_Var_Samp_Fields = {
  __typename?: 'app_loader_n_pype_package_configuration_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type App_Loader_N_Pype_Package_Configuration_Variance_Fields = {
  __typename?: 'app_loader_n_pype_package_configuration_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** column ordering options */
export enum App_Loader_Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type App_Loader_Query_Root = {
  __typename?: 'app_loader_query_root';
  /** fetch data from the table: "app" */
  app: Array<App_Loader_App>;
  /** fetch aggregated fields from the table: "app" */
  app_aggregate: App_Loader_App_Aggregate;
  /** fetch data from the table: "app" using primary key columns */
  app_by_pk?: Maybe<App_Loader_App>;
  /** fetch data from the table: "conditions" */
  conditions: Array<App_Loader_Conditions>;
  /** fetch aggregated fields from the table: "conditions" */
  conditions_aggregate: App_Loader_Conditions_Aggregate;
  /** fetch data from the table: "conditions" using primary key columns */
  conditions_by_pk?: Maybe<App_Loader_Conditions>;
  /** fetch data from the table: "customer" */
  customer: Array<App_Loader_Customer>;
  /** fetch aggregated fields from the table: "customer" */
  customer_aggregate: App_Loader_Customer_Aggregate;
  /** fetch data from the table: "customer" using primary key columns */
  customer_by_pk?: Maybe<App_Loader_Customer>;
  /** fetch data from the table: "deployment" */
  deployment: Array<App_Loader_Deployment>;
  /** fetch aggregated fields from the table: "deployment" */
  deployment_aggregate: App_Loader_Deployment_Aggregate;
  /** fetch data from the table: "deployment" using primary key columns */
  deployment_by_pk?: Maybe<App_Loader_Deployment>;
  /** An array relationship */
  environment: Array<App_Loader_Environment>;
  /** An aggregate relationship */
  environment_aggregate: App_Loader_Environment_Aggregate;
  /** fetch data from the table: "environment" using primary key columns */
  environment_by_pk?: Maybe<App_Loader_Environment>;
  /** fetch data from the table: "latest_schema.anonymous_session" */
  latest_schema_anonymous_session: Array<App_Loader_Latest_Schema_Anonymous_Session>;
  /** fetch aggregated fields from the table: "latest_schema.anonymous_session" */
  latest_schema_anonymous_session_aggregate: App_Loader_Latest_Schema_Anonymous_Session_Aggregate;
  /** fetch data from the table: "latest_schema.anonymous_session" using primary key columns */
  latest_schema_anonymous_session_by_pk?: Maybe<App_Loader_Latest_Schema_Anonymous_Session>;
  /** fetch data from the table: "latest_schema.packages" */
  latest_schema_packages: Array<App_Loader_Latest_Schema_Packages>;
  /** fetch aggregated fields from the table: "latest_schema.packages" */
  latest_schema_packages_aggregate: App_Loader_Latest_Schema_Packages_Aggregate;
  /** fetch data from the table: "latest_schema.packages" using primary key columns */
  latest_schema_packages_by_pk?: Maybe<App_Loader_Latest_Schema_Packages>;
  /** fetch data from the table: "latest_schema.packages_type" */
  latest_schema_packages_type: Array<App_Loader_Latest_Schema_Packages_Type>;
  /** fetch aggregated fields from the table: "latest_schema.packages_type" */
  latest_schema_packages_type_aggregate: App_Loader_Latest_Schema_Packages_Type_Aggregate;
  /** fetch data from the table: "latest_schema.packages_type" using primary key columns */
  latest_schema_packages_type_by_pk?: Maybe<App_Loader_Latest_Schema_Packages_Type>;
  /** fetch data from the table: "metadata.analytics" */
  metadata_analytics: Array<App_Loader_Metadata_Analytics>;
  /** fetch aggregated fields from the table: "metadata.analytics" */
  metadata_analytics_aggregate: App_Loader_Metadata_Analytics_Aggregate;
  /** fetch data from the table: "metadata.analytics" using primary key columns */
  metadata_analytics_by_pk?: Maybe<App_Loader_Metadata_Analytics>;
  /** fetch data from the table: "metadata.cc_position_option" */
  metadata_cc_position_option: Array<App_Loader_Metadata_Cc_Position_Option>;
  /** fetch aggregated fields from the table: "metadata.cc_position_option" */
  metadata_cc_position_option_aggregate: App_Loader_Metadata_Cc_Position_Option_Aggregate;
  /** fetch data from the table: "metadata.cc_position_option" using primary key columns */
  metadata_cc_position_option_by_pk?: Maybe<App_Loader_Metadata_Cc_Position_Option>;
  /** fetch data from the table: "metadata.cc_widget" */
  metadata_cc_widget: Array<App_Loader_Metadata_Cc_Widget>;
  /** fetch aggregated fields from the table: "metadata.cc_widget" */
  metadata_cc_widget_aggregate: App_Loader_Metadata_Cc_Widget_Aggregate;
  /** fetch data from the table: "metadata.cc_widget_bubble_type" */
  metadata_cc_widget_bubble_type: Array<App_Loader_Metadata_Cc_Widget_Bubble_Type>;
  /** fetch aggregated fields from the table: "metadata.cc_widget_bubble_type" */
  metadata_cc_widget_bubble_type_aggregate: App_Loader_Metadata_Cc_Widget_Bubble_Type_Aggregate;
  /** fetch data from the table: "metadata.cc_widget_bubble_type" using primary key columns */
  metadata_cc_widget_bubble_type_by_pk?: Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type>;
  /** fetch data from the table: "metadata.cc_widget" using primary key columns */
  metadata_cc_widget_by_pk?: Maybe<App_Loader_Metadata_Cc_Widget>;
  /** fetch data from the table: "metadata.generic" */
  metadata_generic: Array<App_Loader_Metadata_Generic>;
  /** fetch aggregated fields from the table: "metadata.generic" */
  metadata_generic_aggregate: App_Loader_Metadata_Generic_Aggregate;
  /** fetch data from the table: "metadata.generic" using primary key columns */
  metadata_generic_by_pk?: Maybe<App_Loader_Metadata_Generic>;
  /** fetch data from the table: "metadata.generic_module_type" */
  metadata_generic_module_type: Array<App_Loader_Metadata_Generic_Module_Type>;
  /** fetch aggregated fields from the table: "metadata.generic_module_type" */
  metadata_generic_module_type_aggregate: App_Loader_Metadata_Generic_Module_Type_Aggregate;
  /** fetch data from the table: "metadata.generic_module_type" using primary key columns */
  metadata_generic_module_type_by_pk?: Maybe<App_Loader_Metadata_Generic_Module_Type>;
  /** fetch data from the table: "metadata.pype" */
  metadata_pype: Array<App_Loader_Metadata_Pype>;
  /** fetch aggregated fields from the table: "metadata.pype" */
  metadata_pype_aggregate: App_Loader_Metadata_Pype_Aggregate;
  /** fetch data from the table: "metadata.pype" using primary key columns */
  metadata_pype_by_pk?: Maybe<App_Loader_Metadata_Pype>;
  /** fetch data from the table: "metadata.pype_type" */
  metadata_pype_type: Array<App_Loader_Metadata_Pype_Type>;
  /** fetch aggregated fields from the table: "metadata.pype_type" */
  metadata_pype_type_aggregate: App_Loader_Metadata_Pype_Type_Aggregate;
  /** fetch data from the table: "metadata.pype_type" using primary key columns */
  metadata_pype_type_by_pk?: Maybe<App_Loader_Metadata_Pype_Type>;
  /** fetch data from the table: "n_analytic_package_configuration" */
  n_analytic_package_configuration: Array<App_Loader_N_Analytic_Package_Configuration>;
  /** fetch aggregated fields from the table: "n_analytic_package_configuration" */
  n_analytic_package_configuration_aggregate: App_Loader_N_Analytic_Package_Configuration_Aggregate;
  /** fetch data from the table: "n_analytic_package_configuration" using primary key columns */
  n_analytic_package_configuration_by_pk?: Maybe<App_Loader_N_Analytic_Package_Configuration>;
  /** fetch data from the table: "n_application" */
  n_application: Array<App_Loader_N_Application>;
  /** fetch aggregated fields from the table: "n_application" */
  n_application_aggregate: App_Loader_N_Application_Aggregate;
  /** fetch data from the table: "n_application" using primary key columns */
  n_application_by_pk?: Maybe<App_Loader_N_Application>;
  /** fetch data from the table: "n_domain" */
  n_domain: Array<App_Loader_N_Domain>;
  /** fetch aggregated fields from the table: "n_domain" */
  n_domain_aggregate: App_Loader_N_Domain_Aggregate;
  /** fetch data from the table: "n_domain" using primary key columns */
  n_domain_by_pk?: Maybe<App_Loader_N_Domain>;
  /** fetch data from the table: "n_package" */
  n_package: Array<App_Loader_N_Package>;
  /** fetch aggregated fields from the table: "n_package" */
  n_package_aggregate: App_Loader_N_Package_Aggregate;
  /** fetch data from the table: "n_package" using primary key columns */
  n_package_by_pk?: Maybe<App_Loader_N_Package>;
  /** fetch data from the table: "n_pype_package_configuration" */
  n_pype_package_configuration: Array<App_Loader_N_Pype_Package_Configuration>;
  /** fetch aggregated fields from the table: "n_pype_package_configuration" */
  n_pype_package_configuration_aggregate: App_Loader_N_Pype_Package_Configuration_Aggregate;
  /** fetch data from the table: "n_pype_package_configuration" using primary key columns */
  n_pype_package_configuration_by_pk?: Maybe<App_Loader_N_Pype_Package_Configuration>;
  /** An array relationship */
  target: Array<App_Loader_Target>;
  /** An aggregate relationship */
  target_aggregate: App_Loader_Target_Aggregate;
  /** fetch data from the table: "target" using primary key columns */
  target_by_pk?: Maybe<App_Loader_Target>;
  /** fetch data from the table: "target_type" */
  target_type: Array<App_Loader_Target_Type>;
  /** fetch aggregated fields from the table: "target_type" */
  target_type_aggregate: App_Loader_Target_Type_Aggregate;
  /** fetch data from the table: "target_type" using primary key columns */
  target_type_by_pk?: Maybe<App_Loader_Target_Type>;
};


export type App_Loader_Query_RootAppArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_App_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_App_Order_By>>;
  where?: InputMaybe<App_Loader_App_Bool_Exp>;
};


export type App_Loader_Query_RootApp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_App_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_App_Order_By>>;
  where?: InputMaybe<App_Loader_App_Bool_Exp>;
};


export type App_Loader_Query_RootApp_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Query_RootConditionsArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Conditions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Conditions_Order_By>>;
  where?: InputMaybe<App_Loader_Conditions_Bool_Exp>;
};


export type App_Loader_Query_RootConditions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Conditions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Conditions_Order_By>>;
  where?: InputMaybe<App_Loader_Conditions_Bool_Exp>;
};


export type App_Loader_Query_RootConditions_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Query_RootCustomerArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Customer_Order_By>>;
  where?: InputMaybe<App_Loader_Customer_Bool_Exp>;
};


export type App_Loader_Query_RootCustomer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Customer_Order_By>>;
  where?: InputMaybe<App_Loader_Customer_Bool_Exp>;
};


export type App_Loader_Query_RootCustomer_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Query_RootDeploymentArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Deployment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Deployment_Order_By>>;
  where?: InputMaybe<App_Loader_Deployment_Bool_Exp>;
};


export type App_Loader_Query_RootDeployment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Deployment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Deployment_Order_By>>;
  where?: InputMaybe<App_Loader_Deployment_Bool_Exp>;
};


export type App_Loader_Query_RootDeployment_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Query_RootEnvironmentArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Environment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Environment_Order_By>>;
  where?: InputMaybe<App_Loader_Environment_Bool_Exp>;
};


export type App_Loader_Query_RootEnvironment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Environment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Environment_Order_By>>;
  where?: InputMaybe<App_Loader_Environment_Bool_Exp>;
};


export type App_Loader_Query_RootEnvironment_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Query_RootLatest_Schema_Anonymous_SessionArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Latest_Schema_Anonymous_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Latest_Schema_Anonymous_Session_Order_By>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp>;
};


export type App_Loader_Query_RootLatest_Schema_Anonymous_Session_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Latest_Schema_Anonymous_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Latest_Schema_Anonymous_Session_Order_By>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp>;
};


export type App_Loader_Query_RootLatest_Schema_Anonymous_Session_By_PkArgs = {
  session_id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Query_RootLatest_Schema_PackagesArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Order_By>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Packages_Bool_Exp>;
};


export type App_Loader_Query_RootLatest_Schema_Packages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Order_By>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Packages_Bool_Exp>;
};


export type App_Loader_Query_RootLatest_Schema_Packages_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type App_Loader_Query_RootLatest_Schema_Packages_TypeArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Bool_Exp>;
};


export type App_Loader_Query_RootLatest_Schema_Packages_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Bool_Exp>;
};


export type App_Loader_Query_RootLatest_Schema_Packages_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type App_Loader_Query_RootMetadata_AnalyticsArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Analytics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Analytics_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Analytics_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Analytics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Analytics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Analytics_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Analytics_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Analytics_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Query_RootMetadata_Cc_Position_OptionArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Cc_Position_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Cc_Position_Option_By_PkArgs = {
  position: Scalars['String']['input'];
};


export type App_Loader_Query_RootMetadata_Cc_WidgetArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Cc_Widget_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Cc_Widget_Bubble_TypeArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Cc_Widget_Bubble_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Cc_Widget_Bubble_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type App_Loader_Query_RootMetadata_Cc_Widget_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Query_RootMetadata_GenericArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Generic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Generic_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Generic_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Generic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Generic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Generic_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Generic_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Generic_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Query_RootMetadata_Generic_Module_TypeArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Generic_Module_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Generic_Module_Type_By_PkArgs = {
  moduleType: Scalars['String']['input'];
};


export type App_Loader_Query_RootMetadata_PypeArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Pype_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Pype_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Pype_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Pype_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Pype_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Pype_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Query_RootMetadata_Pype_TypeArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Pype_Type_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Pype_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Pype_Type_Bool_Exp>;
};


export type App_Loader_Query_RootMetadata_Pype_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type App_Loader_Query_RootN_Analytic_Package_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Analytic_Package_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Analytic_Package_Configuration_Order_By>>;
  where?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Bool_Exp>;
};


export type App_Loader_Query_RootN_Analytic_Package_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Analytic_Package_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Analytic_Package_Configuration_Order_By>>;
  where?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Bool_Exp>;
};


export type App_Loader_Query_RootN_Analytic_Package_Configuration_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Query_RootN_ApplicationArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Application_Order_By>>;
  where?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
};


export type App_Loader_Query_RootN_Application_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Application_Order_By>>;
  where?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
};


export type App_Loader_Query_RootN_Application_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Query_RootN_DomainArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Domain_Order_By>>;
  where?: InputMaybe<App_Loader_N_Domain_Bool_Exp>;
};


export type App_Loader_Query_RootN_Domain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Domain_Order_By>>;
  where?: InputMaybe<App_Loader_N_Domain_Bool_Exp>;
};


export type App_Loader_Query_RootN_Domain_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Query_RootN_PackageArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Package_Order_By>>;
  where?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
};


export type App_Loader_Query_RootN_Package_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Package_Order_By>>;
  where?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
};


export type App_Loader_Query_RootN_Package_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Query_RootN_Pype_Package_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Pype_Package_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Pype_Package_Configuration_Order_By>>;
  where?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Bool_Exp>;
};


export type App_Loader_Query_RootN_Pype_Package_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Pype_Package_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Pype_Package_Configuration_Order_By>>;
  where?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Bool_Exp>;
};


export type App_Loader_Query_RootN_Pype_Package_Configuration_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Query_RootTargetArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Target_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Target_Order_By>>;
  where?: InputMaybe<App_Loader_Target_Bool_Exp>;
};


export type App_Loader_Query_RootTarget_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Target_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Target_Order_By>>;
  where?: InputMaybe<App_Loader_Target_Bool_Exp>;
};


export type App_Loader_Query_RootTarget_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Query_RootTarget_TypeArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Target_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Target_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Target_Type_Bool_Exp>;
};


export type App_Loader_Query_RootTarget_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Target_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Target_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Target_Type_Bool_Exp>;
};


export type App_Loader_Query_RootTarget_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};

export type App_Loader_Subscription_Root = {
  __typename?: 'app_loader_subscription_root';
  /** fetch data from the table: "app" */
  app: Array<App_Loader_App>;
  /** fetch aggregated fields from the table: "app" */
  app_aggregate: App_Loader_App_Aggregate;
  /** fetch data from the table: "app" using primary key columns */
  app_by_pk?: Maybe<App_Loader_App>;
  /** fetch data from the table in a streaming manner: "app" */
  app_stream: Array<App_Loader_App>;
  /** fetch data from the table: "conditions" */
  conditions: Array<App_Loader_Conditions>;
  /** fetch aggregated fields from the table: "conditions" */
  conditions_aggregate: App_Loader_Conditions_Aggregate;
  /** fetch data from the table: "conditions" using primary key columns */
  conditions_by_pk?: Maybe<App_Loader_Conditions>;
  /** fetch data from the table in a streaming manner: "conditions" */
  conditions_stream: Array<App_Loader_Conditions>;
  /** fetch data from the table: "customer" */
  customer: Array<App_Loader_Customer>;
  /** fetch aggregated fields from the table: "customer" */
  customer_aggregate: App_Loader_Customer_Aggregate;
  /** fetch data from the table: "customer" using primary key columns */
  customer_by_pk?: Maybe<App_Loader_Customer>;
  /** fetch data from the table in a streaming manner: "customer" */
  customer_stream: Array<App_Loader_Customer>;
  /** fetch data from the table: "deployment" */
  deployment: Array<App_Loader_Deployment>;
  /** fetch aggregated fields from the table: "deployment" */
  deployment_aggregate: App_Loader_Deployment_Aggregate;
  /** fetch data from the table: "deployment" using primary key columns */
  deployment_by_pk?: Maybe<App_Loader_Deployment>;
  /** fetch data from the table in a streaming manner: "deployment" */
  deployment_stream: Array<App_Loader_Deployment>;
  /** An array relationship */
  environment: Array<App_Loader_Environment>;
  /** An aggregate relationship */
  environment_aggregate: App_Loader_Environment_Aggregate;
  /** fetch data from the table: "environment" using primary key columns */
  environment_by_pk?: Maybe<App_Loader_Environment>;
  /** fetch data from the table in a streaming manner: "environment" */
  environment_stream: Array<App_Loader_Environment>;
  /** fetch data from the table: "latest_schema.anonymous_session" */
  latest_schema_anonymous_session: Array<App_Loader_Latest_Schema_Anonymous_Session>;
  /** fetch aggregated fields from the table: "latest_schema.anonymous_session" */
  latest_schema_anonymous_session_aggregate: App_Loader_Latest_Schema_Anonymous_Session_Aggregate;
  /** fetch data from the table: "latest_schema.anonymous_session" using primary key columns */
  latest_schema_anonymous_session_by_pk?: Maybe<App_Loader_Latest_Schema_Anonymous_Session>;
  /** fetch data from the table in a streaming manner: "latest_schema.anonymous_session" */
  latest_schema_anonymous_session_stream: Array<App_Loader_Latest_Schema_Anonymous_Session>;
  /** fetch data from the table: "latest_schema.packages" */
  latest_schema_packages: Array<App_Loader_Latest_Schema_Packages>;
  /** fetch aggregated fields from the table: "latest_schema.packages" */
  latest_schema_packages_aggregate: App_Loader_Latest_Schema_Packages_Aggregate;
  /** fetch data from the table: "latest_schema.packages" using primary key columns */
  latest_schema_packages_by_pk?: Maybe<App_Loader_Latest_Schema_Packages>;
  /** fetch data from the table in a streaming manner: "latest_schema.packages" */
  latest_schema_packages_stream: Array<App_Loader_Latest_Schema_Packages>;
  /** fetch data from the table: "latest_schema.packages_type" */
  latest_schema_packages_type: Array<App_Loader_Latest_Schema_Packages_Type>;
  /** fetch aggregated fields from the table: "latest_schema.packages_type" */
  latest_schema_packages_type_aggregate: App_Loader_Latest_Schema_Packages_Type_Aggregate;
  /** fetch data from the table: "latest_schema.packages_type" using primary key columns */
  latest_schema_packages_type_by_pk?: Maybe<App_Loader_Latest_Schema_Packages_Type>;
  /** fetch data from the table in a streaming manner: "latest_schema.packages_type" */
  latest_schema_packages_type_stream: Array<App_Loader_Latest_Schema_Packages_Type>;
  /** fetch data from the table: "metadata.analytics" */
  metadata_analytics: Array<App_Loader_Metadata_Analytics>;
  /** fetch aggregated fields from the table: "metadata.analytics" */
  metadata_analytics_aggregate: App_Loader_Metadata_Analytics_Aggregate;
  /** fetch data from the table: "metadata.analytics" using primary key columns */
  metadata_analytics_by_pk?: Maybe<App_Loader_Metadata_Analytics>;
  /** fetch data from the table in a streaming manner: "metadata.analytics" */
  metadata_analytics_stream: Array<App_Loader_Metadata_Analytics>;
  /** fetch data from the table: "metadata.cc_position_option" */
  metadata_cc_position_option: Array<App_Loader_Metadata_Cc_Position_Option>;
  /** fetch aggregated fields from the table: "metadata.cc_position_option" */
  metadata_cc_position_option_aggregate: App_Loader_Metadata_Cc_Position_Option_Aggregate;
  /** fetch data from the table: "metadata.cc_position_option" using primary key columns */
  metadata_cc_position_option_by_pk?: Maybe<App_Loader_Metadata_Cc_Position_Option>;
  /** fetch data from the table in a streaming manner: "metadata.cc_position_option" */
  metadata_cc_position_option_stream: Array<App_Loader_Metadata_Cc_Position_Option>;
  /** fetch data from the table: "metadata.cc_widget" */
  metadata_cc_widget: Array<App_Loader_Metadata_Cc_Widget>;
  /** fetch aggregated fields from the table: "metadata.cc_widget" */
  metadata_cc_widget_aggregate: App_Loader_Metadata_Cc_Widget_Aggregate;
  /** fetch data from the table: "metadata.cc_widget_bubble_type" */
  metadata_cc_widget_bubble_type: Array<App_Loader_Metadata_Cc_Widget_Bubble_Type>;
  /** fetch aggregated fields from the table: "metadata.cc_widget_bubble_type" */
  metadata_cc_widget_bubble_type_aggregate: App_Loader_Metadata_Cc_Widget_Bubble_Type_Aggregate;
  /** fetch data from the table: "metadata.cc_widget_bubble_type" using primary key columns */
  metadata_cc_widget_bubble_type_by_pk?: Maybe<App_Loader_Metadata_Cc_Widget_Bubble_Type>;
  /** fetch data from the table in a streaming manner: "metadata.cc_widget_bubble_type" */
  metadata_cc_widget_bubble_type_stream: Array<App_Loader_Metadata_Cc_Widget_Bubble_Type>;
  /** fetch data from the table: "metadata.cc_widget" using primary key columns */
  metadata_cc_widget_by_pk?: Maybe<App_Loader_Metadata_Cc_Widget>;
  /** fetch data from the table in a streaming manner: "metadata.cc_widget" */
  metadata_cc_widget_stream: Array<App_Loader_Metadata_Cc_Widget>;
  /** fetch data from the table: "metadata.generic" */
  metadata_generic: Array<App_Loader_Metadata_Generic>;
  /** fetch aggregated fields from the table: "metadata.generic" */
  metadata_generic_aggregate: App_Loader_Metadata_Generic_Aggregate;
  /** fetch data from the table: "metadata.generic" using primary key columns */
  metadata_generic_by_pk?: Maybe<App_Loader_Metadata_Generic>;
  /** fetch data from the table: "metadata.generic_module_type" */
  metadata_generic_module_type: Array<App_Loader_Metadata_Generic_Module_Type>;
  /** fetch aggregated fields from the table: "metadata.generic_module_type" */
  metadata_generic_module_type_aggregate: App_Loader_Metadata_Generic_Module_Type_Aggregate;
  /** fetch data from the table: "metadata.generic_module_type" using primary key columns */
  metadata_generic_module_type_by_pk?: Maybe<App_Loader_Metadata_Generic_Module_Type>;
  /** fetch data from the table in a streaming manner: "metadata.generic_module_type" */
  metadata_generic_module_type_stream: Array<App_Loader_Metadata_Generic_Module_Type>;
  /** fetch data from the table in a streaming manner: "metadata.generic" */
  metadata_generic_stream: Array<App_Loader_Metadata_Generic>;
  /** fetch data from the table: "metadata.pype" */
  metadata_pype: Array<App_Loader_Metadata_Pype>;
  /** fetch aggregated fields from the table: "metadata.pype" */
  metadata_pype_aggregate: App_Loader_Metadata_Pype_Aggregate;
  /** fetch data from the table: "metadata.pype" using primary key columns */
  metadata_pype_by_pk?: Maybe<App_Loader_Metadata_Pype>;
  /** fetch data from the table in a streaming manner: "metadata.pype" */
  metadata_pype_stream: Array<App_Loader_Metadata_Pype>;
  /** fetch data from the table: "metadata.pype_type" */
  metadata_pype_type: Array<App_Loader_Metadata_Pype_Type>;
  /** fetch aggregated fields from the table: "metadata.pype_type" */
  metadata_pype_type_aggregate: App_Loader_Metadata_Pype_Type_Aggregate;
  /** fetch data from the table: "metadata.pype_type" using primary key columns */
  metadata_pype_type_by_pk?: Maybe<App_Loader_Metadata_Pype_Type>;
  /** fetch data from the table in a streaming manner: "metadata.pype_type" */
  metadata_pype_type_stream: Array<App_Loader_Metadata_Pype_Type>;
  /** fetch data from the table: "n_analytic_package_configuration" */
  n_analytic_package_configuration: Array<App_Loader_N_Analytic_Package_Configuration>;
  /** fetch aggregated fields from the table: "n_analytic_package_configuration" */
  n_analytic_package_configuration_aggregate: App_Loader_N_Analytic_Package_Configuration_Aggregate;
  /** fetch data from the table: "n_analytic_package_configuration" using primary key columns */
  n_analytic_package_configuration_by_pk?: Maybe<App_Loader_N_Analytic_Package_Configuration>;
  /** fetch data from the table in a streaming manner: "n_analytic_package_configuration" */
  n_analytic_package_configuration_stream: Array<App_Loader_N_Analytic_Package_Configuration>;
  /** fetch data from the table: "n_application" */
  n_application: Array<App_Loader_N_Application>;
  /** fetch aggregated fields from the table: "n_application" */
  n_application_aggregate: App_Loader_N_Application_Aggregate;
  /** fetch data from the table: "n_application" using primary key columns */
  n_application_by_pk?: Maybe<App_Loader_N_Application>;
  /** fetch data from the table in a streaming manner: "n_application" */
  n_application_stream: Array<App_Loader_N_Application>;
  /** fetch data from the table: "n_domain" */
  n_domain: Array<App_Loader_N_Domain>;
  /** fetch aggregated fields from the table: "n_domain" */
  n_domain_aggregate: App_Loader_N_Domain_Aggregate;
  /** fetch data from the table: "n_domain" using primary key columns */
  n_domain_by_pk?: Maybe<App_Loader_N_Domain>;
  /** fetch data from the table in a streaming manner: "n_domain" */
  n_domain_stream: Array<App_Loader_N_Domain>;
  /** fetch data from the table: "n_package" */
  n_package: Array<App_Loader_N_Package>;
  /** fetch aggregated fields from the table: "n_package" */
  n_package_aggregate: App_Loader_N_Package_Aggregate;
  /** fetch data from the table: "n_package" using primary key columns */
  n_package_by_pk?: Maybe<App_Loader_N_Package>;
  /** fetch data from the table in a streaming manner: "n_package" */
  n_package_stream: Array<App_Loader_N_Package>;
  /** fetch data from the table: "n_pype_package_configuration" */
  n_pype_package_configuration: Array<App_Loader_N_Pype_Package_Configuration>;
  /** fetch aggregated fields from the table: "n_pype_package_configuration" */
  n_pype_package_configuration_aggregate: App_Loader_N_Pype_Package_Configuration_Aggregate;
  /** fetch data from the table: "n_pype_package_configuration" using primary key columns */
  n_pype_package_configuration_by_pk?: Maybe<App_Loader_N_Pype_Package_Configuration>;
  /** fetch data from the table in a streaming manner: "n_pype_package_configuration" */
  n_pype_package_configuration_stream: Array<App_Loader_N_Pype_Package_Configuration>;
  /** An array relationship */
  target: Array<App_Loader_Target>;
  /** An aggregate relationship */
  target_aggregate: App_Loader_Target_Aggregate;
  /** fetch data from the table: "target" using primary key columns */
  target_by_pk?: Maybe<App_Loader_Target>;
  /** fetch data from the table in a streaming manner: "target" */
  target_stream: Array<App_Loader_Target>;
  /** fetch data from the table: "target_type" */
  target_type: Array<App_Loader_Target_Type>;
  /** fetch aggregated fields from the table: "target_type" */
  target_type_aggregate: App_Loader_Target_Type_Aggregate;
  /** fetch data from the table: "target_type" using primary key columns */
  target_type_by_pk?: Maybe<App_Loader_Target_Type>;
  /** fetch data from the table in a streaming manner: "target_type" */
  target_type_stream: Array<App_Loader_Target_Type>;
};


export type App_Loader_Subscription_RootAppArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_App_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_App_Order_By>>;
  where?: InputMaybe<App_Loader_App_Bool_Exp>;
};


export type App_Loader_Subscription_RootApp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_App_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_App_Order_By>>;
  where?: InputMaybe<App_Loader_App_Bool_Exp>;
};


export type App_Loader_Subscription_RootApp_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Subscription_RootApp_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_App_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_App_Bool_Exp>;
};


export type App_Loader_Subscription_RootConditionsArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Conditions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Conditions_Order_By>>;
  where?: InputMaybe<App_Loader_Conditions_Bool_Exp>;
};


export type App_Loader_Subscription_RootConditions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Conditions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Conditions_Order_By>>;
  where?: InputMaybe<App_Loader_Conditions_Bool_Exp>;
};


export type App_Loader_Subscription_RootConditions_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Subscription_RootConditions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Conditions_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Conditions_Bool_Exp>;
};


export type App_Loader_Subscription_RootCustomerArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Customer_Order_By>>;
  where?: InputMaybe<App_Loader_Customer_Bool_Exp>;
};


export type App_Loader_Subscription_RootCustomer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Customer_Order_By>>;
  where?: InputMaybe<App_Loader_Customer_Bool_Exp>;
};


export type App_Loader_Subscription_RootCustomer_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Subscription_RootCustomer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Customer_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Customer_Bool_Exp>;
};


export type App_Loader_Subscription_RootDeploymentArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Deployment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Deployment_Order_By>>;
  where?: InputMaybe<App_Loader_Deployment_Bool_Exp>;
};


export type App_Loader_Subscription_RootDeployment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Deployment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Deployment_Order_By>>;
  where?: InputMaybe<App_Loader_Deployment_Bool_Exp>;
};


export type App_Loader_Subscription_RootDeployment_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Subscription_RootDeployment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Deployment_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Deployment_Bool_Exp>;
};


export type App_Loader_Subscription_RootEnvironmentArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Environment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Environment_Order_By>>;
  where?: InputMaybe<App_Loader_Environment_Bool_Exp>;
};


export type App_Loader_Subscription_RootEnvironment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Environment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Environment_Order_By>>;
  where?: InputMaybe<App_Loader_Environment_Bool_Exp>;
};


export type App_Loader_Subscription_RootEnvironment_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Subscription_RootEnvironment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Environment_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Environment_Bool_Exp>;
};


export type App_Loader_Subscription_RootLatest_Schema_Anonymous_SessionArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Latest_Schema_Anonymous_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Latest_Schema_Anonymous_Session_Order_By>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp>;
};


export type App_Loader_Subscription_RootLatest_Schema_Anonymous_Session_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Latest_Schema_Anonymous_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Latest_Schema_Anonymous_Session_Order_By>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp>;
};


export type App_Loader_Subscription_RootLatest_Schema_Anonymous_Session_By_PkArgs = {
  session_id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Subscription_RootLatest_Schema_Anonymous_Session_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Anonymous_Session_Bool_Exp>;
};


export type App_Loader_Subscription_RootLatest_Schema_PackagesArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Order_By>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Packages_Bool_Exp>;
};


export type App_Loader_Subscription_RootLatest_Schema_Packages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Order_By>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Packages_Bool_Exp>;
};


export type App_Loader_Subscription_RootLatest_Schema_Packages_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type App_Loader_Subscription_RootLatest_Schema_Packages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Latest_Schema_Packages_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Packages_Bool_Exp>;
};


export type App_Loader_Subscription_RootLatest_Schema_Packages_TypeArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootLatest_Schema_Packages_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Latest_Schema_Packages_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootLatest_Schema_Packages_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type App_Loader_Subscription_RootLatest_Schema_Packages_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Latest_Schema_Packages_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Latest_Schema_Packages_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_AnalyticsArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Analytics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Analytics_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Analytics_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Analytics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Analytics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Analytics_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Analytics_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Analytics_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Subscription_RootMetadata_Analytics_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Metadata_Analytics_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Metadata_Analytics_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Cc_Position_OptionArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Cc_Position_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Cc_Position_Option_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Cc_Position_Option_By_PkArgs = {
  position: Scalars['String']['input'];
};


export type App_Loader_Subscription_RootMetadata_Cc_Position_Option_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Metadata_Cc_Position_Option_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Position_Option_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Cc_WidgetArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Cc_Widget_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Cc_Widget_Bubble_TypeArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Cc_Widget_Bubble_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Cc_Widget_Bubble_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Cc_Widget_Bubble_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type App_Loader_Subscription_RootMetadata_Cc_Widget_Bubble_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bubble_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Cc_Widget_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Subscription_RootMetadata_Cc_Widget_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Metadata_Cc_Widget_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_GenericArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Generic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Generic_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Generic_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Generic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Generic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Generic_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Generic_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Generic_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Subscription_RootMetadata_Generic_Module_TypeArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Generic_Module_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Generic_Module_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Generic_Module_Type_By_PkArgs = {
  moduleType: Scalars['String']['input'];
};


export type App_Loader_Subscription_RootMetadata_Generic_Module_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Metadata_Generic_Module_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Metadata_Generic_Module_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Generic_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Metadata_Generic_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Metadata_Generic_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_PypeArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Pype_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Pype_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Pype_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Pype_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Pype_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Pype_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Subscription_RootMetadata_Pype_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Metadata_Pype_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Metadata_Pype_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Pype_TypeArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Pype_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Pype_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Metadata_Pype_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Metadata_Pype_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootMetadata_Pype_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type App_Loader_Subscription_RootMetadata_Pype_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Metadata_Pype_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Metadata_Pype_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_Analytic_Package_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Analytic_Package_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Analytic_Package_Configuration_Order_By>>;
  where?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_Analytic_Package_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Analytic_Package_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Analytic_Package_Configuration_Order_By>>;
  where?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_Analytic_Package_Configuration_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Subscription_RootN_Analytic_Package_Configuration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_N_Analytic_Package_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_N_Analytic_Package_Configuration_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_ApplicationArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Application_Order_By>>;
  where?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_Application_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Application_Order_By>>;
  where?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_Application_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Subscription_RootN_Application_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_N_Application_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_N_Application_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_DomainArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Domain_Order_By>>;
  where?: InputMaybe<App_Loader_N_Domain_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_Domain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Domain_Order_By>>;
  where?: InputMaybe<App_Loader_N_Domain_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_Domain_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Subscription_RootN_Domain_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_N_Domain_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_N_Domain_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_PackageArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Package_Order_By>>;
  where?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_Package_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Package_Order_By>>;
  where?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_Package_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Subscription_RootN_Package_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_N_Package_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_N_Package_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_Pype_Package_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Pype_Package_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Pype_Package_Configuration_Order_By>>;
  where?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_Pype_Package_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_N_Pype_Package_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_N_Pype_Package_Configuration_Order_By>>;
  where?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Bool_Exp>;
};


export type App_Loader_Subscription_RootN_Pype_Package_Configuration_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type App_Loader_Subscription_RootN_Pype_Package_Configuration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_N_Pype_Package_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_N_Pype_Package_Configuration_Bool_Exp>;
};


export type App_Loader_Subscription_RootTargetArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Target_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Target_Order_By>>;
  where?: InputMaybe<App_Loader_Target_Bool_Exp>;
};


export type App_Loader_Subscription_RootTarget_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Target_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Target_Order_By>>;
  where?: InputMaybe<App_Loader_Target_Bool_Exp>;
};


export type App_Loader_Subscription_RootTarget_By_PkArgs = {
  id: Scalars['app_loader_uuid']['input'];
};


export type App_Loader_Subscription_RootTarget_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Target_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Target_Bool_Exp>;
};


export type App_Loader_Subscription_RootTarget_TypeArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Target_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Target_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Target_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootTarget_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Loader_Target_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Loader_Target_Type_Order_By>>;
  where?: InputMaybe<App_Loader_Target_Type_Bool_Exp>;
};


export type App_Loader_Subscription_RootTarget_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type App_Loader_Subscription_RootTarget_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Loader_Target_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Loader_Target_Type_Bool_Exp>;
};

/** columns and relationships of "target" */
export type App_Loader_Target = {
  __typename?: 'app_loader_target';
  /** An object relationship */
  analytics?: Maybe<App_Loader_Metadata_Analytics>;
  /** An object relationship */
  ccWidget?: Maybe<App_Loader_Metadata_Cc_Widget>;
  envId: Scalars['app_loader_uuid']['output'];
  /** An object relationship */
  environment?: Maybe<App_Loader_Environment>;
  /** An object relationship */
  generic?: Maybe<App_Loader_Metadata_Generic>;
  id: Scalars['app_loader_uuid']['output'];
  /** An object relationship */
  pype?: Maybe<App_Loader_Metadata_Pype>;
  type: App_Loader_Target_Type_Enum;
};

/** aggregated selection of "target" */
export type App_Loader_Target_Aggregate = {
  __typename?: 'app_loader_target_aggregate';
  aggregate?: Maybe<App_Loader_Target_Aggregate_Fields>;
  nodes: Array<App_Loader_Target>;
};

export type App_Loader_Target_Aggregate_Bool_Exp = {
  count?: InputMaybe<App_Loader_Target_Aggregate_Bool_Exp_Count>;
};

export type App_Loader_Target_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<App_Loader_Target_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<App_Loader_Target_Bool_Exp>;
  predicate: App_Loader_Int_Comparison_Exp;
};

/** aggregate fields of "target" */
export type App_Loader_Target_Aggregate_Fields = {
  __typename?: 'app_loader_target_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Target_Max_Fields>;
  min?: Maybe<App_Loader_Target_Min_Fields>;
};


/** aggregate fields of "target" */
export type App_Loader_Target_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Target_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "target" */
export type App_Loader_Target_Aggregate_Order_By = {
  count?: InputMaybe<App_Loader_Order_By>;
  max?: InputMaybe<App_Loader_Target_Max_Order_By>;
  min?: InputMaybe<App_Loader_Target_Min_Order_By>;
};

/** input type for inserting array relation for remote table "target" */
export type App_Loader_Target_Arr_Rel_Insert_Input = {
  data: Array<App_Loader_Target_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<App_Loader_Target_On_Conflict>;
};

/** Boolean expression to filter rows from the table "target". All fields are combined with a logical 'AND'. */
export type App_Loader_Target_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Target_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Target_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Target_Bool_Exp>>;
  analytics?: InputMaybe<App_Loader_Metadata_Analytics_Bool_Exp>;
  ccWidget?: InputMaybe<App_Loader_Metadata_Cc_Widget_Bool_Exp>;
  envId?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  environment?: InputMaybe<App_Loader_Environment_Bool_Exp>;
  generic?: InputMaybe<App_Loader_Metadata_Generic_Bool_Exp>;
  id?: InputMaybe<App_Loader_Uuid_Comparison_Exp>;
  pype?: InputMaybe<App_Loader_Metadata_Pype_Bool_Exp>;
  type?: InputMaybe<App_Loader_Target_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "target" */
export enum App_Loader_Target_Constraint {
  /** unique or primary key constraint on columns "id" */
  TargetPkey = 'target_pkey'
}

/** input type for inserting data into table "target" */
export type App_Loader_Target_Insert_Input = {
  analytics?: InputMaybe<App_Loader_Metadata_Analytics_Obj_Rel_Insert_Input>;
  ccWidget?: InputMaybe<App_Loader_Metadata_Cc_Widget_Obj_Rel_Insert_Input>;
  envId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  environment?: InputMaybe<App_Loader_Environment_Obj_Rel_Insert_Input>;
  generic?: InputMaybe<App_Loader_Metadata_Generic_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  pype?: InputMaybe<App_Loader_Metadata_Pype_Obj_Rel_Insert_Input>;
  type?: InputMaybe<App_Loader_Target_Type_Enum>;
};

/** aggregate max on columns */
export type App_Loader_Target_Max_Fields = {
  __typename?: 'app_loader_target_max_fields';
  envId?: Maybe<Scalars['app_loader_uuid']['output']>;
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
};

/** order by max() on columns of table "target" */
export type App_Loader_Target_Max_Order_By = {
  envId?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** aggregate min on columns */
export type App_Loader_Target_Min_Fields = {
  __typename?: 'app_loader_target_min_fields';
  envId?: Maybe<Scalars['app_loader_uuid']['output']>;
  id?: Maybe<Scalars['app_loader_uuid']['output']>;
};

/** order by min() on columns of table "target" */
export type App_Loader_Target_Min_Order_By = {
  envId?: InputMaybe<App_Loader_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
};

/** response of any mutation on the table "target" */
export type App_Loader_Target_Mutation_Response = {
  __typename?: 'app_loader_target_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Target>;
};

/** on_conflict condition type for table "target" */
export type App_Loader_Target_On_Conflict = {
  constraint: App_Loader_Target_Constraint;
  update_columns?: Array<App_Loader_Target_Update_Column>;
  where?: InputMaybe<App_Loader_Target_Bool_Exp>;
};

/** Ordering options when selecting data from "target". */
export type App_Loader_Target_Order_By = {
  analytics?: InputMaybe<App_Loader_Metadata_Analytics_Order_By>;
  ccWidget?: InputMaybe<App_Loader_Metadata_Cc_Widget_Order_By>;
  envId?: InputMaybe<App_Loader_Order_By>;
  environment?: InputMaybe<App_Loader_Environment_Order_By>;
  generic?: InputMaybe<App_Loader_Metadata_Generic_Order_By>;
  id?: InputMaybe<App_Loader_Order_By>;
  pype?: InputMaybe<App_Loader_Metadata_Pype_Order_By>;
  type?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: target */
export type App_Loader_Target_Pk_Columns_Input = {
  id: Scalars['app_loader_uuid']['input'];
};

/** select columns of table "target" */
export enum App_Loader_Target_Select_Column {
  /** column name */
  EnvId = 'envId',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "target" */
export type App_Loader_Target_Set_Input = {
  envId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  type?: InputMaybe<App_Loader_Target_Type_Enum>;
};

/** Streaming cursor of the table "target" */
export type App_Loader_Target_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Target_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Target_Stream_Cursor_Value_Input = {
  envId?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  id?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  type?: InputMaybe<App_Loader_Target_Type_Enum>;
};

/** columns and relationships of "target_type" */
export type App_Loader_Target_Type = {
  __typename?: 'app_loader_target_type';
  name: Scalars['String']['output'];
};

/** aggregated selection of "target_type" */
export type App_Loader_Target_Type_Aggregate = {
  __typename?: 'app_loader_target_type_aggregate';
  aggregate?: Maybe<App_Loader_Target_Type_Aggregate_Fields>;
  nodes: Array<App_Loader_Target_Type>;
};

/** aggregate fields of "target_type" */
export type App_Loader_Target_Type_Aggregate_Fields = {
  __typename?: 'app_loader_target_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Loader_Target_Type_Max_Fields>;
  min?: Maybe<App_Loader_Target_Type_Min_Fields>;
};


/** aggregate fields of "target_type" */
export type App_Loader_Target_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Loader_Target_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "target_type". All fields are combined with a logical 'AND'. */
export type App_Loader_Target_Type_Bool_Exp = {
  _and?: InputMaybe<Array<App_Loader_Target_Type_Bool_Exp>>;
  _not?: InputMaybe<App_Loader_Target_Type_Bool_Exp>;
  _or?: InputMaybe<Array<App_Loader_Target_Type_Bool_Exp>>;
  name?: InputMaybe<App_Loader_String_Comparison_Exp>;
};

/** unique or primary key constraints on table "target_type" */
export enum App_Loader_Target_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  PlatformEnumPkey = 'platform_enum_pkey'
}

export enum App_Loader_Target_Type_Enum {
  Analytics = 'Analytics',
  CcWidget = 'CCWidget',
  Generic = 'Generic',
  Pype = 'Pype'
}

/** Boolean expression to compare columns of type "target_type_enum". All fields are combined with logical 'AND'. */
export type App_Loader_Target_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<App_Loader_Target_Type_Enum>;
  _in?: InputMaybe<Array<App_Loader_Target_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<App_Loader_Target_Type_Enum>;
  _nin?: InputMaybe<Array<App_Loader_Target_Type_Enum>>;
};

/** input type for inserting data into table "target_type" */
export type App_Loader_Target_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Loader_Target_Type_Max_Fields = {
  __typename?: 'app_loader_target_type_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Loader_Target_Type_Min_Fields = {
  __typename?: 'app_loader_target_type_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "target_type" */
export type App_Loader_Target_Type_Mutation_Response = {
  __typename?: 'app_loader_target_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Loader_Target_Type>;
};

/** on_conflict condition type for table "target_type" */
export type App_Loader_Target_Type_On_Conflict = {
  constraint: App_Loader_Target_Type_Constraint;
  update_columns?: Array<App_Loader_Target_Type_Update_Column>;
  where?: InputMaybe<App_Loader_Target_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "target_type". */
export type App_Loader_Target_Type_Order_By = {
  name?: InputMaybe<App_Loader_Order_By>;
};

/** primary key columns input for table: target_type */
export type App_Loader_Target_Type_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "target_type" */
export enum App_Loader_Target_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "target_type" */
export type App_Loader_Target_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "target_type" */
export type App_Loader_Target_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Loader_Target_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<App_Loader_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Loader_Target_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "target_type" */
export enum App_Loader_Target_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type App_Loader_Target_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Target_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Target_Type_Bool_Exp;
};

/** update columns of table "target" */
export enum App_Loader_Target_Update_Column {
  /** column name */
  EnvId = 'envId',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

export type App_Loader_Target_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Loader_Target_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Loader_Target_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type App_Loader_Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  _gt?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  _gte?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['app_loader_uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  _lte?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  _neq?: InputMaybe<Scalars['app_loader_uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['app_loader_uuid']['input']>>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  admin_?: Maybe<Admin_Mutation>;
  app_loader_?: Maybe<App_Loader_Mutation_Root>;
  deleteBotAssetById?: Maybe<Asset>;
  deleteBotById?: Maybe<Bot>;
  deleteCustomerById: Scalars['String']['output'];
  /** customer. */
  deleteCustomerPackages?: Maybe<BotManagerCustomer>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  deleteOneIntent?: Maybe<Version>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  deleteOneSynonym?: Maybe<Version>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  deleteOneTypeEntity?: Maybe<Version>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  deleteOneUtterance?: Maybe<Version>;
  /** Agent unregister */
  deleteV3BusinessAgent: Scalars['String']['output'];
  /** Agent unregister */
  deleteV3BusinessAgentSandbox: Scalars['String']['output'];
  /** delete a channel */
  deleteV3ConfigurationCustomersCustomerIdChannelChannelId: Scalars['String']['output'];
  /** delete a channel */
  deleteV3ConfigurationCustomersCustomerIdChannelChannelIdSandbox: Scalars['String']['output'];
  /** Doesn't delete the pype, just resets the config to the default. */
  deleteV3ConfigurationPypePypeId: Scalars['String']['output'];
  /** Doesn't delete the pype, just resets the config to the default. */
  deleteV3ConfigurationPypePypeIdSandbox: Scalars['String']['output'];
  /** delete the specified key */
  deleteV3KeysKeyId: Scalars['String']['output'];
  /** delete the specified key */
  deleteV3KeysKeyIdSandbox: Scalars['String']['output'];
  deleteVersionScriptById?: Maybe<Version>;
  /** delete data from the table: "tenancy._ProjectEnvironmentConfigToVariable" */
  delete_tenancy__ProjectEnvironmentConfigToVariable?: Maybe<Tenancy__ProjectEnvironmentConfigToVariable_Mutation_Response>;
  /** delete data from the table: "tenancy._prisma_migrations" */
  delete_tenancy__prisma_migrations?: Maybe<Tenancy__Prisma_Migrations_Mutation_Response>;
  /** delete single row from the table: "tenancy._prisma_migrations" */
  delete_tenancy__prisma_migrations_by_pk?: Maybe<Tenancy__Prisma_Migrations>;
  /** delete data from the table: "tenancy._role_projects" */
  delete_tenancy__role_projects?: Maybe<Tenancy__Role_Projects_Mutation_Response>;
  /** delete data from the table: "tenancy._team_account_environment_config_roles" */
  delete_tenancy__team_account_environment_config_roles?: Maybe<Tenancy__Team_Account_Environment_Config_Roles_Mutation_Response>;
  /** delete data from the table: "tenancy._team_account_project_roles" */
  delete_tenancy__team_account_project_roles?: Maybe<Tenancy__Team_Account_Project_Roles_Mutation_Response>;
  /** delete data from the table: "tenancy._team_account_roles" */
  delete_tenancy__team_account_roles?: Maybe<Tenancy__Team_Account_Roles_Mutation_Response>;
  /** delete data from the table: "tenancy._user_account_environment_config_roles" */
  delete_tenancy__user_account_environment_config_roles?: Maybe<Tenancy__User_Account_Environment_Config_Roles_Mutation_Response>;
  /** delete data from the table: "tenancy._user_account_project_roles" */
  delete_tenancy__user_account_project_roles?: Maybe<Tenancy__User_Account_Project_Roles_Mutation_Response>;
  /** delete data from the table: "tenancy._user_account_roles" */
  delete_tenancy__user_account_roles?: Maybe<Tenancy__User_Account_Roles_Mutation_Response>;
  /** delete data from the table: "tenancy._user_teams" */
  delete_tenancy__user_teams?: Maybe<Tenancy__User_Teams_Mutation_Response>;
  /** delete data from the table: "tenancy.account_auth_method_settings" */
  delete_tenancy_account_auth_method_settings?: Maybe<Tenancy_Account_Auth_Method_Settings_Mutation_Response>;
  /** delete single row from the table: "tenancy.account_auth_method_settings" */
  delete_tenancy_account_auth_method_settings_by_pk?: Maybe<Tenancy_Account_Auth_Method_Settings>;
  /** delete data from the table: "tenancy.accounts" */
  delete_tenancy_accounts?: Maybe<Tenancy_Accounts_Mutation_Response>;
  /** delete single row from the table: "tenancy.accounts" */
  delete_tenancy_accounts_by_pk?: Maybe<Tenancy_Accounts>;
  /** delete data from the table: "tenancy.action" */
  delete_tenancy_action?: Maybe<Tenancy_Action_Mutation_Response>;
  /** delete single row from the table: "tenancy.action" */
  delete_tenancy_action_by_pk?: Maybe<Tenancy_Action>;
  /** delete data from the table: "tenancy.action_node_job" */
  delete_tenancy_action_node_job?: Maybe<Tenancy_Action_Node_Job_Mutation_Response>;
  /** delete single row from the table: "tenancy.action_node_job" */
  delete_tenancy_action_node_job_by_pk?: Maybe<Tenancy_Action_Node_Job>;
  /** delete data from the table: "tenancy.app_config" */
  delete_tenancy_app_config?: Maybe<Tenancy_App_Config_Mutation_Response>;
  /** delete single row from the table: "tenancy.app_config" */
  delete_tenancy_app_config_by_pk?: Maybe<Tenancy_App_Config>;
  /** delete data from the table: "tenancy.applet" */
  delete_tenancy_applet?: Maybe<Tenancy_Applet_Mutation_Response>;
  /** delete single row from the table: "tenancy.applet" */
  delete_tenancy_applet_by_pk?: Maybe<Tenancy_Applet>;
  /** delete data from the table: "tenancy.applet_instance" */
  delete_tenancy_applet_instance?: Maybe<Tenancy_Applet_Instance_Mutation_Response>;
  /** delete single row from the table: "tenancy.applet_instance" */
  delete_tenancy_applet_instance_by_pk?: Maybe<Tenancy_Applet_Instance>;
  /** delete data from the table: "tenancy.applet_version" */
  delete_tenancy_applet_version?: Maybe<Tenancy_Applet_Version_Mutation_Response>;
  /** delete single row from the table: "tenancy.applet_version" */
  delete_tenancy_applet_version_by_pk?: Maybe<Tenancy_Applet_Version>;
  /** delete data from the table: "tenancy.audit_logs" */
  delete_tenancy_audit_logs?: Maybe<Tenancy_Audit_Logs_Mutation_Response>;
  /** delete single row from the table: "tenancy.audit_logs" */
  delete_tenancy_audit_logs_by_pk?: Maybe<Tenancy_Audit_Logs>;
  /** delete data from the table: "tenancy.auth_method" */
  delete_tenancy_auth_method?: Maybe<Tenancy_Auth_Method_Mutation_Response>;
  /** delete single row from the table: "tenancy.auth_method" */
  delete_tenancy_auth_method_by_pk?: Maybe<Tenancy_Auth_Method>;
  /** delete data from the table: "tenancy.condition" */
  delete_tenancy_condition?: Maybe<Tenancy_Condition_Mutation_Response>;
  /** delete single row from the table: "tenancy.condition" */
  delete_tenancy_condition_by_pk?: Maybe<Tenancy_Condition>;
  /** delete data from the table: "tenancy.country" */
  delete_tenancy_country?: Maybe<Tenancy_Country_Mutation_Response>;
  /** delete single row from the table: "tenancy.country" */
  delete_tenancy_country_by_pk?: Maybe<Tenancy_Country>;
  /** delete data from the table: "tenancy.custom_auth_method" */
  delete_tenancy_custom_auth_method?: Maybe<Tenancy_Custom_Auth_Method_Mutation_Response>;
  /** delete single row from the table: "tenancy.custom_auth_method" */
  delete_tenancy_custom_auth_method_by_pk?: Maybe<Tenancy_Custom_Auth_Method>;
  /** delete data from the table: "tenancy.domain" */
  delete_tenancy_domain?: Maybe<Tenancy_Domain_Mutation_Response>;
  /** delete single row from the table: "tenancy.domain" */
  delete_tenancy_domain_by_pk?: Maybe<Tenancy_Domain>;
  /** delete data from the table: "tenancy.environment" */
  delete_tenancy_environment?: Maybe<Tenancy_Environment_Mutation_Response>;
  /** delete single row from the table: "tenancy.environment" */
  delete_tenancy_environment_by_pk?: Maybe<Tenancy_Environment>;
  /** delete data from the table: "tenancy.failed_kafka_events" */
  delete_tenancy_failed_kafka_events?: Maybe<Tenancy_Failed_Kafka_Events_Mutation_Response>;
  /** delete single row from the table: "tenancy.failed_kafka_events" */
  delete_tenancy_failed_kafka_events_by_pk?: Maybe<Tenancy_Failed_Kafka_Events>;
  /** delete data from the table: "tenancy.file" */
  delete_tenancy_file?: Maybe<Tenancy_File_Mutation_Response>;
  /** delete single row from the table: "tenancy.file" */
  delete_tenancy_file_by_pk?: Maybe<Tenancy_File>;
  /** delete data from the table: "tenancy.llm_credentials" */
  delete_tenancy_llm_credentials?: Maybe<Tenancy_Llm_Credentials_Mutation_Response>;
  /** delete single row from the table: "tenancy.llm_credentials" */
  delete_tenancy_llm_credentials_by_pk?: Maybe<Tenancy_Llm_Credentials>;
  /** delete data from the table: "tenancy.llm_providers" */
  delete_tenancy_llm_providers?: Maybe<Tenancy_Llm_Providers_Mutation_Response>;
  /** delete single row from the table: "tenancy.llm_providers" */
  delete_tenancy_llm_providers_by_pk?: Maybe<Tenancy_Llm_Providers>;
  /** delete data from the table: "tenancy.locale" */
  delete_tenancy_locale?: Maybe<Tenancy_Locale_Mutation_Response>;
  /** delete single row from the table: "tenancy.locale" */
  delete_tenancy_locale_by_pk?: Maybe<Tenancy_Locale>;
  /** delete data from the table: "tenancy.localization_settings" */
  delete_tenancy_localization_settings?: Maybe<Tenancy_Localization_Settings_Mutation_Response>;
  /** delete single row from the table: "tenancy.localization_settings" */
  delete_tenancy_localization_settings_by_pk?: Maybe<Tenancy_Localization_Settings>;
  /** delete data from the table: "tenancy.node_type_enum_ps" */
  delete_tenancy_node_type_enum_ps?: Maybe<Tenancy_Node_Type_Enum_Ps_Mutation_Response>;
  /** delete single row from the table: "tenancy.node_type_enum_ps" */
  delete_tenancy_node_type_enum_ps_by_pk?: Maybe<Tenancy_Node_Type_Enum_Ps>;
  /** delete data from the table: "tenancy.package" */
  delete_tenancy_package?: Maybe<Tenancy_Package_Mutation_Response>;
  /** delete single row from the table: "tenancy.package" */
  delete_tenancy_package_by_pk?: Maybe<Tenancy_Package>;
  /** delete data from the table: "tenancy.package_version" */
  delete_tenancy_package_version?: Maybe<Tenancy_Package_Version_Mutation_Response>;
  /** delete single row from the table: "tenancy.package_version" */
  delete_tenancy_package_version_by_pk?: Maybe<Tenancy_Package_Version>;
  /** delete data from the table: "tenancy.pro_studio_performance_metrics" */
  delete_tenancy_pro_studio_performance_metrics?: Maybe<Tenancy_Pro_Studio_Performance_Metrics_Mutation_Response>;
  /** delete single row from the table: "tenancy.pro_studio_performance_metrics" */
  delete_tenancy_pro_studio_performance_metrics_by_pk?: Maybe<Tenancy_Pro_Studio_Performance_Metrics>;
  /** delete data from the table: "tenancy.products" */
  delete_tenancy_products?: Maybe<Tenancy_Products_Mutation_Response>;
  /** delete single row from the table: "tenancy.products" */
  delete_tenancy_products_by_pk?: Maybe<Tenancy_Products>;
  /** delete data from the table: "tenancy.project_environment_config" */
  delete_tenancy_project_environment_config?: Maybe<Tenancy_Project_Environment_Config_Mutation_Response>;
  /** delete single row from the table: "tenancy.project_environment_config" */
  delete_tenancy_project_environment_config_by_pk?: Maybe<Tenancy_Project_Environment_Config>;
  /** delete data from the table: "tenancy.project_pro_studio_setting" */
  delete_tenancy_project_pro_studio_setting?: Maybe<Tenancy_Project_Pro_Studio_Setting_Mutation_Response>;
  /** delete single row from the table: "tenancy.project_pro_studio_setting" */
  delete_tenancy_project_pro_studio_setting_by_pk?: Maybe<Tenancy_Project_Pro_Studio_Setting>;
  /** delete data from the table: "tenancy.project_product_settings" */
  delete_tenancy_project_product_settings?: Maybe<Tenancy_Project_Product_Settings_Mutation_Response>;
  /** delete single row from the table: "tenancy.project_product_settings" */
  delete_tenancy_project_product_settings_by_pk?: Maybe<Tenancy_Project_Product_Settings>;
  /** delete data from the table: "tenancy.projects" */
  delete_tenancy_projects?: Maybe<Tenancy_Projects_Mutation_Response>;
  /** delete single row from the table: "tenancy.projects" */
  delete_tenancy_projects_by_pk?: Maybe<Tenancy_Projects>;
  /** delete data from the table: "tenancy.pype_connection" */
  delete_tenancy_pype_connection?: Maybe<Tenancy_Pype_Connection_Mutation_Response>;
  /** delete single row from the table: "tenancy.pype_connection" */
  delete_tenancy_pype_connection_by_pk?: Maybe<Tenancy_Pype_Connection>;
  /** delete data from the table: "tenancy.pype_connection_pype" */
  delete_tenancy_pype_connection_pype?: Maybe<Tenancy_Pype_Connection_Pype_Mutation_Response>;
  /** delete single row from the table: "tenancy.pype_connection_pype" */
  delete_tenancy_pype_connection_pype_by_pk?: Maybe<Tenancy_Pype_Connection_Pype>;
  /** delete data from the table: "tenancy.pype_rule" */
  delete_tenancy_pype_rule?: Maybe<Tenancy_Pype_Rule_Mutation_Response>;
  /** delete single row from the table: "tenancy.pype_rule" */
  delete_tenancy_pype_rule_by_pk?: Maybe<Tenancy_Pype_Rule>;
  /** delete data from the table: "tenancy.pype_rule_group" */
  delete_tenancy_pype_rule_group?: Maybe<Tenancy_Pype_Rule_Group_Mutation_Response>;
  /** delete single row from the table: "tenancy.pype_rule_group" */
  delete_tenancy_pype_rule_group_by_pk?: Maybe<Tenancy_Pype_Rule_Group>;
  /** delete data from the table: "tenancy.pype_rule_group_pype" */
  delete_tenancy_pype_rule_group_pype?: Maybe<Tenancy_Pype_Rule_Group_Pype_Mutation_Response>;
  /** delete single row from the table: "tenancy.pype_rule_group_pype" */
  delete_tenancy_pype_rule_group_pype_by_pk?: Maybe<Tenancy_Pype_Rule_Group_Pype>;
  /** delete data from the table: "tenancy.rich_asset_type_enum_ps" */
  delete_tenancy_rich_asset_type_enum_ps?: Maybe<Tenancy_Rich_Asset_Type_Enum_Ps_Mutation_Response>;
  /** delete single row from the table: "tenancy.rich_asset_type_enum_ps" */
  delete_tenancy_rich_asset_type_enum_ps_by_pk?: Maybe<Tenancy_Rich_Asset_Type_Enum_Ps>;
  /** delete data from the table: "tenancy.roles" */
  delete_tenancy_roles?: Maybe<Tenancy_Roles_Mutation_Response>;
  /** delete single row from the table: "tenancy.roles" */
  delete_tenancy_roles_by_pk?: Maybe<Tenancy_Roles>;
  /** delete data from the table: "tenancy.solution_deployment_run_workflows" */
  delete_tenancy_solution_deployment_run_workflows?: Maybe<Tenancy_Solution_Deployment_Run_Workflows_Mutation_Response>;
  /** delete single row from the table: "tenancy.solution_deployment_run_workflows" */
  delete_tenancy_solution_deployment_run_workflows_by_pk?: Maybe<Tenancy_Solution_Deployment_Run_Workflows>;
  /** delete data from the table: "tenancy.solution_deployment_runs" */
  delete_tenancy_solution_deployment_runs?: Maybe<Tenancy_Solution_Deployment_Runs_Mutation_Response>;
  /** delete single row from the table: "tenancy.solution_deployment_runs" */
  delete_tenancy_solution_deployment_runs_by_pk?: Maybe<Tenancy_Solution_Deployment_Runs>;
  /** delete data from the table: "tenancy.solution_deployments" */
  delete_tenancy_solution_deployments?: Maybe<Tenancy_Solution_Deployments_Mutation_Response>;
  /** delete single row from the table: "tenancy.solution_deployments" */
  delete_tenancy_solution_deployments_by_pk?: Maybe<Tenancy_Solution_Deployments>;
  /** delete data from the table: "tenancy.solution_task" */
  delete_tenancy_solution_task?: Maybe<Tenancy_Solution_Task_Mutation_Response>;
  /** delete single row from the table: "tenancy.solution_task" */
  delete_tenancy_solution_task_by_pk?: Maybe<Tenancy_Solution_Task>;
  /** delete data from the table: "tenancy.solution_user_presence" */
  delete_tenancy_solution_user_presence?: Maybe<Tenancy_Solution_User_Presence_Mutation_Response>;
  /** delete single row from the table: "tenancy.solution_user_presence" */
  delete_tenancy_solution_user_presence_by_pk?: Maybe<Tenancy_Solution_User_Presence>;
  /** delete data from the table: "tenancy.solution_version_nodes_ps" */
  delete_tenancy_solution_version_nodes_ps?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Mutation_Response>;
  /** delete single row from the table: "tenancy.solution_version_nodes_ps" */
  delete_tenancy_solution_version_nodes_ps_by_pk?: Maybe<Tenancy_Solution_Version_Nodes_Ps>;
  /** delete data from the table: "tenancy.solution_versions" */
  delete_tenancy_solution_versions?: Maybe<Tenancy_Solution_Versions_Mutation_Response>;
  /** delete single row from the table: "tenancy.solution_versions" */
  delete_tenancy_solution_versions_by_pk?: Maybe<Tenancy_Solution_Versions>;
  /** delete data from the table: "tenancy.solution_versions_ps" */
  delete_tenancy_solution_versions_ps?: Maybe<Tenancy_Solution_Versions_Ps_Mutation_Response>;
  /** delete single row from the table: "tenancy.solution_versions_ps" */
  delete_tenancy_solution_versions_ps_by_pk?: Maybe<Tenancy_Solution_Versions_Ps>;
  /** delete data from the table: "tenancy.solutions" */
  delete_tenancy_solutions?: Maybe<Tenancy_Solutions_Mutation_Response>;
  /** delete single row from the table: "tenancy.solutions" */
  delete_tenancy_solutions_by_pk?: Maybe<Tenancy_Solutions>;
  /** delete data from the table: "tenancy.studio_resource" */
  delete_tenancy_studio_resource?: Maybe<Tenancy_Studio_Resource_Mutation_Response>;
  /** delete single row from the table: "tenancy.studio_resource" */
  delete_tenancy_studio_resource_by_pk?: Maybe<Tenancy_Studio_Resource>;
  /** delete data from the table: "tenancy.team_account_environment_config" */
  delete_tenancy_team_account_environment_config?: Maybe<Tenancy_Team_Account_Environment_Config_Mutation_Response>;
  /** delete single row from the table: "tenancy.team_account_environment_config" */
  delete_tenancy_team_account_environment_config_by_pk?: Maybe<Tenancy_Team_Account_Environment_Config>;
  /** delete data from the table: "tenancy.team_account_projects" */
  delete_tenancy_team_account_projects?: Maybe<Tenancy_Team_Account_Projects_Mutation_Response>;
  /** delete single row from the table: "tenancy.team_account_projects" */
  delete_tenancy_team_account_projects_by_pk?: Maybe<Tenancy_Team_Account_Projects>;
  /** delete data from the table: "tenancy.team_accounts" */
  delete_tenancy_team_accounts?: Maybe<Tenancy_Team_Accounts_Mutation_Response>;
  /** delete single row from the table: "tenancy.team_accounts" */
  delete_tenancy_team_accounts_by_pk?: Maybe<Tenancy_Team_Accounts>;
  /** delete data from the table: "tenancy.teams" */
  delete_tenancy_teams?: Maybe<Tenancy_Teams_Mutation_Response>;
  /** delete single row from the table: "tenancy.teams" */
  delete_tenancy_teams_by_pk?: Maybe<Tenancy_Teams>;
  /** delete data from the table: "tenancy.template_node" */
  delete_tenancy_template_node?: Maybe<Tenancy_Template_Node_Mutation_Response>;
  /** delete single row from the table: "tenancy.template_node" */
  delete_tenancy_template_node_by_pk?: Maybe<Tenancy_Template_Node>;
  /** delete data from the table: "tenancy.time_zone" */
  delete_tenancy_time_zone?: Maybe<Tenancy_Time_Zone_Mutation_Response>;
  /** delete single row from the table: "tenancy.time_zone" */
  delete_tenancy_time_zone_by_pk?: Maybe<Tenancy_Time_Zone>;
  /** delete data from the table: "tenancy.trigger" */
  delete_tenancy_trigger?: Maybe<Tenancy_Trigger_Mutation_Response>;
  /** delete single row from the table: "tenancy.trigger" */
  delete_tenancy_trigger_by_pk?: Maybe<Tenancy_Trigger>;
  /** delete data from the table: "tenancy.user_account_auth_method_settings" */
  delete_tenancy_user_account_auth_method_settings?: Maybe<Tenancy_User_Account_Auth_Method_Settings_Mutation_Response>;
  /** delete single row from the table: "tenancy.user_account_auth_method_settings" */
  delete_tenancy_user_account_auth_method_settings_by_pk?: Maybe<Tenancy_User_Account_Auth_Method_Settings>;
  /** delete data from the table: "tenancy.user_account_environment_config" */
  delete_tenancy_user_account_environment_config?: Maybe<Tenancy_User_Account_Environment_Config_Mutation_Response>;
  /** delete single row from the table: "tenancy.user_account_environment_config" */
  delete_tenancy_user_account_environment_config_by_pk?: Maybe<Tenancy_User_Account_Environment_Config>;
  /** delete data from the table: "tenancy.user_account_project_metabase_access" */
  delete_tenancy_user_account_project_metabase_access?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Mutation_Response>;
  /** delete single row from the table: "tenancy.user_account_project_metabase_access" */
  delete_tenancy_user_account_project_metabase_access_by_pk?: Maybe<Tenancy_User_Account_Project_Metabase_Access>;
  /** delete data from the table: "tenancy.user_account_projects" */
  delete_tenancy_user_account_projects?: Maybe<Tenancy_User_Account_Projects_Mutation_Response>;
  /** delete single row from the table: "tenancy.user_account_projects" */
  delete_tenancy_user_account_projects_by_pk?: Maybe<Tenancy_User_Account_Projects>;
  /** delete data from the table: "tenancy.user_accounts" */
  delete_tenancy_user_accounts?: Maybe<Tenancy_User_Accounts_Mutation_Response>;
  /** delete single row from the table: "tenancy.user_accounts" */
  delete_tenancy_user_accounts_by_pk?: Maybe<Tenancy_User_Accounts>;
  /** delete data from the table: "tenancy.users" */
  delete_tenancy_users?: Maybe<Tenancy_Users_Mutation_Response>;
  /** delete single row from the table: "tenancy.users" */
  delete_tenancy_users_by_pk?: Maybe<Tenancy_Users>;
  /** delete data from the table: "tenancy.variable" */
  delete_tenancy_variable?: Maybe<Tenancy_Variable_Mutation_Response>;
  /** delete single row from the table: "tenancy.variable" */
  delete_tenancy_variable_by_pk?: Maybe<Tenancy_Variable>;
  /**
   * Delete a customer by its id.
   * Permission to perform this action is only associated with a superadmin role.
   */
  gesDeleteCustomersById: Scalars['String']['output'];
  /** Delete a customer key by its id */
  gesDeleteCustomersKeysById: Scalars['String']['output'];
  /**
   * Delete a user to environment mapping on a given customer.
   * Restricted to internal customers.
   */
  gesDeleteCustomersUsersEnvironmentMappings: Scalars['String']['output'];
  /** Delete a user by its id. */
  gesDeleteUsersByUserId: Scalars['String']['output'];
  /**
   * Unassign a role from a user.
   * Superadmin role can only be unassigned by another superadmin. A customer admin role requires role_mapping:delete:c permission. Other roles can be unassigned provided that (1) the caller is a pype admin on the role's pype and (2) has a role rank on the relevant pype higher than or equal to that of the role being assigned. Restricted to internal customers.
   */
  gesDeleteUsersRoleMappingsById: Scalars['String']['output'];
  /** Create a customer. */
  gesPostCustomers?: Maybe<Customer>;
  /** Create a customer key. */
  gesPostCustomersKeys?: Maybe<CustomerKey>;
  /**
   * Search customers by substring.
   * Substring matching is tried in name and description fields.
   */
  gesPostCustomersSearches?: Maybe<Array<Maybe<Customer>>>;
  /**
   * Create a user to environment mapping on a given customer.
   * Restricted to internal customers.
   */
  gesPostCustomersUsersEnvironmentMappings?: Maybe<EnvironmentMapping>;
  /**
   * Search users within a given customer.
   * Substring matching is tried in first, last names and email. Not applicable for external customers. Users with role rank higher that the caller's rank will be omitted.
   */
  gesPostCustomersUsersSearches?: Maybe<Array<Maybe<GesUser>>>;
  /** Create a customer key. */
  gesPostKeysValidate?: Maybe<CustomerKey>;
  /**
   * Search users by substring matching in first, last names and email.
   * Unless caller is superadmin, users not belonging to the caller's customer, as well as
   * users with role rank higher that the caller's rank will be omitted.
   */
  gesPostUserSearches?: Maybe<Array<Maybe<GesUser>>>;
  /** Create a user. */
  gesPostUsers?: Maybe<GesUser>;
  /**
   * Search a user's customers by substring.
   * Substring matching is tried in name and description fields.
   */
  gesPostUsersCustomersSearches?: Maybe<Array<Maybe<Customer>>>;
  /**
   * Assign a role to a user.
   * Superadmin role can only be assigned by another superadmin. A customer admin role requires role_mapping:create:c permission. Other roles can be assigned provided that (1) the caller is a pype admin on the role's pype and (2) has a role rank on the relevant pype higher than or equal to that of the role being assigned. Restricted to internal customers.
   */
  gesPostUsersRoleMappings?: Maybe<RoleMapping>;
  /**
   * Update customer.
   * Note that name cannot be changed.
   */
  gesPutCustomersById?: Maybe<Customer>;
  /** Update a customer user. */
  gesPutCustomersUsersByUserId?: Maybe<GesUser>;
  /**
   * Update user.
   * Note on permissions: allowed for Pype Admins whose pype this user belongs to.
   */
  gesPutUsersByUserId?: Maybe<GesUser>;
  /** insert data into the table: "tenancy._ProjectEnvironmentConfigToVariable" */
  insert_tenancy__ProjectEnvironmentConfigToVariable?: Maybe<Tenancy__ProjectEnvironmentConfigToVariable_Mutation_Response>;
  /** insert a single row into the table: "tenancy._ProjectEnvironmentConfigToVariable" */
  insert_tenancy__ProjectEnvironmentConfigToVariable_one?: Maybe<Tenancy__ProjectEnvironmentConfigToVariable>;
  /** insert data into the table: "tenancy._prisma_migrations" */
  insert_tenancy__prisma_migrations?: Maybe<Tenancy__Prisma_Migrations_Mutation_Response>;
  /** insert a single row into the table: "tenancy._prisma_migrations" */
  insert_tenancy__prisma_migrations_one?: Maybe<Tenancy__Prisma_Migrations>;
  /** insert data into the table: "tenancy._role_projects" */
  insert_tenancy__role_projects?: Maybe<Tenancy__Role_Projects_Mutation_Response>;
  /** insert a single row into the table: "tenancy._role_projects" */
  insert_tenancy__role_projects_one?: Maybe<Tenancy__Role_Projects>;
  /** insert data into the table: "tenancy._team_account_environment_config_roles" */
  insert_tenancy__team_account_environment_config_roles?: Maybe<Tenancy__Team_Account_Environment_Config_Roles_Mutation_Response>;
  /** insert a single row into the table: "tenancy._team_account_environment_config_roles" */
  insert_tenancy__team_account_environment_config_roles_one?: Maybe<Tenancy__Team_Account_Environment_Config_Roles>;
  /** insert data into the table: "tenancy._team_account_project_roles" */
  insert_tenancy__team_account_project_roles?: Maybe<Tenancy__Team_Account_Project_Roles_Mutation_Response>;
  /** insert a single row into the table: "tenancy._team_account_project_roles" */
  insert_tenancy__team_account_project_roles_one?: Maybe<Tenancy__Team_Account_Project_Roles>;
  /** insert data into the table: "tenancy._team_account_roles" */
  insert_tenancy__team_account_roles?: Maybe<Tenancy__Team_Account_Roles_Mutation_Response>;
  /** insert a single row into the table: "tenancy._team_account_roles" */
  insert_tenancy__team_account_roles_one?: Maybe<Tenancy__Team_Account_Roles>;
  /** insert data into the table: "tenancy._user_account_environment_config_roles" */
  insert_tenancy__user_account_environment_config_roles?: Maybe<Tenancy__User_Account_Environment_Config_Roles_Mutation_Response>;
  /** insert a single row into the table: "tenancy._user_account_environment_config_roles" */
  insert_tenancy__user_account_environment_config_roles_one?: Maybe<Tenancy__User_Account_Environment_Config_Roles>;
  /** insert data into the table: "tenancy._user_account_project_roles" */
  insert_tenancy__user_account_project_roles?: Maybe<Tenancy__User_Account_Project_Roles_Mutation_Response>;
  /** insert a single row into the table: "tenancy._user_account_project_roles" */
  insert_tenancy__user_account_project_roles_one?: Maybe<Tenancy__User_Account_Project_Roles>;
  /** insert data into the table: "tenancy._user_account_roles" */
  insert_tenancy__user_account_roles?: Maybe<Tenancy__User_Account_Roles_Mutation_Response>;
  /** insert a single row into the table: "tenancy._user_account_roles" */
  insert_tenancy__user_account_roles_one?: Maybe<Tenancy__User_Account_Roles>;
  /** insert data into the table: "tenancy._user_teams" */
  insert_tenancy__user_teams?: Maybe<Tenancy__User_Teams_Mutation_Response>;
  /** insert a single row into the table: "tenancy._user_teams" */
  insert_tenancy__user_teams_one?: Maybe<Tenancy__User_Teams>;
  /** insert data into the table: "tenancy.account_auth_method_settings" */
  insert_tenancy_account_auth_method_settings?: Maybe<Tenancy_Account_Auth_Method_Settings_Mutation_Response>;
  /** insert a single row into the table: "tenancy.account_auth_method_settings" */
  insert_tenancy_account_auth_method_settings_one?: Maybe<Tenancy_Account_Auth_Method_Settings>;
  /** insert data into the table: "tenancy.accounts" */
  insert_tenancy_accounts?: Maybe<Tenancy_Accounts_Mutation_Response>;
  /** insert a single row into the table: "tenancy.accounts" */
  insert_tenancy_accounts_one?: Maybe<Tenancy_Accounts>;
  /** insert data into the table: "tenancy.action" */
  insert_tenancy_action?: Maybe<Tenancy_Action_Mutation_Response>;
  /** insert data into the table: "tenancy.action_node_job" */
  insert_tenancy_action_node_job?: Maybe<Tenancy_Action_Node_Job_Mutation_Response>;
  /** insert a single row into the table: "tenancy.action_node_job" */
  insert_tenancy_action_node_job_one?: Maybe<Tenancy_Action_Node_Job>;
  /** insert a single row into the table: "tenancy.action" */
  insert_tenancy_action_one?: Maybe<Tenancy_Action>;
  /** insert data into the table: "tenancy.app_config" */
  insert_tenancy_app_config?: Maybe<Tenancy_App_Config_Mutation_Response>;
  /** insert a single row into the table: "tenancy.app_config" */
  insert_tenancy_app_config_one?: Maybe<Tenancy_App_Config>;
  /** insert data into the table: "tenancy.applet" */
  insert_tenancy_applet?: Maybe<Tenancy_Applet_Mutation_Response>;
  /** insert data into the table: "tenancy.applet_instance" */
  insert_tenancy_applet_instance?: Maybe<Tenancy_Applet_Instance_Mutation_Response>;
  /** insert a single row into the table: "tenancy.applet_instance" */
  insert_tenancy_applet_instance_one?: Maybe<Tenancy_Applet_Instance>;
  /** insert a single row into the table: "tenancy.applet" */
  insert_tenancy_applet_one?: Maybe<Tenancy_Applet>;
  /** insert data into the table: "tenancy.applet_version" */
  insert_tenancy_applet_version?: Maybe<Tenancy_Applet_Version_Mutation_Response>;
  /** insert a single row into the table: "tenancy.applet_version" */
  insert_tenancy_applet_version_one?: Maybe<Tenancy_Applet_Version>;
  /** insert data into the table: "tenancy.audit_logs" */
  insert_tenancy_audit_logs?: Maybe<Tenancy_Audit_Logs_Mutation_Response>;
  /** insert a single row into the table: "tenancy.audit_logs" */
  insert_tenancy_audit_logs_one?: Maybe<Tenancy_Audit_Logs>;
  /** insert data into the table: "tenancy.auth_method" */
  insert_tenancy_auth_method?: Maybe<Tenancy_Auth_Method_Mutation_Response>;
  /** insert a single row into the table: "tenancy.auth_method" */
  insert_tenancy_auth_method_one?: Maybe<Tenancy_Auth_Method>;
  /** insert data into the table: "tenancy.condition" */
  insert_tenancy_condition?: Maybe<Tenancy_Condition_Mutation_Response>;
  /** insert a single row into the table: "tenancy.condition" */
  insert_tenancy_condition_one?: Maybe<Tenancy_Condition>;
  /** insert data into the table: "tenancy.country" */
  insert_tenancy_country?: Maybe<Tenancy_Country_Mutation_Response>;
  /** insert a single row into the table: "tenancy.country" */
  insert_tenancy_country_one?: Maybe<Tenancy_Country>;
  /** insert data into the table: "tenancy.custom_auth_method" */
  insert_tenancy_custom_auth_method?: Maybe<Tenancy_Custom_Auth_Method_Mutation_Response>;
  /** insert a single row into the table: "tenancy.custom_auth_method" */
  insert_tenancy_custom_auth_method_one?: Maybe<Tenancy_Custom_Auth_Method>;
  /** insert data into the table: "tenancy.domain" */
  insert_tenancy_domain?: Maybe<Tenancy_Domain_Mutation_Response>;
  /** insert a single row into the table: "tenancy.domain" */
  insert_tenancy_domain_one?: Maybe<Tenancy_Domain>;
  /** insert data into the table: "tenancy.environment" */
  insert_tenancy_environment?: Maybe<Tenancy_Environment_Mutation_Response>;
  /** insert a single row into the table: "tenancy.environment" */
  insert_tenancy_environment_one?: Maybe<Tenancy_Environment>;
  /** insert data into the table: "tenancy.failed_kafka_events" */
  insert_tenancy_failed_kafka_events?: Maybe<Tenancy_Failed_Kafka_Events_Mutation_Response>;
  /** insert a single row into the table: "tenancy.failed_kafka_events" */
  insert_tenancy_failed_kafka_events_one?: Maybe<Tenancy_Failed_Kafka_Events>;
  /** insert data into the table: "tenancy.file" */
  insert_tenancy_file?: Maybe<Tenancy_File_Mutation_Response>;
  /** insert a single row into the table: "tenancy.file" */
  insert_tenancy_file_one?: Maybe<Tenancy_File>;
  /** insert data into the table: "tenancy.llm_credentials" */
  insert_tenancy_llm_credentials?: Maybe<Tenancy_Llm_Credentials_Mutation_Response>;
  /** insert a single row into the table: "tenancy.llm_credentials" */
  insert_tenancy_llm_credentials_one?: Maybe<Tenancy_Llm_Credentials>;
  /** insert data into the table: "tenancy.llm_providers" */
  insert_tenancy_llm_providers?: Maybe<Tenancy_Llm_Providers_Mutation_Response>;
  /** insert a single row into the table: "tenancy.llm_providers" */
  insert_tenancy_llm_providers_one?: Maybe<Tenancy_Llm_Providers>;
  /** insert data into the table: "tenancy.locale" */
  insert_tenancy_locale?: Maybe<Tenancy_Locale_Mutation_Response>;
  /** insert a single row into the table: "tenancy.locale" */
  insert_tenancy_locale_one?: Maybe<Tenancy_Locale>;
  /** insert data into the table: "tenancy.localization_settings" */
  insert_tenancy_localization_settings?: Maybe<Tenancy_Localization_Settings_Mutation_Response>;
  /** insert a single row into the table: "tenancy.localization_settings" */
  insert_tenancy_localization_settings_one?: Maybe<Tenancy_Localization_Settings>;
  /** insert data into the table: "tenancy.node_type_enum_ps" */
  insert_tenancy_node_type_enum_ps?: Maybe<Tenancy_Node_Type_Enum_Ps_Mutation_Response>;
  /** insert a single row into the table: "tenancy.node_type_enum_ps" */
  insert_tenancy_node_type_enum_ps_one?: Maybe<Tenancy_Node_Type_Enum_Ps>;
  /** insert data into the table: "tenancy.package" */
  insert_tenancy_package?: Maybe<Tenancy_Package_Mutation_Response>;
  /** insert a single row into the table: "tenancy.package" */
  insert_tenancy_package_one?: Maybe<Tenancy_Package>;
  /** insert data into the table: "tenancy.package_version" */
  insert_tenancy_package_version?: Maybe<Tenancy_Package_Version_Mutation_Response>;
  /** insert a single row into the table: "tenancy.package_version" */
  insert_tenancy_package_version_one?: Maybe<Tenancy_Package_Version>;
  /** insert data into the table: "tenancy.pro_studio_performance_metrics" */
  insert_tenancy_pro_studio_performance_metrics?: Maybe<Tenancy_Pro_Studio_Performance_Metrics_Mutation_Response>;
  /** insert a single row into the table: "tenancy.pro_studio_performance_metrics" */
  insert_tenancy_pro_studio_performance_metrics_one?: Maybe<Tenancy_Pro_Studio_Performance_Metrics>;
  /** insert data into the table: "tenancy.products" */
  insert_tenancy_products?: Maybe<Tenancy_Products_Mutation_Response>;
  /** insert a single row into the table: "tenancy.products" */
  insert_tenancy_products_one?: Maybe<Tenancy_Products>;
  /** insert data into the table: "tenancy.project_environment_config" */
  insert_tenancy_project_environment_config?: Maybe<Tenancy_Project_Environment_Config_Mutation_Response>;
  /** insert a single row into the table: "tenancy.project_environment_config" */
  insert_tenancy_project_environment_config_one?: Maybe<Tenancy_Project_Environment_Config>;
  /** insert data into the table: "tenancy.project_pro_studio_setting" */
  insert_tenancy_project_pro_studio_setting?: Maybe<Tenancy_Project_Pro_Studio_Setting_Mutation_Response>;
  /** insert a single row into the table: "tenancy.project_pro_studio_setting" */
  insert_tenancy_project_pro_studio_setting_one?: Maybe<Tenancy_Project_Pro_Studio_Setting>;
  /** insert data into the table: "tenancy.project_product_settings" */
  insert_tenancy_project_product_settings?: Maybe<Tenancy_Project_Product_Settings_Mutation_Response>;
  /** insert a single row into the table: "tenancy.project_product_settings" */
  insert_tenancy_project_product_settings_one?: Maybe<Tenancy_Project_Product_Settings>;
  /** insert data into the table: "tenancy.projects" */
  insert_tenancy_projects?: Maybe<Tenancy_Projects_Mutation_Response>;
  /** insert a single row into the table: "tenancy.projects" */
  insert_tenancy_projects_one?: Maybe<Tenancy_Projects>;
  /** insert data into the table: "tenancy.pype_connection" */
  insert_tenancy_pype_connection?: Maybe<Tenancy_Pype_Connection_Mutation_Response>;
  /** insert a single row into the table: "tenancy.pype_connection" */
  insert_tenancy_pype_connection_one?: Maybe<Tenancy_Pype_Connection>;
  /** insert data into the table: "tenancy.pype_connection_pype" */
  insert_tenancy_pype_connection_pype?: Maybe<Tenancy_Pype_Connection_Pype_Mutation_Response>;
  /** insert a single row into the table: "tenancy.pype_connection_pype" */
  insert_tenancy_pype_connection_pype_one?: Maybe<Tenancy_Pype_Connection_Pype>;
  /** insert data into the table: "tenancy.pype_rule" */
  insert_tenancy_pype_rule?: Maybe<Tenancy_Pype_Rule_Mutation_Response>;
  /** insert data into the table: "tenancy.pype_rule_group" */
  insert_tenancy_pype_rule_group?: Maybe<Tenancy_Pype_Rule_Group_Mutation_Response>;
  /** insert a single row into the table: "tenancy.pype_rule_group" */
  insert_tenancy_pype_rule_group_one?: Maybe<Tenancy_Pype_Rule_Group>;
  /** insert data into the table: "tenancy.pype_rule_group_pype" */
  insert_tenancy_pype_rule_group_pype?: Maybe<Tenancy_Pype_Rule_Group_Pype_Mutation_Response>;
  /** insert a single row into the table: "tenancy.pype_rule_group_pype" */
  insert_tenancy_pype_rule_group_pype_one?: Maybe<Tenancy_Pype_Rule_Group_Pype>;
  /** insert a single row into the table: "tenancy.pype_rule" */
  insert_tenancy_pype_rule_one?: Maybe<Tenancy_Pype_Rule>;
  /** insert data into the table: "tenancy.rich_asset_type_enum_ps" */
  insert_tenancy_rich_asset_type_enum_ps?: Maybe<Tenancy_Rich_Asset_Type_Enum_Ps_Mutation_Response>;
  /** insert a single row into the table: "tenancy.rich_asset_type_enum_ps" */
  insert_tenancy_rich_asset_type_enum_ps_one?: Maybe<Tenancy_Rich_Asset_Type_Enum_Ps>;
  /** insert data into the table: "tenancy.roles" */
  insert_tenancy_roles?: Maybe<Tenancy_Roles_Mutation_Response>;
  /** insert a single row into the table: "tenancy.roles" */
  insert_tenancy_roles_one?: Maybe<Tenancy_Roles>;
  /** insert data into the table: "tenancy.solution_deployment_run_workflows" */
  insert_tenancy_solution_deployment_run_workflows?: Maybe<Tenancy_Solution_Deployment_Run_Workflows_Mutation_Response>;
  /** insert a single row into the table: "tenancy.solution_deployment_run_workflows" */
  insert_tenancy_solution_deployment_run_workflows_one?: Maybe<Tenancy_Solution_Deployment_Run_Workflows>;
  /** insert data into the table: "tenancy.solution_deployment_runs" */
  insert_tenancy_solution_deployment_runs?: Maybe<Tenancy_Solution_Deployment_Runs_Mutation_Response>;
  /** insert a single row into the table: "tenancy.solution_deployment_runs" */
  insert_tenancy_solution_deployment_runs_one?: Maybe<Tenancy_Solution_Deployment_Runs>;
  /** insert data into the table: "tenancy.solution_deployments" */
  insert_tenancy_solution_deployments?: Maybe<Tenancy_Solution_Deployments_Mutation_Response>;
  /** insert a single row into the table: "tenancy.solution_deployments" */
  insert_tenancy_solution_deployments_one?: Maybe<Tenancy_Solution_Deployments>;
  /** insert data into the table: "tenancy.solution_task" */
  insert_tenancy_solution_task?: Maybe<Tenancy_Solution_Task_Mutation_Response>;
  /** insert a single row into the table: "tenancy.solution_task" */
  insert_tenancy_solution_task_one?: Maybe<Tenancy_Solution_Task>;
  /** insert data into the table: "tenancy.solution_user_presence" */
  insert_tenancy_solution_user_presence?: Maybe<Tenancy_Solution_User_Presence_Mutation_Response>;
  /** insert a single row into the table: "tenancy.solution_user_presence" */
  insert_tenancy_solution_user_presence_one?: Maybe<Tenancy_Solution_User_Presence>;
  /** insert data into the table: "tenancy.solution_version_nodes_ps" */
  insert_tenancy_solution_version_nodes_ps?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Mutation_Response>;
  /** insert a single row into the table: "tenancy.solution_version_nodes_ps" */
  insert_tenancy_solution_version_nodes_ps_one?: Maybe<Tenancy_Solution_Version_Nodes_Ps>;
  /** insert data into the table: "tenancy.solution_versions" */
  insert_tenancy_solution_versions?: Maybe<Tenancy_Solution_Versions_Mutation_Response>;
  /** insert a single row into the table: "tenancy.solution_versions" */
  insert_tenancy_solution_versions_one?: Maybe<Tenancy_Solution_Versions>;
  /** insert data into the table: "tenancy.solution_versions_ps" */
  insert_tenancy_solution_versions_ps?: Maybe<Tenancy_Solution_Versions_Ps_Mutation_Response>;
  /** insert a single row into the table: "tenancy.solution_versions_ps" */
  insert_tenancy_solution_versions_ps_one?: Maybe<Tenancy_Solution_Versions_Ps>;
  /** insert data into the table: "tenancy.solutions" */
  insert_tenancy_solutions?: Maybe<Tenancy_Solutions_Mutation_Response>;
  /** insert a single row into the table: "tenancy.solutions" */
  insert_tenancy_solutions_one?: Maybe<Tenancy_Solutions>;
  /** insert data into the table: "tenancy.studio_resource" */
  insert_tenancy_studio_resource?: Maybe<Tenancy_Studio_Resource_Mutation_Response>;
  /** insert a single row into the table: "tenancy.studio_resource" */
  insert_tenancy_studio_resource_one?: Maybe<Tenancy_Studio_Resource>;
  /** insert data into the table: "tenancy.team_account_environment_config" */
  insert_tenancy_team_account_environment_config?: Maybe<Tenancy_Team_Account_Environment_Config_Mutation_Response>;
  /** insert a single row into the table: "tenancy.team_account_environment_config" */
  insert_tenancy_team_account_environment_config_one?: Maybe<Tenancy_Team_Account_Environment_Config>;
  /** insert data into the table: "tenancy.team_account_projects" */
  insert_tenancy_team_account_projects?: Maybe<Tenancy_Team_Account_Projects_Mutation_Response>;
  /** insert a single row into the table: "tenancy.team_account_projects" */
  insert_tenancy_team_account_projects_one?: Maybe<Tenancy_Team_Account_Projects>;
  /** insert data into the table: "tenancy.team_accounts" */
  insert_tenancy_team_accounts?: Maybe<Tenancy_Team_Accounts_Mutation_Response>;
  /** insert a single row into the table: "tenancy.team_accounts" */
  insert_tenancy_team_accounts_one?: Maybe<Tenancy_Team_Accounts>;
  /** insert data into the table: "tenancy.teams" */
  insert_tenancy_teams?: Maybe<Tenancy_Teams_Mutation_Response>;
  /** insert a single row into the table: "tenancy.teams" */
  insert_tenancy_teams_one?: Maybe<Tenancy_Teams>;
  /** insert data into the table: "tenancy.template_node" */
  insert_tenancy_template_node?: Maybe<Tenancy_Template_Node_Mutation_Response>;
  /** insert a single row into the table: "tenancy.template_node" */
  insert_tenancy_template_node_one?: Maybe<Tenancy_Template_Node>;
  /** insert data into the table: "tenancy.time_zone" */
  insert_tenancy_time_zone?: Maybe<Tenancy_Time_Zone_Mutation_Response>;
  /** insert a single row into the table: "tenancy.time_zone" */
  insert_tenancy_time_zone_one?: Maybe<Tenancy_Time_Zone>;
  /** insert data into the table: "tenancy.trigger" */
  insert_tenancy_trigger?: Maybe<Tenancy_Trigger_Mutation_Response>;
  /** insert a single row into the table: "tenancy.trigger" */
  insert_tenancy_trigger_one?: Maybe<Tenancy_Trigger>;
  /** insert data into the table: "tenancy.user_account_auth_method_settings" */
  insert_tenancy_user_account_auth_method_settings?: Maybe<Tenancy_User_Account_Auth_Method_Settings_Mutation_Response>;
  /** insert a single row into the table: "tenancy.user_account_auth_method_settings" */
  insert_tenancy_user_account_auth_method_settings_one?: Maybe<Tenancy_User_Account_Auth_Method_Settings>;
  /** insert data into the table: "tenancy.user_account_environment_config" */
  insert_tenancy_user_account_environment_config?: Maybe<Tenancy_User_Account_Environment_Config_Mutation_Response>;
  /** insert a single row into the table: "tenancy.user_account_environment_config" */
  insert_tenancy_user_account_environment_config_one?: Maybe<Tenancy_User_Account_Environment_Config>;
  /** insert data into the table: "tenancy.user_account_project_metabase_access" */
  insert_tenancy_user_account_project_metabase_access?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Mutation_Response>;
  /** insert a single row into the table: "tenancy.user_account_project_metabase_access" */
  insert_tenancy_user_account_project_metabase_access_one?: Maybe<Tenancy_User_Account_Project_Metabase_Access>;
  /** insert data into the table: "tenancy.user_account_projects" */
  insert_tenancy_user_account_projects?: Maybe<Tenancy_User_Account_Projects_Mutation_Response>;
  /** insert a single row into the table: "tenancy.user_account_projects" */
  insert_tenancy_user_account_projects_one?: Maybe<Tenancy_User_Account_Projects>;
  /** insert data into the table: "tenancy.user_accounts" */
  insert_tenancy_user_accounts?: Maybe<Tenancy_User_Accounts_Mutation_Response>;
  /** insert a single row into the table: "tenancy.user_accounts" */
  insert_tenancy_user_accounts_one?: Maybe<Tenancy_User_Accounts>;
  /** insert data into the table: "tenancy.users" */
  insert_tenancy_users?: Maybe<Tenancy_Users_Mutation_Response>;
  /** insert a single row into the table: "tenancy.users" */
  insert_tenancy_users_one?: Maybe<Tenancy_Users>;
  /** insert data into the table: "tenancy.variable" */
  insert_tenancy_variable?: Maybe<Tenancy_Variable_Mutation_Response>;
  /** insert a single row into the table: "tenancy.variable" */
  insert_tenancy_variable_one?: Maybe<Tenancy_Variable>;
  /**
   * This endpoint allows you to update any parameter provided
   * when a bot is created, such as botType.
   */
  patchBotById?: Maybe<Bot>;
  /**
   * This endpoint adds packages to a customer, in addition to the
   * ones already configured.  If a package with the same name is
   * added, it overwrites the version currently specified.  To replace
   * packages entirely, use the post endpoint.
   */
  patchCustomerPackages?: Maybe<BotManagerCustomer>;
  patchCustomerResources?: Maybe<BotManagerCustomer>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  patchOneIntent?: Maybe<Version>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  patchOneSynonym?: Maybe<Version>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  patchOneTypeEntity?: Maybe<Version>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  patchOneUtterance?: Maybe<Version>;
  /** patch a pre-existing channel */
  patchV3ConfigurationCustomersCustomerIdChannelChannelId?: Maybe<CustomerChannelConfigResponse>;
  /** patch a pre-existing channel */
  patchV3ConfigurationCustomersCustomerIdChannelChannelIdSandbox?: Maybe<CustomerChannelConfigResponse>;
  /** enable and configure PypeNext speech (STT/TTS) on a widget channel */
  patchV3ConfigurationCustomersCustomerIdChannelChannelIdSpeech?: Maybe<CustomerChannel>;
  /** enable and configure PypeNext speech (STT/TTS) on a widget channel */
  patchV3ConfigurationCustomersCustomerIdChannelChannelIdSpeechSandbox?: Maybe<CustomerChannel>;
  /** patch a pre-existing pype */
  patchV3ConfigurationPypePypeId?: Maybe<PypeConfig>;
  /** patch a pre-existing pype */
  patchV3ConfigurationPypePypeIdSandbox?: Maybe<PypeConfig>;
  postBotVersions?: Maybe<Version>;
  postCustomerBots?: Maybe<BotManagerCustomer>;
  /**
   * This endpoint overwrites and replaces the existing packages. To
   * add packages to the existing packages, use the patch endpoint.
   */
  postCustomerPackages?: Maybe<BotManagerCustomer>;
  postCustomers?: Maybe<BotManagerCustomer>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  postEntities?: Maybe<Version>;
  /**
   * Note: the request body JSON is only expected to have this format
   * {
   *   "env": <string>,          #environment, e.g. Claybox or QA1
   *   "uuid": <string>,         # Unique User ID, e.g. af560c9470e04d69be064f64963a1bcc
   *   "email": <string>,            # user email
   *   "customer": <string>,     # name of customer, e.g. MyCompanyABC
   *   "bot": <string>,          # name of solution, e.g. MyTestSolution
   *   "version": <string>,      # version of bot/solution, e.g. v1
   *   "max_num_entries": <integer>  # number most recent results to return
   * }
   * Where at least one of the fields is required (disregarding max_num_entries)
   */
  postHistorySearch?: Maybe<Version>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  postIntents?: Maybe<Version>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  postOneIntent?: Maybe<Version>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  postOneSynonym?: Maybe<Version>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  postOneTypeEntity?: Maybe<Version>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  postOneUtterance?: Maybe<Version>;
  /** Sends broadcast to users. */
  postV3Broadcast: Scalars['String']['output'];
  /** Sends broadcast to users. */
  postV3BroadcastSandbox: Scalars['String']['output'];
  /** agent register. used by the front end when we create a new internal user or assign a new role to a pre-existing user. */
  postV3BusinessAgent: Scalars['String']['output'];
  /** agent register. used by the front end when we create a new internal user or assign a new role to a pre-existing user. */
  postV3BusinessAgentSandbox: Scalars['String']['output'];
  /** create a new widget */
  postV3BusinessWidget?: Maybe<V3BusinessWidgetResponse>;
  /** create a new widget */
  postV3BusinessWidgetSandbox?: Maybe<V3BusinessWidgetResponse>;
  /** create a new channel */
  postV3ConfigurationCustomersCustomerIdChannel: Scalars['String']['output'];
  /** create a new channel */
  postV3ConfigurationCustomersCustomerIdChannelSandbox: Scalars['String']['output'];
  /** create a new key */
  postV3PypesPypeIdKeys: Scalars['String']['output'];
  /** create a new key */
  postV3PypesPypeIdKeysSandbox: Scalars['String']['output'];
  postVersionBulkTest: Scalars['String']['output'];
  postVersionConfig?: Maybe<Version>;
  postVersionNluTest: Scalars['String']['output'];
  postVersionScript?: Maybe<Version>;
  /**
   * Format of JSON:
   * {"stopwords": ["a", "at", "the", ...]}
   */
  postVersionStopwords: Scalars['String']['output'];
  postVersionTemplate?: Maybe<Version>;
  putBotAssets?: Maybe<Asset>;
  /** update a pre-existent agent, change name/phone, etc. assign role on a new pype */
  putV3BusinessAgent: Scalars['String']['output'];
  /** update a pre-existent agent, change name/phone, etc. assign role on a new pype */
  putV3BusinessAgentSandbox: Scalars['String']['output'];
  /** update a pre-existinmg widget */
  putV3BusinessWidget?: Maybe<V3BusinessWidgetResponse>;
  /** update a pre-existinmg widget */
  putV3BusinessWidgetSandbox?: Maybe<V3BusinessWidgetResponse>;
  putVersionDeploy?: Maybe<Version>;
  putVersionGraph?: Maybe<Version>;
  putVersionPreview?: Maybe<Version>;
  putVersionSearchNluTrain?: Maybe<Version>;
  putVersionTrain?: Maybe<Version>;
  /** Save Pro Studio widget app design (live). */
  putWidgetAppDesign?: Maybe<WidgetAppDesignResponse>;
  /** Save Pro Studio widget app design (sandbox). */
  putWidgetAppDesignSandbox?: Maybe<WidgetAppDesignResponse>;
  /** Update a pype. */
  pypesDeleteCustomersPypesById: Scalars['String']['output'];
  /** Update a pype. */
  pypesDeleteCustomersPypesByIdSandbox: Scalars['String']['output'];
  /** Delete a specific API key by ID. */
  pypesDeleteCustomersPypesKeysById: Scalars['String']['output'];
  /** Delete a specific API key by ID. */
  pypesDeleteCustomersPypesKeysByIdSandbox: Scalars['String']['output'];
  /** Delete a stream bot. */
  pypesDeleteCustomersPypesStreamsBot?: Maybe<Pype>;
  /** Delete a stream bot. */
  pypesDeleteCustomersPypesStreamsBotSandbox?: Maybe<Pype>;
  /** Delete a stream. */
  pypesDeleteCustomersPypesStreamsById: Scalars['String']['output'];
  /** Delete a stream. */
  pypesDeleteCustomersPypesStreamsByIdSandbox: Scalars['String']['output'];
  /** Create a pype on a customer. */
  pypesPostCustomersPypes?: Maybe<Pype>;
  /** Create a new API key for the specified pype. */
  pypesPostCustomersPypesKeys?: Maybe<ApiKey>;
  /** Create a new API key for the specified pype. */
  pypesPostCustomersPypesKeysSandbox?: Maybe<ApiKey>;
  /** List previewable pypes of customer. */
  pypesPostCustomersPypesPreview?: Maybe<Array<Maybe<Pype>>>;
  /** List previewable pypes of customer. */
  pypesPostCustomersPypesPreviewSandbox?: Maybe<Array<Maybe<Pype>>>;
  /** Create a pype on a customer. */
  pypesPostCustomersPypesSandbox?: Maybe<Pype>;
  /** Search a user's pypes. */
  pypesPostCustomersPypesSearches?: Maybe<Array<Maybe<Pype>>>;
  /** Search a user's pypes. */
  pypesPostCustomersPypesSearchesSandbox?: Maybe<Array<Maybe<Pype>>>;
  /** Create a stream on a pype. */
  pypesPostCustomersPypesStreams?: Maybe<Stream>;
  /** Create a stream on a pype. */
  pypesPostCustomersPypesStreamsSandbox?: Maybe<Stream>;
  /** Search a user's pypes. */
  pypesPostUsersPypesSearches?: Maybe<Array<Maybe<Pype>>>;
  /** Search a user's pypes. */
  pypesPostUsersPypesSearchesSandbox?: Maybe<Array<Maybe<Pype>>>;
  /** Update a stream. */
  pypesPutCustomerByIdPypesStreamsById?: Maybe<Stream>;
  /** Update a stream. */
  pypesPutCustomerByIdPypesStreamsByIdSandbox?: Maybe<Stream>;
  /** Bulk update pypes of a customer. */
  pypesPutCustomersPypes?: Maybe<Array<Maybe<Pype>>>;
  /** Update metadata for a specific API key. Only provided fields are changed. */
  pypesPutCustomersPypesKeysById?: Maybe<ApiKeyDetail>;
  /** Update metadata for a specific API key. Only provided fields are changed. */
  pypesPutCustomersPypesKeysByIdSandbox?: Maybe<ApiKeyDetail>;
  /** Bulk update pypes of a customer. */
  pypesPutCustomersPypesSandbox?: Maybe<Array<Maybe<Pype>>>;
  /** Update a stream bot. */
  pypesPutCustomersPypesStreamsBot?: Maybe<CustomerPypesStreamsBotResponse>;
  /** Update a stream bot. */
  pypesPutCustomersPypesStreamsBotSandbox?: Maybe<CustomerPypesStreamsBotResponse>;
  /** Update preview metadata in stream. */
  pypesPutCustomersPypesStreamsMetadata?: Maybe<Stream>;
  /** Update preview metadata in stream. */
  pypesPutCustomersPypesStreamsMetadataSandbox?: Maybe<Stream>;
  /** Update a pype. */
  pypesPutCutomerByIdPypesPypeById?: Maybe<Pype>;
  /** Update a pype. */
  pypesPutCutomerByIdPypesPypeByIdSandbox?: Maybe<Pype>;
  /** update data of the table: "tenancy._ProjectEnvironmentConfigToVariable" */
  update_tenancy__ProjectEnvironmentConfigToVariable?: Maybe<Tenancy__ProjectEnvironmentConfigToVariable_Mutation_Response>;
  /** update multiples rows of table: "tenancy._ProjectEnvironmentConfigToVariable" */
  update_tenancy__ProjectEnvironmentConfigToVariable_many?: Maybe<Array<Maybe<Tenancy__ProjectEnvironmentConfigToVariable_Mutation_Response>>>;
  /** update data of the table: "tenancy._prisma_migrations" */
  update_tenancy__prisma_migrations?: Maybe<Tenancy__Prisma_Migrations_Mutation_Response>;
  /** update single row of the table: "tenancy._prisma_migrations" */
  update_tenancy__prisma_migrations_by_pk?: Maybe<Tenancy__Prisma_Migrations>;
  /** update multiples rows of table: "tenancy._prisma_migrations" */
  update_tenancy__prisma_migrations_many?: Maybe<Array<Maybe<Tenancy__Prisma_Migrations_Mutation_Response>>>;
  /** update data of the table: "tenancy._role_projects" */
  update_tenancy__role_projects?: Maybe<Tenancy__Role_Projects_Mutation_Response>;
  /** update multiples rows of table: "tenancy._role_projects" */
  update_tenancy__role_projects_many?: Maybe<Array<Maybe<Tenancy__Role_Projects_Mutation_Response>>>;
  /** update data of the table: "tenancy._team_account_environment_config_roles" */
  update_tenancy__team_account_environment_config_roles?: Maybe<Tenancy__Team_Account_Environment_Config_Roles_Mutation_Response>;
  /** update multiples rows of table: "tenancy._team_account_environment_config_roles" */
  update_tenancy__team_account_environment_config_roles_many?: Maybe<Array<Maybe<Tenancy__Team_Account_Environment_Config_Roles_Mutation_Response>>>;
  /** update data of the table: "tenancy._team_account_project_roles" */
  update_tenancy__team_account_project_roles?: Maybe<Tenancy__Team_Account_Project_Roles_Mutation_Response>;
  /** update multiples rows of table: "tenancy._team_account_project_roles" */
  update_tenancy__team_account_project_roles_many?: Maybe<Array<Maybe<Tenancy__Team_Account_Project_Roles_Mutation_Response>>>;
  /** update data of the table: "tenancy._team_account_roles" */
  update_tenancy__team_account_roles?: Maybe<Tenancy__Team_Account_Roles_Mutation_Response>;
  /** update multiples rows of table: "tenancy._team_account_roles" */
  update_tenancy__team_account_roles_many?: Maybe<Array<Maybe<Tenancy__Team_Account_Roles_Mutation_Response>>>;
  /** update data of the table: "tenancy._user_account_environment_config_roles" */
  update_tenancy__user_account_environment_config_roles?: Maybe<Tenancy__User_Account_Environment_Config_Roles_Mutation_Response>;
  /** update multiples rows of table: "tenancy._user_account_environment_config_roles" */
  update_tenancy__user_account_environment_config_roles_many?: Maybe<Array<Maybe<Tenancy__User_Account_Environment_Config_Roles_Mutation_Response>>>;
  /** update data of the table: "tenancy._user_account_project_roles" */
  update_tenancy__user_account_project_roles?: Maybe<Tenancy__User_Account_Project_Roles_Mutation_Response>;
  /** update multiples rows of table: "tenancy._user_account_project_roles" */
  update_tenancy__user_account_project_roles_many?: Maybe<Array<Maybe<Tenancy__User_Account_Project_Roles_Mutation_Response>>>;
  /** update data of the table: "tenancy._user_account_roles" */
  update_tenancy__user_account_roles?: Maybe<Tenancy__User_Account_Roles_Mutation_Response>;
  /** update multiples rows of table: "tenancy._user_account_roles" */
  update_tenancy__user_account_roles_many?: Maybe<Array<Maybe<Tenancy__User_Account_Roles_Mutation_Response>>>;
  /** update data of the table: "tenancy._user_teams" */
  update_tenancy__user_teams?: Maybe<Tenancy__User_Teams_Mutation_Response>;
  /** update multiples rows of table: "tenancy._user_teams" */
  update_tenancy__user_teams_many?: Maybe<Array<Maybe<Tenancy__User_Teams_Mutation_Response>>>;
  /** update data of the table: "tenancy.account_auth_method_settings" */
  update_tenancy_account_auth_method_settings?: Maybe<Tenancy_Account_Auth_Method_Settings_Mutation_Response>;
  /** update single row of the table: "tenancy.account_auth_method_settings" */
  update_tenancy_account_auth_method_settings_by_pk?: Maybe<Tenancy_Account_Auth_Method_Settings>;
  /** update multiples rows of table: "tenancy.account_auth_method_settings" */
  update_tenancy_account_auth_method_settings_many?: Maybe<Array<Maybe<Tenancy_Account_Auth_Method_Settings_Mutation_Response>>>;
  /** update data of the table: "tenancy.accounts" */
  update_tenancy_accounts?: Maybe<Tenancy_Accounts_Mutation_Response>;
  /** update single row of the table: "tenancy.accounts" */
  update_tenancy_accounts_by_pk?: Maybe<Tenancy_Accounts>;
  /** update multiples rows of table: "tenancy.accounts" */
  update_tenancy_accounts_many?: Maybe<Array<Maybe<Tenancy_Accounts_Mutation_Response>>>;
  /** update data of the table: "tenancy.action" */
  update_tenancy_action?: Maybe<Tenancy_Action_Mutation_Response>;
  /** update single row of the table: "tenancy.action" */
  update_tenancy_action_by_pk?: Maybe<Tenancy_Action>;
  /** update multiples rows of table: "tenancy.action" */
  update_tenancy_action_many?: Maybe<Array<Maybe<Tenancy_Action_Mutation_Response>>>;
  /** update data of the table: "tenancy.action_node_job" */
  update_tenancy_action_node_job?: Maybe<Tenancy_Action_Node_Job_Mutation_Response>;
  /** update single row of the table: "tenancy.action_node_job" */
  update_tenancy_action_node_job_by_pk?: Maybe<Tenancy_Action_Node_Job>;
  /** update multiples rows of table: "tenancy.action_node_job" */
  update_tenancy_action_node_job_many?: Maybe<Array<Maybe<Tenancy_Action_Node_Job_Mutation_Response>>>;
  /** update data of the table: "tenancy.app_config" */
  update_tenancy_app_config?: Maybe<Tenancy_App_Config_Mutation_Response>;
  /** update single row of the table: "tenancy.app_config" */
  update_tenancy_app_config_by_pk?: Maybe<Tenancy_App_Config>;
  /** update multiples rows of table: "tenancy.app_config" */
  update_tenancy_app_config_many?: Maybe<Array<Maybe<Tenancy_App_Config_Mutation_Response>>>;
  /** update data of the table: "tenancy.applet" */
  update_tenancy_applet?: Maybe<Tenancy_Applet_Mutation_Response>;
  /** update single row of the table: "tenancy.applet" */
  update_tenancy_applet_by_pk?: Maybe<Tenancy_Applet>;
  /** update data of the table: "tenancy.applet_instance" */
  update_tenancy_applet_instance?: Maybe<Tenancy_Applet_Instance_Mutation_Response>;
  /** update single row of the table: "tenancy.applet_instance" */
  update_tenancy_applet_instance_by_pk?: Maybe<Tenancy_Applet_Instance>;
  /** update multiples rows of table: "tenancy.applet_instance" */
  update_tenancy_applet_instance_many?: Maybe<Array<Maybe<Tenancy_Applet_Instance_Mutation_Response>>>;
  /** update multiples rows of table: "tenancy.applet" */
  update_tenancy_applet_many?: Maybe<Array<Maybe<Tenancy_Applet_Mutation_Response>>>;
  /** update data of the table: "tenancy.applet_version" */
  update_tenancy_applet_version?: Maybe<Tenancy_Applet_Version_Mutation_Response>;
  /** update single row of the table: "tenancy.applet_version" */
  update_tenancy_applet_version_by_pk?: Maybe<Tenancy_Applet_Version>;
  /** update multiples rows of table: "tenancy.applet_version" */
  update_tenancy_applet_version_many?: Maybe<Array<Maybe<Tenancy_Applet_Version_Mutation_Response>>>;
  /** update data of the table: "tenancy.audit_logs" */
  update_tenancy_audit_logs?: Maybe<Tenancy_Audit_Logs_Mutation_Response>;
  /** update single row of the table: "tenancy.audit_logs" */
  update_tenancy_audit_logs_by_pk?: Maybe<Tenancy_Audit_Logs>;
  /** update multiples rows of table: "tenancy.audit_logs" */
  update_tenancy_audit_logs_many?: Maybe<Array<Maybe<Tenancy_Audit_Logs_Mutation_Response>>>;
  /** update data of the table: "tenancy.auth_method" */
  update_tenancy_auth_method?: Maybe<Tenancy_Auth_Method_Mutation_Response>;
  /** update single row of the table: "tenancy.auth_method" */
  update_tenancy_auth_method_by_pk?: Maybe<Tenancy_Auth_Method>;
  /** update multiples rows of table: "tenancy.auth_method" */
  update_tenancy_auth_method_many?: Maybe<Array<Maybe<Tenancy_Auth_Method_Mutation_Response>>>;
  /** update data of the table: "tenancy.condition" */
  update_tenancy_condition?: Maybe<Tenancy_Condition_Mutation_Response>;
  /** update single row of the table: "tenancy.condition" */
  update_tenancy_condition_by_pk?: Maybe<Tenancy_Condition>;
  /** update multiples rows of table: "tenancy.condition" */
  update_tenancy_condition_many?: Maybe<Array<Maybe<Tenancy_Condition_Mutation_Response>>>;
  /** update data of the table: "tenancy.country" */
  update_tenancy_country?: Maybe<Tenancy_Country_Mutation_Response>;
  /** update single row of the table: "tenancy.country" */
  update_tenancy_country_by_pk?: Maybe<Tenancy_Country>;
  /** update multiples rows of table: "tenancy.country" */
  update_tenancy_country_many?: Maybe<Array<Maybe<Tenancy_Country_Mutation_Response>>>;
  /** update data of the table: "tenancy.custom_auth_method" */
  update_tenancy_custom_auth_method?: Maybe<Tenancy_Custom_Auth_Method_Mutation_Response>;
  /** update single row of the table: "tenancy.custom_auth_method" */
  update_tenancy_custom_auth_method_by_pk?: Maybe<Tenancy_Custom_Auth_Method>;
  /** update multiples rows of table: "tenancy.custom_auth_method" */
  update_tenancy_custom_auth_method_many?: Maybe<Array<Maybe<Tenancy_Custom_Auth_Method_Mutation_Response>>>;
  /** update data of the table: "tenancy.domain" */
  update_tenancy_domain?: Maybe<Tenancy_Domain_Mutation_Response>;
  /** update single row of the table: "tenancy.domain" */
  update_tenancy_domain_by_pk?: Maybe<Tenancy_Domain>;
  /** update multiples rows of table: "tenancy.domain" */
  update_tenancy_domain_many?: Maybe<Array<Maybe<Tenancy_Domain_Mutation_Response>>>;
  /** update data of the table: "tenancy.environment" */
  update_tenancy_environment?: Maybe<Tenancy_Environment_Mutation_Response>;
  /** update single row of the table: "tenancy.environment" */
  update_tenancy_environment_by_pk?: Maybe<Tenancy_Environment>;
  /** update multiples rows of table: "tenancy.environment" */
  update_tenancy_environment_many?: Maybe<Array<Maybe<Tenancy_Environment_Mutation_Response>>>;
  /** update data of the table: "tenancy.failed_kafka_events" */
  update_tenancy_failed_kafka_events?: Maybe<Tenancy_Failed_Kafka_Events_Mutation_Response>;
  /** update single row of the table: "tenancy.failed_kafka_events" */
  update_tenancy_failed_kafka_events_by_pk?: Maybe<Tenancy_Failed_Kafka_Events>;
  /** update multiples rows of table: "tenancy.failed_kafka_events" */
  update_tenancy_failed_kafka_events_many?: Maybe<Array<Maybe<Tenancy_Failed_Kafka_Events_Mutation_Response>>>;
  /** update data of the table: "tenancy.file" */
  update_tenancy_file?: Maybe<Tenancy_File_Mutation_Response>;
  /** update single row of the table: "tenancy.file" */
  update_tenancy_file_by_pk?: Maybe<Tenancy_File>;
  /** update multiples rows of table: "tenancy.file" */
  update_tenancy_file_many?: Maybe<Array<Maybe<Tenancy_File_Mutation_Response>>>;
  /** update data of the table: "tenancy.llm_credentials" */
  update_tenancy_llm_credentials?: Maybe<Tenancy_Llm_Credentials_Mutation_Response>;
  /** update single row of the table: "tenancy.llm_credentials" */
  update_tenancy_llm_credentials_by_pk?: Maybe<Tenancy_Llm_Credentials>;
  /** update multiples rows of table: "tenancy.llm_credentials" */
  update_tenancy_llm_credentials_many?: Maybe<Array<Maybe<Tenancy_Llm_Credentials_Mutation_Response>>>;
  /** update data of the table: "tenancy.llm_providers" */
  update_tenancy_llm_providers?: Maybe<Tenancy_Llm_Providers_Mutation_Response>;
  /** update single row of the table: "tenancy.llm_providers" */
  update_tenancy_llm_providers_by_pk?: Maybe<Tenancy_Llm_Providers>;
  /** update multiples rows of table: "tenancy.llm_providers" */
  update_tenancy_llm_providers_many?: Maybe<Array<Maybe<Tenancy_Llm_Providers_Mutation_Response>>>;
  /** update data of the table: "tenancy.locale" */
  update_tenancy_locale?: Maybe<Tenancy_Locale_Mutation_Response>;
  /** update single row of the table: "tenancy.locale" */
  update_tenancy_locale_by_pk?: Maybe<Tenancy_Locale>;
  /** update multiples rows of table: "tenancy.locale" */
  update_tenancy_locale_many?: Maybe<Array<Maybe<Tenancy_Locale_Mutation_Response>>>;
  /** update data of the table: "tenancy.localization_settings" */
  update_tenancy_localization_settings?: Maybe<Tenancy_Localization_Settings_Mutation_Response>;
  /** update single row of the table: "tenancy.localization_settings" */
  update_tenancy_localization_settings_by_pk?: Maybe<Tenancy_Localization_Settings>;
  /** update multiples rows of table: "tenancy.localization_settings" */
  update_tenancy_localization_settings_many?: Maybe<Array<Maybe<Tenancy_Localization_Settings_Mutation_Response>>>;
  /** update data of the table: "tenancy.node_type_enum_ps" */
  update_tenancy_node_type_enum_ps?: Maybe<Tenancy_Node_Type_Enum_Ps_Mutation_Response>;
  /** update single row of the table: "tenancy.node_type_enum_ps" */
  update_tenancy_node_type_enum_ps_by_pk?: Maybe<Tenancy_Node_Type_Enum_Ps>;
  /** update multiples rows of table: "tenancy.node_type_enum_ps" */
  update_tenancy_node_type_enum_ps_many?: Maybe<Array<Maybe<Tenancy_Node_Type_Enum_Ps_Mutation_Response>>>;
  /** update data of the table: "tenancy.package" */
  update_tenancy_package?: Maybe<Tenancy_Package_Mutation_Response>;
  /** update single row of the table: "tenancy.package" */
  update_tenancy_package_by_pk?: Maybe<Tenancy_Package>;
  /** update multiples rows of table: "tenancy.package" */
  update_tenancy_package_many?: Maybe<Array<Maybe<Tenancy_Package_Mutation_Response>>>;
  /** update data of the table: "tenancy.package_version" */
  update_tenancy_package_version?: Maybe<Tenancy_Package_Version_Mutation_Response>;
  /** update single row of the table: "tenancy.package_version" */
  update_tenancy_package_version_by_pk?: Maybe<Tenancy_Package_Version>;
  /** update multiples rows of table: "tenancy.package_version" */
  update_tenancy_package_version_many?: Maybe<Array<Maybe<Tenancy_Package_Version_Mutation_Response>>>;
  /** update data of the table: "tenancy.pro_studio_performance_metrics" */
  update_tenancy_pro_studio_performance_metrics?: Maybe<Tenancy_Pro_Studio_Performance_Metrics_Mutation_Response>;
  /** update single row of the table: "tenancy.pro_studio_performance_metrics" */
  update_tenancy_pro_studio_performance_metrics_by_pk?: Maybe<Tenancy_Pro_Studio_Performance_Metrics>;
  /** update multiples rows of table: "tenancy.pro_studio_performance_metrics" */
  update_tenancy_pro_studio_performance_metrics_many?: Maybe<Array<Maybe<Tenancy_Pro_Studio_Performance_Metrics_Mutation_Response>>>;
  /** update data of the table: "tenancy.products" */
  update_tenancy_products?: Maybe<Tenancy_Products_Mutation_Response>;
  /** update single row of the table: "tenancy.products" */
  update_tenancy_products_by_pk?: Maybe<Tenancy_Products>;
  /** update multiples rows of table: "tenancy.products" */
  update_tenancy_products_many?: Maybe<Array<Maybe<Tenancy_Products_Mutation_Response>>>;
  /** update data of the table: "tenancy.project_environment_config" */
  update_tenancy_project_environment_config?: Maybe<Tenancy_Project_Environment_Config_Mutation_Response>;
  /** update single row of the table: "tenancy.project_environment_config" */
  update_tenancy_project_environment_config_by_pk?: Maybe<Tenancy_Project_Environment_Config>;
  /** update multiples rows of table: "tenancy.project_environment_config" */
  update_tenancy_project_environment_config_many?: Maybe<Array<Maybe<Tenancy_Project_Environment_Config_Mutation_Response>>>;
  /** update data of the table: "tenancy.project_pro_studio_setting" */
  update_tenancy_project_pro_studio_setting?: Maybe<Tenancy_Project_Pro_Studio_Setting_Mutation_Response>;
  /** update single row of the table: "tenancy.project_pro_studio_setting" */
  update_tenancy_project_pro_studio_setting_by_pk?: Maybe<Tenancy_Project_Pro_Studio_Setting>;
  /** update multiples rows of table: "tenancy.project_pro_studio_setting" */
  update_tenancy_project_pro_studio_setting_many?: Maybe<Array<Maybe<Tenancy_Project_Pro_Studio_Setting_Mutation_Response>>>;
  /** update data of the table: "tenancy.project_product_settings" */
  update_tenancy_project_product_settings?: Maybe<Tenancy_Project_Product_Settings_Mutation_Response>;
  /** update single row of the table: "tenancy.project_product_settings" */
  update_tenancy_project_product_settings_by_pk?: Maybe<Tenancy_Project_Product_Settings>;
  /** update multiples rows of table: "tenancy.project_product_settings" */
  update_tenancy_project_product_settings_many?: Maybe<Array<Maybe<Tenancy_Project_Product_Settings_Mutation_Response>>>;
  /** update data of the table: "tenancy.projects" */
  update_tenancy_projects?: Maybe<Tenancy_Projects_Mutation_Response>;
  /** update single row of the table: "tenancy.projects" */
  update_tenancy_projects_by_pk?: Maybe<Tenancy_Projects>;
  /** update multiples rows of table: "tenancy.projects" */
  update_tenancy_projects_many?: Maybe<Array<Maybe<Tenancy_Projects_Mutation_Response>>>;
  /** update data of the table: "tenancy.pype_connection" */
  update_tenancy_pype_connection?: Maybe<Tenancy_Pype_Connection_Mutation_Response>;
  /** update single row of the table: "tenancy.pype_connection" */
  update_tenancy_pype_connection_by_pk?: Maybe<Tenancy_Pype_Connection>;
  /** update multiples rows of table: "tenancy.pype_connection" */
  update_tenancy_pype_connection_many?: Maybe<Array<Maybe<Tenancy_Pype_Connection_Mutation_Response>>>;
  /** update data of the table: "tenancy.pype_connection_pype" */
  update_tenancy_pype_connection_pype?: Maybe<Tenancy_Pype_Connection_Pype_Mutation_Response>;
  /** update single row of the table: "tenancy.pype_connection_pype" */
  update_tenancy_pype_connection_pype_by_pk?: Maybe<Tenancy_Pype_Connection_Pype>;
  /** update multiples rows of table: "tenancy.pype_connection_pype" */
  update_tenancy_pype_connection_pype_many?: Maybe<Array<Maybe<Tenancy_Pype_Connection_Pype_Mutation_Response>>>;
  /** update data of the table: "tenancy.pype_rule" */
  update_tenancy_pype_rule?: Maybe<Tenancy_Pype_Rule_Mutation_Response>;
  /** update single row of the table: "tenancy.pype_rule" */
  update_tenancy_pype_rule_by_pk?: Maybe<Tenancy_Pype_Rule>;
  /** update data of the table: "tenancy.pype_rule_group" */
  update_tenancy_pype_rule_group?: Maybe<Tenancy_Pype_Rule_Group_Mutation_Response>;
  /** update single row of the table: "tenancy.pype_rule_group" */
  update_tenancy_pype_rule_group_by_pk?: Maybe<Tenancy_Pype_Rule_Group>;
  /** update multiples rows of table: "tenancy.pype_rule_group" */
  update_tenancy_pype_rule_group_many?: Maybe<Array<Maybe<Tenancy_Pype_Rule_Group_Mutation_Response>>>;
  /** update data of the table: "tenancy.pype_rule_group_pype" */
  update_tenancy_pype_rule_group_pype?: Maybe<Tenancy_Pype_Rule_Group_Pype_Mutation_Response>;
  /** update single row of the table: "tenancy.pype_rule_group_pype" */
  update_tenancy_pype_rule_group_pype_by_pk?: Maybe<Tenancy_Pype_Rule_Group_Pype>;
  /** update multiples rows of table: "tenancy.pype_rule_group_pype" */
  update_tenancy_pype_rule_group_pype_many?: Maybe<Array<Maybe<Tenancy_Pype_Rule_Group_Pype_Mutation_Response>>>;
  /** update multiples rows of table: "tenancy.pype_rule" */
  update_tenancy_pype_rule_many?: Maybe<Array<Maybe<Tenancy_Pype_Rule_Mutation_Response>>>;
  /** update data of the table: "tenancy.rich_asset_type_enum_ps" */
  update_tenancy_rich_asset_type_enum_ps?: Maybe<Tenancy_Rich_Asset_Type_Enum_Ps_Mutation_Response>;
  /** update single row of the table: "tenancy.rich_asset_type_enum_ps" */
  update_tenancy_rich_asset_type_enum_ps_by_pk?: Maybe<Tenancy_Rich_Asset_Type_Enum_Ps>;
  /** update multiples rows of table: "tenancy.rich_asset_type_enum_ps" */
  update_tenancy_rich_asset_type_enum_ps_many?: Maybe<Array<Maybe<Tenancy_Rich_Asset_Type_Enum_Ps_Mutation_Response>>>;
  /** update data of the table: "tenancy.roles" */
  update_tenancy_roles?: Maybe<Tenancy_Roles_Mutation_Response>;
  /** update single row of the table: "tenancy.roles" */
  update_tenancy_roles_by_pk?: Maybe<Tenancy_Roles>;
  /** update multiples rows of table: "tenancy.roles" */
  update_tenancy_roles_many?: Maybe<Array<Maybe<Tenancy_Roles_Mutation_Response>>>;
  /** update data of the table: "tenancy.solution_deployment_run_workflows" */
  update_tenancy_solution_deployment_run_workflows?: Maybe<Tenancy_Solution_Deployment_Run_Workflows_Mutation_Response>;
  /** update single row of the table: "tenancy.solution_deployment_run_workflows" */
  update_tenancy_solution_deployment_run_workflows_by_pk?: Maybe<Tenancy_Solution_Deployment_Run_Workflows>;
  /** update multiples rows of table: "tenancy.solution_deployment_run_workflows" */
  update_tenancy_solution_deployment_run_workflows_many?: Maybe<Array<Maybe<Tenancy_Solution_Deployment_Run_Workflows_Mutation_Response>>>;
  /** update data of the table: "tenancy.solution_deployment_runs" */
  update_tenancy_solution_deployment_runs?: Maybe<Tenancy_Solution_Deployment_Runs_Mutation_Response>;
  /** update single row of the table: "tenancy.solution_deployment_runs" */
  update_tenancy_solution_deployment_runs_by_pk?: Maybe<Tenancy_Solution_Deployment_Runs>;
  /** update multiples rows of table: "tenancy.solution_deployment_runs" */
  update_tenancy_solution_deployment_runs_many?: Maybe<Array<Maybe<Tenancy_Solution_Deployment_Runs_Mutation_Response>>>;
  /** update data of the table: "tenancy.solution_deployments" */
  update_tenancy_solution_deployments?: Maybe<Tenancy_Solution_Deployments_Mutation_Response>;
  /** update single row of the table: "tenancy.solution_deployments" */
  update_tenancy_solution_deployments_by_pk?: Maybe<Tenancy_Solution_Deployments>;
  /** update multiples rows of table: "tenancy.solution_deployments" */
  update_tenancy_solution_deployments_many?: Maybe<Array<Maybe<Tenancy_Solution_Deployments_Mutation_Response>>>;
  /** update data of the table: "tenancy.solution_task" */
  update_tenancy_solution_task?: Maybe<Tenancy_Solution_Task_Mutation_Response>;
  /** update single row of the table: "tenancy.solution_task" */
  update_tenancy_solution_task_by_pk?: Maybe<Tenancy_Solution_Task>;
  /** update multiples rows of table: "tenancy.solution_task" */
  update_tenancy_solution_task_many?: Maybe<Array<Maybe<Tenancy_Solution_Task_Mutation_Response>>>;
  /** update data of the table: "tenancy.solution_user_presence" */
  update_tenancy_solution_user_presence?: Maybe<Tenancy_Solution_User_Presence_Mutation_Response>;
  /** update single row of the table: "tenancy.solution_user_presence" */
  update_tenancy_solution_user_presence_by_pk?: Maybe<Tenancy_Solution_User_Presence>;
  /** update multiples rows of table: "tenancy.solution_user_presence" */
  update_tenancy_solution_user_presence_many?: Maybe<Array<Maybe<Tenancy_Solution_User_Presence_Mutation_Response>>>;
  /** update data of the table: "tenancy.solution_version_nodes_ps" */
  update_tenancy_solution_version_nodes_ps?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Mutation_Response>;
  /** update single row of the table: "tenancy.solution_version_nodes_ps" */
  update_tenancy_solution_version_nodes_ps_by_pk?: Maybe<Tenancy_Solution_Version_Nodes_Ps>;
  /** update multiples rows of table: "tenancy.solution_version_nodes_ps" */
  update_tenancy_solution_version_nodes_ps_many?: Maybe<Array<Maybe<Tenancy_Solution_Version_Nodes_Ps_Mutation_Response>>>;
  /** update data of the table: "tenancy.solution_versions" */
  update_tenancy_solution_versions?: Maybe<Tenancy_Solution_Versions_Mutation_Response>;
  /** update single row of the table: "tenancy.solution_versions" */
  update_tenancy_solution_versions_by_pk?: Maybe<Tenancy_Solution_Versions>;
  /** update multiples rows of table: "tenancy.solution_versions" */
  update_tenancy_solution_versions_many?: Maybe<Array<Maybe<Tenancy_Solution_Versions_Mutation_Response>>>;
  /** update data of the table: "tenancy.solution_versions_ps" */
  update_tenancy_solution_versions_ps?: Maybe<Tenancy_Solution_Versions_Ps_Mutation_Response>;
  /** update single row of the table: "tenancy.solution_versions_ps" */
  update_tenancy_solution_versions_ps_by_pk?: Maybe<Tenancy_Solution_Versions_Ps>;
  /** update multiples rows of table: "tenancy.solution_versions_ps" */
  update_tenancy_solution_versions_ps_many?: Maybe<Array<Maybe<Tenancy_Solution_Versions_Ps_Mutation_Response>>>;
  /** update data of the table: "tenancy.solutions" */
  update_tenancy_solutions?: Maybe<Tenancy_Solutions_Mutation_Response>;
  /** update single row of the table: "tenancy.solutions" */
  update_tenancy_solutions_by_pk?: Maybe<Tenancy_Solutions>;
  /** update multiples rows of table: "tenancy.solutions" */
  update_tenancy_solutions_many?: Maybe<Array<Maybe<Tenancy_Solutions_Mutation_Response>>>;
  /** update data of the table: "tenancy.studio_resource" */
  update_tenancy_studio_resource?: Maybe<Tenancy_Studio_Resource_Mutation_Response>;
  /** update single row of the table: "tenancy.studio_resource" */
  update_tenancy_studio_resource_by_pk?: Maybe<Tenancy_Studio_Resource>;
  /** update multiples rows of table: "tenancy.studio_resource" */
  update_tenancy_studio_resource_many?: Maybe<Array<Maybe<Tenancy_Studio_Resource_Mutation_Response>>>;
  /** update data of the table: "tenancy.team_account_environment_config" */
  update_tenancy_team_account_environment_config?: Maybe<Tenancy_Team_Account_Environment_Config_Mutation_Response>;
  /** update single row of the table: "tenancy.team_account_environment_config" */
  update_tenancy_team_account_environment_config_by_pk?: Maybe<Tenancy_Team_Account_Environment_Config>;
  /** update multiples rows of table: "tenancy.team_account_environment_config" */
  update_tenancy_team_account_environment_config_many?: Maybe<Array<Maybe<Tenancy_Team_Account_Environment_Config_Mutation_Response>>>;
  /** update data of the table: "tenancy.team_account_projects" */
  update_tenancy_team_account_projects?: Maybe<Tenancy_Team_Account_Projects_Mutation_Response>;
  /** update single row of the table: "tenancy.team_account_projects" */
  update_tenancy_team_account_projects_by_pk?: Maybe<Tenancy_Team_Account_Projects>;
  /** update multiples rows of table: "tenancy.team_account_projects" */
  update_tenancy_team_account_projects_many?: Maybe<Array<Maybe<Tenancy_Team_Account_Projects_Mutation_Response>>>;
  /** update data of the table: "tenancy.team_accounts" */
  update_tenancy_team_accounts?: Maybe<Tenancy_Team_Accounts_Mutation_Response>;
  /** update single row of the table: "tenancy.team_accounts" */
  update_tenancy_team_accounts_by_pk?: Maybe<Tenancy_Team_Accounts>;
  /** update multiples rows of table: "tenancy.team_accounts" */
  update_tenancy_team_accounts_many?: Maybe<Array<Maybe<Tenancy_Team_Accounts_Mutation_Response>>>;
  /** update data of the table: "tenancy.teams" */
  update_tenancy_teams?: Maybe<Tenancy_Teams_Mutation_Response>;
  /** update single row of the table: "tenancy.teams" */
  update_tenancy_teams_by_pk?: Maybe<Tenancy_Teams>;
  /** update multiples rows of table: "tenancy.teams" */
  update_tenancy_teams_many?: Maybe<Array<Maybe<Tenancy_Teams_Mutation_Response>>>;
  /** update data of the table: "tenancy.template_node" */
  update_tenancy_template_node?: Maybe<Tenancy_Template_Node_Mutation_Response>;
  /** update single row of the table: "tenancy.template_node" */
  update_tenancy_template_node_by_pk?: Maybe<Tenancy_Template_Node>;
  /** update multiples rows of table: "tenancy.template_node" */
  update_tenancy_template_node_many?: Maybe<Array<Maybe<Tenancy_Template_Node_Mutation_Response>>>;
  /** update data of the table: "tenancy.time_zone" */
  update_tenancy_time_zone?: Maybe<Tenancy_Time_Zone_Mutation_Response>;
  /** update single row of the table: "tenancy.time_zone" */
  update_tenancy_time_zone_by_pk?: Maybe<Tenancy_Time_Zone>;
  /** update multiples rows of table: "tenancy.time_zone" */
  update_tenancy_time_zone_many?: Maybe<Array<Maybe<Tenancy_Time_Zone_Mutation_Response>>>;
  /** update data of the table: "tenancy.trigger" */
  update_tenancy_trigger?: Maybe<Tenancy_Trigger_Mutation_Response>;
  /** update single row of the table: "tenancy.trigger" */
  update_tenancy_trigger_by_pk?: Maybe<Tenancy_Trigger>;
  /** update multiples rows of table: "tenancy.trigger" */
  update_tenancy_trigger_many?: Maybe<Array<Maybe<Tenancy_Trigger_Mutation_Response>>>;
  /** update data of the table: "tenancy.user_account_auth_method_settings" */
  update_tenancy_user_account_auth_method_settings?: Maybe<Tenancy_User_Account_Auth_Method_Settings_Mutation_Response>;
  /** update single row of the table: "tenancy.user_account_auth_method_settings" */
  update_tenancy_user_account_auth_method_settings_by_pk?: Maybe<Tenancy_User_Account_Auth_Method_Settings>;
  /** update multiples rows of table: "tenancy.user_account_auth_method_settings" */
  update_tenancy_user_account_auth_method_settings_many?: Maybe<Array<Maybe<Tenancy_User_Account_Auth_Method_Settings_Mutation_Response>>>;
  /** update data of the table: "tenancy.user_account_environment_config" */
  update_tenancy_user_account_environment_config?: Maybe<Tenancy_User_Account_Environment_Config_Mutation_Response>;
  /** update single row of the table: "tenancy.user_account_environment_config" */
  update_tenancy_user_account_environment_config_by_pk?: Maybe<Tenancy_User_Account_Environment_Config>;
  /** update multiples rows of table: "tenancy.user_account_environment_config" */
  update_tenancy_user_account_environment_config_many?: Maybe<Array<Maybe<Tenancy_User_Account_Environment_Config_Mutation_Response>>>;
  /** update data of the table: "tenancy.user_account_project_metabase_access" */
  update_tenancy_user_account_project_metabase_access?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Mutation_Response>;
  /** update single row of the table: "tenancy.user_account_project_metabase_access" */
  update_tenancy_user_account_project_metabase_access_by_pk?: Maybe<Tenancy_User_Account_Project_Metabase_Access>;
  /** update multiples rows of table: "tenancy.user_account_project_metabase_access" */
  update_tenancy_user_account_project_metabase_access_many?: Maybe<Array<Maybe<Tenancy_User_Account_Project_Metabase_Access_Mutation_Response>>>;
  /** update data of the table: "tenancy.user_account_projects" */
  update_tenancy_user_account_projects?: Maybe<Tenancy_User_Account_Projects_Mutation_Response>;
  /** update single row of the table: "tenancy.user_account_projects" */
  update_tenancy_user_account_projects_by_pk?: Maybe<Tenancy_User_Account_Projects>;
  /** update multiples rows of table: "tenancy.user_account_projects" */
  update_tenancy_user_account_projects_many?: Maybe<Array<Maybe<Tenancy_User_Account_Projects_Mutation_Response>>>;
  /** update data of the table: "tenancy.user_accounts" */
  update_tenancy_user_accounts?: Maybe<Tenancy_User_Accounts_Mutation_Response>;
  /** update single row of the table: "tenancy.user_accounts" */
  update_tenancy_user_accounts_by_pk?: Maybe<Tenancy_User_Accounts>;
  /** update multiples rows of table: "tenancy.user_accounts" */
  update_tenancy_user_accounts_many?: Maybe<Array<Maybe<Tenancy_User_Accounts_Mutation_Response>>>;
  /** update data of the table: "tenancy.users" */
  update_tenancy_users?: Maybe<Tenancy_Users_Mutation_Response>;
  /** update single row of the table: "tenancy.users" */
  update_tenancy_users_by_pk?: Maybe<Tenancy_Users>;
  /** update multiples rows of table: "tenancy.users" */
  update_tenancy_users_many?: Maybe<Array<Maybe<Tenancy_Users_Mutation_Response>>>;
  /** update data of the table: "tenancy.variable" */
  update_tenancy_variable?: Maybe<Tenancy_Variable_Mutation_Response>;
  /** update single row of the table: "tenancy.variable" */
  update_tenancy_variable_by_pk?: Maybe<Tenancy_Variable>;
  /** update multiples rows of table: "tenancy.variable" */
  update_tenancy_variable_many?: Maybe<Array<Maybe<Tenancy_Variable_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDeleteBotAssetByIdArgs = {
  assetId: Scalars['String']['input'];
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBotByIdArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCustomerByIdArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCustomerPackagesArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteOneIntentArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteOneSynonymArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteOneTypeEntityArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteOneUtteranceArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteV3BusinessAgentArgs = {
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteV3BusinessAgentSandboxArgs = {
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteV3ConfigurationCustomersCustomerIdChannelChannelIdArgs = {
  channelId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteV3ConfigurationCustomersCustomerIdChannelChannelIdSandboxArgs = {
  channelId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteV3ConfigurationPypePypeIdArgs = {
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteV3ConfigurationPypePypeIdSandboxArgs = {
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteV3KeysKeyIdArgs = {
  authorization: Scalars['String']['input'];
  keyId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteV3KeysKeyIdSandboxArgs = {
  authorization: Scalars['String']['input'];
  keyId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteVersionScriptByIdArgs = {
  projectId: Scalars['String']['input'];
  scriptId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy__ProjectEnvironmentConfigToVariableArgs = {
  where: Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy__Prisma_MigrationsArgs = {
  where: Tenancy__Prisma_Migrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy__Prisma_Migrations_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy__Role_ProjectsArgs = {
  where: Tenancy__Role_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy__Team_Account_Environment_Config_RolesArgs = {
  where: Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy__Team_Account_Project_RolesArgs = {
  where: Tenancy__Team_Account_Project_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy__Team_Account_RolesArgs = {
  where: Tenancy__Team_Account_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy__User_Account_Environment_Config_RolesArgs = {
  where: Tenancy__User_Account_Environment_Config_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy__User_Account_Project_RolesArgs = {
  where: Tenancy__User_Account_Project_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy__User_Account_RolesArgs = {
  where: Tenancy__User_Account_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy__User_TeamsArgs = {
  where: Tenancy__User_Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Account_Auth_Method_SettingsArgs = {
  where: Tenancy_Account_Auth_Method_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Account_Auth_Method_Settings_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_AccountsArgs = {
  where: Tenancy_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Accounts_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_ActionArgs = {
  where: Tenancy_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Action_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Action_Node_JobArgs = {
  where: Tenancy_Action_Node_Job_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Action_Node_Job_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_App_ConfigArgs = {
  where: Tenancy_App_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_App_Config_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_AppletArgs = {
  where: Tenancy_Applet_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Applet_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Applet_InstanceArgs = {
  where: Tenancy_Applet_Instance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Applet_Instance_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Applet_VersionArgs = {
  where: Tenancy_Applet_Version_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Applet_Version_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Audit_LogsArgs = {
  where: Tenancy_Audit_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Audit_Logs_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Auth_MethodArgs = {
  where: Tenancy_Auth_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Auth_Method_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_ConditionArgs = {
  where: Tenancy_Condition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Condition_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_CountryArgs = {
  where: Tenancy_Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Country_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Custom_Auth_MethodArgs = {
  where: Tenancy_Custom_Auth_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Custom_Auth_Method_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_DomainArgs = {
  where: Tenancy_Domain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Domain_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_EnvironmentArgs = {
  where: Tenancy_Environment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Environment_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Failed_Kafka_EventsArgs = {
  where: Tenancy_Failed_Kafka_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Failed_Kafka_Events_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_FileArgs = {
  where: Tenancy_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_File_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Llm_CredentialsArgs = {
  where: Tenancy_Llm_Credentials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Llm_Credentials_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Llm_ProvidersArgs = {
  where: Tenancy_Llm_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Llm_Providers_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_LocaleArgs = {
  where: Tenancy_Locale_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Locale_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Localization_SettingsArgs = {
  where: Tenancy_Localization_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Localization_Settings_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Node_Type_Enum_PsArgs = {
  where: Tenancy_Node_Type_Enum_Ps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Node_Type_Enum_Ps_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_PackageArgs = {
  where: Tenancy_Package_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Package_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Package_VersionArgs = {
  where: Tenancy_Package_Version_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Package_Version_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Pro_Studio_Performance_MetricsArgs = {
  where: Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Pro_Studio_Performance_Metrics_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_ProductsArgs = {
  where: Tenancy_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Products_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Project_Environment_ConfigArgs = {
  where: Tenancy_Project_Environment_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Project_Environment_Config_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Project_Pro_Studio_SettingArgs = {
  where: Tenancy_Project_Pro_Studio_Setting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Project_Pro_Studio_Setting_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Project_Product_SettingsArgs = {
  where: Tenancy_Project_Product_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Project_Product_Settings_By_PkArgs = {
  productId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_ProjectsArgs = {
  where: Tenancy_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Projects_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Pype_ConnectionArgs = {
  where: Tenancy_Pype_Connection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Pype_Connection_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Pype_Connection_PypeArgs = {
  where: Tenancy_Pype_Connection_Pype_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Pype_Connection_Pype_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Pype_RuleArgs = {
  where: Tenancy_Pype_Rule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Pype_Rule_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Pype_Rule_GroupArgs = {
  where: Tenancy_Pype_Rule_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Pype_Rule_Group_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Pype_Rule_Group_PypeArgs = {
  where: Tenancy_Pype_Rule_Group_Pype_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Pype_Rule_Group_Pype_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Rich_Asset_Type_Enum_PsArgs = {
  where: Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Rich_Asset_Type_Enum_Ps_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_RolesArgs = {
  where: Tenancy_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Roles_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_Deployment_Run_WorkflowsArgs = {
  where: Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_Deployment_Run_Workflows_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_Deployment_RunsArgs = {
  where: Tenancy_Solution_Deployment_Runs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_Deployment_Runs_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_DeploymentsArgs = {
  where: Tenancy_Solution_Deployments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_Deployments_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_TaskArgs = {
  where: Tenancy_Solution_Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_Task_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_User_PresenceArgs = {
  where: Tenancy_Solution_User_Presence_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_User_Presence_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_Version_Nodes_PsArgs = {
  where: Tenancy_Solution_Version_Nodes_Ps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_Version_Nodes_Ps_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_VersionsArgs = {
  where: Tenancy_Solution_Versions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_Versions_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_Versions_PsArgs = {
  where: Tenancy_Solution_Versions_Ps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solution_Versions_Ps_By_PkArgs = {
  solutionVersionId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_SolutionsArgs = {
  where: Tenancy_Solutions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Solutions_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Studio_ResourceArgs = {
  where: Tenancy_Studio_Resource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Studio_Resource_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Team_Account_Environment_ConfigArgs = {
  where: Tenancy_Team_Account_Environment_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Team_Account_Environment_Config_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Team_Account_ProjectsArgs = {
  where: Tenancy_Team_Account_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Team_Account_Projects_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Team_AccountsArgs = {
  where: Tenancy_Team_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Team_Accounts_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_TeamsArgs = {
  where: Tenancy_Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Teams_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Template_NodeArgs = {
  where: Tenancy_Template_Node_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Template_Node_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Time_ZoneArgs = {
  where: Tenancy_Time_Zone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Time_Zone_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_TriggerArgs = {
  where: Tenancy_Trigger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Trigger_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_User_Account_Auth_Method_SettingsArgs = {
  where: Tenancy_User_Account_Auth_Method_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_User_Account_Auth_Method_Settings_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_User_Account_Environment_ConfigArgs = {
  where: Tenancy_User_Account_Environment_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_User_Account_Environment_Config_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_User_Account_Project_Metabase_AccessArgs = {
  where: Tenancy_User_Account_Project_Metabase_Access_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_User_Account_Project_Metabase_Access_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_User_Account_ProjectsArgs = {
  where: Tenancy_User_Account_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_User_Account_Projects_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_User_AccountsArgs = {
  where: Tenancy_User_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_User_Accounts_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_UsersArgs = {
  where: Tenancy_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Users_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_VariableArgs = {
  where: Tenancy_Variable_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenancy_Variable_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesDeleteCustomersByIdArgs = {
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesDeleteCustomersKeysByIdArgs = {
  customerId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesDeleteCustomersUsersEnvironmentMappingsArgs = {
  customerId: Scalars['String']['input'];
  envmapId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesDeleteUsersByUserIdArgs = {
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesDeleteUsersRoleMappingsByIdArgs = {
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPostCustomersArgs = {
  customerInput: CustomerInput;
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPostCustomersKeysArgs = {
  customerId: Scalars['String']['input'];
  customerKeyInput: CustomerKeyInput;
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPostCustomersSearchesArgs = {
  projectId: Scalars['String']['input'];
  term: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPostCustomersUsersEnvironmentMappingsArgs = {
  customerId: Scalars['String']['input'];
  environmentMappingForCreateInput: EnvironmentMappingForCreateInput;
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPostCustomersUsersSearchesArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  term: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPostKeysValidateArgs = {
  customerKeyInput: CustomerKeyInput;
  keyId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPostUserSearchesArgs = {
  projectId: Scalars['String']['input'];
  term: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPostUsersArgs = {
  gESUserInput: GesUserInput;
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPostUsersCustomersSearchesArgs = {
  projectId: Scalars['String']['input'];
  term: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPostUsersRoleMappingsArgs = {
  projectId: Scalars['String']['input'];
  roleInstantiationInput: RoleInstantiationInput;
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPutCustomersByIdArgs = {
  customerInput: CustomerInput;
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPutCustomersUsersByUserIdArgs = {
  customerId: Scalars['String']['input'];
  gESUserInput: GesUserInput;
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGesPutUsersByUserIdArgs = {
  gESUserInput: GesUserInput;
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__ProjectEnvironmentConfigToVariableArgs = {
  objects: Array<Tenancy__ProjectEnvironmentConfigToVariable_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__ProjectEnvironmentConfigToVariable_OneArgs = {
  object: Tenancy__ProjectEnvironmentConfigToVariable_Insert_Input;
  on_conflict?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__Prisma_MigrationsArgs = {
  objects: Array<Tenancy__Prisma_Migrations_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy__Prisma_Migrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__Prisma_Migrations_OneArgs = {
  object: Tenancy__Prisma_Migrations_Insert_Input;
  on_conflict?: InputMaybe<Tenancy__Prisma_Migrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__Role_ProjectsArgs = {
  objects: Array<Tenancy__Role_Projects_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy__Role_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__Role_Projects_OneArgs = {
  object: Tenancy__Role_Projects_Insert_Input;
  on_conflict?: InputMaybe<Tenancy__Role_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__Team_Account_Environment_Config_RolesArgs = {
  objects: Array<Tenancy__Team_Account_Environment_Config_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__Team_Account_Environment_Config_Roles_OneArgs = {
  object: Tenancy__Team_Account_Environment_Config_Roles_Insert_Input;
  on_conflict?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__Team_Account_Project_RolesArgs = {
  objects: Array<Tenancy__Team_Account_Project_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy__Team_Account_Project_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__Team_Account_Project_Roles_OneArgs = {
  object: Tenancy__Team_Account_Project_Roles_Insert_Input;
  on_conflict?: InputMaybe<Tenancy__Team_Account_Project_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__Team_Account_RolesArgs = {
  objects: Array<Tenancy__Team_Account_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy__Team_Account_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__Team_Account_Roles_OneArgs = {
  object: Tenancy__Team_Account_Roles_Insert_Input;
  on_conflict?: InputMaybe<Tenancy__Team_Account_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__User_Account_Environment_Config_RolesArgs = {
  objects: Array<Tenancy__User_Account_Environment_Config_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__User_Account_Environment_Config_Roles_OneArgs = {
  object: Tenancy__User_Account_Environment_Config_Roles_Insert_Input;
  on_conflict?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__User_Account_Project_RolesArgs = {
  objects: Array<Tenancy__User_Account_Project_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy__User_Account_Project_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__User_Account_Project_Roles_OneArgs = {
  object: Tenancy__User_Account_Project_Roles_Insert_Input;
  on_conflict?: InputMaybe<Tenancy__User_Account_Project_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__User_Account_RolesArgs = {
  objects: Array<Tenancy__User_Account_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy__User_Account_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__User_Account_Roles_OneArgs = {
  object: Tenancy__User_Account_Roles_Insert_Input;
  on_conflict?: InputMaybe<Tenancy__User_Account_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__User_TeamsArgs = {
  objects: Array<Tenancy__User_Teams_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy__User_Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy__User_Teams_OneArgs = {
  object: Tenancy__User_Teams_Insert_Input;
  on_conflict?: InputMaybe<Tenancy__User_Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Account_Auth_Method_SettingsArgs = {
  objects: Array<Tenancy_Account_Auth_Method_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Account_Auth_Method_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Account_Auth_Method_Settings_OneArgs = {
  object: Tenancy_Account_Auth_Method_Settings_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Account_Auth_Method_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_AccountsArgs = {
  objects: Array<Tenancy_Accounts_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Accounts_OneArgs = {
  object: Tenancy_Accounts_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_ActionArgs = {
  objects: Array<Tenancy_Action_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Action_Node_JobArgs = {
  objects: Array<Tenancy_Action_Node_Job_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Action_Node_Job_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Action_Node_Job_OneArgs = {
  object: Tenancy_Action_Node_Job_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Action_Node_Job_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Action_OneArgs = {
  object: Tenancy_Action_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_App_ConfigArgs = {
  objects: Array<Tenancy_App_Config_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_App_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_App_Config_OneArgs = {
  object: Tenancy_App_Config_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_App_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_AppletArgs = {
  objects: Array<Tenancy_Applet_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Applet_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Applet_InstanceArgs = {
  objects: Array<Tenancy_Applet_Instance_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Applet_Instance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Applet_Instance_OneArgs = {
  object: Tenancy_Applet_Instance_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Applet_Instance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Applet_OneArgs = {
  object: Tenancy_Applet_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Applet_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Applet_VersionArgs = {
  objects: Array<Tenancy_Applet_Version_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Applet_Version_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Applet_Version_OneArgs = {
  object: Tenancy_Applet_Version_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Applet_Version_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Audit_LogsArgs = {
  objects: Array<Tenancy_Audit_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Audit_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Audit_Logs_OneArgs = {
  object: Tenancy_Audit_Logs_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Audit_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Auth_MethodArgs = {
  objects: Array<Tenancy_Auth_Method_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Auth_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Auth_Method_OneArgs = {
  object: Tenancy_Auth_Method_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Auth_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_ConditionArgs = {
  objects: Array<Tenancy_Condition_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Condition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Condition_OneArgs = {
  object: Tenancy_Condition_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Condition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_CountryArgs = {
  objects: Array<Tenancy_Country_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Country_OneArgs = {
  object: Tenancy_Country_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Custom_Auth_MethodArgs = {
  objects: Array<Tenancy_Custom_Auth_Method_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Custom_Auth_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Custom_Auth_Method_OneArgs = {
  object: Tenancy_Custom_Auth_Method_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Custom_Auth_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_DomainArgs = {
  objects: Array<Tenancy_Domain_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Domain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Domain_OneArgs = {
  object: Tenancy_Domain_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Domain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_EnvironmentArgs = {
  objects: Array<Tenancy_Environment_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Environment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Environment_OneArgs = {
  object: Tenancy_Environment_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Environment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Failed_Kafka_EventsArgs = {
  objects: Array<Tenancy_Failed_Kafka_Events_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Failed_Kafka_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Failed_Kafka_Events_OneArgs = {
  object: Tenancy_Failed_Kafka_Events_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Failed_Kafka_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_FileArgs = {
  objects: Array<Tenancy_File_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_File_OneArgs = {
  object: Tenancy_File_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Llm_CredentialsArgs = {
  objects: Array<Tenancy_Llm_Credentials_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Llm_Credentials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Llm_Credentials_OneArgs = {
  object: Tenancy_Llm_Credentials_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Llm_Credentials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Llm_ProvidersArgs = {
  objects: Array<Tenancy_Llm_Providers_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Llm_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Llm_Providers_OneArgs = {
  object: Tenancy_Llm_Providers_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Llm_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_LocaleArgs = {
  objects: Array<Tenancy_Locale_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Locale_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Locale_OneArgs = {
  object: Tenancy_Locale_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Locale_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Localization_SettingsArgs = {
  objects: Array<Tenancy_Localization_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Localization_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Localization_Settings_OneArgs = {
  object: Tenancy_Localization_Settings_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Localization_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Node_Type_Enum_PsArgs = {
  objects: Array<Tenancy_Node_Type_Enum_Ps_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Node_Type_Enum_Ps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Node_Type_Enum_Ps_OneArgs = {
  object: Tenancy_Node_Type_Enum_Ps_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Node_Type_Enum_Ps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_PackageArgs = {
  objects: Array<Tenancy_Package_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Package_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Package_OneArgs = {
  object: Tenancy_Package_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Package_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Package_VersionArgs = {
  objects: Array<Tenancy_Package_Version_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Package_Version_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Package_Version_OneArgs = {
  object: Tenancy_Package_Version_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Package_Version_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Pro_Studio_Performance_MetricsArgs = {
  objects: Array<Tenancy_Pro_Studio_Performance_Metrics_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Pro_Studio_Performance_Metrics_OneArgs = {
  object: Tenancy_Pro_Studio_Performance_Metrics_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_ProductsArgs = {
  objects: Array<Tenancy_Products_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Products_OneArgs = {
  object: Tenancy_Products_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Project_Environment_ConfigArgs = {
  objects: Array<Tenancy_Project_Environment_Config_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Project_Environment_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Project_Environment_Config_OneArgs = {
  object: Tenancy_Project_Environment_Config_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Project_Environment_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Project_Pro_Studio_SettingArgs = {
  objects: Array<Tenancy_Project_Pro_Studio_Setting_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Project_Pro_Studio_Setting_OneArgs = {
  object: Tenancy_Project_Pro_Studio_Setting_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Project_Product_SettingsArgs = {
  objects: Array<Tenancy_Project_Product_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Project_Product_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Project_Product_Settings_OneArgs = {
  object: Tenancy_Project_Product_Settings_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Project_Product_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_ProjectsArgs = {
  objects: Array<Tenancy_Projects_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Projects_OneArgs = {
  object: Tenancy_Projects_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Pype_ConnectionArgs = {
  objects: Array<Tenancy_Pype_Connection_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Pype_Connection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Pype_Connection_OneArgs = {
  object: Tenancy_Pype_Connection_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Pype_Connection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Pype_Connection_PypeArgs = {
  objects: Array<Tenancy_Pype_Connection_Pype_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Pype_Connection_Pype_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Pype_Connection_Pype_OneArgs = {
  object: Tenancy_Pype_Connection_Pype_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Pype_Connection_Pype_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Pype_RuleArgs = {
  objects: Array<Tenancy_Pype_Rule_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Pype_Rule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Pype_Rule_GroupArgs = {
  objects: Array<Tenancy_Pype_Rule_Group_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Pype_Rule_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Pype_Rule_Group_OneArgs = {
  object: Tenancy_Pype_Rule_Group_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Pype_Rule_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Pype_Rule_Group_PypeArgs = {
  objects: Array<Tenancy_Pype_Rule_Group_Pype_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Pype_Rule_Group_Pype_OneArgs = {
  object: Tenancy_Pype_Rule_Group_Pype_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Pype_Rule_OneArgs = {
  object: Tenancy_Pype_Rule_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Pype_Rule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Rich_Asset_Type_Enum_PsArgs = {
  objects: Array<Tenancy_Rich_Asset_Type_Enum_Ps_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Rich_Asset_Type_Enum_Ps_OneArgs = {
  object: Tenancy_Rich_Asset_Type_Enum_Ps_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_RolesArgs = {
  objects: Array<Tenancy_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Roles_OneArgs = {
  object: Tenancy_Roles_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_Deployment_Run_WorkflowsArgs = {
  objects: Array<Tenancy_Solution_Deployment_Run_Workflows_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_Deployment_Run_Workflows_OneArgs = {
  object: Tenancy_Solution_Deployment_Run_Workflows_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_Deployment_RunsArgs = {
  objects: Array<Tenancy_Solution_Deployment_Runs_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Solution_Deployment_Runs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_Deployment_Runs_OneArgs = {
  object: Tenancy_Solution_Deployment_Runs_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Solution_Deployment_Runs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_DeploymentsArgs = {
  objects: Array<Tenancy_Solution_Deployments_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Solution_Deployments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_Deployments_OneArgs = {
  object: Tenancy_Solution_Deployments_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Solution_Deployments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_TaskArgs = {
  objects: Array<Tenancy_Solution_Task_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Solution_Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_Task_OneArgs = {
  object: Tenancy_Solution_Task_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Solution_Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_User_PresenceArgs = {
  objects: Array<Tenancy_Solution_User_Presence_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Solution_User_Presence_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_User_Presence_OneArgs = {
  object: Tenancy_Solution_User_Presence_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Solution_User_Presence_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_Version_Nodes_PsArgs = {
  objects: Array<Tenancy_Solution_Version_Nodes_Ps_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_Version_Nodes_Ps_OneArgs = {
  object: Tenancy_Solution_Version_Nodes_Ps_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_VersionsArgs = {
  objects: Array<Tenancy_Solution_Versions_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Solution_Versions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_Versions_OneArgs = {
  object: Tenancy_Solution_Versions_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Solution_Versions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_Versions_PsArgs = {
  objects: Array<Tenancy_Solution_Versions_Ps_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Solution_Versions_Ps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solution_Versions_Ps_OneArgs = {
  object: Tenancy_Solution_Versions_Ps_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Solution_Versions_Ps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_SolutionsArgs = {
  objects: Array<Tenancy_Solutions_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Solutions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Solutions_OneArgs = {
  object: Tenancy_Solutions_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Solutions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Studio_ResourceArgs = {
  objects: Array<Tenancy_Studio_Resource_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Studio_Resource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Studio_Resource_OneArgs = {
  object: Tenancy_Studio_Resource_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Studio_Resource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Team_Account_Environment_ConfigArgs = {
  objects: Array<Tenancy_Team_Account_Environment_Config_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Team_Account_Environment_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Team_Account_Environment_Config_OneArgs = {
  object: Tenancy_Team_Account_Environment_Config_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Team_Account_Environment_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Team_Account_ProjectsArgs = {
  objects: Array<Tenancy_Team_Account_Projects_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Team_Account_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Team_Account_Projects_OneArgs = {
  object: Tenancy_Team_Account_Projects_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Team_Account_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Team_AccountsArgs = {
  objects: Array<Tenancy_Team_Accounts_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Team_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Team_Accounts_OneArgs = {
  object: Tenancy_Team_Accounts_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Team_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_TeamsArgs = {
  objects: Array<Tenancy_Teams_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Teams_OneArgs = {
  object: Tenancy_Teams_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Template_NodeArgs = {
  objects: Array<Tenancy_Template_Node_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Template_Node_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Template_Node_OneArgs = {
  object: Tenancy_Template_Node_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Template_Node_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Time_ZoneArgs = {
  objects: Array<Tenancy_Time_Zone_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Time_Zone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Time_Zone_OneArgs = {
  object: Tenancy_Time_Zone_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Time_Zone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_TriggerArgs = {
  objects: Array<Tenancy_Trigger_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Trigger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Trigger_OneArgs = {
  object: Tenancy_Trigger_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Trigger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_User_Account_Auth_Method_SettingsArgs = {
  objects: Array<Tenancy_User_Account_Auth_Method_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_User_Account_Auth_Method_Settings_OneArgs = {
  object: Tenancy_User_Account_Auth_Method_Settings_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_User_Account_Environment_ConfigArgs = {
  objects: Array<Tenancy_User_Account_Environment_Config_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_User_Account_Environment_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_User_Account_Environment_Config_OneArgs = {
  object: Tenancy_User_Account_Environment_Config_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_User_Account_Environment_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_User_Account_Project_Metabase_AccessArgs = {
  objects: Array<Tenancy_User_Account_Project_Metabase_Access_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_User_Account_Project_Metabase_Access_OneArgs = {
  object: Tenancy_User_Account_Project_Metabase_Access_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_User_Account_ProjectsArgs = {
  objects: Array<Tenancy_User_Account_Projects_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_User_Account_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_User_Account_Projects_OneArgs = {
  object: Tenancy_User_Account_Projects_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_User_Account_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_User_AccountsArgs = {
  objects: Array<Tenancy_User_Accounts_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_User_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_User_Accounts_OneArgs = {
  object: Tenancy_User_Accounts_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_User_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_UsersArgs = {
  objects: Array<Tenancy_Users_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Users_OneArgs = {
  object: Tenancy_Users_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_VariableArgs = {
  objects: Array<Tenancy_Variable_Insert_Input>;
  on_conflict?: InputMaybe<Tenancy_Variable_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenancy_Variable_OneArgs = {
  object: Tenancy_Variable_Insert_Input;
  on_conflict?: InputMaybe<Tenancy_Variable_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPatchBotByIdArgs = {
  bot2Input: Bot2Input;
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPatchCustomerPackagesArgs = {
  customerId: Scalars['String']['input'];
  customerPackagesInput: CustomerPackagesInput;
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPatchCustomerResourcesArgs = {
  customerId: Scalars['String']['input'];
  customerResourcesInput: CustomerResourcesInput;
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPatchOneIntentArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPatchOneSynonymArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPatchOneTypeEntityArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPatchOneUtteranceArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPatchV3ConfigurationCustomersCustomerIdChannelChannelIdArgs = {
  channelId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  v3ConfigurationCustomerChannelInput: V3ConfigurationCustomerChannelInput;
};


/** mutation root */
export type Mutation_RootPatchV3ConfigurationCustomersCustomerIdChannelChannelIdSandboxArgs = {
  channelId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  v3ConfigurationCustomerChannelInput: V3ConfigurationCustomerChannelInput;
};


/** mutation root */
export type Mutation_RootPatchV3ConfigurationCustomersCustomerIdChannelChannelIdSpeechArgs = {
  channelId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  speech: ChannelSpeechInput;
};


/** mutation root */
export type Mutation_RootPatchV3ConfigurationCustomersCustomerIdChannelChannelIdSpeechSandboxArgs = {
  channelId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  speech: ChannelSpeechInput;
};


/** mutation root */
export type Mutation_RootPatchV3ConfigurationPypePypeIdArgs = {
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  v3ConfigurationPypeInput: V3ConfigurationPypeInput;
};


/** mutation root */
export type Mutation_RootPatchV3ConfigurationPypePypeIdSandboxArgs = {
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  v3ConfigurationPypeInput: V3ConfigurationPypeInput;
};


/** mutation root */
export type Mutation_RootPostBotVersionsArgs = {
  botId: Scalars['String']['input'];
  botVersionsInput: BotVersionsInput;
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostCustomerBotsArgs = {
  customerBotsInput: CustomerBotsInput;
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostCustomerPackagesArgs = {
  customerId: Scalars['String']['input'];
  customerPackagesInput: CustomerPackagesInput;
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostCustomersArgs = {
  customersInput: CustomersInput;
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostEntitiesArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostHistorySearchArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  searchBody?: InputMaybe<HistorySearchBody>;
};


/** mutation root */
export type Mutation_RootPostIntentsArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostOneIntentArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostOneSynonymArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostOneTypeEntityArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostOneUtteranceArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostV3BroadcastArgs = {
  projectId: Scalars['String']['input'];
  v3BroadcastInput?: InputMaybe<V3BroadcastInput>;
};


/** mutation root */
export type Mutation_RootPostV3BroadcastSandboxArgs = {
  projectId: Scalars['String']['input'];
  v3BroadcastInput?: InputMaybe<V3BroadcastInput>;
};


/** mutation root */
export type Mutation_RootPostV3BusinessAgentArgs = {
  projectId: Scalars['String']['input'];
  v3BusinessAgentInput?: InputMaybe<V3BusinessAgentInput>;
};


/** mutation root */
export type Mutation_RootPostV3BusinessAgentSandboxArgs = {
  projectId: Scalars['String']['input'];
  v3BusinessAgentInput?: InputMaybe<V3BusinessAgentInput>;
};


/** mutation root */
export type Mutation_RootPostV3BusinessWidgetArgs = {
  projectId: Scalars['String']['input'];
  v3BusinessWidgetInput: V3BusinessWidgetInput;
};


/** mutation root */
export type Mutation_RootPostV3BusinessWidgetSandboxArgs = {
  projectId: Scalars['String']['input'];
  v3BusinessWidgetInput: V3BusinessWidgetInput;
};


/** mutation root */
export type Mutation_RootPostV3ConfigurationCustomersCustomerIdChannelArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  v3ConfigurationCustomerChannel2Input: V3ConfigurationCustomerChannel2Input;
};


/** mutation root */
export type Mutation_RootPostV3ConfigurationCustomersCustomerIdChannelSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  v3ConfigurationCustomerChannel2Input: V3ConfigurationCustomerChannel2Input;
};


/** mutation root */
export type Mutation_RootPostV3PypesPypeIdKeysArgs = {
  authorization: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  v3PypeKeysInput: V3PypeKeysInput;
};


/** mutation root */
export type Mutation_RootPostV3PypesPypeIdKeysSandboxArgs = {
  authorization: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  v3PypeKeysInput: V3PypeKeysInput;
};


/** mutation root */
export type Mutation_RootPostVersionBulkTestArgs = {
  projectId: Scalars['String']['input'];
  versionBulkTestInput: VersionBulkTestInput;
  versionId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostVersionConfigArgs = {
  projectId: Scalars['String']['input'];
  versionConfigInput: VersionConfigInput;
  versionId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostVersionNluTestArgs = {
  projectId: Scalars['String']['input'];
  utterance: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPostVersionScriptArgs = {
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
  versionScriptsInput: VersionScriptsInput;
};


/** mutation root */
export type Mutation_RootPostVersionStopwordsArgs = {
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
  versionStopwordsInput: VersionStopwordsInput;
};


/** mutation root */
export type Mutation_RootPostVersionTemplateArgs = {
  botVersion?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
  versionTemplatesInput: VersionTemplatesInput;
};


/** mutation root */
export type Mutation_RootPutBotAssetsArgs = {
  botAssetsInput: BotAssetsInput;
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPutV3BusinessAgentArgs = {
  projectId: Scalars['String']['input'];
  v3BusinessAgent2Input?: InputMaybe<V3BusinessAgent2Input>;
};


/** mutation root */
export type Mutation_RootPutV3BusinessAgentSandboxArgs = {
  projectId: Scalars['String']['input'];
  v3BusinessAgent2Input?: InputMaybe<V3BusinessAgent2Input>;
};


/** mutation root */
export type Mutation_RootPutV3BusinessWidgetArgs = {
  projectId: Scalars['String']['input'];
  v3BusinessWidgetInput: V3BusinessWidgetInput;
};


/** mutation root */
export type Mutation_RootPutV3BusinessWidgetSandboxArgs = {
  projectId: Scalars['String']['input'];
  v3BusinessWidgetInput: V3BusinessWidgetInput;
};


/** mutation root */
export type Mutation_RootPutVersionDeployArgs = {
  projectId: Scalars['String']['input'];
  versionDeployInput: VersionDeployInput;
  versionId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPutVersionGraphArgs = {
  projectId: Scalars['String']['input'];
  versionGraphInput: VersionGraphInput;
  versionId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPutVersionPreviewArgs = {
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPutVersionSearchNluTrainArgs = {
  projectId: Scalars['String']['input'];
  searchNLUEndpointName: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
  versionSearchNluTrainInput: VersionSearchNluTrainInput;
};


/** mutation root */
export type Mutation_RootPutVersionTrainArgs = {
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPutWidgetAppDesignArgs = {
  appId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  widgetAppDesignInput: WidgetAppDesignInput;
};


/** mutation root */
export type Mutation_RootPutWidgetAppDesignSandboxArgs = {
  appId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  widgetAppDesignInput: WidgetAppDesignInput;
};


/** mutation root */
export type Mutation_RootPypesDeleteCustomersPypesByIdArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesDeleteCustomersPypesByIdSandboxArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesDeleteCustomersPypesKeysByIdArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesDeleteCustomersPypesKeysByIdSandboxArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesDeleteCustomersPypesStreamsBotArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesDeleteCustomersPypesStreamsBotSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesDeleteCustomersPypesStreamsByIdArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesDeleteCustomersPypesStreamsByIdSandboxArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPostCustomersPypesArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeInput: PypeInput;
};


/** mutation root */
export type Mutation_RootPypesPostCustomersPypesKeysArgs = {
  apiKeyInput: ApiKeyInput;
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPostCustomersPypesKeysSandboxArgs = {
  apiKeyInput: ApiKeyInput;
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPostCustomersPypesPreviewArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPostCustomersPypesPreviewSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPostCustomersPypesSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeInput: PypeInput;
};


/** mutation root */
export type Mutation_RootPypesPostCustomersPypesSearchesArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  term: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPostCustomersPypesSearchesSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  term: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPostCustomersPypesStreamsArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  streamInput: StreamInput;
};


/** mutation root */
export type Mutation_RootPypesPostCustomersPypesStreamsSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  streamInput: StreamInput;
};


/** mutation root */
export type Mutation_RootPypesPostUsersPypesSearchesArgs = {
  projectId: Scalars['String']['input'];
  term: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPostUsersPypesSearchesSandboxArgs = {
  projectId: Scalars['String']['input'];
  term: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPutCustomerByIdPypesStreamsByIdArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPutCustomerByIdPypesStreamsByIdSandboxArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPutCustomersPypesArgs = {
  bulkPypeUpdateInput: BulkPypeUpdateInput;
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPutCustomersPypesKeysByIdArgs = {
  apiKeyUpdateInput: ApiKeyUpdateInput;
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPutCustomersPypesKeysByIdSandboxArgs = {
  apiKeyUpdateInput: ApiKeyUpdateInput;
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPutCustomersPypesSandboxArgs = {
  bulkPypeUpdateInput: BulkPypeUpdateInput;
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPutCustomersPypesStreamsBotArgs = {
  botInput: CustomerStreamBotInput;
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPutCustomersPypesStreamsBotSandboxArgs = {
  botInput: CustomerStreamBotInput;
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPypesPutCustomersPypesStreamsMetadataArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
  streamInput?: InputMaybe<StreamInput>;
};


/** mutation root */
export type Mutation_RootPypesPutCustomersPypesStreamsMetadataSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
  streamInput?: InputMaybe<StreamInput>;
};


/** mutation root */
export type Mutation_RootPypesPutCutomerByIdPypesPypeByIdArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeUpdateInput?: InputMaybe<PypeUpdateInput>;
};


/** mutation root */
export type Mutation_RootPypesPutCutomerByIdPypesPypeByIdSandboxArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeUpdateInput?: InputMaybe<PypeUpdateInput>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__ProjectEnvironmentConfigToVariableArgs = {
  _set?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Set_Input>;
  where: Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__ProjectEnvironmentConfigToVariable_ManyArgs = {
  updates: Array<Tenancy__ProjectEnvironmentConfigToVariable_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__Prisma_MigrationsArgs = {
  _inc?: InputMaybe<Tenancy__Prisma_Migrations_Inc_Input>;
  _set?: InputMaybe<Tenancy__Prisma_Migrations_Set_Input>;
  where: Tenancy__Prisma_Migrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__Prisma_Migrations_By_PkArgs = {
  _inc?: InputMaybe<Tenancy__Prisma_Migrations_Inc_Input>;
  _set?: InputMaybe<Tenancy__Prisma_Migrations_Set_Input>;
  pk_columns: Tenancy__Prisma_Migrations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__Prisma_Migrations_ManyArgs = {
  updates: Array<Tenancy__Prisma_Migrations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__Role_ProjectsArgs = {
  _set?: InputMaybe<Tenancy__Role_Projects_Set_Input>;
  where: Tenancy__Role_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__Role_Projects_ManyArgs = {
  updates: Array<Tenancy__Role_Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__Team_Account_Environment_Config_RolesArgs = {
  _set?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Set_Input>;
  where: Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__Team_Account_Environment_Config_Roles_ManyArgs = {
  updates: Array<Tenancy__Team_Account_Environment_Config_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__Team_Account_Project_RolesArgs = {
  _set?: InputMaybe<Tenancy__Team_Account_Project_Roles_Set_Input>;
  where: Tenancy__Team_Account_Project_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__Team_Account_Project_Roles_ManyArgs = {
  updates: Array<Tenancy__Team_Account_Project_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__Team_Account_RolesArgs = {
  _set?: InputMaybe<Tenancy__Team_Account_Roles_Set_Input>;
  where: Tenancy__Team_Account_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__Team_Account_Roles_ManyArgs = {
  updates: Array<Tenancy__Team_Account_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__User_Account_Environment_Config_RolesArgs = {
  _set?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Set_Input>;
  where: Tenancy__User_Account_Environment_Config_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__User_Account_Environment_Config_Roles_ManyArgs = {
  updates: Array<Tenancy__User_Account_Environment_Config_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__User_Account_Project_RolesArgs = {
  _set?: InputMaybe<Tenancy__User_Account_Project_Roles_Set_Input>;
  where: Tenancy__User_Account_Project_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__User_Account_Project_Roles_ManyArgs = {
  updates: Array<Tenancy__User_Account_Project_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__User_Account_RolesArgs = {
  _set?: InputMaybe<Tenancy__User_Account_Roles_Set_Input>;
  where: Tenancy__User_Account_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__User_Account_Roles_ManyArgs = {
  updates: Array<Tenancy__User_Account_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__User_TeamsArgs = {
  _set?: InputMaybe<Tenancy__User_Teams_Set_Input>;
  where: Tenancy__User_Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy__User_Teams_ManyArgs = {
  updates: Array<Tenancy__User_Teams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Account_Auth_Method_SettingsArgs = {
  _append?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Set_Input>;
  where: Tenancy_Account_Auth_Method_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Account_Auth_Method_Settings_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Set_Input>;
  pk_columns: Tenancy_Account_Auth_Method_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Account_Auth_Method_Settings_ManyArgs = {
  updates: Array<Tenancy_Account_Auth_Method_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_AccountsArgs = {
  _append?: InputMaybe<Tenancy_Accounts_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Accounts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Accounts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Accounts_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Accounts_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Accounts_Set_Input>;
  where: Tenancy_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Accounts_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Accounts_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Accounts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Accounts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Accounts_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Accounts_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Accounts_Set_Input>;
  pk_columns: Tenancy_Accounts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Accounts_ManyArgs = {
  updates: Array<Tenancy_Accounts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_ActionArgs = {
  _append?: InputMaybe<Tenancy_Action_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Action_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Action_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Action_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Action_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Action_Set_Input>;
  where: Tenancy_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Action_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Action_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Action_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Action_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Action_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Action_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Action_Set_Input>;
  pk_columns: Tenancy_Action_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Action_ManyArgs = {
  updates: Array<Tenancy_Action_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Action_Node_JobArgs = {
  _append?: InputMaybe<Tenancy_Action_Node_Job_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Action_Node_Job_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Action_Node_Job_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Action_Node_Job_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Action_Node_Job_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Action_Node_Job_Set_Input>;
  where: Tenancy_Action_Node_Job_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Action_Node_Job_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Action_Node_Job_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Action_Node_Job_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Action_Node_Job_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Action_Node_Job_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Action_Node_Job_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Action_Node_Job_Set_Input>;
  pk_columns: Tenancy_Action_Node_Job_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Action_Node_Job_ManyArgs = {
  updates: Array<Tenancy_Action_Node_Job_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_App_ConfigArgs = {
  _set?: InputMaybe<Tenancy_App_Config_Set_Input>;
  where: Tenancy_App_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_App_Config_By_PkArgs = {
  _set?: InputMaybe<Tenancy_App_Config_Set_Input>;
  pk_columns: Tenancy_App_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_App_Config_ManyArgs = {
  updates: Array<Tenancy_App_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_AppletArgs = {
  _append?: InputMaybe<Tenancy_Applet_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Applet_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Applet_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Applet_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Applet_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Applet_Set_Input>;
  where: Tenancy_Applet_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Applet_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Applet_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Applet_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Applet_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Applet_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Applet_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Applet_Set_Input>;
  pk_columns: Tenancy_Applet_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Applet_InstanceArgs = {
  _append?: InputMaybe<Tenancy_Applet_Instance_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Applet_Instance_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Applet_Instance_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Applet_Instance_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Applet_Instance_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Applet_Instance_Set_Input>;
  where: Tenancy_Applet_Instance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Applet_Instance_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Applet_Instance_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Applet_Instance_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Applet_Instance_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Applet_Instance_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Applet_Instance_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Applet_Instance_Set_Input>;
  pk_columns: Tenancy_Applet_Instance_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Applet_Instance_ManyArgs = {
  updates: Array<Tenancy_Applet_Instance_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Applet_ManyArgs = {
  updates: Array<Tenancy_Applet_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Applet_VersionArgs = {
  _append?: InputMaybe<Tenancy_Applet_Version_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Applet_Version_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Applet_Version_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Applet_Version_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Applet_Version_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Applet_Version_Set_Input>;
  where: Tenancy_Applet_Version_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Applet_Version_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Applet_Version_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Applet_Version_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Applet_Version_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Applet_Version_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Applet_Version_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Applet_Version_Set_Input>;
  pk_columns: Tenancy_Applet_Version_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Applet_Version_ManyArgs = {
  updates: Array<Tenancy_Applet_Version_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Audit_LogsArgs = {
  _append?: InputMaybe<Tenancy_Audit_Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Audit_Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Audit_Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Audit_Logs_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Audit_Logs_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Audit_Logs_Set_Input>;
  where: Tenancy_Audit_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Audit_Logs_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Audit_Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Audit_Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Audit_Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Audit_Logs_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Audit_Logs_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Audit_Logs_Set_Input>;
  pk_columns: Tenancy_Audit_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Audit_Logs_ManyArgs = {
  updates: Array<Tenancy_Audit_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Auth_MethodArgs = {
  _set?: InputMaybe<Tenancy_Auth_Method_Set_Input>;
  where: Tenancy_Auth_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Auth_Method_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Auth_Method_Set_Input>;
  pk_columns: Tenancy_Auth_Method_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Auth_Method_ManyArgs = {
  updates: Array<Tenancy_Auth_Method_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_ConditionArgs = {
  _append?: InputMaybe<Tenancy_Condition_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Condition_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Condition_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Condition_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Condition_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Condition_Set_Input>;
  where: Tenancy_Condition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Condition_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Condition_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Condition_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Condition_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Condition_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Condition_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Condition_Set_Input>;
  pk_columns: Tenancy_Condition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Condition_ManyArgs = {
  updates: Array<Tenancy_Condition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_CountryArgs = {
  _set?: InputMaybe<Tenancy_Country_Set_Input>;
  where: Tenancy_Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Country_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Country_Set_Input>;
  pk_columns: Tenancy_Country_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Country_ManyArgs = {
  updates: Array<Tenancy_Country_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Custom_Auth_MethodArgs = {
  _append?: InputMaybe<Tenancy_Custom_Auth_Method_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Custom_Auth_Method_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Custom_Auth_Method_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Custom_Auth_Method_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Custom_Auth_Method_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Custom_Auth_Method_Set_Input>;
  where: Tenancy_Custom_Auth_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Custom_Auth_Method_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Custom_Auth_Method_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Custom_Auth_Method_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Custom_Auth_Method_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Custom_Auth_Method_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Custom_Auth_Method_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Custom_Auth_Method_Set_Input>;
  pk_columns: Tenancy_Custom_Auth_Method_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Custom_Auth_Method_ManyArgs = {
  updates: Array<Tenancy_Custom_Auth_Method_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_DomainArgs = {
  _set?: InputMaybe<Tenancy_Domain_Set_Input>;
  where: Tenancy_Domain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Domain_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Domain_Set_Input>;
  pk_columns: Tenancy_Domain_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Domain_ManyArgs = {
  updates: Array<Tenancy_Domain_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_EnvironmentArgs = {
  _set?: InputMaybe<Tenancy_Environment_Set_Input>;
  where: Tenancy_Environment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Environment_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Environment_Set_Input>;
  pk_columns: Tenancy_Environment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Environment_ManyArgs = {
  updates: Array<Tenancy_Environment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Failed_Kafka_EventsArgs = {
  _set?: InputMaybe<Tenancy_Failed_Kafka_Events_Set_Input>;
  where: Tenancy_Failed_Kafka_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Failed_Kafka_Events_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Failed_Kafka_Events_Set_Input>;
  pk_columns: Tenancy_Failed_Kafka_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Failed_Kafka_Events_ManyArgs = {
  updates: Array<Tenancy_Failed_Kafka_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_FileArgs = {
  _append?: InputMaybe<Tenancy_File_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_File_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_File_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_File_Delete_Key_Input>;
  _inc?: InputMaybe<Tenancy_File_Inc_Input>;
  _prepend?: InputMaybe<Tenancy_File_Prepend_Input>;
  _set?: InputMaybe<Tenancy_File_Set_Input>;
  where: Tenancy_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_File_By_PkArgs = {
  _append?: InputMaybe<Tenancy_File_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_File_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_File_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_File_Delete_Key_Input>;
  _inc?: InputMaybe<Tenancy_File_Inc_Input>;
  _prepend?: InputMaybe<Tenancy_File_Prepend_Input>;
  _set?: InputMaybe<Tenancy_File_Set_Input>;
  pk_columns: Tenancy_File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_File_ManyArgs = {
  updates: Array<Tenancy_File_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Llm_CredentialsArgs = {
  _set?: InputMaybe<Tenancy_Llm_Credentials_Set_Input>;
  where: Tenancy_Llm_Credentials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Llm_Credentials_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Llm_Credentials_Set_Input>;
  pk_columns: Tenancy_Llm_Credentials_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Llm_Credentials_ManyArgs = {
  updates: Array<Tenancy_Llm_Credentials_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Llm_ProvidersArgs = {
  _set?: InputMaybe<Tenancy_Llm_Providers_Set_Input>;
  where: Tenancy_Llm_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Llm_Providers_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Llm_Providers_Set_Input>;
  pk_columns: Tenancy_Llm_Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Llm_Providers_ManyArgs = {
  updates: Array<Tenancy_Llm_Providers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_LocaleArgs = {
  _set?: InputMaybe<Tenancy_Locale_Set_Input>;
  where: Tenancy_Locale_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Locale_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Locale_Set_Input>;
  pk_columns: Tenancy_Locale_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Locale_ManyArgs = {
  updates: Array<Tenancy_Locale_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Localization_SettingsArgs = {
  _set?: InputMaybe<Tenancy_Localization_Settings_Set_Input>;
  where: Tenancy_Localization_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Localization_Settings_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Localization_Settings_Set_Input>;
  pk_columns: Tenancy_Localization_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Localization_Settings_ManyArgs = {
  updates: Array<Tenancy_Localization_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Node_Type_Enum_PsArgs = {
  _set?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Set_Input>;
  where: Tenancy_Node_Type_Enum_Ps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Node_Type_Enum_Ps_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Set_Input>;
  pk_columns: Tenancy_Node_Type_Enum_Ps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Node_Type_Enum_Ps_ManyArgs = {
  updates: Array<Tenancy_Node_Type_Enum_Ps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_PackageArgs = {
  _set?: InputMaybe<Tenancy_Package_Set_Input>;
  where: Tenancy_Package_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Package_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Package_Set_Input>;
  pk_columns: Tenancy_Package_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Package_ManyArgs = {
  updates: Array<Tenancy_Package_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Package_VersionArgs = {
  _append?: InputMaybe<Tenancy_Package_Version_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Package_Version_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Package_Version_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Package_Version_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Package_Version_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Package_Version_Set_Input>;
  where: Tenancy_Package_Version_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Package_Version_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Package_Version_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Package_Version_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Package_Version_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Package_Version_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Package_Version_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Package_Version_Set_Input>;
  pk_columns: Tenancy_Package_Version_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Package_Version_ManyArgs = {
  updates: Array<Tenancy_Package_Version_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pro_Studio_Performance_MetricsArgs = {
  _append?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Set_Input>;
  where: Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pro_Studio_Performance_Metrics_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Set_Input>;
  pk_columns: Tenancy_Pro_Studio_Performance_Metrics_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pro_Studio_Performance_Metrics_ManyArgs = {
  updates: Array<Tenancy_Pro_Studio_Performance_Metrics_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_ProductsArgs = {
  _append?: InputMaybe<Tenancy_Products_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Products_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Products_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Products_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Products_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Products_Set_Input>;
  where: Tenancy_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Products_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Products_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Products_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Products_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Products_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Products_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Products_Set_Input>;
  pk_columns: Tenancy_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Products_ManyArgs = {
  updates: Array<Tenancy_Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Project_Environment_ConfigArgs = {
  _set?: InputMaybe<Tenancy_Project_Environment_Config_Set_Input>;
  where: Tenancy_Project_Environment_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Project_Environment_Config_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Project_Environment_Config_Set_Input>;
  pk_columns: Tenancy_Project_Environment_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Project_Environment_Config_ManyArgs = {
  updates: Array<Tenancy_Project_Environment_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Project_Pro_Studio_SettingArgs = {
  _append?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Set_Input>;
  where: Tenancy_Project_Pro_Studio_Setting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Project_Pro_Studio_Setting_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Set_Input>;
  pk_columns: Tenancy_Project_Pro_Studio_Setting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Project_Pro_Studio_Setting_ManyArgs = {
  updates: Array<Tenancy_Project_Pro_Studio_Setting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Project_Product_SettingsArgs = {
  _append?: InputMaybe<Tenancy_Project_Product_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Project_Product_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Project_Product_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Project_Product_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Project_Product_Settings_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Project_Product_Settings_Set_Input>;
  where: Tenancy_Project_Product_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Project_Product_Settings_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Project_Product_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Project_Product_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Project_Product_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Project_Product_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Project_Product_Settings_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Project_Product_Settings_Set_Input>;
  pk_columns: Tenancy_Project_Product_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Project_Product_Settings_ManyArgs = {
  updates: Array<Tenancy_Project_Product_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_ProjectsArgs = {
  _append?: InputMaybe<Tenancy_Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Projects_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Projects_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Projects_Set_Input>;
  where: Tenancy_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Projects_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Projects_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Projects_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Projects_Set_Input>;
  pk_columns: Tenancy_Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Projects_ManyArgs = {
  updates: Array<Tenancy_Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_ConnectionArgs = {
  _append?: InputMaybe<Tenancy_Pype_Connection_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Pype_Connection_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Pype_Connection_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Pype_Connection_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Pype_Connection_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Pype_Connection_Set_Input>;
  where: Tenancy_Pype_Connection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Connection_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Pype_Connection_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Pype_Connection_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Pype_Connection_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Pype_Connection_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Pype_Connection_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Pype_Connection_Set_Input>;
  pk_columns: Tenancy_Pype_Connection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Connection_ManyArgs = {
  updates: Array<Tenancy_Pype_Connection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Connection_PypeArgs = {
  _set?: InputMaybe<Tenancy_Pype_Connection_Pype_Set_Input>;
  where: Tenancy_Pype_Connection_Pype_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Connection_Pype_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Pype_Connection_Pype_Set_Input>;
  pk_columns: Tenancy_Pype_Connection_Pype_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Connection_Pype_ManyArgs = {
  updates: Array<Tenancy_Pype_Connection_Pype_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_RuleArgs = {
  _append?: InputMaybe<Tenancy_Pype_Rule_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Pype_Rule_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Pype_Rule_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Pype_Rule_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Pype_Rule_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Pype_Rule_Set_Input>;
  where: Tenancy_Pype_Rule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Rule_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Pype_Rule_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Pype_Rule_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Pype_Rule_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Pype_Rule_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Pype_Rule_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Pype_Rule_Set_Input>;
  pk_columns: Tenancy_Pype_Rule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Rule_GroupArgs = {
  _append?: InputMaybe<Tenancy_Pype_Rule_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Pype_Rule_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Pype_Rule_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Pype_Rule_Group_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Pype_Rule_Group_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Pype_Rule_Group_Set_Input>;
  where: Tenancy_Pype_Rule_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Rule_Group_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Pype_Rule_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Pype_Rule_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Pype_Rule_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Pype_Rule_Group_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Pype_Rule_Group_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Pype_Rule_Group_Set_Input>;
  pk_columns: Tenancy_Pype_Rule_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Rule_Group_ManyArgs = {
  updates: Array<Tenancy_Pype_Rule_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Rule_Group_PypeArgs = {
  _set?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Set_Input>;
  where: Tenancy_Pype_Rule_Group_Pype_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Rule_Group_Pype_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Set_Input>;
  pk_columns: Tenancy_Pype_Rule_Group_Pype_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Rule_Group_Pype_ManyArgs = {
  updates: Array<Tenancy_Pype_Rule_Group_Pype_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Pype_Rule_ManyArgs = {
  updates: Array<Tenancy_Pype_Rule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Rich_Asset_Type_Enum_PsArgs = {
  _set?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Set_Input>;
  where: Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Rich_Asset_Type_Enum_Ps_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Set_Input>;
  pk_columns: Tenancy_Rich_Asset_Type_Enum_Ps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Rich_Asset_Type_Enum_Ps_ManyArgs = {
  updates: Array<Tenancy_Rich_Asset_Type_Enum_Ps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_RolesArgs = {
  _append?: InputMaybe<Tenancy_Roles_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Roles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Roles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Roles_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Roles_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Roles_Set_Input>;
  where: Tenancy_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Roles_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Roles_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Roles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Roles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Roles_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Roles_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Roles_Set_Input>;
  pk_columns: Tenancy_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Roles_ManyArgs = {
  updates: Array<Tenancy_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Deployment_Run_WorkflowsArgs = {
  _set?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Set_Input>;
  where: Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Deployment_Run_Workflows_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Set_Input>;
  pk_columns: Tenancy_Solution_Deployment_Run_Workflows_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Deployment_Run_Workflows_ManyArgs = {
  updates: Array<Tenancy_Solution_Deployment_Run_Workflows_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Deployment_RunsArgs = {
  _set?: InputMaybe<Tenancy_Solution_Deployment_Runs_Set_Input>;
  where: Tenancy_Solution_Deployment_Runs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Deployment_Runs_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Solution_Deployment_Runs_Set_Input>;
  pk_columns: Tenancy_Solution_Deployment_Runs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Deployment_Runs_ManyArgs = {
  updates: Array<Tenancy_Solution_Deployment_Runs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_DeploymentsArgs = {
  _append?: InputMaybe<Tenancy_Solution_Deployments_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Solution_Deployments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Solution_Deployments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Solution_Deployments_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Solution_Deployments_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Solution_Deployments_Set_Input>;
  where: Tenancy_Solution_Deployments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Deployments_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Solution_Deployments_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Solution_Deployments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Solution_Deployments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Solution_Deployments_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Solution_Deployments_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Solution_Deployments_Set_Input>;
  pk_columns: Tenancy_Solution_Deployments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Deployments_ManyArgs = {
  updates: Array<Tenancy_Solution_Deployments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_TaskArgs = {
  _set?: InputMaybe<Tenancy_Solution_Task_Set_Input>;
  where: Tenancy_Solution_Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Task_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Solution_Task_Set_Input>;
  pk_columns: Tenancy_Solution_Task_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Task_ManyArgs = {
  updates: Array<Tenancy_Solution_Task_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_User_PresenceArgs = {
  _append?: InputMaybe<Tenancy_Solution_User_Presence_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Solution_User_Presence_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Solution_User_Presence_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Solution_User_Presence_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Solution_User_Presence_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Solution_User_Presence_Set_Input>;
  where: Tenancy_Solution_User_Presence_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_User_Presence_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Solution_User_Presence_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Solution_User_Presence_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Solution_User_Presence_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Solution_User_Presence_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Solution_User_Presence_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Solution_User_Presence_Set_Input>;
  pk_columns: Tenancy_Solution_User_Presence_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_User_Presence_ManyArgs = {
  updates: Array<Tenancy_Solution_User_Presence_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Version_Nodes_PsArgs = {
  _append?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Delete_Key_Input>;
  _inc?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Inc_Input>;
  _prepend?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Set_Input>;
  where: Tenancy_Solution_Version_Nodes_Ps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Version_Nodes_Ps_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Delete_Key_Input>;
  _inc?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Inc_Input>;
  _prepend?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Set_Input>;
  pk_columns: Tenancy_Solution_Version_Nodes_Ps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Version_Nodes_Ps_ManyArgs = {
  updates: Array<Tenancy_Solution_Version_Nodes_Ps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_VersionsArgs = {
  _append?: InputMaybe<Tenancy_Solution_Versions_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Solution_Versions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Solution_Versions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Solution_Versions_Delete_Key_Input>;
  _inc?: InputMaybe<Tenancy_Solution_Versions_Inc_Input>;
  _prepend?: InputMaybe<Tenancy_Solution_Versions_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Solution_Versions_Set_Input>;
  where: Tenancy_Solution_Versions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Versions_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Solution_Versions_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Solution_Versions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Solution_Versions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Solution_Versions_Delete_Key_Input>;
  _inc?: InputMaybe<Tenancy_Solution_Versions_Inc_Input>;
  _prepend?: InputMaybe<Tenancy_Solution_Versions_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Solution_Versions_Set_Input>;
  pk_columns: Tenancy_Solution_Versions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Versions_ManyArgs = {
  updates: Array<Tenancy_Solution_Versions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Versions_PsArgs = {
  _append?: InputMaybe<Tenancy_Solution_Versions_Ps_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Solution_Versions_Ps_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Solution_Versions_Ps_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Solution_Versions_Ps_Delete_Key_Input>;
  _inc?: InputMaybe<Tenancy_Solution_Versions_Ps_Inc_Input>;
  _prepend?: InputMaybe<Tenancy_Solution_Versions_Ps_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Solution_Versions_Ps_Set_Input>;
  where: Tenancy_Solution_Versions_Ps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Versions_Ps_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Solution_Versions_Ps_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Solution_Versions_Ps_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Solution_Versions_Ps_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Solution_Versions_Ps_Delete_Key_Input>;
  _inc?: InputMaybe<Tenancy_Solution_Versions_Ps_Inc_Input>;
  _prepend?: InputMaybe<Tenancy_Solution_Versions_Ps_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Solution_Versions_Ps_Set_Input>;
  pk_columns: Tenancy_Solution_Versions_Ps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solution_Versions_Ps_ManyArgs = {
  updates: Array<Tenancy_Solution_Versions_Ps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_SolutionsArgs = {
  _append?: InputMaybe<Tenancy_Solutions_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Solutions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Solutions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Solutions_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Solutions_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Solutions_Set_Input>;
  where: Tenancy_Solutions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solutions_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Solutions_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Solutions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Solutions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Solutions_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Solutions_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Solutions_Set_Input>;
  pk_columns: Tenancy_Solutions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Solutions_ManyArgs = {
  updates: Array<Tenancy_Solutions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Studio_ResourceArgs = {
  _inc?: InputMaybe<Tenancy_Studio_Resource_Inc_Input>;
  _set?: InputMaybe<Tenancy_Studio_Resource_Set_Input>;
  where: Tenancy_Studio_Resource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Studio_Resource_By_PkArgs = {
  _inc?: InputMaybe<Tenancy_Studio_Resource_Inc_Input>;
  _set?: InputMaybe<Tenancy_Studio_Resource_Set_Input>;
  pk_columns: Tenancy_Studio_Resource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Studio_Resource_ManyArgs = {
  updates: Array<Tenancy_Studio_Resource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Team_Account_Environment_ConfigArgs = {
  _set?: InputMaybe<Tenancy_Team_Account_Environment_Config_Set_Input>;
  where: Tenancy_Team_Account_Environment_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Team_Account_Environment_Config_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Team_Account_Environment_Config_Set_Input>;
  pk_columns: Tenancy_Team_Account_Environment_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Team_Account_Environment_Config_ManyArgs = {
  updates: Array<Tenancy_Team_Account_Environment_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Team_Account_ProjectsArgs = {
  _append?: InputMaybe<Tenancy_Team_Account_Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Team_Account_Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Team_Account_Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Team_Account_Projects_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Team_Account_Projects_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Team_Account_Projects_Set_Input>;
  where: Tenancy_Team_Account_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Team_Account_Projects_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Team_Account_Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Team_Account_Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Team_Account_Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Team_Account_Projects_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Team_Account_Projects_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Team_Account_Projects_Set_Input>;
  pk_columns: Tenancy_Team_Account_Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Team_Account_Projects_ManyArgs = {
  updates: Array<Tenancy_Team_Account_Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Team_AccountsArgs = {
  _append?: InputMaybe<Tenancy_Team_Accounts_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Team_Accounts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Team_Accounts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Team_Accounts_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Team_Accounts_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Team_Accounts_Set_Input>;
  where: Tenancy_Team_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Team_Accounts_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Team_Accounts_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Team_Accounts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Team_Accounts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Team_Accounts_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Team_Accounts_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Team_Accounts_Set_Input>;
  pk_columns: Tenancy_Team_Accounts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Team_Accounts_ManyArgs = {
  updates: Array<Tenancy_Team_Accounts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_TeamsArgs = {
  _append?: InputMaybe<Tenancy_Teams_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Teams_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Teams_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Teams_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Teams_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Teams_Set_Input>;
  where: Tenancy_Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Teams_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Teams_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Teams_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Teams_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Teams_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Teams_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Teams_Set_Input>;
  pk_columns: Tenancy_Teams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Teams_ManyArgs = {
  updates: Array<Tenancy_Teams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Template_NodeArgs = {
  _append?: InputMaybe<Tenancy_Template_Node_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Template_Node_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Template_Node_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Template_Node_Delete_Key_Input>;
  _inc?: InputMaybe<Tenancy_Template_Node_Inc_Input>;
  _prepend?: InputMaybe<Tenancy_Template_Node_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Template_Node_Set_Input>;
  where: Tenancy_Template_Node_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Template_Node_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Template_Node_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Template_Node_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Template_Node_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Template_Node_Delete_Key_Input>;
  _inc?: InputMaybe<Tenancy_Template_Node_Inc_Input>;
  _prepend?: InputMaybe<Tenancy_Template_Node_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Template_Node_Set_Input>;
  pk_columns: Tenancy_Template_Node_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Template_Node_ManyArgs = {
  updates: Array<Tenancy_Template_Node_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Time_ZoneArgs = {
  _set?: InputMaybe<Tenancy_Time_Zone_Set_Input>;
  where: Tenancy_Time_Zone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Time_Zone_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Time_Zone_Set_Input>;
  pk_columns: Tenancy_Time_Zone_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Time_Zone_ManyArgs = {
  updates: Array<Tenancy_Time_Zone_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_TriggerArgs = {
  _append?: InputMaybe<Tenancy_Trigger_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Trigger_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Trigger_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Trigger_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Trigger_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Trigger_Set_Input>;
  where: Tenancy_Trigger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Trigger_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Trigger_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Trigger_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Trigger_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Trigger_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Trigger_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Trigger_Set_Input>;
  pk_columns: Tenancy_Trigger_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Trigger_ManyArgs = {
  updates: Array<Tenancy_Trigger_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Account_Auth_Method_SettingsArgs = {
  _append?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Prepend_Input>;
  _set?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Set_Input>;
  where: Tenancy_User_Account_Auth_Method_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Account_Auth_Method_Settings_By_PkArgs = {
  _append?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Prepend_Input>;
  _set?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Set_Input>;
  pk_columns: Tenancy_User_Account_Auth_Method_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Account_Auth_Method_Settings_ManyArgs = {
  updates: Array<Tenancy_User_Account_Auth_Method_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Account_Environment_ConfigArgs = {
  _set?: InputMaybe<Tenancy_User_Account_Environment_Config_Set_Input>;
  where: Tenancy_User_Account_Environment_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Account_Environment_Config_By_PkArgs = {
  _set?: InputMaybe<Tenancy_User_Account_Environment_Config_Set_Input>;
  pk_columns: Tenancy_User_Account_Environment_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Account_Environment_Config_ManyArgs = {
  updates: Array<Tenancy_User_Account_Environment_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Account_Project_Metabase_AccessArgs = {
  _inc?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Inc_Input>;
  _set?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Set_Input>;
  where: Tenancy_User_Account_Project_Metabase_Access_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Account_Project_Metabase_Access_By_PkArgs = {
  _inc?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Inc_Input>;
  _set?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Set_Input>;
  pk_columns: Tenancy_User_Account_Project_Metabase_Access_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Account_Project_Metabase_Access_ManyArgs = {
  updates: Array<Tenancy_User_Account_Project_Metabase_Access_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Account_ProjectsArgs = {
  _append?: InputMaybe<Tenancy_User_Account_Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_User_Account_Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_User_Account_Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_User_Account_Projects_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_User_Account_Projects_Prepend_Input>;
  _set?: InputMaybe<Tenancy_User_Account_Projects_Set_Input>;
  where: Tenancy_User_Account_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Account_Projects_By_PkArgs = {
  _append?: InputMaybe<Tenancy_User_Account_Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_User_Account_Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_User_Account_Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_User_Account_Projects_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_User_Account_Projects_Prepend_Input>;
  _set?: InputMaybe<Tenancy_User_Account_Projects_Set_Input>;
  pk_columns: Tenancy_User_Account_Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Account_Projects_ManyArgs = {
  updates: Array<Tenancy_User_Account_Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_AccountsArgs = {
  _append?: InputMaybe<Tenancy_User_Accounts_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_User_Accounts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_User_Accounts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_User_Accounts_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_User_Accounts_Prepend_Input>;
  _set?: InputMaybe<Tenancy_User_Accounts_Set_Input>;
  where: Tenancy_User_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Accounts_By_PkArgs = {
  _append?: InputMaybe<Tenancy_User_Accounts_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_User_Accounts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_User_Accounts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_User_Accounts_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_User_Accounts_Prepend_Input>;
  _set?: InputMaybe<Tenancy_User_Accounts_Set_Input>;
  pk_columns: Tenancy_User_Accounts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_User_Accounts_ManyArgs = {
  updates: Array<Tenancy_User_Accounts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_UsersArgs = {
  _append?: InputMaybe<Tenancy_Users_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Users_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Users_Set_Input>;
  where: Tenancy_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Users_By_PkArgs = {
  _append?: InputMaybe<Tenancy_Users_Append_Input>;
  _delete_at_path?: InputMaybe<Tenancy_Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenancy_Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenancy_Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Tenancy_Users_Prepend_Input>;
  _set?: InputMaybe<Tenancy_Users_Set_Input>;
  pk_columns: Tenancy_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Users_ManyArgs = {
  updates: Array<Tenancy_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_VariableArgs = {
  _set?: InputMaybe<Tenancy_Variable_Set_Input>;
  where: Tenancy_Variable_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Variable_By_PkArgs = {
  _set?: InputMaybe<Tenancy_Variable_Set_Input>;
  pk_columns: Tenancy_Variable_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenancy_Variable_ManyArgs = {
  updates: Array<Tenancy_Variable_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _eq?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _gt?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _gte?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['numeric']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _lte?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _neq?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['numeric']['input']>>>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  admin_?: Maybe<Admin_Query>;
  app_loader_?: Maybe<App_Loader_Query_Root>;
  /** List customers. */
  gesGetCustomers?: Maybe<Array<Maybe<Customer>>>;
  /** Get a Customer record. */
  gesGetCustomersById?: Maybe<Customer>;
  /** List customer keys. */
  gesGetCustomersKeys?: Maybe<Array<Maybe<CustomerKey>>>;
  /**
   * List users associated with a given pype on a given customer.
   * Users with role rank higher that the caller's rank will be omitted. Restricted to internal customers.
   */
  gesGetCustomersPypesUsers?: Maybe<Array<Maybe<GesUser>>>;
  /**
   * List users with Agent role associated with a given pype on a given customer.
   * Restricted to internal customers.
   */
  gesGetCustomersPypesUsersAgents?: Maybe<Array<Maybe<GesUser>>>;
  /**
   * List role mappings associated with a given customer.
   * Only those mappings will be included which have a rank lower than or equal to the caller's role rank, except that the caller can see all of their own role mappings. Restricted to internal customers.
   */
  gesGetCustomersRoleMappings?: Maybe<Array<Maybe<RoleMapping>>>;
  /**
   * List a customer's users.
   * Not applicable for external customers. Users with role rank higher than the caller's rank will be omitted.
   */
  gesGetCustomersUsers?: Maybe<Array<Maybe<GesUser>>>;
  /**
   * Get a customer User record.
   * Same as GetUser except that it additionally checks that the user belongs to this customer.
   */
  gesGetCustomersUsersByUserId?: Maybe<GesUser>;
  /**
   * List environment mappings of a user on a given customer.
   * Restricted to internal customers.
   */
  gesGetCustomersUsersEnvironmentMappings?: Maybe<Array<Maybe<EnvironmentMapping>>>;
  /**
   * List a given user's role mappings on a specific customer.
   * Only those mappings will be included which have a rank lower than or equal to the caller's role rank, except that the caller can see all of their own role mappings.
   */
  gesGetCustomersUsersRoleMappings?: Maybe<Array<Maybe<RoleMapping>>>;
  /**
   * List environments.
   * The list is static and predefined. No special permissions are required.
   */
  gesGetEnvironments?: Maybe<Array<Maybe<GesEnvironment>>>;
  /**
   * List all role definitions.
   * The list is static and predefined. No special permissions are required.
   */
  gesGetRoles?: Maybe<Array<Maybe<RoleDefinition>>>;
  /**
   * List users.
   * Unless caller is superadmin, users not belonging to the caller's customer, as well as
   * users with role rank higher that the caller's rank will be omitted.
   */
  gesGetUsers?: Maybe<Array<Maybe<GesUser>>>;
  /** Get a User record. */
  gesGetUsersByUserId?: Maybe<GesUser>;
  /** List user Claims. */
  gesGetUsersClaims?: Maybe<Claims>;
  /** List a user's customers. */
  gesGetUsersCustomers?: Maybe<Array<Maybe<Customer>>>;
  /**
   * List a given user's role mappings.
   * Only those mappings will be included which (1) concern the customer(s) and pype(s) where the caller is a pype admin, and (2) have a rank lower than or equal to the caller's role rank, except that the caller can see all of their own role mappings.
   */
  gesGetUsersRoleMappings?: Maybe<Array<Maybe<RoleMapping>>>;
  getBotAssetById?: Maybe<Asset>;
  getBotAssets?: Maybe<List>;
  getBotById?: Maybe<Bot>;
  getBotVersions?: Maybe<List>;
  getCustomerBots?: Maybe<List>;
  getCustomerById?: Maybe<BotManagerCustomer>;
  getCustomerPackages?: Maybe<BotManagerCustomer>;
  getCustomerResources?: Maybe<BotManagerCustomer>;
  getCustomers?: Maybe<List>;
  /**
   * Always returns empty data and a
   * 200 response.
   */
  getEntities?: Maybe<Version>;
  getEnvBotVersions?: Maybe<EnvBotVersionResponse>;
  getGraphMd: Scalars['String']['output'];
  getHealthCheck: Scalars['String']['output'];
  /**
   * Always returns empty data and a
   * 200 response.
   */
  getIntents?: Maybe<Version>;
  getListEnvs?: Maybe<List>;
  /** string and a 500 response. */
  getLivenessCheck: Scalars['JSON']['output'];
  getPdfImage: Scalars['String']['output'];
  /** Always return an empty response. */
  getSupervisedLearning?: Maybe<Version>;
  /** gets all widgets for the queried pype_id */
  getV3BusinessWidget?: Maybe<BusinessWidgetResponse>;
  /** gets all widgets for the queried pype_id */
  getV3BusinessWidgetSandbox?: Maybe<BusinessWidgetResponse>;
  /** Get configuration, not used by the front end so not adding much detail */
  getV3Config: Scalars['String']['output'];
  /** Get configuration, not used by the front end so not adding much detail */
  getV3ConfigSandbox: Scalars['String']['output'];
  /** get a particular channel */
  getV3ConfigurationCustomersCustomerIdChannelChannelId?: Maybe<CustomerChannel>;
  /** get a particular channel */
  getV3ConfigurationCustomersCustomerIdChannelChannelIdSandbox?: Maybe<CustomerChannel>;
  /** get all channels for a customer */
  getV3ConfigurationCustomersCustomerIdChannels: Scalars['String']['output'];
  /** get all channels for a customer */
  getV3ConfigurationCustomersCustomerIdChannelsSandbox: Scalars['String']['output'];
  /** get all channels for a customer that have a specified solution */
  getV3ConfigurationCustomersCustomerIdChannelsSolutionId: Scalars['String']['output'];
  /** get all channels for a customer that have a specified solution */
  getV3ConfigurationCustomersCustomerIdChannelsSolutionIdSandbox: Scalars['String']['output'];
  /** get schemas for external agents for a customer */
  getV3ConfigurationCustomersCustomerIdExternalAgentSchemas?: Maybe<PypeConfigurationExternalAgentSchema>;
  /** get schemas for external agents for a customer */
  getV3ConfigurationCustomersCustomerIdExternalAgentSchemasSandbox?: Maybe<PypeConfigurationExternalAgentSchema>;
  /** get a pype (must exist) */
  getV3ConfigurationPypePypeId?: Maybe<PypeConfig>;
  /** get a pype (must exist) */
  getV3ConfigurationPypePypeIdSandbox?: Maybe<PypeConfig>;
  /** Insights handler, not used by the front end so not adding much detail */
  getV3CustomersCustomerIdSolutionsSolutionIdInsights: Scalars['String']['output'];
  /** Insights handler, not used by the front end so not adding much detail */
  getV3CustomersCustomerIdSolutionsSolutionIdInsightsSandbox: Scalars['String']['output'];
  /** Insights handler, not used by the front end so not adding much detail */
  getV3CustomersCustomerIdSolutionsSolutionIdInsightsType: Scalars['String']['output'];
  /** Insights handler, not used by the front end so not adding much detail */
  getV3CustomersCustomerIdSolutionsSolutionIdInsightsTypeSandbox: Scalars['String']['output'];
  /** get the specified key */
  getV3KeysKeyId: Scalars['String']['output'];
  /** get the specified key */
  getV3KeysKeyIdSandbox: Scalars['String']['output'];
  /** get all keys for the specified pype, sorted by DateUpdated */
  getV3PypesPypeIdKeys: Scalars['String']['output'];
  /** get all keys for the specified pype, sorted by DateUpdated */
  getV3PypesPypeIdKeysSandbox: Scalars['String']['output'];
  getVersionById?: Maybe<Version>;
  /** and is not in the blacklist. */
  getVersionFile: Scalars['String']['output'];
  /** has been compiled. */
  getVersionGraph: Scalars['String']['output'];
  /** Do not include a script if it is in the blacklist */
  getVersionScript: Scalars['String']['output'];
  getVersionSearchNluTest: Scalars['String']['output'];
  /**
   * json exists for the given version, return the stopwords
   * otherwise return a list of errors, e.g. "No stopwords for given version"
   */
  getVersionStopwords: Scalars['String']['output'];
  getVersionValidate?: Maybe<VersionValidateResponse>;
  /** GetVoiceAiAccents */
  getVoiceAiAccents?: Maybe<VoiceAiAccentsResult>;
  /** GetVoiceAiAccentsSandbox */
  getVoiceAiAccentsSandbox?: Maybe<VoiceAiAccentsResult>;
  /** GetVoiceAiLanguages */
  getVoiceAiLanguages?: Maybe<VoiceAiLanguagesResult>;
  /** GetVoiceAiLanguagesSandbox */
  getVoiceAiLanguagesSandbox?: Maybe<VoiceAiLanguagesResult>;
  /** GetVoiceAiProviders */
  getVoiceAiProviders?: Maybe<VoiceAiProviderResult>;
  /** GetVoiceAiProvidersSandbox */
  getVoiceAiProvidersSandbox?: Maybe<VoiceAiProviderResult>;
  /** GetVoiceAiSpeechModels */
  getVoiceAiSpeechModels?: Maybe<VoiceAiSpeechModelsResult>;
  /** GetVoiceAiSpeechModelsSandbox */
  getVoiceAiSpeechModelsSandbox?: Maybe<VoiceAiSpeechModelsResult>;
  /** GetVoiceAiVoicesV2 */
  getVoiceAiVoicesV2?: Maybe<VoiceAiProviderResult>;
  /** GetVoiceAiVoicesV2Sandbox */
  getVoiceAiVoicesV2Sandbox?: Maybe<VoiceAiProviderResult>;
  /** Fetch Pro Studio widget app design (live). */
  getWidgetAppDesign?: Maybe<WidgetAppDesign>;
  /** Fetch Pro Studio widget app design (sandbox). */
  getWidgetAppDesignSandbox?: Maybe<WidgetAppDesign>;
  /** List pypes on a customer. */
  pypesGetCustomersPypes?: Maybe<Array<Maybe<Pype>>>;
  /** List the supported agent routings and their property schemas. */
  pypesGetCustomersPypesAgentRoutingSchemas?: Maybe<AgentRoutingSchemas>;
  /** List the supported agent routings and their property schemas. */
  pypesGetCustomersPypesAgentRoutingSchemasSandbox?: Maybe<AgentRoutingSchemas>;
  /** Get a pype record. */
  pypesGetCustomersPypesById?: Maybe<Pype>;
  /** Get a pype record. */
  pypesGetCustomersPypesByIdSandbox?: Maybe<Pype>;
  /** List external agent integration schemas for a customer. */
  pypesGetCustomersPypesExternalAgentSchemas?: Maybe<PypeConfigurationExternalAgentSchema>;
  /** List external agent integration schemas for a customer. */
  pypesGetCustomersPypesExternalAgentSchemasSandbox?: Maybe<PypeConfigurationExternalAgentSchema>;
  /** List the supported agent routings and their property schemas. */
  pypesGetCustomersPypesInternalAgentSchemas?: Maybe<AgentRoutingSchemas>;
  /** List the supported agent routings and their property schemas. */
  pypesGetCustomersPypesInternalAgentSchemasSandbox?: Maybe<AgentRoutingSchemas>;
  /** Get all API keys for the specified pype, sorted by date_updated descending. */
  pypesGetCustomersPypesKeys?: Maybe<ApiKeys>;
  /** Get a specific API key by ID. */
  pypesGetCustomersPypesKeysById?: Maybe<ApiKeyDetail>;
  /** Get a specific API key by ID. */
  pypesGetCustomersPypesKeysByIdSandbox?: Maybe<ApiKeyDetail>;
  /** Get all API keys for the specified pype, sorted by date_updated descending. */
  pypesGetCustomersPypesKeysSandbox?: Maybe<ApiKeys>;
  /** Get pype metrics. */
  pypesGetCustomersPypesMetrics?: Maybe<PypeMetrics>;
  /** Get pype metrics. */
  pypesGetCustomersPypesMetricsSandbox?: Maybe<PypeMetrics>;
  /** List pypes on a customer. */
  pypesGetCustomersPypesSandbox?: Maybe<Array<Maybe<Pype>>>;
  /** List streams of a pype on a customer. */
  pypesGetCustomersPypesStreams?: Maybe<Array<Maybe<Stream>>>;
  /** Get a StreamBot record. */
  pypesGetCustomersPypesStreamsBot?: Maybe<CustomerPypesStreamsBotResponse>;
  /** Get a StreamBot record. */
  pypesGetCustomersPypesStreamsBotSandbox?: Maybe<CustomerPypesStreamsBotResponse>;
  /** Get a stream record. */
  pypesGetCustomersPypesStreamsById?: Maybe<Stream>;
  /** Get Preview Metadata from record. */
  pypesGetCustomersPypesStreamsByIdMetadata?: Maybe<Stream>;
  /** Get Preview Metadata from record. */
  pypesGetCustomersPypesStreamsByIdMetadataSandbox?: Maybe<Stream>;
  /** Get a stream record. */
  pypesGetCustomersPypesStreamsByIdSandbox?: Maybe<Stream>;
  /** List streams of a pype on a customer. */
  pypesGetCustomersPypesStreamsSandbox?: Maybe<Array<Maybe<Stream>>>;
  /** List a user's pypes. */
  pypesGetUsersPypes?: Maybe<Array<Maybe<Pype>>>;
  /** List a user's pypes. */
  pypesGetUsersPypesSandbox?: Maybe<Array<Maybe<Pype>>>;
  /** List pypes on a customer. */
  pypesV6GetCustomersPypes?: Maybe<V6CustomersResult>;
  /** List pypes on a customer. */
  pypesV6GetCustomersPypesSandbox?: Maybe<V6CustomersResult>;
  /** fetch data from the table: "tenancy._ProjectEnvironmentConfigToVariable" */
  tenancy__ProjectEnvironmentConfigToVariable: Array<Tenancy__ProjectEnvironmentConfigToVariable>;
  /** fetch aggregated fields from the table: "tenancy._ProjectEnvironmentConfigToVariable" */
  tenancy__ProjectEnvironmentConfigToVariable_aggregate: Tenancy__ProjectEnvironmentConfigToVariable_Aggregate;
  /** fetch data from the table: "tenancy._prisma_migrations" */
  tenancy__prisma_migrations: Array<Tenancy__Prisma_Migrations>;
  /** fetch aggregated fields from the table: "tenancy._prisma_migrations" */
  tenancy__prisma_migrations_aggregate: Tenancy__Prisma_Migrations_Aggregate;
  /** fetch data from the table: "tenancy._prisma_migrations" using primary key columns */
  tenancy__prisma_migrations_by_pk?: Maybe<Tenancy__Prisma_Migrations>;
  /** fetch data from the table: "tenancy._role_projects" */
  tenancy__role_projects: Array<Tenancy__Role_Projects>;
  /** fetch aggregated fields from the table: "tenancy._role_projects" */
  tenancy__role_projects_aggregate: Tenancy__Role_Projects_Aggregate;
  /** fetch data from the table: "tenancy._team_account_environment_config_roles" */
  tenancy__team_account_environment_config_roles: Array<Tenancy__Team_Account_Environment_Config_Roles>;
  /** fetch aggregated fields from the table: "tenancy._team_account_environment_config_roles" */
  tenancy__team_account_environment_config_roles_aggregate: Tenancy__Team_Account_Environment_Config_Roles_Aggregate;
  /** fetch data from the table: "tenancy._team_account_project_roles" */
  tenancy__team_account_project_roles: Array<Tenancy__Team_Account_Project_Roles>;
  /** fetch aggregated fields from the table: "tenancy._team_account_project_roles" */
  tenancy__team_account_project_roles_aggregate: Tenancy__Team_Account_Project_Roles_Aggregate;
  /** fetch data from the table: "tenancy._team_account_roles" */
  tenancy__team_account_roles: Array<Tenancy__Team_Account_Roles>;
  /** fetch aggregated fields from the table: "tenancy._team_account_roles" */
  tenancy__team_account_roles_aggregate: Tenancy__Team_Account_Roles_Aggregate;
  /** fetch data from the table: "tenancy._user_account_environment_config_roles" */
  tenancy__user_account_environment_config_roles: Array<Tenancy__User_Account_Environment_Config_Roles>;
  /** fetch aggregated fields from the table: "tenancy._user_account_environment_config_roles" */
  tenancy__user_account_environment_config_roles_aggregate: Tenancy__User_Account_Environment_Config_Roles_Aggregate;
  /** fetch data from the table: "tenancy._user_account_project_roles" */
  tenancy__user_account_project_roles: Array<Tenancy__User_Account_Project_Roles>;
  /** fetch aggregated fields from the table: "tenancy._user_account_project_roles" */
  tenancy__user_account_project_roles_aggregate: Tenancy__User_Account_Project_Roles_Aggregate;
  /** fetch data from the table: "tenancy._user_account_roles" */
  tenancy__user_account_roles: Array<Tenancy__User_Account_Roles>;
  /** fetch aggregated fields from the table: "tenancy._user_account_roles" */
  tenancy__user_account_roles_aggregate: Tenancy__User_Account_Roles_Aggregate;
  /** fetch data from the table: "tenancy._user_teams" */
  tenancy__user_teams: Array<Tenancy__User_Teams>;
  /** fetch aggregated fields from the table: "tenancy._user_teams" */
  tenancy__user_teams_aggregate: Tenancy__User_Teams_Aggregate;
  /** fetch data from the table: "tenancy.account_auth_method_settings" */
  tenancy_account_auth_method_settings: Array<Tenancy_Account_Auth_Method_Settings>;
  /** fetch aggregated fields from the table: "tenancy.account_auth_method_settings" */
  tenancy_account_auth_method_settings_aggregate: Tenancy_Account_Auth_Method_Settings_Aggregate;
  /** fetch data from the table: "tenancy.account_auth_method_settings" using primary key columns */
  tenancy_account_auth_method_settings_by_pk?: Maybe<Tenancy_Account_Auth_Method_Settings>;
  /** fetch data from the table: "tenancy.accounts" */
  tenancy_accounts: Array<Tenancy_Accounts>;
  /** fetch aggregated fields from the table: "tenancy.accounts" */
  tenancy_accounts_aggregate: Tenancy_Accounts_Aggregate;
  /** fetch data from the table: "tenancy.accounts" using primary key columns */
  tenancy_accounts_by_pk?: Maybe<Tenancy_Accounts>;
  /** fetch data from the table: "tenancy.action" */
  tenancy_action: Array<Tenancy_Action>;
  /** fetch aggregated fields from the table: "tenancy.action" */
  tenancy_action_aggregate: Tenancy_Action_Aggregate;
  /** fetch data from the table: "tenancy.action" using primary key columns */
  tenancy_action_by_pk?: Maybe<Tenancy_Action>;
  /** fetch data from the table: "tenancy.action_node_job" */
  tenancy_action_node_job: Array<Tenancy_Action_Node_Job>;
  /** fetch aggregated fields from the table: "tenancy.action_node_job" */
  tenancy_action_node_job_aggregate: Tenancy_Action_Node_Job_Aggregate;
  /** fetch data from the table: "tenancy.action_node_job" using primary key columns */
  tenancy_action_node_job_by_pk?: Maybe<Tenancy_Action_Node_Job>;
  /** fetch data from the table: "tenancy.app_config" */
  tenancy_app_config: Array<Tenancy_App_Config>;
  /** fetch aggregated fields from the table: "tenancy.app_config" */
  tenancy_app_config_aggregate: Tenancy_App_Config_Aggregate;
  /** fetch data from the table: "tenancy.app_config" using primary key columns */
  tenancy_app_config_by_pk?: Maybe<Tenancy_App_Config>;
  /** fetch data from the table: "tenancy.applet" */
  tenancy_applet: Array<Tenancy_Applet>;
  /** fetch aggregated fields from the table: "tenancy.applet" */
  tenancy_applet_aggregate: Tenancy_Applet_Aggregate;
  /** fetch data from the table: "tenancy.applet" using primary key columns */
  tenancy_applet_by_pk?: Maybe<Tenancy_Applet>;
  /** fetch data from the table: "tenancy.applet_instance" */
  tenancy_applet_instance: Array<Tenancy_Applet_Instance>;
  /** fetch aggregated fields from the table: "tenancy.applet_instance" */
  tenancy_applet_instance_aggregate: Tenancy_Applet_Instance_Aggregate;
  /** fetch data from the table: "tenancy.applet_instance" using primary key columns */
  tenancy_applet_instance_by_pk?: Maybe<Tenancy_Applet_Instance>;
  /** fetch data from the table: "tenancy.applet_version" */
  tenancy_applet_version: Array<Tenancy_Applet_Version>;
  /** fetch aggregated fields from the table: "tenancy.applet_version" */
  tenancy_applet_version_aggregate: Tenancy_Applet_Version_Aggregate;
  /** fetch data from the table: "tenancy.applet_version" using primary key columns */
  tenancy_applet_version_by_pk?: Maybe<Tenancy_Applet_Version>;
  /** fetch data from the table: "tenancy.audit_logs" */
  tenancy_audit_logs: Array<Tenancy_Audit_Logs>;
  /** fetch aggregated fields from the table: "tenancy.audit_logs" */
  tenancy_audit_logs_aggregate: Tenancy_Audit_Logs_Aggregate;
  /** fetch data from the table: "tenancy.audit_logs" using primary key columns */
  tenancy_audit_logs_by_pk?: Maybe<Tenancy_Audit_Logs>;
  /** fetch data from the table: "tenancy.auth_method" */
  tenancy_auth_method: Array<Tenancy_Auth_Method>;
  /** fetch aggregated fields from the table: "tenancy.auth_method" */
  tenancy_auth_method_aggregate: Tenancy_Auth_Method_Aggregate;
  /** fetch data from the table: "tenancy.auth_method" using primary key columns */
  tenancy_auth_method_by_pk?: Maybe<Tenancy_Auth_Method>;
  /** fetch data from the table: "tenancy.condition" */
  tenancy_condition: Array<Tenancy_Condition>;
  /** fetch aggregated fields from the table: "tenancy.condition" */
  tenancy_condition_aggregate: Tenancy_Condition_Aggregate;
  /** fetch data from the table: "tenancy.condition" using primary key columns */
  tenancy_condition_by_pk?: Maybe<Tenancy_Condition>;
  /** fetch data from the table: "tenancy.country" */
  tenancy_country: Array<Tenancy_Country>;
  /** fetch aggregated fields from the table: "tenancy.country" */
  tenancy_country_aggregate: Tenancy_Country_Aggregate;
  /** fetch data from the table: "tenancy.country" using primary key columns */
  tenancy_country_by_pk?: Maybe<Tenancy_Country>;
  /** fetch data from the table: "tenancy.custom_auth_method" */
  tenancy_custom_auth_method: Array<Tenancy_Custom_Auth_Method>;
  /** fetch aggregated fields from the table: "tenancy.custom_auth_method" */
  tenancy_custom_auth_method_aggregate: Tenancy_Custom_Auth_Method_Aggregate;
  /** fetch data from the table: "tenancy.custom_auth_method" using primary key columns */
  tenancy_custom_auth_method_by_pk?: Maybe<Tenancy_Custom_Auth_Method>;
  /** fetch data from the table: "tenancy.domain" */
  tenancy_domain: Array<Tenancy_Domain>;
  /** fetch aggregated fields from the table: "tenancy.domain" */
  tenancy_domain_aggregate: Tenancy_Domain_Aggregate;
  /** fetch data from the table: "tenancy.domain" using primary key columns */
  tenancy_domain_by_pk?: Maybe<Tenancy_Domain>;
  /** fetch data from the table: "tenancy.environment" */
  tenancy_environment: Array<Tenancy_Environment>;
  /** fetch aggregated fields from the table: "tenancy.environment" */
  tenancy_environment_aggregate: Tenancy_Environment_Aggregate;
  /** fetch data from the table: "tenancy.environment" using primary key columns */
  tenancy_environment_by_pk?: Maybe<Tenancy_Environment>;
  /** fetch data from the table: "tenancy.failed_kafka_events" */
  tenancy_failed_kafka_events: Array<Tenancy_Failed_Kafka_Events>;
  /** fetch aggregated fields from the table: "tenancy.failed_kafka_events" */
  tenancy_failed_kafka_events_aggregate: Tenancy_Failed_Kafka_Events_Aggregate;
  /** fetch data from the table: "tenancy.failed_kafka_events" using primary key columns */
  tenancy_failed_kafka_events_by_pk?: Maybe<Tenancy_Failed_Kafka_Events>;
  /** fetch data from the table: "tenancy.file" */
  tenancy_file: Array<Tenancy_File>;
  /** fetch aggregated fields from the table: "tenancy.file" */
  tenancy_file_aggregate: Tenancy_File_Aggregate;
  /** fetch data from the table: "tenancy.file" using primary key columns */
  tenancy_file_by_pk?: Maybe<Tenancy_File>;
  /** fetch data from the table: "tenancy.llm_credentials" */
  tenancy_llm_credentials: Array<Tenancy_Llm_Credentials>;
  /** fetch aggregated fields from the table: "tenancy.llm_credentials" */
  tenancy_llm_credentials_aggregate: Tenancy_Llm_Credentials_Aggregate;
  /** fetch data from the table: "tenancy.llm_credentials" using primary key columns */
  tenancy_llm_credentials_by_pk?: Maybe<Tenancy_Llm_Credentials>;
  /** fetch data from the table: "tenancy.llm_providers" */
  tenancy_llm_providers: Array<Tenancy_Llm_Providers>;
  /** fetch aggregated fields from the table: "tenancy.llm_providers" */
  tenancy_llm_providers_aggregate: Tenancy_Llm_Providers_Aggregate;
  /** fetch data from the table: "tenancy.llm_providers" using primary key columns */
  tenancy_llm_providers_by_pk?: Maybe<Tenancy_Llm_Providers>;
  /** fetch data from the table: "tenancy.locale" */
  tenancy_locale: Array<Tenancy_Locale>;
  /** fetch aggregated fields from the table: "tenancy.locale" */
  tenancy_locale_aggregate: Tenancy_Locale_Aggregate;
  /** fetch data from the table: "tenancy.locale" using primary key columns */
  tenancy_locale_by_pk?: Maybe<Tenancy_Locale>;
  /** fetch data from the table: "tenancy.localization_settings" */
  tenancy_localization_settings: Array<Tenancy_Localization_Settings>;
  /** fetch aggregated fields from the table: "tenancy.localization_settings" */
  tenancy_localization_settings_aggregate: Tenancy_Localization_Settings_Aggregate;
  /** fetch data from the table: "tenancy.localization_settings" using primary key columns */
  tenancy_localization_settings_by_pk?: Maybe<Tenancy_Localization_Settings>;
  /** fetch data from the table: "tenancy.node_type_enum_ps" */
  tenancy_node_type_enum_ps: Array<Tenancy_Node_Type_Enum_Ps>;
  /** fetch aggregated fields from the table: "tenancy.node_type_enum_ps" */
  tenancy_node_type_enum_ps_aggregate: Tenancy_Node_Type_Enum_Ps_Aggregate;
  /** fetch data from the table: "tenancy.node_type_enum_ps" using primary key columns */
  tenancy_node_type_enum_ps_by_pk?: Maybe<Tenancy_Node_Type_Enum_Ps>;
  /** fetch data from the table: "tenancy.package" */
  tenancy_package: Array<Tenancy_Package>;
  /** fetch aggregated fields from the table: "tenancy.package" */
  tenancy_package_aggregate: Tenancy_Package_Aggregate;
  /** fetch data from the table: "tenancy.package" using primary key columns */
  tenancy_package_by_pk?: Maybe<Tenancy_Package>;
  /** fetch data from the table: "tenancy.package_version" */
  tenancy_package_version: Array<Tenancy_Package_Version>;
  /** fetch aggregated fields from the table: "tenancy.package_version" */
  tenancy_package_version_aggregate: Tenancy_Package_Version_Aggregate;
  /** fetch data from the table: "tenancy.package_version" using primary key columns */
  tenancy_package_version_by_pk?: Maybe<Tenancy_Package_Version>;
  /** fetch data from the table: "tenancy.pro_studio_performance_metrics" */
  tenancy_pro_studio_performance_metrics: Array<Tenancy_Pro_Studio_Performance_Metrics>;
  /** fetch aggregated fields from the table: "tenancy.pro_studio_performance_metrics" */
  tenancy_pro_studio_performance_metrics_aggregate: Tenancy_Pro_Studio_Performance_Metrics_Aggregate;
  /** fetch data from the table: "tenancy.pro_studio_performance_metrics" using primary key columns */
  tenancy_pro_studio_performance_metrics_by_pk?: Maybe<Tenancy_Pro_Studio_Performance_Metrics>;
  /** fetch data from the table: "tenancy.products" */
  tenancy_products: Array<Tenancy_Products>;
  /** fetch aggregated fields from the table: "tenancy.products" */
  tenancy_products_aggregate: Tenancy_Products_Aggregate;
  /** fetch data from the table: "tenancy.products" using primary key columns */
  tenancy_products_by_pk?: Maybe<Tenancy_Products>;
  /** fetch data from the table: "tenancy.project_environment_config" */
  tenancy_project_environment_config: Array<Tenancy_Project_Environment_Config>;
  /** fetch aggregated fields from the table: "tenancy.project_environment_config" */
  tenancy_project_environment_config_aggregate: Tenancy_Project_Environment_Config_Aggregate;
  /** fetch data from the table: "tenancy.project_environment_config" using primary key columns */
  tenancy_project_environment_config_by_pk?: Maybe<Tenancy_Project_Environment_Config>;
  /** fetch data from the table: "tenancy.project_pro_studio_setting" */
  tenancy_project_pro_studio_setting: Array<Tenancy_Project_Pro_Studio_Setting>;
  /** fetch aggregated fields from the table: "tenancy.project_pro_studio_setting" */
  tenancy_project_pro_studio_setting_aggregate: Tenancy_Project_Pro_Studio_Setting_Aggregate;
  /** fetch data from the table: "tenancy.project_pro_studio_setting" using primary key columns */
  tenancy_project_pro_studio_setting_by_pk?: Maybe<Tenancy_Project_Pro_Studio_Setting>;
  /** fetch data from the table: "tenancy.project_product_settings" */
  tenancy_project_product_settings: Array<Tenancy_Project_Product_Settings>;
  /** fetch aggregated fields from the table: "tenancy.project_product_settings" */
  tenancy_project_product_settings_aggregate: Tenancy_Project_Product_Settings_Aggregate;
  /** fetch data from the table: "tenancy.project_product_settings" using primary key columns */
  tenancy_project_product_settings_by_pk?: Maybe<Tenancy_Project_Product_Settings>;
  /** fetch data from the table: "tenancy.projects" */
  tenancy_projects: Array<Tenancy_Projects>;
  /** fetch aggregated fields from the table: "tenancy.projects" */
  tenancy_projects_aggregate: Tenancy_Projects_Aggregate;
  /** fetch data from the table: "tenancy.projects" using primary key columns */
  tenancy_projects_by_pk?: Maybe<Tenancy_Projects>;
  /** fetch data from the table: "tenancy.pype_connection" */
  tenancy_pype_connection: Array<Tenancy_Pype_Connection>;
  /** fetch aggregated fields from the table: "tenancy.pype_connection" */
  tenancy_pype_connection_aggregate: Tenancy_Pype_Connection_Aggregate;
  /** fetch data from the table: "tenancy.pype_connection" using primary key columns */
  tenancy_pype_connection_by_pk?: Maybe<Tenancy_Pype_Connection>;
  /** fetch data from the table: "tenancy.pype_connection_pype" */
  tenancy_pype_connection_pype: Array<Tenancy_Pype_Connection_Pype>;
  /** fetch aggregated fields from the table: "tenancy.pype_connection_pype" */
  tenancy_pype_connection_pype_aggregate: Tenancy_Pype_Connection_Pype_Aggregate;
  /** fetch data from the table: "tenancy.pype_connection_pype" using primary key columns */
  tenancy_pype_connection_pype_by_pk?: Maybe<Tenancy_Pype_Connection_Pype>;
  /** fetch data from the table: "tenancy.pype_rule" */
  tenancy_pype_rule: Array<Tenancy_Pype_Rule>;
  /** fetch aggregated fields from the table: "tenancy.pype_rule" */
  tenancy_pype_rule_aggregate: Tenancy_Pype_Rule_Aggregate;
  /** fetch data from the table: "tenancy.pype_rule" using primary key columns */
  tenancy_pype_rule_by_pk?: Maybe<Tenancy_Pype_Rule>;
  /** fetch data from the table: "tenancy.pype_rule_group" */
  tenancy_pype_rule_group: Array<Tenancy_Pype_Rule_Group>;
  /** fetch aggregated fields from the table: "tenancy.pype_rule_group" */
  tenancy_pype_rule_group_aggregate: Tenancy_Pype_Rule_Group_Aggregate;
  /** fetch data from the table: "tenancy.pype_rule_group" using primary key columns */
  tenancy_pype_rule_group_by_pk?: Maybe<Tenancy_Pype_Rule_Group>;
  /** fetch data from the table: "tenancy.pype_rule_group_pype" */
  tenancy_pype_rule_group_pype: Array<Tenancy_Pype_Rule_Group_Pype>;
  /** fetch aggregated fields from the table: "tenancy.pype_rule_group_pype" */
  tenancy_pype_rule_group_pype_aggregate: Tenancy_Pype_Rule_Group_Pype_Aggregate;
  /** fetch data from the table: "tenancy.pype_rule_group_pype" using primary key columns */
  tenancy_pype_rule_group_pype_by_pk?: Maybe<Tenancy_Pype_Rule_Group_Pype>;
  /** fetch data from the table: "tenancy.rich_asset_type_enum_ps" */
  tenancy_rich_asset_type_enum_ps: Array<Tenancy_Rich_Asset_Type_Enum_Ps>;
  /** fetch aggregated fields from the table: "tenancy.rich_asset_type_enum_ps" */
  tenancy_rich_asset_type_enum_ps_aggregate: Tenancy_Rich_Asset_Type_Enum_Ps_Aggregate;
  /** fetch data from the table: "tenancy.rich_asset_type_enum_ps" using primary key columns */
  tenancy_rich_asset_type_enum_ps_by_pk?: Maybe<Tenancy_Rich_Asset_Type_Enum_Ps>;
  /** fetch data from the table: "tenancy.roles" */
  tenancy_roles: Array<Tenancy_Roles>;
  /** fetch aggregated fields from the table: "tenancy.roles" */
  tenancy_roles_aggregate: Tenancy_Roles_Aggregate;
  /** fetch data from the table: "tenancy.roles" using primary key columns */
  tenancy_roles_by_pk?: Maybe<Tenancy_Roles>;
  /** fetch data from the table: "tenancy.solution_deployment_run_workflows" */
  tenancy_solution_deployment_run_workflows: Array<Tenancy_Solution_Deployment_Run_Workflows>;
  /** fetch aggregated fields from the table: "tenancy.solution_deployment_run_workflows" */
  tenancy_solution_deployment_run_workflows_aggregate: Tenancy_Solution_Deployment_Run_Workflows_Aggregate;
  /** fetch data from the table: "tenancy.solution_deployment_run_workflows" using primary key columns */
  tenancy_solution_deployment_run_workflows_by_pk?: Maybe<Tenancy_Solution_Deployment_Run_Workflows>;
  /** fetch data from the table: "tenancy.solution_deployment_runs" */
  tenancy_solution_deployment_runs: Array<Tenancy_Solution_Deployment_Runs>;
  /** fetch aggregated fields from the table: "tenancy.solution_deployment_runs" */
  tenancy_solution_deployment_runs_aggregate: Tenancy_Solution_Deployment_Runs_Aggregate;
  /** fetch data from the table: "tenancy.solution_deployment_runs" using primary key columns */
  tenancy_solution_deployment_runs_by_pk?: Maybe<Tenancy_Solution_Deployment_Runs>;
  /** fetch data from the table: "tenancy.solution_deployments" */
  tenancy_solution_deployments: Array<Tenancy_Solution_Deployments>;
  /** fetch aggregated fields from the table: "tenancy.solution_deployments" */
  tenancy_solution_deployments_aggregate: Tenancy_Solution_Deployments_Aggregate;
  /** fetch data from the table: "tenancy.solution_deployments" using primary key columns */
  tenancy_solution_deployments_by_pk?: Maybe<Tenancy_Solution_Deployments>;
  /** fetch data from the table: "tenancy.solution_task" */
  tenancy_solution_task: Array<Tenancy_Solution_Task>;
  /** fetch aggregated fields from the table: "tenancy.solution_task" */
  tenancy_solution_task_aggregate: Tenancy_Solution_Task_Aggregate;
  /** fetch data from the table: "tenancy.solution_task" using primary key columns */
  tenancy_solution_task_by_pk?: Maybe<Tenancy_Solution_Task>;
  /** fetch data from the table: "tenancy.solution_user_presence" */
  tenancy_solution_user_presence: Array<Tenancy_Solution_User_Presence>;
  /** fetch aggregated fields from the table: "tenancy.solution_user_presence" */
  tenancy_solution_user_presence_aggregate: Tenancy_Solution_User_Presence_Aggregate;
  /** fetch data from the table: "tenancy.solution_user_presence" using primary key columns */
  tenancy_solution_user_presence_by_pk?: Maybe<Tenancy_Solution_User_Presence>;
  /** fetch data from the table: "tenancy.solution_version_nodes_ps" */
  tenancy_solution_version_nodes_ps: Array<Tenancy_Solution_Version_Nodes_Ps>;
  /** fetch aggregated fields from the table: "tenancy.solution_version_nodes_ps" */
  tenancy_solution_version_nodes_ps_aggregate: Tenancy_Solution_Version_Nodes_Ps_Aggregate;
  /** fetch data from the table: "tenancy.solution_version_nodes_ps" using primary key columns */
  tenancy_solution_version_nodes_ps_by_pk?: Maybe<Tenancy_Solution_Version_Nodes_Ps>;
  /** fetch data from the table: "tenancy.solution_versions" */
  tenancy_solution_versions: Array<Tenancy_Solution_Versions>;
  /** fetch aggregated fields from the table: "tenancy.solution_versions" */
  tenancy_solution_versions_aggregate: Tenancy_Solution_Versions_Aggregate;
  /** fetch data from the table: "tenancy.solution_versions" using primary key columns */
  tenancy_solution_versions_by_pk?: Maybe<Tenancy_Solution_Versions>;
  /** fetch data from the table: "tenancy.solution_versions_ps" */
  tenancy_solution_versions_ps: Array<Tenancy_Solution_Versions_Ps>;
  /** fetch aggregated fields from the table: "tenancy.solution_versions_ps" */
  tenancy_solution_versions_ps_aggregate: Tenancy_Solution_Versions_Ps_Aggregate;
  /** fetch data from the table: "tenancy.solution_versions_ps" using primary key columns */
  tenancy_solution_versions_ps_by_pk?: Maybe<Tenancy_Solution_Versions_Ps>;
  /** fetch data from the table: "tenancy.solutions" */
  tenancy_solutions: Array<Tenancy_Solutions>;
  /** fetch aggregated fields from the table: "tenancy.solutions" */
  tenancy_solutions_aggregate: Tenancy_Solutions_Aggregate;
  /** fetch data from the table: "tenancy.solutions" using primary key columns */
  tenancy_solutions_by_pk?: Maybe<Tenancy_Solutions>;
  /** fetch data from the table: "tenancy.studio_resource" */
  tenancy_studio_resource: Array<Tenancy_Studio_Resource>;
  /** fetch aggregated fields from the table: "tenancy.studio_resource" */
  tenancy_studio_resource_aggregate: Tenancy_Studio_Resource_Aggregate;
  /** fetch data from the table: "tenancy.studio_resource" using primary key columns */
  tenancy_studio_resource_by_pk?: Maybe<Tenancy_Studio_Resource>;
  /** fetch data from the table: "tenancy.team_account_environment_config" */
  tenancy_team_account_environment_config: Array<Tenancy_Team_Account_Environment_Config>;
  /** fetch aggregated fields from the table: "tenancy.team_account_environment_config" */
  tenancy_team_account_environment_config_aggregate: Tenancy_Team_Account_Environment_Config_Aggregate;
  /** fetch data from the table: "tenancy.team_account_environment_config" using primary key columns */
  tenancy_team_account_environment_config_by_pk?: Maybe<Tenancy_Team_Account_Environment_Config>;
  /** fetch data from the table: "tenancy.team_account_projects" */
  tenancy_team_account_projects: Array<Tenancy_Team_Account_Projects>;
  /** fetch aggregated fields from the table: "tenancy.team_account_projects" */
  tenancy_team_account_projects_aggregate: Tenancy_Team_Account_Projects_Aggregate;
  /** fetch data from the table: "tenancy.team_account_projects" using primary key columns */
  tenancy_team_account_projects_by_pk?: Maybe<Tenancy_Team_Account_Projects>;
  /** fetch data from the table: "tenancy.team_accounts" */
  tenancy_team_accounts: Array<Tenancy_Team_Accounts>;
  /** fetch aggregated fields from the table: "tenancy.team_accounts" */
  tenancy_team_accounts_aggregate: Tenancy_Team_Accounts_Aggregate;
  /** fetch data from the table: "tenancy.team_accounts" using primary key columns */
  tenancy_team_accounts_by_pk?: Maybe<Tenancy_Team_Accounts>;
  /** fetch data from the table: "tenancy.teams" */
  tenancy_teams: Array<Tenancy_Teams>;
  /** fetch aggregated fields from the table: "tenancy.teams" */
  tenancy_teams_aggregate: Tenancy_Teams_Aggregate;
  /** fetch data from the table: "tenancy.teams" using primary key columns */
  tenancy_teams_by_pk?: Maybe<Tenancy_Teams>;
  /** fetch data from the table: "tenancy.template_node" */
  tenancy_template_node: Array<Tenancy_Template_Node>;
  /** fetch aggregated fields from the table: "tenancy.template_node" */
  tenancy_template_node_aggregate: Tenancy_Template_Node_Aggregate;
  /** fetch data from the table: "tenancy.template_node" using primary key columns */
  tenancy_template_node_by_pk?: Maybe<Tenancy_Template_Node>;
  /** fetch data from the table: "tenancy.time_zone" */
  tenancy_time_zone: Array<Tenancy_Time_Zone>;
  /** fetch aggregated fields from the table: "tenancy.time_zone" */
  tenancy_time_zone_aggregate: Tenancy_Time_Zone_Aggregate;
  /** fetch data from the table: "tenancy.time_zone" using primary key columns */
  tenancy_time_zone_by_pk?: Maybe<Tenancy_Time_Zone>;
  /** fetch data from the table: "tenancy.trigger" */
  tenancy_trigger: Array<Tenancy_Trigger>;
  /** fetch aggregated fields from the table: "tenancy.trigger" */
  tenancy_trigger_aggregate: Tenancy_Trigger_Aggregate;
  /** fetch data from the table: "tenancy.trigger" using primary key columns */
  tenancy_trigger_by_pk?: Maybe<Tenancy_Trigger>;
  /** fetch data from the table: "tenancy.user_account_auth_method_settings" */
  tenancy_user_account_auth_method_settings: Array<Tenancy_User_Account_Auth_Method_Settings>;
  /** fetch aggregated fields from the table: "tenancy.user_account_auth_method_settings" */
  tenancy_user_account_auth_method_settings_aggregate: Tenancy_User_Account_Auth_Method_Settings_Aggregate;
  /** fetch data from the table: "tenancy.user_account_auth_method_settings" using primary key columns */
  tenancy_user_account_auth_method_settings_by_pk?: Maybe<Tenancy_User_Account_Auth_Method_Settings>;
  /** fetch data from the table: "tenancy.user_account_environment_config" */
  tenancy_user_account_environment_config: Array<Tenancy_User_Account_Environment_Config>;
  /** fetch aggregated fields from the table: "tenancy.user_account_environment_config" */
  tenancy_user_account_environment_config_aggregate: Tenancy_User_Account_Environment_Config_Aggregate;
  /** fetch data from the table: "tenancy.user_account_environment_config" using primary key columns */
  tenancy_user_account_environment_config_by_pk?: Maybe<Tenancy_User_Account_Environment_Config>;
  /** fetch data from the table: "tenancy.user_account_project_metabase_access" */
  tenancy_user_account_project_metabase_access: Array<Tenancy_User_Account_Project_Metabase_Access>;
  /** fetch aggregated fields from the table: "tenancy.user_account_project_metabase_access" */
  tenancy_user_account_project_metabase_access_aggregate: Tenancy_User_Account_Project_Metabase_Access_Aggregate;
  /** fetch data from the table: "tenancy.user_account_project_metabase_access" using primary key columns */
  tenancy_user_account_project_metabase_access_by_pk?: Maybe<Tenancy_User_Account_Project_Metabase_Access>;
  /** fetch data from the table: "tenancy.user_account_projects" */
  tenancy_user_account_projects: Array<Tenancy_User_Account_Projects>;
  /** fetch aggregated fields from the table: "tenancy.user_account_projects" */
  tenancy_user_account_projects_aggregate: Tenancy_User_Account_Projects_Aggregate;
  /** fetch data from the table: "tenancy.user_account_projects" using primary key columns */
  tenancy_user_account_projects_by_pk?: Maybe<Tenancy_User_Account_Projects>;
  /** fetch data from the table: "tenancy.user_accounts" */
  tenancy_user_accounts: Array<Tenancy_User_Accounts>;
  /** fetch aggregated fields from the table: "tenancy.user_accounts" */
  tenancy_user_accounts_aggregate: Tenancy_User_Accounts_Aggregate;
  /** fetch data from the table: "tenancy.user_accounts" using primary key columns */
  tenancy_user_accounts_by_pk?: Maybe<Tenancy_User_Accounts>;
  /** fetch data from the table: "tenancy.users" */
  tenancy_users: Array<Tenancy_Users>;
  /** fetch aggregated fields from the table: "tenancy.users" */
  tenancy_users_aggregate: Tenancy_Users_Aggregate;
  /** fetch data from the table: "tenancy.users" using primary key columns */
  tenancy_users_by_pk?: Maybe<Tenancy_Users>;
  /** fetch data from the table: "tenancy.variable" */
  tenancy_variable: Array<Tenancy_Variable>;
  /** fetch aggregated fields from the table: "tenancy.variable" */
  tenancy_variable_aggregate: Tenancy_Variable_Aggregate;
  /** fetch data from the table: "tenancy.variable" using primary key columns */
  tenancy_variable_by_pk?: Maybe<Tenancy_Variable>;
};


export type Query_RootGesGetCustomersArgs = {
  projectId: Scalars['String']['input'];
};


export type Query_RootGesGetCustomersByIdArgs = {
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGesGetCustomersKeysArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGesGetCustomersPypesUsersArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootGesGetCustomersPypesUsersAgentsArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootGesGetCustomersRoleMappingsArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGesGetCustomersUsersArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGesGetCustomersUsersByUserIdArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Query_RootGesGetCustomersUsersEnvironmentMappingsArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Query_RootGesGetCustomersUsersRoleMappingsArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Query_RootGesGetEnvironmentsArgs = {
  projectId: Scalars['String']['input'];
};


export type Query_RootGesGetRolesArgs = {
  projectId: Scalars['String']['input'];
};


export type Query_RootGesGetUsersArgs = {
  projectId: Scalars['String']['input'];
};


export type Query_RootGesGetUsersByUserIdArgs = {
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGesGetUsersClaimsArgs = {
  idOrEmail: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGesGetUsersCustomersArgs = {
  projectId: Scalars['String']['input'];
  term: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Query_RootGesGetUsersRoleMappingsArgs = {
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Query_RootGetBotAssetByIdArgs = {
  assetId: Scalars['String']['input'];
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetBotAssetsArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetBotByIdArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetBotVersionsArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetCustomerBotsArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetCustomerByIdArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetCustomerPackagesArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetCustomerResourcesArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetCustomersArgs = {
  projectId: Scalars['String']['input'];
};


export type Query_RootGetEntitiesArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetEnvBotVersionsArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetGraphMdArgs = {
  projectId: Scalars['String']['input'];
  queryURL: Scalars['String']['input'];
};


export type Query_RootGetIntentsArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetListEnvsArgs = {
  projectId: Scalars['String']['input'];
};


export type Query_RootGetPdfImageArgs = {
  projectId: Scalars['String']['input'];
  queryURL: Scalars['String']['input'];
};


export type Query_RootGetSupervisedLearningArgs = {
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetV3BusinessWidgetArgs = {
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootGetV3BusinessWidgetSandboxArgs = {
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootGetV3ConfigArgs = {
  projectId: Scalars['String']['input'];
};


export type Query_RootGetV3ConfigSandboxArgs = {
  projectId: Scalars['String']['input'];
};


export type Query_RootGetV3ConfigurationCustomersCustomerIdChannelChannelIdArgs = {
  channelId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetV3ConfigurationCustomersCustomerIdChannelChannelIdSandboxArgs = {
  channelId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetV3ConfigurationCustomersCustomerIdChannelsArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetV3ConfigurationCustomersCustomerIdChannelsSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetV3ConfigurationCustomersCustomerIdChannelsSolutionIdArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Query_RootGetV3ConfigurationCustomersCustomerIdChannelsSolutionIdSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Query_RootGetV3ConfigurationCustomersCustomerIdExternalAgentSchemasArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetV3ConfigurationCustomersCustomerIdExternalAgentSchemasSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetV3ConfigurationPypePypeIdArgs = {
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootGetV3ConfigurationPypePypeIdSandboxArgs = {
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootGetV3CustomersCustomerIdSolutionsSolutionIdInsightsArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Query_RootGetV3CustomersCustomerIdSolutionsSolutionIdInsightsSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
};


export type Query_RootGetV3CustomersCustomerIdSolutionsSolutionIdInsightsTypeArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type Query_RootGetV3CustomersCustomerIdSolutionsSolutionIdInsightsTypeSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type Query_RootGetV3KeysKeyIdArgs = {
  authorization: Scalars['String']['input'];
  keyId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetV3KeysKeyIdSandboxArgs = {
  authorization: Scalars['String']['input'];
  keyId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetV3PypesPypeIdKeysArgs = {
  authorization: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootGetV3PypesPypeIdKeysSandboxArgs = {
  authorization: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootGetVersionByIdArgs = {
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type Query_RootGetVersionFileArgs = {
  filePath: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type Query_RootGetVersionGraphArgs = {
  accept?: InputMaybe<Accept>;
  compiled?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type Query_RootGetVersionScriptArgs = {
  filePath: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type Query_RootGetVersionSearchNluTestArgs = {
  projectId: Scalars['String']['input'];
  searchNLUEndpointName: Scalars['String']['input'];
  utterance: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type Query_RootGetVersionStopwordsArgs = {
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type Query_RootGetVersionValidateArgs = {
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type Query_RootGetVoiceAiAccentsArgs = {
  args: GetVoiceAiAccentsInput;
};


export type Query_RootGetVoiceAiAccentsSandboxArgs = {
  args: GetVoiceAiAccentsInput;
};


export type Query_RootGetVoiceAiProvidersArgs = {
  args: GetVoiceAiProvidersInput;
};


export type Query_RootGetVoiceAiProvidersSandboxArgs = {
  args: GetVoiceAiProvidersInput;
};


export type Query_RootGetVoiceAiSpeechModelsArgs = {
  args: GetVoiceAiSpeechModelsInput;
};


export type Query_RootGetVoiceAiSpeechModelsSandboxArgs = {
  args: GetVoiceAiSpeechModelsInput;
};


export type Query_RootGetVoiceAiVoicesV2Args = {
  args: GetVoiceAiVoicesV2Input;
};


export type Query_RootGetVoiceAiVoicesV2SandboxArgs = {
  args: GetVoiceAiVoicesV2Input;
};


export type Query_RootGetWidgetAppDesignArgs = {
  appId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootGetWidgetAppDesignSandboxArgs = {
  appId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesAgentRoutingSchemasArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesAgentRoutingSchemasSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesByIdArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesByIdSandboxArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesExternalAgentSchemasArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesExternalAgentSchemasSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesInternalAgentSchemasArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesInternalAgentSchemasSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesKeysArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesKeysByIdArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesKeysByIdSandboxArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesKeysSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesMetricsArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesMetricsSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesStreamsArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesStreamsBotArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesStreamsBotSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesStreamsByIdArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesStreamsByIdMetadataArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesStreamsByIdMetadataSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesStreamsByIdSandboxArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootPypesGetCustomersPypesStreamsSandboxArgs = {
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
};


export type Query_RootPypesGetUsersPypesArgs = {
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Query_RootPypesGetUsersPypesSandboxArgs = {
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Query_RootPypesV6GetCustomersPypesArgs = {
  botId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootPypesV6GetCustomersPypesSandboxArgs = {
  botId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootTenancy__ProjectEnvironmentConfigToVariableArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Order_By>>;
  where?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
};


export type Query_RootTenancy__ProjectEnvironmentConfigToVariable_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Order_By>>;
  where?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
};


export type Query_RootTenancy__Prisma_MigrationsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Prisma_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Prisma_Migrations_Order_By>>;
  where?: InputMaybe<Tenancy__Prisma_Migrations_Bool_Exp>;
};


export type Query_RootTenancy__Prisma_Migrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Prisma_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Prisma_Migrations_Order_By>>;
  where?: InputMaybe<Tenancy__Prisma_Migrations_Bool_Exp>;
};


export type Query_RootTenancy__Prisma_Migrations_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy__Role_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Role_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Role_Projects_Order_By>>;
  where?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
};


export type Query_RootTenancy__Role_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Role_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Role_Projects_Order_By>>;
  where?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
};


export type Query_RootTenancy__Team_Account_Environment_Config_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
};


export type Query_RootTenancy__Team_Account_Environment_Config_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
};


export type Query_RootTenancy__Team_Account_Project_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
};


export type Query_RootTenancy__Team_Account_Project_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
};


export type Query_RootTenancy__Team_Account_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
};


export type Query_RootTenancy__Team_Account_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
};


export type Query_RootTenancy__User_Account_Environment_Config_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
};


export type Query_RootTenancy__User_Account_Environment_Config_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
};


export type Query_RootTenancy__User_Account_Project_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
};


export type Query_RootTenancy__User_Account_Project_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
};


export type Query_RootTenancy__User_Account_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
};


export type Query_RootTenancy__User_Account_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
};


export type Query_RootTenancy__User_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Teams_Order_By>>;
  where?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
};


export type Query_RootTenancy__User_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Teams_Order_By>>;
  where?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
};


export type Query_RootTenancy_Account_Auth_Method_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
};


export type Query_RootTenancy_Account_Auth_Method_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
};


export type Query_RootTenancy_Account_Auth_Method_Settings_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
};


export type Query_RootTenancy_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
};


export type Query_RootTenancy_Accounts_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_ActionArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Bool_Exp>;
};


export type Query_RootTenancy_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Bool_Exp>;
};


export type Query_RootTenancy_Action_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Action_Node_JobArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Node_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Node_Job_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
};


export type Query_RootTenancy_Action_Node_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Node_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Node_Job_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
};


export type Query_RootTenancy_Action_Node_Job_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_App_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_App_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_App_Config_Order_By>>;
  where?: InputMaybe<Tenancy_App_Config_Bool_Exp>;
};


export type Query_RootTenancy_App_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_App_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_App_Config_Order_By>>;
  where?: InputMaybe<Tenancy_App_Config_Bool_Exp>;
};


export type Query_RootTenancy_App_Config_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_AppletArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Bool_Exp>;
};


export type Query_RootTenancy_Applet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Bool_Exp>;
};


export type Query_RootTenancy_Applet_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Applet_InstanceArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Instance_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
};


export type Query_RootTenancy_Applet_Instance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Instance_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
};


export type Query_RootTenancy_Applet_Instance_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Applet_VersionArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Version_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
};


export type Query_RootTenancy_Applet_Version_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Version_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
};


export type Query_RootTenancy_Applet_Version_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Audit_Logs_Order_By>>;
  where?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
};


export type Query_RootTenancy_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Audit_Logs_Order_By>>;
  where?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
};


export type Query_RootTenancy_Audit_Logs_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Auth_MethodArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Auth_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Auth_Method_Order_By>>;
  where?: InputMaybe<Tenancy_Auth_Method_Bool_Exp>;
};


export type Query_RootTenancy_Auth_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Auth_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Auth_Method_Order_By>>;
  where?: InputMaybe<Tenancy_Auth_Method_Bool_Exp>;
};


export type Query_RootTenancy_Auth_Method_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_ConditionArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Condition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Condition_Order_By>>;
  where?: InputMaybe<Tenancy_Condition_Bool_Exp>;
};


export type Query_RootTenancy_Condition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Condition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Condition_Order_By>>;
  where?: InputMaybe<Tenancy_Condition_Bool_Exp>;
};


export type Query_RootTenancy_Condition_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_CountryArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Country_Order_By>>;
  where?: InputMaybe<Tenancy_Country_Bool_Exp>;
};


export type Query_RootTenancy_Country_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Country_Order_By>>;
  where?: InputMaybe<Tenancy_Country_Bool_Exp>;
};


export type Query_RootTenancy_Country_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Custom_Auth_MethodArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Order_By>>;
  where?: InputMaybe<Tenancy_Custom_Auth_Method_Bool_Exp>;
};


export type Query_RootTenancy_Custom_Auth_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Order_By>>;
  where?: InputMaybe<Tenancy_Custom_Auth_Method_Bool_Exp>;
};


export type Query_RootTenancy_Custom_Auth_Method_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_DomainArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Domain_Order_By>>;
  where?: InputMaybe<Tenancy_Domain_Bool_Exp>;
};


export type Query_RootTenancy_Domain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Domain_Order_By>>;
  where?: InputMaybe<Tenancy_Domain_Bool_Exp>;
};


export type Query_RootTenancy_Domain_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_EnvironmentArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Environment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Environment_Order_By>>;
  where?: InputMaybe<Tenancy_Environment_Bool_Exp>;
};


export type Query_RootTenancy_Environment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Environment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Environment_Order_By>>;
  where?: InputMaybe<Tenancy_Environment_Bool_Exp>;
};


export type Query_RootTenancy_Environment_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Failed_Kafka_EventsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Failed_Kafka_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Failed_Kafka_Events_Order_By>>;
  where?: InputMaybe<Tenancy_Failed_Kafka_Events_Bool_Exp>;
};


export type Query_RootTenancy_Failed_Kafka_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Failed_Kafka_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Failed_Kafka_Events_Order_By>>;
  where?: InputMaybe<Tenancy_Failed_Kafka_Events_Bool_Exp>;
};


export type Query_RootTenancy_Failed_Kafka_Events_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_FileArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


export type Query_RootTenancy_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


export type Query_RootTenancy_File_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Llm_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Llm_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Llm_Credentials_Order_By>>;
  where?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
};


export type Query_RootTenancy_Llm_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Llm_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Llm_Credentials_Order_By>>;
  where?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
};


export type Query_RootTenancy_Llm_Credentials_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Llm_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Llm_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Llm_Providers_Order_By>>;
  where?: InputMaybe<Tenancy_Llm_Providers_Bool_Exp>;
};


export type Query_RootTenancy_Llm_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Llm_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Llm_Providers_Order_By>>;
  where?: InputMaybe<Tenancy_Llm_Providers_Bool_Exp>;
};


export type Query_RootTenancy_Llm_Providers_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_LocaleArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Locale_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Locale_Order_By>>;
  where?: InputMaybe<Tenancy_Locale_Bool_Exp>;
};


export type Query_RootTenancy_Locale_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Locale_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Locale_Order_By>>;
  where?: InputMaybe<Tenancy_Locale_Bool_Exp>;
};


export type Query_RootTenancy_Locale_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Localization_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};


export type Query_RootTenancy_Localization_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};


export type Query_RootTenancy_Localization_Settings_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Node_Type_Enum_PsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Bool_Exp>;
};


export type Query_RootTenancy_Node_Type_Enum_Ps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Bool_Exp>;
};


export type Query_RootTenancy_Node_Type_Enum_Ps_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTenancy_PackageArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Package_Order_By>>;
  where?: InputMaybe<Tenancy_Package_Bool_Exp>;
};


export type Query_RootTenancy_Package_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Package_Order_By>>;
  where?: InputMaybe<Tenancy_Package_Bool_Exp>;
};


export type Query_RootTenancy_Package_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Package_VersionArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Package_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Package_Version_Order_By>>;
  where?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
};


export type Query_RootTenancy_Package_Version_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Package_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Package_Version_Order_By>>;
  where?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
};


export type Query_RootTenancy_Package_Version_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Pro_Studio_Performance_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pro_Studio_Performance_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pro_Studio_Performance_Metrics_Order_By>>;
  where?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp>;
};


export type Query_RootTenancy_Pro_Studio_Performance_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pro_Studio_Performance_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pro_Studio_Performance_Metrics_Order_By>>;
  where?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp>;
};


export type Query_RootTenancy_Pro_Studio_Performance_Metrics_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Products_Order_By>>;
  where?: InputMaybe<Tenancy_Products_Bool_Exp>;
};


export type Query_RootTenancy_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Products_Order_By>>;
  where?: InputMaybe<Tenancy_Products_Bool_Exp>;
};


export type Query_RootTenancy_Products_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Project_Environment_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
};


export type Query_RootTenancy_Project_Environment_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
};


export type Query_RootTenancy_Project_Environment_Config_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Project_Pro_Studio_SettingArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
};


export type Query_RootTenancy_Project_Pro_Studio_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
};


export type Query_RootTenancy_Project_Pro_Studio_Setting_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Project_Product_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Product_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Product_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
};


export type Query_RootTenancy_Project_Product_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Product_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Product_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
};


export type Query_RootTenancy_Project_Product_Settings_By_PkArgs = {
  productId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootTenancy_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Projects_Bool_Exp>;
};


export type Query_RootTenancy_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Projects_Bool_Exp>;
};


export type Query_RootTenancy_Projects_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Pype_ConnectionArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Connection_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Bool_Exp>;
};


export type Query_RootTenancy_Pype_Connection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Connection_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Bool_Exp>;
};


export type Query_RootTenancy_Pype_Connection_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Pype_Connection_PypeArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Pype_Bool_Exp>;
};


export type Query_RootTenancy_Pype_Connection_Pype_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Pype_Bool_Exp>;
};


export type Query_RootTenancy_Pype_Connection_Pype_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Pype_RuleArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Bool_Exp>;
};


export type Query_RootTenancy_Pype_Rule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Bool_Exp>;
};


export type Query_RootTenancy_Pype_Rule_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Pype_Rule_GroupArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
};


export type Query_RootTenancy_Pype_Rule_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
};


export type Query_RootTenancy_Pype_Rule_Group_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Pype_Rule_Group_PypeArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>;
};


export type Query_RootTenancy_Pype_Rule_Group_Pype_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>;
};


export type Query_RootTenancy_Pype_Rule_Group_Pype_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Rich_Asset_Type_Enum_PsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp>;
};


export type Query_RootTenancy_Rich_Asset_Type_Enum_Ps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp>;
};


export type Query_RootTenancy_Rich_Asset_Type_Enum_Ps_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTenancy_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Roles_Order_By>>;
  where?: InputMaybe<Tenancy_Roles_Bool_Exp>;
};


export type Query_RootTenancy_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Roles_Order_By>>;
  where?: InputMaybe<Tenancy_Roles_Bool_Exp>;
};


export type Query_RootTenancy_Roles_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Solution_Deployment_Run_WorkflowsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Deployment_Run_Workflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Deployment_Run_Workflows_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Solution_Deployment_RunsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Runs_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Deployment_Runs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Runs_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Deployment_Runs_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Solution_DeploymentsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployments_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Deployments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployments_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Deployments_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Solution_TaskArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Task_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Task_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Task_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Task_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Task_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Task_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Solution_User_PresenceArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_User_Presence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_User_Presence_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
};


export type Query_RootTenancy_Solution_User_Presence_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_User_Presence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_User_Presence_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
};


export type Query_RootTenancy_Solution_User_Presence_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Solution_Version_Nodes_PsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Version_Nodes_Ps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Version_Nodes_Ps_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Solution_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Versions_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Solution_Versions_PsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Versions_Ps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
};


export type Query_RootTenancy_Solution_Versions_Ps_By_PkArgs = {
  solutionVersionId: Scalars['String']['input'];
};


export type Query_RootTenancy_SolutionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solutions_Order_By>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};


export type Query_RootTenancy_Solutions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solutions_Order_By>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};


export type Query_RootTenancy_Solutions_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Studio_ResourceArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Studio_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Studio_Resource_Order_By>>;
  where?: InputMaybe<Tenancy_Studio_Resource_Bool_Exp>;
};


export type Query_RootTenancy_Studio_Resource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Studio_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Studio_Resource_Order_By>>;
  where?: InputMaybe<Tenancy_Studio_Resource_Bool_Exp>;
};


export type Query_RootTenancy_Studio_Resource_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Team_Account_Environment_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
};


export type Query_RootTenancy_Team_Account_Environment_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
};


export type Query_RootTenancy_Team_Account_Environment_Config_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Team_Account_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
};


export type Query_RootTenancy_Team_Account_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
};


export type Query_RootTenancy_Team_Account_Projects_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Team_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
};


export type Query_RootTenancy_Team_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
};


export type Query_RootTenancy_Team_Accounts_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Teams_Order_By>>;
  where?: InputMaybe<Tenancy_Teams_Bool_Exp>;
};


export type Query_RootTenancy_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Teams_Order_By>>;
  where?: InputMaybe<Tenancy_Teams_Bool_Exp>;
};


export type Query_RootTenancy_Teams_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Template_NodeArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Template_Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Template_Node_Order_By>>;
  where?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
};


export type Query_RootTenancy_Template_Node_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Template_Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Template_Node_Order_By>>;
  where?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
};


export type Query_RootTenancy_Template_Node_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_Time_ZoneArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Time_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Time_Zone_Order_By>>;
  where?: InputMaybe<Tenancy_Time_Zone_Bool_Exp>;
};


export type Query_RootTenancy_Time_Zone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Time_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Time_Zone_Order_By>>;
  where?: InputMaybe<Tenancy_Time_Zone_Bool_Exp>;
};


export type Query_RootTenancy_Time_Zone_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_TriggerArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Trigger_Order_By>>;
  where?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
};


export type Query_RootTenancy_Trigger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Trigger_Order_By>>;
  where?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
};


export type Query_RootTenancy_Trigger_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_User_Account_Auth_Method_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
};


export type Query_RootTenancy_User_Account_Auth_Method_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
};


export type Query_RootTenancy_User_Account_Auth_Method_Settings_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_User_Account_Environment_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
};


export type Query_RootTenancy_User_Account_Environment_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
};


export type Query_RootTenancy_User_Account_Environment_Config_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_User_Account_Project_Metabase_AccessArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
};


export type Query_RootTenancy_User_Account_Project_Metabase_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
};


export type Query_RootTenancy_User_Account_Project_Metabase_Access_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_User_Account_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
};


export type Query_RootTenancy_User_Account_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
};


export type Query_RootTenancy_User_Account_Projects_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_User_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};


export type Query_RootTenancy_User_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};


export type Query_RootTenancy_User_Accounts_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_UsersArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Users_Order_By>>;
  where?: InputMaybe<Tenancy_Users_Bool_Exp>;
};


export type Query_RootTenancy_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Users_Order_By>>;
  where?: InputMaybe<Tenancy_Users_Bool_Exp>;
};


export type Query_RootTenancy_Users_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTenancy_VariableArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Variable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Variable_Order_By>>;
  where?: InputMaybe<Tenancy_Variable_Bool_Exp>;
};


export type Query_RootTenancy_Variable_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Variable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Variable_Order_By>>;
  where?: InputMaybe<Tenancy_Variable_Bool_Exp>;
};


export type Query_RootTenancy_Variable_By_PkArgs = {
  id: Scalars['String']['input'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  admin_?: Maybe<Admin_Subscription>;
  app_loader_?: Maybe<App_Loader_Subscription_Root>;
  /** fetch data from the table: "tenancy._ProjectEnvironmentConfigToVariable" */
  tenancy__ProjectEnvironmentConfigToVariable: Array<Tenancy__ProjectEnvironmentConfigToVariable>;
  /** fetch aggregated fields from the table: "tenancy._ProjectEnvironmentConfigToVariable" */
  tenancy__ProjectEnvironmentConfigToVariable_aggregate: Tenancy__ProjectEnvironmentConfigToVariable_Aggregate;
  /** fetch data from the table in a streaming manner: "tenancy._ProjectEnvironmentConfigToVariable" */
  tenancy__ProjectEnvironmentConfigToVariable_stream: Array<Tenancy__ProjectEnvironmentConfigToVariable>;
  /** fetch data from the table: "tenancy._prisma_migrations" */
  tenancy__prisma_migrations: Array<Tenancy__Prisma_Migrations>;
  /** fetch aggregated fields from the table: "tenancy._prisma_migrations" */
  tenancy__prisma_migrations_aggregate: Tenancy__Prisma_Migrations_Aggregate;
  /** fetch data from the table: "tenancy._prisma_migrations" using primary key columns */
  tenancy__prisma_migrations_by_pk?: Maybe<Tenancy__Prisma_Migrations>;
  /** fetch data from the table in a streaming manner: "tenancy._prisma_migrations" */
  tenancy__prisma_migrations_stream: Array<Tenancy__Prisma_Migrations>;
  /** fetch data from the table: "tenancy._role_projects" */
  tenancy__role_projects: Array<Tenancy__Role_Projects>;
  /** fetch aggregated fields from the table: "tenancy._role_projects" */
  tenancy__role_projects_aggregate: Tenancy__Role_Projects_Aggregate;
  /** fetch data from the table in a streaming manner: "tenancy._role_projects" */
  tenancy__role_projects_stream: Array<Tenancy__Role_Projects>;
  /** fetch data from the table: "tenancy._team_account_environment_config_roles" */
  tenancy__team_account_environment_config_roles: Array<Tenancy__Team_Account_Environment_Config_Roles>;
  /** fetch aggregated fields from the table: "tenancy._team_account_environment_config_roles" */
  tenancy__team_account_environment_config_roles_aggregate: Tenancy__Team_Account_Environment_Config_Roles_Aggregate;
  /** fetch data from the table in a streaming manner: "tenancy._team_account_environment_config_roles" */
  tenancy__team_account_environment_config_roles_stream: Array<Tenancy__Team_Account_Environment_Config_Roles>;
  /** fetch data from the table: "tenancy._team_account_project_roles" */
  tenancy__team_account_project_roles: Array<Tenancy__Team_Account_Project_Roles>;
  /** fetch aggregated fields from the table: "tenancy._team_account_project_roles" */
  tenancy__team_account_project_roles_aggregate: Tenancy__Team_Account_Project_Roles_Aggregate;
  /** fetch data from the table in a streaming manner: "tenancy._team_account_project_roles" */
  tenancy__team_account_project_roles_stream: Array<Tenancy__Team_Account_Project_Roles>;
  /** fetch data from the table: "tenancy._team_account_roles" */
  tenancy__team_account_roles: Array<Tenancy__Team_Account_Roles>;
  /** fetch aggregated fields from the table: "tenancy._team_account_roles" */
  tenancy__team_account_roles_aggregate: Tenancy__Team_Account_Roles_Aggregate;
  /** fetch data from the table in a streaming manner: "tenancy._team_account_roles" */
  tenancy__team_account_roles_stream: Array<Tenancy__Team_Account_Roles>;
  /** fetch data from the table: "tenancy._user_account_environment_config_roles" */
  tenancy__user_account_environment_config_roles: Array<Tenancy__User_Account_Environment_Config_Roles>;
  /** fetch aggregated fields from the table: "tenancy._user_account_environment_config_roles" */
  tenancy__user_account_environment_config_roles_aggregate: Tenancy__User_Account_Environment_Config_Roles_Aggregate;
  /** fetch data from the table in a streaming manner: "tenancy._user_account_environment_config_roles" */
  tenancy__user_account_environment_config_roles_stream: Array<Tenancy__User_Account_Environment_Config_Roles>;
  /** fetch data from the table: "tenancy._user_account_project_roles" */
  tenancy__user_account_project_roles: Array<Tenancy__User_Account_Project_Roles>;
  /** fetch aggregated fields from the table: "tenancy._user_account_project_roles" */
  tenancy__user_account_project_roles_aggregate: Tenancy__User_Account_Project_Roles_Aggregate;
  /** fetch data from the table in a streaming manner: "tenancy._user_account_project_roles" */
  tenancy__user_account_project_roles_stream: Array<Tenancy__User_Account_Project_Roles>;
  /** fetch data from the table: "tenancy._user_account_roles" */
  tenancy__user_account_roles: Array<Tenancy__User_Account_Roles>;
  /** fetch aggregated fields from the table: "tenancy._user_account_roles" */
  tenancy__user_account_roles_aggregate: Tenancy__User_Account_Roles_Aggregate;
  /** fetch data from the table in a streaming manner: "tenancy._user_account_roles" */
  tenancy__user_account_roles_stream: Array<Tenancy__User_Account_Roles>;
  /** fetch data from the table: "tenancy._user_teams" */
  tenancy__user_teams: Array<Tenancy__User_Teams>;
  /** fetch aggregated fields from the table: "tenancy._user_teams" */
  tenancy__user_teams_aggregate: Tenancy__User_Teams_Aggregate;
  /** fetch data from the table in a streaming manner: "tenancy._user_teams" */
  tenancy__user_teams_stream: Array<Tenancy__User_Teams>;
  /** fetch data from the table: "tenancy.account_auth_method_settings" */
  tenancy_account_auth_method_settings: Array<Tenancy_Account_Auth_Method_Settings>;
  /** fetch aggregated fields from the table: "tenancy.account_auth_method_settings" */
  tenancy_account_auth_method_settings_aggregate: Tenancy_Account_Auth_Method_Settings_Aggregate;
  /** fetch data from the table: "tenancy.account_auth_method_settings" using primary key columns */
  tenancy_account_auth_method_settings_by_pk?: Maybe<Tenancy_Account_Auth_Method_Settings>;
  /** fetch data from the table in a streaming manner: "tenancy.account_auth_method_settings" */
  tenancy_account_auth_method_settings_stream: Array<Tenancy_Account_Auth_Method_Settings>;
  /** fetch data from the table: "tenancy.accounts" */
  tenancy_accounts: Array<Tenancy_Accounts>;
  /** fetch aggregated fields from the table: "tenancy.accounts" */
  tenancy_accounts_aggregate: Tenancy_Accounts_Aggregate;
  /** fetch data from the table: "tenancy.accounts" using primary key columns */
  tenancy_accounts_by_pk?: Maybe<Tenancy_Accounts>;
  /** fetch data from the table in a streaming manner: "tenancy.accounts" */
  tenancy_accounts_stream: Array<Tenancy_Accounts>;
  /** fetch data from the table: "tenancy.action" */
  tenancy_action: Array<Tenancy_Action>;
  /** fetch aggregated fields from the table: "tenancy.action" */
  tenancy_action_aggregate: Tenancy_Action_Aggregate;
  /** fetch data from the table: "tenancy.action" using primary key columns */
  tenancy_action_by_pk?: Maybe<Tenancy_Action>;
  /** fetch data from the table: "tenancy.action_node_job" */
  tenancy_action_node_job: Array<Tenancy_Action_Node_Job>;
  /** fetch aggregated fields from the table: "tenancy.action_node_job" */
  tenancy_action_node_job_aggregate: Tenancy_Action_Node_Job_Aggregate;
  /** fetch data from the table: "tenancy.action_node_job" using primary key columns */
  tenancy_action_node_job_by_pk?: Maybe<Tenancy_Action_Node_Job>;
  /** fetch data from the table in a streaming manner: "tenancy.action_node_job" */
  tenancy_action_node_job_stream: Array<Tenancy_Action_Node_Job>;
  /** fetch data from the table in a streaming manner: "tenancy.action" */
  tenancy_action_stream: Array<Tenancy_Action>;
  /** fetch data from the table: "tenancy.app_config" */
  tenancy_app_config: Array<Tenancy_App_Config>;
  /** fetch aggregated fields from the table: "tenancy.app_config" */
  tenancy_app_config_aggregate: Tenancy_App_Config_Aggregate;
  /** fetch data from the table: "tenancy.app_config" using primary key columns */
  tenancy_app_config_by_pk?: Maybe<Tenancy_App_Config>;
  /** fetch data from the table in a streaming manner: "tenancy.app_config" */
  tenancy_app_config_stream: Array<Tenancy_App_Config>;
  /** fetch data from the table: "tenancy.applet" */
  tenancy_applet: Array<Tenancy_Applet>;
  /** fetch aggregated fields from the table: "tenancy.applet" */
  tenancy_applet_aggregate: Tenancy_Applet_Aggregate;
  /** fetch data from the table: "tenancy.applet" using primary key columns */
  tenancy_applet_by_pk?: Maybe<Tenancy_Applet>;
  /** fetch data from the table: "tenancy.applet_instance" */
  tenancy_applet_instance: Array<Tenancy_Applet_Instance>;
  /** fetch aggregated fields from the table: "tenancy.applet_instance" */
  tenancy_applet_instance_aggregate: Tenancy_Applet_Instance_Aggregate;
  /** fetch data from the table: "tenancy.applet_instance" using primary key columns */
  tenancy_applet_instance_by_pk?: Maybe<Tenancy_Applet_Instance>;
  /** fetch data from the table in a streaming manner: "tenancy.applet_instance" */
  tenancy_applet_instance_stream: Array<Tenancy_Applet_Instance>;
  /** fetch data from the table in a streaming manner: "tenancy.applet" */
  tenancy_applet_stream: Array<Tenancy_Applet>;
  /** fetch data from the table: "tenancy.applet_version" */
  tenancy_applet_version: Array<Tenancy_Applet_Version>;
  /** fetch aggregated fields from the table: "tenancy.applet_version" */
  tenancy_applet_version_aggregate: Tenancy_Applet_Version_Aggregate;
  /** fetch data from the table: "tenancy.applet_version" using primary key columns */
  tenancy_applet_version_by_pk?: Maybe<Tenancy_Applet_Version>;
  /** fetch data from the table in a streaming manner: "tenancy.applet_version" */
  tenancy_applet_version_stream: Array<Tenancy_Applet_Version>;
  /** fetch data from the table: "tenancy.audit_logs" */
  tenancy_audit_logs: Array<Tenancy_Audit_Logs>;
  /** fetch aggregated fields from the table: "tenancy.audit_logs" */
  tenancy_audit_logs_aggregate: Tenancy_Audit_Logs_Aggregate;
  /** fetch data from the table: "tenancy.audit_logs" using primary key columns */
  tenancy_audit_logs_by_pk?: Maybe<Tenancy_Audit_Logs>;
  /** fetch data from the table in a streaming manner: "tenancy.audit_logs" */
  tenancy_audit_logs_stream: Array<Tenancy_Audit_Logs>;
  /** fetch data from the table: "tenancy.auth_method" */
  tenancy_auth_method: Array<Tenancy_Auth_Method>;
  /** fetch aggregated fields from the table: "tenancy.auth_method" */
  tenancy_auth_method_aggregate: Tenancy_Auth_Method_Aggregate;
  /** fetch data from the table: "tenancy.auth_method" using primary key columns */
  tenancy_auth_method_by_pk?: Maybe<Tenancy_Auth_Method>;
  /** fetch data from the table in a streaming manner: "tenancy.auth_method" */
  tenancy_auth_method_stream: Array<Tenancy_Auth_Method>;
  /** fetch data from the table: "tenancy.condition" */
  tenancy_condition: Array<Tenancy_Condition>;
  /** fetch aggregated fields from the table: "tenancy.condition" */
  tenancy_condition_aggregate: Tenancy_Condition_Aggregate;
  /** fetch data from the table: "tenancy.condition" using primary key columns */
  tenancy_condition_by_pk?: Maybe<Tenancy_Condition>;
  /** fetch data from the table in a streaming manner: "tenancy.condition" */
  tenancy_condition_stream: Array<Tenancy_Condition>;
  /** fetch data from the table: "tenancy.country" */
  tenancy_country: Array<Tenancy_Country>;
  /** fetch aggregated fields from the table: "tenancy.country" */
  tenancy_country_aggregate: Tenancy_Country_Aggregate;
  /** fetch data from the table: "tenancy.country" using primary key columns */
  tenancy_country_by_pk?: Maybe<Tenancy_Country>;
  /** fetch data from the table in a streaming manner: "tenancy.country" */
  tenancy_country_stream: Array<Tenancy_Country>;
  /** fetch data from the table: "tenancy.custom_auth_method" */
  tenancy_custom_auth_method: Array<Tenancy_Custom_Auth_Method>;
  /** fetch aggregated fields from the table: "tenancy.custom_auth_method" */
  tenancy_custom_auth_method_aggregate: Tenancy_Custom_Auth_Method_Aggregate;
  /** fetch data from the table: "tenancy.custom_auth_method" using primary key columns */
  tenancy_custom_auth_method_by_pk?: Maybe<Tenancy_Custom_Auth_Method>;
  /** fetch data from the table in a streaming manner: "tenancy.custom_auth_method" */
  tenancy_custom_auth_method_stream: Array<Tenancy_Custom_Auth_Method>;
  /** fetch data from the table: "tenancy.domain" */
  tenancy_domain: Array<Tenancy_Domain>;
  /** fetch aggregated fields from the table: "tenancy.domain" */
  tenancy_domain_aggregate: Tenancy_Domain_Aggregate;
  /** fetch data from the table: "tenancy.domain" using primary key columns */
  tenancy_domain_by_pk?: Maybe<Tenancy_Domain>;
  /** fetch data from the table in a streaming manner: "tenancy.domain" */
  tenancy_domain_stream: Array<Tenancy_Domain>;
  /** fetch data from the table: "tenancy.environment" */
  tenancy_environment: Array<Tenancy_Environment>;
  /** fetch aggregated fields from the table: "tenancy.environment" */
  tenancy_environment_aggregate: Tenancy_Environment_Aggregate;
  /** fetch data from the table: "tenancy.environment" using primary key columns */
  tenancy_environment_by_pk?: Maybe<Tenancy_Environment>;
  /** fetch data from the table in a streaming manner: "tenancy.environment" */
  tenancy_environment_stream: Array<Tenancy_Environment>;
  /** fetch data from the table: "tenancy.failed_kafka_events" */
  tenancy_failed_kafka_events: Array<Tenancy_Failed_Kafka_Events>;
  /** fetch aggregated fields from the table: "tenancy.failed_kafka_events" */
  tenancy_failed_kafka_events_aggregate: Tenancy_Failed_Kafka_Events_Aggregate;
  /** fetch data from the table: "tenancy.failed_kafka_events" using primary key columns */
  tenancy_failed_kafka_events_by_pk?: Maybe<Tenancy_Failed_Kafka_Events>;
  /** fetch data from the table in a streaming manner: "tenancy.failed_kafka_events" */
  tenancy_failed_kafka_events_stream: Array<Tenancy_Failed_Kafka_Events>;
  /** fetch data from the table: "tenancy.file" */
  tenancy_file: Array<Tenancy_File>;
  /** fetch aggregated fields from the table: "tenancy.file" */
  tenancy_file_aggregate: Tenancy_File_Aggregate;
  /** fetch data from the table: "tenancy.file" using primary key columns */
  tenancy_file_by_pk?: Maybe<Tenancy_File>;
  /** fetch data from the table in a streaming manner: "tenancy.file" */
  tenancy_file_stream: Array<Tenancy_File>;
  /** fetch data from the table: "tenancy.llm_credentials" */
  tenancy_llm_credentials: Array<Tenancy_Llm_Credentials>;
  /** fetch aggregated fields from the table: "tenancy.llm_credentials" */
  tenancy_llm_credentials_aggregate: Tenancy_Llm_Credentials_Aggregate;
  /** fetch data from the table: "tenancy.llm_credentials" using primary key columns */
  tenancy_llm_credentials_by_pk?: Maybe<Tenancy_Llm_Credentials>;
  /** fetch data from the table in a streaming manner: "tenancy.llm_credentials" */
  tenancy_llm_credentials_stream: Array<Tenancy_Llm_Credentials>;
  /** fetch data from the table: "tenancy.llm_providers" */
  tenancy_llm_providers: Array<Tenancy_Llm_Providers>;
  /** fetch aggregated fields from the table: "tenancy.llm_providers" */
  tenancy_llm_providers_aggregate: Tenancy_Llm_Providers_Aggregate;
  /** fetch data from the table: "tenancy.llm_providers" using primary key columns */
  tenancy_llm_providers_by_pk?: Maybe<Tenancy_Llm_Providers>;
  /** fetch data from the table in a streaming manner: "tenancy.llm_providers" */
  tenancy_llm_providers_stream: Array<Tenancy_Llm_Providers>;
  /** fetch data from the table: "tenancy.locale" */
  tenancy_locale: Array<Tenancy_Locale>;
  /** fetch aggregated fields from the table: "tenancy.locale" */
  tenancy_locale_aggregate: Tenancy_Locale_Aggregate;
  /** fetch data from the table: "tenancy.locale" using primary key columns */
  tenancy_locale_by_pk?: Maybe<Tenancy_Locale>;
  /** fetch data from the table in a streaming manner: "tenancy.locale" */
  tenancy_locale_stream: Array<Tenancy_Locale>;
  /** fetch data from the table: "tenancy.localization_settings" */
  tenancy_localization_settings: Array<Tenancy_Localization_Settings>;
  /** fetch aggregated fields from the table: "tenancy.localization_settings" */
  tenancy_localization_settings_aggregate: Tenancy_Localization_Settings_Aggregate;
  /** fetch data from the table: "tenancy.localization_settings" using primary key columns */
  tenancy_localization_settings_by_pk?: Maybe<Tenancy_Localization_Settings>;
  /** fetch data from the table in a streaming manner: "tenancy.localization_settings" */
  tenancy_localization_settings_stream: Array<Tenancy_Localization_Settings>;
  /** fetch data from the table: "tenancy.node_type_enum_ps" */
  tenancy_node_type_enum_ps: Array<Tenancy_Node_Type_Enum_Ps>;
  /** fetch aggregated fields from the table: "tenancy.node_type_enum_ps" */
  tenancy_node_type_enum_ps_aggregate: Tenancy_Node_Type_Enum_Ps_Aggregate;
  /** fetch data from the table: "tenancy.node_type_enum_ps" using primary key columns */
  tenancy_node_type_enum_ps_by_pk?: Maybe<Tenancy_Node_Type_Enum_Ps>;
  /** fetch data from the table in a streaming manner: "tenancy.node_type_enum_ps" */
  tenancy_node_type_enum_ps_stream: Array<Tenancy_Node_Type_Enum_Ps>;
  /** fetch data from the table: "tenancy.package" */
  tenancy_package: Array<Tenancy_Package>;
  /** fetch aggregated fields from the table: "tenancy.package" */
  tenancy_package_aggregate: Tenancy_Package_Aggregate;
  /** fetch data from the table: "tenancy.package" using primary key columns */
  tenancy_package_by_pk?: Maybe<Tenancy_Package>;
  /** fetch data from the table in a streaming manner: "tenancy.package" */
  tenancy_package_stream: Array<Tenancy_Package>;
  /** fetch data from the table: "tenancy.package_version" */
  tenancy_package_version: Array<Tenancy_Package_Version>;
  /** fetch aggregated fields from the table: "tenancy.package_version" */
  tenancy_package_version_aggregate: Tenancy_Package_Version_Aggregate;
  /** fetch data from the table: "tenancy.package_version" using primary key columns */
  tenancy_package_version_by_pk?: Maybe<Tenancy_Package_Version>;
  /** fetch data from the table in a streaming manner: "tenancy.package_version" */
  tenancy_package_version_stream: Array<Tenancy_Package_Version>;
  /** fetch data from the table: "tenancy.pro_studio_performance_metrics" */
  tenancy_pro_studio_performance_metrics: Array<Tenancy_Pro_Studio_Performance_Metrics>;
  /** fetch aggregated fields from the table: "tenancy.pro_studio_performance_metrics" */
  tenancy_pro_studio_performance_metrics_aggregate: Tenancy_Pro_Studio_Performance_Metrics_Aggregate;
  /** fetch data from the table: "tenancy.pro_studio_performance_metrics" using primary key columns */
  tenancy_pro_studio_performance_metrics_by_pk?: Maybe<Tenancy_Pro_Studio_Performance_Metrics>;
  /** fetch data from the table in a streaming manner: "tenancy.pro_studio_performance_metrics" */
  tenancy_pro_studio_performance_metrics_stream: Array<Tenancy_Pro_Studio_Performance_Metrics>;
  /** fetch data from the table: "tenancy.products" */
  tenancy_products: Array<Tenancy_Products>;
  /** fetch aggregated fields from the table: "tenancy.products" */
  tenancy_products_aggregate: Tenancy_Products_Aggregate;
  /** fetch data from the table: "tenancy.products" using primary key columns */
  tenancy_products_by_pk?: Maybe<Tenancy_Products>;
  /** fetch data from the table in a streaming manner: "tenancy.products" */
  tenancy_products_stream: Array<Tenancy_Products>;
  /** fetch data from the table: "tenancy.project_environment_config" */
  tenancy_project_environment_config: Array<Tenancy_Project_Environment_Config>;
  /** fetch aggregated fields from the table: "tenancy.project_environment_config" */
  tenancy_project_environment_config_aggregate: Tenancy_Project_Environment_Config_Aggregate;
  /** fetch data from the table: "tenancy.project_environment_config" using primary key columns */
  tenancy_project_environment_config_by_pk?: Maybe<Tenancy_Project_Environment_Config>;
  /** fetch data from the table in a streaming manner: "tenancy.project_environment_config" */
  tenancy_project_environment_config_stream: Array<Tenancy_Project_Environment_Config>;
  /** fetch data from the table: "tenancy.project_pro_studio_setting" */
  tenancy_project_pro_studio_setting: Array<Tenancy_Project_Pro_Studio_Setting>;
  /** fetch aggregated fields from the table: "tenancy.project_pro_studio_setting" */
  tenancy_project_pro_studio_setting_aggregate: Tenancy_Project_Pro_Studio_Setting_Aggregate;
  /** fetch data from the table: "tenancy.project_pro_studio_setting" using primary key columns */
  tenancy_project_pro_studio_setting_by_pk?: Maybe<Tenancy_Project_Pro_Studio_Setting>;
  /** fetch data from the table in a streaming manner: "tenancy.project_pro_studio_setting" */
  tenancy_project_pro_studio_setting_stream: Array<Tenancy_Project_Pro_Studio_Setting>;
  /** fetch data from the table: "tenancy.project_product_settings" */
  tenancy_project_product_settings: Array<Tenancy_Project_Product_Settings>;
  /** fetch aggregated fields from the table: "tenancy.project_product_settings" */
  tenancy_project_product_settings_aggregate: Tenancy_Project_Product_Settings_Aggregate;
  /** fetch data from the table: "tenancy.project_product_settings" using primary key columns */
  tenancy_project_product_settings_by_pk?: Maybe<Tenancy_Project_Product_Settings>;
  /** fetch data from the table in a streaming manner: "tenancy.project_product_settings" */
  tenancy_project_product_settings_stream: Array<Tenancy_Project_Product_Settings>;
  /** fetch data from the table: "tenancy.projects" */
  tenancy_projects: Array<Tenancy_Projects>;
  /** fetch aggregated fields from the table: "tenancy.projects" */
  tenancy_projects_aggregate: Tenancy_Projects_Aggregate;
  /** fetch data from the table: "tenancy.projects" using primary key columns */
  tenancy_projects_by_pk?: Maybe<Tenancy_Projects>;
  /** fetch data from the table in a streaming manner: "tenancy.projects" */
  tenancy_projects_stream: Array<Tenancy_Projects>;
  /** fetch data from the table: "tenancy.pype_connection" */
  tenancy_pype_connection: Array<Tenancy_Pype_Connection>;
  /** fetch aggregated fields from the table: "tenancy.pype_connection" */
  tenancy_pype_connection_aggregate: Tenancy_Pype_Connection_Aggregate;
  /** fetch data from the table: "tenancy.pype_connection" using primary key columns */
  tenancy_pype_connection_by_pk?: Maybe<Tenancy_Pype_Connection>;
  /** fetch data from the table: "tenancy.pype_connection_pype" */
  tenancy_pype_connection_pype: Array<Tenancy_Pype_Connection_Pype>;
  /** fetch aggregated fields from the table: "tenancy.pype_connection_pype" */
  tenancy_pype_connection_pype_aggregate: Tenancy_Pype_Connection_Pype_Aggregate;
  /** fetch data from the table: "tenancy.pype_connection_pype" using primary key columns */
  tenancy_pype_connection_pype_by_pk?: Maybe<Tenancy_Pype_Connection_Pype>;
  /** fetch data from the table in a streaming manner: "tenancy.pype_connection_pype" */
  tenancy_pype_connection_pype_stream: Array<Tenancy_Pype_Connection_Pype>;
  /** fetch data from the table in a streaming manner: "tenancy.pype_connection" */
  tenancy_pype_connection_stream: Array<Tenancy_Pype_Connection>;
  /** fetch data from the table: "tenancy.pype_rule" */
  tenancy_pype_rule: Array<Tenancy_Pype_Rule>;
  /** fetch aggregated fields from the table: "tenancy.pype_rule" */
  tenancy_pype_rule_aggregate: Tenancy_Pype_Rule_Aggregate;
  /** fetch data from the table: "tenancy.pype_rule" using primary key columns */
  tenancy_pype_rule_by_pk?: Maybe<Tenancy_Pype_Rule>;
  /** fetch data from the table: "tenancy.pype_rule_group" */
  tenancy_pype_rule_group: Array<Tenancy_Pype_Rule_Group>;
  /** fetch aggregated fields from the table: "tenancy.pype_rule_group" */
  tenancy_pype_rule_group_aggregate: Tenancy_Pype_Rule_Group_Aggregate;
  /** fetch data from the table: "tenancy.pype_rule_group" using primary key columns */
  tenancy_pype_rule_group_by_pk?: Maybe<Tenancy_Pype_Rule_Group>;
  /** fetch data from the table: "tenancy.pype_rule_group_pype" */
  tenancy_pype_rule_group_pype: Array<Tenancy_Pype_Rule_Group_Pype>;
  /** fetch aggregated fields from the table: "tenancy.pype_rule_group_pype" */
  tenancy_pype_rule_group_pype_aggregate: Tenancy_Pype_Rule_Group_Pype_Aggregate;
  /** fetch data from the table: "tenancy.pype_rule_group_pype" using primary key columns */
  tenancy_pype_rule_group_pype_by_pk?: Maybe<Tenancy_Pype_Rule_Group_Pype>;
  /** fetch data from the table in a streaming manner: "tenancy.pype_rule_group_pype" */
  tenancy_pype_rule_group_pype_stream: Array<Tenancy_Pype_Rule_Group_Pype>;
  /** fetch data from the table in a streaming manner: "tenancy.pype_rule_group" */
  tenancy_pype_rule_group_stream: Array<Tenancy_Pype_Rule_Group>;
  /** fetch data from the table in a streaming manner: "tenancy.pype_rule" */
  tenancy_pype_rule_stream: Array<Tenancy_Pype_Rule>;
  /** fetch data from the table: "tenancy.rich_asset_type_enum_ps" */
  tenancy_rich_asset_type_enum_ps: Array<Tenancy_Rich_Asset_Type_Enum_Ps>;
  /** fetch aggregated fields from the table: "tenancy.rich_asset_type_enum_ps" */
  tenancy_rich_asset_type_enum_ps_aggregate: Tenancy_Rich_Asset_Type_Enum_Ps_Aggregate;
  /** fetch data from the table: "tenancy.rich_asset_type_enum_ps" using primary key columns */
  tenancy_rich_asset_type_enum_ps_by_pk?: Maybe<Tenancy_Rich_Asset_Type_Enum_Ps>;
  /** fetch data from the table in a streaming manner: "tenancy.rich_asset_type_enum_ps" */
  tenancy_rich_asset_type_enum_ps_stream: Array<Tenancy_Rich_Asset_Type_Enum_Ps>;
  /** fetch data from the table: "tenancy.roles" */
  tenancy_roles: Array<Tenancy_Roles>;
  /** fetch aggregated fields from the table: "tenancy.roles" */
  tenancy_roles_aggregate: Tenancy_Roles_Aggregate;
  /** fetch data from the table: "tenancy.roles" using primary key columns */
  tenancy_roles_by_pk?: Maybe<Tenancy_Roles>;
  /** fetch data from the table in a streaming manner: "tenancy.roles" */
  tenancy_roles_stream: Array<Tenancy_Roles>;
  /** fetch data from the table: "tenancy.solution_deployment_run_workflows" */
  tenancy_solution_deployment_run_workflows: Array<Tenancy_Solution_Deployment_Run_Workflows>;
  /** fetch aggregated fields from the table: "tenancy.solution_deployment_run_workflows" */
  tenancy_solution_deployment_run_workflows_aggregate: Tenancy_Solution_Deployment_Run_Workflows_Aggregate;
  /** fetch data from the table: "tenancy.solution_deployment_run_workflows" using primary key columns */
  tenancy_solution_deployment_run_workflows_by_pk?: Maybe<Tenancy_Solution_Deployment_Run_Workflows>;
  /** fetch data from the table in a streaming manner: "tenancy.solution_deployment_run_workflows" */
  tenancy_solution_deployment_run_workflows_stream: Array<Tenancy_Solution_Deployment_Run_Workflows>;
  /** fetch data from the table: "tenancy.solution_deployment_runs" */
  tenancy_solution_deployment_runs: Array<Tenancy_Solution_Deployment_Runs>;
  /** fetch aggregated fields from the table: "tenancy.solution_deployment_runs" */
  tenancy_solution_deployment_runs_aggregate: Tenancy_Solution_Deployment_Runs_Aggregate;
  /** fetch data from the table: "tenancy.solution_deployment_runs" using primary key columns */
  tenancy_solution_deployment_runs_by_pk?: Maybe<Tenancy_Solution_Deployment_Runs>;
  /** fetch data from the table in a streaming manner: "tenancy.solution_deployment_runs" */
  tenancy_solution_deployment_runs_stream: Array<Tenancy_Solution_Deployment_Runs>;
  /** fetch data from the table: "tenancy.solution_deployments" */
  tenancy_solution_deployments: Array<Tenancy_Solution_Deployments>;
  /** fetch aggregated fields from the table: "tenancy.solution_deployments" */
  tenancy_solution_deployments_aggregate: Tenancy_Solution_Deployments_Aggregate;
  /** fetch data from the table: "tenancy.solution_deployments" using primary key columns */
  tenancy_solution_deployments_by_pk?: Maybe<Tenancy_Solution_Deployments>;
  /** fetch data from the table in a streaming manner: "tenancy.solution_deployments" */
  tenancy_solution_deployments_stream: Array<Tenancy_Solution_Deployments>;
  /** fetch data from the table: "tenancy.solution_task" */
  tenancy_solution_task: Array<Tenancy_Solution_Task>;
  /** fetch aggregated fields from the table: "tenancy.solution_task" */
  tenancy_solution_task_aggregate: Tenancy_Solution_Task_Aggregate;
  /** fetch data from the table: "tenancy.solution_task" using primary key columns */
  tenancy_solution_task_by_pk?: Maybe<Tenancy_Solution_Task>;
  /** fetch data from the table in a streaming manner: "tenancy.solution_task" */
  tenancy_solution_task_stream: Array<Tenancy_Solution_Task>;
  /** fetch data from the table: "tenancy.solution_user_presence" */
  tenancy_solution_user_presence: Array<Tenancy_Solution_User_Presence>;
  /** fetch aggregated fields from the table: "tenancy.solution_user_presence" */
  tenancy_solution_user_presence_aggregate: Tenancy_Solution_User_Presence_Aggregate;
  /** fetch data from the table: "tenancy.solution_user_presence" using primary key columns */
  tenancy_solution_user_presence_by_pk?: Maybe<Tenancy_Solution_User_Presence>;
  /** fetch data from the table in a streaming manner: "tenancy.solution_user_presence" */
  tenancy_solution_user_presence_stream: Array<Tenancy_Solution_User_Presence>;
  /** fetch data from the table: "tenancy.solution_version_nodes_ps" */
  tenancy_solution_version_nodes_ps: Array<Tenancy_Solution_Version_Nodes_Ps>;
  /** fetch aggregated fields from the table: "tenancy.solution_version_nodes_ps" */
  tenancy_solution_version_nodes_ps_aggregate: Tenancy_Solution_Version_Nodes_Ps_Aggregate;
  /** fetch data from the table: "tenancy.solution_version_nodes_ps" using primary key columns */
  tenancy_solution_version_nodes_ps_by_pk?: Maybe<Tenancy_Solution_Version_Nodes_Ps>;
  /** fetch data from the table in a streaming manner: "tenancy.solution_version_nodes_ps" */
  tenancy_solution_version_nodes_ps_stream: Array<Tenancy_Solution_Version_Nodes_Ps>;
  /** fetch data from the table: "tenancy.solution_versions" */
  tenancy_solution_versions: Array<Tenancy_Solution_Versions>;
  /** fetch aggregated fields from the table: "tenancy.solution_versions" */
  tenancy_solution_versions_aggregate: Tenancy_Solution_Versions_Aggregate;
  /** fetch data from the table: "tenancy.solution_versions" using primary key columns */
  tenancy_solution_versions_by_pk?: Maybe<Tenancy_Solution_Versions>;
  /** fetch data from the table: "tenancy.solution_versions_ps" */
  tenancy_solution_versions_ps: Array<Tenancy_Solution_Versions_Ps>;
  /** fetch aggregated fields from the table: "tenancy.solution_versions_ps" */
  tenancy_solution_versions_ps_aggregate: Tenancy_Solution_Versions_Ps_Aggregate;
  /** fetch data from the table: "tenancy.solution_versions_ps" using primary key columns */
  tenancy_solution_versions_ps_by_pk?: Maybe<Tenancy_Solution_Versions_Ps>;
  /** fetch data from the table in a streaming manner: "tenancy.solution_versions_ps" */
  tenancy_solution_versions_ps_stream: Array<Tenancy_Solution_Versions_Ps>;
  /** fetch data from the table in a streaming manner: "tenancy.solution_versions" */
  tenancy_solution_versions_stream: Array<Tenancy_Solution_Versions>;
  /** fetch data from the table: "tenancy.solutions" */
  tenancy_solutions: Array<Tenancy_Solutions>;
  /** fetch aggregated fields from the table: "tenancy.solutions" */
  tenancy_solutions_aggregate: Tenancy_Solutions_Aggregate;
  /** fetch data from the table: "tenancy.solutions" using primary key columns */
  tenancy_solutions_by_pk?: Maybe<Tenancy_Solutions>;
  /** fetch data from the table in a streaming manner: "tenancy.solutions" */
  tenancy_solutions_stream: Array<Tenancy_Solutions>;
  /** fetch data from the table: "tenancy.studio_resource" */
  tenancy_studio_resource: Array<Tenancy_Studio_Resource>;
  /** fetch aggregated fields from the table: "tenancy.studio_resource" */
  tenancy_studio_resource_aggregate: Tenancy_Studio_Resource_Aggregate;
  /** fetch data from the table: "tenancy.studio_resource" using primary key columns */
  tenancy_studio_resource_by_pk?: Maybe<Tenancy_Studio_Resource>;
  /** fetch data from the table in a streaming manner: "tenancy.studio_resource" */
  tenancy_studio_resource_stream: Array<Tenancy_Studio_Resource>;
  /** fetch data from the table: "tenancy.team_account_environment_config" */
  tenancy_team_account_environment_config: Array<Tenancy_Team_Account_Environment_Config>;
  /** fetch aggregated fields from the table: "tenancy.team_account_environment_config" */
  tenancy_team_account_environment_config_aggregate: Tenancy_Team_Account_Environment_Config_Aggregate;
  /** fetch data from the table: "tenancy.team_account_environment_config" using primary key columns */
  tenancy_team_account_environment_config_by_pk?: Maybe<Tenancy_Team_Account_Environment_Config>;
  /** fetch data from the table in a streaming manner: "tenancy.team_account_environment_config" */
  tenancy_team_account_environment_config_stream: Array<Tenancy_Team_Account_Environment_Config>;
  /** fetch data from the table: "tenancy.team_account_projects" */
  tenancy_team_account_projects: Array<Tenancy_Team_Account_Projects>;
  /** fetch aggregated fields from the table: "tenancy.team_account_projects" */
  tenancy_team_account_projects_aggregate: Tenancy_Team_Account_Projects_Aggregate;
  /** fetch data from the table: "tenancy.team_account_projects" using primary key columns */
  tenancy_team_account_projects_by_pk?: Maybe<Tenancy_Team_Account_Projects>;
  /** fetch data from the table in a streaming manner: "tenancy.team_account_projects" */
  tenancy_team_account_projects_stream: Array<Tenancy_Team_Account_Projects>;
  /** fetch data from the table: "tenancy.team_accounts" */
  tenancy_team_accounts: Array<Tenancy_Team_Accounts>;
  /** fetch aggregated fields from the table: "tenancy.team_accounts" */
  tenancy_team_accounts_aggregate: Tenancy_Team_Accounts_Aggregate;
  /** fetch data from the table: "tenancy.team_accounts" using primary key columns */
  tenancy_team_accounts_by_pk?: Maybe<Tenancy_Team_Accounts>;
  /** fetch data from the table in a streaming manner: "tenancy.team_accounts" */
  tenancy_team_accounts_stream: Array<Tenancy_Team_Accounts>;
  /** fetch data from the table: "tenancy.teams" */
  tenancy_teams: Array<Tenancy_Teams>;
  /** fetch aggregated fields from the table: "tenancy.teams" */
  tenancy_teams_aggregate: Tenancy_Teams_Aggregate;
  /** fetch data from the table: "tenancy.teams" using primary key columns */
  tenancy_teams_by_pk?: Maybe<Tenancy_Teams>;
  /** fetch data from the table in a streaming manner: "tenancy.teams" */
  tenancy_teams_stream: Array<Tenancy_Teams>;
  /** fetch data from the table: "tenancy.template_node" */
  tenancy_template_node: Array<Tenancy_Template_Node>;
  /** fetch aggregated fields from the table: "tenancy.template_node" */
  tenancy_template_node_aggregate: Tenancy_Template_Node_Aggregate;
  /** fetch data from the table: "tenancy.template_node" using primary key columns */
  tenancy_template_node_by_pk?: Maybe<Tenancy_Template_Node>;
  /** fetch data from the table in a streaming manner: "tenancy.template_node" */
  tenancy_template_node_stream: Array<Tenancy_Template_Node>;
  /** fetch data from the table: "tenancy.time_zone" */
  tenancy_time_zone: Array<Tenancy_Time_Zone>;
  /** fetch aggregated fields from the table: "tenancy.time_zone" */
  tenancy_time_zone_aggregate: Tenancy_Time_Zone_Aggregate;
  /** fetch data from the table: "tenancy.time_zone" using primary key columns */
  tenancy_time_zone_by_pk?: Maybe<Tenancy_Time_Zone>;
  /** fetch data from the table in a streaming manner: "tenancy.time_zone" */
  tenancy_time_zone_stream: Array<Tenancy_Time_Zone>;
  /** fetch data from the table: "tenancy.trigger" */
  tenancy_trigger: Array<Tenancy_Trigger>;
  /** fetch aggregated fields from the table: "tenancy.trigger" */
  tenancy_trigger_aggregate: Tenancy_Trigger_Aggregate;
  /** fetch data from the table: "tenancy.trigger" using primary key columns */
  tenancy_trigger_by_pk?: Maybe<Tenancy_Trigger>;
  /** fetch data from the table in a streaming manner: "tenancy.trigger" */
  tenancy_trigger_stream: Array<Tenancy_Trigger>;
  /** fetch data from the table: "tenancy.user_account_auth_method_settings" */
  tenancy_user_account_auth_method_settings: Array<Tenancy_User_Account_Auth_Method_Settings>;
  /** fetch aggregated fields from the table: "tenancy.user_account_auth_method_settings" */
  tenancy_user_account_auth_method_settings_aggregate: Tenancy_User_Account_Auth_Method_Settings_Aggregate;
  /** fetch data from the table: "tenancy.user_account_auth_method_settings" using primary key columns */
  tenancy_user_account_auth_method_settings_by_pk?: Maybe<Tenancy_User_Account_Auth_Method_Settings>;
  /** fetch data from the table in a streaming manner: "tenancy.user_account_auth_method_settings" */
  tenancy_user_account_auth_method_settings_stream: Array<Tenancy_User_Account_Auth_Method_Settings>;
  /** fetch data from the table: "tenancy.user_account_environment_config" */
  tenancy_user_account_environment_config: Array<Tenancy_User_Account_Environment_Config>;
  /** fetch aggregated fields from the table: "tenancy.user_account_environment_config" */
  tenancy_user_account_environment_config_aggregate: Tenancy_User_Account_Environment_Config_Aggregate;
  /** fetch data from the table: "tenancy.user_account_environment_config" using primary key columns */
  tenancy_user_account_environment_config_by_pk?: Maybe<Tenancy_User_Account_Environment_Config>;
  /** fetch data from the table in a streaming manner: "tenancy.user_account_environment_config" */
  tenancy_user_account_environment_config_stream: Array<Tenancy_User_Account_Environment_Config>;
  /** fetch data from the table: "tenancy.user_account_project_metabase_access" */
  tenancy_user_account_project_metabase_access: Array<Tenancy_User_Account_Project_Metabase_Access>;
  /** fetch aggregated fields from the table: "tenancy.user_account_project_metabase_access" */
  tenancy_user_account_project_metabase_access_aggregate: Tenancy_User_Account_Project_Metabase_Access_Aggregate;
  /** fetch data from the table: "tenancy.user_account_project_metabase_access" using primary key columns */
  tenancy_user_account_project_metabase_access_by_pk?: Maybe<Tenancy_User_Account_Project_Metabase_Access>;
  /** fetch data from the table in a streaming manner: "tenancy.user_account_project_metabase_access" */
  tenancy_user_account_project_metabase_access_stream: Array<Tenancy_User_Account_Project_Metabase_Access>;
  /** fetch data from the table: "tenancy.user_account_projects" */
  tenancy_user_account_projects: Array<Tenancy_User_Account_Projects>;
  /** fetch aggregated fields from the table: "tenancy.user_account_projects" */
  tenancy_user_account_projects_aggregate: Tenancy_User_Account_Projects_Aggregate;
  /** fetch data from the table: "tenancy.user_account_projects" using primary key columns */
  tenancy_user_account_projects_by_pk?: Maybe<Tenancy_User_Account_Projects>;
  /** fetch data from the table in a streaming manner: "tenancy.user_account_projects" */
  tenancy_user_account_projects_stream: Array<Tenancy_User_Account_Projects>;
  /** fetch data from the table: "tenancy.user_accounts" */
  tenancy_user_accounts: Array<Tenancy_User_Accounts>;
  /** fetch aggregated fields from the table: "tenancy.user_accounts" */
  tenancy_user_accounts_aggregate: Tenancy_User_Accounts_Aggregate;
  /** fetch data from the table: "tenancy.user_accounts" using primary key columns */
  tenancy_user_accounts_by_pk?: Maybe<Tenancy_User_Accounts>;
  /** fetch data from the table in a streaming manner: "tenancy.user_accounts" */
  tenancy_user_accounts_stream: Array<Tenancy_User_Accounts>;
  /** fetch data from the table: "tenancy.users" */
  tenancy_users: Array<Tenancy_Users>;
  /** fetch aggregated fields from the table: "tenancy.users" */
  tenancy_users_aggregate: Tenancy_Users_Aggregate;
  /** fetch data from the table: "tenancy.users" using primary key columns */
  tenancy_users_by_pk?: Maybe<Tenancy_Users>;
  /** fetch data from the table in a streaming manner: "tenancy.users" */
  tenancy_users_stream: Array<Tenancy_Users>;
  /** fetch data from the table: "tenancy.variable" */
  tenancy_variable: Array<Tenancy_Variable>;
  /** fetch aggregated fields from the table: "tenancy.variable" */
  tenancy_variable_aggregate: Tenancy_Variable_Aggregate;
  /** fetch data from the table: "tenancy.variable" using primary key columns */
  tenancy_variable_by_pk?: Maybe<Tenancy_Variable>;
  /** fetch data from the table in a streaming manner: "tenancy.variable" */
  tenancy_variable_stream: Array<Tenancy_Variable>;
};


export type Subscription_RootTenancy__ProjectEnvironmentConfigToVariableArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Order_By>>;
  where?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
};


export type Subscription_RootTenancy__ProjectEnvironmentConfigToVariable_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Order_By>>;
  where?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
};


export type Subscription_RootTenancy__ProjectEnvironmentConfigToVariable_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
};


export type Subscription_RootTenancy__Prisma_MigrationsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Prisma_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Prisma_Migrations_Order_By>>;
  where?: InputMaybe<Tenancy__Prisma_Migrations_Bool_Exp>;
};


export type Subscription_RootTenancy__Prisma_Migrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Prisma_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Prisma_Migrations_Order_By>>;
  where?: InputMaybe<Tenancy__Prisma_Migrations_Bool_Exp>;
};


export type Subscription_RootTenancy__Prisma_Migrations_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy__Prisma_Migrations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy__Prisma_Migrations_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy__Prisma_Migrations_Bool_Exp>;
};


export type Subscription_RootTenancy__Role_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Role_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Role_Projects_Order_By>>;
  where?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
};


export type Subscription_RootTenancy__Role_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Role_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Role_Projects_Order_By>>;
  where?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
};


export type Subscription_RootTenancy__Role_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy__Role_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
};


export type Subscription_RootTenancy__Team_Account_Environment_Config_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__Team_Account_Environment_Config_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__Team_Account_Environment_Config_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__Team_Account_Project_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__Team_Account_Project_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__Team_Account_Project_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy__Team_Account_Project_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__Team_Account_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__Team_Account_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__Team_Account_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy__Team_Account_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__User_Account_Environment_Config_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__User_Account_Environment_Config_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__User_Account_Environment_Config_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__User_Account_Project_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__User_Account_Project_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__User_Account_Project_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy__User_Account_Project_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__User_Account_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__User_Account_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__User_Account_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy__User_Account_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy__User_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Teams_Order_By>>;
  where?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
};


export type Subscription_RootTenancy__User_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Teams_Order_By>>;
  where?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
};


export type Subscription_RootTenancy__User_Teams_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy__User_Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
};


export type Subscription_RootTenancy_Account_Auth_Method_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
};


export type Subscription_RootTenancy_Account_Auth_Method_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
};


export type Subscription_RootTenancy_Account_Auth_Method_Settings_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Account_Auth_Method_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Account_Auth_Method_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
};


export type Subscription_RootTenancy_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
};


export type Subscription_RootTenancy_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
};


export type Subscription_RootTenancy_Accounts_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Accounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Accounts_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
};


export type Subscription_RootTenancy_ActionArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Bool_Exp>;
};


export type Subscription_RootTenancy_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Bool_Exp>;
};


export type Subscription_RootTenancy_Action_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Action_Node_JobArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Node_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Node_Job_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
};


export type Subscription_RootTenancy_Action_Node_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Node_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Node_Job_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
};


export type Subscription_RootTenancy_Action_Node_Job_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Action_Node_Job_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Action_Node_Job_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
};


export type Subscription_RootTenancy_Action_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Action_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Action_Bool_Exp>;
};


export type Subscription_RootTenancy_App_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_App_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_App_Config_Order_By>>;
  where?: InputMaybe<Tenancy_App_Config_Bool_Exp>;
};


export type Subscription_RootTenancy_App_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_App_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_App_Config_Order_By>>;
  where?: InputMaybe<Tenancy_App_Config_Bool_Exp>;
};


export type Subscription_RootTenancy_App_Config_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_App_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_App_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_App_Config_Bool_Exp>;
};


export type Subscription_RootTenancy_AppletArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Bool_Exp>;
};


export type Subscription_RootTenancy_Applet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Bool_Exp>;
};


export type Subscription_RootTenancy_Applet_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Applet_InstanceArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Instance_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
};


export type Subscription_RootTenancy_Applet_Instance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Instance_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
};


export type Subscription_RootTenancy_Applet_Instance_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Applet_Instance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Applet_Instance_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
};


export type Subscription_RootTenancy_Applet_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Applet_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Applet_Bool_Exp>;
};


export type Subscription_RootTenancy_Applet_VersionArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Version_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
};


export type Subscription_RootTenancy_Applet_Version_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Version_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
};


export type Subscription_RootTenancy_Applet_Version_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Applet_Version_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Applet_Version_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
};


export type Subscription_RootTenancy_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Audit_Logs_Order_By>>;
  where?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
};


export type Subscription_RootTenancy_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Audit_Logs_Order_By>>;
  where?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
};


export type Subscription_RootTenancy_Audit_Logs_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Audit_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Audit_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
};


export type Subscription_RootTenancy_Auth_MethodArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Auth_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Auth_Method_Order_By>>;
  where?: InputMaybe<Tenancy_Auth_Method_Bool_Exp>;
};


export type Subscription_RootTenancy_Auth_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Auth_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Auth_Method_Order_By>>;
  where?: InputMaybe<Tenancy_Auth_Method_Bool_Exp>;
};


export type Subscription_RootTenancy_Auth_Method_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Auth_Method_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Auth_Method_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Auth_Method_Bool_Exp>;
};


export type Subscription_RootTenancy_ConditionArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Condition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Condition_Order_By>>;
  where?: InputMaybe<Tenancy_Condition_Bool_Exp>;
};


export type Subscription_RootTenancy_Condition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Condition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Condition_Order_By>>;
  where?: InputMaybe<Tenancy_Condition_Bool_Exp>;
};


export type Subscription_RootTenancy_Condition_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Condition_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Condition_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Condition_Bool_Exp>;
};


export type Subscription_RootTenancy_CountryArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Country_Order_By>>;
  where?: InputMaybe<Tenancy_Country_Bool_Exp>;
};


export type Subscription_RootTenancy_Country_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Country_Order_By>>;
  where?: InputMaybe<Tenancy_Country_Bool_Exp>;
};


export type Subscription_RootTenancy_Country_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Country_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Country_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Country_Bool_Exp>;
};


export type Subscription_RootTenancy_Custom_Auth_MethodArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Order_By>>;
  where?: InputMaybe<Tenancy_Custom_Auth_Method_Bool_Exp>;
};


export type Subscription_RootTenancy_Custom_Auth_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Order_By>>;
  where?: InputMaybe<Tenancy_Custom_Auth_Method_Bool_Exp>;
};


export type Subscription_RootTenancy_Custom_Auth_Method_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Custom_Auth_Method_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Custom_Auth_Method_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Custom_Auth_Method_Bool_Exp>;
};


export type Subscription_RootTenancy_DomainArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Domain_Order_By>>;
  where?: InputMaybe<Tenancy_Domain_Bool_Exp>;
};


export type Subscription_RootTenancy_Domain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Domain_Order_By>>;
  where?: InputMaybe<Tenancy_Domain_Bool_Exp>;
};


export type Subscription_RootTenancy_Domain_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Domain_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Domain_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Domain_Bool_Exp>;
};


export type Subscription_RootTenancy_EnvironmentArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Environment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Environment_Order_By>>;
  where?: InputMaybe<Tenancy_Environment_Bool_Exp>;
};


export type Subscription_RootTenancy_Environment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Environment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Environment_Order_By>>;
  where?: InputMaybe<Tenancy_Environment_Bool_Exp>;
};


export type Subscription_RootTenancy_Environment_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Environment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Environment_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Environment_Bool_Exp>;
};


export type Subscription_RootTenancy_Failed_Kafka_EventsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Failed_Kafka_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Failed_Kafka_Events_Order_By>>;
  where?: InputMaybe<Tenancy_Failed_Kafka_Events_Bool_Exp>;
};


export type Subscription_RootTenancy_Failed_Kafka_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Failed_Kafka_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Failed_Kafka_Events_Order_By>>;
  where?: InputMaybe<Tenancy_Failed_Kafka_Events_Bool_Exp>;
};


export type Subscription_RootTenancy_Failed_Kafka_Events_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Failed_Kafka_Events_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Failed_Kafka_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Failed_Kafka_Events_Bool_Exp>;
};


export type Subscription_RootTenancy_FileArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


export type Subscription_RootTenancy_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


export type Subscription_RootTenancy_File_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_File_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_File_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


export type Subscription_RootTenancy_Llm_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Llm_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Llm_Credentials_Order_By>>;
  where?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
};


export type Subscription_RootTenancy_Llm_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Llm_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Llm_Credentials_Order_By>>;
  where?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
};


export type Subscription_RootTenancy_Llm_Credentials_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Llm_Credentials_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Llm_Credentials_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
};


export type Subscription_RootTenancy_Llm_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Llm_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Llm_Providers_Order_By>>;
  where?: InputMaybe<Tenancy_Llm_Providers_Bool_Exp>;
};


export type Subscription_RootTenancy_Llm_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Llm_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Llm_Providers_Order_By>>;
  where?: InputMaybe<Tenancy_Llm_Providers_Bool_Exp>;
};


export type Subscription_RootTenancy_Llm_Providers_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Llm_Providers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Llm_Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Llm_Providers_Bool_Exp>;
};


export type Subscription_RootTenancy_LocaleArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Locale_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Locale_Order_By>>;
  where?: InputMaybe<Tenancy_Locale_Bool_Exp>;
};


export type Subscription_RootTenancy_Locale_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Locale_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Locale_Order_By>>;
  where?: InputMaybe<Tenancy_Locale_Bool_Exp>;
};


export type Subscription_RootTenancy_Locale_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Locale_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Locale_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Locale_Bool_Exp>;
};


export type Subscription_RootTenancy_Localization_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};


export type Subscription_RootTenancy_Localization_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};


export type Subscription_RootTenancy_Localization_Settings_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Localization_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Localization_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};


export type Subscription_RootTenancy_Node_Type_Enum_PsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Bool_Exp>;
};


export type Subscription_RootTenancy_Node_Type_Enum_Ps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Bool_Exp>;
};


export type Subscription_RootTenancy_Node_Type_Enum_Ps_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Node_Type_Enum_Ps_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Node_Type_Enum_Ps_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Bool_Exp>;
};


export type Subscription_RootTenancy_PackageArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Package_Order_By>>;
  where?: InputMaybe<Tenancy_Package_Bool_Exp>;
};


export type Subscription_RootTenancy_Package_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Package_Order_By>>;
  where?: InputMaybe<Tenancy_Package_Bool_Exp>;
};


export type Subscription_RootTenancy_Package_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Package_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Package_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Package_Bool_Exp>;
};


export type Subscription_RootTenancy_Package_VersionArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Package_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Package_Version_Order_By>>;
  where?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
};


export type Subscription_RootTenancy_Package_Version_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Package_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Package_Version_Order_By>>;
  where?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
};


export type Subscription_RootTenancy_Package_Version_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Package_Version_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Package_Version_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
};


export type Subscription_RootTenancy_Pro_Studio_Performance_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pro_Studio_Performance_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pro_Studio_Performance_Metrics_Order_By>>;
  where?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp>;
};


export type Subscription_RootTenancy_Pro_Studio_Performance_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pro_Studio_Performance_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pro_Studio_Performance_Metrics_Order_By>>;
  where?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp>;
};


export type Subscription_RootTenancy_Pro_Studio_Performance_Metrics_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Pro_Studio_Performance_Metrics_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp>;
};


export type Subscription_RootTenancy_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Products_Order_By>>;
  where?: InputMaybe<Tenancy_Products_Bool_Exp>;
};


export type Subscription_RootTenancy_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Products_Order_By>>;
  where?: InputMaybe<Tenancy_Products_Bool_Exp>;
};


export type Subscription_RootTenancy_Products_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Products_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Products_Bool_Exp>;
};


export type Subscription_RootTenancy_Project_Environment_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
};


export type Subscription_RootTenancy_Project_Environment_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
};


export type Subscription_RootTenancy_Project_Environment_Config_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Project_Environment_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Project_Environment_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
};


export type Subscription_RootTenancy_Project_Pro_Studio_SettingArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
};


export type Subscription_RootTenancy_Project_Pro_Studio_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
};


export type Subscription_RootTenancy_Project_Pro_Studio_Setting_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Project_Pro_Studio_Setting_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Project_Pro_Studio_Setting_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
};


export type Subscription_RootTenancy_Project_Product_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Product_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Product_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
};


export type Subscription_RootTenancy_Project_Product_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Product_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Product_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
};


export type Subscription_RootTenancy_Project_Product_Settings_By_PkArgs = {
  productId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Project_Product_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Project_Product_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
};


export type Subscription_RootTenancy_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Projects_Bool_Exp>;
};


export type Subscription_RootTenancy_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Projects_Bool_Exp>;
};


export type Subscription_RootTenancy_Projects_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Projects_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_ConnectionArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Connection_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Connection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Connection_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Connection_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Pype_Connection_PypeArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Pype_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Connection_Pype_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Pype_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Connection_Pype_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Pype_Connection_Pype_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Pype_Connection_Pype_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Pype_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Connection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Pype_Connection_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_RuleArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Rule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Rule_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Pype_Rule_GroupArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Rule_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Rule_Group_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Pype_Rule_Group_PypeArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Rule_Group_Pype_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Rule_Group_Pype_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Pype_Rule_Group_Pype_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Pype_Rule_Group_Pype_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Rule_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Pype_Rule_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
};


export type Subscription_RootTenancy_Pype_Rule_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Pype_Rule_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Bool_Exp>;
};


export type Subscription_RootTenancy_Rich_Asset_Type_Enum_PsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp>;
};


export type Subscription_RootTenancy_Rich_Asset_Type_Enum_Ps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp>;
};


export type Subscription_RootTenancy_Rich_Asset_Type_Enum_Ps_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Rich_Asset_Type_Enum_Ps_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp>;
};


export type Subscription_RootTenancy_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Roles_Order_By>>;
  where?: InputMaybe<Tenancy_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Roles_Order_By>>;
  where?: InputMaybe<Tenancy_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy_Roles_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Roles_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Deployment_Run_WorkflowsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Deployment_Run_Workflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Deployment_Run_Workflows_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Solution_Deployment_Run_Workflows_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Deployment_RunsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Runs_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Deployment_Runs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Runs_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Deployment_Runs_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Solution_Deployment_Runs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Solution_Deployment_Runs_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Runs_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_DeploymentsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployments_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Deployments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployments_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Deployments_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Solution_Deployments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Solution_Deployments_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_TaskArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Task_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Task_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Task_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Task_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Task_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Task_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Solution_Task_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Solution_Task_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Solution_Task_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_User_PresenceArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_User_Presence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_User_Presence_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_User_Presence_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_User_Presence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_User_Presence_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_User_Presence_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Solution_User_Presence_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Solution_User_Presence_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Version_Nodes_PsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Version_Nodes_Ps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Version_Nodes_Ps_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Solution_Version_Nodes_Ps_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Versions_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Solution_Versions_PsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Versions_Ps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Versions_Ps_By_PkArgs = {
  solutionVersionId: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Solution_Versions_Ps_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Solution_Versions_Ps_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
};


export type Subscription_RootTenancy_Solution_Versions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Solution_Versions_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
};


export type Subscription_RootTenancy_SolutionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solutions_Order_By>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};


export type Subscription_RootTenancy_Solutions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solutions_Order_By>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};


export type Subscription_RootTenancy_Solutions_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Solutions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Solutions_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};


export type Subscription_RootTenancy_Studio_ResourceArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Studio_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Studio_Resource_Order_By>>;
  where?: InputMaybe<Tenancy_Studio_Resource_Bool_Exp>;
};


export type Subscription_RootTenancy_Studio_Resource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Studio_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Studio_Resource_Order_By>>;
  where?: InputMaybe<Tenancy_Studio_Resource_Bool_Exp>;
};


export type Subscription_RootTenancy_Studio_Resource_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Studio_Resource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Studio_Resource_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Studio_Resource_Bool_Exp>;
};


export type Subscription_RootTenancy_Team_Account_Environment_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
};


export type Subscription_RootTenancy_Team_Account_Environment_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
};


export type Subscription_RootTenancy_Team_Account_Environment_Config_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Team_Account_Environment_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Team_Account_Environment_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
};


export type Subscription_RootTenancy_Team_Account_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
};


export type Subscription_RootTenancy_Team_Account_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
};


export type Subscription_RootTenancy_Team_Account_Projects_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Team_Account_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Team_Account_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
};


export type Subscription_RootTenancy_Team_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
};


export type Subscription_RootTenancy_Team_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
};


export type Subscription_RootTenancy_Team_Accounts_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Team_Accounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Team_Accounts_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
};


export type Subscription_RootTenancy_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Teams_Order_By>>;
  where?: InputMaybe<Tenancy_Teams_Bool_Exp>;
};


export type Subscription_RootTenancy_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Teams_Order_By>>;
  where?: InputMaybe<Tenancy_Teams_Bool_Exp>;
};


export type Subscription_RootTenancy_Teams_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Teams_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Teams_Bool_Exp>;
};


export type Subscription_RootTenancy_Template_NodeArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Template_Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Template_Node_Order_By>>;
  where?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
};


export type Subscription_RootTenancy_Template_Node_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Template_Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Template_Node_Order_By>>;
  where?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
};


export type Subscription_RootTenancy_Template_Node_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Template_Node_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Template_Node_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
};


export type Subscription_RootTenancy_Time_ZoneArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Time_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Time_Zone_Order_By>>;
  where?: InputMaybe<Tenancy_Time_Zone_Bool_Exp>;
};


export type Subscription_RootTenancy_Time_Zone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Time_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Time_Zone_Order_By>>;
  where?: InputMaybe<Tenancy_Time_Zone_Bool_Exp>;
};


export type Subscription_RootTenancy_Time_Zone_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Time_Zone_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Time_Zone_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Time_Zone_Bool_Exp>;
};


export type Subscription_RootTenancy_TriggerArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Trigger_Order_By>>;
  where?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
};


export type Subscription_RootTenancy_Trigger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Trigger_Order_By>>;
  where?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
};


export type Subscription_RootTenancy_Trigger_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Trigger_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Trigger_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Account_Auth_Method_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Account_Auth_Method_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Account_Auth_Method_Settings_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_User_Account_Auth_Method_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Account_Environment_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Account_Environment_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Account_Environment_Config_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_User_Account_Environment_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_User_Account_Environment_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Account_Project_Metabase_AccessArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Account_Project_Metabase_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Account_Project_Metabase_Access_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_User_Account_Project_Metabase_Access_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Account_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Account_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Account_Projects_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_User_Account_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_User_Account_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
};


export type Subscription_RootTenancy_User_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};


export type Subscription_RootTenancy_User_Accounts_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_User_Accounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_User_Accounts_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};


export type Subscription_RootTenancy_UsersArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Users_Order_By>>;
  where?: InputMaybe<Tenancy_Users_Bool_Exp>;
};


export type Subscription_RootTenancy_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Users_Order_By>>;
  where?: InputMaybe<Tenancy_Users_Bool_Exp>;
};


export type Subscription_RootTenancy_Users_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Users_Bool_Exp>;
};


export type Subscription_RootTenancy_VariableArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Variable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Variable_Order_By>>;
  where?: InputMaybe<Tenancy_Variable_Bool_Exp>;
};


export type Subscription_RootTenancy_Variable_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Variable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Variable_Order_By>>;
  where?: InputMaybe<Tenancy_Variable_Bool_Exp>;
};


export type Subscription_RootTenancy_Variable_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTenancy_Variable_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenancy_Variable_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenancy_Variable_Bool_Exp>;
};

/** columns and relationships of "tenancy._ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable = {
  __typename?: 'tenancy__ProjectEnvironmentConfigToVariable';
  A: Scalars['String']['output'];
  B: Scalars['String']['output'];
  /** An object relationship */
  project_environment_config: Tenancy_Project_Environment_Config;
  /** An object relationship */
  variable: Tenancy_Variable;
};

/** aggregated selection of "tenancy._ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable_Aggregate = {
  __typename?: 'tenancy__ProjectEnvironmentConfigToVariable_aggregate';
  aggregate?: Maybe<Tenancy__ProjectEnvironmentConfigToVariable_Aggregate_Fields>;
  nodes: Array<Tenancy__ProjectEnvironmentConfigToVariable>;
};

export type Tenancy__ProjectEnvironmentConfigToVariable_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Aggregate_Bool_Exp_Count>;
};

export type Tenancy__ProjectEnvironmentConfigToVariable_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy._ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable_Aggregate_Fields = {
  __typename?: 'tenancy__ProjectEnvironmentConfigToVariable_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy__ProjectEnvironmentConfigToVariable_Max_Fields>;
  min?: Maybe<Tenancy__ProjectEnvironmentConfigToVariable_Min_Fields>;
};


/** aggregate fields of "tenancy._ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy._ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Max_Order_By>;
  min?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy._ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable_Arr_Rel_Insert_Input = {
  data: Array<Tenancy__ProjectEnvironmentConfigToVariable_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy._ProjectEnvironmentConfigToVariable". All fields are combined with a logical 'AND'. */
export type Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp = {
  A?: InputMaybe<String_Comparison_Exp>;
  B?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>>;
  _not?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
  variable?: InputMaybe<Tenancy_Variable_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy._ProjectEnvironmentConfigToVariable" */
export enum Tenancy__ProjectEnvironmentConfigToVariable_Constraint {
  /** unique or primary key constraint on columns "A", "B" */
  ProjectEnvironmentConfigToVariableAbUnique = '_ProjectEnvironmentConfigToVariable_AB_unique'
}

/** input type for inserting data into table "tenancy._ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable_Insert_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Obj_Rel_Insert_Input>;
  variable?: InputMaybe<Tenancy_Variable_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy__ProjectEnvironmentConfigToVariable_Max_Fields = {
  __typename?: 'tenancy__ProjectEnvironmentConfigToVariable_max_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy._ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable_Max_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy__ProjectEnvironmentConfigToVariable_Min_Fields = {
  __typename?: 'tenancy__ProjectEnvironmentConfigToVariable_min_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy._ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable_Min_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy._ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable_Mutation_Response = {
  __typename?: 'tenancy__ProjectEnvironmentConfigToVariable_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy__ProjectEnvironmentConfigToVariable>;
};

/** on_conflict condition type for table "tenancy._ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable_On_Conflict = {
  constraint: Tenancy__ProjectEnvironmentConfigToVariable_Constraint;
  update_columns?: Array<Tenancy__ProjectEnvironmentConfigToVariable_Update_Column>;
  where?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy._ProjectEnvironmentConfigToVariable". */
export type Tenancy__ProjectEnvironmentConfigToVariable_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Order_By>;
  variable?: InputMaybe<Tenancy_Variable_Order_By>;
};

/** select columns of table "tenancy._ProjectEnvironmentConfigToVariable" */
export enum Tenancy__ProjectEnvironmentConfigToVariable_Select_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

/** input type for updating data in table "tenancy._ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable_Set_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy__ProjectEnvironmentConfigToVariable" */
export type Tenancy__ProjectEnvironmentConfigToVariable_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy__ProjectEnvironmentConfigToVariable_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy__ProjectEnvironmentConfigToVariable_Stream_Cursor_Value_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy._ProjectEnvironmentConfigToVariable" */
export enum Tenancy__ProjectEnvironmentConfigToVariable_Update_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

export type Tenancy__ProjectEnvironmentConfigToVariable_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp;
};

/** columns and relationships of "tenancy._prisma_migrations" */
export type Tenancy__Prisma_Migrations = {
  __typename?: 'tenancy__prisma_migrations';
  applied_steps_count: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  finished_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['String']['output'];
  logs?: Maybe<Scalars['String']['output']>;
  migration_name: Scalars['String']['output'];
  rolled_back_at?: Maybe<Scalars['timestamptz']['output']>;
  started_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "tenancy._prisma_migrations" */
export type Tenancy__Prisma_Migrations_Aggregate = {
  __typename?: 'tenancy__prisma_migrations_aggregate';
  aggregate?: Maybe<Tenancy__Prisma_Migrations_Aggregate_Fields>;
  nodes: Array<Tenancy__Prisma_Migrations>;
};

/** aggregate fields of "tenancy._prisma_migrations" */
export type Tenancy__Prisma_Migrations_Aggregate_Fields = {
  __typename?: 'tenancy__prisma_migrations_aggregate_fields';
  avg?: Maybe<Tenancy__Prisma_Migrations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy__Prisma_Migrations_Max_Fields>;
  min?: Maybe<Tenancy__Prisma_Migrations_Min_Fields>;
  stddev?: Maybe<Tenancy__Prisma_Migrations_Stddev_Fields>;
  stddev_pop?: Maybe<Tenancy__Prisma_Migrations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenancy__Prisma_Migrations_Stddev_Samp_Fields>;
  sum?: Maybe<Tenancy__Prisma_Migrations_Sum_Fields>;
  var_pop?: Maybe<Tenancy__Prisma_Migrations_Var_Pop_Fields>;
  var_samp?: Maybe<Tenancy__Prisma_Migrations_Var_Samp_Fields>;
  variance?: Maybe<Tenancy__Prisma_Migrations_Variance_Fields>;
};


/** aggregate fields of "tenancy._prisma_migrations" */
export type Tenancy__Prisma_Migrations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy__Prisma_Migrations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Tenancy__Prisma_Migrations_Avg_Fields = {
  __typename?: 'tenancy__prisma_migrations_avg_fields';
  applied_steps_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tenancy._prisma_migrations". All fields are combined with a logical 'AND'. */
export type Tenancy__Prisma_Migrations_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy__Prisma_Migrations_Bool_Exp>>;
  _not?: InputMaybe<Tenancy__Prisma_Migrations_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy__Prisma_Migrations_Bool_Exp>>;
  applied_steps_count?: InputMaybe<Int_Comparison_Exp>;
  checksum?: InputMaybe<String_Comparison_Exp>;
  finished_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  logs?: InputMaybe<String_Comparison_Exp>;
  migration_name?: InputMaybe<String_Comparison_Exp>;
  rolled_back_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  started_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy._prisma_migrations" */
export enum Tenancy__Prisma_Migrations_Constraint {
  /** unique or primary key constraint on columns "id" */
  PrismaMigrationsPkey = '_prisma_migrations_pkey'
}

/** input type for incrementing numeric columns in table "tenancy._prisma_migrations" */
export type Tenancy__Prisma_Migrations_Inc_Input = {
  applied_steps_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tenancy._prisma_migrations" */
export type Tenancy__Prisma_Migrations_Insert_Input = {
  applied_steps_count?: InputMaybe<Scalars['Int']['input']>;
  checksum?: InputMaybe<Scalars['String']['input']>;
  finished_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  logs?: InputMaybe<Scalars['String']['input']>;
  migration_name?: InputMaybe<Scalars['String']['input']>;
  rolled_back_at?: InputMaybe<Scalars['timestamptz']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Tenancy__Prisma_Migrations_Max_Fields = {
  __typename?: 'tenancy__prisma_migrations_max_fields';
  applied_steps_count?: Maybe<Scalars['Int']['output']>;
  checksum?: Maybe<Scalars['String']['output']>;
  finished_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logs?: Maybe<Scalars['String']['output']>;
  migration_name?: Maybe<Scalars['String']['output']>;
  rolled_back_at?: Maybe<Scalars['timestamptz']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Tenancy__Prisma_Migrations_Min_Fields = {
  __typename?: 'tenancy__prisma_migrations_min_fields';
  applied_steps_count?: Maybe<Scalars['Int']['output']>;
  checksum?: Maybe<Scalars['String']['output']>;
  finished_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logs?: Maybe<Scalars['String']['output']>;
  migration_name?: Maybe<Scalars['String']['output']>;
  rolled_back_at?: Maybe<Scalars['timestamptz']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "tenancy._prisma_migrations" */
export type Tenancy__Prisma_Migrations_Mutation_Response = {
  __typename?: 'tenancy__prisma_migrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy__Prisma_Migrations>;
};

/** on_conflict condition type for table "tenancy._prisma_migrations" */
export type Tenancy__Prisma_Migrations_On_Conflict = {
  constraint: Tenancy__Prisma_Migrations_Constraint;
  update_columns?: Array<Tenancy__Prisma_Migrations_Update_Column>;
  where?: InputMaybe<Tenancy__Prisma_Migrations_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy._prisma_migrations". */
export type Tenancy__Prisma_Migrations_Order_By = {
  applied_steps_count?: InputMaybe<Order_By>;
  checksum?: InputMaybe<Order_By>;
  finished_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logs?: InputMaybe<Order_By>;
  migration_name?: InputMaybe<Order_By>;
  rolled_back_at?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy._prisma_migrations */
export type Tenancy__Prisma_Migrations_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy._prisma_migrations" */
export enum Tenancy__Prisma_Migrations_Select_Column {
  /** column name */
  AppliedStepsCount = 'applied_steps_count',
  /** column name */
  Checksum = 'checksum',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  Id = 'id',
  /** column name */
  Logs = 'logs',
  /** column name */
  MigrationName = 'migration_name',
  /** column name */
  RolledBackAt = 'rolled_back_at',
  /** column name */
  StartedAt = 'started_at'
}

/** input type for updating data in table "tenancy._prisma_migrations" */
export type Tenancy__Prisma_Migrations_Set_Input = {
  applied_steps_count?: InputMaybe<Scalars['Int']['input']>;
  checksum?: InputMaybe<Scalars['String']['input']>;
  finished_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  logs?: InputMaybe<Scalars['String']['input']>;
  migration_name?: InputMaybe<Scalars['String']['input']>;
  rolled_back_at?: InputMaybe<Scalars['timestamptz']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Tenancy__Prisma_Migrations_Stddev_Fields = {
  __typename?: 'tenancy__prisma_migrations_stddev_fields';
  applied_steps_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Tenancy__Prisma_Migrations_Stddev_Pop_Fields = {
  __typename?: 'tenancy__prisma_migrations_stddev_pop_fields';
  applied_steps_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Tenancy__Prisma_Migrations_Stddev_Samp_Fields = {
  __typename?: 'tenancy__prisma_migrations_stddev_samp_fields';
  applied_steps_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tenancy__prisma_migrations" */
export type Tenancy__Prisma_Migrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy__Prisma_Migrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy__Prisma_Migrations_Stream_Cursor_Value_Input = {
  applied_steps_count?: InputMaybe<Scalars['Int']['input']>;
  checksum?: InputMaybe<Scalars['String']['input']>;
  finished_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  logs?: InputMaybe<Scalars['String']['input']>;
  migration_name?: InputMaybe<Scalars['String']['input']>;
  rolled_back_at?: InputMaybe<Scalars['timestamptz']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Tenancy__Prisma_Migrations_Sum_Fields = {
  __typename?: 'tenancy__prisma_migrations_sum_fields';
  applied_steps_count?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "tenancy._prisma_migrations" */
export enum Tenancy__Prisma_Migrations_Update_Column {
  /** column name */
  AppliedStepsCount = 'applied_steps_count',
  /** column name */
  Checksum = 'checksum',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  Id = 'id',
  /** column name */
  Logs = 'logs',
  /** column name */
  MigrationName = 'migration_name',
  /** column name */
  RolledBackAt = 'rolled_back_at',
  /** column name */
  StartedAt = 'started_at'
}

export type Tenancy__Prisma_Migrations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenancy__Prisma_Migrations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy__Prisma_Migrations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy__Prisma_Migrations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tenancy__Prisma_Migrations_Var_Pop_Fields = {
  __typename?: 'tenancy__prisma_migrations_var_pop_fields';
  applied_steps_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Tenancy__Prisma_Migrations_Var_Samp_Fields = {
  __typename?: 'tenancy__prisma_migrations_var_samp_fields';
  applied_steps_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Tenancy__Prisma_Migrations_Variance_Fields = {
  __typename?: 'tenancy__prisma_migrations_variance_fields';
  applied_steps_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "tenancy._role_projects" */
export type Tenancy__Role_Projects = {
  __typename?: 'tenancy__role_projects';
  A: Scalars['String']['output'];
  B: Scalars['String']['output'];
  /** An object relationship */
  project: Tenancy_Projects;
  /** An object relationship */
  role: Tenancy_Roles;
};

/** aggregated selection of "tenancy._role_projects" */
export type Tenancy__Role_Projects_Aggregate = {
  __typename?: 'tenancy__role_projects_aggregate';
  aggregate?: Maybe<Tenancy__Role_Projects_Aggregate_Fields>;
  nodes: Array<Tenancy__Role_Projects>;
};

export type Tenancy__Role_Projects_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy__Role_Projects_Aggregate_Bool_Exp_Count>;
};

export type Tenancy__Role_Projects_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy__Role_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy._role_projects" */
export type Tenancy__Role_Projects_Aggregate_Fields = {
  __typename?: 'tenancy__role_projects_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy__Role_Projects_Max_Fields>;
  min?: Maybe<Tenancy__Role_Projects_Min_Fields>;
};


/** aggregate fields of "tenancy._role_projects" */
export type Tenancy__Role_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy__Role_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy._role_projects" */
export type Tenancy__Role_Projects_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy__Role_Projects_Max_Order_By>;
  min?: InputMaybe<Tenancy__Role_Projects_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy._role_projects" */
export type Tenancy__Role_Projects_Arr_Rel_Insert_Input = {
  data: Array<Tenancy__Role_Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy__Role_Projects_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy._role_projects". All fields are combined with a logical 'AND'. */
export type Tenancy__Role_Projects_Bool_Exp = {
  A?: InputMaybe<String_Comparison_Exp>;
  B?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Tenancy__Role_Projects_Bool_Exp>>;
  _not?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy__Role_Projects_Bool_Exp>>;
  project?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  role?: InputMaybe<Tenancy_Roles_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy._role_projects" */
export enum Tenancy__Role_Projects_Constraint {
  /** unique or primary key constraint on columns "A", "B" */
  RoleProjectsAbUnique = '_role_projects_AB_unique'
}

/** input type for inserting data into table "tenancy._role_projects" */
export type Tenancy__Role_Projects_Insert_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Tenancy_Projects_Obj_Rel_Insert_Input>;
  role?: InputMaybe<Tenancy_Roles_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy__Role_Projects_Max_Fields = {
  __typename?: 'tenancy__role_projects_max_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy._role_projects" */
export type Tenancy__Role_Projects_Max_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy__Role_Projects_Min_Fields = {
  __typename?: 'tenancy__role_projects_min_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy._role_projects" */
export type Tenancy__Role_Projects_Min_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy._role_projects" */
export type Tenancy__Role_Projects_Mutation_Response = {
  __typename?: 'tenancy__role_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy__Role_Projects>;
};

/** on_conflict condition type for table "tenancy._role_projects" */
export type Tenancy__Role_Projects_On_Conflict = {
  constraint: Tenancy__Role_Projects_Constraint;
  update_columns?: Array<Tenancy__Role_Projects_Update_Column>;
  where?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy._role_projects". */
export type Tenancy__Role_Projects_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
  project?: InputMaybe<Tenancy_Projects_Order_By>;
  role?: InputMaybe<Tenancy_Roles_Order_By>;
};

/** select columns of table "tenancy._role_projects" */
export enum Tenancy__Role_Projects_Select_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

/** input type for updating data in table "tenancy._role_projects" */
export type Tenancy__Role_Projects_Set_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy__role_projects" */
export type Tenancy__Role_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy__Role_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy__Role_Projects_Stream_Cursor_Value_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy._role_projects" */
export enum Tenancy__Role_Projects_Update_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

export type Tenancy__Role_Projects_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy__Role_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy__Role_Projects_Bool_Exp;
};

/** columns and relationships of "tenancy._team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles = {
  __typename?: 'tenancy__team_account_environment_config_roles';
  A: Scalars['String']['output'];
  B: Scalars['String']['output'];
  /** An object relationship */
  role: Tenancy_Roles;
  /** An object relationship */
  team_account_environment_config: Tenancy_Team_Account_Environment_Config;
};

/** aggregated selection of "tenancy._team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles_Aggregate = {
  __typename?: 'tenancy__team_account_environment_config_roles_aggregate';
  aggregate?: Maybe<Tenancy__Team_Account_Environment_Config_Roles_Aggregate_Fields>;
  nodes: Array<Tenancy__Team_Account_Environment_Config_Roles>;
};

export type Tenancy__Team_Account_Environment_Config_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Aggregate_Bool_Exp_Count>;
};

export type Tenancy__Team_Account_Environment_Config_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy._team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles_Aggregate_Fields = {
  __typename?: 'tenancy__team_account_environment_config_roles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy__Team_Account_Environment_Config_Roles_Max_Fields>;
  min?: Maybe<Tenancy__Team_Account_Environment_Config_Roles_Min_Fields>;
};


/** aggregate fields of "tenancy._team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy._team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Max_Order_By>;
  min?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy._team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles_Arr_Rel_Insert_Input = {
  data: Array<Tenancy__Team_Account_Environment_Config_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy._team_account_environment_config_roles". All fields are combined with a logical 'AND'. */
export type Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp = {
  A?: InputMaybe<String_Comparison_Exp>;
  B?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>>;
  _not?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>>;
  role?: InputMaybe<Tenancy_Roles_Bool_Exp>;
  team_account_environment_config?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy._team_account_environment_config_roles" */
export enum Tenancy__Team_Account_Environment_Config_Roles_Constraint {
  /** unique or primary key constraint on columns "A", "B" */
  TeamAccountEnvironmentConfigRolesAbUnique = '_team_account_environment_config_roles_AB_unique'
}

/** input type for inserting data into table "tenancy._team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles_Insert_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Tenancy_Roles_Obj_Rel_Insert_Input>;
  team_account_environment_config?: InputMaybe<Tenancy_Team_Account_Environment_Config_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy__Team_Account_Environment_Config_Roles_Max_Fields = {
  __typename?: 'tenancy__team_account_environment_config_roles_max_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy._team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles_Max_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy__Team_Account_Environment_Config_Roles_Min_Fields = {
  __typename?: 'tenancy__team_account_environment_config_roles_min_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy._team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles_Min_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy._team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles_Mutation_Response = {
  __typename?: 'tenancy__team_account_environment_config_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy__Team_Account_Environment_Config_Roles>;
};

/** on_conflict condition type for table "tenancy._team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles_On_Conflict = {
  constraint: Tenancy__Team_Account_Environment_Config_Roles_Constraint;
  update_columns?: Array<Tenancy__Team_Account_Environment_Config_Roles_Update_Column>;
  where?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy._team_account_environment_config_roles". */
export type Tenancy__Team_Account_Environment_Config_Roles_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
  role?: InputMaybe<Tenancy_Roles_Order_By>;
  team_account_environment_config?: InputMaybe<Tenancy_Team_Account_Environment_Config_Order_By>;
};

/** select columns of table "tenancy._team_account_environment_config_roles" */
export enum Tenancy__Team_Account_Environment_Config_Roles_Select_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

/** input type for updating data in table "tenancy._team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles_Set_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy__team_account_environment_config_roles" */
export type Tenancy__Team_Account_Environment_Config_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy__Team_Account_Environment_Config_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy__Team_Account_Environment_Config_Roles_Stream_Cursor_Value_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy._team_account_environment_config_roles" */
export enum Tenancy__Team_Account_Environment_Config_Roles_Update_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

export type Tenancy__Team_Account_Environment_Config_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp;
};

/** columns and relationships of "tenancy._team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles = {
  __typename?: 'tenancy__team_account_project_roles';
  A: Scalars['String']['output'];
  B: Scalars['String']['output'];
  /** An object relationship */
  role: Tenancy_Roles;
  /** An object relationship */
  team_account_project: Tenancy_Team_Account_Projects;
};

/** aggregated selection of "tenancy._team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles_Aggregate = {
  __typename?: 'tenancy__team_account_project_roles_aggregate';
  aggregate?: Maybe<Tenancy__Team_Account_Project_Roles_Aggregate_Fields>;
  nodes: Array<Tenancy__Team_Account_Project_Roles>;
};

export type Tenancy__Team_Account_Project_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy__Team_Account_Project_Roles_Aggregate_Bool_Exp_Count>;
};

export type Tenancy__Team_Account_Project_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy._team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles_Aggregate_Fields = {
  __typename?: 'tenancy__team_account_project_roles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy__Team_Account_Project_Roles_Max_Fields>;
  min?: Maybe<Tenancy__Team_Account_Project_Roles_Min_Fields>;
};


/** aggregate fields of "tenancy._team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy._team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy__Team_Account_Project_Roles_Max_Order_By>;
  min?: InputMaybe<Tenancy__Team_Account_Project_Roles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy._team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles_Arr_Rel_Insert_Input = {
  data: Array<Tenancy__Team_Account_Project_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy__Team_Account_Project_Roles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy._team_account_project_roles". All fields are combined with a logical 'AND'. */
export type Tenancy__Team_Account_Project_Roles_Bool_Exp = {
  A?: InputMaybe<String_Comparison_Exp>;
  B?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Bool_Exp>>;
  _not?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Bool_Exp>>;
  role?: InputMaybe<Tenancy_Roles_Bool_Exp>;
  team_account_project?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy._team_account_project_roles" */
export enum Tenancy__Team_Account_Project_Roles_Constraint {
  /** unique or primary key constraint on columns "A", "B" */
  TeamAccountProjectRolesAbUnique = '_team_account_project_roles_AB_unique'
}

/** input type for inserting data into table "tenancy._team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles_Insert_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Tenancy_Roles_Obj_Rel_Insert_Input>;
  team_account_project?: InputMaybe<Tenancy_Team_Account_Projects_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy__Team_Account_Project_Roles_Max_Fields = {
  __typename?: 'tenancy__team_account_project_roles_max_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy._team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles_Max_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy__Team_Account_Project_Roles_Min_Fields = {
  __typename?: 'tenancy__team_account_project_roles_min_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy._team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles_Min_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy._team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles_Mutation_Response = {
  __typename?: 'tenancy__team_account_project_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy__Team_Account_Project_Roles>;
};

/** on_conflict condition type for table "tenancy._team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles_On_Conflict = {
  constraint: Tenancy__Team_Account_Project_Roles_Constraint;
  update_columns?: Array<Tenancy__Team_Account_Project_Roles_Update_Column>;
  where?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy._team_account_project_roles". */
export type Tenancy__Team_Account_Project_Roles_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
  role?: InputMaybe<Tenancy_Roles_Order_By>;
  team_account_project?: InputMaybe<Tenancy_Team_Account_Projects_Order_By>;
};

/** select columns of table "tenancy._team_account_project_roles" */
export enum Tenancy__Team_Account_Project_Roles_Select_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

/** input type for updating data in table "tenancy._team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles_Set_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy__team_account_project_roles" */
export type Tenancy__Team_Account_Project_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy__Team_Account_Project_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy__Team_Account_Project_Roles_Stream_Cursor_Value_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy._team_account_project_roles" */
export enum Tenancy__Team_Account_Project_Roles_Update_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

export type Tenancy__Team_Account_Project_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy__Team_Account_Project_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy__Team_Account_Project_Roles_Bool_Exp;
};

/** columns and relationships of "tenancy._team_account_roles" */
export type Tenancy__Team_Account_Roles = {
  __typename?: 'tenancy__team_account_roles';
  A: Scalars['String']['output'];
  B: Scalars['String']['output'];
  /** An object relationship */
  role: Tenancy_Roles;
  /** An object relationship */
  team_account: Tenancy_Team_Accounts;
};

/** aggregated selection of "tenancy._team_account_roles" */
export type Tenancy__Team_Account_Roles_Aggregate = {
  __typename?: 'tenancy__team_account_roles_aggregate';
  aggregate?: Maybe<Tenancy__Team_Account_Roles_Aggregate_Fields>;
  nodes: Array<Tenancy__Team_Account_Roles>;
};

export type Tenancy__Team_Account_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy__Team_Account_Roles_Aggregate_Bool_Exp_Count>;
};

export type Tenancy__Team_Account_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy__Team_Account_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy._team_account_roles" */
export type Tenancy__Team_Account_Roles_Aggregate_Fields = {
  __typename?: 'tenancy__team_account_roles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy__Team_Account_Roles_Max_Fields>;
  min?: Maybe<Tenancy__Team_Account_Roles_Min_Fields>;
};


/** aggregate fields of "tenancy._team_account_roles" */
export type Tenancy__Team_Account_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy__Team_Account_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy._team_account_roles" */
export type Tenancy__Team_Account_Roles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy__Team_Account_Roles_Max_Order_By>;
  min?: InputMaybe<Tenancy__Team_Account_Roles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy._team_account_roles" */
export type Tenancy__Team_Account_Roles_Arr_Rel_Insert_Input = {
  data: Array<Tenancy__Team_Account_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy__Team_Account_Roles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy._team_account_roles". All fields are combined with a logical 'AND'. */
export type Tenancy__Team_Account_Roles_Bool_Exp = {
  A?: InputMaybe<String_Comparison_Exp>;
  B?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Tenancy__Team_Account_Roles_Bool_Exp>>;
  _not?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy__Team_Account_Roles_Bool_Exp>>;
  role?: InputMaybe<Tenancy_Roles_Bool_Exp>;
  team_account?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy._team_account_roles" */
export enum Tenancy__Team_Account_Roles_Constraint {
  /** unique or primary key constraint on columns "A", "B" */
  TeamAccountRolesAbUnique = '_team_account_roles_AB_unique'
}

/** input type for inserting data into table "tenancy._team_account_roles" */
export type Tenancy__Team_Account_Roles_Insert_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Tenancy_Roles_Obj_Rel_Insert_Input>;
  team_account?: InputMaybe<Tenancy_Team_Accounts_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy__Team_Account_Roles_Max_Fields = {
  __typename?: 'tenancy__team_account_roles_max_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy._team_account_roles" */
export type Tenancy__Team_Account_Roles_Max_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy__Team_Account_Roles_Min_Fields = {
  __typename?: 'tenancy__team_account_roles_min_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy._team_account_roles" */
export type Tenancy__Team_Account_Roles_Min_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy._team_account_roles" */
export type Tenancy__Team_Account_Roles_Mutation_Response = {
  __typename?: 'tenancy__team_account_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy__Team_Account_Roles>;
};

/** on_conflict condition type for table "tenancy._team_account_roles" */
export type Tenancy__Team_Account_Roles_On_Conflict = {
  constraint: Tenancy__Team_Account_Roles_Constraint;
  update_columns?: Array<Tenancy__Team_Account_Roles_Update_Column>;
  where?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy._team_account_roles". */
export type Tenancy__Team_Account_Roles_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
  role?: InputMaybe<Tenancy_Roles_Order_By>;
  team_account?: InputMaybe<Tenancy_Team_Accounts_Order_By>;
};

/** select columns of table "tenancy._team_account_roles" */
export enum Tenancy__Team_Account_Roles_Select_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

/** input type for updating data in table "tenancy._team_account_roles" */
export type Tenancy__Team_Account_Roles_Set_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy__team_account_roles" */
export type Tenancy__Team_Account_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy__Team_Account_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy__Team_Account_Roles_Stream_Cursor_Value_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy._team_account_roles" */
export enum Tenancy__Team_Account_Roles_Update_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

export type Tenancy__Team_Account_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy__Team_Account_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy__Team_Account_Roles_Bool_Exp;
};

/** columns and relationships of "tenancy._user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles = {
  __typename?: 'tenancy__user_account_environment_config_roles';
  A: Scalars['String']['output'];
  B: Scalars['String']['output'];
  /** An object relationship */
  role: Tenancy_Roles;
  /** An object relationship */
  user_account_environment_config: Tenancy_User_Account_Environment_Config;
};

/** aggregated selection of "tenancy._user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles_Aggregate = {
  __typename?: 'tenancy__user_account_environment_config_roles_aggregate';
  aggregate?: Maybe<Tenancy__User_Account_Environment_Config_Roles_Aggregate_Fields>;
  nodes: Array<Tenancy__User_Account_Environment_Config_Roles>;
};

export type Tenancy__User_Account_Environment_Config_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Aggregate_Bool_Exp_Count>;
};

export type Tenancy__User_Account_Environment_Config_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy._user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles_Aggregate_Fields = {
  __typename?: 'tenancy__user_account_environment_config_roles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy__User_Account_Environment_Config_Roles_Max_Fields>;
  min?: Maybe<Tenancy__User_Account_Environment_Config_Roles_Min_Fields>;
};


/** aggregate fields of "tenancy._user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy._user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Max_Order_By>;
  min?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy._user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles_Arr_Rel_Insert_Input = {
  data: Array<Tenancy__User_Account_Environment_Config_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy._user_account_environment_config_roles". All fields are combined with a logical 'AND'. */
export type Tenancy__User_Account_Environment_Config_Roles_Bool_Exp = {
  A?: InputMaybe<String_Comparison_Exp>;
  B?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>>;
  _not?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>>;
  role?: InputMaybe<Tenancy_Roles_Bool_Exp>;
  user_account_environment_config?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy._user_account_environment_config_roles" */
export enum Tenancy__User_Account_Environment_Config_Roles_Constraint {
  /** unique or primary key constraint on columns "A", "B" */
  UserAccountEnvironmentConfigRolesAbUnique = '_user_account_environment_config_roles_AB_unique'
}

/** input type for inserting data into table "tenancy._user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles_Insert_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Tenancy_Roles_Obj_Rel_Insert_Input>;
  user_account_environment_config?: InputMaybe<Tenancy_User_Account_Environment_Config_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy__User_Account_Environment_Config_Roles_Max_Fields = {
  __typename?: 'tenancy__user_account_environment_config_roles_max_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy._user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles_Max_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy__User_Account_Environment_Config_Roles_Min_Fields = {
  __typename?: 'tenancy__user_account_environment_config_roles_min_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy._user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles_Min_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy._user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles_Mutation_Response = {
  __typename?: 'tenancy__user_account_environment_config_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy__User_Account_Environment_Config_Roles>;
};

/** on_conflict condition type for table "tenancy._user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles_On_Conflict = {
  constraint: Tenancy__User_Account_Environment_Config_Roles_Constraint;
  update_columns?: Array<Tenancy__User_Account_Environment_Config_Roles_Update_Column>;
  where?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy._user_account_environment_config_roles". */
export type Tenancy__User_Account_Environment_Config_Roles_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
  role?: InputMaybe<Tenancy_Roles_Order_By>;
  user_account_environment_config?: InputMaybe<Tenancy_User_Account_Environment_Config_Order_By>;
};

/** select columns of table "tenancy._user_account_environment_config_roles" */
export enum Tenancy__User_Account_Environment_Config_Roles_Select_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

/** input type for updating data in table "tenancy._user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles_Set_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy__user_account_environment_config_roles" */
export type Tenancy__User_Account_Environment_Config_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy__User_Account_Environment_Config_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy__User_Account_Environment_Config_Roles_Stream_Cursor_Value_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy._user_account_environment_config_roles" */
export enum Tenancy__User_Account_Environment_Config_Roles_Update_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

export type Tenancy__User_Account_Environment_Config_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy__User_Account_Environment_Config_Roles_Bool_Exp;
};

/** columns and relationships of "tenancy._user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles = {
  __typename?: 'tenancy__user_account_project_roles';
  A: Scalars['String']['output'];
  B: Scalars['String']['output'];
  /** An object relationship */
  role: Tenancy_Roles;
  /** An object relationship */
  user_account_project: Tenancy_User_Account_Projects;
};

/** aggregated selection of "tenancy._user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles_Aggregate = {
  __typename?: 'tenancy__user_account_project_roles_aggregate';
  aggregate?: Maybe<Tenancy__User_Account_Project_Roles_Aggregate_Fields>;
  nodes: Array<Tenancy__User_Account_Project_Roles>;
};

export type Tenancy__User_Account_Project_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy__User_Account_Project_Roles_Aggregate_Bool_Exp_Count>;
};

export type Tenancy__User_Account_Project_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy._user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles_Aggregate_Fields = {
  __typename?: 'tenancy__user_account_project_roles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy__User_Account_Project_Roles_Max_Fields>;
  min?: Maybe<Tenancy__User_Account_Project_Roles_Min_Fields>;
};


/** aggregate fields of "tenancy._user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy._user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy__User_Account_Project_Roles_Max_Order_By>;
  min?: InputMaybe<Tenancy__User_Account_Project_Roles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy._user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles_Arr_Rel_Insert_Input = {
  data: Array<Tenancy__User_Account_Project_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy__User_Account_Project_Roles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy._user_account_project_roles". All fields are combined with a logical 'AND'. */
export type Tenancy__User_Account_Project_Roles_Bool_Exp = {
  A?: InputMaybe<String_Comparison_Exp>;
  B?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Bool_Exp>>;
  _not?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Bool_Exp>>;
  role?: InputMaybe<Tenancy_Roles_Bool_Exp>;
  user_account_project?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy._user_account_project_roles" */
export enum Tenancy__User_Account_Project_Roles_Constraint {
  /** unique or primary key constraint on columns "A", "B" */
  UserAccountProjectRolesAbUnique = '_user_account_project_roles_AB_unique'
}

/** input type for inserting data into table "tenancy._user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles_Insert_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Tenancy_Roles_Obj_Rel_Insert_Input>;
  user_account_project?: InputMaybe<Tenancy_User_Account_Projects_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy__User_Account_Project_Roles_Max_Fields = {
  __typename?: 'tenancy__user_account_project_roles_max_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy._user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles_Max_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy__User_Account_Project_Roles_Min_Fields = {
  __typename?: 'tenancy__user_account_project_roles_min_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy._user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles_Min_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy._user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles_Mutation_Response = {
  __typename?: 'tenancy__user_account_project_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy__User_Account_Project_Roles>;
};

/** on_conflict condition type for table "tenancy._user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles_On_Conflict = {
  constraint: Tenancy__User_Account_Project_Roles_Constraint;
  update_columns?: Array<Tenancy__User_Account_Project_Roles_Update_Column>;
  where?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy._user_account_project_roles". */
export type Tenancy__User_Account_Project_Roles_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
  role?: InputMaybe<Tenancy_Roles_Order_By>;
  user_account_project?: InputMaybe<Tenancy_User_Account_Projects_Order_By>;
};

/** select columns of table "tenancy._user_account_project_roles" */
export enum Tenancy__User_Account_Project_Roles_Select_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

/** input type for updating data in table "tenancy._user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles_Set_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy__user_account_project_roles" */
export type Tenancy__User_Account_Project_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy__User_Account_Project_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy__User_Account_Project_Roles_Stream_Cursor_Value_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy._user_account_project_roles" */
export enum Tenancy__User_Account_Project_Roles_Update_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

export type Tenancy__User_Account_Project_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy__User_Account_Project_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy__User_Account_Project_Roles_Bool_Exp;
};

/** columns and relationships of "tenancy._user_account_roles" */
export type Tenancy__User_Account_Roles = {
  __typename?: 'tenancy__user_account_roles';
  A: Scalars['String']['output'];
  B: Scalars['String']['output'];
  /** An object relationship */
  role: Tenancy_Roles;
  /** An object relationship */
  user_account: Tenancy_User_Accounts;
};

/** aggregated selection of "tenancy._user_account_roles" */
export type Tenancy__User_Account_Roles_Aggregate = {
  __typename?: 'tenancy__user_account_roles_aggregate';
  aggregate?: Maybe<Tenancy__User_Account_Roles_Aggregate_Fields>;
  nodes: Array<Tenancy__User_Account_Roles>;
};

export type Tenancy__User_Account_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy__User_Account_Roles_Aggregate_Bool_Exp_Count>;
};

export type Tenancy__User_Account_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy__User_Account_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy._user_account_roles" */
export type Tenancy__User_Account_Roles_Aggregate_Fields = {
  __typename?: 'tenancy__user_account_roles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy__User_Account_Roles_Max_Fields>;
  min?: Maybe<Tenancy__User_Account_Roles_Min_Fields>;
};


/** aggregate fields of "tenancy._user_account_roles" */
export type Tenancy__User_Account_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy__User_Account_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy._user_account_roles" */
export type Tenancy__User_Account_Roles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy__User_Account_Roles_Max_Order_By>;
  min?: InputMaybe<Tenancy__User_Account_Roles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy._user_account_roles" */
export type Tenancy__User_Account_Roles_Arr_Rel_Insert_Input = {
  data: Array<Tenancy__User_Account_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy__User_Account_Roles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy._user_account_roles". All fields are combined with a logical 'AND'. */
export type Tenancy__User_Account_Roles_Bool_Exp = {
  A?: InputMaybe<String_Comparison_Exp>;
  B?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Tenancy__User_Account_Roles_Bool_Exp>>;
  _not?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy__User_Account_Roles_Bool_Exp>>;
  role?: InputMaybe<Tenancy_Roles_Bool_Exp>;
  user_account?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy._user_account_roles" */
export enum Tenancy__User_Account_Roles_Constraint {
  /** unique or primary key constraint on columns "A", "B" */
  UserAccountRolesAbUnique = '_user_account_roles_AB_unique'
}

/** input type for inserting data into table "tenancy._user_account_roles" */
export type Tenancy__User_Account_Roles_Insert_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Tenancy_Roles_Obj_Rel_Insert_Input>;
  user_account?: InputMaybe<Tenancy_User_Accounts_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy__User_Account_Roles_Max_Fields = {
  __typename?: 'tenancy__user_account_roles_max_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy._user_account_roles" */
export type Tenancy__User_Account_Roles_Max_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy__User_Account_Roles_Min_Fields = {
  __typename?: 'tenancy__user_account_roles_min_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy._user_account_roles" */
export type Tenancy__User_Account_Roles_Min_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy._user_account_roles" */
export type Tenancy__User_Account_Roles_Mutation_Response = {
  __typename?: 'tenancy__user_account_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy__User_Account_Roles>;
};

/** on_conflict condition type for table "tenancy._user_account_roles" */
export type Tenancy__User_Account_Roles_On_Conflict = {
  constraint: Tenancy__User_Account_Roles_Constraint;
  update_columns?: Array<Tenancy__User_Account_Roles_Update_Column>;
  where?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy._user_account_roles". */
export type Tenancy__User_Account_Roles_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
  role?: InputMaybe<Tenancy_Roles_Order_By>;
  user_account?: InputMaybe<Tenancy_User_Accounts_Order_By>;
};

/** select columns of table "tenancy._user_account_roles" */
export enum Tenancy__User_Account_Roles_Select_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

/** input type for updating data in table "tenancy._user_account_roles" */
export type Tenancy__User_Account_Roles_Set_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy__user_account_roles" */
export type Tenancy__User_Account_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy__User_Account_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy__User_Account_Roles_Stream_Cursor_Value_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy._user_account_roles" */
export enum Tenancy__User_Account_Roles_Update_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

export type Tenancy__User_Account_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy__User_Account_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy__User_Account_Roles_Bool_Exp;
};

/** columns and relationships of "tenancy._user_teams" */
export type Tenancy__User_Teams = {
  __typename?: 'tenancy__user_teams';
  A: Scalars['String']['output'];
  B: Scalars['String']['output'];
  /** An object relationship */
  team: Tenancy_Teams;
  /** An object relationship */
  user: Tenancy_Users;
};

/** aggregated selection of "tenancy._user_teams" */
export type Tenancy__User_Teams_Aggregate = {
  __typename?: 'tenancy__user_teams_aggregate';
  aggregate?: Maybe<Tenancy__User_Teams_Aggregate_Fields>;
  nodes: Array<Tenancy__User_Teams>;
};

export type Tenancy__User_Teams_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy__User_Teams_Aggregate_Bool_Exp_Count>;
};

export type Tenancy__User_Teams_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy__User_Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy._user_teams" */
export type Tenancy__User_Teams_Aggregate_Fields = {
  __typename?: 'tenancy__user_teams_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy__User_Teams_Max_Fields>;
  min?: Maybe<Tenancy__User_Teams_Min_Fields>;
};


/** aggregate fields of "tenancy._user_teams" */
export type Tenancy__User_Teams_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy__User_Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy._user_teams" */
export type Tenancy__User_Teams_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy__User_Teams_Max_Order_By>;
  min?: InputMaybe<Tenancy__User_Teams_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy._user_teams" */
export type Tenancy__User_Teams_Arr_Rel_Insert_Input = {
  data: Array<Tenancy__User_Teams_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy__User_Teams_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy._user_teams". All fields are combined with a logical 'AND'. */
export type Tenancy__User_Teams_Bool_Exp = {
  A?: InputMaybe<String_Comparison_Exp>;
  B?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Tenancy__User_Teams_Bool_Exp>>;
  _not?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy__User_Teams_Bool_Exp>>;
  team?: InputMaybe<Tenancy_Teams_Bool_Exp>;
  user?: InputMaybe<Tenancy_Users_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy._user_teams" */
export enum Tenancy__User_Teams_Constraint {
  /** unique or primary key constraint on columns "A", "B" */
  UserTeamsAbUnique = '_user_teams_AB_unique'
}

/** input type for inserting data into table "tenancy._user_teams" */
export type Tenancy__User_Teams_Insert_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Tenancy_Teams_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Tenancy_Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy__User_Teams_Max_Fields = {
  __typename?: 'tenancy__user_teams_max_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy._user_teams" */
export type Tenancy__User_Teams_Max_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy__User_Teams_Min_Fields = {
  __typename?: 'tenancy__user_teams_min_fields';
  A?: Maybe<Scalars['String']['output']>;
  B?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy._user_teams" */
export type Tenancy__User_Teams_Min_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy._user_teams" */
export type Tenancy__User_Teams_Mutation_Response = {
  __typename?: 'tenancy__user_teams_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy__User_Teams>;
};

/** on_conflict condition type for table "tenancy._user_teams" */
export type Tenancy__User_Teams_On_Conflict = {
  constraint: Tenancy__User_Teams_Constraint;
  update_columns?: Array<Tenancy__User_Teams_Update_Column>;
  where?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy._user_teams". */
export type Tenancy__User_Teams_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
  team?: InputMaybe<Tenancy_Teams_Order_By>;
  user?: InputMaybe<Tenancy_Users_Order_By>;
};

/** select columns of table "tenancy._user_teams" */
export enum Tenancy__User_Teams_Select_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

/** input type for updating data in table "tenancy._user_teams" */
export type Tenancy__User_Teams_Set_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy__user_teams" */
export type Tenancy__User_Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy__User_Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy__User_Teams_Stream_Cursor_Value_Input = {
  A?: InputMaybe<Scalars['String']['input']>;
  B?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy._user_teams" */
export enum Tenancy__User_Teams_Update_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

export type Tenancy__User_Teams_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy__User_Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy__User_Teams_Bool_Exp;
};

/** columns and relationships of "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings = {
  __typename?: 'tenancy_account_auth_method_settings';
  /** An object relationship */
  account: Tenancy_Accounts;
  accountId: Scalars['String']['output'];
  authMethodId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  auth_method?: Maybe<Tenancy_Auth_Method>;
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  customAuthMethodId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  custom_auth_method?: Maybe<Tenancy_Custom_Auth_Method>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  settings?: Maybe<Scalars['jsonb']['output']>;
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
  /** An array relationship */
  user_account_auth_method_settings: Array<Tenancy_User_Account_Auth_Method_Settings>;
  /** An aggregate relationship */
  user_account_auth_method_settings_aggregate: Tenancy_User_Account_Auth_Method_Settings_Aggregate;
};


/** columns and relationships of "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_SettingsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_SettingsUser_Account_Auth_Method_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_SettingsUser_Account_Auth_Method_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
};

/** aggregated selection of "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_Aggregate = {
  __typename?: 'tenancy_account_auth_method_settings_aggregate';
  aggregate?: Maybe<Tenancy_Account_Auth_Method_Settings_Aggregate_Fields>;
  nodes: Array<Tenancy_Account_Auth_Method_Settings>;
};

export type Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_Account_Auth_Method_Settings_Select_Column_Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_Account_Auth_Method_Settings_Select_Column_Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_Aggregate_Fields = {
  __typename?: 'tenancy_account_auth_method_settings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Account_Auth_Method_Settings_Max_Fields>;
  min?: Maybe<Tenancy_Account_Auth_Method_Settings_Min_Fields>;
};


/** aggregate fields of "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Max_Order_By>;
  min?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Account_Auth_Method_Settings_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Account_Auth_Method_Settings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Account_Auth_Method_Settings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.account_auth_method_settings". All fields are combined with a logical 'AND'. */
export type Tenancy_Account_Auth_Method_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Bool_Exp>>;
  account?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  accountId?: InputMaybe<String_Comparison_Exp>;
  authMethodId?: InputMaybe<String_Comparison_Exp>;
  auth_method?: InputMaybe<Tenancy_Auth_Method_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  customAuthMethodId?: InputMaybe<String_Comparison_Exp>;
  custom_auth_method?: InputMaybe<Tenancy_Custom_Auth_Method_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  isDefault?: InputMaybe<Boolean_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
  user_account_auth_method_settings?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
  user_account_auth_method_settings_aggregate?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.account_auth_method_settings" */
export enum Tenancy_Account_Auth_Method_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountAuthMethodSettingsPkey = 'account_auth_method_settings_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Account_Auth_Method_Settings_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Account_Auth_Method_Settings_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Account_Auth_Method_Settings_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_Insert_Input = {
  account?: InputMaybe<Tenancy_Accounts_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  authMethodId?: InputMaybe<Scalars['String']['input']>;
  auth_method?: InputMaybe<Tenancy_Auth_Method_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customAuthMethodId?: InputMaybe<Scalars['String']['input']>;
  custom_auth_method?: InputMaybe<Tenancy_Custom_Auth_Method_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  user_account_auth_method_settings?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Account_Auth_Method_Settings_Max_Fields = {
  __typename?: 'tenancy_account_auth_method_settings_max_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  authMethodId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customAuthMethodId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  authMethodId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  customAuthMethodId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Account_Auth_Method_Settings_Min_Fields = {
  __typename?: 'tenancy_account_auth_method_settings_min_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  authMethodId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customAuthMethodId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  authMethodId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  customAuthMethodId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_Mutation_Response = {
  __typename?: 'tenancy_account_auth_method_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Account_Auth_Method_Settings>;
};

/** input type for inserting object relation for remote table "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_Obj_Rel_Insert_Input = {
  data: Tenancy_Account_Auth_Method_Settings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Account_Auth_Method_Settings_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_On_Conflict = {
  constraint: Tenancy_Account_Auth_Method_Settings_Constraint;
  update_columns?: Array<Tenancy_Account_Auth_Method_Settings_Update_Column>;
  where?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.account_auth_method_settings". */
export type Tenancy_Account_Auth_Method_Settings_Order_By = {
  account?: InputMaybe<Tenancy_Accounts_Order_By>;
  accountId?: InputMaybe<Order_By>;
  authMethodId?: InputMaybe<Order_By>;
  auth_method?: InputMaybe<Tenancy_Auth_Method_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  customAuthMethodId?: InputMaybe<Order_By>;
  custom_auth_method?: InputMaybe<Tenancy_Custom_Auth_Method_Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  isDefault?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  user_account_auth_method_settings_aggregate?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Aggregate_Order_By>;
};

/** primary key columns input for table: tenancy.account_auth_method_settings */
export type Tenancy_Account_Auth_Method_Settings_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Account_Auth_Method_Settings_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.account_auth_method_settings" */
export enum Tenancy_Account_Auth_Method_Settings_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AuthMethodId = 'authMethodId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CustomAuthMethodId = 'customAuthMethodId',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsDefault = 'isDefault',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** select "tenancy_account_auth_method_settings_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.account_auth_method_settings" */
export enum Tenancy_Account_Auth_Method_Settings_Select_Column_Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsDefault = 'isDefault'
}

/** select "tenancy_account_auth_method_settings_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.account_auth_method_settings" */
export enum Tenancy_Account_Auth_Method_Settings_Select_Column_Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsDefault = 'isDefault'
}

/** input type for updating data in table "tenancy.account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_Set_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  authMethodId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customAuthMethodId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_account_auth_method_settings" */
export type Tenancy_Account_Auth_Method_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Account_Auth_Method_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Account_Auth_Method_Settings_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  authMethodId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customAuthMethodId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.account_auth_method_settings" */
export enum Tenancy_Account_Auth_Method_Settings_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AuthMethodId = 'authMethodId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CustomAuthMethodId = 'customAuthMethodId',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsDefault = 'isDefault',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type Tenancy_Account_Auth_Method_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Account_Auth_Method_Settings_Bool_Exp;
};

/** columns and relationships of "tenancy.accounts" */
export type Tenancy_Accounts = {
  __typename?: 'tenancy_accounts';
  /** An object relationship */
  account?: Maybe<Tenancy_Accounts>;
  accountManagerId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  account_auth_method_settings: Array<Tenancy_Account_Auth_Method_Settings>;
  /** An aggregate relationship */
  account_auth_method_settings_aggregate: Tenancy_Account_Auth_Method_Settings_Aggregate;
  /** An array relationship */
  accounts: Array<Tenancy_Accounts>;
  /** An aggregate relationship */
  accounts_aggregate: Tenancy_Accounts_Aggregate;
  allParentIds?: Maybe<Array<Scalars['String']['output']>>;
  allParentIdsString?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  audit_logs: Array<Tenancy_Audit_Logs>;
  /** An aggregate relationship */
  audit_logs_aggregate: Tenancy_Audit_Logs_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  /** An array relationship */
  custom_auth_methods: Array<Tenancy_Custom_Auth_Method>;
  /** An aggregate relationship */
  custom_auth_methods_aggregate: Tenancy_Custom_Auth_Method_Aggregate;
  /** An array relationship */
  files: Array<Tenancy_File>;
  /** An aggregate relationship */
  files_aggregate: Tenancy_File_Aggregate;
  hasGiteaIntegration: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isManaged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  projects: Array<Tenancy_Projects>;
  /** An aggregate relationship */
  projects_aggregate: Tenancy_Projects_Aggregate;
  /** An array relationship */
  roles: Array<Tenancy_Roles>;
  /** An aggregate relationship */
  roles_aggregate: Tenancy_Roles_Aggregate;
  settings?: Maybe<Scalars['jsonb']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  /** An array relationship */
  team_accounts: Array<Tenancy_Team_Accounts>;
  /** An aggregate relationship */
  team_accounts_aggregate: Tenancy_Team_Accounts_Aggregate;
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<Tenancy_Users>;
  /** An array relationship */
  user_accounts: Array<Tenancy_User_Accounts>;
  /** An aggregate relationship */
  user_accounts_aggregate: Tenancy_User_Accounts_Aggregate;
  /** An array relationship */
  variables: Array<Tenancy_Variable>;
  /** An aggregate relationship */
  variables_aggregate: Tenancy_Variable_Aggregate;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsAccount_Auth_Method_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsAccount_Auth_Method_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsAccountsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsAudit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Audit_Logs_Order_By>>;
  where?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsAudit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Audit_Logs_Order_By>>;
  where?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsCustom_Auth_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Order_By>>;
  where?: InputMaybe<Tenancy_Custom_Auth_Method_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsCustom_Auth_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Order_By>>;
  where?: InputMaybe<Tenancy_Custom_Auth_Method_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsFilesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Projects_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Projects_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsRolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Roles_Order_By>>;
  where?: InputMaybe<Tenancy_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Roles_Order_By>>;
  where?: InputMaybe<Tenancy_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsTeam_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsTeam_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsUser_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsUser_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsVariablesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Variable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Variable_Order_By>>;
  where?: InputMaybe<Tenancy_Variable_Bool_Exp>;
};


/** columns and relationships of "tenancy.accounts" */
export type Tenancy_AccountsVariables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Variable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Variable_Order_By>>;
  where?: InputMaybe<Tenancy_Variable_Bool_Exp>;
};

/** aggregated selection of "tenancy.accounts" */
export type Tenancy_Accounts_Aggregate = {
  __typename?: 'tenancy_accounts_aggregate';
  aggregate?: Maybe<Tenancy_Accounts_Aggregate_Fields>;
  nodes: Array<Tenancy_Accounts>;
};

export type Tenancy_Accounts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_Accounts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_Accounts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_Accounts_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Accounts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_Accounts_Select_Column_Tenancy_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Accounts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_Accounts_Select_Column_Tenancy_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Accounts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.accounts" */
export type Tenancy_Accounts_Aggregate_Fields = {
  __typename?: 'tenancy_accounts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Accounts_Max_Fields>;
  min?: Maybe<Tenancy_Accounts_Min_Fields>;
};


/** aggregate fields of "tenancy.accounts" */
export type Tenancy_Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.accounts" */
export type Tenancy_Accounts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Accounts_Max_Order_By>;
  min?: InputMaybe<Tenancy_Accounts_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Accounts_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.accounts" */
export type Tenancy_Accounts_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Accounts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Accounts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.accounts". All fields are combined with a logical 'AND'. */
export type Tenancy_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Accounts_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Accounts_Bool_Exp>>;
  account?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  accountManagerId?: InputMaybe<String_Comparison_Exp>;
  account_auth_method_settings?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
  account_auth_method_settings_aggregate?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp>;
  accounts?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  accounts_aggregate?: InputMaybe<Tenancy_Accounts_Aggregate_Bool_Exp>;
  allParentIds?: InputMaybe<String_Array_Comparison_Exp>;
  allParentIdsString?: InputMaybe<String_Comparison_Exp>;
  audit_logs?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
  audit_logs_aggregate?: InputMaybe<Tenancy_Audit_Logs_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  custom_auth_methods?: InputMaybe<Tenancy_Custom_Auth_Method_Bool_Exp>;
  custom_auth_methods_aggregate?: InputMaybe<Tenancy_Custom_Auth_Method_Aggregate_Bool_Exp>;
  files?: InputMaybe<Tenancy_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Tenancy_File_Aggregate_Bool_Exp>;
  hasGiteaIntegration?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isManaged?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parentId?: InputMaybe<String_Comparison_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  projects?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  projects_aggregate?: InputMaybe<Tenancy_Projects_Aggregate_Bool_Exp>;
  roles?: InputMaybe<Tenancy_Roles_Bool_Exp>;
  roles_aggregate?: InputMaybe<Tenancy_Roles_Aggregate_Bool_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  shortId?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  team_accounts?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
  team_accounts_aggregate?: InputMaybe<Tenancy_Team_Accounts_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Tenancy_Users_Bool_Exp>;
  user_accounts?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
  user_accounts_aggregate?: InputMaybe<Tenancy_User_Accounts_Aggregate_Bool_Exp>;
  variables?: InputMaybe<Tenancy_Variable_Bool_Exp>;
  variables_aggregate?: InputMaybe<Tenancy_Variable_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.accounts" */
export enum Tenancy_Accounts_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountsPkey = 'accounts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Accounts_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Accounts_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Accounts_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.accounts" */
export type Tenancy_Accounts_Insert_Input = {
  account?: InputMaybe<Tenancy_Accounts_Obj_Rel_Insert_Input>;
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  account_auth_method_settings?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Arr_Rel_Insert_Input>;
  accounts?: InputMaybe<Tenancy_Accounts_Arr_Rel_Insert_Input>;
  allParentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  allParentIdsString?: InputMaybe<Scalars['String']['input']>;
  audit_logs?: InputMaybe<Tenancy_Audit_Logs_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  custom_auth_methods?: InputMaybe<Tenancy_Custom_Auth_Method_Arr_Rel_Insert_Input>;
  files?: InputMaybe<Tenancy_File_Arr_Rel_Insert_Input>;
  hasGiteaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isManaged?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Tenancy_Projects_Arr_Rel_Insert_Input>;
  roles?: InputMaybe<Tenancy_Roles_Arr_Rel_Insert_Input>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team_accounts?: InputMaybe<Tenancy_Team_Accounts_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Tenancy_Users_Obj_Rel_Insert_Input>;
  user_accounts?: InputMaybe<Tenancy_User_Accounts_Arr_Rel_Insert_Input>;
  variables?: InputMaybe<Tenancy_Variable_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Accounts_Max_Fields = {
  __typename?: 'tenancy_accounts_max_fields';
  accountManagerId?: Maybe<Scalars['String']['output']>;
  allParentIds?: Maybe<Array<Scalars['String']['output']>>;
  allParentIdsString?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.accounts" */
export type Tenancy_Accounts_Max_Order_By = {
  accountManagerId?: InputMaybe<Order_By>;
  allParentIds?: InputMaybe<Order_By>;
  allParentIdsString?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Accounts_Min_Fields = {
  __typename?: 'tenancy_accounts_min_fields';
  accountManagerId?: Maybe<Scalars['String']['output']>;
  allParentIds?: Maybe<Array<Scalars['String']['output']>>;
  allParentIdsString?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.accounts" */
export type Tenancy_Accounts_Min_Order_By = {
  accountManagerId?: InputMaybe<Order_By>;
  allParentIds?: InputMaybe<Order_By>;
  allParentIdsString?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.accounts" */
export type Tenancy_Accounts_Mutation_Response = {
  __typename?: 'tenancy_accounts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Accounts>;
};

/** input type for inserting object relation for remote table "tenancy.accounts" */
export type Tenancy_Accounts_Obj_Rel_Insert_Input = {
  data: Tenancy_Accounts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Accounts_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.accounts" */
export type Tenancy_Accounts_On_Conflict = {
  constraint: Tenancy_Accounts_Constraint;
  update_columns?: Array<Tenancy_Accounts_Update_Column>;
  where?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.accounts". */
export type Tenancy_Accounts_Order_By = {
  account?: InputMaybe<Tenancy_Accounts_Order_By>;
  accountManagerId?: InputMaybe<Order_By>;
  account_auth_method_settings_aggregate?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Aggregate_Order_By>;
  accounts_aggregate?: InputMaybe<Tenancy_Accounts_Aggregate_Order_By>;
  allParentIds?: InputMaybe<Order_By>;
  allParentIdsString?: InputMaybe<Order_By>;
  audit_logs_aggregate?: InputMaybe<Tenancy_Audit_Logs_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  custom_auth_methods_aggregate?: InputMaybe<Tenancy_Custom_Auth_Method_Aggregate_Order_By>;
  files_aggregate?: InputMaybe<Tenancy_File_Aggregate_Order_By>;
  hasGiteaIntegration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isManaged?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Tenancy_Projects_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<Tenancy_Roles_Aggregate_Order_By>;
  settings?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  team_accounts_aggregate?: InputMaybe<Tenancy_Team_Accounts_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  user?: InputMaybe<Tenancy_Users_Order_By>;
  user_accounts_aggregate?: InputMaybe<Tenancy_User_Accounts_Aggregate_Order_By>;
  variables_aggregate?: InputMaybe<Tenancy_Variable_Aggregate_Order_By>;
};

/** primary key columns input for table: tenancy.accounts */
export type Tenancy_Accounts_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Accounts_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.accounts" */
export enum Tenancy_Accounts_Select_Column {
  /** column name */
  AccountManagerId = 'accountManagerId',
  /** column name */
  AllParentIds = 'allParentIds',
  /** column name */
  AllParentIdsString = 'allParentIdsString',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  HasGiteaIntegration = 'hasGiteaIntegration',
  /** column name */
  Id = 'id',
  /** column name */
  IsManaged = 'isManaged',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  Picture = 'picture',
  /** column name */
  Settings = 'settings',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** select "tenancy_accounts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.accounts" */
export enum Tenancy_Accounts_Select_Column_Tenancy_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasGiteaIntegration = 'hasGiteaIntegration',
  /** column name */
  IsManaged = 'isManaged'
}

/** select "tenancy_accounts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.accounts" */
export enum Tenancy_Accounts_Select_Column_Tenancy_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasGiteaIntegration = 'hasGiteaIntegration',
  /** column name */
  IsManaged = 'isManaged'
}

/** input type for updating data in table "tenancy.accounts" */
export type Tenancy_Accounts_Set_Input = {
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  allParentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  allParentIdsString?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  hasGiteaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isManaged?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_accounts" */
export type Tenancy_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Accounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Accounts_Stream_Cursor_Value_Input = {
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  allParentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  allParentIdsString?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  hasGiteaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isManaged?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.accounts" */
export enum Tenancy_Accounts_Update_Column {
  /** column name */
  AccountManagerId = 'accountManagerId',
  /** column name */
  AllParentIds = 'allParentIds',
  /** column name */
  AllParentIdsString = 'allParentIdsString',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  HasGiteaIntegration = 'hasGiteaIntegration',
  /** column name */
  Id = 'id',
  /** column name */
  IsManaged = 'isManaged',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  Picture = 'picture',
  /** column name */
  Settings = 'settings',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type Tenancy_Accounts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Accounts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Accounts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Accounts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Accounts_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Accounts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Accounts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Accounts_Bool_Exp;
};

/** columns and relationships of "tenancy.action" */
export type Tenancy_Action = {
  __typename?: 'tenancy_action';
  appletInstanceId: Scalars['String']['output'];
  /** An object relationship */
  applet_instance: Tenancy_Applet_Instance;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latestVersionWhileCreating?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  package?: Maybe<Tenancy_Package>;
  packageId?: Maybe<Scalars['String']['output']>;
  packageVersionId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  package_version?: Maybe<Tenancy_Package_Version>;
};


/** columns and relationships of "tenancy.action" */
export type Tenancy_ActionOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.action" */
export type Tenancy_Action_Aggregate = {
  __typename?: 'tenancy_action_aggregate';
  aggregate?: Maybe<Tenancy_Action_Aggregate_Fields>;
  nodes: Array<Tenancy_Action>;
};

export type Tenancy_Action_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Action_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Action_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Action_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.action" */
export type Tenancy_Action_Aggregate_Fields = {
  __typename?: 'tenancy_action_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Action_Max_Fields>;
  min?: Maybe<Tenancy_Action_Min_Fields>;
};


/** aggregate fields of "tenancy.action" */
export type Tenancy_Action_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.action" */
export type Tenancy_Action_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Action_Max_Order_By>;
  min?: InputMaybe<Tenancy_Action_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Action_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.action" */
export type Tenancy_Action_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Action_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Action_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.action". All fields are combined with a logical 'AND'. */
export type Tenancy_Action_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Action_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Action_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Action_Bool_Exp>>;
  appletInstanceId?: InputMaybe<String_Comparison_Exp>;
  applet_instance?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  latestVersionWhileCreating?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  package?: InputMaybe<Tenancy_Package_Bool_Exp>;
  packageId?: InputMaybe<String_Comparison_Exp>;
  packageVersionId?: InputMaybe<String_Comparison_Exp>;
  package_version?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.action" */
export enum Tenancy_Action_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActionPkey = 'action_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Action_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Action_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Action_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.action" */
export type Tenancy_Action_Insert_Input = {
  appletInstanceId?: InputMaybe<Scalars['String']['input']>;
  applet_instance?: InputMaybe<Tenancy_Applet_Instance_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionWhileCreating?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  package?: InputMaybe<Tenancy_Package_Obj_Rel_Insert_Input>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  packageVersionId?: InputMaybe<Scalars['String']['input']>;
  package_version?: InputMaybe<Tenancy_Package_Version_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Action_Max_Fields = {
  __typename?: 'tenancy_action_max_fields';
  appletInstanceId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latestVersionWhileCreating?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  packageVersionId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.action" */
export type Tenancy_Action_Max_Order_By = {
  appletInstanceId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionWhileCreating?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  packageId?: InputMaybe<Order_By>;
  packageVersionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Action_Min_Fields = {
  __typename?: 'tenancy_action_min_fields';
  appletInstanceId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latestVersionWhileCreating?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  packageVersionId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.action" */
export type Tenancy_Action_Min_Order_By = {
  appletInstanceId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionWhileCreating?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  packageId?: InputMaybe<Order_By>;
  packageVersionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.action" */
export type Tenancy_Action_Mutation_Response = {
  __typename?: 'tenancy_action_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Action>;
};

/** columns and relationships of "tenancy.action_node_job" */
export type Tenancy_Action_Node_Job = {
  __typename?: 'tenancy_action_node_job';
  createdOn: Scalars['timestamp']['output'];
  customerName: Scalars['String']['output'];
  environment: Scalars['ActionNodeJobEnvironment']['output'];
  errors?: Maybe<Scalars['jsonb']['output']>;
  finishedOn?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['String']['output'];
  jobType: Scalars['ActionNodeJobType']['output'];
  payload: Scalars['jsonb']['output'];
  projectId: Scalars['String']['output'];
  runtime: Scalars['String']['output'];
  service: Scalars['String']['output'];
  /** An object relationship */
  solution?: Maybe<Tenancy_Solutions>;
  solutionId?: Maybe<Scalars['String']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  solution_version?: Maybe<Tenancy_Solution_Versions>;
  status: Scalars['ActionNodeJobStatus']['output'];
  trigger: Scalars['ActionNodeJobTrigger']['output'];
  updatedOn: Scalars['timestamp']['output'];
};


/** columns and relationships of "tenancy.action_node_job" */
export type Tenancy_Action_Node_JobErrorsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.action_node_job" */
export type Tenancy_Action_Node_JobPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.action_node_job" */
export type Tenancy_Action_Node_Job_Aggregate = {
  __typename?: 'tenancy_action_node_job_aggregate';
  aggregate?: Maybe<Tenancy_Action_Node_Job_Aggregate_Fields>;
  nodes: Array<Tenancy_Action_Node_Job>;
};

export type Tenancy_Action_Node_Job_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Action_Node_Job_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Action_Node_Job_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Action_Node_Job_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.action_node_job" */
export type Tenancy_Action_Node_Job_Aggregate_Fields = {
  __typename?: 'tenancy_action_node_job_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Action_Node_Job_Max_Fields>;
  min?: Maybe<Tenancy_Action_Node_Job_Min_Fields>;
};


/** aggregate fields of "tenancy.action_node_job" */
export type Tenancy_Action_Node_Job_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Action_Node_Job_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.action_node_job" */
export type Tenancy_Action_Node_Job_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Action_Node_Job_Max_Order_By>;
  min?: InputMaybe<Tenancy_Action_Node_Job_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Action_Node_Job_Append_Input = {
  errors?: InputMaybe<Scalars['jsonb']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.action_node_job" */
export type Tenancy_Action_Node_Job_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Action_Node_Job_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Action_Node_Job_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.action_node_job". All fields are combined with a logical 'AND'. */
export type Tenancy_Action_Node_Job_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Action_Node_Job_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Action_Node_Job_Bool_Exp>>;
  createdOn?: InputMaybe<Timestamp_Comparison_Exp>;
  customerName?: InputMaybe<String_Comparison_Exp>;
  environment?: InputMaybe<ActionNodeJobEnvironment_Comparison_Exp>;
  errors?: InputMaybe<Jsonb_Comparison_Exp>;
  finishedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  jobType?: InputMaybe<ActionNodeJobType_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  runtime?: InputMaybe<String_Comparison_Exp>;
  service?: InputMaybe<String_Comparison_Exp>;
  solution?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
  solutionId?: InputMaybe<String_Comparison_Exp>;
  solutionVersionId?: InputMaybe<String_Comparison_Exp>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  status?: InputMaybe<ActionNodeJobStatus_Comparison_Exp>;
  trigger?: InputMaybe<ActionNodeJobTrigger_Comparison_Exp>;
  updatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.action_node_job" */
export enum Tenancy_Action_Node_Job_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActionNodeJobPkey = 'action_node_job_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Action_Node_Job_Delete_At_Path_Input = {
  errors?: InputMaybe<Array<Scalars['String']['input']>>;
  payload?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Action_Node_Job_Delete_Elem_Input = {
  errors?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Action_Node_Job_Delete_Key_Input = {
  errors?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.action_node_job" */
export type Tenancy_Action_Node_Job_Insert_Input = {
  createdOn?: InputMaybe<Scalars['timestamp']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['ActionNodeJobEnvironment']['input']>;
  errors?: InputMaybe<Scalars['jsonb']['input']>;
  finishedOn?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['ActionNodeJobType']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Tenancy_Solutions_Obj_Rel_Insert_Input>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['ActionNodeJobStatus']['input']>;
  trigger?: InputMaybe<Scalars['ActionNodeJobTrigger']['input']>;
  updatedOn?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Action_Node_Job_Max_Fields = {
  __typename?: 'tenancy_action_node_job_max_fields';
  createdOn?: Maybe<Scalars['timestamp']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['ActionNodeJobEnvironment']['output']>;
  finishedOn?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  jobType?: Maybe<Scalars['ActionNodeJobType']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  runtime?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  solutionId?: Maybe<Scalars['String']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['ActionNodeJobStatus']['output']>;
  trigger?: Maybe<Scalars['ActionNodeJobTrigger']['output']>;
  updatedOn?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.action_node_job" */
export type Tenancy_Action_Node_Job_Max_Order_By = {
  createdOn?: InputMaybe<Order_By>;
  customerName?: InputMaybe<Order_By>;
  environment?: InputMaybe<Order_By>;
  finishedOn?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobType?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  runtime?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  solutionId?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trigger?: InputMaybe<Order_By>;
  updatedOn?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Action_Node_Job_Min_Fields = {
  __typename?: 'tenancy_action_node_job_min_fields';
  createdOn?: Maybe<Scalars['timestamp']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['ActionNodeJobEnvironment']['output']>;
  finishedOn?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  jobType?: Maybe<Scalars['ActionNodeJobType']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  runtime?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  solutionId?: Maybe<Scalars['String']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['ActionNodeJobStatus']['output']>;
  trigger?: Maybe<Scalars['ActionNodeJobTrigger']['output']>;
  updatedOn?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.action_node_job" */
export type Tenancy_Action_Node_Job_Min_Order_By = {
  createdOn?: InputMaybe<Order_By>;
  customerName?: InputMaybe<Order_By>;
  environment?: InputMaybe<Order_By>;
  finishedOn?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobType?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  runtime?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  solutionId?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trigger?: InputMaybe<Order_By>;
  updatedOn?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.action_node_job" */
export type Tenancy_Action_Node_Job_Mutation_Response = {
  __typename?: 'tenancy_action_node_job_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Action_Node_Job>;
};

/** on_conflict condition type for table "tenancy.action_node_job" */
export type Tenancy_Action_Node_Job_On_Conflict = {
  constraint: Tenancy_Action_Node_Job_Constraint;
  update_columns?: Array<Tenancy_Action_Node_Job_Update_Column>;
  where?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.action_node_job". */
export type Tenancy_Action_Node_Job_Order_By = {
  createdOn?: InputMaybe<Order_By>;
  customerName?: InputMaybe<Order_By>;
  environment?: InputMaybe<Order_By>;
  errors?: InputMaybe<Order_By>;
  finishedOn?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobType?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  runtime?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  solution?: InputMaybe<Tenancy_Solutions_Order_By>;
  solutionId?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Order_By>;
  status?: InputMaybe<Order_By>;
  trigger?: InputMaybe<Order_By>;
  updatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.action_node_job */
export type Tenancy_Action_Node_Job_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Action_Node_Job_Prepend_Input = {
  errors?: InputMaybe<Scalars['jsonb']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.action_node_job" */
export enum Tenancy_Action_Node_Job_Select_Column {
  /** column name */
  CreatedOn = 'createdOn',
  /** column name */
  CustomerName = 'customerName',
  /** column name */
  Environment = 'environment',
  /** column name */
  Errors = 'errors',
  /** column name */
  FinishedOn = 'finishedOn',
  /** column name */
  Id = 'id',
  /** column name */
  JobType = 'jobType',
  /** column name */
  Payload = 'payload',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  Runtime = 'runtime',
  /** column name */
  Service = 'service',
  /** column name */
  SolutionId = 'solutionId',
  /** column name */
  SolutionVersionId = 'solutionVersionId',
  /** column name */
  Status = 'status',
  /** column name */
  Trigger = 'trigger',
  /** column name */
  UpdatedOn = 'updatedOn'
}

/** input type for updating data in table "tenancy.action_node_job" */
export type Tenancy_Action_Node_Job_Set_Input = {
  createdOn?: InputMaybe<Scalars['timestamp']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['ActionNodeJobEnvironment']['input']>;
  errors?: InputMaybe<Scalars['jsonb']['input']>;
  finishedOn?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['ActionNodeJobType']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['ActionNodeJobStatus']['input']>;
  trigger?: InputMaybe<Scalars['ActionNodeJobTrigger']['input']>;
  updatedOn?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_action_node_job" */
export type Tenancy_Action_Node_Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Action_Node_Job_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Action_Node_Job_Stream_Cursor_Value_Input = {
  createdOn?: InputMaybe<Scalars['timestamp']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['ActionNodeJobEnvironment']['input']>;
  errors?: InputMaybe<Scalars['jsonb']['input']>;
  finishedOn?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['ActionNodeJobType']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['ActionNodeJobStatus']['input']>;
  trigger?: InputMaybe<Scalars['ActionNodeJobTrigger']['input']>;
  updatedOn?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.action_node_job" */
export enum Tenancy_Action_Node_Job_Update_Column {
  /** column name */
  CreatedOn = 'createdOn',
  /** column name */
  CustomerName = 'customerName',
  /** column name */
  Environment = 'environment',
  /** column name */
  Errors = 'errors',
  /** column name */
  FinishedOn = 'finishedOn',
  /** column name */
  Id = 'id',
  /** column name */
  JobType = 'jobType',
  /** column name */
  Payload = 'payload',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  Runtime = 'runtime',
  /** column name */
  Service = 'service',
  /** column name */
  SolutionId = 'solutionId',
  /** column name */
  SolutionVersionId = 'solutionVersionId',
  /** column name */
  Status = 'status',
  /** column name */
  Trigger = 'trigger',
  /** column name */
  UpdatedOn = 'updatedOn'
}

export type Tenancy_Action_Node_Job_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Action_Node_Job_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Action_Node_Job_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Action_Node_Job_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Action_Node_Job_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Action_Node_Job_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Action_Node_Job_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Action_Node_Job_Bool_Exp;
};

/** on_conflict condition type for table "tenancy.action" */
export type Tenancy_Action_On_Conflict = {
  constraint: Tenancy_Action_Constraint;
  update_columns?: Array<Tenancy_Action_Update_Column>;
  where?: InputMaybe<Tenancy_Action_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.action". */
export type Tenancy_Action_Order_By = {
  appletInstanceId?: InputMaybe<Order_By>;
  applet_instance?: InputMaybe<Tenancy_Applet_Instance_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionWhileCreating?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  package?: InputMaybe<Tenancy_Package_Order_By>;
  packageId?: InputMaybe<Order_By>;
  packageVersionId?: InputMaybe<Order_By>;
  package_version?: InputMaybe<Tenancy_Package_Version_Order_By>;
};

/** primary key columns input for table: tenancy.action */
export type Tenancy_Action_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Action_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.action" */
export enum Tenancy_Action_Select_Column {
  /** column name */
  AppletInstanceId = 'appletInstanceId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LatestVersionWhileCreating = 'latestVersionWhileCreating',
  /** column name */
  Name = 'name',
  /** column name */
  Options = 'options',
  /** column name */
  PackageId = 'packageId',
  /** column name */
  PackageVersionId = 'packageVersionId'
}

/** input type for updating data in table "tenancy.action" */
export type Tenancy_Action_Set_Input = {
  appletInstanceId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionWhileCreating?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  packageVersionId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_action" */
export type Tenancy_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Action_Stream_Cursor_Value_Input = {
  appletInstanceId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionWhileCreating?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  packageVersionId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.action" */
export enum Tenancy_Action_Update_Column {
  /** column name */
  AppletInstanceId = 'appletInstanceId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LatestVersionWhileCreating = 'latestVersionWhileCreating',
  /** column name */
  Name = 'name',
  /** column name */
  Options = 'options',
  /** column name */
  PackageId = 'packageId',
  /** column name */
  PackageVersionId = 'packageVersionId'
}

export type Tenancy_Action_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Action_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Action_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Action_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Action_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Action_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Action_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Action_Bool_Exp;
};

/** columns and relationships of "tenancy.app_config" */
export type Tenancy_App_Config = {
  __typename?: 'tenancy_app_config';
  id: Scalars['String']['output'];
  isAnalyticsEventsReported: Scalars['Boolean']['output'];
  isCustomAuthMethodsSeeded: Scalars['Boolean']['output'];
  isShortIdsAssigned: Scalars['Boolean']['output'];
  kafkaOffset: Scalars['String']['output'];
};

/** aggregated selection of "tenancy.app_config" */
export type Tenancy_App_Config_Aggregate = {
  __typename?: 'tenancy_app_config_aggregate';
  aggregate?: Maybe<Tenancy_App_Config_Aggregate_Fields>;
  nodes: Array<Tenancy_App_Config>;
};

/** aggregate fields of "tenancy.app_config" */
export type Tenancy_App_Config_Aggregate_Fields = {
  __typename?: 'tenancy_app_config_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_App_Config_Max_Fields>;
  min?: Maybe<Tenancy_App_Config_Min_Fields>;
};


/** aggregate fields of "tenancy.app_config" */
export type Tenancy_App_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_App_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.app_config". All fields are combined with a logical 'AND'. */
export type Tenancy_App_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_App_Config_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_App_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_App_Config_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  isAnalyticsEventsReported?: InputMaybe<Boolean_Comparison_Exp>;
  isCustomAuthMethodsSeeded?: InputMaybe<Boolean_Comparison_Exp>;
  isShortIdsAssigned?: InputMaybe<Boolean_Comparison_Exp>;
  kafkaOffset?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.app_config" */
export enum Tenancy_App_Config_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppConfigPkey = 'app_config_pkey'
}

/** input type for inserting data into table "tenancy.app_config" */
export type Tenancy_App_Config_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  isAnalyticsEventsReported?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomAuthMethodsSeeded?: InputMaybe<Scalars['Boolean']['input']>;
  isShortIdsAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  kafkaOffset?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_App_Config_Max_Fields = {
  __typename?: 'tenancy_app_config_max_fields';
  id?: Maybe<Scalars['String']['output']>;
  kafkaOffset?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tenancy_App_Config_Min_Fields = {
  __typename?: 'tenancy_app_config_min_fields';
  id?: Maybe<Scalars['String']['output']>;
  kafkaOffset?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tenancy.app_config" */
export type Tenancy_App_Config_Mutation_Response = {
  __typename?: 'tenancy_app_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_App_Config>;
};

/** on_conflict condition type for table "tenancy.app_config" */
export type Tenancy_App_Config_On_Conflict = {
  constraint: Tenancy_App_Config_Constraint;
  update_columns?: Array<Tenancy_App_Config_Update_Column>;
  where?: InputMaybe<Tenancy_App_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.app_config". */
export type Tenancy_App_Config_Order_By = {
  id?: InputMaybe<Order_By>;
  isAnalyticsEventsReported?: InputMaybe<Order_By>;
  isCustomAuthMethodsSeeded?: InputMaybe<Order_By>;
  isShortIdsAssigned?: InputMaybe<Order_By>;
  kafkaOffset?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.app_config */
export type Tenancy_App_Config_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.app_config" */
export enum Tenancy_App_Config_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsAnalyticsEventsReported = 'isAnalyticsEventsReported',
  /** column name */
  IsCustomAuthMethodsSeeded = 'isCustomAuthMethodsSeeded',
  /** column name */
  IsShortIdsAssigned = 'isShortIdsAssigned',
  /** column name */
  KafkaOffset = 'kafkaOffset'
}

/** input type for updating data in table "tenancy.app_config" */
export type Tenancy_App_Config_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  isAnalyticsEventsReported?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomAuthMethodsSeeded?: InputMaybe<Scalars['Boolean']['input']>;
  isShortIdsAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  kafkaOffset?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_app_config" */
export type Tenancy_App_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_App_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_App_Config_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  isAnalyticsEventsReported?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomAuthMethodsSeeded?: InputMaybe<Scalars['Boolean']['input']>;
  isShortIdsAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  kafkaOffset?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.app_config" */
export enum Tenancy_App_Config_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsAnalyticsEventsReported = 'isAnalyticsEventsReported',
  /** column name */
  IsCustomAuthMethodsSeeded = 'isCustomAuthMethodsSeeded',
  /** column name */
  IsShortIdsAssigned = 'isShortIdsAssigned',
  /** column name */
  KafkaOffset = 'kafkaOffset'
}

export type Tenancy_App_Config_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_App_Config_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_App_Config_Bool_Exp;
};

/** columns and relationships of "tenancy.applet" */
export type Tenancy_Applet = {
  __typename?: 'tenancy_applet';
  appletCategory: Scalars['AppletCategory']['output'];
  appletType: Scalars['AppletType']['output'];
  /** An object relationship */
  applet_version?: Maybe<Tenancy_Applet_Version>;
  /** An array relationship */
  applet_versions: Array<Tenancy_Applet_Version>;
  /** An aggregate relationship */
  applet_versions_aggregate: Tenancy_Applet_Version_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  files: Array<Tenancy_File>;
  /** An aggregate relationship */
  files_aggregate: Tenancy_File_Aggregate;
  id: Scalars['String']['output'];
  latestVersionId?: Maybe<Scalars['String']['output']>;
  pkgName: Scalars['String']['output'];
  schema: Scalars['jsonb']['output'];
  updatedAt: Scalars['timestamp']['output'];
};


/** columns and relationships of "tenancy.applet" */
export type Tenancy_AppletApplet_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Version_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet" */
export type Tenancy_AppletApplet_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Version_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet" */
export type Tenancy_AppletFilesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet" */
export type Tenancy_AppletFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet" */
export type Tenancy_AppletSchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.applet" */
export type Tenancy_Applet_Aggregate = {
  __typename?: 'tenancy_applet_aggregate';
  aggregate?: Maybe<Tenancy_Applet_Aggregate_Fields>;
  nodes: Array<Tenancy_Applet>;
};

export type Tenancy_Applet_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Applet_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Applet_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Applet_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Applet_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.applet" */
export type Tenancy_Applet_Aggregate_Fields = {
  __typename?: 'tenancy_applet_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Applet_Max_Fields>;
  min?: Maybe<Tenancy_Applet_Min_Fields>;
};


/** aggregate fields of "tenancy.applet" */
export type Tenancy_Applet_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Applet_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.applet" */
export type Tenancy_Applet_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Applet_Max_Order_By>;
  min?: InputMaybe<Tenancy_Applet_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Applet_Append_Input = {
  schema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.applet" */
export type Tenancy_Applet_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Applet_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Applet_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.applet". All fields are combined with a logical 'AND'. */
export type Tenancy_Applet_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Applet_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Applet_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Applet_Bool_Exp>>;
  appletCategory?: InputMaybe<AppletCategory_Comparison_Exp>;
  appletType?: InputMaybe<AppletType_Comparison_Exp>;
  applet_version?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
  applet_versions?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
  applet_versions_aggregate?: InputMaybe<Tenancy_Applet_Version_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  files?: InputMaybe<Tenancy_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Tenancy_File_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  latestVersionId?: InputMaybe<String_Comparison_Exp>;
  pkgName?: InputMaybe<String_Comparison_Exp>;
  schema?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.applet" */
export enum Tenancy_Applet_Constraint {
  /** unique or primary key constraint on columns "latestVersionId" */
  AppletLatestVersionIdKey = 'applet_latestVersionId_key',
  /** unique or primary key constraint on columns "id" */
  AppletPkey = 'applet_pkey',
  /** unique or primary key constraint on columns "pkgName" */
  AppletPkgNameKey = 'applet_pkgName_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Applet_Delete_At_Path_Input = {
  schema?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Applet_Delete_Elem_Input = {
  schema?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Applet_Delete_Key_Input = {
  schema?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.applet" */
export type Tenancy_Applet_Insert_Input = {
  appletCategory?: InputMaybe<Scalars['AppletCategory']['input']>;
  appletType?: InputMaybe<Scalars['AppletType']['input']>;
  applet_version?: InputMaybe<Tenancy_Applet_Version_Obj_Rel_Insert_Input>;
  applet_versions?: InputMaybe<Tenancy_Applet_Version_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Tenancy_File_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionId?: InputMaybe<Scalars['String']['input']>;
  pkgName?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** columns and relationships of "tenancy.applet_instance" */
export type Tenancy_Applet_Instance = {
  __typename?: 'tenancy_applet_instance';
  /** An array relationship */
  actions: Array<Tenancy_Action>;
  /** An aggregate relationship */
  actions_aggregate: Tenancy_Action_Aggregate;
  appletVersionId: Scalars['String']['output'];
  /** An object relationship */
  applet_version: Tenancy_Applet_Version;
  /** An array relationship */
  conditions: Array<Tenancy_Condition>;
  /** An aggregate relationship */
  conditions_aggregate: Tenancy_Condition_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['jsonb']['output']>;
  projectEnvironmentConfigId: Scalars['String']['output'];
  /** An object relationship */
  project_environment_config: Tenancy_Project_Environment_Config;
  shortId?: Maybe<Scalars['String']['output']>;
  status: Scalars['AppletStatus']['output'];
  /** An array relationship */
  triggers: Array<Tenancy_Trigger>;
  /** An aggregate relationship */
  triggers_aggregate: Tenancy_Trigger_Aggregate;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "tenancy.applet_instance" */
export type Tenancy_Applet_InstanceActionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet_instance" */
export type Tenancy_Applet_InstanceActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet_instance" */
export type Tenancy_Applet_InstanceConditionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Condition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Condition_Order_By>>;
  where?: InputMaybe<Tenancy_Condition_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet_instance" */
export type Tenancy_Applet_InstanceConditions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Condition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Condition_Order_By>>;
  where?: InputMaybe<Tenancy_Condition_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet_instance" */
export type Tenancy_Applet_InstanceOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.applet_instance" */
export type Tenancy_Applet_InstanceTriggersArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Trigger_Order_By>>;
  where?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet_instance" */
export type Tenancy_Applet_InstanceTriggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Trigger_Order_By>>;
  where?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
};

/** aggregated selection of "tenancy.applet_instance" */
export type Tenancy_Applet_Instance_Aggregate = {
  __typename?: 'tenancy_applet_instance_aggregate';
  aggregate?: Maybe<Tenancy_Applet_Instance_Aggregate_Fields>;
  nodes: Array<Tenancy_Applet_Instance>;
};

export type Tenancy_Applet_Instance_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Applet_Instance_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Applet_Instance_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Applet_Instance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.applet_instance" */
export type Tenancy_Applet_Instance_Aggregate_Fields = {
  __typename?: 'tenancy_applet_instance_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Applet_Instance_Max_Fields>;
  min?: Maybe<Tenancy_Applet_Instance_Min_Fields>;
};


/** aggregate fields of "tenancy.applet_instance" */
export type Tenancy_Applet_Instance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Applet_Instance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.applet_instance" */
export type Tenancy_Applet_Instance_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Applet_Instance_Max_Order_By>;
  min?: InputMaybe<Tenancy_Applet_Instance_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Applet_Instance_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.applet_instance" */
export type Tenancy_Applet_Instance_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Applet_Instance_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Applet_Instance_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.applet_instance". All fields are combined with a logical 'AND'. */
export type Tenancy_Applet_Instance_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Applet_Instance_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Applet_Instance_Bool_Exp>>;
  actions?: InputMaybe<Tenancy_Action_Bool_Exp>;
  actions_aggregate?: InputMaybe<Tenancy_Action_Aggregate_Bool_Exp>;
  appletVersionId?: InputMaybe<String_Comparison_Exp>;
  applet_version?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
  conditions?: InputMaybe<Tenancy_Condition_Bool_Exp>;
  conditions_aggregate?: InputMaybe<Tenancy_Condition_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  projectEnvironmentConfigId?: InputMaybe<String_Comparison_Exp>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
  shortId?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<AppletStatus_Comparison_Exp>;
  triggers?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
  triggers_aggregate?: InputMaybe<Tenancy_Trigger_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.applet_instance" */
export enum Tenancy_Applet_Instance_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppletInstancePkey = 'applet_instance_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Applet_Instance_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Applet_Instance_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Applet_Instance_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.applet_instance" */
export type Tenancy_Applet_Instance_Insert_Input = {
  actions?: InputMaybe<Tenancy_Action_Arr_Rel_Insert_Input>;
  appletVersionId?: InputMaybe<Scalars['String']['input']>;
  applet_version?: InputMaybe<Tenancy_Applet_Version_Obj_Rel_Insert_Input>;
  conditions?: InputMaybe<Tenancy_Condition_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  projectEnvironmentConfigId?: InputMaybe<Scalars['String']['input']>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Obj_Rel_Insert_Input>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['AppletStatus']['input']>;
  triggers?: InputMaybe<Tenancy_Trigger_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Applet_Instance_Max_Fields = {
  __typename?: 'tenancy_applet_instance_max_fields';
  appletVersionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectEnvironmentConfigId?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['AppletStatus']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.applet_instance" */
export type Tenancy_Applet_Instance_Max_Order_By = {
  appletVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectEnvironmentConfigId?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Applet_Instance_Min_Fields = {
  __typename?: 'tenancy_applet_instance_min_fields';
  appletVersionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectEnvironmentConfigId?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['AppletStatus']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.applet_instance" */
export type Tenancy_Applet_Instance_Min_Order_By = {
  appletVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectEnvironmentConfigId?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.applet_instance" */
export type Tenancy_Applet_Instance_Mutation_Response = {
  __typename?: 'tenancy_applet_instance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Applet_Instance>;
};

/** input type for inserting object relation for remote table "tenancy.applet_instance" */
export type Tenancy_Applet_Instance_Obj_Rel_Insert_Input = {
  data: Tenancy_Applet_Instance_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Applet_Instance_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.applet_instance" */
export type Tenancy_Applet_Instance_On_Conflict = {
  constraint: Tenancy_Applet_Instance_Constraint;
  update_columns?: Array<Tenancy_Applet_Instance_Update_Column>;
  where?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.applet_instance". */
export type Tenancy_Applet_Instance_Order_By = {
  actions_aggregate?: InputMaybe<Tenancy_Action_Aggregate_Order_By>;
  appletVersionId?: InputMaybe<Order_By>;
  applet_version?: InputMaybe<Tenancy_Applet_Version_Order_By>;
  conditions_aggregate?: InputMaybe<Tenancy_Condition_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  projectEnvironmentConfigId?: InputMaybe<Order_By>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Order_By>;
  shortId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  triggers_aggregate?: InputMaybe<Tenancy_Trigger_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.applet_instance */
export type Tenancy_Applet_Instance_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Applet_Instance_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.applet_instance" */
export enum Tenancy_Applet_Instance_Select_Column {
  /** column name */
  AppletVersionId = 'appletVersionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Options = 'options',
  /** column name */
  ProjectEnvironmentConfigId = 'projectEnvironmentConfigId',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "tenancy.applet_instance" */
export type Tenancy_Applet_Instance_Set_Input = {
  appletVersionId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  projectEnvironmentConfigId?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['AppletStatus']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_applet_instance" */
export type Tenancy_Applet_Instance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Applet_Instance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Applet_Instance_Stream_Cursor_Value_Input = {
  appletVersionId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  projectEnvironmentConfigId?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['AppletStatus']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.applet_instance" */
export enum Tenancy_Applet_Instance_Update_Column {
  /** column name */
  AppletVersionId = 'appletVersionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Options = 'options',
  /** column name */
  ProjectEnvironmentConfigId = 'projectEnvironmentConfigId',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type Tenancy_Applet_Instance_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Applet_Instance_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Applet_Instance_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Applet_Instance_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Applet_Instance_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Applet_Instance_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Applet_Instance_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Applet_Instance_Bool_Exp;
};

/** aggregate max on columns */
export type Tenancy_Applet_Max_Fields = {
  __typename?: 'tenancy_applet_max_fields';
  appletCategory?: Maybe<Scalars['AppletCategory']['output']>;
  appletType?: Maybe<Scalars['AppletType']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latestVersionId?: Maybe<Scalars['String']['output']>;
  pkgName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.applet" */
export type Tenancy_Applet_Max_Order_By = {
  appletCategory?: InputMaybe<Order_By>;
  appletType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionId?: InputMaybe<Order_By>;
  pkgName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Applet_Min_Fields = {
  __typename?: 'tenancy_applet_min_fields';
  appletCategory?: Maybe<Scalars['AppletCategory']['output']>;
  appletType?: Maybe<Scalars['AppletType']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latestVersionId?: Maybe<Scalars['String']['output']>;
  pkgName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.applet" */
export type Tenancy_Applet_Min_Order_By = {
  appletCategory?: InputMaybe<Order_By>;
  appletType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionId?: InputMaybe<Order_By>;
  pkgName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.applet" */
export type Tenancy_Applet_Mutation_Response = {
  __typename?: 'tenancy_applet_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Applet>;
};

/** input type for inserting object relation for remote table "tenancy.applet" */
export type Tenancy_Applet_Obj_Rel_Insert_Input = {
  data: Tenancy_Applet_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Applet_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.applet" */
export type Tenancy_Applet_On_Conflict = {
  constraint: Tenancy_Applet_Constraint;
  update_columns?: Array<Tenancy_Applet_Update_Column>;
  where?: InputMaybe<Tenancy_Applet_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.applet". */
export type Tenancy_Applet_Order_By = {
  appletCategory?: InputMaybe<Order_By>;
  appletType?: InputMaybe<Order_By>;
  applet_version?: InputMaybe<Tenancy_Applet_Version_Order_By>;
  applet_versions_aggregate?: InputMaybe<Tenancy_Applet_Version_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Tenancy_File_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionId?: InputMaybe<Order_By>;
  pkgName?: InputMaybe<Order_By>;
  schema?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.applet */
export type Tenancy_Applet_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Applet_Prepend_Input = {
  schema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.applet" */
export enum Tenancy_Applet_Select_Column {
  /** column name */
  AppletCategory = 'appletCategory',
  /** column name */
  AppletType = 'appletType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  LatestVersionId = 'latestVersionId',
  /** column name */
  PkgName = 'pkgName',
  /** column name */
  Schema = 'schema',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tenancy.applet" */
export type Tenancy_Applet_Set_Input = {
  appletCategory?: InputMaybe<Scalars['AppletCategory']['input']>;
  appletType?: InputMaybe<Scalars['AppletType']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionId?: InputMaybe<Scalars['String']['input']>;
  pkgName?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_applet" */
export type Tenancy_Applet_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Applet_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Applet_Stream_Cursor_Value_Input = {
  appletCategory?: InputMaybe<Scalars['AppletCategory']['input']>;
  appletType?: InputMaybe<Scalars['AppletType']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionId?: InputMaybe<Scalars['String']['input']>;
  pkgName?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.applet" */
export enum Tenancy_Applet_Update_Column {
  /** column name */
  AppletCategory = 'appletCategory',
  /** column name */
  AppletType = 'appletType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  LatestVersionId = 'latestVersionId',
  /** column name */
  PkgName = 'pkgName',
  /** column name */
  Schema = 'schema',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Applet_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Applet_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Applet_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Applet_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Applet_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Applet_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Applet_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Applet_Bool_Exp;
};

/** columns and relationships of "tenancy.applet_version" */
export type Tenancy_Applet_Version = {
  __typename?: 'tenancy_applet_version';
  /** An object relationship */
  applet: Tenancy_Applet;
  appletId: Scalars['String']['output'];
  /** An array relationship */
  applet_instances: Array<Tenancy_Applet_Instance>;
  /** An aggregate relationship */
  applet_instances_aggregate: Tenancy_Applet_Instance_Aggregate;
  /** An array relationship */
  applets: Array<Tenancy_Applet>;
  /** An aggregate relationship */
  applets_aggregate: Tenancy_Applet_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  schema: Scalars['jsonb']['output'];
  updatedAt: Scalars['timestamp']['output'];
  version: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.applet_version" */
export type Tenancy_Applet_VersionApplet_InstancesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Instance_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet_version" */
export type Tenancy_Applet_VersionApplet_Instances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Instance_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet_version" */
export type Tenancy_Applet_VersionAppletsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet_version" */
export type Tenancy_Applet_VersionApplets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Bool_Exp>;
};


/** columns and relationships of "tenancy.applet_version" */
export type Tenancy_Applet_VersionSchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.applet_version" */
export type Tenancy_Applet_Version_Aggregate = {
  __typename?: 'tenancy_applet_version_aggregate';
  aggregate?: Maybe<Tenancy_Applet_Version_Aggregate_Fields>;
  nodes: Array<Tenancy_Applet_Version>;
};

export type Tenancy_Applet_Version_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Applet_Version_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Applet_Version_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Applet_Version_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.applet_version" */
export type Tenancy_Applet_Version_Aggregate_Fields = {
  __typename?: 'tenancy_applet_version_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Applet_Version_Max_Fields>;
  min?: Maybe<Tenancy_Applet_Version_Min_Fields>;
};


/** aggregate fields of "tenancy.applet_version" */
export type Tenancy_Applet_Version_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Applet_Version_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.applet_version" */
export type Tenancy_Applet_Version_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Applet_Version_Max_Order_By>;
  min?: InputMaybe<Tenancy_Applet_Version_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Applet_Version_Append_Input = {
  schema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.applet_version" */
export type Tenancy_Applet_Version_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Applet_Version_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Applet_Version_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.applet_version". All fields are combined with a logical 'AND'. */
export type Tenancy_Applet_Version_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Applet_Version_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Applet_Version_Bool_Exp>>;
  applet?: InputMaybe<Tenancy_Applet_Bool_Exp>;
  appletId?: InputMaybe<String_Comparison_Exp>;
  applet_instances?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
  applet_instances_aggregate?: InputMaybe<Tenancy_Applet_Instance_Aggregate_Bool_Exp>;
  applets?: InputMaybe<Tenancy_Applet_Bool_Exp>;
  applets_aggregate?: InputMaybe<Tenancy_Applet_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  schema?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.applet_version" */
export enum Tenancy_Applet_Version_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppletVersionPkey = 'applet_version_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Applet_Version_Delete_At_Path_Input = {
  schema?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Applet_Version_Delete_Elem_Input = {
  schema?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Applet_Version_Delete_Key_Input = {
  schema?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.applet_version" */
export type Tenancy_Applet_Version_Insert_Input = {
  applet?: InputMaybe<Tenancy_Applet_Obj_Rel_Insert_Input>;
  appletId?: InputMaybe<Scalars['String']['input']>;
  applet_instances?: InputMaybe<Tenancy_Applet_Instance_Arr_Rel_Insert_Input>;
  applets?: InputMaybe<Tenancy_Applet_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Applet_Version_Max_Fields = {
  __typename?: 'tenancy_applet_version_max_fields';
  appletId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.applet_version" */
export type Tenancy_Applet_Version_Max_Order_By = {
  appletId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Applet_Version_Min_Fields = {
  __typename?: 'tenancy_applet_version_min_fields';
  appletId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.applet_version" */
export type Tenancy_Applet_Version_Min_Order_By = {
  appletId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.applet_version" */
export type Tenancy_Applet_Version_Mutation_Response = {
  __typename?: 'tenancy_applet_version_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Applet_Version>;
};

/** input type for inserting object relation for remote table "tenancy.applet_version" */
export type Tenancy_Applet_Version_Obj_Rel_Insert_Input = {
  data: Tenancy_Applet_Version_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Applet_Version_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.applet_version" */
export type Tenancy_Applet_Version_On_Conflict = {
  constraint: Tenancy_Applet_Version_Constraint;
  update_columns?: Array<Tenancy_Applet_Version_Update_Column>;
  where?: InputMaybe<Tenancy_Applet_Version_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.applet_version". */
export type Tenancy_Applet_Version_Order_By = {
  applet?: InputMaybe<Tenancy_Applet_Order_By>;
  appletId?: InputMaybe<Order_By>;
  applet_instances_aggregate?: InputMaybe<Tenancy_Applet_Instance_Aggregate_Order_By>;
  applets_aggregate?: InputMaybe<Tenancy_Applet_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  schema?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.applet_version */
export type Tenancy_Applet_Version_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Applet_Version_Prepend_Input = {
  schema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.applet_version" */
export enum Tenancy_Applet_Version_Select_Column {
  /** column name */
  AppletId = 'appletId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Schema = 'schema',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "tenancy.applet_version" */
export type Tenancy_Applet_Version_Set_Input = {
  appletId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_applet_version" */
export type Tenancy_Applet_Version_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Applet_Version_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Applet_Version_Stream_Cursor_Value_Input = {
  appletId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.applet_version" */
export enum Tenancy_Applet_Version_Update_Column {
  /** column name */
  AppletId = 'appletId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Schema = 'schema',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Version = 'version'
}

export type Tenancy_Applet_Version_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Applet_Version_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Applet_Version_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Applet_Version_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Applet_Version_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Applet_Version_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Applet_Version_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Applet_Version_Bool_Exp;
};

/** columns and relationships of "tenancy.audit_logs" */
export type Tenancy_Audit_Logs = {
  __typename?: 'tenancy_audit_logs';
  /** An object relationship */
  account?: Maybe<Tenancy_Accounts>;
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
  logDetails: Scalars['jsonb']['output'];
  /** An object relationship */
  product: Tenancy_Products;
  productId: Scalars['String']['output'];
  /** An object relationship */
  user: Tenancy_Users;
  userId: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.audit_logs" */
export type Tenancy_Audit_LogsLogDetailsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.audit_logs" */
export type Tenancy_Audit_Logs_Aggregate = {
  __typename?: 'tenancy_audit_logs_aggregate';
  aggregate?: Maybe<Tenancy_Audit_Logs_Aggregate_Fields>;
  nodes: Array<Tenancy_Audit_Logs>;
};

export type Tenancy_Audit_Logs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Audit_Logs_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Audit_Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Audit_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.audit_logs" */
export type Tenancy_Audit_Logs_Aggregate_Fields = {
  __typename?: 'tenancy_audit_logs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Audit_Logs_Max_Fields>;
  min?: Maybe<Tenancy_Audit_Logs_Min_Fields>;
};


/** aggregate fields of "tenancy.audit_logs" */
export type Tenancy_Audit_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Audit_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.audit_logs" */
export type Tenancy_Audit_Logs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Audit_Logs_Max_Order_By>;
  min?: InputMaybe<Tenancy_Audit_Logs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Audit_Logs_Append_Input = {
  logDetails?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.audit_logs" */
export type Tenancy_Audit_Logs_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Audit_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Audit_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.audit_logs". All fields are combined with a logical 'AND'. */
export type Tenancy_Audit_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Audit_Logs_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Audit_Logs_Bool_Exp>>;
  account?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  accountId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  logDetails?: InputMaybe<Jsonb_Comparison_Exp>;
  product?: InputMaybe<Tenancy_Products_Bool_Exp>;
  productId?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Tenancy_Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.audit_logs" */
export enum Tenancy_Audit_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  AuditLogsPkey = 'audit_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Audit_Logs_Delete_At_Path_Input = {
  logDetails?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Audit_Logs_Delete_Elem_Input = {
  logDetails?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Audit_Logs_Delete_Key_Input = {
  logDetails?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.audit_logs" */
export type Tenancy_Audit_Logs_Insert_Input = {
  account?: InputMaybe<Tenancy_Accounts_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  logDetails?: InputMaybe<Scalars['jsonb']['input']>;
  product?: InputMaybe<Tenancy_Products_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Tenancy_Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Audit_Logs_Max_Fields = {
  __typename?: 'tenancy_audit_logs_max_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.audit_logs" */
export type Tenancy_Audit_Logs_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Audit_Logs_Min_Fields = {
  __typename?: 'tenancy_audit_logs_min_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.audit_logs" */
export type Tenancy_Audit_Logs_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.audit_logs" */
export type Tenancy_Audit_Logs_Mutation_Response = {
  __typename?: 'tenancy_audit_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Audit_Logs>;
};

/** on_conflict condition type for table "tenancy.audit_logs" */
export type Tenancy_Audit_Logs_On_Conflict = {
  constraint: Tenancy_Audit_Logs_Constraint;
  update_columns?: Array<Tenancy_Audit_Logs_Update_Column>;
  where?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.audit_logs". */
export type Tenancy_Audit_Logs_Order_By = {
  account?: InputMaybe<Tenancy_Accounts_Order_By>;
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logDetails?: InputMaybe<Order_By>;
  product?: InputMaybe<Tenancy_Products_Order_By>;
  productId?: InputMaybe<Order_By>;
  user?: InputMaybe<Tenancy_Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.audit_logs */
export type Tenancy_Audit_Logs_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Audit_Logs_Prepend_Input = {
  logDetails?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.audit_logs" */
export enum Tenancy_Audit_Logs_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LogDetails = 'logDetails',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "tenancy.audit_logs" */
export type Tenancy_Audit_Logs_Set_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  logDetails?: InputMaybe<Scalars['jsonb']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_audit_logs" */
export type Tenancy_Audit_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Audit_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Audit_Logs_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  logDetails?: InputMaybe<Scalars['jsonb']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.audit_logs" */
export enum Tenancy_Audit_Logs_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LogDetails = 'logDetails',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UserId = 'userId'
}

export type Tenancy_Audit_Logs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Audit_Logs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Audit_Logs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Audit_Logs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Audit_Logs_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Audit_Logs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Audit_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Audit_Logs_Bool_Exp;
};

/** columns and relationships of "tenancy.auth_method" */
export type Tenancy_Auth_Method = {
  __typename?: 'tenancy_auth_method';
  /** An array relationship */
  account_auth_method_settings: Array<Tenancy_Account_Auth_Method_Settings>;
  /** An aggregate relationship */
  account_auth_method_settings_aggregate: Tenancy_Account_Auth_Method_Settings_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.auth_method" */
export type Tenancy_Auth_MethodAccount_Auth_Method_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.auth_method" */
export type Tenancy_Auth_MethodAccount_Auth_Method_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
};

/** aggregated selection of "tenancy.auth_method" */
export type Tenancy_Auth_Method_Aggregate = {
  __typename?: 'tenancy_auth_method_aggregate';
  aggregate?: Maybe<Tenancy_Auth_Method_Aggregate_Fields>;
  nodes: Array<Tenancy_Auth_Method>;
};

/** aggregate fields of "tenancy.auth_method" */
export type Tenancy_Auth_Method_Aggregate_Fields = {
  __typename?: 'tenancy_auth_method_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Auth_Method_Max_Fields>;
  min?: Maybe<Tenancy_Auth_Method_Min_Fields>;
};


/** aggregate fields of "tenancy.auth_method" */
export type Tenancy_Auth_Method_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Auth_Method_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.auth_method". All fields are combined with a logical 'AND'. */
export type Tenancy_Auth_Method_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Auth_Method_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Auth_Method_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Auth_Method_Bool_Exp>>;
  account_auth_method_settings?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
  account_auth_method_settings_aggregate?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  providerId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.auth_method" */
export enum Tenancy_Auth_Method_Constraint {
  /** unique or primary key constraint on columns "id" */
  AuthMethodPkey = 'auth_method_pkey'
}

/** input type for inserting data into table "tenancy.auth_method" */
export type Tenancy_Auth_Method_Insert_Input = {
  account_auth_method_settings?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Auth_Method_Max_Fields = {
  __typename?: 'tenancy_auth_method_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Auth_Method_Min_Fields = {
  __typename?: 'tenancy_auth_method_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tenancy.auth_method" */
export type Tenancy_Auth_Method_Mutation_Response = {
  __typename?: 'tenancy_auth_method_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Auth_Method>;
};

/** input type for inserting object relation for remote table "tenancy.auth_method" */
export type Tenancy_Auth_Method_Obj_Rel_Insert_Input = {
  data: Tenancy_Auth_Method_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Auth_Method_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.auth_method" */
export type Tenancy_Auth_Method_On_Conflict = {
  constraint: Tenancy_Auth_Method_Constraint;
  update_columns?: Array<Tenancy_Auth_Method_Update_Column>;
  where?: InputMaybe<Tenancy_Auth_Method_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.auth_method". */
export type Tenancy_Auth_Method_Order_By = {
  account_auth_method_settings_aggregate?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.auth_method */
export type Tenancy_Auth_Method_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.auth_method" */
export enum Tenancy_Auth_Method_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderId = 'providerId'
}

/** input type for updating data in table "tenancy.auth_method" */
export type Tenancy_Auth_Method_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_auth_method" */
export type Tenancy_Auth_Method_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Auth_Method_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Auth_Method_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.auth_method" */
export enum Tenancy_Auth_Method_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderId = 'providerId'
}

export type Tenancy_Auth_Method_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Auth_Method_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Auth_Method_Bool_Exp;
};

/** columns and relationships of "tenancy.condition" */
export type Tenancy_Condition = {
  __typename?: 'tenancy_condition';
  appletInstanceId: Scalars['String']['output'];
  /** An object relationship */
  applet_instance: Tenancy_Applet_Instance;
  id: Scalars['String']['output'];
  options?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "tenancy.condition" */
export type Tenancy_ConditionOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.condition" */
export type Tenancy_Condition_Aggregate = {
  __typename?: 'tenancy_condition_aggregate';
  aggregate?: Maybe<Tenancy_Condition_Aggregate_Fields>;
  nodes: Array<Tenancy_Condition>;
};

export type Tenancy_Condition_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Condition_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Condition_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Condition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Condition_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.condition" */
export type Tenancy_Condition_Aggregate_Fields = {
  __typename?: 'tenancy_condition_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Condition_Max_Fields>;
  min?: Maybe<Tenancy_Condition_Min_Fields>;
};


/** aggregate fields of "tenancy.condition" */
export type Tenancy_Condition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Condition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.condition" */
export type Tenancy_Condition_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Condition_Max_Order_By>;
  min?: InputMaybe<Tenancy_Condition_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Condition_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.condition" */
export type Tenancy_Condition_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Condition_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Condition_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.condition". All fields are combined with a logical 'AND'. */
export type Tenancy_Condition_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Condition_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Condition_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Condition_Bool_Exp>>;
  appletInstanceId?: InputMaybe<String_Comparison_Exp>;
  applet_instance?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.condition" */
export enum Tenancy_Condition_Constraint {
  /** unique or primary key constraint on columns "appletInstanceId" */
  ConditionAppletInstanceIdKey = 'condition_appletInstanceId_key',
  /** unique or primary key constraint on columns "id" */
  ConditionPkey = 'condition_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Condition_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Condition_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Condition_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.condition" */
export type Tenancy_Condition_Insert_Input = {
  appletInstanceId?: InputMaybe<Scalars['String']['input']>;
  applet_instance?: InputMaybe<Tenancy_Applet_Instance_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Condition_Max_Fields = {
  __typename?: 'tenancy_condition_max_fields';
  appletInstanceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.condition" */
export type Tenancy_Condition_Max_Order_By = {
  appletInstanceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Condition_Min_Fields = {
  __typename?: 'tenancy_condition_min_fields';
  appletInstanceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.condition" */
export type Tenancy_Condition_Min_Order_By = {
  appletInstanceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.condition" */
export type Tenancy_Condition_Mutation_Response = {
  __typename?: 'tenancy_condition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Condition>;
};

/** on_conflict condition type for table "tenancy.condition" */
export type Tenancy_Condition_On_Conflict = {
  constraint: Tenancy_Condition_Constraint;
  update_columns?: Array<Tenancy_Condition_Update_Column>;
  where?: InputMaybe<Tenancy_Condition_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.condition". */
export type Tenancy_Condition_Order_By = {
  appletInstanceId?: InputMaybe<Order_By>;
  applet_instance?: InputMaybe<Tenancy_Applet_Instance_Order_By>;
  id?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.condition */
export type Tenancy_Condition_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Condition_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.condition" */
export enum Tenancy_Condition_Select_Column {
  /** column name */
  AppletInstanceId = 'appletInstanceId',
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

/** input type for updating data in table "tenancy.condition" */
export type Tenancy_Condition_Set_Input = {
  appletInstanceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "tenancy_condition" */
export type Tenancy_Condition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Condition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Condition_Stream_Cursor_Value_Input = {
  appletInstanceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "tenancy.condition" */
export enum Tenancy_Condition_Update_Column {
  /** column name */
  AppletInstanceId = 'appletInstanceId',
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

export type Tenancy_Condition_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Condition_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Condition_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Condition_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Condition_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Condition_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Condition_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Condition_Bool_Exp;
};

/** columns and relationships of "tenancy.country" */
export type Tenancy_Country = {
  __typename?: 'tenancy_country';
  code: Scalars['String']['output'];
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  iso3?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  localization_settings: Array<Tenancy_Localization_Settings>;
  /** An aggregate relationship */
  localization_settings_aggregate: Tenancy_Localization_Settings_Aggregate;
  name: Scalars['String']['output'];
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.country" */
export type Tenancy_CountryLocalization_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.country" */
export type Tenancy_CountryLocalization_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};

/** aggregated selection of "tenancy.country" */
export type Tenancy_Country_Aggregate = {
  __typename?: 'tenancy_country_aggregate';
  aggregate?: Maybe<Tenancy_Country_Aggregate_Fields>;
  nodes: Array<Tenancy_Country>;
};

/** aggregate fields of "tenancy.country" */
export type Tenancy_Country_Aggregate_Fields = {
  __typename?: 'tenancy_country_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Country_Max_Fields>;
  min?: Maybe<Tenancy_Country_Min_Fields>;
};


/** aggregate fields of "tenancy.country" */
export type Tenancy_Country_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Country_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.country". All fields are combined with a logical 'AND'. */
export type Tenancy_Country_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Country_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Country_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Country_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  iso3?: InputMaybe<String_Comparison_Exp>;
  localization_settings?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
  localization_settings_aggregate?: InputMaybe<Tenancy_Localization_Settings_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.country" */
export enum Tenancy_Country_Constraint {
  /** unique or primary key constraint on columns "id" */
  CountryPkey = 'country_pkey'
}

/** input type for inserting data into table "tenancy.country" */
export type Tenancy_Country_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  iso3?: InputMaybe<Scalars['String']['input']>;
  localization_settings?: InputMaybe<Tenancy_Localization_Settings_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Country_Max_Fields = {
  __typename?: 'tenancy_country_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  iso3?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Country_Min_Fields = {
  __typename?: 'tenancy_country_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  iso3?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tenancy.country" */
export type Tenancy_Country_Mutation_Response = {
  __typename?: 'tenancy_country_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Country>;
};

/** input type for inserting object relation for remote table "tenancy.country" */
export type Tenancy_Country_Obj_Rel_Insert_Input = {
  data: Tenancy_Country_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Country_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.country" */
export type Tenancy_Country_On_Conflict = {
  constraint: Tenancy_Country_Constraint;
  update_columns?: Array<Tenancy_Country_Update_Column>;
  where?: InputMaybe<Tenancy_Country_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.country". */
export type Tenancy_Country_Order_By = {
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  iso3?: InputMaybe<Order_By>;
  localization_settings_aggregate?: InputMaybe<Tenancy_Localization_Settings_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.country */
export type Tenancy_Country_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.country" */
export enum Tenancy_Country_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Iso3 = 'iso3',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "tenancy.country" */
export type Tenancy_Country_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  iso3?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_country" */
export type Tenancy_Country_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Country_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Country_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  iso3?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.country" */
export enum Tenancy_Country_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Iso3 = 'iso3',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type Tenancy_Country_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Country_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Country_Bool_Exp;
};

/** columns and relationships of "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method = {
  __typename?: 'tenancy_custom_auth_method';
  /** An object relationship */
  account: Tenancy_Accounts;
  accountId: Scalars['String']['output'];
  /** An array relationship */
  account_auth_method_settings: Array<Tenancy_Account_Auth_Method_Settings>;
  /** An aggregate relationship */
  account_auth_method_settings_aggregate: Tenancy_Account_Auth_Method_Settings_Aggregate;
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  emailAttribute?: Maybe<Scalars['String']['output']>;
  entityIssuer?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  issuerURL: Scalars['String']['output'];
  mapper?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  settings?: Maybe<Scalars['jsonb']['output']>;
  type: Scalars['CustomAuthMethodType']['output'];
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
  usernameAttribute?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_MethodAccount_Auth_Method_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_MethodAccount_Auth_Method_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_MethodSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method_Aggregate = {
  __typename?: 'tenancy_custom_auth_method_aggregate';
  aggregate?: Maybe<Tenancy_Custom_Auth_Method_Aggregate_Fields>;
  nodes: Array<Tenancy_Custom_Auth_Method>;
};

export type Tenancy_Custom_Auth_Method_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Custom_Auth_Method_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Custom_Auth_Method_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Custom_Auth_Method_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method_Aggregate_Fields = {
  __typename?: 'tenancy_custom_auth_method_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Custom_Auth_Method_Max_Fields>;
  min?: Maybe<Tenancy_Custom_Auth_Method_Min_Fields>;
};


/** aggregate fields of "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Custom_Auth_Method_Max_Order_By>;
  min?: InputMaybe<Tenancy_Custom_Auth_Method_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Custom_Auth_Method_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Custom_Auth_Method_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Custom_Auth_Method_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.custom_auth_method". All fields are combined with a logical 'AND'. */
export type Tenancy_Custom_Auth_Method_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Custom_Auth_Method_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Custom_Auth_Method_Bool_Exp>>;
  account?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  accountId?: InputMaybe<String_Comparison_Exp>;
  account_auth_method_settings?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
  account_auth_method_settings_aggregate?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Aggregate_Bool_Exp>;
  clientId?: InputMaybe<String_Comparison_Exp>;
  clientSecret?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  emailAttribute?: InputMaybe<String_Comparison_Exp>;
  entityIssuer?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  issuerURL?: InputMaybe<String_Comparison_Exp>;
  mapper?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  scopes?: InputMaybe<String_Array_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<CustomAuthMethodType_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
  usernameAttribute?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.custom_auth_method" */
export enum Tenancy_Custom_Auth_Method_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomAuthMethodPkey = 'custom_auth_method_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Custom_Auth_Method_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Custom_Auth_Method_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Custom_Auth_Method_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method_Insert_Input = {
  account?: InputMaybe<Tenancy_Accounts_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  account_auth_method_settings?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Arr_Rel_Insert_Input>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  emailAttribute?: InputMaybe<Scalars['String']['input']>;
  entityIssuer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  issuerURL?: InputMaybe<Scalars['String']['input']>;
  mapper?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['CustomAuthMethodType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  usernameAttribute?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Custom_Auth_Method_Max_Fields = {
  __typename?: 'tenancy_custom_auth_method_max_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  emailAttribute?: Maybe<Scalars['String']['output']>;
  entityIssuer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  issuerURL?: Maybe<Scalars['String']['output']>;
  mapper?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<Scalars['CustomAuthMethodType']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  usernameAttribute?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  clientId?: InputMaybe<Order_By>;
  clientSecret?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  emailAttribute?: InputMaybe<Order_By>;
  entityIssuer?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuerURL?: InputMaybe<Order_By>;
  mapper?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  usernameAttribute?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Custom_Auth_Method_Min_Fields = {
  __typename?: 'tenancy_custom_auth_method_min_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  emailAttribute?: Maybe<Scalars['String']['output']>;
  entityIssuer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  issuerURL?: Maybe<Scalars['String']['output']>;
  mapper?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<Scalars['CustomAuthMethodType']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  usernameAttribute?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  clientId?: InputMaybe<Order_By>;
  clientSecret?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  emailAttribute?: InputMaybe<Order_By>;
  entityIssuer?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuerURL?: InputMaybe<Order_By>;
  mapper?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  usernameAttribute?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method_Mutation_Response = {
  __typename?: 'tenancy_custom_auth_method_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Custom_Auth_Method>;
};

/** input type for inserting object relation for remote table "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method_Obj_Rel_Insert_Input = {
  data: Tenancy_Custom_Auth_Method_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Custom_Auth_Method_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method_On_Conflict = {
  constraint: Tenancy_Custom_Auth_Method_Constraint;
  update_columns?: Array<Tenancy_Custom_Auth_Method_Update_Column>;
  where?: InputMaybe<Tenancy_Custom_Auth_Method_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.custom_auth_method". */
export type Tenancy_Custom_Auth_Method_Order_By = {
  account?: InputMaybe<Tenancy_Accounts_Order_By>;
  accountId?: InputMaybe<Order_By>;
  account_auth_method_settings_aggregate?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Aggregate_Order_By>;
  clientId?: InputMaybe<Order_By>;
  clientSecret?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  emailAttribute?: InputMaybe<Order_By>;
  entityIssuer?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuerURL?: InputMaybe<Order_By>;
  mapper?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  usernameAttribute?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.custom_auth_method */
export type Tenancy_Custom_Auth_Method_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Custom_Auth_Method_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.custom_auth_method" */
export enum Tenancy_Custom_Auth_Method_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  ClientSecret = 'clientSecret',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailAttribute = 'emailAttribute',
  /** column name */
  EntityIssuer = 'entityIssuer',
  /** column name */
  Id = 'id',
  /** column name */
  IssuerUrl = 'issuerURL',
  /** column name */
  Mapper = 'mapper',
  /** column name */
  Name = 'name',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  Settings = 'settings',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UsernameAttribute = 'usernameAttribute'
}

/** input type for updating data in table "tenancy.custom_auth_method" */
export type Tenancy_Custom_Auth_Method_Set_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  emailAttribute?: InputMaybe<Scalars['String']['input']>;
  entityIssuer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  issuerURL?: InputMaybe<Scalars['String']['input']>;
  mapper?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['CustomAuthMethodType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  usernameAttribute?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_custom_auth_method" */
export type Tenancy_Custom_Auth_Method_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Custom_Auth_Method_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Custom_Auth_Method_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  emailAttribute?: InputMaybe<Scalars['String']['input']>;
  entityIssuer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  issuerURL?: InputMaybe<Scalars['String']['input']>;
  mapper?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['CustomAuthMethodType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  usernameAttribute?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.custom_auth_method" */
export enum Tenancy_Custom_Auth_Method_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  ClientSecret = 'clientSecret',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailAttribute = 'emailAttribute',
  /** column name */
  EntityIssuer = 'entityIssuer',
  /** column name */
  Id = 'id',
  /** column name */
  IssuerUrl = 'issuerURL',
  /** column name */
  Mapper = 'mapper',
  /** column name */
  Name = 'name',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  Settings = 'settings',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UsernameAttribute = 'usernameAttribute'
}

export type Tenancy_Custom_Auth_Method_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Custom_Auth_Method_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Custom_Auth_Method_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Custom_Auth_Method_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Custom_Auth_Method_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Custom_Auth_Method_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Custom_Auth_Method_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Custom_Auth_Method_Bool_Exp;
};

/** columns and relationships of "tenancy.domain" */
export type Tenancy_Domain = {
  __typename?: 'tenancy_domain';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastVerifiedAt?: Maybe<Scalars['timestamp']['output']>;
  projectEnvironmentConfigId: Scalars['String']['output'];
  /** An object relationship */
  project_environment_config: Tenancy_Project_Environment_Config;
  type: Scalars['DomainType']['output'];
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
  url: Scalars['String']['output'];
  verificationStatus: Scalars['DomainVerificationStatus']['output'];
  verifiedThroughId?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "tenancy.domain" */
export type Tenancy_Domain_Aggregate = {
  __typename?: 'tenancy_domain_aggregate';
  aggregate?: Maybe<Tenancy_Domain_Aggregate_Fields>;
  nodes: Array<Tenancy_Domain>;
};

export type Tenancy_Domain_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Domain_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Domain_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Domain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Domain_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.domain" */
export type Tenancy_Domain_Aggregate_Fields = {
  __typename?: 'tenancy_domain_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Domain_Max_Fields>;
  min?: Maybe<Tenancy_Domain_Min_Fields>;
};


/** aggregate fields of "tenancy.domain" */
export type Tenancy_Domain_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Domain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.domain" */
export type Tenancy_Domain_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Domain_Max_Order_By>;
  min?: InputMaybe<Tenancy_Domain_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.domain" */
export type Tenancy_Domain_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Domain_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Domain_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.domain". All fields are combined with a logical 'AND'. */
export type Tenancy_Domain_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Domain_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Domain_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Domain_Bool_Exp>>;
  accountId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  host?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  lastVerifiedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  projectEnvironmentConfigId?: InputMaybe<String_Comparison_Exp>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
  type?: InputMaybe<DomainType_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  verificationStatus?: InputMaybe<DomainVerificationStatus_Comparison_Exp>;
  verifiedThroughId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.domain" */
export enum Tenancy_Domain_Constraint {
  /** unique or primary key constraint on columns "id" */
  DomainPkey = 'domain_pkey'
}

/** input type for inserting data into table "tenancy.domain" */
export type Tenancy_Domain_Insert_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastVerifiedAt?: InputMaybe<Scalars['timestamp']['input']>;
  projectEnvironmentConfigId?: InputMaybe<Scalars['String']['input']>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['DomainType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  verificationStatus?: InputMaybe<Scalars['DomainVerificationStatus']['input']>;
  verifiedThroughId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Domain_Max_Fields = {
  __typename?: 'tenancy_domain_max_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastVerifiedAt?: Maybe<Scalars['timestamp']['output']>;
  projectEnvironmentConfigId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['DomainType']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  verificationStatus?: Maybe<Scalars['DomainVerificationStatus']['output']>;
  verifiedThroughId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.domain" */
export type Tenancy_Domain_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  host?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastVerifiedAt?: InputMaybe<Order_By>;
  projectEnvironmentConfigId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  verificationStatus?: InputMaybe<Order_By>;
  verifiedThroughId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Domain_Min_Fields = {
  __typename?: 'tenancy_domain_min_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastVerifiedAt?: Maybe<Scalars['timestamp']['output']>;
  projectEnvironmentConfigId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['DomainType']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  verificationStatus?: Maybe<Scalars['DomainVerificationStatus']['output']>;
  verifiedThroughId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.domain" */
export type Tenancy_Domain_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  host?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastVerifiedAt?: InputMaybe<Order_By>;
  projectEnvironmentConfigId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  verificationStatus?: InputMaybe<Order_By>;
  verifiedThroughId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.domain" */
export type Tenancy_Domain_Mutation_Response = {
  __typename?: 'tenancy_domain_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Domain>;
};

/** on_conflict condition type for table "tenancy.domain" */
export type Tenancy_Domain_On_Conflict = {
  constraint: Tenancy_Domain_Constraint;
  update_columns?: Array<Tenancy_Domain_Update_Column>;
  where?: InputMaybe<Tenancy_Domain_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.domain". */
export type Tenancy_Domain_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  host?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastVerifiedAt?: InputMaybe<Order_By>;
  projectEnvironmentConfigId?: InputMaybe<Order_By>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  verificationStatus?: InputMaybe<Order_By>;
  verifiedThroughId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.domain */
export type Tenancy_Domain_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.domain" */
export enum Tenancy_Domain_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  LastVerifiedAt = 'lastVerifiedAt',
  /** column name */
  ProjectEnvironmentConfigId = 'projectEnvironmentConfigId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Url = 'url',
  /** column name */
  VerificationStatus = 'verificationStatus',
  /** column name */
  VerifiedThroughId = 'verifiedThroughId'
}

/** input type for updating data in table "tenancy.domain" */
export type Tenancy_Domain_Set_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastVerifiedAt?: InputMaybe<Scalars['timestamp']['input']>;
  projectEnvironmentConfigId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['DomainType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  verificationStatus?: InputMaybe<Scalars['DomainVerificationStatus']['input']>;
  verifiedThroughId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_domain" */
export type Tenancy_Domain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Domain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Domain_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastVerifiedAt?: InputMaybe<Scalars['timestamp']['input']>;
  projectEnvironmentConfigId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['DomainType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  verificationStatus?: InputMaybe<Scalars['DomainVerificationStatus']['input']>;
  verifiedThroughId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.domain" */
export enum Tenancy_Domain_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  LastVerifiedAt = 'lastVerifiedAt',
  /** column name */
  ProjectEnvironmentConfigId = 'projectEnvironmentConfigId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Url = 'url',
  /** column name */
  VerificationStatus = 'verificationStatus',
  /** column name */
  VerifiedThroughId = 'verifiedThroughId'
}

export type Tenancy_Domain_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Domain_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Domain_Bool_Exp;
};

/** columns and relationships of "tenancy.environment" */
export type Tenancy_Environment = {
  __typename?: 'tenancy_environment';
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  project_environment_configs: Array<Tenancy_Project_Environment_Config>;
  /** An aggregate relationship */
  project_environment_configs_aggregate: Tenancy_Project_Environment_Config_Aggregate;
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.environment" */
export type Tenancy_EnvironmentProject_Environment_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
};


/** columns and relationships of "tenancy.environment" */
export type Tenancy_EnvironmentProject_Environment_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
};

/** aggregated selection of "tenancy.environment" */
export type Tenancy_Environment_Aggregate = {
  __typename?: 'tenancy_environment_aggregate';
  aggregate?: Maybe<Tenancy_Environment_Aggregate_Fields>;
  nodes: Array<Tenancy_Environment>;
};

/** aggregate fields of "tenancy.environment" */
export type Tenancy_Environment_Aggregate_Fields = {
  __typename?: 'tenancy_environment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Environment_Max_Fields>;
  min?: Maybe<Tenancy_Environment_Min_Fields>;
};


/** aggregate fields of "tenancy.environment" */
export type Tenancy_Environment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Environment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.environment". All fields are combined with a logical 'AND'. */
export type Tenancy_Environment_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Environment_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Environment_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Environment_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_environment_configs?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
  project_environment_configs_aggregate?: InputMaybe<Tenancy_Project_Environment_Config_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.environment" */
export enum Tenancy_Environment_Constraint {
  /** unique or primary key constraint on columns "id" */
  EnvironmentPkey = 'environment_pkey'
}

/** input type for inserting data into table "tenancy.environment" */
export type Tenancy_Environment_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  project_environment_configs?: InputMaybe<Tenancy_Project_Environment_Config_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Environment_Max_Fields = {
  __typename?: 'tenancy_environment_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Environment_Min_Fields = {
  __typename?: 'tenancy_environment_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tenancy.environment" */
export type Tenancy_Environment_Mutation_Response = {
  __typename?: 'tenancy_environment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Environment>;
};

/** input type for inserting object relation for remote table "tenancy.environment" */
export type Tenancy_Environment_Obj_Rel_Insert_Input = {
  data: Tenancy_Environment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Environment_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.environment" */
export type Tenancy_Environment_On_Conflict = {
  constraint: Tenancy_Environment_Constraint;
  update_columns?: Array<Tenancy_Environment_Update_Column>;
  where?: InputMaybe<Tenancy_Environment_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.environment". */
export type Tenancy_Environment_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project_environment_configs_aggregate?: InputMaybe<Tenancy_Project_Environment_Config_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.environment */
export type Tenancy_Environment_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.environment" */
export enum Tenancy_Environment_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "tenancy.environment" */
export type Tenancy_Environment_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_environment" */
export type Tenancy_Environment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Environment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Environment_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.environment" */
export enum Tenancy_Environment_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type Tenancy_Environment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Environment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Environment_Bool_Exp;
};

/** columns and relationships of "tenancy.failed_kafka_events" */
export type Tenancy_Failed_Kafka_Events = {
  __typename?: 'tenancy_failed_kafka_events';
  createdAt: Scalars['timestamp']['output'];
  eventName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "tenancy.failed_kafka_events" */
export type Tenancy_Failed_Kafka_Events_Aggregate = {
  __typename?: 'tenancy_failed_kafka_events_aggregate';
  aggregate?: Maybe<Tenancy_Failed_Kafka_Events_Aggregate_Fields>;
  nodes: Array<Tenancy_Failed_Kafka_Events>;
};

/** aggregate fields of "tenancy.failed_kafka_events" */
export type Tenancy_Failed_Kafka_Events_Aggregate_Fields = {
  __typename?: 'tenancy_failed_kafka_events_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Failed_Kafka_Events_Max_Fields>;
  min?: Maybe<Tenancy_Failed_Kafka_Events_Min_Fields>;
};


/** aggregate fields of "tenancy.failed_kafka_events" */
export type Tenancy_Failed_Kafka_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Failed_Kafka_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.failed_kafka_events". All fields are combined with a logical 'AND'. */
export type Tenancy_Failed_Kafka_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Failed_Kafka_Events_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Failed_Kafka_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Failed_Kafka_Events_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  eventName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.failed_kafka_events" */
export enum Tenancy_Failed_Kafka_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  FailedKafkaEventsPkey = 'failed_kafka_events_pkey'
}

/** input type for inserting data into table "tenancy.failed_kafka_events" */
export type Tenancy_Failed_Kafka_Events_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Failed_Kafka_Events_Max_Fields = {
  __typename?: 'tenancy_failed_kafka_events_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Failed_Kafka_Events_Min_Fields = {
  __typename?: 'tenancy_failed_kafka_events_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tenancy.failed_kafka_events" */
export type Tenancy_Failed_Kafka_Events_Mutation_Response = {
  __typename?: 'tenancy_failed_kafka_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Failed_Kafka_Events>;
};

/** on_conflict condition type for table "tenancy.failed_kafka_events" */
export type Tenancy_Failed_Kafka_Events_On_Conflict = {
  constraint: Tenancy_Failed_Kafka_Events_Constraint;
  update_columns?: Array<Tenancy_Failed_Kafka_Events_Update_Column>;
  where?: InputMaybe<Tenancy_Failed_Kafka_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.failed_kafka_events". */
export type Tenancy_Failed_Kafka_Events_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.failed_kafka_events */
export type Tenancy_Failed_Kafka_Events_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.failed_kafka_events" */
export enum Tenancy_Failed_Kafka_Events_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventName = 'eventName',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "tenancy.failed_kafka_events" */
export type Tenancy_Failed_Kafka_Events_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_failed_kafka_events" */
export type Tenancy_Failed_Kafka_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Failed_Kafka_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Failed_Kafka_Events_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.failed_kafka_events" */
export enum Tenancy_Failed_Kafka_Events_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventName = 'eventName',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

export type Tenancy_Failed_Kafka_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Failed_Kafka_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Failed_Kafka_Events_Bool_Exp;
};

/** columns and relationships of "tenancy.file" */
export type Tenancy_File = {
  __typename?: 'tenancy_file';
  /** An object relationship */
  account?: Maybe<Tenancy_Accounts>;
  accountId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  applet?: Maybe<Tenancy_Applet>;
  appletId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project?: Maybe<Tenancy_Projects>;
  projectId?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  settings?: Maybe<Scalars['jsonb']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  solution_version?: Maybe<Tenancy_Solution_Versions>;
  url: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<Tenancy_Users>;
  userId?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "tenancy.file" */
export type Tenancy_FileSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.file" */
export type Tenancy_File_Aggregate = {
  __typename?: 'tenancy_file_aggregate';
  aggregate?: Maybe<Tenancy_File_Aggregate_Fields>;
  nodes: Array<Tenancy_File>;
};

export type Tenancy_File_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_File_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_File_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_File_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.file" */
export type Tenancy_File_Aggregate_Fields = {
  __typename?: 'tenancy_file_aggregate_fields';
  avg?: Maybe<Tenancy_File_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_File_Max_Fields>;
  min?: Maybe<Tenancy_File_Min_Fields>;
  stddev?: Maybe<Tenancy_File_Stddev_Fields>;
  stddev_pop?: Maybe<Tenancy_File_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenancy_File_Stddev_Samp_Fields>;
  sum?: Maybe<Tenancy_File_Sum_Fields>;
  var_pop?: Maybe<Tenancy_File_Var_Pop_Fields>;
  var_samp?: Maybe<Tenancy_File_Var_Samp_Fields>;
  variance?: Maybe<Tenancy_File_Variance_Fields>;
};


/** aggregate fields of "tenancy.file" */
export type Tenancy_File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.file" */
export type Tenancy_File_Aggregate_Order_By = {
  avg?: InputMaybe<Tenancy_File_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_File_Max_Order_By>;
  min?: InputMaybe<Tenancy_File_Min_Order_By>;
  stddev?: InputMaybe<Tenancy_File_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tenancy_File_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tenancy_File_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tenancy_File_Sum_Order_By>;
  var_pop?: InputMaybe<Tenancy_File_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tenancy_File_Var_Samp_Order_By>;
  variance?: InputMaybe<Tenancy_File_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_File_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.file" */
export type Tenancy_File_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_File_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_File_On_Conflict>;
};

/** aggregate avg on columns */
export type Tenancy_File_Avg_Fields = {
  __typename?: 'tenancy_file_avg_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tenancy.file" */
export type Tenancy_File_Avg_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tenancy.file". All fields are combined with a logical 'AND'. */
export type Tenancy_File_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_File_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_File_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_File_Bool_Exp>>;
  account?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  accountId?: InputMaybe<String_Comparison_Exp>;
  applet?: InputMaybe<Tenancy_Applet_Bool_Exp>;
  appletId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  originalName?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  publicId?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  solutionVersionId?: InputMaybe<String_Comparison_Exp>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Tenancy_Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.file" */
export enum Tenancy_File_Constraint {
  /** unique or primary key constraint on columns "accountId" */
  FileAccountIdKey = 'file_accountId_key',
  /** unique or primary key constraint on columns "appletId" */
  FileAppletIdKey = 'file_appletId_key',
  /** unique or primary key constraint on columns "id" */
  FilePkey = 'file_pkey',
  /** unique or primary key constraint on columns "projectId" */
  FileProjectIdKey = 'file_projectId_key',
  /** unique or primary key constraint on columns "userId" */
  FileUserIdKey = 'file_userId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_File_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_File_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_File_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "tenancy.file" */
export type Tenancy_File_Inc_Input = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tenancy.file" */
export type Tenancy_File_Insert_Input = {
  account?: InputMaybe<Tenancy_Accounts_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  applet?: InputMaybe<Tenancy_Applet_Obj_Rel_Insert_Input>;
  appletId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Tenancy_Projects_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Obj_Rel_Insert_Input>;
  url?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Tenancy_Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_File_Max_Fields = {
  __typename?: 'tenancy_file_max_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  appletId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.file" */
export type Tenancy_File_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  appletId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  originalName?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  publicId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_File_Min_Fields = {
  __typename?: 'tenancy_file_min_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  appletId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.file" */
export type Tenancy_File_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  appletId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  originalName?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  publicId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.file" */
export type Tenancy_File_Mutation_Response = {
  __typename?: 'tenancy_file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_File>;
};

/** on_conflict condition type for table "tenancy.file" */
export type Tenancy_File_On_Conflict = {
  constraint: Tenancy_File_Constraint;
  update_columns?: Array<Tenancy_File_Update_Column>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.file". */
export type Tenancy_File_Order_By = {
  account?: InputMaybe<Tenancy_Accounts_Order_By>;
  accountId?: InputMaybe<Order_By>;
  applet?: InputMaybe<Tenancy_Applet_Order_By>;
  appletId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  originalName?: InputMaybe<Order_By>;
  project?: InputMaybe<Tenancy_Projects_Order_By>;
  projectId?: InputMaybe<Order_By>;
  publicId?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Order_By>;
  url?: InputMaybe<Order_By>;
  user?: InputMaybe<Tenancy_Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.file */
export type Tenancy_File_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_File_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.file" */
export enum Tenancy_File_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AppletId = 'appletId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  OriginalName = 'originalName',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  PublicId = 'publicId',
  /** column name */
  Settings = 'settings',
  /** column name */
  Size = 'size',
  /** column name */
  SolutionVersionId = 'solutionVersionId',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "tenancy.file" */
export type Tenancy_File_Set_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  appletId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Tenancy_File_Stddev_Fields = {
  __typename?: 'tenancy_file_stddev_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tenancy.file" */
export type Tenancy_File_Stddev_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tenancy_File_Stddev_Pop_Fields = {
  __typename?: 'tenancy_file_stddev_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tenancy.file" */
export type Tenancy_File_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tenancy_File_Stddev_Samp_Fields = {
  __typename?: 'tenancy_file_stddev_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tenancy.file" */
export type Tenancy_File_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tenancy_file" */
export type Tenancy_File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_File_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  appletId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Tenancy_File_Sum_Fields = {
  __typename?: 'tenancy_file_sum_fields';
  size?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tenancy.file" */
export type Tenancy_File_Sum_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** update columns of table "tenancy.file" */
export enum Tenancy_File_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AppletId = 'appletId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  OriginalName = 'originalName',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  PublicId = 'publicId',
  /** column name */
  Settings = 'settings',
  /** column name */
  Size = 'size',
  /** column name */
  SolutionVersionId = 'solutionVersionId',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

export type Tenancy_File_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_File_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_File_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_File_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_File_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenancy_File_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_File_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_File_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_File_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tenancy_File_Var_Pop_Fields = {
  __typename?: 'tenancy_file_var_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tenancy.file" */
export type Tenancy_File_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tenancy_File_Var_Samp_Fields = {
  __typename?: 'tenancy_file_var_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tenancy.file" */
export type Tenancy_File_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tenancy_File_Variance_Fields = {
  __typename?: 'tenancy_file_variance_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tenancy.file" */
export type Tenancy_File_Variance_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** columns and relationships of "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials = {
  __typename?: 'tenancy_llm_credentials';
  apiKey: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  id: Scalars['String']['output'];
  llmProviderId: Scalars['String']['output'];
  /** An object relationship */
  llm_provider: Tenancy_Llm_Providers;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  project: Tenancy_Projects;
  projectId: Scalars['String']['output'];
  /** An array relationship */
  solution_versions: Array<Tenancy_Solution_Versions>;
  /** An aggregate relationship */
  solution_versions_aggregate: Tenancy_Solution_Versions_Aggregate;
};


/** columns and relationships of "tenancy.llm_credentials" */
export type Tenancy_Llm_CredentialsSolution_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
};


/** columns and relationships of "tenancy.llm_credentials" */
export type Tenancy_Llm_CredentialsSolution_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
};

/** aggregated selection of "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials_Aggregate = {
  __typename?: 'tenancy_llm_credentials_aggregate';
  aggregate?: Maybe<Tenancy_Llm_Credentials_Aggregate_Fields>;
  nodes: Array<Tenancy_Llm_Credentials>;
};

export type Tenancy_Llm_Credentials_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Llm_Credentials_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Llm_Credentials_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Llm_Credentials_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials_Aggregate_Fields = {
  __typename?: 'tenancy_llm_credentials_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Llm_Credentials_Max_Fields>;
  min?: Maybe<Tenancy_Llm_Credentials_Min_Fields>;
};


/** aggregate fields of "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Llm_Credentials_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Llm_Credentials_Max_Order_By>;
  min?: InputMaybe<Tenancy_Llm_Credentials_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Llm_Credentials_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Llm_Credentials_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.llm_credentials". All fields are combined with a logical 'AND'. */
export type Tenancy_Llm_Credentials_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Llm_Credentials_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Llm_Credentials_Bool_Exp>>;
  apiKey?: InputMaybe<String_Comparison_Exp>;
  endpoint?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  llmProviderId?: InputMaybe<String_Comparison_Exp>;
  llm_provider?: InputMaybe<Tenancy_Llm_Providers_Bool_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  solution_versions?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  solution_versions_aggregate?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.llm_credentials" */
export enum Tenancy_Llm_Credentials_Constraint {
  /** unique or primary key constraint on columns "id" */
  LlmCredentialsPkey = 'llm_credentials_pkey'
}

/** input type for inserting data into table "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials_Insert_Input = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  llmProviderId?: InputMaybe<Scalars['String']['input']>;
  llm_provider?: InputMaybe<Tenancy_Llm_Providers_Obj_Rel_Insert_Input>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Tenancy_Projects_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  solution_versions?: InputMaybe<Tenancy_Solution_Versions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Llm_Credentials_Max_Fields = {
  __typename?: 'tenancy_llm_credentials_max_fields';
  apiKey?: Maybe<Scalars['String']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  llmProviderId?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials_Max_Order_By = {
  apiKey?: InputMaybe<Order_By>;
  endpoint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llmProviderId?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Llm_Credentials_Min_Fields = {
  __typename?: 'tenancy_llm_credentials_min_fields';
  apiKey?: Maybe<Scalars['String']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  llmProviderId?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials_Min_Order_By = {
  apiKey?: InputMaybe<Order_By>;
  endpoint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llmProviderId?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials_Mutation_Response = {
  __typename?: 'tenancy_llm_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Llm_Credentials>;
};

/** input type for inserting object relation for remote table "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials_Obj_Rel_Insert_Input = {
  data: Tenancy_Llm_Credentials_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Llm_Credentials_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials_On_Conflict = {
  constraint: Tenancy_Llm_Credentials_Constraint;
  update_columns?: Array<Tenancy_Llm_Credentials_Update_Column>;
  where?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.llm_credentials". */
export type Tenancy_Llm_Credentials_Order_By = {
  apiKey?: InputMaybe<Order_By>;
  endpoint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llmProviderId?: InputMaybe<Order_By>;
  llm_provider?: InputMaybe<Tenancy_Llm_Providers_Order_By>;
  model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project?: InputMaybe<Tenancy_Projects_Order_By>;
  projectId?: InputMaybe<Order_By>;
  solution_versions_aggregate?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Order_By>;
};

/** primary key columns input for table: tenancy.llm_credentials */
export type Tenancy_Llm_Credentials_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.llm_credentials" */
export enum Tenancy_Llm_Credentials_Select_Column {
  /** column name */
  ApiKey = 'apiKey',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  Id = 'id',
  /** column name */
  LlmProviderId = 'llmProviderId',
  /** column name */
  Model = 'model',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'projectId'
}

/** input type for updating data in table "tenancy.llm_credentials" */
export type Tenancy_Llm_Credentials_Set_Input = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  llmProviderId?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_llm_credentials" */
export type Tenancy_Llm_Credentials_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Llm_Credentials_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Llm_Credentials_Stream_Cursor_Value_Input = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  llmProviderId?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.llm_credentials" */
export enum Tenancy_Llm_Credentials_Update_Column {
  /** column name */
  ApiKey = 'apiKey',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  Id = 'id',
  /** column name */
  LlmProviderId = 'llmProviderId',
  /** column name */
  Model = 'model',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'projectId'
}

export type Tenancy_Llm_Credentials_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Llm_Credentials_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Llm_Credentials_Bool_Exp;
};

/** columns and relationships of "tenancy.llm_providers" */
export type Tenancy_Llm_Providers = {
  __typename?: 'tenancy_llm_providers';
  displayName: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** An array relationship */
  llm_credentials: Array<Tenancy_Llm_Credentials>;
  /** An aggregate relationship */
  llm_credentials_aggregate: Tenancy_Llm_Credentials_Aggregate;
  name: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.llm_providers" */
export type Tenancy_Llm_ProvidersLlm_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Llm_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Llm_Credentials_Order_By>>;
  where?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
};


/** columns and relationships of "tenancy.llm_providers" */
export type Tenancy_Llm_ProvidersLlm_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Llm_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Llm_Credentials_Order_By>>;
  where?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
};

/** aggregated selection of "tenancy.llm_providers" */
export type Tenancy_Llm_Providers_Aggregate = {
  __typename?: 'tenancy_llm_providers_aggregate';
  aggregate?: Maybe<Tenancy_Llm_Providers_Aggregate_Fields>;
  nodes: Array<Tenancy_Llm_Providers>;
};

/** aggregate fields of "tenancy.llm_providers" */
export type Tenancy_Llm_Providers_Aggregate_Fields = {
  __typename?: 'tenancy_llm_providers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Llm_Providers_Max_Fields>;
  min?: Maybe<Tenancy_Llm_Providers_Min_Fields>;
};


/** aggregate fields of "tenancy.llm_providers" */
export type Tenancy_Llm_Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Llm_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.llm_providers". All fields are combined with a logical 'AND'. */
export type Tenancy_Llm_Providers_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Llm_Providers_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Llm_Providers_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Llm_Providers_Bool_Exp>>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  llm_credentials?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
  llm_credentials_aggregate?: InputMaybe<Tenancy_Llm_Credentials_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.llm_providers" */
export enum Tenancy_Llm_Providers_Constraint {
  /** unique or primary key constraint on columns "id" */
  LlmProvidersPkey = 'llm_providers_pkey'
}

/** input type for inserting data into table "tenancy.llm_providers" */
export type Tenancy_Llm_Providers_Insert_Input = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  llm_credentials?: InputMaybe<Tenancy_Llm_Credentials_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Llm_Providers_Max_Fields = {
  __typename?: 'tenancy_llm_providers_max_fields';
  displayName?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Llm_Providers_Min_Fields = {
  __typename?: 'tenancy_llm_providers_min_fields';
  displayName?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tenancy.llm_providers" */
export type Tenancy_Llm_Providers_Mutation_Response = {
  __typename?: 'tenancy_llm_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Llm_Providers>;
};

/** input type for inserting object relation for remote table "tenancy.llm_providers" */
export type Tenancy_Llm_Providers_Obj_Rel_Insert_Input = {
  data: Tenancy_Llm_Providers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Llm_Providers_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.llm_providers" */
export type Tenancy_Llm_Providers_On_Conflict = {
  constraint: Tenancy_Llm_Providers_Constraint;
  update_columns?: Array<Tenancy_Llm_Providers_Update_Column>;
  where?: InputMaybe<Tenancy_Llm_Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.llm_providers". */
export type Tenancy_Llm_Providers_Order_By = {
  displayName?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llm_credentials_aggregate?: InputMaybe<Tenancy_Llm_Credentials_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.llm_providers */
export type Tenancy_Llm_Providers_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.llm_providers" */
export enum Tenancy_Llm_Providers_Select_Column {
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "tenancy.llm_providers" */
export type Tenancy_Llm_Providers_Set_Input = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_llm_providers" */
export type Tenancy_Llm_Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Llm_Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Llm_Providers_Stream_Cursor_Value_Input = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.llm_providers" */
export enum Tenancy_Llm_Providers_Update_Column {
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Tenancy_Llm_Providers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Llm_Providers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Llm_Providers_Bool_Exp;
};

/** columns and relationships of "tenancy.locale" */
export type Tenancy_Locale = {
  __typename?: 'tenancy_locale';
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isoCode: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  /** An array relationship */
  localization_settings: Array<Tenancy_Localization_Settings>;
  /** An aggregate relationship */
  localization_settings_aggregate: Tenancy_Localization_Settings_Aggregate;
  name: Scalars['String']['output'];
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.locale" */
export type Tenancy_LocaleLocalization_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.locale" */
export type Tenancy_LocaleLocalization_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};

/** aggregated selection of "tenancy.locale" */
export type Tenancy_Locale_Aggregate = {
  __typename?: 'tenancy_locale_aggregate';
  aggregate?: Maybe<Tenancy_Locale_Aggregate_Fields>;
  nodes: Array<Tenancy_Locale>;
};

/** aggregate fields of "tenancy.locale" */
export type Tenancy_Locale_Aggregate_Fields = {
  __typename?: 'tenancy_locale_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Locale_Max_Fields>;
  min?: Maybe<Tenancy_Locale_Min_Fields>;
};


/** aggregate fields of "tenancy.locale" */
export type Tenancy_Locale_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Locale_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.locale". All fields are combined with a logical 'AND'. */
export type Tenancy_Locale_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Locale_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Locale_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Locale_Bool_Exp>>;
  countryCode?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isoCode?: InputMaybe<String_Comparison_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  localization_settings?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
  localization_settings_aggregate?: InputMaybe<Tenancy_Localization_Settings_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.locale" */
export enum Tenancy_Locale_Constraint {
  /** unique or primary key constraint on columns "id" */
  LocalePkey = 'locale_pkey'
}

/** input type for inserting data into table "tenancy.locale" */
export type Tenancy_Locale_Insert_Input = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isoCode?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localization_settings?: InputMaybe<Tenancy_Localization_Settings_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Locale_Max_Fields = {
  __typename?: 'tenancy_locale_max_fields';
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isoCode?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Locale_Min_Fields = {
  __typename?: 'tenancy_locale_min_fields';
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isoCode?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tenancy.locale" */
export type Tenancy_Locale_Mutation_Response = {
  __typename?: 'tenancy_locale_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Locale>;
};

/** input type for inserting object relation for remote table "tenancy.locale" */
export type Tenancy_Locale_Obj_Rel_Insert_Input = {
  data: Tenancy_Locale_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Locale_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.locale" */
export type Tenancy_Locale_On_Conflict = {
  constraint: Tenancy_Locale_Constraint;
  update_columns?: Array<Tenancy_Locale_Update_Column>;
  where?: InputMaybe<Tenancy_Locale_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.locale". */
export type Tenancy_Locale_Order_By = {
  countryCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isoCode?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  localization_settings_aggregate?: InputMaybe<Tenancy_Localization_Settings_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.locale */
export type Tenancy_Locale_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.locale" */
export enum Tenancy_Locale_Select_Column {
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  IsoCode = 'isoCode',
  /** column name */
  LanguageCode = 'languageCode',
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "tenancy.locale" */
export type Tenancy_Locale_Set_Input = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isoCode?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_locale" */
export type Tenancy_Locale_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Locale_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Locale_Stream_Cursor_Value_Input = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isoCode?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.locale" */
export enum Tenancy_Locale_Update_Column {
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  IsoCode = 'isoCode',
  /** column name */
  LanguageCode = 'languageCode',
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type Tenancy_Locale_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Locale_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Locale_Bool_Exp;
};

/** columns and relationships of "tenancy.localization_settings" */
export type Tenancy_Localization_Settings = {
  __typename?: 'tenancy_localization_settings';
  /** An object relationship */
  country?: Maybe<Tenancy_Country>;
  countryId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** An object relationship */
  locale?: Maybe<Tenancy_Locale>;
  localeId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project?: Maybe<Tenancy_Projects>;
  projectId?: Maybe<Scalars['String']['output']>;
  timeZoneId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  time_zone?: Maybe<Tenancy_Time_Zone>;
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<Tenancy_Users>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "tenancy.localization_settings" */
export type Tenancy_Localization_Settings_Aggregate = {
  __typename?: 'tenancy_localization_settings_aggregate';
  aggregate?: Maybe<Tenancy_Localization_Settings_Aggregate_Fields>;
  nodes: Array<Tenancy_Localization_Settings>;
};

export type Tenancy_Localization_Settings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Localization_Settings_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Localization_Settings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.localization_settings" */
export type Tenancy_Localization_Settings_Aggregate_Fields = {
  __typename?: 'tenancy_localization_settings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Localization_Settings_Max_Fields>;
  min?: Maybe<Tenancy_Localization_Settings_Min_Fields>;
};


/** aggregate fields of "tenancy.localization_settings" */
export type Tenancy_Localization_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.localization_settings" */
export type Tenancy_Localization_Settings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Localization_Settings_Max_Order_By>;
  min?: InputMaybe<Tenancy_Localization_Settings_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.localization_settings" */
export type Tenancy_Localization_Settings_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Localization_Settings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Localization_Settings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.localization_settings". All fields are combined with a logical 'AND'. */
export type Tenancy_Localization_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Localization_Settings_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Localization_Settings_Bool_Exp>>;
  country?: InputMaybe<Tenancy_Country_Bool_Exp>;
  countryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  locale?: InputMaybe<Tenancy_Locale_Bool_Exp>;
  localeId?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  timeZoneId?: InputMaybe<String_Comparison_Exp>;
  time_zone?: InputMaybe<Tenancy_Time_Zone_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Tenancy_Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.localization_settings" */
export enum Tenancy_Localization_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  LocalizationSettingsPkey = 'localization_settings_pkey',
  /** unique or primary key constraint on columns "projectId" */
  LocalizationSettingsProjectIdKey = 'localization_settings_projectId_key',
  /** unique or primary key constraint on columns "userId" */
  LocalizationSettingsUserIdKey = 'localization_settings_userId_key'
}

/** input type for inserting data into table "tenancy.localization_settings" */
export type Tenancy_Localization_Settings_Insert_Input = {
  country?: InputMaybe<Tenancy_Country_Obj_Rel_Insert_Input>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Tenancy_Locale_Obj_Rel_Insert_Input>;
  localeId?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Tenancy_Projects_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Tenancy_Time_Zone_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Tenancy_Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Localization_Settings_Max_Fields = {
  __typename?: 'tenancy_localization_settings_max_fields';
  countryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  localeId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  timeZoneId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.localization_settings" */
export type Tenancy_Localization_Settings_Max_Order_By = {
  countryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  localeId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  timeZoneId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Localization_Settings_Min_Fields = {
  __typename?: 'tenancy_localization_settings_min_fields';
  countryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  localeId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  timeZoneId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.localization_settings" */
export type Tenancy_Localization_Settings_Min_Order_By = {
  countryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  localeId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  timeZoneId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.localization_settings" */
export type Tenancy_Localization_Settings_Mutation_Response = {
  __typename?: 'tenancy_localization_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Localization_Settings>;
};

/** on_conflict condition type for table "tenancy.localization_settings" */
export type Tenancy_Localization_Settings_On_Conflict = {
  constraint: Tenancy_Localization_Settings_Constraint;
  update_columns?: Array<Tenancy_Localization_Settings_Update_Column>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.localization_settings". */
export type Tenancy_Localization_Settings_Order_By = {
  country?: InputMaybe<Tenancy_Country_Order_By>;
  countryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locale?: InputMaybe<Tenancy_Locale_Order_By>;
  localeId?: InputMaybe<Order_By>;
  project?: InputMaybe<Tenancy_Projects_Order_By>;
  projectId?: InputMaybe<Order_By>;
  timeZoneId?: InputMaybe<Order_By>;
  time_zone?: InputMaybe<Tenancy_Time_Zone_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  user?: InputMaybe<Tenancy_Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.localization_settings */
export type Tenancy_Localization_Settings_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.localization_settings" */
export enum Tenancy_Localization_Settings_Select_Column {
  /** column name */
  CountryId = 'countryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'localeId',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  TimeZoneId = 'timeZoneId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "tenancy.localization_settings" */
export type Tenancy_Localization_Settings_Set_Input = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  localeId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_localization_settings" */
export type Tenancy_Localization_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Localization_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Localization_Settings_Stream_Cursor_Value_Input = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  localeId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.localization_settings" */
export enum Tenancy_Localization_Settings_Update_Column {
  /** column name */
  CountryId = 'countryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'localeId',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  TimeZoneId = 'timeZoneId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UserId = 'userId'
}

export type Tenancy_Localization_Settings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Localization_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Localization_Settings_Bool_Exp;
};

/** columns and relationships of "tenancy.node_type_enum_ps" */
export type Tenancy_Node_Type_Enum_Ps = {
  __typename?: 'tenancy_node_type_enum_ps';
  /** An array relationship */
  solution_version_nodes_ps: Array<Tenancy_Solution_Version_Nodes_Ps>;
  /** An aggregate relationship */
  solution_version_nodes_ps_aggregate: Tenancy_Solution_Version_Nodes_Ps_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.node_type_enum_ps" */
export type Tenancy_Node_Type_Enum_PsSolution_Version_Nodes_PsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
};


/** columns and relationships of "tenancy.node_type_enum_ps" */
export type Tenancy_Node_Type_Enum_PsSolution_Version_Nodes_Ps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
};

/** aggregated selection of "tenancy.node_type_enum_ps" */
export type Tenancy_Node_Type_Enum_Ps_Aggregate = {
  __typename?: 'tenancy_node_type_enum_ps_aggregate';
  aggregate?: Maybe<Tenancy_Node_Type_Enum_Ps_Aggregate_Fields>;
  nodes: Array<Tenancy_Node_Type_Enum_Ps>;
};

/** aggregate fields of "tenancy.node_type_enum_ps" */
export type Tenancy_Node_Type_Enum_Ps_Aggregate_Fields = {
  __typename?: 'tenancy_node_type_enum_ps_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Node_Type_Enum_Ps_Max_Fields>;
  min?: Maybe<Tenancy_Node_Type_Enum_Ps_Min_Fields>;
};


/** aggregate fields of "tenancy.node_type_enum_ps" */
export type Tenancy_Node_Type_Enum_Ps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.node_type_enum_ps". All fields are combined with a logical 'AND'. */
export type Tenancy_Node_Type_Enum_Ps_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Bool_Exp>>;
  solution_version_nodes_ps?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
  solution_version_nodes_ps_aggregate?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.node_type_enum_ps" */
export enum Tenancy_Node_Type_Enum_Ps_Constraint {
  /** unique or primary key constraint on columns "value" */
  NodeTypeEnumPsPkey = 'node_type_enum_ps_pkey'
}

export enum Tenancy_Node_Type_Enum_Ps_Enum {
  A = 'a',
  D = 'd',
  G = 'g'
}

/** Boolean expression to compare columns of type "tenancy_node_type_enum_ps_enum". All fields are combined with logical 'AND'. */
export type Tenancy_Node_Type_Enum_Ps_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Enum>;
  _in?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Enum>;
  _nin?: InputMaybe<Array<Tenancy_Node_Type_Enum_Ps_Enum>>;
};

/** input type for inserting data into table "tenancy.node_type_enum_ps" */
export type Tenancy_Node_Type_Enum_Ps_Insert_Input = {
  solution_version_nodes_ps?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Node_Type_Enum_Ps_Max_Fields = {
  __typename?: 'tenancy_node_type_enum_ps_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Node_Type_Enum_Ps_Min_Fields = {
  __typename?: 'tenancy_node_type_enum_ps_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tenancy.node_type_enum_ps" */
export type Tenancy_Node_Type_Enum_Ps_Mutation_Response = {
  __typename?: 'tenancy_node_type_enum_ps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Node_Type_Enum_Ps>;
};

/** input type for inserting object relation for remote table "tenancy.node_type_enum_ps" */
export type Tenancy_Node_Type_Enum_Ps_Obj_Rel_Insert_Input = {
  data: Tenancy_Node_Type_Enum_Ps_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Node_Type_Enum_Ps_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.node_type_enum_ps" */
export type Tenancy_Node_Type_Enum_Ps_On_Conflict = {
  constraint: Tenancy_Node_Type_Enum_Ps_Constraint;
  update_columns?: Array<Tenancy_Node_Type_Enum_Ps_Update_Column>;
  where?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.node_type_enum_ps". */
export type Tenancy_Node_Type_Enum_Ps_Order_By = {
  solution_version_nodes_ps_aggregate?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.node_type_enum_ps */
export type Tenancy_Node_Type_Enum_Ps_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "tenancy.node_type_enum_ps" */
export enum Tenancy_Node_Type_Enum_Ps_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "tenancy.node_type_enum_ps" */
export type Tenancy_Node_Type_Enum_Ps_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_node_type_enum_ps" */
export type Tenancy_Node_Type_Enum_Ps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Node_Type_Enum_Ps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Node_Type_Enum_Ps_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.node_type_enum_ps" */
export enum Tenancy_Node_Type_Enum_Ps_Update_Column {
  /** column name */
  Value = 'value'
}

export type Tenancy_Node_Type_Enum_Ps_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Node_Type_Enum_Ps_Bool_Exp;
};

/** columns and relationships of "tenancy.package" */
export type Tenancy_Package = {
  __typename?: 'tenancy_package';
  /** An array relationship */
  actions: Array<Tenancy_Action>;
  /** An aggregate relationship */
  actions_aggregate: Tenancy_Action_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latestVersionId?: Maybe<Scalars['String']['output']>;
  packageTypes?: Maybe<Array<Scalars['PackageType']['output']>>;
  /** An object relationship */
  package_version?: Maybe<Tenancy_Package_Version>;
  /** An array relationship */
  package_versions: Array<Tenancy_Package_Version>;
  /** An aggregate relationship */
  package_versions_aggregate: Tenancy_Package_Version_Aggregate;
  pkgName: Scalars['String']['output'];
  /** An array relationship */
  triggers: Array<Tenancy_Trigger>;
  /** An aggregate relationship */
  triggers_aggregate: Tenancy_Trigger_Aggregate;
  updatedAt: Scalars['timestamp']['output'];
};


/** columns and relationships of "tenancy.package" */
export type Tenancy_PackageActionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Bool_Exp>;
};


/** columns and relationships of "tenancy.package" */
export type Tenancy_PackageActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Bool_Exp>;
};


/** columns and relationships of "tenancy.package" */
export type Tenancy_PackagePackage_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Package_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Package_Version_Order_By>>;
  where?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
};


/** columns and relationships of "tenancy.package" */
export type Tenancy_PackagePackage_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Package_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Package_Version_Order_By>>;
  where?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
};


/** columns and relationships of "tenancy.package" */
export type Tenancy_PackageTriggersArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Trigger_Order_By>>;
  where?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
};


/** columns and relationships of "tenancy.package" */
export type Tenancy_PackageTriggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Trigger_Order_By>>;
  where?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
};

/** aggregated selection of "tenancy.package" */
export type Tenancy_Package_Aggregate = {
  __typename?: 'tenancy_package_aggregate';
  aggregate?: Maybe<Tenancy_Package_Aggregate_Fields>;
  nodes: Array<Tenancy_Package>;
};

export type Tenancy_Package_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Package_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Package_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Package_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Package_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.package" */
export type Tenancy_Package_Aggregate_Fields = {
  __typename?: 'tenancy_package_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Package_Max_Fields>;
  min?: Maybe<Tenancy_Package_Min_Fields>;
};


/** aggregate fields of "tenancy.package" */
export type Tenancy_Package_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Package_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.package" */
export type Tenancy_Package_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Package_Max_Order_By>;
  min?: InputMaybe<Tenancy_Package_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.package" */
export type Tenancy_Package_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Package_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Package_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.package". All fields are combined with a logical 'AND'. */
export type Tenancy_Package_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Package_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Package_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Package_Bool_Exp>>;
  actions?: InputMaybe<Tenancy_Action_Bool_Exp>;
  actions_aggregate?: InputMaybe<Tenancy_Action_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  latestVersionId?: InputMaybe<String_Comparison_Exp>;
  packageTypes?: InputMaybe<PackageType_Array_Comparison_Exp>;
  package_version?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
  package_versions?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
  package_versions_aggregate?: InputMaybe<Tenancy_Package_Version_Aggregate_Bool_Exp>;
  pkgName?: InputMaybe<String_Comparison_Exp>;
  triggers?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
  triggers_aggregate?: InputMaybe<Tenancy_Trigger_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.package" */
export enum Tenancy_Package_Constraint {
  /** unique or primary key constraint on columns "latestVersionId" */
  PackageLatestVersionIdKey = 'package_latestVersionId_key',
  /** unique or primary key constraint on columns "id" */
  PackagePkey = 'package_pkey',
  /** unique or primary key constraint on columns "pkgName" */
  PackagePkgNameKey = 'package_pkgName_key'
}

/** input type for inserting data into table "tenancy.package" */
export type Tenancy_Package_Insert_Input = {
  actions?: InputMaybe<Tenancy_Action_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionId?: InputMaybe<Scalars['String']['input']>;
  packageTypes?: InputMaybe<Array<Scalars['PackageType']['input']>>;
  package_version?: InputMaybe<Tenancy_Package_Version_Obj_Rel_Insert_Input>;
  package_versions?: InputMaybe<Tenancy_Package_Version_Arr_Rel_Insert_Input>;
  pkgName?: InputMaybe<Scalars['String']['input']>;
  triggers?: InputMaybe<Tenancy_Trigger_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Package_Max_Fields = {
  __typename?: 'tenancy_package_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latestVersionId?: Maybe<Scalars['String']['output']>;
  packageTypes?: Maybe<Array<Scalars['PackageType']['output']>>;
  pkgName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.package" */
export type Tenancy_Package_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionId?: InputMaybe<Order_By>;
  packageTypes?: InputMaybe<Order_By>;
  pkgName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Package_Min_Fields = {
  __typename?: 'tenancy_package_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latestVersionId?: Maybe<Scalars['String']['output']>;
  packageTypes?: Maybe<Array<Scalars['PackageType']['output']>>;
  pkgName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.package" */
export type Tenancy_Package_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionId?: InputMaybe<Order_By>;
  packageTypes?: InputMaybe<Order_By>;
  pkgName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.package" */
export type Tenancy_Package_Mutation_Response = {
  __typename?: 'tenancy_package_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Package>;
};

/** input type for inserting object relation for remote table "tenancy.package" */
export type Tenancy_Package_Obj_Rel_Insert_Input = {
  data: Tenancy_Package_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Package_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.package" */
export type Tenancy_Package_On_Conflict = {
  constraint: Tenancy_Package_Constraint;
  update_columns?: Array<Tenancy_Package_Update_Column>;
  where?: InputMaybe<Tenancy_Package_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.package". */
export type Tenancy_Package_Order_By = {
  actions_aggregate?: InputMaybe<Tenancy_Action_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionId?: InputMaybe<Order_By>;
  packageTypes?: InputMaybe<Order_By>;
  package_version?: InputMaybe<Tenancy_Package_Version_Order_By>;
  package_versions_aggregate?: InputMaybe<Tenancy_Package_Version_Aggregate_Order_By>;
  pkgName?: InputMaybe<Order_By>;
  triggers_aggregate?: InputMaybe<Tenancy_Trigger_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.package */
export type Tenancy_Package_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.package" */
export enum Tenancy_Package_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  LatestVersionId = 'latestVersionId',
  /** column name */
  PackageTypes = 'packageTypes',
  /** column name */
  PkgName = 'pkgName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tenancy.package" */
export type Tenancy_Package_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionId?: InputMaybe<Scalars['String']['input']>;
  packageTypes?: InputMaybe<Array<Scalars['PackageType']['input']>>;
  pkgName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_package" */
export type Tenancy_Package_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Package_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Package_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionId?: InputMaybe<Scalars['String']['input']>;
  packageTypes?: InputMaybe<Array<Scalars['PackageType']['input']>>;
  pkgName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.package" */
export enum Tenancy_Package_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  LatestVersionId = 'latestVersionId',
  /** column name */
  PackageTypes = 'packageTypes',
  /** column name */
  PkgName = 'pkgName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Package_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Package_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Package_Bool_Exp;
};

/** columns and relationships of "tenancy.package_version" */
export type Tenancy_Package_Version = {
  __typename?: 'tenancy_package_version';
  /** An array relationship */
  actions: Array<Tenancy_Action>;
  /** An aggregate relationship */
  actions_aggregate: Tenancy_Action_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
  isLatestInMinor: Scalars['Boolean']['output'];
  /** An object relationship */
  package: Tenancy_Package;
  packageId: Scalars['String']['output'];
  packageJson: Scalars['jsonb']['output'];
  /** An array relationship */
  packages: Array<Tenancy_Package>;
  /** An aggregate relationship */
  packages_aggregate: Tenancy_Package_Aggregate;
  schema: Scalars['jsonb']['output'];
  /** An array relationship */
  triggers: Array<Tenancy_Trigger>;
  /** An aggregate relationship */
  triggers_aggregate: Tenancy_Trigger_Aggregate;
  version: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.package_version" */
export type Tenancy_Package_VersionActionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Bool_Exp>;
};


/** columns and relationships of "tenancy.package_version" */
export type Tenancy_Package_VersionActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Bool_Exp>;
};


/** columns and relationships of "tenancy.package_version" */
export type Tenancy_Package_VersionPackageJsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.package_version" */
export type Tenancy_Package_VersionPackagesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Package_Order_By>>;
  where?: InputMaybe<Tenancy_Package_Bool_Exp>;
};


/** columns and relationships of "tenancy.package_version" */
export type Tenancy_Package_VersionPackages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Package_Order_By>>;
  where?: InputMaybe<Tenancy_Package_Bool_Exp>;
};


/** columns and relationships of "tenancy.package_version" */
export type Tenancy_Package_VersionSchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.package_version" */
export type Tenancy_Package_VersionTriggersArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Trigger_Order_By>>;
  where?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
};


/** columns and relationships of "tenancy.package_version" */
export type Tenancy_Package_VersionTriggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Trigger_Order_By>>;
  where?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
};

/** aggregated selection of "tenancy.package_version" */
export type Tenancy_Package_Version_Aggregate = {
  __typename?: 'tenancy_package_version_aggregate';
  aggregate?: Maybe<Tenancy_Package_Version_Aggregate_Fields>;
  nodes: Array<Tenancy_Package_Version>;
};

export type Tenancy_Package_Version_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_Package_Version_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_Package_Version_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_Package_Version_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Package_Version_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_Package_Version_Select_Column_Tenancy_Package_Version_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Package_Version_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_Package_Version_Select_Column_Tenancy_Package_Version_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Package_Version_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Package_Version_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.package_version" */
export type Tenancy_Package_Version_Aggregate_Fields = {
  __typename?: 'tenancy_package_version_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Package_Version_Max_Fields>;
  min?: Maybe<Tenancy_Package_Version_Min_Fields>;
};


/** aggregate fields of "tenancy.package_version" */
export type Tenancy_Package_Version_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Package_Version_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.package_version" */
export type Tenancy_Package_Version_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Package_Version_Max_Order_By>;
  min?: InputMaybe<Tenancy_Package_Version_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Package_Version_Append_Input = {
  packageJson?: InputMaybe<Scalars['jsonb']['input']>;
  schema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.package_version" */
export type Tenancy_Package_Version_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Package_Version_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Package_Version_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.package_version". All fields are combined with a logical 'AND'. */
export type Tenancy_Package_Version_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Package_Version_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Package_Version_Bool_Exp>>;
  actions?: InputMaybe<Tenancy_Action_Bool_Exp>;
  actions_aggregate?: InputMaybe<Tenancy_Action_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isLatestInMinor?: InputMaybe<Boolean_Comparison_Exp>;
  package?: InputMaybe<Tenancy_Package_Bool_Exp>;
  packageId?: InputMaybe<String_Comparison_Exp>;
  packageJson?: InputMaybe<Jsonb_Comparison_Exp>;
  packages?: InputMaybe<Tenancy_Package_Bool_Exp>;
  packages_aggregate?: InputMaybe<Tenancy_Package_Aggregate_Bool_Exp>;
  schema?: InputMaybe<Jsonb_Comparison_Exp>;
  triggers?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
  triggers_aggregate?: InputMaybe<Tenancy_Trigger_Aggregate_Bool_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.package_version" */
export enum Tenancy_Package_Version_Constraint {
  /** unique or primary key constraint on columns "id" */
  PackageVersionPkey = 'package_version_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Package_Version_Delete_At_Path_Input = {
  packageJson?: InputMaybe<Array<Scalars['String']['input']>>;
  schema?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Package_Version_Delete_Elem_Input = {
  packageJson?: InputMaybe<Scalars['Int']['input']>;
  schema?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Package_Version_Delete_Key_Input = {
  packageJson?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.package_version" */
export type Tenancy_Package_Version_Insert_Input = {
  actions?: InputMaybe<Tenancy_Action_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLatestInMinor?: InputMaybe<Scalars['Boolean']['input']>;
  package?: InputMaybe<Tenancy_Package_Obj_Rel_Insert_Input>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  packageJson?: InputMaybe<Scalars['jsonb']['input']>;
  packages?: InputMaybe<Tenancy_Package_Arr_Rel_Insert_Input>;
  schema?: InputMaybe<Scalars['jsonb']['input']>;
  triggers?: InputMaybe<Tenancy_Trigger_Arr_Rel_Insert_Input>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Package_Version_Max_Fields = {
  __typename?: 'tenancy_package_version_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.package_version" */
export type Tenancy_Package_Version_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packageId?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Package_Version_Min_Fields = {
  __typename?: 'tenancy_package_version_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.package_version" */
export type Tenancy_Package_Version_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packageId?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.package_version" */
export type Tenancy_Package_Version_Mutation_Response = {
  __typename?: 'tenancy_package_version_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Package_Version>;
};

/** input type for inserting object relation for remote table "tenancy.package_version" */
export type Tenancy_Package_Version_Obj_Rel_Insert_Input = {
  data: Tenancy_Package_Version_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Package_Version_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.package_version" */
export type Tenancy_Package_Version_On_Conflict = {
  constraint: Tenancy_Package_Version_Constraint;
  update_columns?: Array<Tenancy_Package_Version_Update_Column>;
  where?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.package_version". */
export type Tenancy_Package_Version_Order_By = {
  actions_aggregate?: InputMaybe<Tenancy_Action_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isLatestInMinor?: InputMaybe<Order_By>;
  package?: InputMaybe<Tenancy_Package_Order_By>;
  packageId?: InputMaybe<Order_By>;
  packageJson?: InputMaybe<Order_By>;
  packages_aggregate?: InputMaybe<Tenancy_Package_Aggregate_Order_By>;
  schema?: InputMaybe<Order_By>;
  triggers_aggregate?: InputMaybe<Tenancy_Trigger_Aggregate_Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.package_version */
export type Tenancy_Package_Version_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Package_Version_Prepend_Input = {
  packageJson?: InputMaybe<Scalars['jsonb']['input']>;
  schema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.package_version" */
export enum Tenancy_Package_Version_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsLatestInMinor = 'isLatestInMinor',
  /** column name */
  PackageId = 'packageId',
  /** column name */
  PackageJson = 'packageJson',
  /** column name */
  Schema = 'schema',
  /** column name */
  Version = 'version'
}

/** select "tenancy_package_version_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.package_version" */
export enum Tenancy_Package_Version_Select_Column_Tenancy_Package_Version_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsLatestInMinor = 'isLatestInMinor'
}

/** select "tenancy_package_version_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.package_version" */
export enum Tenancy_Package_Version_Select_Column_Tenancy_Package_Version_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsLatestInMinor = 'isLatestInMinor'
}

/** input type for updating data in table "tenancy.package_version" */
export type Tenancy_Package_Version_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLatestInMinor?: InputMaybe<Scalars['Boolean']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  packageJson?: InputMaybe<Scalars['jsonb']['input']>;
  schema?: InputMaybe<Scalars['jsonb']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_package_version" */
export type Tenancy_Package_Version_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Package_Version_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Package_Version_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLatestInMinor?: InputMaybe<Scalars['Boolean']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  packageJson?: InputMaybe<Scalars['jsonb']['input']>;
  schema?: InputMaybe<Scalars['jsonb']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.package_version" */
export enum Tenancy_Package_Version_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsLatestInMinor = 'isLatestInMinor',
  /** column name */
  PackageId = 'packageId',
  /** column name */
  PackageJson = 'packageJson',
  /** column name */
  Schema = 'schema',
  /** column name */
  Version = 'version'
}

export type Tenancy_Package_Version_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Package_Version_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Package_Version_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Package_Version_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Package_Version_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Package_Version_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Package_Version_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Package_Version_Bool_Exp;
};

/** columns and relationships of "tenancy.pro_studio_performance_metrics" */
export type Tenancy_Pro_Studio_Performance_Metrics = {
  __typename?: 'tenancy_pro_studio_performance_metrics';
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
  settings?: Maybe<Scalars['jsonb']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "tenancy.pro_studio_performance_metrics" */
export type Tenancy_Pro_Studio_Performance_MetricsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.pro_studio_performance_metrics" */
export type Tenancy_Pro_Studio_Performance_Metrics_Aggregate = {
  __typename?: 'tenancy_pro_studio_performance_metrics_aggregate';
  aggregate?: Maybe<Tenancy_Pro_Studio_Performance_Metrics_Aggregate_Fields>;
  nodes: Array<Tenancy_Pro_Studio_Performance_Metrics>;
};

/** aggregate fields of "tenancy.pro_studio_performance_metrics" */
export type Tenancy_Pro_Studio_Performance_Metrics_Aggregate_Fields = {
  __typename?: 'tenancy_pro_studio_performance_metrics_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Pro_Studio_Performance_Metrics_Max_Fields>;
  min?: Maybe<Tenancy_Pro_Studio_Performance_Metrics_Min_Fields>;
};


/** aggregate fields of "tenancy.pro_studio_performance_metrics" */
export type Tenancy_Pro_Studio_Performance_Metrics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Pro_Studio_Performance_Metrics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Pro_Studio_Performance_Metrics_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.pro_studio_performance_metrics". All fields are combined with a logical 'AND'. */
export type Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.pro_studio_performance_metrics" */
export enum Tenancy_Pro_Studio_Performance_Metrics_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProStudioPerformanceMetricsPkey = 'pro_studio_performance_metrics_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Pro_Studio_Performance_Metrics_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Pro_Studio_Performance_Metrics_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Pro_Studio_Performance_Metrics_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.pro_studio_performance_metrics" */
export type Tenancy_Pro_Studio_Performance_Metrics_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Pro_Studio_Performance_Metrics_Max_Fields = {
  __typename?: 'tenancy_pro_studio_performance_metrics_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Pro_Studio_Performance_Metrics_Min_Fields = {
  __typename?: 'tenancy_pro_studio_performance_metrics_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "tenancy.pro_studio_performance_metrics" */
export type Tenancy_Pro_Studio_Performance_Metrics_Mutation_Response = {
  __typename?: 'tenancy_pro_studio_performance_metrics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Pro_Studio_Performance_Metrics>;
};

/** on_conflict condition type for table "tenancy.pro_studio_performance_metrics" */
export type Tenancy_Pro_Studio_Performance_Metrics_On_Conflict = {
  constraint: Tenancy_Pro_Studio_Performance_Metrics_Constraint;
  update_columns?: Array<Tenancy_Pro_Studio_Performance_Metrics_Update_Column>;
  where?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.pro_studio_performance_metrics". */
export type Tenancy_Pro_Studio_Performance_Metrics_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.pro_studio_performance_metrics */
export type Tenancy_Pro_Studio_Performance_Metrics_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Pro_Studio_Performance_Metrics_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.pro_studio_performance_metrics" */
export enum Tenancy_Pro_Studio_Performance_Metrics_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Settings = 'settings',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tenancy.pro_studio_performance_metrics" */
export type Tenancy_Pro_Studio_Performance_Metrics_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_pro_studio_performance_metrics" */
export type Tenancy_Pro_Studio_Performance_Metrics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Pro_Studio_Performance_Metrics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Pro_Studio_Performance_Metrics_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.pro_studio_performance_metrics" */
export enum Tenancy_Pro_Studio_Performance_Metrics_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Settings = 'settings',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Pro_Studio_Performance_Metrics_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Pro_Studio_Performance_Metrics_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Pro_Studio_Performance_Metrics_Bool_Exp;
};

/** columns and relationships of "tenancy.products" */
export type Tenancy_Products = {
  __typename?: 'tenancy_products';
  /** An array relationship */
  audit_logs: Array<Tenancy_Audit_Logs>;
  /** An aggregate relationship */
  audit_logs_aggregate: Tenancy_Audit_Logs_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  project_product_settings: Array<Tenancy_Project_Product_Settings>;
  /** An aggregate relationship */
  project_product_settings_aggregate: Tenancy_Project_Product_Settings_Aggregate;
  /** An array relationship */
  roles: Array<Tenancy_Roles>;
  /** An aggregate relationship */
  roles_aggregate: Tenancy_Roles_Aggregate;
  settings?: Maybe<Scalars['jsonb']['output']>;
  updatedAt: Scalars['timestamp']['output'];
};


/** columns and relationships of "tenancy.products" */
export type Tenancy_ProductsAudit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Audit_Logs_Order_By>>;
  where?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "tenancy.products" */
export type Tenancy_ProductsAudit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Audit_Logs_Order_By>>;
  where?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "tenancy.products" */
export type Tenancy_ProductsProject_Product_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Product_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Product_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.products" */
export type Tenancy_ProductsProject_Product_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Product_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Product_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.products" */
export type Tenancy_ProductsRolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Roles_Order_By>>;
  where?: InputMaybe<Tenancy_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.products" */
export type Tenancy_ProductsRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Roles_Order_By>>;
  where?: InputMaybe<Tenancy_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.products" */
export type Tenancy_ProductsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.products" */
export type Tenancy_Products_Aggregate = {
  __typename?: 'tenancy_products_aggregate';
  aggregate?: Maybe<Tenancy_Products_Aggregate_Fields>;
  nodes: Array<Tenancy_Products>;
};

/** aggregate fields of "tenancy.products" */
export type Tenancy_Products_Aggregate_Fields = {
  __typename?: 'tenancy_products_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Products_Max_Fields>;
  min?: Maybe<Tenancy_Products_Min_Fields>;
};


/** aggregate fields of "tenancy.products" */
export type Tenancy_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Products_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.products". All fields are combined with a logical 'AND'. */
export type Tenancy_Products_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Products_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Products_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Products_Bool_Exp>>;
  audit_logs?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
  audit_logs_aggregate?: InputMaybe<Tenancy_Audit_Logs_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_product_settings?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
  project_product_settings_aggregate?: InputMaybe<Tenancy_Project_Product_Settings_Aggregate_Bool_Exp>;
  roles?: InputMaybe<Tenancy_Roles_Bool_Exp>;
  roles_aggregate?: InputMaybe<Tenancy_Roles_Aggregate_Bool_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.products" */
export enum Tenancy_Products_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductsPkey = 'products_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Products_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Products_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Products_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.products" */
export type Tenancy_Products_Insert_Input = {
  audit_logs?: InputMaybe<Tenancy_Audit_Logs_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  project_product_settings?: InputMaybe<Tenancy_Project_Product_Settings_Arr_Rel_Insert_Input>;
  roles?: InputMaybe<Tenancy_Roles_Arr_Rel_Insert_Input>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Products_Max_Fields = {
  __typename?: 'tenancy_products_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Products_Min_Fields = {
  __typename?: 'tenancy_products_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "tenancy.products" */
export type Tenancy_Products_Mutation_Response = {
  __typename?: 'tenancy_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Products>;
};

/** input type for inserting object relation for remote table "tenancy.products" */
export type Tenancy_Products_Obj_Rel_Insert_Input = {
  data: Tenancy_Products_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Products_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.products" */
export type Tenancy_Products_On_Conflict = {
  constraint: Tenancy_Products_Constraint;
  update_columns?: Array<Tenancy_Products_Update_Column>;
  where?: InputMaybe<Tenancy_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.products". */
export type Tenancy_Products_Order_By = {
  audit_logs_aggregate?: InputMaybe<Tenancy_Audit_Logs_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project_product_settings_aggregate?: InputMaybe<Tenancy_Project_Product_Settings_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<Tenancy_Roles_Aggregate_Order_By>;
  settings?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.products */
export type Tenancy_Products_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Products_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.products" */
export enum Tenancy_Products_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tenancy.products" */
export type Tenancy_Products_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_products" */
export type Tenancy_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Products_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.products" */
export enum Tenancy_Products_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Products_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Products_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Products_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Products_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Products_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Products_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Products_Bool_Exp;
};

/** columns and relationships of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config = {
  __typename?: 'tenancy_project_environment_config';
  /** An array relationship */
  _ProjectEnvironmentConfigToVariables: Array<Tenancy__ProjectEnvironmentConfigToVariable>;
  /** An aggregate relationship */
  _ProjectEnvironmentConfigToVariables_aggregate: Tenancy__ProjectEnvironmentConfigToVariable_Aggregate;
  /** An array relationship */
  applet_instances: Array<Tenancy_Applet_Instance>;
  /** An aggregate relationship */
  applet_instances_aggregate: Tenancy_Applet_Instance_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  domains: Array<Tenancy_Domain>;
  /** An aggregate relationship */
  domains_aggregate: Tenancy_Domain_Aggregate;
  /** An object relationship */
  environment: Tenancy_Environment;
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** An object relationship */
  project: Tenancy_Projects;
  projectId: Scalars['String']['output'];
  shortId?: Maybe<Scalars['String']['output']>;
  status: Scalars['EnvironmentStatus']['output'];
  /** An array relationship */
  team_account_environment_configs: Array<Tenancy_Team_Account_Environment_Config>;
  /** An aggregate relationship */
  team_account_environment_configs_aggregate: Tenancy_Team_Account_Environment_Config_Aggregate;
  /** An array relationship */
  user_account_environment_configs: Array<Tenancy_User_Account_Environment_Config>;
  /** An aggregate relationship */
  user_account_environment_configs_aggregate: Tenancy_User_Account_Environment_Config_Aggregate;
};


/** columns and relationships of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_ProjectEnvironmentConfigToVariablesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Order_By>>;
  where?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_ProjectEnvironmentConfigToVariables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Order_By>>;
  where?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_ConfigApplet_InstancesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Instance_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_ConfigApplet_Instances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Applet_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Applet_Instance_Order_By>>;
  where?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_ConfigDomainsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Domain_Order_By>>;
  where?: InputMaybe<Tenancy_Domain_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_ConfigDomains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Domain_Order_By>>;
  where?: InputMaybe<Tenancy_Domain_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_ConfigTeam_Account_Environment_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_ConfigTeam_Account_Environment_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_ConfigUser_Account_Environment_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_ConfigUser_Account_Environment_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
};

/** aggregated selection of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_Aggregate = {
  __typename?: 'tenancy_project_environment_config_aggregate';
  aggregate?: Maybe<Tenancy_Project_Environment_Config_Aggregate_Fields>;
  nodes: Array<Tenancy_Project_Environment_Config>;
};

export type Tenancy_Project_Environment_Config_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Project_Environment_Config_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Project_Environment_Config_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Project_Environment_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_Aggregate_Fields = {
  __typename?: 'tenancy_project_environment_config_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Project_Environment_Config_Max_Fields>;
  min?: Maybe<Tenancy_Project_Environment_Config_Min_Fields>;
};


/** aggregate fields of "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Project_Environment_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Project_Environment_Config_Max_Order_By>;
  min?: InputMaybe<Tenancy_Project_Environment_Config_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Project_Environment_Config_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Project_Environment_Config_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.project_environment_config". All fields are combined with a logical 'AND'. */
export type Tenancy_Project_Environment_Config_Bool_Exp = {
  _ProjectEnvironmentConfigToVariables?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
  _ProjectEnvironmentConfigToVariables_aggregate?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<Tenancy_Project_Environment_Config_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Project_Environment_Config_Bool_Exp>>;
  applet_instances?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
  applet_instances_aggregate?: InputMaybe<Tenancy_Applet_Instance_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  domains?: InputMaybe<Tenancy_Domain_Bool_Exp>;
  domains_aggregate?: InputMaybe<Tenancy_Domain_Aggregate_Bool_Exp>;
  environment?: InputMaybe<Tenancy_Environment_Bool_Exp>;
  environmentId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  shortId?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<EnvironmentStatus_Comparison_Exp>;
  team_account_environment_configs?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
  team_account_environment_configs_aggregate?: InputMaybe<Tenancy_Team_Account_Environment_Config_Aggregate_Bool_Exp>;
  user_account_environment_configs?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
  user_account_environment_configs_aggregate?: InputMaybe<Tenancy_User_Account_Environment_Config_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.project_environment_config" */
export enum Tenancy_Project_Environment_Config_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectEnvironmentConfigPkey = 'project_environment_config_pkey'
}

/** input type for inserting data into table "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_Insert_Input = {
  _ProjectEnvironmentConfigToVariables?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Arr_Rel_Insert_Input>;
  applet_instances?: InputMaybe<Tenancy_Applet_Instance_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  domains?: InputMaybe<Tenancy_Domain_Arr_Rel_Insert_Input>;
  environment?: InputMaybe<Tenancy_Environment_Obj_Rel_Insert_Input>;
  environmentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Tenancy_Projects_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['EnvironmentStatus']['input']>;
  team_account_environment_configs?: InputMaybe<Tenancy_Team_Account_Environment_Config_Arr_Rel_Insert_Input>;
  user_account_environment_configs?: InputMaybe<Tenancy_User_Account_Environment_Config_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Project_Environment_Config_Max_Fields = {
  __typename?: 'tenancy_project_environment_config_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['EnvironmentStatus']['output']>;
};

/** order by max() on columns of table "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  environmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Project_Environment_Config_Min_Fields = {
  __typename?: 'tenancy_project_environment_config_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['EnvironmentStatus']['output']>;
};

/** order by min() on columns of table "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  environmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_Mutation_Response = {
  __typename?: 'tenancy_project_environment_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Project_Environment_Config>;
};

/** input type for inserting object relation for remote table "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_Obj_Rel_Insert_Input = {
  data: Tenancy_Project_Environment_Config_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Project_Environment_Config_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_On_Conflict = {
  constraint: Tenancy_Project_Environment_Config_Constraint;
  update_columns?: Array<Tenancy_Project_Environment_Config_Update_Column>;
  where?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.project_environment_config". */
export type Tenancy_Project_Environment_Config_Order_By = {
  _ProjectEnvironmentConfigToVariables_aggregate?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Aggregate_Order_By>;
  applet_instances_aggregate?: InputMaybe<Tenancy_Applet_Instance_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  domains_aggregate?: InputMaybe<Tenancy_Domain_Aggregate_Order_By>;
  environment?: InputMaybe<Tenancy_Environment_Order_By>;
  environmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Tenancy_Projects_Order_By>;
  projectId?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  team_account_environment_configs_aggregate?: InputMaybe<Tenancy_Team_Account_Environment_Config_Aggregate_Order_By>;
  user_account_environment_configs_aggregate?: InputMaybe<Tenancy_User_Account_Environment_Config_Aggregate_Order_By>;
};

/** primary key columns input for table: tenancy.project_environment_config */
export type Tenancy_Project_Environment_Config_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.project_environment_config" */
export enum Tenancy_Project_Environment_Config_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  EnvironmentId = 'environmentId',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "tenancy.project_environment_config" */
export type Tenancy_Project_Environment_Config_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  environmentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['EnvironmentStatus']['input']>;
};

/** Streaming cursor of the table "tenancy_project_environment_config" */
export type Tenancy_Project_Environment_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Project_Environment_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Project_Environment_Config_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  environmentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['EnvironmentStatus']['input']>;
};

/** update columns of table "tenancy.project_environment_config" */
export enum Tenancy_Project_Environment_Config_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  EnvironmentId = 'environmentId',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  Status = 'status'
}

export type Tenancy_Project_Environment_Config_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Project_Environment_Config_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Project_Environment_Config_Bool_Exp;
};

/** columns and relationships of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting = {
  __typename?: 'tenancy_project_pro_studio_setting';
  customerId: Scalars['String']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** An object relationship */
  project: Tenancy_Projects;
  projectId: Scalars['String']['output'];
  /** An array relationship */
  pype_connections: Array<Tenancy_Pype_Connection>;
  /** An aggregate relationship */
  pype_connections_aggregate: Tenancy_Pype_Connection_Aggregate;
  /** An array relationship */
  pype_rule_groups: Array<Tenancy_Pype_Rule_Group>;
  /** An aggregate relationship */
  pype_rule_groups_aggregate: Tenancy_Pype_Rule_Group_Aggregate;
  settings?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  solution_versions_ps: Array<Tenancy_Solution_Versions_Ps>;
  /** An aggregate relationship */
  solution_versions_ps_aggregate: Tenancy_Solution_Versions_Ps_Aggregate;
  /** An array relationship */
  solutions: Array<Tenancy_Solutions>;
  /** An aggregate relationship */
  solutions_aggregate: Tenancy_Solutions_Aggregate;
};


/** columns and relationships of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_SettingPype_ConnectionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Connection_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_SettingPype_Connections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Connection_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_SettingPype_Rule_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_SettingPype_Rule_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_SettingSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_SettingSolution_Versions_PsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_SettingSolution_Versions_Ps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_SettingSolutionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solutions_Order_By>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};


/** columns and relationships of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_SettingSolutions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solutions_Order_By>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};

/** aggregated selection of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_Aggregate = {
  __typename?: 'tenancy_project_pro_studio_setting_aggregate';
  aggregate?: Maybe<Tenancy_Project_Pro_Studio_Setting_Aggregate_Fields>;
  nodes: Array<Tenancy_Project_Pro_Studio_Setting>;
};

export type Tenancy_Project_Pro_Studio_Setting_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Project_Pro_Studio_Setting_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_Aggregate_Fields = {
  __typename?: 'tenancy_project_pro_studio_setting_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Project_Pro_Studio_Setting_Max_Fields>;
  min?: Maybe<Tenancy_Project_Pro_Studio_Setting_Min_Fields>;
};


/** aggregate fields of "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Max_Order_By>;
  min?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Project_Pro_Studio_Setting_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Project_Pro_Studio_Setting_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.project_pro_studio_setting". All fields are combined with a logical 'AND'. */
export type Tenancy_Project_Pro_Studio_Setting_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>>;
  customerId?: InputMaybe<String_Comparison_Exp>;
  customerName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  pype_connections?: InputMaybe<Tenancy_Pype_Connection_Bool_Exp>;
  pype_connections_aggregate?: InputMaybe<Tenancy_Pype_Connection_Aggregate_Bool_Exp>;
  pype_rule_groups?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
  pype_rule_groups_aggregate?: InputMaybe<Tenancy_Pype_Rule_Group_Aggregate_Bool_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  solution_versions_ps?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
  solution_versions_ps_aggregate?: InputMaybe<Tenancy_Solution_Versions_Ps_Aggregate_Bool_Exp>;
  solutions?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
  solutions_aggregate?: InputMaybe<Tenancy_Solutions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.project_pro_studio_setting" */
export enum Tenancy_Project_Pro_Studio_Setting_Constraint {
  /** unique or primary key constraint on columns "customerId" */
  ProjectProStudioSettingCustomerIdKey = 'project_pro_studio_setting_customerId_key',
  /** unique or primary key constraint on columns "id" */
  ProjectProStudioSettingPkey = 'project_pro_studio_setting_pkey',
  /** unique or primary key constraint on columns "projectId" */
  ProjectProStudioSettingProjectIdKey = 'project_pro_studio_setting_projectId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Project_Pro_Studio_Setting_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Project_Pro_Studio_Setting_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Project_Pro_Studio_Setting_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_Insert_Input = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Tenancy_Projects_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  pype_connections?: InputMaybe<Tenancy_Pype_Connection_Arr_Rel_Insert_Input>;
  pype_rule_groups?: InputMaybe<Tenancy_Pype_Rule_Group_Arr_Rel_Insert_Input>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  solution_versions_ps?: InputMaybe<Tenancy_Solution_Versions_Ps_Arr_Rel_Insert_Input>;
  solutions?: InputMaybe<Tenancy_Solutions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Project_Pro_Studio_Setting_Max_Fields = {
  __typename?: 'tenancy_project_pro_studio_setting_max_fields';
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_Max_Order_By = {
  customerId?: InputMaybe<Order_By>;
  customerName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Project_Pro_Studio_Setting_Min_Fields = {
  __typename?: 'tenancy_project_pro_studio_setting_min_fields';
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_Min_Order_By = {
  customerId?: InputMaybe<Order_By>;
  customerName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_Mutation_Response = {
  __typename?: 'tenancy_project_pro_studio_setting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Project_Pro_Studio_Setting>;
};

/** input type for inserting object relation for remote table "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_Obj_Rel_Insert_Input = {
  data: Tenancy_Project_Pro_Studio_Setting_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_On_Conflict = {
  constraint: Tenancy_Project_Pro_Studio_Setting_Constraint;
  update_columns?: Array<Tenancy_Project_Pro_Studio_Setting_Update_Column>;
  where?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.project_pro_studio_setting". */
export type Tenancy_Project_Pro_Studio_Setting_Order_By = {
  customerId?: InputMaybe<Order_By>;
  customerName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Tenancy_Projects_Order_By>;
  projectId?: InputMaybe<Order_By>;
  pype_connections_aggregate?: InputMaybe<Tenancy_Pype_Connection_Aggregate_Order_By>;
  pype_rule_groups_aggregate?: InputMaybe<Tenancy_Pype_Rule_Group_Aggregate_Order_By>;
  settings?: InputMaybe<Order_By>;
  solution_versions_ps_aggregate?: InputMaybe<Tenancy_Solution_Versions_Ps_Aggregate_Order_By>;
  solutions_aggregate?: InputMaybe<Tenancy_Solutions_Aggregate_Order_By>;
};

/** primary key columns input for table: tenancy.project_pro_studio_setting */
export type Tenancy_Project_Pro_Studio_Setting_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Project_Pro_Studio_Setting_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.project_pro_studio_setting" */
export enum Tenancy_Project_Pro_Studio_Setting_Select_Column {
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  CustomerName = 'customerName',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  Settings = 'settings'
}

/** input type for updating data in table "tenancy.project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_Set_Input = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "tenancy_project_pro_studio_setting" */
export type Tenancy_Project_Pro_Studio_Setting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Project_Pro_Studio_Setting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Project_Pro_Studio_Setting_Stream_Cursor_Value_Input = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "tenancy.project_pro_studio_setting" */
export enum Tenancy_Project_Pro_Studio_Setting_Update_Column {
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  CustomerName = 'customerName',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  Settings = 'settings'
}

export type Tenancy_Project_Pro_Studio_Setting_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Project_Pro_Studio_Setting_Bool_Exp;
};

/** columns and relationships of "tenancy.project_product_settings" */
export type Tenancy_Project_Product_Settings = {
  __typename?: 'tenancy_project_product_settings';
  /** An object relationship */
  product: Tenancy_Products;
  productId: Scalars['String']['output'];
  /** An object relationship */
  project: Tenancy_Projects;
  projectId: Scalars['String']['output'];
  settings?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "tenancy.project_product_settings" */
export type Tenancy_Project_Product_SettingsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.project_product_settings" */
export type Tenancy_Project_Product_Settings_Aggregate = {
  __typename?: 'tenancy_project_product_settings_aggregate';
  aggregate?: Maybe<Tenancy_Project_Product_Settings_Aggregate_Fields>;
  nodes: Array<Tenancy_Project_Product_Settings>;
};

export type Tenancy_Project_Product_Settings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Project_Product_Settings_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Project_Product_Settings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Project_Product_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.project_product_settings" */
export type Tenancy_Project_Product_Settings_Aggregate_Fields = {
  __typename?: 'tenancy_project_product_settings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Project_Product_Settings_Max_Fields>;
  min?: Maybe<Tenancy_Project_Product_Settings_Min_Fields>;
};


/** aggregate fields of "tenancy.project_product_settings" */
export type Tenancy_Project_Product_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Project_Product_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.project_product_settings" */
export type Tenancy_Project_Product_Settings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Project_Product_Settings_Max_Order_By>;
  min?: InputMaybe<Tenancy_Project_Product_Settings_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Project_Product_Settings_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.project_product_settings" */
export type Tenancy_Project_Product_Settings_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Project_Product_Settings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Project_Product_Settings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.project_product_settings". All fields are combined with a logical 'AND'. */
export type Tenancy_Project_Product_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Project_Product_Settings_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Project_Product_Settings_Bool_Exp>>;
  product?: InputMaybe<Tenancy_Products_Bool_Exp>;
  productId?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.project_product_settings" */
export enum Tenancy_Project_Product_Settings_Constraint {
  /** unique or primary key constraint on columns "projectId", "productId" */
  ProjectProductSettingsPkey = 'project_product_settings_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Project_Product_Settings_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Project_Product_Settings_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Project_Product_Settings_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.project_product_settings" */
export type Tenancy_Project_Product_Settings_Insert_Input = {
  product?: InputMaybe<Tenancy_Products_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Tenancy_Projects_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Project_Product_Settings_Max_Fields = {
  __typename?: 'tenancy_project_product_settings_max_fields';
  productId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.project_product_settings" */
export type Tenancy_Project_Product_Settings_Max_Order_By = {
  productId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Project_Product_Settings_Min_Fields = {
  __typename?: 'tenancy_project_product_settings_min_fields';
  productId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.project_product_settings" */
export type Tenancy_Project_Product_Settings_Min_Order_By = {
  productId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.project_product_settings" */
export type Tenancy_Project_Product_Settings_Mutation_Response = {
  __typename?: 'tenancy_project_product_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Project_Product_Settings>;
};

/** on_conflict condition type for table "tenancy.project_product_settings" */
export type Tenancy_Project_Product_Settings_On_Conflict = {
  constraint: Tenancy_Project_Product_Settings_Constraint;
  update_columns?: Array<Tenancy_Project_Product_Settings_Update_Column>;
  where?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.project_product_settings". */
export type Tenancy_Project_Product_Settings_Order_By = {
  product?: InputMaybe<Tenancy_Products_Order_By>;
  productId?: InputMaybe<Order_By>;
  project?: InputMaybe<Tenancy_Projects_Order_By>;
  projectId?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.project_product_settings */
export type Tenancy_Project_Product_Settings_Pk_Columns_Input = {
  productId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Project_Product_Settings_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.project_product_settings" */
export enum Tenancy_Project_Product_Settings_Select_Column {
  /** column name */
  ProductId = 'productId',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  Settings = 'settings'
}

/** input type for updating data in table "tenancy.project_product_settings" */
export type Tenancy_Project_Product_Settings_Set_Input = {
  productId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "tenancy_project_product_settings" */
export type Tenancy_Project_Product_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Project_Product_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Project_Product_Settings_Stream_Cursor_Value_Input = {
  productId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "tenancy.project_product_settings" */
export enum Tenancy_Project_Product_Settings_Update_Column {
  /** column name */
  ProductId = 'productId',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  Settings = 'settings'
}

export type Tenancy_Project_Product_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Project_Product_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Project_Product_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Project_Product_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Project_Product_Settings_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Project_Product_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Project_Product_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Project_Product_Settings_Bool_Exp;
};

/** columns and relationships of "tenancy.projects" */
export type Tenancy_Projects = {
  __typename?: 'tenancy_projects';
  /** An array relationship */
  _role_projects: Array<Tenancy__Role_Projects>;
  /** An aggregate relationship */
  _role_projects_aggregate: Tenancy__Role_Projects_Aggregate;
  /** An object relationship */
  account: Tenancy_Accounts;
  accountId: Scalars['String']['output'];
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  files: Array<Tenancy_File>;
  /** An aggregate relationship */
  files_aggregate: Tenancy_File_Aggregate;
  id: Scalars['String']['output'];
  /** An array relationship */
  llm_credentials: Array<Tenancy_Llm_Credentials>;
  /** An aggregate relationship */
  llm_credentials_aggregate: Tenancy_Llm_Credentials_Aggregate;
  /** An array relationship */
  localization_settings: Array<Tenancy_Localization_Settings>;
  /** An aggregate relationship */
  localization_settings_aggregate: Tenancy_Localization_Settings_Aggregate;
  name: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  project_environment_configs: Array<Tenancy_Project_Environment_Config>;
  /** An aggregate relationship */
  project_environment_configs_aggregate: Tenancy_Project_Environment_Config_Aggregate;
  /** An array relationship */
  project_pro_studio_settings: Array<Tenancy_Project_Pro_Studio_Setting>;
  /** An aggregate relationship */
  project_pro_studio_settings_aggregate: Tenancy_Project_Pro_Studio_Setting_Aggregate;
  /** An array relationship */
  project_product_settings: Array<Tenancy_Project_Product_Settings>;
  /** An aggregate relationship */
  project_product_settings_aggregate: Tenancy_Project_Product_Settings_Aggregate;
  settings?: Maybe<Scalars['jsonb']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  team_account_projects: Array<Tenancy_Team_Account_Projects>;
  /** An aggregate relationship */
  team_account_projects_aggregate: Tenancy_Team_Account_Projects_Aggregate;
  toolIdsWhileCreating?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
  /** An array relationship */
  user_account_projects: Array<Tenancy_User_Account_Projects>;
  /** An aggregate relationship */
  user_account_projects_aggregate: Tenancy_User_Account_Projects_Aggregate;
  /** An array relationship */
  variables: Array<Tenancy_Variable>;
  /** An aggregate relationship */
  variables_aggregate: Tenancy_Variable_Aggregate;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_Projects_Role_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Role_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Role_Projects_Order_By>>;
  where?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_Projects_Role_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Role_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Role_Projects_Order_By>>;
  where?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsFilesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsLlm_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Llm_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Llm_Credentials_Order_By>>;
  where?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsLlm_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Llm_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Llm_Credentials_Order_By>>;
  where?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsLocalization_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsLocalization_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsProject_Environment_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsProject_Environment_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsProject_Pro_Studio_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsProject_Pro_Studio_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Pro_Studio_Setting_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsProject_Product_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Product_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Product_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsProject_Product_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Project_Product_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Project_Product_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsTeam_Account_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsTeam_Account_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsUser_Account_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsUser_Account_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsVariablesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Variable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Variable_Order_By>>;
  where?: InputMaybe<Tenancy_Variable_Bool_Exp>;
};


/** columns and relationships of "tenancy.projects" */
export type Tenancy_ProjectsVariables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Variable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Variable_Order_By>>;
  where?: InputMaybe<Tenancy_Variable_Bool_Exp>;
};

/** aggregated selection of "tenancy.projects" */
export type Tenancy_Projects_Aggregate = {
  __typename?: 'tenancy_projects_aggregate';
  aggregate?: Maybe<Tenancy_Projects_Aggregate_Fields>;
  nodes: Array<Tenancy_Projects>;
};

export type Tenancy_Projects_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Projects_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Projects_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.projects" */
export type Tenancy_Projects_Aggregate_Fields = {
  __typename?: 'tenancy_projects_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Projects_Max_Fields>;
  min?: Maybe<Tenancy_Projects_Min_Fields>;
};


/** aggregate fields of "tenancy.projects" */
export type Tenancy_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.projects" */
export type Tenancy_Projects_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Projects_Max_Order_By>;
  min?: InputMaybe<Tenancy_Projects_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Projects_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.projects" */
export type Tenancy_Projects_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Projects_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.projects". All fields are combined with a logical 'AND'. */
export type Tenancy_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Projects_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Projects_Bool_Exp>>;
  _role_projects?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
  _role_projects_aggregate?: InputMaybe<Tenancy__Role_Projects_Aggregate_Bool_Exp>;
  account?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  accountId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  files?: InputMaybe<Tenancy_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Tenancy_File_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  llm_credentials?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
  llm_credentials_aggregate?: InputMaybe<Tenancy_Llm_Credentials_Aggregate_Bool_Exp>;
  localization_settings?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
  localization_settings_aggregate?: InputMaybe<Tenancy_Localization_Settings_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  project_environment_configs?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
  project_environment_configs_aggregate?: InputMaybe<Tenancy_Project_Environment_Config_Aggregate_Bool_Exp>;
  project_pro_studio_settings?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
  project_pro_studio_settings_aggregate?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Aggregate_Bool_Exp>;
  project_product_settings?: InputMaybe<Tenancy_Project_Product_Settings_Bool_Exp>;
  project_product_settings_aggregate?: InputMaybe<Tenancy_Project_Product_Settings_Aggregate_Bool_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  shortId?: InputMaybe<String_Comparison_Exp>;
  team_account_projects?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
  team_account_projects_aggregate?: InputMaybe<Tenancy_Team_Account_Projects_Aggregate_Bool_Exp>;
  toolIdsWhileCreating?: InputMaybe<String_Array_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
  user_account_projects?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
  user_account_projects_aggregate?: InputMaybe<Tenancy_User_Account_Projects_Aggregate_Bool_Exp>;
  variables?: InputMaybe<Tenancy_Variable_Bool_Exp>;
  variables_aggregate?: InputMaybe<Tenancy_Variable_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.projects" */
export enum Tenancy_Projects_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectsPkey = 'projects_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Projects_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Projects_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Projects_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.projects" */
export type Tenancy_Projects_Insert_Input = {
  _role_projects?: InputMaybe<Tenancy__Role_Projects_Arr_Rel_Insert_Input>;
  account?: InputMaybe<Tenancy_Accounts_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Tenancy_File_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  llm_credentials?: InputMaybe<Tenancy_Llm_Credentials_Arr_Rel_Insert_Input>;
  localization_settings?: InputMaybe<Tenancy_Localization_Settings_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  project_environment_configs?: InputMaybe<Tenancy_Project_Environment_Config_Arr_Rel_Insert_Input>;
  project_pro_studio_settings?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Arr_Rel_Insert_Input>;
  project_product_settings?: InputMaybe<Tenancy_Project_Product_Settings_Arr_Rel_Insert_Input>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  team_account_projects?: InputMaybe<Tenancy_Team_Account_Projects_Arr_Rel_Insert_Input>;
  toolIdsWhileCreating?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  user_account_projects?: InputMaybe<Tenancy_User_Account_Projects_Arr_Rel_Insert_Input>;
  variables?: InputMaybe<Tenancy_Variable_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Projects_Max_Fields = {
  __typename?: 'tenancy_projects_max_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  toolIdsWhileCreating?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.projects" */
export type Tenancy_Projects_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  toolIdsWhileCreating?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Projects_Min_Fields = {
  __typename?: 'tenancy_projects_min_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  toolIdsWhileCreating?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.projects" */
export type Tenancy_Projects_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  toolIdsWhileCreating?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.projects" */
export type Tenancy_Projects_Mutation_Response = {
  __typename?: 'tenancy_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Projects>;
};

/** input type for inserting object relation for remote table "tenancy.projects" */
export type Tenancy_Projects_Obj_Rel_Insert_Input = {
  data: Tenancy_Projects_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Projects_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.projects" */
export type Tenancy_Projects_On_Conflict = {
  constraint: Tenancy_Projects_Constraint;
  update_columns?: Array<Tenancy_Projects_Update_Column>;
  where?: InputMaybe<Tenancy_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.projects". */
export type Tenancy_Projects_Order_By = {
  _role_projects_aggregate?: InputMaybe<Tenancy__Role_Projects_Aggregate_Order_By>;
  account?: InputMaybe<Tenancy_Accounts_Order_By>;
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Tenancy_File_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  llm_credentials_aggregate?: InputMaybe<Tenancy_Llm_Credentials_Aggregate_Order_By>;
  localization_settings_aggregate?: InputMaybe<Tenancy_Localization_Settings_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  project_environment_configs_aggregate?: InputMaybe<Tenancy_Project_Environment_Config_Aggregate_Order_By>;
  project_pro_studio_settings_aggregate?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Aggregate_Order_By>;
  project_product_settings_aggregate?: InputMaybe<Tenancy_Project_Product_Settings_Aggregate_Order_By>;
  settings?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  team_account_projects_aggregate?: InputMaybe<Tenancy_Team_Account_Projects_Aggregate_Order_By>;
  toolIdsWhileCreating?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  user_account_projects_aggregate?: InputMaybe<Tenancy_User_Account_Projects_Aggregate_Order_By>;
  variables_aggregate?: InputMaybe<Tenancy_Variable_Aggregate_Order_By>;
};

/** primary key columns input for table: tenancy.projects */
export type Tenancy_Projects_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Projects_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.projects" */
export enum Tenancy_Projects_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Picture = 'picture',
  /** column name */
  Settings = 'settings',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  ToolIdsWhileCreating = 'toolIdsWhileCreating',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "tenancy.projects" */
export type Tenancy_Projects_Set_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  toolIdsWhileCreating?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_projects" */
export type Tenancy_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Projects_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  toolIdsWhileCreating?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.projects" */
export enum Tenancy_Projects_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Picture = 'picture',
  /** column name */
  Settings = 'settings',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  ToolIdsWhileCreating = 'toolIdsWhileCreating',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type Tenancy_Projects_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Projects_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Projects_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Projects_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Projects_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Projects_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Projects_Bool_Exp;
};

/** columns and relationships of "tenancy.pype_connection" */
export type Tenancy_Pype_Connection = {
  __typename?: 'tenancy_pype_connection';
  agentRouting?: Maybe<Scalars['String']['output']>;
  agentRoutingUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamp']['output'];
  environment: Scalars['PypeEnvironment']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  platformId: Scalars['String']['output'];
  projectProStudioSettingId: Scalars['String']['output'];
  /** An object relationship */
  project_pro_studio_setting: Tenancy_Project_Pro_Studio_Setting;
  /** An array relationship */
  pype_connection_pypes: Array<Tenancy_Pype_Connection_Pype>;
  /** An aggregate relationship */
  pype_connection_pypes_aggregate: Tenancy_Pype_Connection_Pype_Aggregate;
  settings?: Maybe<Scalars['jsonb']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "tenancy.pype_connection" */
export type Tenancy_Pype_ConnectionPype_Connection_PypesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Pype_Bool_Exp>;
};


/** columns and relationships of "tenancy.pype_connection" */
export type Tenancy_Pype_ConnectionPype_Connection_Pypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Connection_Pype_Bool_Exp>;
};


/** columns and relationships of "tenancy.pype_connection" */
export type Tenancy_Pype_ConnectionSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.pype_connection" */
export type Tenancy_Pype_Connection_Aggregate = {
  __typename?: 'tenancy_pype_connection_aggregate';
  aggregate?: Maybe<Tenancy_Pype_Connection_Aggregate_Fields>;
  nodes: Array<Tenancy_Pype_Connection>;
};

export type Tenancy_Pype_Connection_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Pype_Connection_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Pype_Connection_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Pype_Connection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Pype_Connection_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.pype_connection" */
export type Tenancy_Pype_Connection_Aggregate_Fields = {
  __typename?: 'tenancy_pype_connection_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Pype_Connection_Max_Fields>;
  min?: Maybe<Tenancy_Pype_Connection_Min_Fields>;
};


/** aggregate fields of "tenancy.pype_connection" */
export type Tenancy_Pype_Connection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Pype_Connection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.pype_connection" */
export type Tenancy_Pype_Connection_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Pype_Connection_Max_Order_By>;
  min?: InputMaybe<Tenancy_Pype_Connection_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Pype_Connection_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.pype_connection" */
export type Tenancy_Pype_Connection_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Pype_Connection_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Pype_Connection_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.pype_connection". All fields are combined with a logical 'AND'. */
export type Tenancy_Pype_Connection_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Pype_Connection_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Pype_Connection_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Pype_Connection_Bool_Exp>>;
  agentRouting?: InputMaybe<String_Comparison_Exp>;
  agentRoutingUrl?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  environment?: InputMaybe<PypeEnvironment_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  platformId?: InputMaybe<String_Comparison_Exp>;
  projectProStudioSettingId?: InputMaybe<String_Comparison_Exp>;
  project_pro_studio_setting?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
  pype_connection_pypes?: InputMaybe<Tenancy_Pype_Connection_Pype_Bool_Exp>;
  pype_connection_pypes_aggregate?: InputMaybe<Tenancy_Pype_Connection_Pype_Aggregate_Bool_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.pype_connection" */
export enum Tenancy_Pype_Connection_Constraint {
  /** unique or primary key constraint on columns "id" */
  PypeConnectionPkey = 'pype_connection_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Pype_Connection_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Pype_Connection_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Pype_Connection_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.pype_connection" */
export type Tenancy_Pype_Connection_Insert_Input = {
  agentRouting?: InputMaybe<Scalars['String']['input']>;
  agentRoutingUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  environment?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
  project_pro_studio_setting?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Obj_Rel_Insert_Input>;
  pype_connection_pypes?: InputMaybe<Tenancy_Pype_Connection_Pype_Arr_Rel_Insert_Input>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Pype_Connection_Max_Fields = {
  __typename?: 'tenancy_pype_connection_max_fields';
  agentRouting?: Maybe<Scalars['String']['output']>;
  agentRoutingUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  environment?: Maybe<Scalars['PypeEnvironment']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platformId?: Maybe<Scalars['String']['output']>;
  projectProStudioSettingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.pype_connection" */
export type Tenancy_Pype_Connection_Max_Order_By = {
  agentRouting?: InputMaybe<Order_By>;
  agentRoutingUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  environment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platformId?: InputMaybe<Order_By>;
  projectProStudioSettingId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Pype_Connection_Min_Fields = {
  __typename?: 'tenancy_pype_connection_min_fields';
  agentRouting?: Maybe<Scalars['String']['output']>;
  agentRoutingUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  environment?: Maybe<Scalars['PypeEnvironment']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platformId?: Maybe<Scalars['String']['output']>;
  projectProStudioSettingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.pype_connection" */
export type Tenancy_Pype_Connection_Min_Order_By = {
  agentRouting?: InputMaybe<Order_By>;
  agentRoutingUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  environment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platformId?: InputMaybe<Order_By>;
  projectProStudioSettingId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.pype_connection" */
export type Tenancy_Pype_Connection_Mutation_Response = {
  __typename?: 'tenancy_pype_connection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Pype_Connection>;
};

/** input type for inserting object relation for remote table "tenancy.pype_connection" */
export type Tenancy_Pype_Connection_Obj_Rel_Insert_Input = {
  data: Tenancy_Pype_Connection_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Pype_Connection_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.pype_connection" */
export type Tenancy_Pype_Connection_On_Conflict = {
  constraint: Tenancy_Pype_Connection_Constraint;
  update_columns?: Array<Tenancy_Pype_Connection_Update_Column>;
  where?: InputMaybe<Tenancy_Pype_Connection_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.pype_connection". */
export type Tenancy_Pype_Connection_Order_By = {
  agentRouting?: InputMaybe<Order_By>;
  agentRoutingUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  environment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platformId?: InputMaybe<Order_By>;
  projectProStudioSettingId?: InputMaybe<Order_By>;
  project_pro_studio_setting?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Order_By>;
  pype_connection_pypes_aggregate?: InputMaybe<Tenancy_Pype_Connection_Pype_Aggregate_Order_By>;
  settings?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.pype_connection */
export type Tenancy_Pype_Connection_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Pype_Connection_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "tenancy.pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype = {
  __typename?: 'tenancy_pype_connection_pype';
  createdAt: Scalars['timestamp']['output'];
  env: Scalars['PypeEnvironment']['output'];
  id: Scalars['String']['output'];
  pypeConnectionId: Scalars['String']['output'];
  pypeId: Scalars['String']['output'];
  /** An object relationship */
  pype_connection: Tenancy_Pype_Connection;
};

/** aggregated selection of "tenancy.pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype_Aggregate = {
  __typename?: 'tenancy_pype_connection_pype_aggregate';
  aggregate?: Maybe<Tenancy_Pype_Connection_Pype_Aggregate_Fields>;
  nodes: Array<Tenancy_Pype_Connection_Pype>;
};

export type Tenancy_Pype_Connection_Pype_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Pype_Connection_Pype_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Pype_Connection_Pype_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Pype_Connection_Pype_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype_Aggregate_Fields = {
  __typename?: 'tenancy_pype_connection_pype_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Pype_Connection_Pype_Max_Fields>;
  min?: Maybe<Tenancy_Pype_Connection_Pype_Min_Fields>;
};


/** aggregate fields of "tenancy.pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Pype_Connection_Pype_Max_Order_By>;
  min?: InputMaybe<Tenancy_Pype_Connection_Pype_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Pype_Connection_Pype_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Pype_Connection_Pype_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.pype_connection_pype". All fields are combined with a logical 'AND'. */
export type Tenancy_Pype_Connection_Pype_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Pype_Connection_Pype_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Pype_Connection_Pype_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  env?: InputMaybe<PypeEnvironment_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  pypeConnectionId?: InputMaybe<String_Comparison_Exp>;
  pypeId?: InputMaybe<String_Comparison_Exp>;
  pype_connection?: InputMaybe<Tenancy_Pype_Connection_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.pype_connection_pype" */
export enum Tenancy_Pype_Connection_Pype_Constraint {
  /** unique or primary key constraint on columns "id" */
  PypeConnectionPypePkey = 'pype_connection_pype_pkey',
  /** unique or primary key constraint on columns "pypeId", "env", "pypeConnectionId" */
  PypeConnectionPypePypeConnectionIdPypeIdEnvKey = 'pype_connection_pype_pypeConnectionId_pypeId_env_key'
}

/** input type for inserting data into table "tenancy.pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  env?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  pypeConnectionId?: InputMaybe<Scalars['String']['input']>;
  pypeId?: InputMaybe<Scalars['String']['input']>;
  pype_connection?: InputMaybe<Tenancy_Pype_Connection_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Pype_Connection_Pype_Max_Fields = {
  __typename?: 'tenancy_pype_connection_pype_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  env?: Maybe<Scalars['PypeEnvironment']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pypeConnectionId?: Maybe<Scalars['String']['output']>;
  pypeId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  env?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pypeConnectionId?: InputMaybe<Order_By>;
  pypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Pype_Connection_Pype_Min_Fields = {
  __typename?: 'tenancy_pype_connection_pype_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  env?: Maybe<Scalars['PypeEnvironment']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pypeConnectionId?: Maybe<Scalars['String']['output']>;
  pypeId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  env?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pypeConnectionId?: InputMaybe<Order_By>;
  pypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype_Mutation_Response = {
  __typename?: 'tenancy_pype_connection_pype_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Pype_Connection_Pype>;
};

/** on_conflict condition type for table "tenancy.pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype_On_Conflict = {
  constraint: Tenancy_Pype_Connection_Pype_Constraint;
  update_columns?: Array<Tenancy_Pype_Connection_Pype_Update_Column>;
  where?: InputMaybe<Tenancy_Pype_Connection_Pype_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.pype_connection_pype". */
export type Tenancy_Pype_Connection_Pype_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  env?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pypeConnectionId?: InputMaybe<Order_By>;
  pypeId?: InputMaybe<Order_By>;
  pype_connection?: InputMaybe<Tenancy_Pype_Connection_Order_By>;
};

/** primary key columns input for table: tenancy.pype_connection_pype */
export type Tenancy_Pype_Connection_Pype_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.pype_connection_pype" */
export enum Tenancy_Pype_Connection_Pype_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Env = 'env',
  /** column name */
  Id = 'id',
  /** column name */
  PypeConnectionId = 'pypeConnectionId',
  /** column name */
  PypeId = 'pypeId'
}

/** input type for updating data in table "tenancy.pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  env?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  pypeConnectionId?: InputMaybe<Scalars['String']['input']>;
  pypeId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_pype_connection_pype" */
export type Tenancy_Pype_Connection_Pype_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Pype_Connection_Pype_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Pype_Connection_Pype_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  env?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  pypeConnectionId?: InputMaybe<Scalars['String']['input']>;
  pypeId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.pype_connection_pype" */
export enum Tenancy_Pype_Connection_Pype_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Env = 'env',
  /** column name */
  Id = 'id',
  /** column name */
  PypeConnectionId = 'pypeConnectionId',
  /** column name */
  PypeId = 'pypeId'
}

export type Tenancy_Pype_Connection_Pype_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Pype_Connection_Pype_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Pype_Connection_Pype_Bool_Exp;
};

/** select columns of table "tenancy.pype_connection" */
export enum Tenancy_Pype_Connection_Select_Column {
  /** column name */
  AgentRouting = 'agentRouting',
  /** column name */
  AgentRoutingUrl = 'agentRoutingUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Environment = 'environment',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PlatformId = 'platformId',
  /** column name */
  ProjectProStudioSettingId = 'projectProStudioSettingId',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tenancy.pype_connection" */
export type Tenancy_Pype_Connection_Set_Input = {
  agentRouting?: InputMaybe<Scalars['String']['input']>;
  agentRoutingUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  environment?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_pype_connection" */
export type Tenancy_Pype_Connection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Pype_Connection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Pype_Connection_Stream_Cursor_Value_Input = {
  agentRouting?: InputMaybe<Scalars['String']['input']>;
  agentRoutingUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  environment?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.pype_connection" */
export enum Tenancy_Pype_Connection_Update_Column {
  /** column name */
  AgentRouting = 'agentRouting',
  /** column name */
  AgentRoutingUrl = 'agentRoutingUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Environment = 'environment',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PlatformId = 'platformId',
  /** column name */
  ProjectProStudioSettingId = 'projectProStudioSettingId',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Pype_Connection_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Pype_Connection_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Pype_Connection_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Pype_Connection_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Pype_Connection_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Pype_Connection_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Pype_Connection_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Pype_Connection_Bool_Exp;
};

/** columns and relationships of "tenancy.pype_rule" */
export type Tenancy_Pype_Rule = {
  __typename?: 'tenancy_pype_rule';
  createdAt: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pypeRuleGroupId: Scalars['String']['output'];
  /** An object relationship */
  pype_rule_group: Tenancy_Pype_Rule_Group;
  rules?: Maybe<Array<Scalars['String']['output']>>;
  settings?: Maybe<Scalars['jsonb']['output']>;
  type: Scalars['RuleCreationType']['output'];
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "tenancy.pype_rule" */
export type Tenancy_Pype_RuleSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.pype_rule" */
export type Tenancy_Pype_Rule_Aggregate = {
  __typename?: 'tenancy_pype_rule_aggregate';
  aggregate?: Maybe<Tenancy_Pype_Rule_Aggregate_Fields>;
  nodes: Array<Tenancy_Pype_Rule>;
};

export type Tenancy_Pype_Rule_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Pype_Rule_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Pype_Rule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Pype_Rule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Pype_Rule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.pype_rule" */
export type Tenancy_Pype_Rule_Aggregate_Fields = {
  __typename?: 'tenancy_pype_rule_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Pype_Rule_Max_Fields>;
  min?: Maybe<Tenancy_Pype_Rule_Min_Fields>;
};


/** aggregate fields of "tenancy.pype_rule" */
export type Tenancy_Pype_Rule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Pype_Rule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.pype_rule" */
export type Tenancy_Pype_Rule_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Pype_Rule_Max_Order_By>;
  min?: InputMaybe<Tenancy_Pype_Rule_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Pype_Rule_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.pype_rule" */
export type Tenancy_Pype_Rule_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Pype_Rule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Pype_Rule_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.pype_rule". All fields are combined with a logical 'AND'. */
export type Tenancy_Pype_Rule_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Pype_Rule_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Pype_Rule_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Pype_Rule_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pypeRuleGroupId?: InputMaybe<String_Comparison_Exp>;
  pype_rule_group?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
  rules?: InputMaybe<String_Array_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<RuleCreationType_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.pype_rule" */
export enum Tenancy_Pype_Rule_Constraint {
  /** unique or primary key constraint on columns "id" */
  PypeRulePkey = 'pype_rule_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Pype_Rule_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Pype_Rule_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Pype_Rule_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group = {
  __typename?: 'tenancy_pype_rule_group';
  createdAt: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  projectProStudioSettingId: Scalars['String']['output'];
  /** An object relationship */
  project_pro_studio_setting: Tenancy_Project_Pro_Studio_Setting;
  /** An array relationship */
  pype_rule_group_pypes: Array<Tenancy_Pype_Rule_Group_Pype>;
  /** An aggregate relationship */
  pype_rule_group_pypes_aggregate: Tenancy_Pype_Rule_Group_Pype_Aggregate;
  /** An array relationship */
  pype_rules: Array<Tenancy_Pype_Rule>;
  /** An aggregate relationship */
  pype_rules_aggregate: Tenancy_Pype_Rule_Aggregate;
  settings?: Maybe<Scalars['jsonb']['output']>;
  type: Scalars['RuleCreationType']['output'];
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_GroupPype_Rule_Group_PypesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>;
};


/** columns and relationships of "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_GroupPype_Rule_Group_Pypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>;
};


/** columns and relationships of "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_GroupPype_RulesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Bool_Exp>;
};


/** columns and relationships of "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_GroupPype_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Pype_Rule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Pype_Rule_Order_By>>;
  where?: InputMaybe<Tenancy_Pype_Rule_Bool_Exp>;
};


/** columns and relationships of "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_GroupSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group_Aggregate = {
  __typename?: 'tenancy_pype_rule_group_aggregate';
  aggregate?: Maybe<Tenancy_Pype_Rule_Group_Aggregate_Fields>;
  nodes: Array<Tenancy_Pype_Rule_Group>;
};

export type Tenancy_Pype_Rule_Group_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Pype_Rule_Group_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Pype_Rule_Group_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group_Aggregate_Fields = {
  __typename?: 'tenancy_pype_rule_group_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Pype_Rule_Group_Max_Fields>;
  min?: Maybe<Tenancy_Pype_Rule_Group_Min_Fields>;
};


/** aggregate fields of "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Pype_Rule_Group_Max_Order_By>;
  min?: InputMaybe<Tenancy_Pype_Rule_Group_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Pype_Rule_Group_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Pype_Rule_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Pype_Rule_Group_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.pype_rule_group". All fields are combined with a logical 'AND'. */
export type Tenancy_Pype_Rule_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  projectProStudioSettingId?: InputMaybe<String_Comparison_Exp>;
  project_pro_studio_setting?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
  pype_rule_group_pypes?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>;
  pype_rule_group_pypes_aggregate?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Aggregate_Bool_Exp>;
  pype_rules?: InputMaybe<Tenancy_Pype_Rule_Bool_Exp>;
  pype_rules_aggregate?: InputMaybe<Tenancy_Pype_Rule_Aggregate_Bool_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<RuleCreationType_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.pype_rule_group" */
export enum Tenancy_Pype_Rule_Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  PypeRuleGroupPkey = 'pype_rule_group_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Pype_Rule_Group_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Pype_Rule_Group_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Pype_Rule_Group_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
  project_pro_studio_setting?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Obj_Rel_Insert_Input>;
  pype_rule_group_pypes?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Arr_Rel_Insert_Input>;
  pype_rules?: InputMaybe<Tenancy_Pype_Rule_Arr_Rel_Insert_Input>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['RuleCreationType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Pype_Rule_Group_Max_Fields = {
  __typename?: 'tenancy_pype_rule_group_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectProStudioSettingId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['RuleCreationType']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectProStudioSettingId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Pype_Rule_Group_Min_Fields = {
  __typename?: 'tenancy_pype_rule_group_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectProStudioSettingId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['RuleCreationType']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectProStudioSettingId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group_Mutation_Response = {
  __typename?: 'tenancy_pype_rule_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Pype_Rule_Group>;
};

/** input type for inserting object relation for remote table "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group_Obj_Rel_Insert_Input = {
  data: Tenancy_Pype_Rule_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Pype_Rule_Group_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group_On_Conflict = {
  constraint: Tenancy_Pype_Rule_Group_Constraint;
  update_columns?: Array<Tenancy_Pype_Rule_Group_Update_Column>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.pype_rule_group". */
export type Tenancy_Pype_Rule_Group_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectProStudioSettingId?: InputMaybe<Order_By>;
  project_pro_studio_setting?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Order_By>;
  pype_rule_group_pypes_aggregate?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Aggregate_Order_By>;
  pype_rules_aggregate?: InputMaybe<Tenancy_Pype_Rule_Aggregate_Order_By>;
  settings?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.pype_rule_group */
export type Tenancy_Pype_Rule_Group_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Pype_Rule_Group_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "tenancy.pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype = {
  __typename?: 'tenancy_pype_rule_group_pype';
  createdAt: Scalars['timestamp']['output'];
  env: Scalars['PypeEnvironment']['output'];
  id: Scalars['String']['output'];
  pypeId: Scalars['String']['output'];
  pypeRuleGroupId: Scalars['String']['output'];
  /** An object relationship */
  pype_rule_group: Tenancy_Pype_Rule_Group;
};

/** aggregated selection of "tenancy.pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype_Aggregate = {
  __typename?: 'tenancy_pype_rule_group_pype_aggregate';
  aggregate?: Maybe<Tenancy_Pype_Rule_Group_Pype_Aggregate_Fields>;
  nodes: Array<Tenancy_Pype_Rule_Group_Pype>;
};

export type Tenancy_Pype_Rule_Group_Pype_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Pype_Rule_Group_Pype_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype_Aggregate_Fields = {
  __typename?: 'tenancy_pype_rule_group_pype_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Pype_Rule_Group_Pype_Max_Fields>;
  min?: Maybe<Tenancy_Pype_Rule_Group_Pype_Min_Fields>;
};


/** aggregate fields of "tenancy.pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Max_Order_By>;
  min?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Pype_Rule_Group_Pype_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.pype_rule_group_pype". All fields are combined with a logical 'AND'. */
export type Tenancy_Pype_Rule_Group_Pype_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  env?: InputMaybe<PypeEnvironment_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  pypeId?: InputMaybe<String_Comparison_Exp>;
  pypeRuleGroupId?: InputMaybe<String_Comparison_Exp>;
  pype_rule_group?: InputMaybe<Tenancy_Pype_Rule_Group_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.pype_rule_group_pype" */
export enum Tenancy_Pype_Rule_Group_Pype_Constraint {
  /** unique or primary key constraint on columns "id" */
  PypeRuleGroupPypePkey = 'pype_rule_group_pype_pkey',
  /** unique or primary key constraint on columns "pypeId", "env", "pypeRuleGroupId" */
  PypeRuleGroupPypePypeRuleGroupIdPypeIdEnvKey = 'pype_rule_group_pype_pypeRuleGroupId_pypeId_env_key'
}

/** input type for inserting data into table "tenancy.pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  env?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  pypeId?: InputMaybe<Scalars['String']['input']>;
  pypeRuleGroupId?: InputMaybe<Scalars['String']['input']>;
  pype_rule_group?: InputMaybe<Tenancy_Pype_Rule_Group_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Pype_Rule_Group_Pype_Max_Fields = {
  __typename?: 'tenancy_pype_rule_group_pype_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  env?: Maybe<Scalars['PypeEnvironment']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pypeId?: Maybe<Scalars['String']['output']>;
  pypeRuleGroupId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  env?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pypeId?: InputMaybe<Order_By>;
  pypeRuleGroupId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Pype_Rule_Group_Pype_Min_Fields = {
  __typename?: 'tenancy_pype_rule_group_pype_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  env?: Maybe<Scalars['PypeEnvironment']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pypeId?: Maybe<Scalars['String']['output']>;
  pypeRuleGroupId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  env?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pypeId?: InputMaybe<Order_By>;
  pypeRuleGroupId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype_Mutation_Response = {
  __typename?: 'tenancy_pype_rule_group_pype_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Pype_Rule_Group_Pype>;
};

/** on_conflict condition type for table "tenancy.pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype_On_Conflict = {
  constraint: Tenancy_Pype_Rule_Group_Pype_Constraint;
  update_columns?: Array<Tenancy_Pype_Rule_Group_Pype_Update_Column>;
  where?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.pype_rule_group_pype". */
export type Tenancy_Pype_Rule_Group_Pype_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  env?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pypeId?: InputMaybe<Order_By>;
  pypeRuleGroupId?: InputMaybe<Order_By>;
  pype_rule_group?: InputMaybe<Tenancy_Pype_Rule_Group_Order_By>;
};

/** primary key columns input for table: tenancy.pype_rule_group_pype */
export type Tenancy_Pype_Rule_Group_Pype_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.pype_rule_group_pype" */
export enum Tenancy_Pype_Rule_Group_Pype_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Env = 'env',
  /** column name */
  Id = 'id',
  /** column name */
  PypeId = 'pypeId',
  /** column name */
  PypeRuleGroupId = 'pypeRuleGroupId'
}

/** input type for updating data in table "tenancy.pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  env?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  pypeId?: InputMaybe<Scalars['String']['input']>;
  pypeRuleGroupId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_pype_rule_group_pype" */
export type Tenancy_Pype_Rule_Group_Pype_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Pype_Rule_Group_Pype_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Pype_Rule_Group_Pype_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  env?: InputMaybe<Scalars['PypeEnvironment']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  pypeId?: InputMaybe<Scalars['String']['input']>;
  pypeRuleGroupId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.pype_rule_group_pype" */
export enum Tenancy_Pype_Rule_Group_Pype_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Env = 'env',
  /** column name */
  Id = 'id',
  /** column name */
  PypeId = 'pypeId',
  /** column name */
  PypeRuleGroupId = 'pypeRuleGroupId'
}

export type Tenancy_Pype_Rule_Group_Pype_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Pype_Rule_Group_Pype_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Pype_Rule_Group_Pype_Bool_Exp;
};

/** select columns of table "tenancy.pype_rule_group" */
export enum Tenancy_Pype_Rule_Group_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectProStudioSettingId = 'projectProStudioSettingId',
  /** column name */
  Settings = 'settings',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tenancy.pype_rule_group" */
export type Tenancy_Pype_Rule_Group_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['RuleCreationType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_pype_rule_group" */
export type Tenancy_Pype_Rule_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Pype_Rule_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Pype_Rule_Group_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['RuleCreationType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.pype_rule_group" */
export enum Tenancy_Pype_Rule_Group_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectProStudioSettingId = 'projectProStudioSettingId',
  /** column name */
  Settings = 'settings',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Pype_Rule_Group_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Pype_Rule_Group_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Pype_Rule_Group_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Pype_Rule_Group_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Pype_Rule_Group_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Pype_Rule_Group_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Pype_Rule_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Pype_Rule_Group_Bool_Exp;
};

/** input type for inserting data into table "tenancy.pype_rule" */
export type Tenancy_Pype_Rule_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pypeRuleGroupId?: InputMaybe<Scalars['String']['input']>;
  pype_rule_group?: InputMaybe<Tenancy_Pype_Rule_Group_Obj_Rel_Insert_Input>;
  rules?: InputMaybe<Array<Scalars['String']['input']>>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['RuleCreationType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Pype_Rule_Max_Fields = {
  __typename?: 'tenancy_pype_rule_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pypeRuleGroupId?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<Scalars['RuleCreationType']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.pype_rule" */
export type Tenancy_Pype_Rule_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pypeRuleGroupId?: InputMaybe<Order_By>;
  rules?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Pype_Rule_Min_Fields = {
  __typename?: 'tenancy_pype_rule_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pypeRuleGroupId?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<Scalars['RuleCreationType']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.pype_rule" */
export type Tenancy_Pype_Rule_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pypeRuleGroupId?: InputMaybe<Order_By>;
  rules?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.pype_rule" */
export type Tenancy_Pype_Rule_Mutation_Response = {
  __typename?: 'tenancy_pype_rule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Pype_Rule>;
};

/** on_conflict condition type for table "tenancy.pype_rule" */
export type Tenancy_Pype_Rule_On_Conflict = {
  constraint: Tenancy_Pype_Rule_Constraint;
  update_columns?: Array<Tenancy_Pype_Rule_Update_Column>;
  where?: InputMaybe<Tenancy_Pype_Rule_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.pype_rule". */
export type Tenancy_Pype_Rule_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pypeRuleGroupId?: InputMaybe<Order_By>;
  pype_rule_group?: InputMaybe<Tenancy_Pype_Rule_Group_Order_By>;
  rules?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.pype_rule */
export type Tenancy_Pype_Rule_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Pype_Rule_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.pype_rule" */
export enum Tenancy_Pype_Rule_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PypeRuleGroupId = 'pypeRuleGroupId',
  /** column name */
  Rules = 'rules',
  /** column name */
  Settings = 'settings',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tenancy.pype_rule" */
export type Tenancy_Pype_Rule_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pypeRuleGroupId?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<Scalars['String']['input']>>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['RuleCreationType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_pype_rule" */
export type Tenancy_Pype_Rule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Pype_Rule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Pype_Rule_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pypeRuleGroupId?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<Scalars['String']['input']>>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['RuleCreationType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.pype_rule" */
export enum Tenancy_Pype_Rule_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PypeRuleGroupId = 'pypeRuleGroupId',
  /** column name */
  Rules = 'rules',
  /** column name */
  Settings = 'settings',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Pype_Rule_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Pype_Rule_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Pype_Rule_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Pype_Rule_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Pype_Rule_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Pype_Rule_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Pype_Rule_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Pype_Rule_Bool_Exp;
};

/** columns and relationships of "tenancy.rich_asset_type_enum_ps" */
export type Tenancy_Rich_Asset_Type_Enum_Ps = {
  __typename?: 'tenancy_rich_asset_type_enum_ps';
  /** An array relationship */
  solution_version_nodes_ps: Array<Tenancy_Solution_Version_Nodes_Ps>;
  /** An aggregate relationship */
  solution_version_nodes_ps_aggregate: Tenancy_Solution_Version_Nodes_Ps_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.rich_asset_type_enum_ps" */
export type Tenancy_Rich_Asset_Type_Enum_PsSolution_Version_Nodes_PsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
};


/** columns and relationships of "tenancy.rich_asset_type_enum_ps" */
export type Tenancy_Rich_Asset_Type_Enum_PsSolution_Version_Nodes_Ps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
};

/** aggregated selection of "tenancy.rich_asset_type_enum_ps" */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Aggregate = {
  __typename?: 'tenancy_rich_asset_type_enum_ps_aggregate';
  aggregate?: Maybe<Tenancy_Rich_Asset_Type_Enum_Ps_Aggregate_Fields>;
  nodes: Array<Tenancy_Rich_Asset_Type_Enum_Ps>;
};

/** aggregate fields of "tenancy.rich_asset_type_enum_ps" */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Aggregate_Fields = {
  __typename?: 'tenancy_rich_asset_type_enum_ps_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Rich_Asset_Type_Enum_Ps_Max_Fields>;
  min?: Maybe<Tenancy_Rich_Asset_Type_Enum_Ps_Min_Fields>;
};


/** aggregate fields of "tenancy.rich_asset_type_enum_ps" */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.rich_asset_type_enum_ps". All fields are combined with a logical 'AND'. */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp>>;
  solution_version_nodes_ps?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
  solution_version_nodes_ps_aggregate?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.rich_asset_type_enum_ps" */
export enum Tenancy_Rich_Asset_Type_Enum_Ps_Constraint {
  /** unique or primary key constraint on columns "value" */
  RichAssetTypeEnumPsPkey = 'rich_asset_type_enum_ps_pkey'
}

export enum Tenancy_Rich_Asset_Type_Enum_Ps_Enum {
  Audio = 'audio',
  Button = 'button',
  Buttons = 'buttons',
  Carousel = 'carousel',
  Datepicker = 'datepicker',
  Deeplink = 'deeplink',
  Document = 'document',
  FileUpload = 'file_upload',
  Image = 'image',
  Imagebutton = 'imagebutton',
  Listpicker = 'listpicker',
  Location = 'location',
  LoginButton = 'login_button',
  Nav = 'nav',
  None = 'none',
  PersistentMenu = 'persistent_menu',
  Png = 'png',
  QuickReply = 'quick_reply',
  Secure = 'secure',
  Selection = 'selection',
  Star = 'star',
  Timepicker = 'timepicker',
  Utterances = 'utterances',
  Video = 'video',
  Webview = 'webview'
}

/** Boolean expression to compare columns of type "tenancy_rich_asset_type_enum_ps_enum". All fields are combined with logical 'AND'. */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Enum>;
  _in?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Enum>;
  _nin?: InputMaybe<Array<Tenancy_Rich_Asset_Type_Enum_Ps_Enum>>;
};

/** input type for inserting data into table "tenancy.rich_asset_type_enum_ps" */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Insert_Input = {
  solution_version_nodes_ps?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Max_Fields = {
  __typename?: 'tenancy_rich_asset_type_enum_ps_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Min_Fields = {
  __typename?: 'tenancy_rich_asset_type_enum_ps_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tenancy.rich_asset_type_enum_ps" */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Mutation_Response = {
  __typename?: 'tenancy_rich_asset_type_enum_ps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Rich_Asset_Type_Enum_Ps>;
};

/** input type for inserting object relation for remote table "tenancy.rich_asset_type_enum_ps" */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Obj_Rel_Insert_Input = {
  data: Tenancy_Rich_Asset_Type_Enum_Ps_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.rich_asset_type_enum_ps" */
export type Tenancy_Rich_Asset_Type_Enum_Ps_On_Conflict = {
  constraint: Tenancy_Rich_Asset_Type_Enum_Ps_Constraint;
  update_columns?: Array<Tenancy_Rich_Asset_Type_Enum_Ps_Update_Column>;
  where?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.rich_asset_type_enum_ps". */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Order_By = {
  solution_version_nodes_ps_aggregate?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.rich_asset_type_enum_ps */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "tenancy.rich_asset_type_enum_ps" */
export enum Tenancy_Rich_Asset_Type_Enum_Ps_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "tenancy.rich_asset_type_enum_ps" */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_rich_asset_type_enum_ps" */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Rich_Asset_Type_Enum_Ps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Rich_Asset_Type_Enum_Ps_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.rich_asset_type_enum_ps" */
export enum Tenancy_Rich_Asset_Type_Enum_Ps_Update_Column {
  /** column name */
  Value = 'value'
}

export type Tenancy_Rich_Asset_Type_Enum_Ps_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp;
};

/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles = {
  __typename?: 'tenancy_roles';
  /** An array relationship */
  _role_projects: Array<Tenancy__Role_Projects>;
  /** An aggregate relationship */
  _role_projects_aggregate: Tenancy__Role_Projects_Aggregate;
  /** An array relationship */
  _team_account_environment_config_roles: Array<Tenancy__Team_Account_Environment_Config_Roles>;
  /** An aggregate relationship */
  _team_account_environment_config_roles_aggregate: Tenancy__Team_Account_Environment_Config_Roles_Aggregate;
  /** An array relationship */
  _team_account_project_roles: Array<Tenancy__Team_Account_Project_Roles>;
  /** An aggregate relationship */
  _team_account_project_roles_aggregate: Tenancy__Team_Account_Project_Roles_Aggregate;
  /** An array relationship */
  _team_account_roles: Array<Tenancy__Team_Account_Roles>;
  /** An aggregate relationship */
  _team_account_roles_aggregate: Tenancy__Team_Account_Roles_Aggregate;
  /** An array relationship */
  _user_account_environment_config_roles: Array<Tenancy__User_Account_Environment_Config_Roles>;
  /** An aggregate relationship */
  _user_account_environment_config_roles_aggregate: Tenancy__User_Account_Environment_Config_Roles_Aggregate;
  /** An array relationship */
  _user_account_project_roles: Array<Tenancy__User_Account_Project_Roles>;
  /** An aggregate relationship */
  _user_account_project_roles_aggregate: Tenancy__User_Account_Project_Roles_Aggregate;
  /** An array relationship */
  _user_account_roles: Array<Tenancy__User_Account_Roles>;
  /** An aggregate relationship */
  _user_account_roles_aggregate: Tenancy__User_Account_Roles_Aggregate;
  /** An object relationship */
  account: Tenancy_Accounts;
  accountId: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissions: Scalars['jsonb']['output'];
  /** An object relationship */
  product: Tenancy_Products;
  productId: Scalars['String']['output'];
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
  /** An array relationship */
  user_account_project_metabase_accesses: Array<Tenancy_User_Account_Project_Metabase_Access>;
  /** An aggregate relationship */
  user_account_project_metabase_accesses_aggregate: Tenancy_User_Account_Project_Metabase_Access_Aggregate;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_Role_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Role_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Role_Projects_Order_By>>;
  where?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_Role_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Role_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Role_Projects_Order_By>>;
  where?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_Team_Account_Environment_Config_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_Team_Account_Environment_Config_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_Team_Account_Project_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_Team_Account_Project_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_Team_Account_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_Team_Account_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_User_Account_Environment_Config_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_User_Account_Environment_Config_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_User_Account_Project_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_User_Account_Project_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_User_Account_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_Roles_User_Account_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_RolesPermissionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_RolesUser_Account_Project_Metabase_AccessesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
};


/** columns and relationships of "tenancy.roles" */
export type Tenancy_RolesUser_Account_Project_Metabase_Accesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
};

/** aggregated selection of "tenancy.roles" */
export type Tenancy_Roles_Aggregate = {
  __typename?: 'tenancy_roles_aggregate';
  aggregate?: Maybe<Tenancy_Roles_Aggregate_Fields>;
  nodes: Array<Tenancy_Roles>;
};

export type Tenancy_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Roles_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.roles" */
export type Tenancy_Roles_Aggregate_Fields = {
  __typename?: 'tenancy_roles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Roles_Max_Fields>;
  min?: Maybe<Tenancy_Roles_Min_Fields>;
};


/** aggregate fields of "tenancy.roles" */
export type Tenancy_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.roles" */
export type Tenancy_Roles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Roles_Max_Order_By>;
  min?: InputMaybe<Tenancy_Roles_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Roles_Append_Input = {
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.roles" */
export type Tenancy_Roles_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Roles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.roles". All fields are combined with a logical 'AND'. */
export type Tenancy_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Roles_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Roles_Bool_Exp>>;
  _role_projects?: InputMaybe<Tenancy__Role_Projects_Bool_Exp>;
  _role_projects_aggregate?: InputMaybe<Tenancy__Role_Projects_Aggregate_Bool_Exp>;
  _team_account_environment_config_roles?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
  _team_account_environment_config_roles_aggregate?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Aggregate_Bool_Exp>;
  _team_account_project_roles?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
  _team_account_project_roles_aggregate?: InputMaybe<Tenancy__Team_Account_Project_Roles_Aggregate_Bool_Exp>;
  _team_account_roles?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
  _team_account_roles_aggregate?: InputMaybe<Tenancy__Team_Account_Roles_Aggregate_Bool_Exp>;
  _user_account_environment_config_roles?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
  _user_account_environment_config_roles_aggregate?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Aggregate_Bool_Exp>;
  _user_account_project_roles?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
  _user_account_project_roles_aggregate?: InputMaybe<Tenancy__User_Account_Project_Roles_Aggregate_Bool_Exp>;
  _user_account_roles?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
  _user_account_roles_aggregate?: InputMaybe<Tenancy__User_Account_Roles_Aggregate_Bool_Exp>;
  account?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  accountId?: InputMaybe<String_Comparison_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  permissions?: InputMaybe<Jsonb_Comparison_Exp>;
  product?: InputMaybe<Tenancy_Products_Bool_Exp>;
  productId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
  user_account_project_metabase_accesses?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
  user_account_project_metabase_accesses_aggregate?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.roles" */
export enum Tenancy_Roles_Constraint {
  /** unique or primary key constraint on columns "id" */
  RolesPkey = 'roles_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Roles_Delete_At_Path_Input = {
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Roles_Delete_Elem_Input = {
  permissions?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Roles_Delete_Key_Input = {
  permissions?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.roles" */
export type Tenancy_Roles_Insert_Input = {
  _role_projects?: InputMaybe<Tenancy__Role_Projects_Arr_Rel_Insert_Input>;
  _team_account_environment_config_roles?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Arr_Rel_Insert_Input>;
  _team_account_project_roles?: InputMaybe<Tenancy__Team_Account_Project_Roles_Arr_Rel_Insert_Input>;
  _team_account_roles?: InputMaybe<Tenancy__Team_Account_Roles_Arr_Rel_Insert_Input>;
  _user_account_environment_config_roles?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Arr_Rel_Insert_Input>;
  _user_account_project_roles?: InputMaybe<Tenancy__User_Account_Project_Roles_Arr_Rel_Insert_Input>;
  _user_account_roles?: InputMaybe<Tenancy__User_Account_Roles_Arr_Rel_Insert_Input>;
  account?: InputMaybe<Tenancy_Accounts_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
  product?: InputMaybe<Tenancy_Products_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  user_account_project_metabase_accesses?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Roles_Max_Fields = {
  __typename?: 'tenancy_roles_max_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.roles" */
export type Tenancy_Roles_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Roles_Min_Fields = {
  __typename?: 'tenancy_roles_min_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.roles" */
export type Tenancy_Roles_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.roles" */
export type Tenancy_Roles_Mutation_Response = {
  __typename?: 'tenancy_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Roles>;
};

/** input type for inserting object relation for remote table "tenancy.roles" */
export type Tenancy_Roles_Obj_Rel_Insert_Input = {
  data: Tenancy_Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Roles_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.roles" */
export type Tenancy_Roles_On_Conflict = {
  constraint: Tenancy_Roles_Constraint;
  update_columns?: Array<Tenancy_Roles_Update_Column>;
  where?: InputMaybe<Tenancy_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.roles". */
export type Tenancy_Roles_Order_By = {
  _role_projects_aggregate?: InputMaybe<Tenancy__Role_Projects_Aggregate_Order_By>;
  _team_account_environment_config_roles_aggregate?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Aggregate_Order_By>;
  _team_account_project_roles_aggregate?: InputMaybe<Tenancy__Team_Account_Project_Roles_Aggregate_Order_By>;
  _team_account_roles_aggregate?: InputMaybe<Tenancy__Team_Account_Roles_Aggregate_Order_By>;
  _user_account_environment_config_roles_aggregate?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Aggregate_Order_By>;
  _user_account_project_roles_aggregate?: InputMaybe<Tenancy__User_Account_Project_Roles_Aggregate_Order_By>;
  _user_account_roles_aggregate?: InputMaybe<Tenancy__User_Account_Roles_Aggregate_Order_By>;
  account?: InputMaybe<Tenancy_Accounts_Order_By>;
  accountId?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  permissions?: InputMaybe<Order_By>;
  product?: InputMaybe<Tenancy_Products_Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  user_account_project_metabase_accesses_aggregate?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Aggregate_Order_By>;
};

/** primary key columns input for table: tenancy.roles */
export type Tenancy_Roles_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Roles_Prepend_Input = {
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.roles" */
export enum Tenancy_Roles_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "tenancy.roles" */
export type Tenancy_Roles_Set_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_roles" */
export type Tenancy_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Roles_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.roles" */
export enum Tenancy_Roles_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type Tenancy_Roles_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Roles_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Roles_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Roles_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Roles_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Roles_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Roles_Bool_Exp;
};

/** columns and relationships of "tenancy.solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows = {
  __typename?: 'tenancy_solution_deployment_run_workflows';
  createdAt: Scalars['timestamp']['output'];
  giteaRunId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  solutionDeploymentRunId: Scalars['String']['output'];
  /** An object relationship */
  solution_deployment_run: Tenancy_Solution_Deployment_Runs;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "tenancy.solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows_Aggregate = {
  __typename?: 'tenancy_solution_deployment_run_workflows_aggregate';
  aggregate?: Maybe<Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Fields>;
  nodes: Array<Tenancy_Solution_Deployment_Run_Workflows>;
};

export type Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_Solution_Deployment_Run_Workflows_Select_Column_Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_Solution_Deployment_Run_Workflows_Select_Column_Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Fields = {
  __typename?: 'tenancy_solution_deployment_run_workflows_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Solution_Deployment_Run_Workflows_Max_Fields>;
  min?: Maybe<Tenancy_Solution_Deployment_Run_Workflows_Min_Fields>;
};


/** aggregate fields of "tenancy.solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Max_Order_By>;
  min?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Solution_Deployment_Run_Workflows_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.solution_deployment_run_workflows". All fields are combined with a logical 'AND'. */
export type Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  giteaRunId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  required?: InputMaybe<Boolean_Comparison_Exp>;
  solutionDeploymentRunId?: InputMaybe<String_Comparison_Exp>;
  solution_deployment_run?: InputMaybe<Tenancy_Solution_Deployment_Runs_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.solution_deployment_run_workflows" */
export enum Tenancy_Solution_Deployment_Run_Workflows_Constraint {
  /** unique or primary key constraint on columns "id" */
  SolutionDeploymentRunWorkflowsPkey = 'solution_deployment_run_workflows_pkey',
  /** unique or primary key constraint on columns "solutionDeploymentRunId", "name" */
  SolutionDeploymentRunWorkflowsSolutionDeploymentRunIdNKey = 'solution_deployment_run_workflows_solutionDeploymentRunId_n_key'
}

/** input type for inserting data into table "tenancy.solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  giteaRunId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  solutionDeploymentRunId?: InputMaybe<Scalars['String']['input']>;
  solution_deployment_run?: InputMaybe<Tenancy_Solution_Deployment_Runs_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Solution_Deployment_Run_Workflows_Max_Fields = {
  __typename?: 'tenancy_solution_deployment_run_workflows_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  giteaRunId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  solutionDeploymentRunId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  giteaRunId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  solutionDeploymentRunId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Solution_Deployment_Run_Workflows_Min_Fields = {
  __typename?: 'tenancy_solution_deployment_run_workflows_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  giteaRunId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  solutionDeploymentRunId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  giteaRunId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  solutionDeploymentRunId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows_Mutation_Response = {
  __typename?: 'tenancy_solution_deployment_run_workflows_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Solution_Deployment_Run_Workflows>;
};

/** on_conflict condition type for table "tenancy.solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows_On_Conflict = {
  constraint: Tenancy_Solution_Deployment_Run_Workflows_Constraint;
  update_columns?: Array<Tenancy_Solution_Deployment_Run_Workflows_Update_Column>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.solution_deployment_run_workflows". */
export type Tenancy_Solution_Deployment_Run_Workflows_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  giteaRunId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  required?: InputMaybe<Order_By>;
  solutionDeploymentRunId?: InputMaybe<Order_By>;
  solution_deployment_run?: InputMaybe<Tenancy_Solution_Deployment_Runs_Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.solution_deployment_run_workflows */
export type Tenancy_Solution_Deployment_Run_Workflows_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.solution_deployment_run_workflows" */
export enum Tenancy_Solution_Deployment_Run_Workflows_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GiteaRunId = 'giteaRunId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Required = 'required',
  /** column name */
  SolutionDeploymentRunId = 'solutionDeploymentRunId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "tenancy_solution_deployment_run_workflows_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.solution_deployment_run_workflows" */
export enum Tenancy_Solution_Deployment_Run_Workflows_Select_Column_Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Required = 'required'
}

/** select "tenancy_solution_deployment_run_workflows_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.solution_deployment_run_workflows" */
export enum Tenancy_Solution_Deployment_Run_Workflows_Select_Column_Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Required = 'required'
}

/** input type for updating data in table "tenancy.solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  giteaRunId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  solutionDeploymentRunId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_solution_deployment_run_workflows" */
export type Tenancy_Solution_Deployment_Run_Workflows_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Solution_Deployment_Run_Workflows_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Solution_Deployment_Run_Workflows_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  giteaRunId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  solutionDeploymentRunId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.solution_deployment_run_workflows" */
export enum Tenancy_Solution_Deployment_Run_Workflows_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GiteaRunId = 'giteaRunId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Required = 'required',
  /** column name */
  SolutionDeploymentRunId = 'solutionDeploymentRunId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Solution_Deployment_Run_Workflows_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp;
};

/** columns and relationships of "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs = {
  __typename?: 'tenancy_solution_deployment_runs';
  createdAt: Scalars['timestamp']['output'];
  giteaCommitSha?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  solutionDeploymentId: Scalars['String']['output'];
  /** An object relationship */
  solution_deployment: Tenancy_Solution_Deployments;
  /** An array relationship */
  solution_deployment_run_workflows: Array<Tenancy_Solution_Deployment_Run_Workflows>;
  /** An aggregate relationship */
  solution_deployment_run_workflows_aggregate: Tenancy_Solution_Deployment_Run_Workflows_Aggregate;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_RunsSolution_Deployment_Run_WorkflowsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_RunsSolution_Deployment_Run_Workflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployment_Run_Workflows_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
};

/** aggregated selection of "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_Aggregate = {
  __typename?: 'tenancy_solution_deployment_runs_aggregate';
  aggregate?: Maybe<Tenancy_Solution_Deployment_Runs_Aggregate_Fields>;
  nodes: Array<Tenancy_Solution_Deployment_Runs>;
};

export type Tenancy_Solution_Deployment_Runs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Solution_Deployment_Runs_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Solution_Deployment_Runs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Deployment_Runs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_Aggregate_Fields = {
  __typename?: 'tenancy_solution_deployment_runs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Solution_Deployment_Runs_Max_Fields>;
  min?: Maybe<Tenancy_Solution_Deployment_Runs_Min_Fields>;
};


/** aggregate fields of "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Solution_Deployment_Runs_Max_Order_By>;
  min?: InputMaybe<Tenancy_Solution_Deployment_Runs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Solution_Deployment_Runs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solution_Deployment_Runs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.solution_deployment_runs". All fields are combined with a logical 'AND'. */
export type Tenancy_Solution_Deployment_Runs_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Solution_Deployment_Runs_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  giteaCommitSha?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  solutionDeploymentId?: InputMaybe<String_Comparison_Exp>;
  solution_deployment?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
  solution_deployment_run_workflows?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Bool_Exp>;
  solution_deployment_run_workflows_aggregate?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.solution_deployment_runs" */
export enum Tenancy_Solution_Deployment_Runs_Constraint {
  /** unique or primary key constraint on columns "id" */
  SolutionDeploymentRunsPkey = 'solution_deployment_runs_pkey'
}

/** input type for inserting data into table "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  giteaCommitSha?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  solutionDeploymentId?: InputMaybe<Scalars['String']['input']>;
  solution_deployment?: InputMaybe<Tenancy_Solution_Deployments_Obj_Rel_Insert_Input>;
  solution_deployment_run_workflows?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Solution_Deployment_Runs_Max_Fields = {
  __typename?: 'tenancy_solution_deployment_runs_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  giteaCommitSha?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  solutionDeploymentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  giteaCommitSha?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  solutionDeploymentId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Solution_Deployment_Runs_Min_Fields = {
  __typename?: 'tenancy_solution_deployment_runs_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  giteaCommitSha?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  solutionDeploymentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  giteaCommitSha?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  solutionDeploymentId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_Mutation_Response = {
  __typename?: 'tenancy_solution_deployment_runs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Solution_Deployment_Runs>;
};

/** input type for inserting object relation for remote table "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_Obj_Rel_Insert_Input = {
  data: Tenancy_Solution_Deployment_Runs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solution_Deployment_Runs_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_On_Conflict = {
  constraint: Tenancy_Solution_Deployment_Runs_Constraint;
  update_columns?: Array<Tenancy_Solution_Deployment_Runs_Update_Column>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Runs_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.solution_deployment_runs". */
export type Tenancy_Solution_Deployment_Runs_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  giteaCommitSha?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  solutionDeploymentId?: InputMaybe<Order_By>;
  solution_deployment?: InputMaybe<Tenancy_Solution_Deployments_Order_By>;
  solution_deployment_run_workflows_aggregate?: InputMaybe<Tenancy_Solution_Deployment_Run_Workflows_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.solution_deployment_runs */
export type Tenancy_Solution_Deployment_Runs_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.solution_deployment_runs" */
export enum Tenancy_Solution_Deployment_Runs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GiteaCommitSha = 'giteaCommitSha',
  /** column name */
  Id = 'id',
  /** column name */
  SolutionDeploymentId = 'solutionDeploymentId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tenancy.solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  giteaCommitSha?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  solutionDeploymentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_solution_deployment_runs" */
export type Tenancy_Solution_Deployment_Runs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Solution_Deployment_Runs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Solution_Deployment_Runs_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  giteaCommitSha?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  solutionDeploymentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.solution_deployment_runs" */
export enum Tenancy_Solution_Deployment_Runs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GiteaCommitSha = 'giteaCommitSha',
  /** column name */
  Id = 'id',
  /** column name */
  SolutionDeploymentId = 'solutionDeploymentId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Solution_Deployment_Runs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Solution_Deployment_Runs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Solution_Deployment_Runs_Bool_Exp;
};

/** columns and relationships of "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments = {
  __typename?: 'tenancy_solution_deployments';
  callbackToken: Scalars['String']['output'];
  createdAt: Scalars['timestamp']['output'];
  deployedAt: Scalars['timestamp']['output'];
  deployedBy: Scalars['String']['output'];
  environment: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isLatest: Scalars['Boolean']['output'];
  isRepublish: Scalars['Boolean']['output'];
  options?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  solution: Tenancy_Solutions;
  solutionId: Scalars['String']['output'];
  solutionVersionId: Scalars['String']['output'];
  /** An array relationship */
  solution_deployment_runs: Array<Tenancy_Solution_Deployment_Runs>;
  /** An aggregate relationship */
  solution_deployment_runs_aggregate: Tenancy_Solution_Deployment_Runs_Aggregate;
  /** An object relationship */
  solution_version: Tenancy_Solution_Versions;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "tenancy.solution_deployments" */
export type Tenancy_Solution_DeploymentsOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solution_deployments" */
export type Tenancy_Solution_DeploymentsSolution_Deployment_RunsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Runs_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_deployments" */
export type Tenancy_Solution_DeploymentsSolution_Deployment_Runs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployment_Runs_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployment_Runs_Bool_Exp>;
};

/** aggregated selection of "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments_Aggregate = {
  __typename?: 'tenancy_solution_deployments_aggregate';
  aggregate?: Maybe<Tenancy_Solution_Deployments_Aggregate_Fields>;
  nodes: Array<Tenancy_Solution_Deployments>;
};

export type Tenancy_Solution_Deployments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_Solution_Deployments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_Solution_Deployments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_Solution_Deployments_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Solution_Deployments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_Solution_Deployments_Select_Column_Tenancy_Solution_Deployments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solution_Deployments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_Solution_Deployments_Select_Column_Tenancy_Solution_Deployments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solution_Deployments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Solution_Deployments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments_Aggregate_Fields = {
  __typename?: 'tenancy_solution_deployments_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Solution_Deployments_Max_Fields>;
  min?: Maybe<Tenancy_Solution_Deployments_Min_Fields>;
};


/** aggregate fields of "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Solution_Deployments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Solution_Deployments_Max_Order_By>;
  min?: InputMaybe<Tenancy_Solution_Deployments_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Solution_Deployments_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Solution_Deployments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solution_Deployments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.solution_deployments". All fields are combined with a logical 'AND'. */
export type Tenancy_Solution_Deployments_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Solution_Deployments_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Solution_Deployments_Bool_Exp>>;
  callbackToken?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  deployedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  deployedBy?: InputMaybe<String_Comparison_Exp>;
  environment?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isLatest?: InputMaybe<Boolean_Comparison_Exp>;
  isRepublish?: InputMaybe<Boolean_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  solution?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
  solutionId?: InputMaybe<String_Comparison_Exp>;
  solutionVersionId?: InputMaybe<String_Comparison_Exp>;
  solution_deployment_runs?: InputMaybe<Tenancy_Solution_Deployment_Runs_Bool_Exp>;
  solution_deployment_runs_aggregate?: InputMaybe<Tenancy_Solution_Deployment_Runs_Aggregate_Bool_Exp>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.solution_deployments" */
export enum Tenancy_Solution_Deployments_Constraint {
  /** unique or primary key constraint on columns "id" */
  SolutionDeploymentsPkey = 'solution_deployments_pkey',
  /** unique or primary key constraint on columns "environment", "solutionVersionId" */
  SolutionDeploymentsSolutionVersionIdEnvironmentKey = 'solution_deployments_solutionVersionId_environment_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Solution_Deployments_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Solution_Deployments_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Solution_Deployments_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments_Insert_Input = {
  callbackToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  deployedAt?: InputMaybe<Scalars['timestamp']['input']>;
  deployedBy?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  isRepublish?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  solution?: InputMaybe<Tenancy_Solutions_Obj_Rel_Insert_Input>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  solution_deployment_runs?: InputMaybe<Tenancy_Solution_Deployment_Runs_Arr_Rel_Insert_Input>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Solution_Deployments_Max_Fields = {
  __typename?: 'tenancy_solution_deployments_max_fields';
  callbackToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  deployedAt?: Maybe<Scalars['timestamp']['output']>;
  deployedBy?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  solutionId?: Maybe<Scalars['String']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments_Max_Order_By = {
  callbackToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deployedAt?: InputMaybe<Order_By>;
  deployedBy?: InputMaybe<Order_By>;
  environment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  solutionId?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Solution_Deployments_Min_Fields = {
  __typename?: 'tenancy_solution_deployments_min_fields';
  callbackToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  deployedAt?: Maybe<Scalars['timestamp']['output']>;
  deployedBy?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  solutionId?: Maybe<Scalars['String']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments_Min_Order_By = {
  callbackToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deployedAt?: InputMaybe<Order_By>;
  deployedBy?: InputMaybe<Order_By>;
  environment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  solutionId?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments_Mutation_Response = {
  __typename?: 'tenancy_solution_deployments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Solution_Deployments>;
};

/** input type for inserting object relation for remote table "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments_Obj_Rel_Insert_Input = {
  data: Tenancy_Solution_Deployments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solution_Deployments_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments_On_Conflict = {
  constraint: Tenancy_Solution_Deployments_Constraint;
  update_columns?: Array<Tenancy_Solution_Deployments_Update_Column>;
  where?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.solution_deployments". */
export type Tenancy_Solution_Deployments_Order_By = {
  callbackToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deployedAt?: InputMaybe<Order_By>;
  deployedBy?: InputMaybe<Order_By>;
  environment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isLatest?: InputMaybe<Order_By>;
  isRepublish?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  solution?: InputMaybe<Tenancy_Solutions_Order_By>;
  solutionId?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  solution_deployment_runs_aggregate?: InputMaybe<Tenancy_Solution_Deployment_Runs_Aggregate_Order_By>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.solution_deployments */
export type Tenancy_Solution_Deployments_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Solution_Deployments_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.solution_deployments" */
export enum Tenancy_Solution_Deployments_Select_Column {
  /** column name */
  CallbackToken = 'callbackToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeployedAt = 'deployedAt',
  /** column name */
  DeployedBy = 'deployedBy',
  /** column name */
  Environment = 'environment',
  /** column name */
  Id = 'id',
  /** column name */
  IsLatest = 'isLatest',
  /** column name */
  IsRepublish = 'isRepublish',
  /** column name */
  Options = 'options',
  /** column name */
  SolutionId = 'solutionId',
  /** column name */
  SolutionVersionId = 'solutionVersionId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "tenancy_solution_deployments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.solution_deployments" */
export enum Tenancy_Solution_Deployments_Select_Column_Tenancy_Solution_Deployments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsLatest = 'isLatest',
  /** column name */
  IsRepublish = 'isRepublish'
}

/** select "tenancy_solution_deployments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.solution_deployments" */
export enum Tenancy_Solution_Deployments_Select_Column_Tenancy_Solution_Deployments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsLatest = 'isLatest',
  /** column name */
  IsRepublish = 'isRepublish'
}

/** input type for updating data in table "tenancy.solution_deployments" */
export type Tenancy_Solution_Deployments_Set_Input = {
  callbackToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  deployedAt?: InputMaybe<Scalars['timestamp']['input']>;
  deployedBy?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  isRepublish?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_solution_deployments" */
export type Tenancy_Solution_Deployments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Solution_Deployments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Solution_Deployments_Stream_Cursor_Value_Input = {
  callbackToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  deployedAt?: InputMaybe<Scalars['timestamp']['input']>;
  deployedBy?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  isRepublish?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.solution_deployments" */
export enum Tenancy_Solution_Deployments_Update_Column {
  /** column name */
  CallbackToken = 'callbackToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeployedAt = 'deployedAt',
  /** column name */
  DeployedBy = 'deployedBy',
  /** column name */
  Environment = 'environment',
  /** column name */
  Id = 'id',
  /** column name */
  IsLatest = 'isLatest',
  /** column name */
  IsRepublish = 'isRepublish',
  /** column name */
  Options = 'options',
  /** column name */
  SolutionId = 'solutionId',
  /** column name */
  SolutionVersionId = 'solutionVersionId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Solution_Deployments_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Solution_Deployments_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Solution_Deployments_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Solution_Deployments_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Solution_Deployments_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Solution_Deployments_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Solution_Deployments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Solution_Deployments_Bool_Exp;
};

/** columns and relationships of "tenancy.solution_task" */
export type Tenancy_Solution_Task = {
  __typename?: 'tenancy_solution_task';
  createdAt: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  solutionVersionId: Scalars['String']['output'];
  /** An object relationship */
  solution_version: Tenancy_Solution_Versions;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "tenancy.solution_task" */
export type Tenancy_Solution_Task_Aggregate = {
  __typename?: 'tenancy_solution_task_aggregate';
  aggregate?: Maybe<Tenancy_Solution_Task_Aggregate_Fields>;
  nodes: Array<Tenancy_Solution_Task>;
};

export type Tenancy_Solution_Task_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Solution_Task_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Solution_Task_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Solution_Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Task_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.solution_task" */
export type Tenancy_Solution_Task_Aggregate_Fields = {
  __typename?: 'tenancy_solution_task_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Solution_Task_Max_Fields>;
  min?: Maybe<Tenancy_Solution_Task_Min_Fields>;
};


/** aggregate fields of "tenancy.solution_task" */
export type Tenancy_Solution_Task_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Solution_Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.solution_task" */
export type Tenancy_Solution_Task_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Solution_Task_Max_Order_By>;
  min?: InputMaybe<Tenancy_Solution_Task_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.solution_task" */
export type Tenancy_Solution_Task_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Solution_Task_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solution_Task_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.solution_task". All fields are combined with a logical 'AND'. */
export type Tenancy_Solution_Task_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Solution_Task_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Solution_Task_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Solution_Task_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  solutionVersionId?: InputMaybe<String_Comparison_Exp>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.solution_task" */
export enum Tenancy_Solution_Task_Constraint {
  /** unique or primary key constraint on columns "id" */
  SolutionTaskPkey = 'solution_task_pkey'
}

/** input type for inserting data into table "tenancy.solution_task" */
export type Tenancy_Solution_Task_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Solution_Task_Max_Fields = {
  __typename?: 'tenancy_solution_task_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.solution_task" */
export type Tenancy_Solution_Task_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Solution_Task_Min_Fields = {
  __typename?: 'tenancy_solution_task_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.solution_task" */
export type Tenancy_Solution_Task_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.solution_task" */
export type Tenancy_Solution_Task_Mutation_Response = {
  __typename?: 'tenancy_solution_task_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Solution_Task>;
};

/** on_conflict condition type for table "tenancy.solution_task" */
export type Tenancy_Solution_Task_On_Conflict = {
  constraint: Tenancy_Solution_Task_Constraint;
  update_columns?: Array<Tenancy_Solution_Task_Update_Column>;
  where?: InputMaybe<Tenancy_Solution_Task_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.solution_task". */
export type Tenancy_Solution_Task_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.solution_task */
export type Tenancy_Solution_Task_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.solution_task" */
export enum Tenancy_Solution_Task_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SolutionVersionId = 'solutionVersionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tenancy.solution_task" */
export type Tenancy_Solution_Task_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_solution_task" */
export type Tenancy_Solution_Task_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Solution_Task_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Solution_Task_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.solution_task" */
export enum Tenancy_Solution_Task_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SolutionVersionId = 'solutionVersionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Solution_Task_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Solution_Task_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Solution_Task_Bool_Exp;
};

/** columns and relationships of "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_Presence = {
  __typename?: 'tenancy_solution_user_presence';
  firstSeenAt: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastSeenAt: Scalars['timestamp']['output'];
  pageParams?: Maybe<Scalars['jsonb']['output']>;
  pagePath: Scalars['String']['output'];
  /** An object relationship */
  solution: Tenancy_Solutions;
  solutionId: Scalars['String']['output'];
  /** An object relationship */
  user: Tenancy_Users;
  userId: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_PresencePageParamsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_Presence_Aggregate = {
  __typename?: 'tenancy_solution_user_presence_aggregate';
  aggregate?: Maybe<Tenancy_Solution_User_Presence_Aggregate_Fields>;
  nodes: Array<Tenancy_Solution_User_Presence>;
};

export type Tenancy_Solution_User_Presence_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_Solution_User_Presence_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_Solution_User_Presence_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_Solution_User_Presence_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Solution_User_Presence_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_Solution_User_Presence_Select_Column_Tenancy_Solution_User_Presence_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solution_User_Presence_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_Solution_User_Presence_Select_Column_Tenancy_Solution_User_Presence_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solution_User_Presence_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Solution_User_Presence_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_Presence_Aggregate_Fields = {
  __typename?: 'tenancy_solution_user_presence_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Solution_User_Presence_Max_Fields>;
  min?: Maybe<Tenancy_Solution_User_Presence_Min_Fields>;
};


/** aggregate fields of "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_Presence_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Solution_User_Presence_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_Presence_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Solution_User_Presence_Max_Order_By>;
  min?: InputMaybe<Tenancy_Solution_User_Presence_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Solution_User_Presence_Append_Input = {
  pageParams?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_Presence_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Solution_User_Presence_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solution_User_Presence_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.solution_user_presence". All fields are combined with a logical 'AND'. */
export type Tenancy_Solution_User_Presence_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Solution_User_Presence_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Solution_User_Presence_Bool_Exp>>;
  firstSeenAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  lastSeenAt?: InputMaybe<Timestamp_Comparison_Exp>;
  pageParams?: InputMaybe<Jsonb_Comparison_Exp>;
  pagePath?: InputMaybe<String_Comparison_Exp>;
  solution?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
  solutionId?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Tenancy_Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.solution_user_presence" */
export enum Tenancy_Solution_User_Presence_Constraint {
  /** unique or primary key constraint on columns "id" */
  SolutionUserPresencePkey = 'solution_user_presence_pkey',
  /** unique or primary key constraint on columns "userId", "solutionId" */
  SolutionUserPresenceSolutionIdUserIdKey = 'solution_user_presence_solutionId_userId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Solution_User_Presence_Delete_At_Path_Input = {
  pageParams?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Solution_User_Presence_Delete_Elem_Input = {
  pageParams?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Solution_User_Presence_Delete_Key_Input = {
  pageParams?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_Presence_Insert_Input = {
  firstSeenAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeenAt?: InputMaybe<Scalars['timestamp']['input']>;
  pageParams?: InputMaybe<Scalars['jsonb']['input']>;
  pagePath?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Tenancy_Solutions_Obj_Rel_Insert_Input>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Tenancy_Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Solution_User_Presence_Max_Fields = {
  __typename?: 'tenancy_solution_user_presence_max_fields';
  firstSeenAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['timestamp']['output']>;
  pagePath?: Maybe<Scalars['String']['output']>;
  solutionId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_Presence_Max_Order_By = {
  firstSeenAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeenAt?: InputMaybe<Order_By>;
  pagePath?: InputMaybe<Order_By>;
  solutionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Solution_User_Presence_Min_Fields = {
  __typename?: 'tenancy_solution_user_presence_min_fields';
  firstSeenAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['timestamp']['output']>;
  pagePath?: Maybe<Scalars['String']['output']>;
  solutionId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_Presence_Min_Order_By = {
  firstSeenAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeenAt?: InputMaybe<Order_By>;
  pagePath?: InputMaybe<Order_By>;
  solutionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_Presence_Mutation_Response = {
  __typename?: 'tenancy_solution_user_presence_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Solution_User_Presence>;
};

/** on_conflict condition type for table "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_Presence_On_Conflict = {
  constraint: Tenancy_Solution_User_Presence_Constraint;
  update_columns?: Array<Tenancy_Solution_User_Presence_Update_Column>;
  where?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.solution_user_presence". */
export type Tenancy_Solution_User_Presence_Order_By = {
  firstSeenAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  lastSeenAt?: InputMaybe<Order_By>;
  pageParams?: InputMaybe<Order_By>;
  pagePath?: InputMaybe<Order_By>;
  solution?: InputMaybe<Tenancy_Solutions_Order_By>;
  solutionId?: InputMaybe<Order_By>;
  user?: InputMaybe<Tenancy_Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.solution_user_presence */
export type Tenancy_Solution_User_Presence_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Solution_User_Presence_Prepend_Input = {
  pageParams?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.solution_user_presence" */
export enum Tenancy_Solution_User_Presence_Select_Column {
  /** column name */
  FirstSeenAt = 'firstSeenAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  LastSeenAt = 'lastSeenAt',
  /** column name */
  PageParams = 'pageParams',
  /** column name */
  PagePath = 'pagePath',
  /** column name */
  SolutionId = 'solutionId',
  /** column name */
  UserId = 'userId'
}

/** select "tenancy_solution_user_presence_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.solution_user_presence" */
export enum Tenancy_Solution_User_Presence_Select_Column_Tenancy_Solution_User_Presence_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** select "tenancy_solution_user_presence_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.solution_user_presence" */
export enum Tenancy_Solution_User_Presence_Select_Column_Tenancy_Solution_User_Presence_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** input type for updating data in table "tenancy.solution_user_presence" */
export type Tenancy_Solution_User_Presence_Set_Input = {
  firstSeenAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeenAt?: InputMaybe<Scalars['timestamp']['input']>;
  pageParams?: InputMaybe<Scalars['jsonb']['input']>;
  pagePath?: InputMaybe<Scalars['String']['input']>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_solution_user_presence" */
export type Tenancy_Solution_User_Presence_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Solution_User_Presence_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Solution_User_Presence_Stream_Cursor_Value_Input = {
  firstSeenAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeenAt?: InputMaybe<Scalars['timestamp']['input']>;
  pageParams?: InputMaybe<Scalars['jsonb']['input']>;
  pagePath?: InputMaybe<Scalars['String']['input']>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.solution_user_presence" */
export enum Tenancy_Solution_User_Presence_Update_Column {
  /** column name */
  FirstSeenAt = 'firstSeenAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  LastSeenAt = 'lastSeenAt',
  /** column name */
  PageParams = 'pageParams',
  /** column name */
  PagePath = 'pagePath',
  /** column name */
  SolutionId = 'solutionId',
  /** column name */
  UserId = 'userId'
}

export type Tenancy_Solution_User_Presence_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Solution_User_Presence_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Solution_User_Presence_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Solution_User_Presence_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Solution_User_Presence_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Solution_User_Presence_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Solution_User_Presence_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Solution_User_Presence_Bool_Exp;
};

/** columns and relationships of "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps = {
  __typename?: 'tenancy_solution_version_nodes_ps';
  analyticsEvent?: Maybe<Scalars['json']['output']>;
  analyticsEventMap?: Maybe<Scalars['jsonb']['output']>;
  answerRequired: Scalars['Boolean']['output'];
  behaviors?: Maybe<Array<Scalars['String']['output']>>;
  command?: Maybe<Scalars['String']['output']>;
  cssClassname?: Maybe<Scalars['String']['output']>;
  decisionVariable?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  intent?: Maybe<Scalars['String']['output']>;
  lastModified?: Maybe<Scalars['timestamp']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nextNodes?: Maybe<Array<Scalars['numeric']['output']>>;
  nluDisabled?: Maybe<Scalars['Boolean']['output']>;
  nodeInput?: Maybe<Scalars['String']['output']>;
  nodeName?: Maybe<Scalars['String']['output']>;
  nodeNumber?: Maybe<Scalars['numeric']['output']>;
  nodeTags?: Maybe<Scalars['String']['output']>;
  nodeType: Tenancy_Node_Type_Enum_Ps_Enum;
  /** An object relationship */
  node_type_enum_p: Tenancy_Node_Type_Enum_Ps;
  order: Scalars['numeric']['output'];
  output?: Maybe<Array<Scalars['String']['output']>>;
  parameterInput?: Maybe<Scalars['json']['output']>;
  parameterInputMap?: Maybe<Scalars['jsonb']['output']>;
  platformFlag?: Maybe<Scalars['String']['output']>;
  richAssetContent?: Maybe<Scalars['json']['output']>;
  richAssetContentMap?: Maybe<Scalars['jsonb']['output']>;
  richAssetType: Tenancy_Rich_Asset_Type_Enum_Ps_Enum;
  /** An object relationship */
  rich_asset_type_enum_p: Tenancy_Rich_Asset_Type_Enum_Ps;
  settings?: Maybe<Scalars['jsonb']['output']>;
  skillTag?: Maybe<Scalars['String']['output']>;
  solutionVersionId: Scalars['String']['output'];
  /** An object relationship */
  solution_versions_p: Tenancy_Solution_Versions_Ps;
  utterances?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<Array<Scalars['String']['output']>>;
  whatsNext?: Maybe<Array<Scalars['String']['output']>>;
};


/** columns and relationships of "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_PsAnalyticsEventArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_PsAnalyticsEventMapArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_PsParameterInputArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_PsParameterInputMapArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_PsRichAssetContentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_PsRichAssetContentMapArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_PsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Aggregate = {
  __typename?: 'tenancy_solution_version_nodes_ps_aggregate';
  aggregate?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Aggregate_Fields>;
  nodes: Array<Tenancy_Solution_Version_Nodes_Ps>;
};

export type Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_Solution_Version_Nodes_Ps_Select_Column_Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_Solution_Version_Nodes_Ps_Select_Column_Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Aggregate_Fields = {
  __typename?: 'tenancy_solution_version_nodes_ps_aggregate_fields';
  avg?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Max_Fields>;
  min?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Min_Fields>;
  stddev?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Stddev_Fields>;
  stddev_pop?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Stddev_Samp_Fields>;
  sum?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Sum_Fields>;
  var_pop?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Var_Pop_Fields>;
  var_samp?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Var_Samp_Fields>;
  variance?: Maybe<Tenancy_Solution_Version_Nodes_Ps_Variance_Fields>;
};


/** aggregate fields of "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Aggregate_Order_By = {
  avg?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Max_Order_By>;
  min?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Min_Order_By>;
  stddev?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Sum_Order_By>;
  var_pop?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Var_Samp_Order_By>;
  variance?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Solution_Version_Nodes_Ps_Append_Input = {
  analyticsEventMap?: InputMaybe<Scalars['jsonb']['input']>;
  parameterInputMap?: InputMaybe<Scalars['jsonb']['input']>;
  richAssetContentMap?: InputMaybe<Scalars['jsonb']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Solution_Version_Nodes_Ps_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_On_Conflict>;
};

/** aggregate avg on columns */
export type Tenancy_Solution_Version_Nodes_Ps_Avg_Fields = {
  __typename?: 'tenancy_solution_version_nodes_ps_avg_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Avg_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tenancy.solution_version_nodes_ps". All fields are combined with a logical 'AND'. */
export type Tenancy_Solution_Version_Nodes_Ps_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>>;
  analyticsEvent?: InputMaybe<Json_Comparison_Exp>;
  analyticsEventMap?: InputMaybe<Jsonb_Comparison_Exp>;
  answerRequired?: InputMaybe<Boolean_Comparison_Exp>;
  behaviors?: InputMaybe<String_Array_Comparison_Exp>;
  command?: InputMaybe<String_Comparison_Exp>;
  cssClassname?: InputMaybe<String_Comparison_Exp>;
  decisionVariable?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  intent?: InputMaybe<String_Comparison_Exp>;
  lastModified?: InputMaybe<Timestamp_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  nextNodes?: InputMaybe<Numeric_Array_Comparison_Exp>;
  nluDisabled?: InputMaybe<Boolean_Comparison_Exp>;
  nodeInput?: InputMaybe<String_Comparison_Exp>;
  nodeName?: InputMaybe<String_Comparison_Exp>;
  nodeNumber?: InputMaybe<Numeric_Comparison_Exp>;
  nodeTags?: InputMaybe<String_Comparison_Exp>;
  nodeType?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Enum_Comparison_Exp>;
  node_type_enum_p?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Bool_Exp>;
  order?: InputMaybe<Numeric_Comparison_Exp>;
  output?: InputMaybe<String_Array_Comparison_Exp>;
  parameterInput?: InputMaybe<Json_Comparison_Exp>;
  parameterInputMap?: InputMaybe<Jsonb_Comparison_Exp>;
  platformFlag?: InputMaybe<String_Comparison_Exp>;
  richAssetContent?: InputMaybe<Json_Comparison_Exp>;
  richAssetContentMap?: InputMaybe<Jsonb_Comparison_Exp>;
  richAssetType?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Enum_Comparison_Exp>;
  rich_asset_type_enum_p?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Bool_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  skillTag?: InputMaybe<String_Comparison_Exp>;
  solutionVersionId?: InputMaybe<String_Comparison_Exp>;
  solution_versions_p?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
  utterances?: InputMaybe<String_Comparison_Exp>;
  variables?: InputMaybe<String_Array_Comparison_Exp>;
  whatsNext?: InputMaybe<String_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.solution_version_nodes_ps" */
export enum Tenancy_Solution_Version_Nodes_Ps_Constraint {
  /** unique or primary key constraint on columns "id" */
  SolutionVersionNodesPsPkey = 'solution_version_nodes_ps_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Solution_Version_Nodes_Ps_Delete_At_Path_Input = {
  analyticsEventMap?: InputMaybe<Array<Scalars['String']['input']>>;
  parameterInputMap?: InputMaybe<Array<Scalars['String']['input']>>;
  richAssetContentMap?: InputMaybe<Array<Scalars['String']['input']>>;
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Solution_Version_Nodes_Ps_Delete_Elem_Input = {
  analyticsEventMap?: InputMaybe<Scalars['Int']['input']>;
  parameterInputMap?: InputMaybe<Scalars['Int']['input']>;
  richAssetContentMap?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Solution_Version_Nodes_Ps_Delete_Key_Input = {
  analyticsEventMap?: InputMaybe<Scalars['String']['input']>;
  parameterInputMap?: InputMaybe<Scalars['String']['input']>;
  richAssetContentMap?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Inc_Input = {
  nodeNumber?: InputMaybe<Scalars['numeric']['input']>;
  order?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Insert_Input = {
  analyticsEvent?: InputMaybe<Scalars['json']['input']>;
  analyticsEventMap?: InputMaybe<Scalars['jsonb']['input']>;
  answerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  behaviors?: InputMaybe<Array<Scalars['String']['input']>>;
  command?: InputMaybe<Scalars['String']['input']>;
  cssClassname?: InputMaybe<Scalars['String']['input']>;
  decisionVariable?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['timestamp']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  nextNodes?: InputMaybe<Array<Scalars['numeric']['input']>>;
  nluDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  nodeInput?: InputMaybe<Scalars['String']['input']>;
  nodeName?: InputMaybe<Scalars['String']['input']>;
  nodeNumber?: InputMaybe<Scalars['numeric']['input']>;
  nodeTags?: InputMaybe<Scalars['String']['input']>;
  nodeType?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Enum>;
  node_type_enum_p?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Obj_Rel_Insert_Input>;
  order?: InputMaybe<Scalars['numeric']['input']>;
  output?: InputMaybe<Array<Scalars['String']['input']>>;
  parameterInput?: InputMaybe<Scalars['json']['input']>;
  parameterInputMap?: InputMaybe<Scalars['jsonb']['input']>;
  platformFlag?: InputMaybe<Scalars['String']['input']>;
  richAssetContent?: InputMaybe<Scalars['json']['input']>;
  richAssetContentMap?: InputMaybe<Scalars['jsonb']['input']>;
  richAssetType?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Enum>;
  rich_asset_type_enum_p?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Obj_Rel_Insert_Input>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  skillTag?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  solution_versions_p?: InputMaybe<Tenancy_Solution_Versions_Ps_Obj_Rel_Insert_Input>;
  utterances?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Array<Scalars['String']['input']>>;
  whatsNext?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** aggregate max on columns */
export type Tenancy_Solution_Version_Nodes_Ps_Max_Fields = {
  __typename?: 'tenancy_solution_version_nodes_ps_max_fields';
  behaviors?: Maybe<Array<Scalars['String']['output']>>;
  command?: Maybe<Scalars['String']['output']>;
  cssClassname?: Maybe<Scalars['String']['output']>;
  decisionVariable?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  lastModified?: Maybe<Scalars['timestamp']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nextNodes?: Maybe<Array<Scalars['numeric']['output']>>;
  nodeInput?: Maybe<Scalars['String']['output']>;
  nodeName?: Maybe<Scalars['String']['output']>;
  nodeNumber?: Maybe<Scalars['numeric']['output']>;
  nodeTags?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['numeric']['output']>;
  output?: Maybe<Array<Scalars['String']['output']>>;
  platformFlag?: Maybe<Scalars['String']['output']>;
  skillTag?: Maybe<Scalars['String']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  utterances?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<Array<Scalars['String']['output']>>;
  whatsNext?: Maybe<Array<Scalars['String']['output']>>;
};

/** order by max() on columns of table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Max_Order_By = {
  behaviors?: InputMaybe<Order_By>;
  command?: InputMaybe<Order_By>;
  cssClassname?: InputMaybe<Order_By>;
  decisionVariable?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intent?: InputMaybe<Order_By>;
  lastModified?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  nextNodes?: InputMaybe<Order_By>;
  nodeInput?: InputMaybe<Order_By>;
  nodeName?: InputMaybe<Order_By>;
  nodeNumber?: InputMaybe<Order_By>;
  nodeTags?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  output?: InputMaybe<Order_By>;
  platformFlag?: InputMaybe<Order_By>;
  skillTag?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  utterances?: InputMaybe<Order_By>;
  variables?: InputMaybe<Order_By>;
  whatsNext?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Solution_Version_Nodes_Ps_Min_Fields = {
  __typename?: 'tenancy_solution_version_nodes_ps_min_fields';
  behaviors?: Maybe<Array<Scalars['String']['output']>>;
  command?: Maybe<Scalars['String']['output']>;
  cssClassname?: Maybe<Scalars['String']['output']>;
  decisionVariable?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  lastModified?: Maybe<Scalars['timestamp']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nextNodes?: Maybe<Array<Scalars['numeric']['output']>>;
  nodeInput?: Maybe<Scalars['String']['output']>;
  nodeName?: Maybe<Scalars['String']['output']>;
  nodeNumber?: Maybe<Scalars['numeric']['output']>;
  nodeTags?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['numeric']['output']>;
  output?: Maybe<Array<Scalars['String']['output']>>;
  platformFlag?: Maybe<Scalars['String']['output']>;
  skillTag?: Maybe<Scalars['String']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  utterances?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<Array<Scalars['String']['output']>>;
  whatsNext?: Maybe<Array<Scalars['String']['output']>>;
};

/** order by min() on columns of table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Min_Order_By = {
  behaviors?: InputMaybe<Order_By>;
  command?: InputMaybe<Order_By>;
  cssClassname?: InputMaybe<Order_By>;
  decisionVariable?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intent?: InputMaybe<Order_By>;
  lastModified?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  nextNodes?: InputMaybe<Order_By>;
  nodeInput?: InputMaybe<Order_By>;
  nodeName?: InputMaybe<Order_By>;
  nodeNumber?: InputMaybe<Order_By>;
  nodeTags?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  output?: InputMaybe<Order_By>;
  platformFlag?: InputMaybe<Order_By>;
  skillTag?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  utterances?: InputMaybe<Order_By>;
  variables?: InputMaybe<Order_By>;
  whatsNext?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Mutation_Response = {
  __typename?: 'tenancy_solution_version_nodes_ps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Solution_Version_Nodes_Ps>;
};

/** on_conflict condition type for table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_On_Conflict = {
  constraint: Tenancy_Solution_Version_Nodes_Ps_Constraint;
  update_columns?: Array<Tenancy_Solution_Version_Nodes_Ps_Update_Column>;
  where?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.solution_version_nodes_ps". */
export type Tenancy_Solution_Version_Nodes_Ps_Order_By = {
  analyticsEvent?: InputMaybe<Order_By>;
  analyticsEventMap?: InputMaybe<Order_By>;
  answerRequired?: InputMaybe<Order_By>;
  behaviors?: InputMaybe<Order_By>;
  command?: InputMaybe<Order_By>;
  cssClassname?: InputMaybe<Order_By>;
  decisionVariable?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intent?: InputMaybe<Order_By>;
  lastModified?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  nextNodes?: InputMaybe<Order_By>;
  nluDisabled?: InputMaybe<Order_By>;
  nodeInput?: InputMaybe<Order_By>;
  nodeName?: InputMaybe<Order_By>;
  nodeNumber?: InputMaybe<Order_By>;
  nodeTags?: InputMaybe<Order_By>;
  nodeType?: InputMaybe<Order_By>;
  node_type_enum_p?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Order_By>;
  order?: InputMaybe<Order_By>;
  output?: InputMaybe<Order_By>;
  parameterInput?: InputMaybe<Order_By>;
  parameterInputMap?: InputMaybe<Order_By>;
  platformFlag?: InputMaybe<Order_By>;
  richAssetContent?: InputMaybe<Order_By>;
  richAssetContentMap?: InputMaybe<Order_By>;
  richAssetType?: InputMaybe<Order_By>;
  rich_asset_type_enum_p?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Order_By>;
  settings?: InputMaybe<Order_By>;
  skillTag?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  solution_versions_p?: InputMaybe<Tenancy_Solution_Versions_Ps_Order_By>;
  utterances?: InputMaybe<Order_By>;
  variables?: InputMaybe<Order_By>;
  whatsNext?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.solution_version_nodes_ps */
export type Tenancy_Solution_Version_Nodes_Ps_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Solution_Version_Nodes_Ps_Prepend_Input = {
  analyticsEventMap?: InputMaybe<Scalars['jsonb']['input']>;
  parameterInputMap?: InputMaybe<Scalars['jsonb']['input']>;
  richAssetContentMap?: InputMaybe<Scalars['jsonb']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.solution_version_nodes_ps" */
export enum Tenancy_Solution_Version_Nodes_Ps_Select_Column {
  /** column name */
  AnalyticsEvent = 'analyticsEvent',
  /** column name */
  AnalyticsEventMap = 'analyticsEventMap',
  /** column name */
  AnswerRequired = 'answerRequired',
  /** column name */
  Behaviors = 'behaviors',
  /** column name */
  Command = 'command',
  /** column name */
  CssClassname = 'cssClassname',
  /** column name */
  DecisionVariable = 'decisionVariable',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Intent = 'intent',
  /** column name */
  LastModified = 'lastModified',
  /** column name */
  Message = 'message',
  /** column name */
  NextNodes = 'nextNodes',
  /** column name */
  NluDisabled = 'nluDisabled',
  /** column name */
  NodeInput = 'nodeInput',
  /** column name */
  NodeName = 'nodeName',
  /** column name */
  NodeNumber = 'nodeNumber',
  /** column name */
  NodeTags = 'nodeTags',
  /** column name */
  NodeType = 'nodeType',
  /** column name */
  Order = 'order',
  /** column name */
  Output = 'output',
  /** column name */
  ParameterInput = 'parameterInput',
  /** column name */
  ParameterInputMap = 'parameterInputMap',
  /** column name */
  PlatformFlag = 'platformFlag',
  /** column name */
  RichAssetContent = 'richAssetContent',
  /** column name */
  RichAssetContentMap = 'richAssetContentMap',
  /** column name */
  RichAssetType = 'richAssetType',
  /** column name */
  Settings = 'settings',
  /** column name */
  SkillTag = 'skillTag',
  /** column name */
  SolutionVersionId = 'solutionVersionId',
  /** column name */
  Utterances = 'utterances',
  /** column name */
  Variables = 'variables',
  /** column name */
  WhatsNext = 'whatsNext'
}

/** select "tenancy_solution_version_nodes_ps_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.solution_version_nodes_ps" */
export enum Tenancy_Solution_Version_Nodes_Ps_Select_Column_Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AnswerRequired = 'answerRequired',
  /** column name */
  NluDisabled = 'nluDisabled'
}

/** select "tenancy_solution_version_nodes_ps_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.solution_version_nodes_ps" */
export enum Tenancy_Solution_Version_Nodes_Ps_Select_Column_Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AnswerRequired = 'answerRequired',
  /** column name */
  NluDisabled = 'nluDisabled'
}

/** input type for updating data in table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Set_Input = {
  analyticsEvent?: InputMaybe<Scalars['json']['input']>;
  analyticsEventMap?: InputMaybe<Scalars['jsonb']['input']>;
  answerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  behaviors?: InputMaybe<Array<Scalars['String']['input']>>;
  command?: InputMaybe<Scalars['String']['input']>;
  cssClassname?: InputMaybe<Scalars['String']['input']>;
  decisionVariable?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['timestamp']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  nextNodes?: InputMaybe<Array<Scalars['numeric']['input']>>;
  nluDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  nodeInput?: InputMaybe<Scalars['String']['input']>;
  nodeName?: InputMaybe<Scalars['String']['input']>;
  nodeNumber?: InputMaybe<Scalars['numeric']['input']>;
  nodeTags?: InputMaybe<Scalars['String']['input']>;
  nodeType?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Enum>;
  order?: InputMaybe<Scalars['numeric']['input']>;
  output?: InputMaybe<Array<Scalars['String']['input']>>;
  parameterInput?: InputMaybe<Scalars['json']['input']>;
  parameterInputMap?: InputMaybe<Scalars['jsonb']['input']>;
  platformFlag?: InputMaybe<Scalars['String']['input']>;
  richAssetContent?: InputMaybe<Scalars['json']['input']>;
  richAssetContentMap?: InputMaybe<Scalars['jsonb']['input']>;
  richAssetType?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Enum>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  skillTag?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  utterances?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Array<Scalars['String']['input']>>;
  whatsNext?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** aggregate stddev on columns */
export type Tenancy_Solution_Version_Nodes_Ps_Stddev_Fields = {
  __typename?: 'tenancy_solution_version_nodes_ps_stddev_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Stddev_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tenancy_Solution_Version_Nodes_Ps_Stddev_Pop_Fields = {
  __typename?: 'tenancy_solution_version_nodes_ps_stddev_pop_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Stddev_Pop_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tenancy_Solution_Version_Nodes_Ps_Stddev_Samp_Fields = {
  __typename?: 'tenancy_solution_version_nodes_ps_stddev_samp_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Stddev_Samp_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tenancy_solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Solution_Version_Nodes_Ps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Solution_Version_Nodes_Ps_Stream_Cursor_Value_Input = {
  analyticsEvent?: InputMaybe<Scalars['json']['input']>;
  analyticsEventMap?: InputMaybe<Scalars['jsonb']['input']>;
  answerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  behaviors?: InputMaybe<Array<Scalars['String']['input']>>;
  command?: InputMaybe<Scalars['String']['input']>;
  cssClassname?: InputMaybe<Scalars['String']['input']>;
  decisionVariable?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['timestamp']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  nextNodes?: InputMaybe<Array<Scalars['numeric']['input']>>;
  nluDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  nodeInput?: InputMaybe<Scalars['String']['input']>;
  nodeName?: InputMaybe<Scalars['String']['input']>;
  nodeNumber?: InputMaybe<Scalars['numeric']['input']>;
  nodeTags?: InputMaybe<Scalars['String']['input']>;
  nodeType?: InputMaybe<Tenancy_Node_Type_Enum_Ps_Enum>;
  order?: InputMaybe<Scalars['numeric']['input']>;
  output?: InputMaybe<Array<Scalars['String']['input']>>;
  parameterInput?: InputMaybe<Scalars['json']['input']>;
  parameterInputMap?: InputMaybe<Scalars['jsonb']['input']>;
  platformFlag?: InputMaybe<Scalars['String']['input']>;
  richAssetContent?: InputMaybe<Scalars['json']['input']>;
  richAssetContentMap?: InputMaybe<Scalars['jsonb']['input']>;
  richAssetType?: InputMaybe<Tenancy_Rich_Asset_Type_Enum_Ps_Enum>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  skillTag?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  utterances?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Array<Scalars['String']['input']>>;
  whatsNext?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** aggregate sum on columns */
export type Tenancy_Solution_Version_Nodes_Ps_Sum_Fields = {
  __typename?: 'tenancy_solution_version_nodes_ps_sum_fields';
  nodeNumber?: Maybe<Scalars['numeric']['output']>;
  order?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Sum_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "tenancy.solution_version_nodes_ps" */
export enum Tenancy_Solution_Version_Nodes_Ps_Update_Column {
  /** column name */
  AnalyticsEvent = 'analyticsEvent',
  /** column name */
  AnalyticsEventMap = 'analyticsEventMap',
  /** column name */
  AnswerRequired = 'answerRequired',
  /** column name */
  Behaviors = 'behaviors',
  /** column name */
  Command = 'command',
  /** column name */
  CssClassname = 'cssClassname',
  /** column name */
  DecisionVariable = 'decisionVariable',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Intent = 'intent',
  /** column name */
  LastModified = 'lastModified',
  /** column name */
  Message = 'message',
  /** column name */
  NextNodes = 'nextNodes',
  /** column name */
  NluDisabled = 'nluDisabled',
  /** column name */
  NodeInput = 'nodeInput',
  /** column name */
  NodeName = 'nodeName',
  /** column name */
  NodeNumber = 'nodeNumber',
  /** column name */
  NodeTags = 'nodeTags',
  /** column name */
  NodeType = 'nodeType',
  /** column name */
  Order = 'order',
  /** column name */
  Output = 'output',
  /** column name */
  ParameterInput = 'parameterInput',
  /** column name */
  ParameterInputMap = 'parameterInputMap',
  /** column name */
  PlatformFlag = 'platformFlag',
  /** column name */
  RichAssetContent = 'richAssetContent',
  /** column name */
  RichAssetContentMap = 'richAssetContentMap',
  /** column name */
  RichAssetType = 'richAssetType',
  /** column name */
  Settings = 'settings',
  /** column name */
  SkillTag = 'skillTag',
  /** column name */
  SolutionVersionId = 'solutionVersionId',
  /** column name */
  Utterances = 'utterances',
  /** column name */
  Variables = 'variables',
  /** column name */
  WhatsNext = 'whatsNext'
}

export type Tenancy_Solution_Version_Nodes_Ps_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Solution_Version_Nodes_Ps_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tenancy_Solution_Version_Nodes_Ps_Var_Pop_Fields = {
  __typename?: 'tenancy_solution_version_nodes_ps_var_pop_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Var_Pop_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tenancy_Solution_Version_Nodes_Ps_Var_Samp_Fields = {
  __typename?: 'tenancy_solution_version_nodes_ps_var_samp_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Var_Samp_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tenancy_Solution_Version_Nodes_Ps_Variance_Fields = {
  __typename?: 'tenancy_solution_version_nodes_ps_variance_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tenancy.solution_version_nodes_ps" */
export type Tenancy_Solution_Version_Nodes_Ps_Variance_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_Versions = {
  __typename?: 'tenancy_solution_versions';
  /** An array relationship */
  action_node_jobs: Array<Tenancy_Action_Node_Job>;
  /** An aggregate relationship */
  action_node_jobs_aggregate: Tenancy_Action_Node_Job_Aggregate;
  botSolutionVersionId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  child_versions: Array<Tenancy_Solution_Versions>;
  /** An aggregate relationship */
  child_versions_aggregate: Tenancy_Solution_Versions_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  /** An array relationship */
  files: Array<Tenancy_File>;
  /** An aggregate relationship */
  files_aggregate: Tenancy_File_Aggregate;
  fullyIntegrated: Scalars['Boolean']['output'];
  hasGiteaIntegration: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isDraft: Scalars['Boolean']['output'];
  isFilesSynced: Scalars['Boolean']['output'];
  isNodesSynced: Scalars['Boolean']['output'];
  knowledgeAgentContext?: Maybe<Scalars['String']['output']>;
  llmCredentialId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  llm_credential?: Maybe<Tenancy_Llm_Credentials>;
  maxOutputTokens?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otherInformation?: Maybe<Scalars['String']['output']>;
  parentCommitSha?: Maybe<Scalars['String']['output']>;
  parentVersionId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  parent_version?: Maybe<Tenancy_Solution_Versions>;
  settings?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  solution: Tenancy_Solutions;
  solutionId: Scalars['String']['output'];
  /** An array relationship */
  solution_deployments: Array<Tenancy_Solution_Deployments>;
  /** An aggregate relationship */
  solution_deployments_aggregate: Tenancy_Solution_Deployments_Aggregate;
  /** An array relationship */
  solution_tasks: Array<Tenancy_Solution_Task>;
  /** An aggregate relationship */
  solution_tasks_aggregate: Tenancy_Solution_Task_Aggregate;
  /** An array relationship */
  solutions: Array<Tenancy_Solutions>;
  /** An array relationship */
  solutionsByDefaultdraftversionid: Array<Tenancy_Solutions>;
  /** An aggregate relationship */
  solutionsByDefaultdraftversionid_aggregate: Tenancy_Solutions_Aggregate;
  /** An array relationship */
  solutionsBySelectedversionid: Array<Tenancy_Solutions>;
  /** An aggregate relationship */
  solutionsBySelectedversionid_aggregate: Tenancy_Solutions_Aggregate;
  /** An aggregate relationship */
  solutions_aggregate: Tenancy_Solutions_Aggregate;
  status: Scalars['SolutionVersionStatus']['output'];
  supervisorName?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['float8']['output']>;
  tone?: Maybe<Scalars['String']['output']>;
  topK?: Maybe<Scalars['float8']['output']>;
  topP?: Maybe<Scalars['float8']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsAction_Node_JobsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Node_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Node_Job_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsAction_Node_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Node_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Node_Job_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsChild_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsChild_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsFilesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsSolution_DeploymentsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployments_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsSolution_Deployments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployments_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsSolution_TasksArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Task_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Task_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsSolution_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Task_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Task_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsSolutionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solutions_Order_By>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsSolutionsByDefaultdraftversionidArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solutions_Order_By>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsSolutionsByDefaultdraftversionid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solutions_Order_By>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsSolutionsBySelectedversionidArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solutions_Order_By>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsSolutionsBySelectedversionid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solutions_Order_By>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions" */
export type Tenancy_Solution_VersionsSolutions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solutions_Order_By>>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};

/** aggregated selection of "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Aggregate = {
  __typename?: 'tenancy_solution_versions_aggregate';
  aggregate?: Maybe<Tenancy_Solution_Versions_Aggregate_Fields>;
  nodes: Array<Tenancy_Solution_Versions>;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp_Var_Samp>;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Avg = {
  arguments: Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Corr = {
  arguments: Tenancy_Solution_Versions_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Solution_Versions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Tenancy_Solution_Versions_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Max = {
  arguments: Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Min = {
  arguments: Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Sum = {
  arguments: Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tenancy_Solution_Versions_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Aggregate_Fields = {
  __typename?: 'tenancy_solution_versions_aggregate_fields';
  avg?: Maybe<Tenancy_Solution_Versions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Solution_Versions_Max_Fields>;
  min?: Maybe<Tenancy_Solution_Versions_Min_Fields>;
  stddev?: Maybe<Tenancy_Solution_Versions_Stddev_Fields>;
  stddev_pop?: Maybe<Tenancy_Solution_Versions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenancy_Solution_Versions_Stddev_Samp_Fields>;
  sum?: Maybe<Tenancy_Solution_Versions_Sum_Fields>;
  var_pop?: Maybe<Tenancy_Solution_Versions_Var_Pop_Fields>;
  var_samp?: Maybe<Tenancy_Solution_Versions_Var_Samp_Fields>;
  variance?: Maybe<Tenancy_Solution_Versions_Variance_Fields>;
};


/** aggregate fields of "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Solution_Versions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Aggregate_Order_By = {
  avg?: InputMaybe<Tenancy_Solution_Versions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Solution_Versions_Max_Order_By>;
  min?: InputMaybe<Tenancy_Solution_Versions_Min_Order_By>;
  stddev?: InputMaybe<Tenancy_Solution_Versions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tenancy_Solution_Versions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tenancy_Solution_Versions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tenancy_Solution_Versions_Sum_Order_By>;
  var_pop?: InputMaybe<Tenancy_Solution_Versions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tenancy_Solution_Versions_Var_Samp_Order_By>;
  variance?: InputMaybe<Tenancy_Solution_Versions_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Solution_Versions_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Solution_Versions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solution_Versions_On_Conflict>;
};

/** aggregate avg on columns */
export type Tenancy_Solution_Versions_Avg_Fields = {
  __typename?: 'tenancy_solution_versions_avg_fields';
  maxOutputTokens?: Maybe<Scalars['Float']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  topK?: Maybe<Scalars['Float']['output']>;
  topP?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Avg_Order_By = {
  maxOutputTokens?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  topK?: InputMaybe<Order_By>;
  topP?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tenancy.solution_versions". All fields are combined with a logical 'AND'. */
export type Tenancy_Solution_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Solution_Versions_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Solution_Versions_Bool_Exp>>;
  action_node_jobs?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
  action_node_jobs_aggregate?: InputMaybe<Tenancy_Action_Node_Job_Aggregate_Bool_Exp>;
  botSolutionVersionId?: InputMaybe<String_Comparison_Exp>;
  brandName?: InputMaybe<String_Comparison_Exp>;
  child_versions?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  child_versions_aggregate?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  files?: InputMaybe<Tenancy_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Tenancy_File_Aggregate_Bool_Exp>;
  fullyIntegrated?: InputMaybe<Boolean_Comparison_Exp>;
  hasGiteaIntegration?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isDraft?: InputMaybe<Boolean_Comparison_Exp>;
  isFilesSynced?: InputMaybe<Boolean_Comparison_Exp>;
  isNodesSynced?: InputMaybe<Boolean_Comparison_Exp>;
  knowledgeAgentContext?: InputMaybe<String_Comparison_Exp>;
  llmCredentialId?: InputMaybe<String_Comparison_Exp>;
  llm_credential?: InputMaybe<Tenancy_Llm_Credentials_Bool_Exp>;
  maxOutputTokens?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  otherInformation?: InputMaybe<String_Comparison_Exp>;
  parentCommitSha?: InputMaybe<String_Comparison_Exp>;
  parentVersionId?: InputMaybe<String_Comparison_Exp>;
  parent_version?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  solution?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
  solutionId?: InputMaybe<String_Comparison_Exp>;
  solution_deployments?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
  solution_deployments_aggregate?: InputMaybe<Tenancy_Solution_Deployments_Aggregate_Bool_Exp>;
  solution_tasks?: InputMaybe<Tenancy_Solution_Task_Bool_Exp>;
  solution_tasks_aggregate?: InputMaybe<Tenancy_Solution_Task_Aggregate_Bool_Exp>;
  solutions?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
  solutionsByDefaultdraftversionid?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
  solutionsByDefaultdraftversionid_aggregate?: InputMaybe<Tenancy_Solutions_Aggregate_Bool_Exp>;
  solutionsBySelectedversionid?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
  solutionsBySelectedversionid_aggregate?: InputMaybe<Tenancy_Solutions_Aggregate_Bool_Exp>;
  solutions_aggregate?: InputMaybe<Tenancy_Solutions_Aggregate_Bool_Exp>;
  status?: InputMaybe<SolutionVersionStatus_Comparison_Exp>;
  supervisorName?: InputMaybe<String_Comparison_Exp>;
  temperature?: InputMaybe<Float8_Comparison_Exp>;
  tone?: InputMaybe<String_Comparison_Exp>;
  topK?: InputMaybe<Float8_Comparison_Exp>;
  topP?: InputMaybe<Float8_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Constraint {
  /** unique or primary key constraint on columns "id" */
  SolutionVersionsPkey = 'solution_versions_pkey',
  /** unique or primary key constraint on columns "botSolutionVersionId", "solutionId" */
  SolutionVersionsSolutionIdBotSolutionVersionIdKey = 'solution_versions_solutionId_botSolutionVersionId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Solution_Versions_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Solution_Versions_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Solution_Versions_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Inc_Input = {
  maxOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  temperature?: InputMaybe<Scalars['float8']['input']>;
  topK?: InputMaybe<Scalars['float8']['input']>;
  topP?: InputMaybe<Scalars['float8']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Insert_Input = {
  action_node_jobs?: InputMaybe<Tenancy_Action_Node_Job_Arr_Rel_Insert_Input>;
  botSolutionVersionId?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  child_versions?: InputMaybe<Tenancy_Solution_Versions_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  files?: InputMaybe<Tenancy_File_Arr_Rel_Insert_Input>;
  fullyIntegrated?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiteaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesSynced?: InputMaybe<Scalars['Boolean']['input']>;
  isNodesSynced?: InputMaybe<Scalars['Boolean']['input']>;
  knowledgeAgentContext?: InputMaybe<Scalars['String']['input']>;
  llmCredentialId?: InputMaybe<Scalars['String']['input']>;
  llm_credential?: InputMaybe<Tenancy_Llm_Credentials_Obj_Rel_Insert_Input>;
  maxOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherInformation?: InputMaybe<Scalars['String']['input']>;
  parentCommitSha?: InputMaybe<Scalars['String']['input']>;
  parentVersionId?: InputMaybe<Scalars['String']['input']>;
  parent_version?: InputMaybe<Tenancy_Solution_Versions_Obj_Rel_Insert_Input>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  solution?: InputMaybe<Tenancy_Solutions_Obj_Rel_Insert_Input>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  solution_deployments?: InputMaybe<Tenancy_Solution_Deployments_Arr_Rel_Insert_Input>;
  solution_tasks?: InputMaybe<Tenancy_Solution_Task_Arr_Rel_Insert_Input>;
  solutions?: InputMaybe<Tenancy_Solutions_Arr_Rel_Insert_Input>;
  solutionsByDefaultdraftversionid?: InputMaybe<Tenancy_Solutions_Arr_Rel_Insert_Input>;
  solutionsBySelectedversionid?: InputMaybe<Tenancy_Solutions_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['SolutionVersionStatus']['input']>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['float8']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
  topK?: InputMaybe<Scalars['float8']['input']>;
  topP?: InputMaybe<Scalars['float8']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Solution_Versions_Max_Fields = {
  __typename?: 'tenancy_solution_versions_max_fields';
  botSolutionVersionId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  knowledgeAgentContext?: Maybe<Scalars['String']['output']>;
  llmCredentialId?: Maybe<Scalars['String']['output']>;
  maxOutputTokens?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otherInformation?: Maybe<Scalars['String']['output']>;
  parentCommitSha?: Maybe<Scalars['String']['output']>;
  parentVersionId?: Maybe<Scalars['String']['output']>;
  solutionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['SolutionVersionStatus']['output']>;
  supervisorName?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['float8']['output']>;
  tone?: Maybe<Scalars['String']['output']>;
  topK?: Maybe<Scalars['float8']['output']>;
  topP?: Maybe<Scalars['float8']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Max_Order_By = {
  botSolutionVersionId?: InputMaybe<Order_By>;
  brandName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  knowledgeAgentContext?: InputMaybe<Order_By>;
  llmCredentialId?: InputMaybe<Order_By>;
  maxOutputTokens?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  otherInformation?: InputMaybe<Order_By>;
  parentCommitSha?: InputMaybe<Order_By>;
  parentVersionId?: InputMaybe<Order_By>;
  solutionId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supervisorName?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  tone?: InputMaybe<Order_By>;
  topK?: InputMaybe<Order_By>;
  topP?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Solution_Versions_Min_Fields = {
  __typename?: 'tenancy_solution_versions_min_fields';
  botSolutionVersionId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  knowledgeAgentContext?: Maybe<Scalars['String']['output']>;
  llmCredentialId?: Maybe<Scalars['String']['output']>;
  maxOutputTokens?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otherInformation?: Maybe<Scalars['String']['output']>;
  parentCommitSha?: Maybe<Scalars['String']['output']>;
  parentVersionId?: Maybe<Scalars['String']['output']>;
  solutionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['SolutionVersionStatus']['output']>;
  supervisorName?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['float8']['output']>;
  tone?: Maybe<Scalars['String']['output']>;
  topK?: Maybe<Scalars['float8']['output']>;
  topP?: Maybe<Scalars['float8']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Min_Order_By = {
  botSolutionVersionId?: InputMaybe<Order_By>;
  brandName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  knowledgeAgentContext?: InputMaybe<Order_By>;
  llmCredentialId?: InputMaybe<Order_By>;
  maxOutputTokens?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  otherInformation?: InputMaybe<Order_By>;
  parentCommitSha?: InputMaybe<Order_By>;
  parentVersionId?: InputMaybe<Order_By>;
  solutionId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supervisorName?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  tone?: InputMaybe<Order_By>;
  topK?: InputMaybe<Order_By>;
  topP?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Mutation_Response = {
  __typename?: 'tenancy_solution_versions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Solution_Versions>;
};

/** input type for inserting object relation for remote table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Obj_Rel_Insert_Input = {
  data: Tenancy_Solution_Versions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solution_Versions_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_On_Conflict = {
  constraint: Tenancy_Solution_Versions_Constraint;
  update_columns?: Array<Tenancy_Solution_Versions_Update_Column>;
  where?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.solution_versions". */
export type Tenancy_Solution_Versions_Order_By = {
  action_node_jobs_aggregate?: InputMaybe<Tenancy_Action_Node_Job_Aggregate_Order_By>;
  botSolutionVersionId?: InputMaybe<Order_By>;
  brandName?: InputMaybe<Order_By>;
  child_versions_aggregate?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Tenancy_File_Aggregate_Order_By>;
  fullyIntegrated?: InputMaybe<Order_By>;
  hasGiteaIntegration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDraft?: InputMaybe<Order_By>;
  isFilesSynced?: InputMaybe<Order_By>;
  isNodesSynced?: InputMaybe<Order_By>;
  knowledgeAgentContext?: InputMaybe<Order_By>;
  llmCredentialId?: InputMaybe<Order_By>;
  llm_credential?: InputMaybe<Tenancy_Llm_Credentials_Order_By>;
  maxOutputTokens?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  otherInformation?: InputMaybe<Order_By>;
  parentCommitSha?: InputMaybe<Order_By>;
  parentVersionId?: InputMaybe<Order_By>;
  parent_version?: InputMaybe<Tenancy_Solution_Versions_Order_By>;
  settings?: InputMaybe<Order_By>;
  solution?: InputMaybe<Tenancy_Solutions_Order_By>;
  solutionId?: InputMaybe<Order_By>;
  solution_deployments_aggregate?: InputMaybe<Tenancy_Solution_Deployments_Aggregate_Order_By>;
  solution_tasks_aggregate?: InputMaybe<Tenancy_Solution_Task_Aggregate_Order_By>;
  solutionsByDefaultdraftversionid_aggregate?: InputMaybe<Tenancy_Solutions_Aggregate_Order_By>;
  solutionsBySelectedversionid_aggregate?: InputMaybe<Tenancy_Solutions_Aggregate_Order_By>;
  solutions_aggregate?: InputMaybe<Tenancy_Solutions_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  supervisorName?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  tone?: InputMaybe<Order_By>;
  topK?: InputMaybe<Order_By>;
  topP?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.solution_versions */
export type Tenancy_Solution_Versions_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Solution_Versions_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps = {
  __typename?: 'tenancy_solution_versions_ps';
  columnPinningSettings?: Maybe<Scalars['jsonb']['output']>;
  columnWidths?: Maybe<Scalars['jsonb']['output']>;
  columnWrapSettings?: Maybe<Scalars['jsonb']['output']>;
  createdAt: Scalars['timestamp']['output'];
  isUsingUpdatedId: Scalars['Boolean']['output'];
  lastServerSync?: Maybe<Scalars['timestamp']['output']>;
  lastServerSyncError?: Maybe<Array<Scalars['String']['output']>>;
  lastServerSyncHash?: Maybe<Scalars['Int']['output']>;
  lastServerValidation?: Maybe<Scalars['timestamp']['output']>;
  lastServerValidationHash?: Maybe<Scalars['Int']['output']>;
  lastServerValidationMessages?: Maybe<Array<Scalars['String']['output']>>;
  projectProStudioSettingId: Scalars['String']['output'];
  /** An object relationship */
  project_pro_studio_setting: Tenancy_Project_Pro_Studio_Setting;
  settings?: Maybe<Scalars['jsonb']['output']>;
  solutionVersionId: Scalars['String']['output'];
  /** An array relationship */
  solution_version_nodes_ps: Array<Tenancy_Solution_Version_Nodes_Ps>;
  /** An aggregate relationship */
  solution_version_nodes_ps_aggregate: Tenancy_Solution_Version_Nodes_Ps_Aggregate;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  versionId?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_PsColumnPinningSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_PsColumnWidthsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_PsColumnWrapSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_PsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_PsSolution_Version_Nodes_PsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
};


/** columns and relationships of "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_PsSolution_Version_Nodes_Ps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Version_Nodes_Ps_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
};

/** aggregated selection of "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Aggregate = {
  __typename?: 'tenancy_solution_versions_ps_aggregate';
  aggregate?: Maybe<Tenancy_Solution_Versions_Ps_Aggregate_Fields>;
  nodes: Array<Tenancy_Solution_Versions_Ps>;
};

export type Tenancy_Solution_Versions_Ps_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_Solution_Versions_Ps_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_Solution_Versions_Ps_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_Solution_Versions_Ps_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Solution_Versions_Ps_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_Solution_Versions_Ps_Select_Column_Tenancy_Solution_Versions_Ps_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solution_Versions_Ps_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_Solution_Versions_Ps_Select_Column_Tenancy_Solution_Versions_Ps_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solution_Versions_Ps_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Aggregate_Fields = {
  __typename?: 'tenancy_solution_versions_ps_aggregate_fields';
  avg?: Maybe<Tenancy_Solution_Versions_Ps_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Solution_Versions_Ps_Max_Fields>;
  min?: Maybe<Tenancy_Solution_Versions_Ps_Min_Fields>;
  stddev?: Maybe<Tenancy_Solution_Versions_Ps_Stddev_Fields>;
  stddev_pop?: Maybe<Tenancy_Solution_Versions_Ps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenancy_Solution_Versions_Ps_Stddev_Samp_Fields>;
  sum?: Maybe<Tenancy_Solution_Versions_Ps_Sum_Fields>;
  var_pop?: Maybe<Tenancy_Solution_Versions_Ps_Var_Pop_Fields>;
  var_samp?: Maybe<Tenancy_Solution_Versions_Ps_Var_Samp_Fields>;
  variance?: Maybe<Tenancy_Solution_Versions_Ps_Variance_Fields>;
};


/** aggregate fields of "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Aggregate_Order_By = {
  avg?: InputMaybe<Tenancy_Solution_Versions_Ps_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Solution_Versions_Ps_Max_Order_By>;
  min?: InputMaybe<Tenancy_Solution_Versions_Ps_Min_Order_By>;
  stddev?: InputMaybe<Tenancy_Solution_Versions_Ps_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tenancy_Solution_Versions_Ps_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tenancy_Solution_Versions_Ps_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tenancy_Solution_Versions_Ps_Sum_Order_By>;
  var_pop?: InputMaybe<Tenancy_Solution_Versions_Ps_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tenancy_Solution_Versions_Ps_Var_Samp_Order_By>;
  variance?: InputMaybe<Tenancy_Solution_Versions_Ps_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Solution_Versions_Ps_Append_Input = {
  columnPinningSettings?: InputMaybe<Scalars['jsonb']['input']>;
  columnWidths?: InputMaybe<Scalars['jsonb']['input']>;
  columnWrapSettings?: InputMaybe<Scalars['jsonb']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Solution_Versions_Ps_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solution_Versions_Ps_On_Conflict>;
};

/** aggregate avg on columns */
export type Tenancy_Solution_Versions_Ps_Avg_Fields = {
  __typename?: 'tenancy_solution_versions_ps_avg_fields';
  lastServerSyncHash?: Maybe<Scalars['Float']['output']>;
  lastServerValidationHash?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Avg_Order_By = {
  lastServerSyncHash?: InputMaybe<Order_By>;
  lastServerValidationHash?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tenancy.solution_versions_ps". All fields are combined with a logical 'AND'. */
export type Tenancy_Solution_Versions_Ps_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Solution_Versions_Ps_Bool_Exp>>;
  columnPinningSettings?: InputMaybe<Jsonb_Comparison_Exp>;
  columnWidths?: InputMaybe<Jsonb_Comparison_Exp>;
  columnWrapSettings?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  isUsingUpdatedId?: InputMaybe<Boolean_Comparison_Exp>;
  lastServerSync?: InputMaybe<Timestamp_Comparison_Exp>;
  lastServerSyncError?: InputMaybe<String_Array_Comparison_Exp>;
  lastServerSyncHash?: InputMaybe<Int_Comparison_Exp>;
  lastServerValidation?: InputMaybe<Timestamp_Comparison_Exp>;
  lastServerValidationHash?: InputMaybe<Int_Comparison_Exp>;
  lastServerValidationMessages?: InputMaybe<String_Array_Comparison_Exp>;
  projectProStudioSettingId?: InputMaybe<String_Comparison_Exp>;
  project_pro_studio_setting?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  solutionVersionId?: InputMaybe<String_Comparison_Exp>;
  solution_version_nodes_ps?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Bool_Exp>;
  solution_version_nodes_ps_aggregate?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  versionId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.solution_versions_ps" */
export enum Tenancy_Solution_Versions_Ps_Constraint {
  /** unique or primary key constraint on columns "solutionVersionId" */
  SolutionVersionsPsPkey = 'solution_versions_ps_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Solution_Versions_Ps_Delete_At_Path_Input = {
  columnPinningSettings?: InputMaybe<Array<Scalars['String']['input']>>;
  columnWidths?: InputMaybe<Array<Scalars['String']['input']>>;
  columnWrapSettings?: InputMaybe<Array<Scalars['String']['input']>>;
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Solution_Versions_Ps_Delete_Elem_Input = {
  columnPinningSettings?: InputMaybe<Scalars['Int']['input']>;
  columnWidths?: InputMaybe<Scalars['Int']['input']>;
  columnWrapSettings?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Solution_Versions_Ps_Delete_Key_Input = {
  columnPinningSettings?: InputMaybe<Scalars['String']['input']>;
  columnWidths?: InputMaybe<Scalars['String']['input']>;
  columnWrapSettings?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Inc_Input = {
  lastServerSyncHash?: InputMaybe<Scalars['Int']['input']>;
  lastServerValidationHash?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Insert_Input = {
  columnPinningSettings?: InputMaybe<Scalars['jsonb']['input']>;
  columnWidths?: InputMaybe<Scalars['jsonb']['input']>;
  columnWrapSettings?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  isUsingUpdatedId?: InputMaybe<Scalars['Boolean']['input']>;
  lastServerSync?: InputMaybe<Scalars['timestamp']['input']>;
  lastServerSyncError?: InputMaybe<Array<Scalars['String']['input']>>;
  lastServerSyncHash?: InputMaybe<Scalars['Int']['input']>;
  lastServerValidation?: InputMaybe<Scalars['timestamp']['input']>;
  lastServerValidationHash?: InputMaybe<Scalars['Int']['input']>;
  lastServerValidationMessages?: InputMaybe<Array<Scalars['String']['input']>>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
  project_pro_studio_setting?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Obj_Rel_Insert_Input>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  solution_version_nodes_ps?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Solution_Versions_Ps_Max_Fields = {
  __typename?: 'tenancy_solution_versions_ps_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  lastServerSync?: Maybe<Scalars['timestamp']['output']>;
  lastServerSyncError?: Maybe<Array<Scalars['String']['output']>>;
  lastServerSyncHash?: Maybe<Scalars['Int']['output']>;
  lastServerValidation?: Maybe<Scalars['timestamp']['output']>;
  lastServerValidationHash?: Maybe<Scalars['Int']['output']>;
  lastServerValidationMessages?: Maybe<Array<Scalars['String']['output']>>;
  projectProStudioSettingId?: Maybe<Scalars['String']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  versionId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastServerSync?: InputMaybe<Order_By>;
  lastServerSyncError?: InputMaybe<Order_By>;
  lastServerSyncHash?: InputMaybe<Order_By>;
  lastServerValidation?: InputMaybe<Order_By>;
  lastServerValidationHash?: InputMaybe<Order_By>;
  lastServerValidationMessages?: InputMaybe<Order_By>;
  projectProStudioSettingId?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  versionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Solution_Versions_Ps_Min_Fields = {
  __typename?: 'tenancy_solution_versions_ps_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  lastServerSync?: Maybe<Scalars['timestamp']['output']>;
  lastServerSyncError?: Maybe<Array<Scalars['String']['output']>>;
  lastServerSyncHash?: Maybe<Scalars['Int']['output']>;
  lastServerValidation?: Maybe<Scalars['timestamp']['output']>;
  lastServerValidationHash?: Maybe<Scalars['Int']['output']>;
  lastServerValidationMessages?: Maybe<Array<Scalars['String']['output']>>;
  projectProStudioSettingId?: Maybe<Scalars['String']['output']>;
  solutionVersionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  versionId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastServerSync?: InputMaybe<Order_By>;
  lastServerSyncError?: InputMaybe<Order_By>;
  lastServerSyncHash?: InputMaybe<Order_By>;
  lastServerValidation?: InputMaybe<Order_By>;
  lastServerValidationHash?: InputMaybe<Order_By>;
  lastServerValidationMessages?: InputMaybe<Order_By>;
  projectProStudioSettingId?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  versionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Mutation_Response = {
  __typename?: 'tenancy_solution_versions_ps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Solution_Versions_Ps>;
};

/** input type for inserting object relation for remote table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Obj_Rel_Insert_Input = {
  data: Tenancy_Solution_Versions_Ps_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solution_Versions_Ps_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_On_Conflict = {
  constraint: Tenancy_Solution_Versions_Ps_Constraint;
  update_columns?: Array<Tenancy_Solution_Versions_Ps_Update_Column>;
  where?: InputMaybe<Tenancy_Solution_Versions_Ps_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.solution_versions_ps". */
export type Tenancy_Solution_Versions_Ps_Order_By = {
  columnPinningSettings?: InputMaybe<Order_By>;
  columnWidths?: InputMaybe<Order_By>;
  columnWrapSettings?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  isUsingUpdatedId?: InputMaybe<Order_By>;
  lastServerSync?: InputMaybe<Order_By>;
  lastServerSyncError?: InputMaybe<Order_By>;
  lastServerSyncHash?: InputMaybe<Order_By>;
  lastServerValidation?: InputMaybe<Order_By>;
  lastServerValidationHash?: InputMaybe<Order_By>;
  lastServerValidationMessages?: InputMaybe<Order_By>;
  projectProStudioSettingId?: InputMaybe<Order_By>;
  project_pro_studio_setting?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Order_By>;
  settings?: InputMaybe<Order_By>;
  solutionVersionId?: InputMaybe<Order_By>;
  solution_version_nodes_ps_aggregate?: InputMaybe<Tenancy_Solution_Version_Nodes_Ps_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  versionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.solution_versions_ps */
export type Tenancy_Solution_Versions_Ps_Pk_Columns_Input = {
  solutionVersionId: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Solution_Versions_Ps_Prepend_Input = {
  columnPinningSettings?: InputMaybe<Scalars['jsonb']['input']>;
  columnWidths?: InputMaybe<Scalars['jsonb']['input']>;
  columnWrapSettings?: InputMaybe<Scalars['jsonb']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.solution_versions_ps" */
export enum Tenancy_Solution_Versions_Ps_Select_Column {
  /** column name */
  ColumnPinningSettings = 'columnPinningSettings',
  /** column name */
  ColumnWidths = 'columnWidths',
  /** column name */
  ColumnWrapSettings = 'columnWrapSettings',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  IsUsingUpdatedId = 'isUsingUpdatedId',
  /** column name */
  LastServerSync = 'lastServerSync',
  /** column name */
  LastServerSyncError = 'lastServerSyncError',
  /** column name */
  LastServerSyncHash = 'lastServerSyncHash',
  /** column name */
  LastServerValidation = 'lastServerValidation',
  /** column name */
  LastServerValidationHash = 'lastServerValidationHash',
  /** column name */
  LastServerValidationMessages = 'lastServerValidationMessages',
  /** column name */
  ProjectProStudioSettingId = 'projectProStudioSettingId',
  /** column name */
  Settings = 'settings',
  /** column name */
  SolutionVersionId = 'solutionVersionId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VersionId = 'versionId'
}

/** select "tenancy_solution_versions_ps_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.solution_versions_ps" */
export enum Tenancy_Solution_Versions_Ps_Select_Column_Tenancy_Solution_Versions_Ps_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsUsingUpdatedId = 'isUsingUpdatedId'
}

/** select "tenancy_solution_versions_ps_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.solution_versions_ps" */
export enum Tenancy_Solution_Versions_Ps_Select_Column_Tenancy_Solution_Versions_Ps_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsUsingUpdatedId = 'isUsingUpdatedId'
}

/** input type for updating data in table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Set_Input = {
  columnPinningSettings?: InputMaybe<Scalars['jsonb']['input']>;
  columnWidths?: InputMaybe<Scalars['jsonb']['input']>;
  columnWrapSettings?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  isUsingUpdatedId?: InputMaybe<Scalars['Boolean']['input']>;
  lastServerSync?: InputMaybe<Scalars['timestamp']['input']>;
  lastServerSyncError?: InputMaybe<Array<Scalars['String']['input']>>;
  lastServerSyncHash?: InputMaybe<Scalars['Int']['input']>;
  lastServerValidation?: InputMaybe<Scalars['timestamp']['input']>;
  lastServerValidationHash?: InputMaybe<Scalars['Int']['input']>;
  lastServerValidationMessages?: InputMaybe<Array<Scalars['String']['input']>>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Tenancy_Solution_Versions_Ps_Stddev_Fields = {
  __typename?: 'tenancy_solution_versions_ps_stddev_fields';
  lastServerSyncHash?: Maybe<Scalars['Float']['output']>;
  lastServerValidationHash?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Stddev_Order_By = {
  lastServerSyncHash?: InputMaybe<Order_By>;
  lastServerValidationHash?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tenancy_Solution_Versions_Ps_Stddev_Pop_Fields = {
  __typename?: 'tenancy_solution_versions_ps_stddev_pop_fields';
  lastServerSyncHash?: Maybe<Scalars['Float']['output']>;
  lastServerValidationHash?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Stddev_Pop_Order_By = {
  lastServerSyncHash?: InputMaybe<Order_By>;
  lastServerValidationHash?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tenancy_Solution_Versions_Ps_Stddev_Samp_Fields = {
  __typename?: 'tenancy_solution_versions_ps_stddev_samp_fields';
  lastServerSyncHash?: Maybe<Scalars['Float']['output']>;
  lastServerValidationHash?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Stddev_Samp_Order_By = {
  lastServerSyncHash?: InputMaybe<Order_By>;
  lastServerValidationHash?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tenancy_solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Solution_Versions_Ps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Solution_Versions_Ps_Stream_Cursor_Value_Input = {
  columnPinningSettings?: InputMaybe<Scalars['jsonb']['input']>;
  columnWidths?: InputMaybe<Scalars['jsonb']['input']>;
  columnWrapSettings?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  isUsingUpdatedId?: InputMaybe<Scalars['Boolean']['input']>;
  lastServerSync?: InputMaybe<Scalars['timestamp']['input']>;
  lastServerSyncError?: InputMaybe<Array<Scalars['String']['input']>>;
  lastServerSyncHash?: InputMaybe<Scalars['Int']['input']>;
  lastServerValidation?: InputMaybe<Scalars['timestamp']['input']>;
  lastServerValidationHash?: InputMaybe<Scalars['Int']['input']>;
  lastServerValidationMessages?: InputMaybe<Array<Scalars['String']['input']>>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Tenancy_Solution_Versions_Ps_Sum_Fields = {
  __typename?: 'tenancy_solution_versions_ps_sum_fields';
  lastServerSyncHash?: Maybe<Scalars['Int']['output']>;
  lastServerValidationHash?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Sum_Order_By = {
  lastServerSyncHash?: InputMaybe<Order_By>;
  lastServerValidationHash?: InputMaybe<Order_By>;
};

/** update columns of table "tenancy.solution_versions_ps" */
export enum Tenancy_Solution_Versions_Ps_Update_Column {
  /** column name */
  ColumnPinningSettings = 'columnPinningSettings',
  /** column name */
  ColumnWidths = 'columnWidths',
  /** column name */
  ColumnWrapSettings = 'columnWrapSettings',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  IsUsingUpdatedId = 'isUsingUpdatedId',
  /** column name */
  LastServerSync = 'lastServerSync',
  /** column name */
  LastServerSyncError = 'lastServerSyncError',
  /** column name */
  LastServerSyncHash = 'lastServerSyncHash',
  /** column name */
  LastServerValidation = 'lastServerValidation',
  /** column name */
  LastServerValidationHash = 'lastServerValidationHash',
  /** column name */
  LastServerValidationMessages = 'lastServerValidationMessages',
  /** column name */
  ProjectProStudioSettingId = 'projectProStudioSettingId',
  /** column name */
  Settings = 'settings',
  /** column name */
  SolutionVersionId = 'solutionVersionId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VersionId = 'versionId'
}

export type Tenancy_Solution_Versions_Ps_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Solution_Versions_Ps_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Solution_Versions_Ps_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Solution_Versions_Ps_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Solution_Versions_Ps_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenancy_Solution_Versions_Ps_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Solution_Versions_Ps_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Solution_Versions_Ps_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Solution_Versions_Ps_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tenancy_Solution_Versions_Ps_Var_Pop_Fields = {
  __typename?: 'tenancy_solution_versions_ps_var_pop_fields';
  lastServerSyncHash?: Maybe<Scalars['Float']['output']>;
  lastServerValidationHash?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Var_Pop_Order_By = {
  lastServerSyncHash?: InputMaybe<Order_By>;
  lastServerValidationHash?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tenancy_Solution_Versions_Ps_Var_Samp_Fields = {
  __typename?: 'tenancy_solution_versions_ps_var_samp_fields';
  lastServerSyncHash?: Maybe<Scalars['Float']['output']>;
  lastServerValidationHash?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Var_Samp_Order_By = {
  lastServerSyncHash?: InputMaybe<Order_By>;
  lastServerValidationHash?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tenancy_Solution_Versions_Ps_Variance_Fields = {
  __typename?: 'tenancy_solution_versions_ps_variance_fields';
  lastServerSyncHash?: Maybe<Scalars['Float']['output']>;
  lastServerValidationHash?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tenancy.solution_versions_ps" */
export type Tenancy_Solution_Versions_Ps_Variance_Order_By = {
  lastServerSyncHash?: InputMaybe<Order_By>;
  lastServerValidationHash?: InputMaybe<Order_By>;
};

/** select columns of table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Select_Column {
  /** column name */
  BotSolutionVersionId = 'botSolutionVersionId',
  /** column name */
  BrandName = 'brandName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FullyIntegrated = 'fullyIntegrated',
  /** column name */
  HasGiteaIntegration = 'hasGiteaIntegration',
  /** column name */
  Id = 'id',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  IsFilesSynced = 'isFilesSynced',
  /** column name */
  IsNodesSynced = 'isNodesSynced',
  /** column name */
  KnowledgeAgentContext = 'knowledgeAgentContext',
  /** column name */
  LlmCredentialId = 'llmCredentialId',
  /** column name */
  MaxOutputTokens = 'maxOutputTokens',
  /** column name */
  Name = 'name',
  /** column name */
  OtherInformation = 'otherInformation',
  /** column name */
  ParentCommitSha = 'parentCommitSha',
  /** column name */
  ParentVersionId = 'parentVersionId',
  /** column name */
  Settings = 'settings',
  /** column name */
  SolutionId = 'solutionId',
  /** column name */
  Status = 'status',
  /** column name */
  SupervisorName = 'supervisorName',
  /** column name */
  Temperature = 'temperature',
  /** column name */
  Tone = 'tone',
  /** column name */
  TopK = 'topK',
  /** column name */
  TopP = 'topP',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Version = 'version'
}

/** select "tenancy_solution_versions_aggregate_bool_exp_avg_arguments_columns" columns of table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Temperature = 'temperature',
  /** column name */
  TopK = 'topK',
  /** column name */
  TopP = 'topP'
}

/** select "tenancy_solution_versions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FullyIntegrated = 'fullyIntegrated',
  /** column name */
  HasGiteaIntegration = 'hasGiteaIntegration',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  IsFilesSynced = 'isFilesSynced',
  /** column name */
  IsNodesSynced = 'isNodesSynced'
}

/** select "tenancy_solution_versions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FullyIntegrated = 'fullyIntegrated',
  /** column name */
  HasGiteaIntegration = 'hasGiteaIntegration',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  IsFilesSynced = 'isFilesSynced',
  /** column name */
  IsNodesSynced = 'isNodesSynced'
}

/** select "tenancy_solution_versions_aggregate_bool_exp_corr_arguments_columns" columns of table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Temperature = 'temperature',
  /** column name */
  TopK = 'topK',
  /** column name */
  TopP = 'topP'
}

/** select "tenancy_solution_versions_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Temperature = 'temperature',
  /** column name */
  TopK = 'topK',
  /** column name */
  TopP = 'topP'
}

/** select "tenancy_solution_versions_aggregate_bool_exp_max_arguments_columns" columns of table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Temperature = 'temperature',
  /** column name */
  TopK = 'topK',
  /** column name */
  TopP = 'topP'
}

/** select "tenancy_solution_versions_aggregate_bool_exp_min_arguments_columns" columns of table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Temperature = 'temperature',
  /** column name */
  TopK = 'topK',
  /** column name */
  TopP = 'topP'
}

/** select "tenancy_solution_versions_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Temperature = 'temperature',
  /** column name */
  TopK = 'topK',
  /** column name */
  TopP = 'topP'
}

/** select "tenancy_solution_versions_aggregate_bool_exp_sum_arguments_columns" columns of table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Temperature = 'temperature',
  /** column name */
  TopK = 'topK',
  /** column name */
  TopP = 'topP'
}

/** select "tenancy_solution_versions_aggregate_bool_exp_var_samp_arguments_columns" columns of table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Select_Column_Tenancy_Solution_Versions_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Temperature = 'temperature',
  /** column name */
  TopK = 'topK',
  /** column name */
  TopP = 'topP'
}

/** input type for updating data in table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Set_Input = {
  botSolutionVersionId?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  fullyIntegrated?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiteaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesSynced?: InputMaybe<Scalars['Boolean']['input']>;
  isNodesSynced?: InputMaybe<Scalars['Boolean']['input']>;
  knowledgeAgentContext?: InputMaybe<Scalars['String']['input']>;
  llmCredentialId?: InputMaybe<Scalars['String']['input']>;
  maxOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherInformation?: InputMaybe<Scalars['String']['input']>;
  parentCommitSha?: InputMaybe<Scalars['String']['input']>;
  parentVersionId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['SolutionVersionStatus']['input']>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['float8']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
  topK?: InputMaybe<Scalars['float8']['input']>;
  topP?: InputMaybe<Scalars['float8']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Tenancy_Solution_Versions_Stddev_Fields = {
  __typename?: 'tenancy_solution_versions_stddev_fields';
  maxOutputTokens?: Maybe<Scalars['Float']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  topK?: Maybe<Scalars['Float']['output']>;
  topP?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Stddev_Order_By = {
  maxOutputTokens?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  topK?: InputMaybe<Order_By>;
  topP?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tenancy_Solution_Versions_Stddev_Pop_Fields = {
  __typename?: 'tenancy_solution_versions_stddev_pop_fields';
  maxOutputTokens?: Maybe<Scalars['Float']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  topK?: Maybe<Scalars['Float']['output']>;
  topP?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Stddev_Pop_Order_By = {
  maxOutputTokens?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  topK?: InputMaybe<Order_By>;
  topP?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tenancy_Solution_Versions_Stddev_Samp_Fields = {
  __typename?: 'tenancy_solution_versions_stddev_samp_fields';
  maxOutputTokens?: Maybe<Scalars['Float']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  topK?: Maybe<Scalars['Float']['output']>;
  topP?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Stddev_Samp_Order_By = {
  maxOutputTokens?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  topK?: InputMaybe<Order_By>;
  topP?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tenancy_solution_versions" */
export type Tenancy_Solution_Versions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Solution_Versions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Solution_Versions_Stream_Cursor_Value_Input = {
  botSolutionVersionId?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  fullyIntegrated?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiteaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesSynced?: InputMaybe<Scalars['Boolean']['input']>;
  isNodesSynced?: InputMaybe<Scalars['Boolean']['input']>;
  knowledgeAgentContext?: InputMaybe<Scalars['String']['input']>;
  llmCredentialId?: InputMaybe<Scalars['String']['input']>;
  maxOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherInformation?: InputMaybe<Scalars['String']['input']>;
  parentCommitSha?: InputMaybe<Scalars['String']['input']>;
  parentVersionId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  solutionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['SolutionVersionStatus']['input']>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['float8']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
  topK?: InputMaybe<Scalars['float8']['input']>;
  topP?: InputMaybe<Scalars['float8']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Tenancy_Solution_Versions_Sum_Fields = {
  __typename?: 'tenancy_solution_versions_sum_fields';
  maxOutputTokens?: Maybe<Scalars['Int']['output']>;
  temperature?: Maybe<Scalars['float8']['output']>;
  topK?: Maybe<Scalars['float8']['output']>;
  topP?: Maybe<Scalars['float8']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Sum_Order_By = {
  maxOutputTokens?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  topK?: InputMaybe<Order_By>;
  topP?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** update columns of table "tenancy.solution_versions" */
export enum Tenancy_Solution_Versions_Update_Column {
  /** column name */
  BotSolutionVersionId = 'botSolutionVersionId',
  /** column name */
  BrandName = 'brandName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FullyIntegrated = 'fullyIntegrated',
  /** column name */
  HasGiteaIntegration = 'hasGiteaIntegration',
  /** column name */
  Id = 'id',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  IsFilesSynced = 'isFilesSynced',
  /** column name */
  IsNodesSynced = 'isNodesSynced',
  /** column name */
  KnowledgeAgentContext = 'knowledgeAgentContext',
  /** column name */
  LlmCredentialId = 'llmCredentialId',
  /** column name */
  MaxOutputTokens = 'maxOutputTokens',
  /** column name */
  Name = 'name',
  /** column name */
  OtherInformation = 'otherInformation',
  /** column name */
  ParentCommitSha = 'parentCommitSha',
  /** column name */
  ParentVersionId = 'parentVersionId',
  /** column name */
  Settings = 'settings',
  /** column name */
  SolutionId = 'solutionId',
  /** column name */
  Status = 'status',
  /** column name */
  SupervisorName = 'supervisorName',
  /** column name */
  Temperature = 'temperature',
  /** column name */
  Tone = 'tone',
  /** column name */
  TopK = 'topK',
  /** column name */
  TopP = 'topP',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Version = 'version'
}

export type Tenancy_Solution_Versions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Solution_Versions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Solution_Versions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Solution_Versions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Solution_Versions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenancy_Solution_Versions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Solution_Versions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Solution_Versions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Solution_Versions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tenancy_Solution_Versions_Var_Pop_Fields = {
  __typename?: 'tenancy_solution_versions_var_pop_fields';
  maxOutputTokens?: Maybe<Scalars['Float']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  topK?: Maybe<Scalars['Float']['output']>;
  topP?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Var_Pop_Order_By = {
  maxOutputTokens?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  topK?: InputMaybe<Order_By>;
  topP?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tenancy_Solution_Versions_Var_Samp_Fields = {
  __typename?: 'tenancy_solution_versions_var_samp_fields';
  maxOutputTokens?: Maybe<Scalars['Float']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  topK?: Maybe<Scalars['Float']['output']>;
  topP?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Var_Samp_Order_By = {
  maxOutputTokens?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  topK?: InputMaybe<Order_By>;
  topP?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tenancy_Solution_Versions_Variance_Fields = {
  __typename?: 'tenancy_solution_versions_variance_fields';
  maxOutputTokens?: Maybe<Scalars['Float']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  topK?: Maybe<Scalars['Float']['output']>;
  topP?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tenancy.solution_versions" */
export type Tenancy_Solution_Versions_Variance_Order_By = {
  maxOutputTokens?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  topK?: InputMaybe<Order_By>;
  topP?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** columns and relationships of "tenancy.solutions" */
export type Tenancy_Solutions = {
  __typename?: 'tenancy_solutions';
  /** An array relationship */
  action_node_jobs: Array<Tenancy_Action_Node_Job>;
  /** An aggregate relationship */
  action_node_jobs_aggregate: Tenancy_Action_Node_Job_Aggregate;
  botSolutionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamp']['output'];
  defaultDraftVersionId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  hasGiteaIntegration: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  latestVersionId?: Maybe<Scalars['String']['output']>;
  migrationFlags?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  projectProStudioSettingId: Scalars['String']['output'];
  /** An object relationship */
  project_pro_studio_setting: Tenancy_Project_Pro_Studio_Setting;
  publishLockToken?: Maybe<Scalars['String']['output']>;
  publishStartedAt?: Maybe<Scalars['timestamp']['output']>;
  selectedVersionId?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  solutionVersionByDefaultdraftversionid?: Maybe<Tenancy_Solution_Versions>;
  /** An object relationship */
  solutionVersionBySelectedversionid?: Maybe<Tenancy_Solution_Versions>;
  /** An array relationship */
  solution_deployments: Array<Tenancy_Solution_Deployments>;
  /** An aggregate relationship */
  solution_deployments_aggregate: Tenancy_Solution_Deployments_Aggregate;
  /** An array relationship */
  solution_user_presences: Array<Tenancy_Solution_User_Presence>;
  /** An aggregate relationship */
  solution_user_presences_aggregate: Tenancy_Solution_User_Presence_Aggregate;
  /** An object relationship */
  solution_version?: Maybe<Tenancy_Solution_Versions>;
  /** An array relationship */
  solution_versions: Array<Tenancy_Solution_Versions>;
  /** An aggregate relationship */
  solution_versions_aggregate: Tenancy_Solution_Versions_Aggregate;
  status: Scalars['SolutionVersionStatus']['output'];
  type: Scalars['SolutionType']['output'];
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "tenancy.solutions" */
export type Tenancy_SolutionsAction_Node_JobsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Node_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Node_Job_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
};


/** columns and relationships of "tenancy.solutions" */
export type Tenancy_SolutionsAction_Node_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Action_Node_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Action_Node_Job_Order_By>>;
  where?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
};


/** columns and relationships of "tenancy.solutions" */
export type Tenancy_SolutionsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.solutions" */
export type Tenancy_SolutionsSolution_DeploymentsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployments_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
};


/** columns and relationships of "tenancy.solutions" */
export type Tenancy_SolutionsSolution_Deployments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Deployments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Deployments_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
};


/** columns and relationships of "tenancy.solutions" */
export type Tenancy_SolutionsSolution_User_PresencesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_User_Presence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_User_Presence_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
};


/** columns and relationships of "tenancy.solutions" */
export type Tenancy_SolutionsSolution_User_Presences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_User_Presence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_User_Presence_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
};


/** columns and relationships of "tenancy.solutions" */
export type Tenancy_SolutionsSolution_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
};


/** columns and relationships of "tenancy.solutions" */
export type Tenancy_SolutionsSolution_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_Versions_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
};

/** aggregated selection of "tenancy.solutions" */
export type Tenancy_Solutions_Aggregate = {
  __typename?: 'tenancy_solutions_aggregate';
  aggregate?: Maybe<Tenancy_Solutions_Aggregate_Fields>;
  nodes: Array<Tenancy_Solutions>;
};

export type Tenancy_Solutions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_Solutions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_Solutions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_Solutions_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Solutions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_Solutions_Select_Column_Tenancy_Solutions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solutions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_Solutions_Select_Column_Tenancy_Solutions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Solutions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.solutions" */
export type Tenancy_Solutions_Aggregate_Fields = {
  __typename?: 'tenancy_solutions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Solutions_Max_Fields>;
  min?: Maybe<Tenancy_Solutions_Min_Fields>;
};


/** aggregate fields of "tenancy.solutions" */
export type Tenancy_Solutions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Solutions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.solutions" */
export type Tenancy_Solutions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Solutions_Max_Order_By>;
  min?: InputMaybe<Tenancy_Solutions_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Solutions_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.solutions" */
export type Tenancy_Solutions_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Solutions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solutions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.solutions". All fields are combined with a logical 'AND'. */
export type Tenancy_Solutions_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Solutions_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Solutions_Bool_Exp>>;
  action_node_jobs?: InputMaybe<Tenancy_Action_Node_Job_Bool_Exp>;
  action_node_jobs_aggregate?: InputMaybe<Tenancy_Action_Node_Job_Aggregate_Bool_Exp>;
  botSolutionId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  defaultDraftVersionId?: InputMaybe<String_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  hasGiteaIntegration?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  latestVersionId?: InputMaybe<String_Comparison_Exp>;
  migrationFlags?: InputMaybe<String_Array_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  projectProStudioSettingId?: InputMaybe<String_Comparison_Exp>;
  project_pro_studio_setting?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Bool_Exp>;
  publishLockToken?: InputMaybe<String_Comparison_Exp>;
  publishStartedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  selectedVersionId?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  solutionVersionByDefaultdraftversionid?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  solutionVersionBySelectedversionid?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  solution_deployments?: InputMaybe<Tenancy_Solution_Deployments_Bool_Exp>;
  solution_deployments_aggregate?: InputMaybe<Tenancy_Solution_Deployments_Aggregate_Bool_Exp>;
  solution_user_presences?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
  solution_user_presences_aggregate?: InputMaybe<Tenancy_Solution_User_Presence_Aggregate_Bool_Exp>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  solution_versions?: InputMaybe<Tenancy_Solution_Versions_Bool_Exp>;
  solution_versions_aggregate?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Bool_Exp>;
  status?: InputMaybe<SolutionVersionStatus_Comparison_Exp>;
  type?: InputMaybe<SolutionType_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.solutions" */
export enum Tenancy_Solutions_Constraint {
  /** unique or primary key constraint on columns "defaultDraftVersionId" */
  SolutionsDefaultDraftVersionIdKey = 'solutions_defaultDraftVersionId_key',
  /** unique or primary key constraint on columns "latestVersionId" */
  SolutionsLatestVersionIdKey = 'solutions_latestVersionId_key',
  /** unique or primary key constraint on columns "id" */
  SolutionsPkey = 'solutions_pkey',
  /** unique or primary key constraint on columns "selectedVersionId" */
  SolutionsSelectedVersionIdKey = 'solutions_selectedVersionId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Solutions_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Solutions_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Solutions_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.solutions" */
export type Tenancy_Solutions_Insert_Input = {
  action_node_jobs?: InputMaybe<Tenancy_Action_Node_Job_Arr_Rel_Insert_Input>;
  botSolutionId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  defaultDraftVersionId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  hasGiteaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionId?: InputMaybe<Scalars['String']['input']>;
  migrationFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
  project_pro_studio_setting?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Obj_Rel_Insert_Input>;
  publishLockToken?: InputMaybe<Scalars['String']['input']>;
  publishStartedAt?: InputMaybe<Scalars['timestamp']['input']>;
  selectedVersionId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  solutionVersionByDefaultdraftversionid?: InputMaybe<Tenancy_Solution_Versions_Obj_Rel_Insert_Input>;
  solutionVersionBySelectedversionid?: InputMaybe<Tenancy_Solution_Versions_Obj_Rel_Insert_Input>;
  solution_deployments?: InputMaybe<Tenancy_Solution_Deployments_Arr_Rel_Insert_Input>;
  solution_user_presences?: InputMaybe<Tenancy_Solution_User_Presence_Arr_Rel_Insert_Input>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Obj_Rel_Insert_Input>;
  solution_versions?: InputMaybe<Tenancy_Solution_Versions_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['SolutionVersionStatus']['input']>;
  type?: InputMaybe<Scalars['SolutionType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Solutions_Max_Fields = {
  __typename?: 'tenancy_solutions_max_fields';
  botSolutionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  defaultDraftVersionId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latestVersionId?: Maybe<Scalars['String']['output']>;
  migrationFlags?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  projectProStudioSettingId?: Maybe<Scalars['String']['output']>;
  publishLockToken?: Maybe<Scalars['String']['output']>;
  publishStartedAt?: Maybe<Scalars['timestamp']['output']>;
  selectedVersionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['SolutionVersionStatus']['output']>;
  type?: Maybe<Scalars['SolutionType']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.solutions" */
export type Tenancy_Solutions_Max_Order_By = {
  botSolutionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  defaultDraftVersionId?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionId?: InputMaybe<Order_By>;
  migrationFlags?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectProStudioSettingId?: InputMaybe<Order_By>;
  publishLockToken?: InputMaybe<Order_By>;
  publishStartedAt?: InputMaybe<Order_By>;
  selectedVersionId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Solutions_Min_Fields = {
  __typename?: 'tenancy_solutions_min_fields';
  botSolutionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  defaultDraftVersionId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latestVersionId?: Maybe<Scalars['String']['output']>;
  migrationFlags?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  projectProStudioSettingId?: Maybe<Scalars['String']['output']>;
  publishLockToken?: Maybe<Scalars['String']['output']>;
  publishStartedAt?: Maybe<Scalars['timestamp']['output']>;
  selectedVersionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['SolutionVersionStatus']['output']>;
  type?: Maybe<Scalars['SolutionType']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.solutions" */
export type Tenancy_Solutions_Min_Order_By = {
  botSolutionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  defaultDraftVersionId?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionId?: InputMaybe<Order_By>;
  migrationFlags?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectProStudioSettingId?: InputMaybe<Order_By>;
  publishLockToken?: InputMaybe<Order_By>;
  publishStartedAt?: InputMaybe<Order_By>;
  selectedVersionId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.solutions" */
export type Tenancy_Solutions_Mutation_Response = {
  __typename?: 'tenancy_solutions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Solutions>;
};

/** input type for inserting object relation for remote table "tenancy.solutions" */
export type Tenancy_Solutions_Obj_Rel_Insert_Input = {
  data: Tenancy_Solutions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Solutions_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.solutions" */
export type Tenancy_Solutions_On_Conflict = {
  constraint: Tenancy_Solutions_Constraint;
  update_columns?: Array<Tenancy_Solutions_Update_Column>;
  where?: InputMaybe<Tenancy_Solutions_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.solutions". */
export type Tenancy_Solutions_Order_By = {
  action_node_jobs_aggregate?: InputMaybe<Tenancy_Action_Node_Job_Aggregate_Order_By>;
  botSolutionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  defaultDraftVersionId?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  hasGiteaIntegration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionId?: InputMaybe<Order_By>;
  migrationFlags?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectProStudioSettingId?: InputMaybe<Order_By>;
  project_pro_studio_setting?: InputMaybe<Tenancy_Project_Pro_Studio_Setting_Order_By>;
  publishLockToken?: InputMaybe<Order_By>;
  publishStartedAt?: InputMaybe<Order_By>;
  selectedVersionId?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  solutionVersionByDefaultdraftversionid?: InputMaybe<Tenancy_Solution_Versions_Order_By>;
  solutionVersionBySelectedversionid?: InputMaybe<Tenancy_Solution_Versions_Order_By>;
  solution_deployments_aggregate?: InputMaybe<Tenancy_Solution_Deployments_Aggregate_Order_By>;
  solution_user_presences_aggregate?: InputMaybe<Tenancy_Solution_User_Presence_Aggregate_Order_By>;
  solution_version?: InputMaybe<Tenancy_Solution_Versions_Order_By>;
  solution_versions_aggregate?: InputMaybe<Tenancy_Solution_Versions_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.solutions */
export type Tenancy_Solutions_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Solutions_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.solutions" */
export enum Tenancy_Solutions_Select_Column {
  /** column name */
  BotSolutionId = 'botSolutionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefaultDraftVersionId = 'defaultDraftVersionId',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  HasGiteaIntegration = 'hasGiteaIntegration',
  /** column name */
  Id = 'id',
  /** column name */
  LatestVersionId = 'latestVersionId',
  /** column name */
  MigrationFlags = 'migrationFlags',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectProStudioSettingId = 'projectProStudioSettingId',
  /** column name */
  PublishLockToken = 'publishLockToken',
  /** column name */
  PublishStartedAt = 'publishStartedAt',
  /** column name */
  SelectedVersionId = 'selectedVersionId',
  /** column name */
  Settings = 'settings',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "tenancy_solutions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.solutions" */
export enum Tenancy_Solutions_Select_Column_Tenancy_Solutions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasGiteaIntegration = 'hasGiteaIntegration'
}

/** select "tenancy_solutions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.solutions" */
export enum Tenancy_Solutions_Select_Column_Tenancy_Solutions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasGiteaIntegration = 'hasGiteaIntegration'
}

/** input type for updating data in table "tenancy.solutions" */
export type Tenancy_Solutions_Set_Input = {
  botSolutionId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  defaultDraftVersionId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  hasGiteaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionId?: InputMaybe<Scalars['String']['input']>;
  migrationFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
  publishLockToken?: InputMaybe<Scalars['String']['input']>;
  publishStartedAt?: InputMaybe<Scalars['timestamp']['input']>;
  selectedVersionId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['SolutionVersionStatus']['input']>;
  type?: InputMaybe<Scalars['SolutionType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_solutions" */
export type Tenancy_Solutions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Solutions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Solutions_Stream_Cursor_Value_Input = {
  botSolutionId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  defaultDraftVersionId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  hasGiteaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionId?: InputMaybe<Scalars['String']['input']>;
  migrationFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
  publishLockToken?: InputMaybe<Scalars['String']['input']>;
  publishStartedAt?: InputMaybe<Scalars['timestamp']['input']>;
  selectedVersionId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['SolutionVersionStatus']['input']>;
  type?: InputMaybe<Scalars['SolutionType']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.solutions" */
export enum Tenancy_Solutions_Update_Column {
  /** column name */
  BotSolutionId = 'botSolutionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefaultDraftVersionId = 'defaultDraftVersionId',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  HasGiteaIntegration = 'hasGiteaIntegration',
  /** column name */
  Id = 'id',
  /** column name */
  LatestVersionId = 'latestVersionId',
  /** column name */
  MigrationFlags = 'migrationFlags',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectProStudioSettingId = 'projectProStudioSettingId',
  /** column name */
  PublishLockToken = 'publishLockToken',
  /** column name */
  PublishStartedAt = 'publishStartedAt',
  /** column name */
  SelectedVersionId = 'selectedVersionId',
  /** column name */
  Settings = 'settings',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Solutions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Solutions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Solutions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Solutions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Solutions_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Solutions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Solutions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Solutions_Bool_Exp;
};

/** columns and relationships of "tenancy.studio_resource" */
export type Tenancy_Studio_Resource = {
  __typename?: 'tenancy_studio_resource';
  description?: Maybe<Scalars['String']['output']>;
  endNodeNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startNodeNumber?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  template_nodes: Array<Tenancy_Template_Node>;
  /** An aggregate relationship */
  template_nodes_aggregate: Tenancy_Template_Node_Aggregate;
  type: Scalars['StudioResourceType']['output'];
};


/** columns and relationships of "tenancy.studio_resource" */
export type Tenancy_Studio_ResourceTemplate_NodesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Template_Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Template_Node_Order_By>>;
  where?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
};


/** columns and relationships of "tenancy.studio_resource" */
export type Tenancy_Studio_ResourceTemplate_Nodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Template_Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Template_Node_Order_By>>;
  where?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
};

/** aggregated selection of "tenancy.studio_resource" */
export type Tenancy_Studio_Resource_Aggregate = {
  __typename?: 'tenancy_studio_resource_aggregate';
  aggregate?: Maybe<Tenancy_Studio_Resource_Aggregate_Fields>;
  nodes: Array<Tenancy_Studio_Resource>;
};

/** aggregate fields of "tenancy.studio_resource" */
export type Tenancy_Studio_Resource_Aggregate_Fields = {
  __typename?: 'tenancy_studio_resource_aggregate_fields';
  avg?: Maybe<Tenancy_Studio_Resource_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Studio_Resource_Max_Fields>;
  min?: Maybe<Tenancy_Studio_Resource_Min_Fields>;
  stddev?: Maybe<Tenancy_Studio_Resource_Stddev_Fields>;
  stddev_pop?: Maybe<Tenancy_Studio_Resource_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenancy_Studio_Resource_Stddev_Samp_Fields>;
  sum?: Maybe<Tenancy_Studio_Resource_Sum_Fields>;
  var_pop?: Maybe<Tenancy_Studio_Resource_Var_Pop_Fields>;
  var_samp?: Maybe<Tenancy_Studio_Resource_Var_Samp_Fields>;
  variance?: Maybe<Tenancy_Studio_Resource_Variance_Fields>;
};


/** aggregate fields of "tenancy.studio_resource" */
export type Tenancy_Studio_Resource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Studio_Resource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Tenancy_Studio_Resource_Avg_Fields = {
  __typename?: 'tenancy_studio_resource_avg_fields';
  endNodeNumber?: Maybe<Scalars['Float']['output']>;
  startNodeNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tenancy.studio_resource". All fields are combined with a logical 'AND'. */
export type Tenancy_Studio_Resource_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Studio_Resource_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Studio_Resource_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Studio_Resource_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  endNodeNumber?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  startNodeNumber?: InputMaybe<Int_Comparison_Exp>;
  template_nodes?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
  template_nodes_aggregate?: InputMaybe<Tenancy_Template_Node_Aggregate_Bool_Exp>;
  type?: InputMaybe<StudioResourceType_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.studio_resource" */
export enum Tenancy_Studio_Resource_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudioResourcePkey = 'studio_resource_pkey'
}

/** input type for incrementing numeric columns in table "tenancy.studio_resource" */
export type Tenancy_Studio_Resource_Inc_Input = {
  endNodeNumber?: InputMaybe<Scalars['Int']['input']>;
  startNodeNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tenancy.studio_resource" */
export type Tenancy_Studio_Resource_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  endNodeNumber?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startNodeNumber?: InputMaybe<Scalars['Int']['input']>;
  template_nodes?: InputMaybe<Tenancy_Template_Node_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['StudioResourceType']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Studio_Resource_Max_Fields = {
  __typename?: 'tenancy_studio_resource_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  endNodeNumber?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startNodeNumber?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['StudioResourceType']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Studio_Resource_Min_Fields = {
  __typename?: 'tenancy_studio_resource_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  endNodeNumber?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startNodeNumber?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['StudioResourceType']['output']>;
};

/** response of any mutation on the table "tenancy.studio_resource" */
export type Tenancy_Studio_Resource_Mutation_Response = {
  __typename?: 'tenancy_studio_resource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Studio_Resource>;
};

/** input type for inserting object relation for remote table "tenancy.studio_resource" */
export type Tenancy_Studio_Resource_Obj_Rel_Insert_Input = {
  data: Tenancy_Studio_Resource_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Studio_Resource_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.studio_resource" */
export type Tenancy_Studio_Resource_On_Conflict = {
  constraint: Tenancy_Studio_Resource_Constraint;
  update_columns?: Array<Tenancy_Studio_Resource_Update_Column>;
  where?: InputMaybe<Tenancy_Studio_Resource_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.studio_resource". */
export type Tenancy_Studio_Resource_Order_By = {
  description?: InputMaybe<Order_By>;
  endNodeNumber?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  startNodeNumber?: InputMaybe<Order_By>;
  template_nodes_aggregate?: InputMaybe<Tenancy_Template_Node_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.studio_resource */
export type Tenancy_Studio_Resource_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.studio_resource" */
export enum Tenancy_Studio_Resource_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  EndNodeNumber = 'endNodeNumber',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StartNodeNumber = 'startNodeNumber',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "tenancy.studio_resource" */
export type Tenancy_Studio_Resource_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  endNodeNumber?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startNodeNumber?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['StudioResourceType']['input']>;
};

/** aggregate stddev on columns */
export type Tenancy_Studio_Resource_Stddev_Fields = {
  __typename?: 'tenancy_studio_resource_stddev_fields';
  endNodeNumber?: Maybe<Scalars['Float']['output']>;
  startNodeNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Tenancy_Studio_Resource_Stddev_Pop_Fields = {
  __typename?: 'tenancy_studio_resource_stddev_pop_fields';
  endNodeNumber?: Maybe<Scalars['Float']['output']>;
  startNodeNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Tenancy_Studio_Resource_Stddev_Samp_Fields = {
  __typename?: 'tenancy_studio_resource_stddev_samp_fields';
  endNodeNumber?: Maybe<Scalars['Float']['output']>;
  startNodeNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tenancy_studio_resource" */
export type Tenancy_Studio_Resource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Studio_Resource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Studio_Resource_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  endNodeNumber?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startNodeNumber?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['StudioResourceType']['input']>;
};

/** aggregate sum on columns */
export type Tenancy_Studio_Resource_Sum_Fields = {
  __typename?: 'tenancy_studio_resource_sum_fields';
  endNodeNumber?: Maybe<Scalars['Int']['output']>;
  startNodeNumber?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "tenancy.studio_resource" */
export enum Tenancy_Studio_Resource_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  EndNodeNumber = 'endNodeNumber',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StartNodeNumber = 'startNodeNumber',
  /** column name */
  Type = 'type'
}

export type Tenancy_Studio_Resource_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenancy_Studio_Resource_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Studio_Resource_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Studio_Resource_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tenancy_Studio_Resource_Var_Pop_Fields = {
  __typename?: 'tenancy_studio_resource_var_pop_fields';
  endNodeNumber?: Maybe<Scalars['Float']['output']>;
  startNodeNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Tenancy_Studio_Resource_Var_Samp_Fields = {
  __typename?: 'tenancy_studio_resource_var_samp_fields';
  endNodeNumber?: Maybe<Scalars['Float']['output']>;
  startNodeNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Tenancy_Studio_Resource_Variance_Fields = {
  __typename?: 'tenancy_studio_resource_variance_fields';
  endNodeNumber?: Maybe<Scalars['Float']['output']>;
  startNodeNumber?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config = {
  __typename?: 'tenancy_team_account_environment_config';
  /** An array relationship */
  _team_account_environment_config_roles: Array<Tenancy__Team_Account_Environment_Config_Roles>;
  /** An aggregate relationship */
  _team_account_environment_config_roles_aggregate: Tenancy__Team_Account_Environment_Config_Roles_Aggregate;
  id: Scalars['String']['output'];
  projectEnvironmentConfigId: Scalars['String']['output'];
  /** An object relationship */
  project_environment_config: Tenancy_Project_Environment_Config;
  teamAccountId: Scalars['String']['output'];
  /** An object relationship */
  team_account: Tenancy_Team_Accounts;
};


/** columns and relationships of "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Team_Account_Environment_Config_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Team_Account_Environment_Config_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
};

/** aggregated selection of "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Aggregate = {
  __typename?: 'tenancy_team_account_environment_config_aggregate';
  aggregate?: Maybe<Tenancy_Team_Account_Environment_Config_Aggregate_Fields>;
  nodes: Array<Tenancy_Team_Account_Environment_Config>;
};

export type Tenancy_Team_Account_Environment_Config_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Team_Account_Environment_Config_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Team_Account_Environment_Config_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Aggregate_Fields = {
  __typename?: 'tenancy_team_account_environment_config_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Team_Account_Environment_Config_Max_Fields>;
  min?: Maybe<Tenancy_Team_Account_Environment_Config_Min_Fields>;
};


/** aggregate fields of "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Team_Account_Environment_Config_Max_Order_By>;
  min?: InputMaybe<Tenancy_Team_Account_Environment_Config_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Team_Account_Environment_Config_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Team_Account_Environment_Config_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.team_account_environment_config". All fields are combined with a logical 'AND'. */
export type Tenancy_Team_Account_Environment_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Bool_Exp>>;
  _team_account_environment_config_roles?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Bool_Exp>;
  _team_account_environment_config_roles_aggregate?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  projectEnvironmentConfigId?: InputMaybe<String_Comparison_Exp>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
  teamAccountId?: InputMaybe<String_Comparison_Exp>;
  team_account?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.team_account_environment_config" */
export enum Tenancy_Team_Account_Environment_Config_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamAccountEnvironmentConfigPkey = 'team_account_environment_config_pkey'
}

/** input type for inserting data into table "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Insert_Input = {
  _team_account_environment_config_roles?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  projectEnvironmentConfigId?: InputMaybe<Scalars['String']['input']>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Obj_Rel_Insert_Input>;
  teamAccountId?: InputMaybe<Scalars['String']['input']>;
  team_account?: InputMaybe<Tenancy_Team_Accounts_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Team_Account_Environment_Config_Max_Fields = {
  __typename?: 'tenancy_team_account_environment_config_max_fields';
  id?: Maybe<Scalars['String']['output']>;
  projectEnvironmentConfigId?: Maybe<Scalars['String']['output']>;
  teamAccountId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  projectEnvironmentConfigId?: InputMaybe<Order_By>;
  teamAccountId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Team_Account_Environment_Config_Min_Fields = {
  __typename?: 'tenancy_team_account_environment_config_min_fields';
  id?: Maybe<Scalars['String']['output']>;
  projectEnvironmentConfigId?: Maybe<Scalars['String']['output']>;
  teamAccountId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  projectEnvironmentConfigId?: InputMaybe<Order_By>;
  teamAccountId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Mutation_Response = {
  __typename?: 'tenancy_team_account_environment_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Team_Account_Environment_Config>;
};

/** input type for inserting object relation for remote table "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Obj_Rel_Insert_Input = {
  data: Tenancy_Team_Account_Environment_Config_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Team_Account_Environment_Config_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_On_Conflict = {
  constraint: Tenancy_Team_Account_Environment_Config_Constraint;
  update_columns?: Array<Tenancy_Team_Account_Environment_Config_Update_Column>;
  where?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.team_account_environment_config". */
export type Tenancy_Team_Account_Environment_Config_Order_By = {
  _team_account_environment_config_roles_aggregate?: InputMaybe<Tenancy__Team_Account_Environment_Config_Roles_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  projectEnvironmentConfigId?: InputMaybe<Order_By>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Order_By>;
  teamAccountId?: InputMaybe<Order_By>;
  team_account?: InputMaybe<Tenancy_Team_Accounts_Order_By>;
};

/** primary key columns input for table: tenancy.team_account_environment_config */
export type Tenancy_Team_Account_Environment_Config_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.team_account_environment_config" */
export enum Tenancy_Team_Account_Environment_Config_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectEnvironmentConfigId = 'projectEnvironmentConfigId',
  /** column name */
  TeamAccountId = 'teamAccountId'
}

/** input type for updating data in table "tenancy.team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  projectEnvironmentConfigId?: InputMaybe<Scalars['String']['input']>;
  teamAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_team_account_environment_config" */
export type Tenancy_Team_Account_Environment_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Team_Account_Environment_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Team_Account_Environment_Config_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  projectEnvironmentConfigId?: InputMaybe<Scalars['String']['input']>;
  teamAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.team_account_environment_config" */
export enum Tenancy_Team_Account_Environment_Config_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectEnvironmentConfigId = 'projectEnvironmentConfigId',
  /** column name */
  TeamAccountId = 'teamAccountId'
}

export type Tenancy_Team_Account_Environment_Config_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Team_Account_Environment_Config_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Team_Account_Environment_Config_Bool_Exp;
};

/** columns and relationships of "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects = {
  __typename?: 'tenancy_team_account_projects';
  /** An array relationship */
  _team_account_project_roles: Array<Tenancy__Team_Account_Project_Roles>;
  /** An aggregate relationship */
  _team_account_project_roles_aggregate: Tenancy__Team_Account_Project_Roles_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
  /** An object relationship */
  project: Tenancy_Projects;
  projectId: Scalars['String']['output'];
  settings?: Maybe<Scalars['jsonb']['output']>;
  teamAccountId: Scalars['String']['output'];
  /** An object relationship */
  team_account: Tenancy_Team_Accounts;
  updatedAt: Scalars['timestamp']['output'];
};


/** columns and relationships of "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Team_Account_Project_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Team_Account_Project_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.team_account_projects" */
export type Tenancy_Team_Account_ProjectsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Aggregate = {
  __typename?: 'tenancy_team_account_projects_aggregate';
  aggregate?: Maybe<Tenancy_Team_Account_Projects_Aggregate_Fields>;
  nodes: Array<Tenancy_Team_Account_Projects>;
};

export type Tenancy_Team_Account_Projects_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Team_Account_Projects_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Team_Account_Projects_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Team_Account_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Aggregate_Fields = {
  __typename?: 'tenancy_team_account_projects_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Team_Account_Projects_Max_Fields>;
  min?: Maybe<Tenancy_Team_Account_Projects_Min_Fields>;
};


/** aggregate fields of "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Team_Account_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Team_Account_Projects_Max_Order_By>;
  min?: InputMaybe<Tenancy_Team_Account_Projects_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Team_Account_Projects_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Team_Account_Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Team_Account_Projects_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.team_account_projects". All fields are combined with a logical 'AND'. */
export type Tenancy_Team_Account_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Team_Account_Projects_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Team_Account_Projects_Bool_Exp>>;
  _team_account_project_roles?: InputMaybe<Tenancy__Team_Account_Project_Roles_Bool_Exp>;
  _team_account_project_roles_aggregate?: InputMaybe<Tenancy__Team_Account_Project_Roles_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  teamAccountId?: InputMaybe<String_Comparison_Exp>;
  team_account?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.team_account_projects" */
export enum Tenancy_Team_Account_Projects_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamAccountProjectsPkey = 'team_account_projects_pkey',
  /** unique or primary key constraint on columns "projectId", "teamAccountId" */
  TeamAccountProjectsTeamAccountIdProjectIdKey = 'team_account_projects_teamAccountId_projectId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Team_Account_Projects_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Team_Account_Projects_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Team_Account_Projects_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Insert_Input = {
  _team_account_project_roles?: InputMaybe<Tenancy__Team_Account_Project_Roles_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Tenancy_Projects_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  teamAccountId?: InputMaybe<Scalars['String']['input']>;
  team_account?: InputMaybe<Tenancy_Team_Accounts_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Team_Account_Projects_Max_Fields = {
  __typename?: 'tenancy_team_account_projects_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  teamAccountId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  teamAccountId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Team_Account_Projects_Min_Fields = {
  __typename?: 'tenancy_team_account_projects_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  teamAccountId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  teamAccountId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Mutation_Response = {
  __typename?: 'tenancy_team_account_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Team_Account_Projects>;
};

/** input type for inserting object relation for remote table "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Obj_Rel_Insert_Input = {
  data: Tenancy_Team_Account_Projects_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Team_Account_Projects_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_On_Conflict = {
  constraint: Tenancy_Team_Account_Projects_Constraint;
  update_columns?: Array<Tenancy_Team_Account_Projects_Update_Column>;
  where?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.team_account_projects". */
export type Tenancy_Team_Account_Projects_Order_By = {
  _team_account_project_roles_aggregate?: InputMaybe<Tenancy__Team_Account_Project_Roles_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Tenancy_Projects_Order_By>;
  projectId?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  teamAccountId?: InputMaybe<Order_By>;
  team_account?: InputMaybe<Tenancy_Team_Accounts_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.team_account_projects */
export type Tenancy_Team_Account_Projects_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Team_Account_Projects_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.team_account_projects" */
export enum Tenancy_Team_Account_Projects_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  Settings = 'settings',
  /** column name */
  TeamAccountId = 'teamAccountId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tenancy.team_account_projects" */
export type Tenancy_Team_Account_Projects_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  teamAccountId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_team_account_projects" */
export type Tenancy_Team_Account_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Team_Account_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Team_Account_Projects_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  teamAccountId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.team_account_projects" */
export enum Tenancy_Team_Account_Projects_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  Settings = 'settings',
  /** column name */
  TeamAccountId = 'teamAccountId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Team_Account_Projects_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Team_Account_Projects_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Team_Account_Projects_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Team_Account_Projects_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Team_Account_Projects_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Team_Account_Projects_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Team_Account_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Team_Account_Projects_Bool_Exp;
};

/** columns and relationships of "tenancy.team_accounts" */
export type Tenancy_Team_Accounts = {
  __typename?: 'tenancy_team_accounts';
  /** An array relationship */
  _team_account_roles: Array<Tenancy__Team_Account_Roles>;
  /** An aggregate relationship */
  _team_account_roles_aggregate: Tenancy__Team_Account_Roles_Aggregate;
  /** An object relationship */
  account: Tenancy_Accounts;
  accountId: Scalars['String']['output'];
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
  isPrimaryAccount: Scalars['Boolean']['output'];
  settings?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  team: Tenancy_Teams;
  teamId: Scalars['String']['output'];
  /** An array relationship */
  team_account_environment_configs: Array<Tenancy_Team_Account_Environment_Config>;
  /** An aggregate relationship */
  team_account_environment_configs_aggregate: Tenancy_Team_Account_Environment_Config_Aggregate;
  /** An array relationship */
  team_account_projects: Array<Tenancy_Team_Account_Projects>;
  /** An aggregate relationship */
  team_account_projects_aggregate: Tenancy_Team_Account_Projects_Aggregate;
  updatedAt: Scalars['timestamp']['output'];
};


/** columns and relationships of "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Team_Account_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Team_Account_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__Team_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__Team_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.team_accounts" */
export type Tenancy_Team_AccountsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.team_accounts" */
export type Tenancy_Team_AccountsTeam_Account_Environment_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
};


/** columns and relationships of "tenancy.team_accounts" */
export type Tenancy_Team_AccountsTeam_Account_Environment_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
};


/** columns and relationships of "tenancy.team_accounts" */
export type Tenancy_Team_AccountsTeam_Account_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
};


/** columns and relationships of "tenancy.team_accounts" */
export type Tenancy_Team_AccountsTeam_Account_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
};

/** aggregated selection of "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Aggregate = {
  __typename?: 'tenancy_team_accounts_aggregate';
  aggregate?: Maybe<Tenancy_Team_Accounts_Aggregate_Fields>;
  nodes: Array<Tenancy_Team_Accounts>;
};

export type Tenancy_Team_Accounts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_Team_Accounts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_Team_Accounts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_Team_Accounts_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Team_Accounts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_Team_Accounts_Select_Column_Tenancy_Team_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Team_Accounts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_Team_Accounts_Select_Column_Tenancy_Team_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Team_Accounts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Team_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Aggregate_Fields = {
  __typename?: 'tenancy_team_accounts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Team_Accounts_Max_Fields>;
  min?: Maybe<Tenancy_Team_Accounts_Min_Fields>;
};


/** aggregate fields of "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Team_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Team_Accounts_Max_Order_By>;
  min?: InputMaybe<Tenancy_Team_Accounts_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Team_Accounts_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Team_Accounts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Team_Accounts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.team_accounts". All fields are combined with a logical 'AND'. */
export type Tenancy_Team_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Team_Accounts_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Team_Accounts_Bool_Exp>>;
  _team_account_roles?: InputMaybe<Tenancy__Team_Account_Roles_Bool_Exp>;
  _team_account_roles_aggregate?: InputMaybe<Tenancy__Team_Account_Roles_Aggregate_Bool_Exp>;
  account?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  accountId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isPrimaryAccount?: InputMaybe<Boolean_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  team?: InputMaybe<Tenancy_Teams_Bool_Exp>;
  teamId?: InputMaybe<String_Comparison_Exp>;
  team_account_environment_configs?: InputMaybe<Tenancy_Team_Account_Environment_Config_Bool_Exp>;
  team_account_environment_configs_aggregate?: InputMaybe<Tenancy_Team_Account_Environment_Config_Aggregate_Bool_Exp>;
  team_account_projects?: InputMaybe<Tenancy_Team_Account_Projects_Bool_Exp>;
  team_account_projects_aggregate?: InputMaybe<Tenancy_Team_Account_Projects_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.team_accounts" */
export enum Tenancy_Team_Accounts_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamAccountsPkey = 'team_accounts_pkey',
  /** unique or primary key constraint on columns "teamId", "accountId" */
  TeamAccountsTeamIdAccountIdKey = 'team_accounts_teamId_accountId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Team_Accounts_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Team_Accounts_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Team_Accounts_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Insert_Input = {
  _team_account_roles?: InputMaybe<Tenancy__Team_Account_Roles_Arr_Rel_Insert_Input>;
  account?: InputMaybe<Tenancy_Accounts_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrimaryAccount?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  team?: InputMaybe<Tenancy_Teams_Obj_Rel_Insert_Input>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  team_account_environment_configs?: InputMaybe<Tenancy_Team_Account_Environment_Config_Arr_Rel_Insert_Input>;
  team_account_projects?: InputMaybe<Tenancy_Team_Account_Projects_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Team_Accounts_Max_Fields = {
  __typename?: 'tenancy_team_accounts_max_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  teamId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Team_Accounts_Min_Fields = {
  __typename?: 'tenancy_team_accounts_min_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  teamId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Mutation_Response = {
  __typename?: 'tenancy_team_accounts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Team_Accounts>;
};

/** input type for inserting object relation for remote table "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Obj_Rel_Insert_Input = {
  data: Tenancy_Team_Accounts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Team_Accounts_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_On_Conflict = {
  constraint: Tenancy_Team_Accounts_Constraint;
  update_columns?: Array<Tenancy_Team_Accounts_Update_Column>;
  where?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.team_accounts". */
export type Tenancy_Team_Accounts_Order_By = {
  _team_account_roles_aggregate?: InputMaybe<Tenancy__Team_Account_Roles_Aggregate_Order_By>;
  account?: InputMaybe<Tenancy_Accounts_Order_By>;
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isPrimaryAccount?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  team?: InputMaybe<Tenancy_Teams_Order_By>;
  teamId?: InputMaybe<Order_By>;
  team_account_environment_configs_aggregate?: InputMaybe<Tenancy_Team_Account_Environment_Config_Aggregate_Order_By>;
  team_account_projects_aggregate?: InputMaybe<Tenancy_Team_Account_Projects_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.team_accounts */
export type Tenancy_Team_Accounts_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Team_Accounts_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.team_accounts" */
export enum Tenancy_Team_Accounts_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimaryAccount = 'isPrimaryAccount',
  /** column name */
  Settings = 'settings',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "tenancy_team_accounts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.team_accounts" */
export enum Tenancy_Team_Accounts_Select_Column_Tenancy_Team_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPrimaryAccount = 'isPrimaryAccount'
}

/** select "tenancy_team_accounts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.team_accounts" */
export enum Tenancy_Team_Accounts_Select_Column_Tenancy_Team_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPrimaryAccount = 'isPrimaryAccount'
}

/** input type for updating data in table "tenancy.team_accounts" */
export type Tenancy_Team_Accounts_Set_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrimaryAccount?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "tenancy_team_accounts" */
export type Tenancy_Team_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Team_Accounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Team_Accounts_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrimaryAccount?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "tenancy.team_accounts" */
export enum Tenancy_Team_Accounts_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimaryAccount = 'isPrimaryAccount',
  /** column name */
  Settings = 'settings',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tenancy_Team_Accounts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Team_Accounts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Team_Accounts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Team_Accounts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Team_Accounts_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Team_Accounts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Team_Accounts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Team_Accounts_Bool_Exp;
};

/** columns and relationships of "tenancy.teams" */
export type Tenancy_Teams = {
  __typename?: 'tenancy_teams';
  /** An array relationship */
  _user_teams: Array<Tenancy__User_Teams>;
  /** An aggregate relationship */
  _user_teams_aggregate: Tenancy__User_Teams_Aggregate;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  settings?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  team_accounts: Array<Tenancy_Team_Accounts>;
  /** An aggregate relationship */
  team_accounts_aggregate: Tenancy_Team_Accounts_Aggregate;
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.teams" */
export type Tenancy_Teams_User_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Teams_Order_By>>;
  where?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
};


/** columns and relationships of "tenancy.teams" */
export type Tenancy_Teams_User_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Teams_Order_By>>;
  where?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
};


/** columns and relationships of "tenancy.teams" */
export type Tenancy_TeamsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.teams" */
export type Tenancy_TeamsTeam_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
};


/** columns and relationships of "tenancy.teams" */
export type Tenancy_TeamsTeam_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Team_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Team_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
};

/** aggregated selection of "tenancy.teams" */
export type Tenancy_Teams_Aggregate = {
  __typename?: 'tenancy_teams_aggregate';
  aggregate?: Maybe<Tenancy_Teams_Aggregate_Fields>;
  nodes: Array<Tenancy_Teams>;
};

/** aggregate fields of "tenancy.teams" */
export type Tenancy_Teams_Aggregate_Fields = {
  __typename?: 'tenancy_teams_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Teams_Max_Fields>;
  min?: Maybe<Tenancy_Teams_Min_Fields>;
};


/** aggregate fields of "tenancy.teams" */
export type Tenancy_Teams_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Teams_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.teams". All fields are combined with a logical 'AND'. */
export type Tenancy_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Teams_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Teams_Bool_Exp>>;
  _user_teams?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
  _user_teams_aggregate?: InputMaybe<Tenancy__User_Teams_Aggregate_Bool_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  team_accounts?: InputMaybe<Tenancy_Team_Accounts_Bool_Exp>;
  team_accounts_aggregate?: InputMaybe<Tenancy_Team_Accounts_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.teams" */
export enum Tenancy_Teams_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamsPkey = 'teams_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Teams_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Teams_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Teams_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.teams" */
export type Tenancy_Teams_Insert_Input = {
  _user_teams?: InputMaybe<Tenancy__User_Teams_Arr_Rel_Insert_Input>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  team_accounts?: InputMaybe<Tenancy_Team_Accounts_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Teams_Max_Fields = {
  __typename?: 'tenancy_teams_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Teams_Min_Fields = {
  __typename?: 'tenancy_teams_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tenancy.teams" */
export type Tenancy_Teams_Mutation_Response = {
  __typename?: 'tenancy_teams_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Teams>;
};

/** input type for inserting object relation for remote table "tenancy.teams" */
export type Tenancy_Teams_Obj_Rel_Insert_Input = {
  data: Tenancy_Teams_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Teams_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.teams" */
export type Tenancy_Teams_On_Conflict = {
  constraint: Tenancy_Teams_Constraint;
  update_columns?: Array<Tenancy_Teams_Update_Column>;
  where?: InputMaybe<Tenancy_Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.teams". */
export type Tenancy_Teams_Order_By = {
  _user_teams_aggregate?: InputMaybe<Tenancy__User_Teams_Aggregate_Order_By>;
  color?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  team_accounts_aggregate?: InputMaybe<Tenancy_Team_Accounts_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.teams */
export type Tenancy_Teams_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Teams_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.teams" */
export enum Tenancy_Teams_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "tenancy.teams" */
export type Tenancy_Teams_Set_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_teams" */
export type Tenancy_Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Teams_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.teams" */
export enum Tenancy_Teams_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type Tenancy_Teams_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Teams_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Teams_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Teams_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Teams_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Teams_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Teams_Bool_Exp;
};

/** columns and relationships of "tenancy.template_node" */
export type Tenancy_Template_Node = {
  __typename?: 'tenancy_template_node';
  answerRequired?: Maybe<Scalars['Boolean']['output']>;
  behaviors?: Maybe<Array<Scalars['String']['output']>>;
  command?: Maybe<Scalars['String']['output']>;
  cssClassname?: Maybe<Scalars['String']['output']>;
  decisionVariable?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  intent?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nextNodes?: Maybe<Array<Scalars['Int']['output']>>;
  nluDisabled?: Maybe<Scalars['Boolean']['output']>;
  nodeInput?: Maybe<Scalars['String']['output']>;
  nodeName: Scalars['String']['output'];
  nodeNumber?: Maybe<Scalars['Int']['output']>;
  nodeTags?: Maybe<Scalars['String']['output']>;
  nodeType: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  output?: Maybe<Array<Scalars['String']['output']>>;
  parameterInput?: Maybe<Scalars['jsonb']['output']>;
  platformFlag?: Maybe<Scalars['String']['output']>;
  richAssetType: Scalars['String']['output'];
  skillTag?: Maybe<Scalars['String']['output']>;
  studioResourceId: Scalars['String']['output'];
  /** An object relationship */
  studio_resource: Tenancy_Studio_Resource;
  utterances?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<Array<Scalars['String']['output']>>;
  whatsNext?: Maybe<Array<Scalars['String']['output']>>;
};


/** columns and relationships of "tenancy.template_node" */
export type Tenancy_Template_NodeParameterInputArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.template_node" */
export type Tenancy_Template_Node_Aggregate = {
  __typename?: 'tenancy_template_node_aggregate';
  aggregate?: Maybe<Tenancy_Template_Node_Aggregate_Fields>;
  nodes: Array<Tenancy_Template_Node>;
};

export type Tenancy_Template_Node_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_Template_Node_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_Template_Node_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_Template_Node_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Template_Node_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_Template_Node_Select_Column_Tenancy_Template_Node_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Template_Node_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_Template_Node_Select_Column_Tenancy_Template_Node_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_Template_Node_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Template_Node_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.template_node" */
export type Tenancy_Template_Node_Aggregate_Fields = {
  __typename?: 'tenancy_template_node_aggregate_fields';
  avg?: Maybe<Tenancy_Template_Node_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Template_Node_Max_Fields>;
  min?: Maybe<Tenancy_Template_Node_Min_Fields>;
  stddev?: Maybe<Tenancy_Template_Node_Stddev_Fields>;
  stddev_pop?: Maybe<Tenancy_Template_Node_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenancy_Template_Node_Stddev_Samp_Fields>;
  sum?: Maybe<Tenancy_Template_Node_Sum_Fields>;
  var_pop?: Maybe<Tenancy_Template_Node_Var_Pop_Fields>;
  var_samp?: Maybe<Tenancy_Template_Node_Var_Samp_Fields>;
  variance?: Maybe<Tenancy_Template_Node_Variance_Fields>;
};


/** aggregate fields of "tenancy.template_node" */
export type Tenancy_Template_Node_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Template_Node_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.template_node" */
export type Tenancy_Template_Node_Aggregate_Order_By = {
  avg?: InputMaybe<Tenancy_Template_Node_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Template_Node_Max_Order_By>;
  min?: InputMaybe<Tenancy_Template_Node_Min_Order_By>;
  stddev?: InputMaybe<Tenancy_Template_Node_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tenancy_Template_Node_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tenancy_Template_Node_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tenancy_Template_Node_Sum_Order_By>;
  var_pop?: InputMaybe<Tenancy_Template_Node_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tenancy_Template_Node_Var_Samp_Order_By>;
  variance?: InputMaybe<Tenancy_Template_Node_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Template_Node_Append_Input = {
  parameterInput?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.template_node" */
export type Tenancy_Template_Node_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Template_Node_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Template_Node_On_Conflict>;
};

/** aggregate avg on columns */
export type Tenancy_Template_Node_Avg_Fields = {
  __typename?: 'tenancy_template_node_avg_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tenancy.template_node" */
export type Tenancy_Template_Node_Avg_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tenancy.template_node". All fields are combined with a logical 'AND'. */
export type Tenancy_Template_Node_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Template_Node_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Template_Node_Bool_Exp>>;
  answerRequired?: InputMaybe<Boolean_Comparison_Exp>;
  behaviors?: InputMaybe<String_Array_Comparison_Exp>;
  command?: InputMaybe<String_Comparison_Exp>;
  cssClassname?: InputMaybe<String_Comparison_Exp>;
  decisionVariable?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  intent?: InputMaybe<String_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  nextNodes?: InputMaybe<Int_Array_Comparison_Exp>;
  nluDisabled?: InputMaybe<Boolean_Comparison_Exp>;
  nodeInput?: InputMaybe<String_Comparison_Exp>;
  nodeName?: InputMaybe<String_Comparison_Exp>;
  nodeNumber?: InputMaybe<Int_Comparison_Exp>;
  nodeTags?: InputMaybe<String_Comparison_Exp>;
  nodeType?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  output?: InputMaybe<String_Array_Comparison_Exp>;
  parameterInput?: InputMaybe<Jsonb_Comparison_Exp>;
  platformFlag?: InputMaybe<String_Comparison_Exp>;
  richAssetType?: InputMaybe<String_Comparison_Exp>;
  skillTag?: InputMaybe<String_Comparison_Exp>;
  studioResourceId?: InputMaybe<String_Comparison_Exp>;
  studio_resource?: InputMaybe<Tenancy_Studio_Resource_Bool_Exp>;
  utterances?: InputMaybe<String_Comparison_Exp>;
  variables?: InputMaybe<String_Array_Comparison_Exp>;
  whatsNext?: InputMaybe<String_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.template_node" */
export enum Tenancy_Template_Node_Constraint {
  /** unique or primary key constraint on columns "id" */
  TemplateNodePkey = 'template_node_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Template_Node_Delete_At_Path_Input = {
  parameterInput?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Template_Node_Delete_Elem_Input = {
  parameterInput?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Template_Node_Delete_Key_Input = {
  parameterInput?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "tenancy.template_node" */
export type Tenancy_Template_Node_Inc_Input = {
  nodeNumber?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tenancy.template_node" */
export type Tenancy_Template_Node_Insert_Input = {
  answerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  behaviors?: InputMaybe<Array<Scalars['String']['input']>>;
  command?: InputMaybe<Scalars['String']['input']>;
  cssClassname?: InputMaybe<Scalars['String']['input']>;
  decisionVariable?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  nextNodes?: InputMaybe<Array<Scalars['Int']['input']>>;
  nluDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  nodeInput?: InputMaybe<Scalars['String']['input']>;
  nodeName?: InputMaybe<Scalars['String']['input']>;
  nodeNumber?: InputMaybe<Scalars['Int']['input']>;
  nodeTags?: InputMaybe<Scalars['String']['input']>;
  nodeType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  output?: InputMaybe<Array<Scalars['String']['input']>>;
  parameterInput?: InputMaybe<Scalars['jsonb']['input']>;
  platformFlag?: InputMaybe<Scalars['String']['input']>;
  richAssetType?: InputMaybe<Scalars['String']['input']>;
  skillTag?: InputMaybe<Scalars['String']['input']>;
  studioResourceId?: InputMaybe<Scalars['String']['input']>;
  studio_resource?: InputMaybe<Tenancy_Studio_Resource_Obj_Rel_Insert_Input>;
  utterances?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Array<Scalars['String']['input']>>;
  whatsNext?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** aggregate max on columns */
export type Tenancy_Template_Node_Max_Fields = {
  __typename?: 'tenancy_template_node_max_fields';
  behaviors?: Maybe<Array<Scalars['String']['output']>>;
  command?: Maybe<Scalars['String']['output']>;
  cssClassname?: Maybe<Scalars['String']['output']>;
  decisionVariable?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nextNodes?: Maybe<Array<Scalars['Int']['output']>>;
  nodeInput?: Maybe<Scalars['String']['output']>;
  nodeName?: Maybe<Scalars['String']['output']>;
  nodeNumber?: Maybe<Scalars['Int']['output']>;
  nodeTags?: Maybe<Scalars['String']['output']>;
  nodeType?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  output?: Maybe<Array<Scalars['String']['output']>>;
  platformFlag?: Maybe<Scalars['String']['output']>;
  richAssetType?: Maybe<Scalars['String']['output']>;
  skillTag?: Maybe<Scalars['String']['output']>;
  studioResourceId?: Maybe<Scalars['String']['output']>;
  utterances?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<Array<Scalars['String']['output']>>;
  whatsNext?: Maybe<Array<Scalars['String']['output']>>;
};

/** order by max() on columns of table "tenancy.template_node" */
export type Tenancy_Template_Node_Max_Order_By = {
  behaviors?: InputMaybe<Order_By>;
  command?: InputMaybe<Order_By>;
  cssClassname?: InputMaybe<Order_By>;
  decisionVariable?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intent?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  nextNodes?: InputMaybe<Order_By>;
  nodeInput?: InputMaybe<Order_By>;
  nodeName?: InputMaybe<Order_By>;
  nodeNumber?: InputMaybe<Order_By>;
  nodeTags?: InputMaybe<Order_By>;
  nodeType?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  output?: InputMaybe<Order_By>;
  platformFlag?: InputMaybe<Order_By>;
  richAssetType?: InputMaybe<Order_By>;
  skillTag?: InputMaybe<Order_By>;
  studioResourceId?: InputMaybe<Order_By>;
  utterances?: InputMaybe<Order_By>;
  variables?: InputMaybe<Order_By>;
  whatsNext?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Template_Node_Min_Fields = {
  __typename?: 'tenancy_template_node_min_fields';
  behaviors?: Maybe<Array<Scalars['String']['output']>>;
  command?: Maybe<Scalars['String']['output']>;
  cssClassname?: Maybe<Scalars['String']['output']>;
  decisionVariable?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nextNodes?: Maybe<Array<Scalars['Int']['output']>>;
  nodeInput?: Maybe<Scalars['String']['output']>;
  nodeName?: Maybe<Scalars['String']['output']>;
  nodeNumber?: Maybe<Scalars['Int']['output']>;
  nodeTags?: Maybe<Scalars['String']['output']>;
  nodeType?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  output?: Maybe<Array<Scalars['String']['output']>>;
  platformFlag?: Maybe<Scalars['String']['output']>;
  richAssetType?: Maybe<Scalars['String']['output']>;
  skillTag?: Maybe<Scalars['String']['output']>;
  studioResourceId?: Maybe<Scalars['String']['output']>;
  utterances?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<Array<Scalars['String']['output']>>;
  whatsNext?: Maybe<Array<Scalars['String']['output']>>;
};

/** order by min() on columns of table "tenancy.template_node" */
export type Tenancy_Template_Node_Min_Order_By = {
  behaviors?: InputMaybe<Order_By>;
  command?: InputMaybe<Order_By>;
  cssClassname?: InputMaybe<Order_By>;
  decisionVariable?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intent?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  nextNodes?: InputMaybe<Order_By>;
  nodeInput?: InputMaybe<Order_By>;
  nodeName?: InputMaybe<Order_By>;
  nodeNumber?: InputMaybe<Order_By>;
  nodeTags?: InputMaybe<Order_By>;
  nodeType?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  output?: InputMaybe<Order_By>;
  platformFlag?: InputMaybe<Order_By>;
  richAssetType?: InputMaybe<Order_By>;
  skillTag?: InputMaybe<Order_By>;
  studioResourceId?: InputMaybe<Order_By>;
  utterances?: InputMaybe<Order_By>;
  variables?: InputMaybe<Order_By>;
  whatsNext?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.template_node" */
export type Tenancy_Template_Node_Mutation_Response = {
  __typename?: 'tenancy_template_node_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Template_Node>;
};

/** on_conflict condition type for table "tenancy.template_node" */
export type Tenancy_Template_Node_On_Conflict = {
  constraint: Tenancy_Template_Node_Constraint;
  update_columns?: Array<Tenancy_Template_Node_Update_Column>;
  where?: InputMaybe<Tenancy_Template_Node_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.template_node". */
export type Tenancy_Template_Node_Order_By = {
  answerRequired?: InputMaybe<Order_By>;
  behaviors?: InputMaybe<Order_By>;
  command?: InputMaybe<Order_By>;
  cssClassname?: InputMaybe<Order_By>;
  decisionVariable?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intent?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  nextNodes?: InputMaybe<Order_By>;
  nluDisabled?: InputMaybe<Order_By>;
  nodeInput?: InputMaybe<Order_By>;
  nodeName?: InputMaybe<Order_By>;
  nodeNumber?: InputMaybe<Order_By>;
  nodeTags?: InputMaybe<Order_By>;
  nodeType?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  output?: InputMaybe<Order_By>;
  parameterInput?: InputMaybe<Order_By>;
  platformFlag?: InputMaybe<Order_By>;
  richAssetType?: InputMaybe<Order_By>;
  skillTag?: InputMaybe<Order_By>;
  studioResourceId?: InputMaybe<Order_By>;
  studio_resource?: InputMaybe<Tenancy_Studio_Resource_Order_By>;
  utterances?: InputMaybe<Order_By>;
  variables?: InputMaybe<Order_By>;
  whatsNext?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.template_node */
export type Tenancy_Template_Node_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Template_Node_Prepend_Input = {
  parameterInput?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.template_node" */
export enum Tenancy_Template_Node_Select_Column {
  /** column name */
  AnswerRequired = 'answerRequired',
  /** column name */
  Behaviors = 'behaviors',
  /** column name */
  Command = 'command',
  /** column name */
  CssClassname = 'cssClassname',
  /** column name */
  DecisionVariable = 'decisionVariable',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Intent = 'intent',
  /** column name */
  Message = 'message',
  /** column name */
  NextNodes = 'nextNodes',
  /** column name */
  NluDisabled = 'nluDisabled',
  /** column name */
  NodeInput = 'nodeInput',
  /** column name */
  NodeName = 'nodeName',
  /** column name */
  NodeNumber = 'nodeNumber',
  /** column name */
  NodeTags = 'nodeTags',
  /** column name */
  NodeType = 'nodeType',
  /** column name */
  Order = 'order',
  /** column name */
  Output = 'output',
  /** column name */
  ParameterInput = 'parameterInput',
  /** column name */
  PlatformFlag = 'platformFlag',
  /** column name */
  RichAssetType = 'richAssetType',
  /** column name */
  SkillTag = 'skillTag',
  /** column name */
  StudioResourceId = 'studioResourceId',
  /** column name */
  Utterances = 'utterances',
  /** column name */
  Variables = 'variables',
  /** column name */
  WhatsNext = 'whatsNext'
}

/** select "tenancy_template_node_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.template_node" */
export enum Tenancy_Template_Node_Select_Column_Tenancy_Template_Node_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AnswerRequired = 'answerRequired',
  /** column name */
  NluDisabled = 'nluDisabled'
}

/** select "tenancy_template_node_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.template_node" */
export enum Tenancy_Template_Node_Select_Column_Tenancy_Template_Node_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AnswerRequired = 'answerRequired',
  /** column name */
  NluDisabled = 'nluDisabled'
}

/** input type for updating data in table "tenancy.template_node" */
export type Tenancy_Template_Node_Set_Input = {
  answerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  behaviors?: InputMaybe<Array<Scalars['String']['input']>>;
  command?: InputMaybe<Scalars['String']['input']>;
  cssClassname?: InputMaybe<Scalars['String']['input']>;
  decisionVariable?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  nextNodes?: InputMaybe<Array<Scalars['Int']['input']>>;
  nluDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  nodeInput?: InputMaybe<Scalars['String']['input']>;
  nodeName?: InputMaybe<Scalars['String']['input']>;
  nodeNumber?: InputMaybe<Scalars['Int']['input']>;
  nodeTags?: InputMaybe<Scalars['String']['input']>;
  nodeType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  output?: InputMaybe<Array<Scalars['String']['input']>>;
  parameterInput?: InputMaybe<Scalars['jsonb']['input']>;
  platformFlag?: InputMaybe<Scalars['String']['input']>;
  richAssetType?: InputMaybe<Scalars['String']['input']>;
  skillTag?: InputMaybe<Scalars['String']['input']>;
  studioResourceId?: InputMaybe<Scalars['String']['input']>;
  utterances?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Array<Scalars['String']['input']>>;
  whatsNext?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** aggregate stddev on columns */
export type Tenancy_Template_Node_Stddev_Fields = {
  __typename?: 'tenancy_template_node_stddev_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tenancy.template_node" */
export type Tenancy_Template_Node_Stddev_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tenancy_Template_Node_Stddev_Pop_Fields = {
  __typename?: 'tenancy_template_node_stddev_pop_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tenancy.template_node" */
export type Tenancy_Template_Node_Stddev_Pop_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tenancy_Template_Node_Stddev_Samp_Fields = {
  __typename?: 'tenancy_template_node_stddev_samp_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tenancy.template_node" */
export type Tenancy_Template_Node_Stddev_Samp_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tenancy_template_node" */
export type Tenancy_Template_Node_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Template_Node_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Template_Node_Stream_Cursor_Value_Input = {
  answerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  behaviors?: InputMaybe<Array<Scalars['String']['input']>>;
  command?: InputMaybe<Scalars['String']['input']>;
  cssClassname?: InputMaybe<Scalars['String']['input']>;
  decisionVariable?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  nextNodes?: InputMaybe<Array<Scalars['Int']['input']>>;
  nluDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  nodeInput?: InputMaybe<Scalars['String']['input']>;
  nodeName?: InputMaybe<Scalars['String']['input']>;
  nodeNumber?: InputMaybe<Scalars['Int']['input']>;
  nodeTags?: InputMaybe<Scalars['String']['input']>;
  nodeType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  output?: InputMaybe<Array<Scalars['String']['input']>>;
  parameterInput?: InputMaybe<Scalars['jsonb']['input']>;
  platformFlag?: InputMaybe<Scalars['String']['input']>;
  richAssetType?: InputMaybe<Scalars['String']['input']>;
  skillTag?: InputMaybe<Scalars['String']['input']>;
  studioResourceId?: InputMaybe<Scalars['String']['input']>;
  utterances?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Array<Scalars['String']['input']>>;
  whatsNext?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** aggregate sum on columns */
export type Tenancy_Template_Node_Sum_Fields = {
  __typename?: 'tenancy_template_node_sum_fields';
  nodeNumber?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tenancy.template_node" */
export type Tenancy_Template_Node_Sum_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "tenancy.template_node" */
export enum Tenancy_Template_Node_Update_Column {
  /** column name */
  AnswerRequired = 'answerRequired',
  /** column name */
  Behaviors = 'behaviors',
  /** column name */
  Command = 'command',
  /** column name */
  CssClassname = 'cssClassname',
  /** column name */
  DecisionVariable = 'decisionVariable',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Intent = 'intent',
  /** column name */
  Message = 'message',
  /** column name */
  NextNodes = 'nextNodes',
  /** column name */
  NluDisabled = 'nluDisabled',
  /** column name */
  NodeInput = 'nodeInput',
  /** column name */
  NodeName = 'nodeName',
  /** column name */
  NodeNumber = 'nodeNumber',
  /** column name */
  NodeTags = 'nodeTags',
  /** column name */
  NodeType = 'nodeType',
  /** column name */
  Order = 'order',
  /** column name */
  Output = 'output',
  /** column name */
  ParameterInput = 'parameterInput',
  /** column name */
  PlatformFlag = 'platformFlag',
  /** column name */
  RichAssetType = 'richAssetType',
  /** column name */
  SkillTag = 'skillTag',
  /** column name */
  StudioResourceId = 'studioResourceId',
  /** column name */
  Utterances = 'utterances',
  /** column name */
  Variables = 'variables',
  /** column name */
  WhatsNext = 'whatsNext'
}

export type Tenancy_Template_Node_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Template_Node_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Template_Node_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Template_Node_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Template_Node_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenancy_Template_Node_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Template_Node_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Template_Node_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Template_Node_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tenancy_Template_Node_Var_Pop_Fields = {
  __typename?: 'tenancy_template_node_var_pop_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tenancy.template_node" */
export type Tenancy_Template_Node_Var_Pop_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tenancy_Template_Node_Var_Samp_Fields = {
  __typename?: 'tenancy_template_node_var_samp_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tenancy.template_node" */
export type Tenancy_Template_Node_Var_Samp_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tenancy_Template_Node_Variance_Fields = {
  __typename?: 'tenancy_template_node_variance_fields';
  nodeNumber?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tenancy.template_node" */
export type Tenancy_Template_Node_Variance_Order_By = {
  nodeNumber?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "tenancy.time_zone" */
export type Tenancy_Time_Zone = {
  __typename?: 'tenancy_time_zone';
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  localization_settings: Array<Tenancy_Localization_Settings>;
  /** An aggregate relationship */
  localization_settings_aggregate: Tenancy_Localization_Settings_Aggregate;
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
};


/** columns and relationships of "tenancy.time_zone" */
export type Tenancy_Time_ZoneLocalization_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.time_zone" */
export type Tenancy_Time_ZoneLocalization_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};

/** aggregated selection of "tenancy.time_zone" */
export type Tenancy_Time_Zone_Aggregate = {
  __typename?: 'tenancy_time_zone_aggregate';
  aggregate?: Maybe<Tenancy_Time_Zone_Aggregate_Fields>;
  nodes: Array<Tenancy_Time_Zone>;
};

/** aggregate fields of "tenancy.time_zone" */
export type Tenancy_Time_Zone_Aggregate_Fields = {
  __typename?: 'tenancy_time_zone_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Time_Zone_Max_Fields>;
  min?: Maybe<Tenancy_Time_Zone_Min_Fields>;
};


/** aggregate fields of "tenancy.time_zone" */
export type Tenancy_Time_Zone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Time_Zone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.time_zone". All fields are combined with a logical 'AND'. */
export type Tenancy_Time_Zone_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Time_Zone_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Time_Zone_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Time_Zone_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  identifier?: InputMaybe<String_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  localization_settings?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
  localization_settings_aggregate?: InputMaybe<Tenancy_Localization_Settings_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.time_zone" */
export enum Tenancy_Time_Zone_Constraint {
  /** unique or primary key constraint on columns "id" */
  TimeZonePkey = 'time_zone_pkey'
}

/** input type for inserting data into table "tenancy.time_zone" */
export type Tenancy_Time_Zone_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  localization_settings?: InputMaybe<Tenancy_Localization_Settings_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Time_Zone_Max_Fields = {
  __typename?: 'tenancy_time_zone_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Time_Zone_Min_Fields = {
  __typename?: 'tenancy_time_zone_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tenancy.time_zone" */
export type Tenancy_Time_Zone_Mutation_Response = {
  __typename?: 'tenancy_time_zone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Time_Zone>;
};

/** input type for inserting object relation for remote table "tenancy.time_zone" */
export type Tenancy_Time_Zone_Obj_Rel_Insert_Input = {
  data: Tenancy_Time_Zone_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Time_Zone_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.time_zone" */
export type Tenancy_Time_Zone_On_Conflict = {
  constraint: Tenancy_Time_Zone_Constraint;
  update_columns?: Array<Tenancy_Time_Zone_Update_Column>;
  where?: InputMaybe<Tenancy_Time_Zone_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.time_zone". */
export type Tenancy_Time_Zone_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  localization_settings_aggregate?: InputMaybe<Tenancy_Localization_Settings_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.time_zone */
export type Tenancy_Time_Zone_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.time_zone" */
export enum Tenancy_Time_Zone_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  Label = 'label',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "tenancy.time_zone" */
export type Tenancy_Time_Zone_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_time_zone" */
export type Tenancy_Time_Zone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Time_Zone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Time_Zone_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.time_zone" */
export enum Tenancy_Time_Zone_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  Label = 'label',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type Tenancy_Time_Zone_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Time_Zone_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Time_Zone_Bool_Exp;
};

/** columns and relationships of "tenancy.trigger" */
export type Tenancy_Trigger = {
  __typename?: 'tenancy_trigger';
  appletInstanceId: Scalars['String']['output'];
  /** An object relationship */
  applet_instance: Tenancy_Applet_Instance;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latestVersionWhileCreating?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  package?: Maybe<Tenancy_Package>;
  packageId?: Maybe<Scalars['String']['output']>;
  packageVersionId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  package_version?: Maybe<Tenancy_Package_Version>;
};


/** columns and relationships of "tenancy.trigger" */
export type Tenancy_TriggerOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.trigger" */
export type Tenancy_Trigger_Aggregate = {
  __typename?: 'tenancy_trigger_aggregate';
  aggregate?: Maybe<Tenancy_Trigger_Aggregate_Fields>;
  nodes: Array<Tenancy_Trigger>;
};

export type Tenancy_Trigger_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Trigger_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Trigger_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Trigger_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.trigger" */
export type Tenancy_Trigger_Aggregate_Fields = {
  __typename?: 'tenancy_trigger_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Trigger_Max_Fields>;
  min?: Maybe<Tenancy_Trigger_Min_Fields>;
};


/** aggregate fields of "tenancy.trigger" */
export type Tenancy_Trigger_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Trigger_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.trigger" */
export type Tenancy_Trigger_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Trigger_Max_Order_By>;
  min?: InputMaybe<Tenancy_Trigger_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Trigger_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.trigger" */
export type Tenancy_Trigger_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Trigger_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Trigger_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.trigger". All fields are combined with a logical 'AND'. */
export type Tenancy_Trigger_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Trigger_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Trigger_Bool_Exp>>;
  appletInstanceId?: InputMaybe<String_Comparison_Exp>;
  applet_instance?: InputMaybe<Tenancy_Applet_Instance_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  latestVersionWhileCreating?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  package?: InputMaybe<Tenancy_Package_Bool_Exp>;
  packageId?: InputMaybe<String_Comparison_Exp>;
  packageVersionId?: InputMaybe<String_Comparison_Exp>;
  package_version?: InputMaybe<Tenancy_Package_Version_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.trigger" */
export enum Tenancy_Trigger_Constraint {
  /** unique or primary key constraint on columns "id" */
  TriggerPkey = 'trigger_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Trigger_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Trigger_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Trigger_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.trigger" */
export type Tenancy_Trigger_Insert_Input = {
  appletInstanceId?: InputMaybe<Scalars['String']['input']>;
  applet_instance?: InputMaybe<Tenancy_Applet_Instance_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionWhileCreating?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  package?: InputMaybe<Tenancy_Package_Obj_Rel_Insert_Input>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  packageVersionId?: InputMaybe<Scalars['String']['input']>;
  package_version?: InputMaybe<Tenancy_Package_Version_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Trigger_Max_Fields = {
  __typename?: 'tenancy_trigger_max_fields';
  appletInstanceId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latestVersionWhileCreating?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  packageVersionId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.trigger" */
export type Tenancy_Trigger_Max_Order_By = {
  appletInstanceId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionWhileCreating?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  packageId?: InputMaybe<Order_By>;
  packageVersionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Trigger_Min_Fields = {
  __typename?: 'tenancy_trigger_min_fields';
  appletInstanceId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latestVersionWhileCreating?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  packageVersionId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.trigger" */
export type Tenancy_Trigger_Min_Order_By = {
  appletInstanceId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionWhileCreating?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  packageId?: InputMaybe<Order_By>;
  packageVersionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.trigger" */
export type Tenancy_Trigger_Mutation_Response = {
  __typename?: 'tenancy_trigger_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Trigger>;
};

/** on_conflict condition type for table "tenancy.trigger" */
export type Tenancy_Trigger_On_Conflict = {
  constraint: Tenancy_Trigger_Constraint;
  update_columns?: Array<Tenancy_Trigger_Update_Column>;
  where?: InputMaybe<Tenancy_Trigger_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.trigger". */
export type Tenancy_Trigger_Order_By = {
  appletInstanceId?: InputMaybe<Order_By>;
  applet_instance?: InputMaybe<Tenancy_Applet_Instance_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestVersionWhileCreating?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  package?: InputMaybe<Tenancy_Package_Order_By>;
  packageId?: InputMaybe<Order_By>;
  packageVersionId?: InputMaybe<Order_By>;
  package_version?: InputMaybe<Tenancy_Package_Version_Order_By>;
};

/** primary key columns input for table: tenancy.trigger */
export type Tenancy_Trigger_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Trigger_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.trigger" */
export enum Tenancy_Trigger_Select_Column {
  /** column name */
  AppletInstanceId = 'appletInstanceId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LatestVersionWhileCreating = 'latestVersionWhileCreating',
  /** column name */
  Name = 'name',
  /** column name */
  Options = 'options',
  /** column name */
  PackageId = 'packageId',
  /** column name */
  PackageVersionId = 'packageVersionId'
}

/** input type for updating data in table "tenancy.trigger" */
export type Tenancy_Trigger_Set_Input = {
  appletInstanceId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionWhileCreating?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  packageVersionId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_trigger" */
export type Tenancy_Trigger_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Trigger_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Trigger_Stream_Cursor_Value_Input = {
  appletInstanceId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latestVersionWhileCreating?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  packageVersionId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.trigger" */
export enum Tenancy_Trigger_Update_Column {
  /** column name */
  AppletInstanceId = 'appletInstanceId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LatestVersionWhileCreating = 'latestVersionWhileCreating',
  /** column name */
  Name = 'name',
  /** column name */
  Options = 'options',
  /** column name */
  PackageId = 'packageId',
  /** column name */
  PackageVersionId = 'packageVersionId'
}

export type Tenancy_Trigger_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Trigger_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Trigger_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Trigger_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Trigger_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Trigger_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Trigger_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Trigger_Bool_Exp;
};

/** columns and relationships of "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings = {
  __typename?: 'tenancy_user_account_auth_method_settings';
  accountAuthMethodSettingsId: Scalars['String']['output'];
  /** An object relationship */
  account_auth_method_setting: Tenancy_Account_Auth_Method_Settings;
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isCreationOne: Scalars['Boolean']['output'];
  settings?: Maybe<Scalars['jsonb']['output']>;
  updatedAt: Scalars['timestamp']['output'];
  userAccountId: Scalars['String']['output'];
  /** An object relationship */
  user_account: Tenancy_User_Accounts;
};


/** columns and relationships of "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_SettingsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings_Aggregate = {
  __typename?: 'tenancy_user_account_auth_method_settings_aggregate';
  aggregate?: Maybe<Tenancy_User_Account_Auth_Method_Settings_Aggregate_Fields>;
  nodes: Array<Tenancy_User_Account_Auth_Method_Settings>;
};

export type Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_User_Account_Auth_Method_Settings_Select_Column_Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_User_Account_Auth_Method_Settings_Select_Column_Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings_Aggregate_Fields = {
  __typename?: 'tenancy_user_account_auth_method_settings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_User_Account_Auth_Method_Settings_Max_Fields>;
  min?: Maybe<Tenancy_User_Account_Auth_Method_Settings_Min_Fields>;
};


/** aggregate fields of "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Max_Order_By>;
  min?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_User_Account_Auth_Method_Settings_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_User_Account_Auth_Method_Settings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.user_account_auth_method_settings". All fields are combined with a logical 'AND'. */
export type Tenancy_User_Account_Auth_Method_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>>;
  accountAuthMethodSettingsId?: InputMaybe<String_Comparison_Exp>;
  account_auth_method_setting?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  isCreationOne?: InputMaybe<Boolean_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  userAccountId?: InputMaybe<String_Comparison_Exp>;
  user_account?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.user_account_auth_method_settings" */
export enum Tenancy_User_Account_Auth_Method_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAccountAuthMethodSettingsPkey = 'user_account_auth_method_settings_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_User_Account_Auth_Method_Settings_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_User_Account_Auth_Method_Settings_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_User_Account_Auth_Method_Settings_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings_Insert_Input = {
  accountAuthMethodSettingsId?: InputMaybe<Scalars['String']['input']>;
  account_auth_method_setting?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCreationOne?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userAccountId?: InputMaybe<Scalars['String']['input']>;
  user_account?: InputMaybe<Tenancy_User_Accounts_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_User_Account_Auth_Method_Settings_Max_Fields = {
  __typename?: 'tenancy_user_account_auth_method_settings_max_fields';
  accountAuthMethodSettingsId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  userAccountId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings_Max_Order_By = {
  accountAuthMethodSettingsId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAccountId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_User_Account_Auth_Method_Settings_Min_Fields = {
  __typename?: 'tenancy_user_account_auth_method_settings_min_fields';
  accountAuthMethodSettingsId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  userAccountId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings_Min_Order_By = {
  accountAuthMethodSettingsId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAccountId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings_Mutation_Response = {
  __typename?: 'tenancy_user_account_auth_method_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_User_Account_Auth_Method_Settings>;
};

/** on_conflict condition type for table "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings_On_Conflict = {
  constraint: Tenancy_User_Account_Auth_Method_Settings_Constraint;
  update_columns?: Array<Tenancy_User_Account_Auth_Method_Settings_Update_Column>;
  where?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.user_account_auth_method_settings". */
export type Tenancy_User_Account_Auth_Method_Settings_Order_By = {
  accountAuthMethodSettingsId?: InputMaybe<Order_By>;
  account_auth_method_setting?: InputMaybe<Tenancy_Account_Auth_Method_Settings_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  isCreationOne?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAccountId?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Tenancy_User_Accounts_Order_By>;
};

/** primary key columns input for table: tenancy.user_account_auth_method_settings */
export type Tenancy_User_Account_Auth_Method_Settings_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_User_Account_Auth_Method_Settings_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.user_account_auth_method_settings" */
export enum Tenancy_User_Account_Auth_Method_Settings_Select_Column {
  /** column name */
  AccountAuthMethodSettingsId = 'accountAuthMethodSettingsId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsCreationOne = 'isCreationOne',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAccountId = 'userAccountId'
}

/** select "tenancy_user_account_auth_method_settings_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.user_account_auth_method_settings" */
export enum Tenancy_User_Account_Auth_Method_Settings_Select_Column_Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsCreationOne = 'isCreationOne'
}

/** select "tenancy_user_account_auth_method_settings_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.user_account_auth_method_settings" */
export enum Tenancy_User_Account_Auth_Method_Settings_Select_Column_Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsCreationOne = 'isCreationOne'
}

/** input type for updating data in table "tenancy.user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings_Set_Input = {
  accountAuthMethodSettingsId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCreationOne?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_user_account_auth_method_settings" */
export type Tenancy_User_Account_Auth_Method_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_User_Account_Auth_Method_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_User_Account_Auth_Method_Settings_Stream_Cursor_Value_Input = {
  accountAuthMethodSettingsId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCreationOne?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.user_account_auth_method_settings" */
export enum Tenancy_User_Account_Auth_Method_Settings_Update_Column {
  /** column name */
  AccountAuthMethodSettingsId = 'accountAuthMethodSettingsId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsCreationOne = 'isCreationOne',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAccountId = 'userAccountId'
}

export type Tenancy_User_Account_Auth_Method_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_User_Account_Auth_Method_Settings_Bool_Exp;
};

/** columns and relationships of "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config = {
  __typename?: 'tenancy_user_account_environment_config';
  /** An array relationship */
  _user_account_environment_config_roles: Array<Tenancy__User_Account_Environment_Config_Roles>;
  /** An aggregate relationship */
  _user_account_environment_config_roles_aggregate: Tenancy__User_Account_Environment_Config_Roles_Aggregate;
  id: Scalars['String']['output'];
  projectEnvironmentConfigId: Scalars['String']['output'];
  /** An object relationship */
  project_environment_config: Tenancy_Project_Environment_Config;
  userAccountId: Scalars['String']['output'];
  /** An object relationship */
  user_account: Tenancy_User_Accounts;
};


/** columns and relationships of "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_User_Account_Environment_Config_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_User_Account_Environment_Config_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Environment_Config_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
};

/** aggregated selection of "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_Aggregate = {
  __typename?: 'tenancy_user_account_environment_config_aggregate';
  aggregate?: Maybe<Tenancy_User_Account_Environment_Config_Aggregate_Fields>;
  nodes: Array<Tenancy_User_Account_Environment_Config>;
};

export type Tenancy_User_Account_Environment_Config_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_User_Account_Environment_Config_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_User_Account_Environment_Config_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_Aggregate_Fields = {
  __typename?: 'tenancy_user_account_environment_config_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_User_Account_Environment_Config_Max_Fields>;
  min?: Maybe<Tenancy_User_Account_Environment_Config_Min_Fields>;
};


/** aggregate fields of "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_User_Account_Environment_Config_Max_Order_By>;
  min?: InputMaybe<Tenancy_User_Account_Environment_Config_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_User_Account_Environment_Config_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_User_Account_Environment_Config_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.user_account_environment_config". All fields are combined with a logical 'AND'. */
export type Tenancy_User_Account_Environment_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Bool_Exp>>;
  _user_account_environment_config_roles?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Bool_Exp>;
  _user_account_environment_config_roles_aggregate?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  projectEnvironmentConfigId?: InputMaybe<String_Comparison_Exp>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Bool_Exp>;
  userAccountId?: InputMaybe<String_Comparison_Exp>;
  user_account?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.user_account_environment_config" */
export enum Tenancy_User_Account_Environment_Config_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAccountEnvironmentConfigPkey = 'user_account_environment_config_pkey'
}

/** input type for inserting data into table "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_Insert_Input = {
  _user_account_environment_config_roles?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  projectEnvironmentConfigId?: InputMaybe<Scalars['String']['input']>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Obj_Rel_Insert_Input>;
  userAccountId?: InputMaybe<Scalars['String']['input']>;
  user_account?: InputMaybe<Tenancy_User_Accounts_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_User_Account_Environment_Config_Max_Fields = {
  __typename?: 'tenancy_user_account_environment_config_max_fields';
  id?: Maybe<Scalars['String']['output']>;
  projectEnvironmentConfigId?: Maybe<Scalars['String']['output']>;
  userAccountId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  projectEnvironmentConfigId?: InputMaybe<Order_By>;
  userAccountId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_User_Account_Environment_Config_Min_Fields = {
  __typename?: 'tenancy_user_account_environment_config_min_fields';
  id?: Maybe<Scalars['String']['output']>;
  projectEnvironmentConfigId?: Maybe<Scalars['String']['output']>;
  userAccountId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  projectEnvironmentConfigId?: InputMaybe<Order_By>;
  userAccountId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_Mutation_Response = {
  __typename?: 'tenancy_user_account_environment_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_User_Account_Environment_Config>;
};

/** input type for inserting object relation for remote table "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_Obj_Rel_Insert_Input = {
  data: Tenancy_User_Account_Environment_Config_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_User_Account_Environment_Config_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_On_Conflict = {
  constraint: Tenancy_User_Account_Environment_Config_Constraint;
  update_columns?: Array<Tenancy_User_Account_Environment_Config_Update_Column>;
  where?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.user_account_environment_config". */
export type Tenancy_User_Account_Environment_Config_Order_By = {
  _user_account_environment_config_roles_aggregate?: InputMaybe<Tenancy__User_Account_Environment_Config_Roles_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  projectEnvironmentConfigId?: InputMaybe<Order_By>;
  project_environment_config?: InputMaybe<Tenancy_Project_Environment_Config_Order_By>;
  userAccountId?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Tenancy_User_Accounts_Order_By>;
};

/** primary key columns input for table: tenancy.user_account_environment_config */
export type Tenancy_User_Account_Environment_Config_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.user_account_environment_config" */
export enum Tenancy_User_Account_Environment_Config_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectEnvironmentConfigId = 'projectEnvironmentConfigId',
  /** column name */
  UserAccountId = 'userAccountId'
}

/** input type for updating data in table "tenancy.user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  projectEnvironmentConfigId?: InputMaybe<Scalars['String']['input']>;
  userAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_user_account_environment_config" */
export type Tenancy_User_Account_Environment_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_User_Account_Environment_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_User_Account_Environment_Config_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  projectEnvironmentConfigId?: InputMaybe<Scalars['String']['input']>;
  userAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.user_account_environment_config" */
export enum Tenancy_User_Account_Environment_Config_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectEnvironmentConfigId = 'projectEnvironmentConfigId',
  /** column name */
  UserAccountId = 'userAccountId'
}

export type Tenancy_User_Account_Environment_Config_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_User_Account_Environment_Config_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_User_Account_Environment_Config_Bool_Exp;
};

/** columns and relationships of "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access = {
  __typename?: 'tenancy_user_account_project_metabase_access';
  collectionId: Scalars['Int']['output'];
  createdAt: Scalars['timestamp']['output'];
  dataset: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** An object relationship */
  role: Tenancy_Roles;
  roleId: Scalars['String']['output'];
  updatedAt: Scalars['timestamp']['output'];
  userAccountProjectId: Scalars['String']['output'];
  /** An object relationship */
  user_account_project: Tenancy_User_Account_Projects;
};

/** aggregated selection of "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Aggregate = {
  __typename?: 'tenancy_user_account_project_metabase_access_aggregate';
  aggregate?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Aggregate_Fields>;
  nodes: Array<Tenancy_User_Account_Project_Metabase_Access>;
};

export type Tenancy_User_Account_Project_Metabase_Access_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_User_Account_Project_Metabase_Access_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Aggregate_Fields = {
  __typename?: 'tenancy_user_account_project_metabase_access_aggregate_fields';
  avg?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Max_Fields>;
  min?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Min_Fields>;
  stddev?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Stddev_Fields>;
  stddev_pop?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Stddev_Samp_Fields>;
  sum?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Sum_Fields>;
  var_pop?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Var_Pop_Fields>;
  var_samp?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Var_Samp_Fields>;
  variance?: Maybe<Tenancy_User_Account_Project_Metabase_Access_Variance_Fields>;
};


/** aggregate fields of "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Aggregate_Order_By = {
  avg?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Max_Order_By>;
  min?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Min_Order_By>;
  stddev?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Sum_Order_By>;
  var_pop?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Var_Samp_Order_By>;
  variance?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_User_Account_Project_Metabase_Access_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_On_Conflict>;
};

/** aggregate avg on columns */
export type Tenancy_User_Account_Project_Metabase_Access_Avg_Fields = {
  __typename?: 'tenancy_user_account_project_metabase_access_avg_fields';
  collectionId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Avg_Order_By = {
  collectionId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tenancy.user_account_project_metabase_access". All fields are combined with a logical 'AND'. */
export type Tenancy_User_Account_Project_Metabase_Access_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>>;
  collectionId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  dataset?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<Tenancy_Roles_Bool_Exp>;
  roleId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  userAccountProjectId?: InputMaybe<String_Comparison_Exp>;
  user_account_project?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.user_account_project_metabase_access" */
export enum Tenancy_User_Account_Project_Metabase_Access_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAccountProjectMetabaseAccessPkey = 'user_account_project_metabase_access_pkey',
  /** unique or primary key constraint on columns "dataset", "userAccountProjectId", "collectionId" */
  UserAccountProjectMetabaseAccessUserAccountProjectIdDKey = 'user_account_project_metabase_access_userAccountProjectId_d_key'
}

/** input type for incrementing numeric columns in table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Inc_Input = {
  collectionId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Insert_Input = {
  collectionId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  dataset?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Tenancy_Roles_Obj_Rel_Insert_Input>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userAccountProjectId?: InputMaybe<Scalars['String']['input']>;
  user_account_project?: InputMaybe<Tenancy_User_Account_Projects_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_User_Account_Project_Metabase_Access_Max_Fields = {
  __typename?: 'tenancy_user_account_project_metabase_access_max_fields';
  collectionId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  dataset?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  userAccountProjectId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Max_Order_By = {
  collectionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dataset?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAccountProjectId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_User_Account_Project_Metabase_Access_Min_Fields = {
  __typename?: 'tenancy_user_account_project_metabase_access_min_fields';
  collectionId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  dataset?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  userAccountProjectId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Min_Order_By = {
  collectionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dataset?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAccountProjectId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Mutation_Response = {
  __typename?: 'tenancy_user_account_project_metabase_access_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_User_Account_Project_Metabase_Access>;
};

/** on_conflict condition type for table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_On_Conflict = {
  constraint: Tenancy_User_Account_Project_Metabase_Access_Constraint;
  update_columns?: Array<Tenancy_User_Account_Project_Metabase_Access_Update_Column>;
  where?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.user_account_project_metabase_access". */
export type Tenancy_User_Account_Project_Metabase_Access_Order_By = {
  collectionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dataset?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Tenancy_Roles_Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAccountProjectId?: InputMaybe<Order_By>;
  user_account_project?: InputMaybe<Tenancy_User_Account_Projects_Order_By>;
};

/** primary key columns input for table: tenancy.user_account_project_metabase_access */
export type Tenancy_User_Account_Project_Metabase_Access_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.user_account_project_metabase_access" */
export enum Tenancy_User_Account_Project_Metabase_Access_Select_Column {
  /** column name */
  CollectionId = 'collectionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Dataset = 'dataset',
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAccountProjectId = 'userAccountProjectId'
}

/** input type for updating data in table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Set_Input = {
  collectionId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  dataset?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userAccountProjectId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Tenancy_User_Account_Project_Metabase_Access_Stddev_Fields = {
  __typename?: 'tenancy_user_account_project_metabase_access_stddev_fields';
  collectionId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Stddev_Order_By = {
  collectionId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tenancy_User_Account_Project_Metabase_Access_Stddev_Pop_Fields = {
  __typename?: 'tenancy_user_account_project_metabase_access_stddev_pop_fields';
  collectionId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Stddev_Pop_Order_By = {
  collectionId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tenancy_User_Account_Project_Metabase_Access_Stddev_Samp_Fields = {
  __typename?: 'tenancy_user_account_project_metabase_access_stddev_samp_fields';
  collectionId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Stddev_Samp_Order_By = {
  collectionId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tenancy_user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_User_Account_Project_Metabase_Access_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_User_Account_Project_Metabase_Access_Stream_Cursor_Value_Input = {
  collectionId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  dataset?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userAccountProjectId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Tenancy_User_Account_Project_Metabase_Access_Sum_Fields = {
  __typename?: 'tenancy_user_account_project_metabase_access_sum_fields';
  collectionId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Sum_Order_By = {
  collectionId?: InputMaybe<Order_By>;
};

/** update columns of table "tenancy.user_account_project_metabase_access" */
export enum Tenancy_User_Account_Project_Metabase_Access_Update_Column {
  /** column name */
  CollectionId = 'collectionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Dataset = 'dataset',
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAccountProjectId = 'userAccountProjectId'
}

export type Tenancy_User_Account_Project_Metabase_Access_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_User_Account_Project_Metabase_Access_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tenancy_User_Account_Project_Metabase_Access_Var_Pop_Fields = {
  __typename?: 'tenancy_user_account_project_metabase_access_var_pop_fields';
  collectionId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Var_Pop_Order_By = {
  collectionId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tenancy_User_Account_Project_Metabase_Access_Var_Samp_Fields = {
  __typename?: 'tenancy_user_account_project_metabase_access_var_samp_fields';
  collectionId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Var_Samp_Order_By = {
  collectionId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tenancy_User_Account_Project_Metabase_Access_Variance_Fields = {
  __typename?: 'tenancy_user_account_project_metabase_access_variance_fields';
  collectionId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tenancy.user_account_project_metabase_access" */
export type Tenancy_User_Account_Project_Metabase_Access_Variance_Order_By = {
  collectionId?: InputMaybe<Order_By>;
};

/** columns and relationships of "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects = {
  __typename?: 'tenancy_user_account_projects';
  /** An array relationship */
  _user_account_project_roles: Array<Tenancy__User_Account_Project_Roles>;
  /** An aggregate relationship */
  _user_account_project_roles_aggregate: Tenancy__User_Account_Project_Roles_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
  /** An array relationship */
  metabase_access: Array<Tenancy_User_Account_Project_Metabase_Access>;
  /** An aggregate relationship */
  metabase_access_aggregate: Tenancy_User_Account_Project_Metabase_Access_Aggregate;
  /** An object relationship */
  project: Tenancy_Projects;
  projectId: Scalars['String']['output'];
  settings?: Maybe<Scalars['jsonb']['output']>;
  updatedAt: Scalars['timestamp']['output'];
  userAccountId: Scalars['String']['output'];
  /** An object relationship */
  user_account: Tenancy_User_Accounts;
};


/** columns and relationships of "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_User_Account_Project_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_User_Account_Project_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Project_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.user_account_projects" */
export type Tenancy_User_Account_ProjectsMetabase_AccessArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
};


/** columns and relationships of "tenancy.user_account_projects" */
export type Tenancy_User_Account_ProjectsMetabase_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Project_Metabase_Access_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
};


/** columns and relationships of "tenancy.user_account_projects" */
export type Tenancy_User_Account_ProjectsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_Aggregate = {
  __typename?: 'tenancy_user_account_projects_aggregate';
  aggregate?: Maybe<Tenancy_User_Account_Projects_Aggregate_Fields>;
  nodes: Array<Tenancy_User_Account_Projects>;
};

export type Tenancy_User_Account_Projects_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_User_Account_Projects_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_User_Account_Projects_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_User_Account_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_Aggregate_Fields = {
  __typename?: 'tenancy_user_account_projects_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_User_Account_Projects_Max_Fields>;
  min?: Maybe<Tenancy_User_Account_Projects_Min_Fields>;
};


/** aggregate fields of "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_User_Account_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_User_Account_Projects_Max_Order_By>;
  min?: InputMaybe<Tenancy_User_Account_Projects_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_User_Account_Projects_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_User_Account_Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_User_Account_Projects_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.user_account_projects". All fields are combined with a logical 'AND'. */
export type Tenancy_User_Account_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_User_Account_Projects_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_User_Account_Projects_Bool_Exp>>;
  _user_account_project_roles?: InputMaybe<Tenancy__User_Account_Project_Roles_Bool_Exp>;
  _user_account_project_roles_aggregate?: InputMaybe<Tenancy__User_Account_Project_Roles_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  metabase_access?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Bool_Exp>;
  metabase_access_aggregate?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Aggregate_Bool_Exp>;
  project?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  userAccountId?: InputMaybe<String_Comparison_Exp>;
  user_account?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.user_account_projects" */
export enum Tenancy_User_Account_Projects_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAccountProjectsPkey = 'user_account_projects_pkey',
  /** unique or primary key constraint on columns "projectId", "userAccountId" */
  UserAccountProjectsUserAccountIdProjectIdKey = 'user_account_projects_userAccountId_projectId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_User_Account_Projects_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_User_Account_Projects_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_User_Account_Projects_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_Insert_Input = {
  _user_account_project_roles?: InputMaybe<Tenancy__User_Account_Project_Roles_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metabase_access?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Arr_Rel_Insert_Input>;
  project?: InputMaybe<Tenancy_Projects_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userAccountId?: InputMaybe<Scalars['String']['input']>;
  user_account?: InputMaybe<Tenancy_User_Accounts_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_User_Account_Projects_Max_Fields = {
  __typename?: 'tenancy_user_account_projects_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  userAccountId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAccountId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_User_Account_Projects_Min_Fields = {
  __typename?: 'tenancy_user_account_projects_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  userAccountId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAccountId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_Mutation_Response = {
  __typename?: 'tenancy_user_account_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_User_Account_Projects>;
};

/** input type for inserting object relation for remote table "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_Obj_Rel_Insert_Input = {
  data: Tenancy_User_Account_Projects_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_User_Account_Projects_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_On_Conflict = {
  constraint: Tenancy_User_Account_Projects_Constraint;
  update_columns?: Array<Tenancy_User_Account_Projects_Update_Column>;
  where?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.user_account_projects". */
export type Tenancy_User_Account_Projects_Order_By = {
  _user_account_project_roles_aggregate?: InputMaybe<Tenancy__User_Account_Project_Roles_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metabase_access_aggregate?: InputMaybe<Tenancy_User_Account_Project_Metabase_Access_Aggregate_Order_By>;
  project?: InputMaybe<Tenancy_Projects_Order_By>;
  projectId?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAccountId?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Tenancy_User_Accounts_Order_By>;
};

/** primary key columns input for table: tenancy.user_account_projects */
export type Tenancy_User_Account_Projects_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_User_Account_Projects_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.user_account_projects" */
export enum Tenancy_User_Account_Projects_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAccountId = 'userAccountId'
}

/** input type for updating data in table "tenancy.user_account_projects" */
export type Tenancy_User_Account_Projects_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_user_account_projects" */
export type Tenancy_User_Account_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_User_Account_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_User_Account_Projects_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.user_account_projects" */
export enum Tenancy_User_Account_Projects_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAccountId = 'userAccountId'
}

export type Tenancy_User_Account_Projects_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_User_Account_Projects_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_User_Account_Projects_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_User_Account_Projects_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_User_Account_Projects_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_User_Account_Projects_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_User_Account_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_User_Account_Projects_Bool_Exp;
};

/** columns and relationships of "tenancy.user_accounts" */
export type Tenancy_User_Accounts = {
  __typename?: 'tenancy_user_accounts';
  /** An array relationship */
  _user_account_roles: Array<Tenancy__User_Account_Roles>;
  /** An aggregate relationship */
  _user_account_roles_aggregate: Tenancy__User_Account_Roles_Aggregate;
  /** An object relationship */
  account: Tenancy_Accounts;
  accountId: Scalars['String']['output'];
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
  isPrimaryAccount: Scalars['Boolean']['output'];
  settings?: Maybe<Scalars['jsonb']['output']>;
  updatedAt: Scalars['timestamp']['output'];
  /** An object relationship */
  user: Tenancy_Users;
  userId: Scalars['String']['output'];
  /** An array relationship */
  user_account_auth_method_settings: Array<Tenancy_User_Account_Auth_Method_Settings>;
  /** An aggregate relationship */
  user_account_auth_method_settings_aggregate: Tenancy_User_Account_Auth_Method_Settings_Aggregate;
  /** An array relationship */
  user_account_environment_configs: Array<Tenancy_User_Account_Environment_Config>;
  /** An aggregate relationship */
  user_account_environment_configs_aggregate: Tenancy_User_Account_Environment_Config_Aggregate;
  /** An array relationship */
  user_account_projects: Array<Tenancy_User_Account_Projects>;
  /** An aggregate relationship */
  user_account_projects_aggregate: Tenancy_User_Account_Projects_Aggregate;
};


/** columns and relationships of "tenancy.user_accounts" */
export type Tenancy_User_Accounts_User_Account_RolesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.user_accounts" */
export type Tenancy_User_Accounts_User_Account_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Account_Roles_Order_By>>;
  where?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
};


/** columns and relationships of "tenancy.user_accounts" */
export type Tenancy_User_AccountsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.user_accounts" */
export type Tenancy_User_AccountsUser_Account_Auth_Method_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.user_accounts" */
export type Tenancy_User_AccountsUser_Account_Auth_Method_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Auth_Method_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.user_accounts" */
export type Tenancy_User_AccountsUser_Account_Environment_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
};


/** columns and relationships of "tenancy.user_accounts" */
export type Tenancy_User_AccountsUser_Account_Environment_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Environment_Config_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
};


/** columns and relationships of "tenancy.user_accounts" */
export type Tenancy_User_AccountsUser_Account_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
};


/** columns and relationships of "tenancy.user_accounts" */
export type Tenancy_User_AccountsUser_Account_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Account_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Account_Projects_Order_By>>;
  where?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
};

/** aggregated selection of "tenancy.user_accounts" */
export type Tenancy_User_Accounts_Aggregate = {
  __typename?: 'tenancy_user_accounts_aggregate';
  aggregate?: Maybe<Tenancy_User_Accounts_Aggregate_Fields>;
  nodes: Array<Tenancy_User_Accounts>;
};

export type Tenancy_User_Accounts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tenancy_User_Accounts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tenancy_User_Accounts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tenancy_User_Accounts_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_User_Accounts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenancy_User_Accounts_Select_Column_Tenancy_User_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_User_Accounts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenancy_User_Accounts_Select_Column_Tenancy_User_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenancy_User_Accounts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_User_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.user_accounts" */
export type Tenancy_User_Accounts_Aggregate_Fields = {
  __typename?: 'tenancy_user_accounts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_User_Accounts_Max_Fields>;
  min?: Maybe<Tenancy_User_Accounts_Min_Fields>;
};


/** aggregate fields of "tenancy.user_accounts" */
export type Tenancy_User_Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_User_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.user_accounts" */
export type Tenancy_User_Accounts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_User_Accounts_Max_Order_By>;
  min?: InputMaybe<Tenancy_User_Accounts_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_User_Accounts_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tenancy.user_accounts" */
export type Tenancy_User_Accounts_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_User_Accounts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_User_Accounts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.user_accounts". All fields are combined with a logical 'AND'. */
export type Tenancy_User_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_User_Accounts_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_User_Accounts_Bool_Exp>>;
  _user_account_roles?: InputMaybe<Tenancy__User_Account_Roles_Bool_Exp>;
  _user_account_roles_aggregate?: InputMaybe<Tenancy__User_Account_Roles_Aggregate_Bool_Exp>;
  account?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  accountId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isPrimaryAccount?: InputMaybe<Boolean_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Tenancy_Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
  user_account_auth_method_settings?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Bool_Exp>;
  user_account_auth_method_settings_aggregate?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Aggregate_Bool_Exp>;
  user_account_environment_configs?: InputMaybe<Tenancy_User_Account_Environment_Config_Bool_Exp>;
  user_account_environment_configs_aggregate?: InputMaybe<Tenancy_User_Account_Environment_Config_Aggregate_Bool_Exp>;
  user_account_projects?: InputMaybe<Tenancy_User_Account_Projects_Bool_Exp>;
  user_account_projects_aggregate?: InputMaybe<Tenancy_User_Account_Projects_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.user_accounts" */
export enum Tenancy_User_Accounts_Constraint {
  /** unique or primary key constraint on columns "userId", "accountId" */
  UserAccountsAccountIdUserIdKey = 'user_accounts_accountId_userId_key',
  /** unique or primary key constraint on columns "id" */
  UserAccountsPkey = 'user_accounts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_User_Accounts_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_User_Accounts_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_User_Accounts_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.user_accounts" */
export type Tenancy_User_Accounts_Insert_Input = {
  _user_account_roles?: InputMaybe<Tenancy__User_Account_Roles_Arr_Rel_Insert_Input>;
  account?: InputMaybe<Tenancy_Accounts_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrimaryAccount?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Tenancy_Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']['input']>;
  user_account_auth_method_settings?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Arr_Rel_Insert_Input>;
  user_account_environment_configs?: InputMaybe<Tenancy_User_Account_Environment_Config_Arr_Rel_Insert_Input>;
  user_account_projects?: InputMaybe<Tenancy_User_Account_Projects_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_User_Accounts_Max_Fields = {
  __typename?: 'tenancy_user_accounts_max_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenancy.user_accounts" */
export type Tenancy_User_Accounts_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_User_Accounts_Min_Fields = {
  __typename?: 'tenancy_user_accounts_min_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenancy.user_accounts" */
export type Tenancy_User_Accounts_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.user_accounts" */
export type Tenancy_User_Accounts_Mutation_Response = {
  __typename?: 'tenancy_user_accounts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_User_Accounts>;
};

/** input type for inserting object relation for remote table "tenancy.user_accounts" */
export type Tenancy_User_Accounts_Obj_Rel_Insert_Input = {
  data: Tenancy_User_Accounts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_User_Accounts_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.user_accounts" */
export type Tenancy_User_Accounts_On_Conflict = {
  constraint: Tenancy_User_Accounts_Constraint;
  update_columns?: Array<Tenancy_User_Accounts_Update_Column>;
  where?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.user_accounts". */
export type Tenancy_User_Accounts_Order_By = {
  _user_account_roles_aggregate?: InputMaybe<Tenancy__User_Account_Roles_Aggregate_Order_By>;
  account?: InputMaybe<Tenancy_Accounts_Order_By>;
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isPrimaryAccount?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Tenancy_Users_Order_By>;
  userId?: InputMaybe<Order_By>;
  user_account_auth_method_settings_aggregate?: InputMaybe<Tenancy_User_Account_Auth_Method_Settings_Aggregate_Order_By>;
  user_account_environment_configs_aggregate?: InputMaybe<Tenancy_User_Account_Environment_Config_Aggregate_Order_By>;
  user_account_projects_aggregate?: InputMaybe<Tenancy_User_Account_Projects_Aggregate_Order_By>;
};

/** primary key columns input for table: tenancy.user_accounts */
export type Tenancy_User_Accounts_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_User_Accounts_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.user_accounts" */
export enum Tenancy_User_Accounts_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimaryAccount = 'isPrimaryAccount',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** select "tenancy_user_accounts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenancy.user_accounts" */
export enum Tenancy_User_Accounts_Select_Column_Tenancy_User_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPrimaryAccount = 'isPrimaryAccount'
}

/** select "tenancy_user_accounts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenancy.user_accounts" */
export enum Tenancy_User_Accounts_Select_Column_Tenancy_User_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPrimaryAccount = 'isPrimaryAccount'
}

/** input type for updating data in table "tenancy.user_accounts" */
export type Tenancy_User_Accounts_Set_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrimaryAccount?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_user_accounts" */
export type Tenancy_User_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_User_Accounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_User_Accounts_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrimaryAccount?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.user_accounts" */
export enum Tenancy_User_Accounts_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimaryAccount = 'isPrimaryAccount',
  /** column name */
  Settings = 'settings',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Tenancy_User_Accounts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_User_Accounts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_User_Accounts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_User_Accounts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_User_Accounts_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_User_Accounts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_User_Accounts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_User_Accounts_Bool_Exp;
};

/** columns and relationships of "tenancy.users" */
export type Tenancy_Users = {
  __typename?: 'tenancy_users';
  /** An array relationship */
  _user_teams: Array<Tenancy__User_Teams>;
  /** An aggregate relationship */
  _user_teams_aggregate: Tenancy__User_Teams_Aggregate;
  /** An array relationship */
  accounts: Array<Tenancy_Accounts>;
  /** An aggregate relationship */
  accounts_aggregate: Tenancy_Accounts_Aggregate;
  /** An array relationship */
  audit_logs: Array<Tenancy_Audit_Logs>;
  /** An aggregate relationship */
  audit_logs_aggregate: Tenancy_Audit_Logs_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  /** An array relationship */
  files: Array<Tenancy_File>;
  /** An aggregate relationship */
  files_aggregate: Tenancy_File_Aggregate;
  firstName: Scalars['String']['output'];
  hasActiveSessions: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isHidden: Scalars['Boolean']['output'];
  kratosId?: Maybe<Scalars['String']['output']>;
  lastActiveAt: Scalars['timestamp']['output'];
  lastLoggedInAt?: Maybe<Scalars['timestamp']['output']>;
  lastName: Scalars['String']['output'];
  /** An array relationship */
  localization_settings: Array<Tenancy_Localization_Settings>;
  /** An aggregate relationship */
  localization_settings_aggregate: Tenancy_Localization_Settings_Aggregate;
  optionalConsentStatus: Scalars['ConsentStatus']['output'];
  optionalConsentUpdatedAt: Scalars['timestamp']['output'];
  passwordRecoveryStatus?: Maybe<Scalars['PasswordRecoveryStatus']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  requiredConsentStatus: Scalars['ConsentStatus']['output'];
  requiredConsentUpdatedAt: Scalars['timestamp']['output'];
  settings?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  solution_user_presences: Array<Tenancy_Solution_User_Presence>;
  /** An aggregate relationship */
  solution_user_presences_aggregate: Tenancy_Solution_User_Presence_Aggregate;
  status: Scalars['String']['output'];
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
  userName: Scalars['String']['output'];
  /** An array relationship */
  user_accounts: Array<Tenancy_User_Accounts>;
  /** An aggregate relationship */
  user_accounts_aggregate: Tenancy_User_Accounts_Aggregate;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_Users_User_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Teams_Order_By>>;
  where?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_Users_User_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__User_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__User_Teams_Order_By>>;
  where?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersAccountsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersAudit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Audit_Logs_Order_By>>;
  where?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersAudit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Audit_Logs_Order_By>>;
  where?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersFilesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_File_Order_By>>;
  where?: InputMaybe<Tenancy_File_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersLocalization_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersLocalization_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Localization_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Localization_Settings_Order_By>>;
  where?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersSolution_User_PresencesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_User_Presence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_User_Presence_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersSolution_User_Presences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_Solution_User_Presence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_Solution_User_Presence_Order_By>>;
  where?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersUser_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};


/** columns and relationships of "tenancy.users" */
export type Tenancy_UsersUser_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy_User_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy_User_Accounts_Order_By>>;
  where?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
};

/** aggregated selection of "tenancy.users" */
export type Tenancy_Users_Aggregate = {
  __typename?: 'tenancy_users_aggregate';
  aggregate?: Maybe<Tenancy_Users_Aggregate_Fields>;
  nodes: Array<Tenancy_Users>;
};

/** aggregate fields of "tenancy.users" */
export type Tenancy_Users_Aggregate_Fields = {
  __typename?: 'tenancy_users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Users_Max_Fields>;
  min?: Maybe<Tenancy_Users_Min_Fields>;
};


/** aggregate fields of "tenancy.users" */
export type Tenancy_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Users_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "tenancy.users". All fields are combined with a logical 'AND'. */
export type Tenancy_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Tenancy_Users_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Users_Bool_Exp>>;
  _user_teams?: InputMaybe<Tenancy__User_Teams_Bool_Exp>;
  _user_teams_aggregate?: InputMaybe<Tenancy__User_Teams_Aggregate_Bool_Exp>;
  accounts?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  accounts_aggregate?: InputMaybe<Tenancy_Accounts_Aggregate_Bool_Exp>;
  audit_logs?: InputMaybe<Tenancy_Audit_Logs_Bool_Exp>;
  audit_logs_aggregate?: InputMaybe<Tenancy_Audit_Logs_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  files?: InputMaybe<Tenancy_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Tenancy_File_Aggregate_Bool_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  hasActiveSessions?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp>;
  kratosId?: InputMaybe<String_Comparison_Exp>;
  lastActiveAt?: InputMaybe<Timestamp_Comparison_Exp>;
  lastLoggedInAt?: InputMaybe<Timestamp_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  localization_settings?: InputMaybe<Tenancy_Localization_Settings_Bool_Exp>;
  localization_settings_aggregate?: InputMaybe<Tenancy_Localization_Settings_Aggregate_Bool_Exp>;
  optionalConsentStatus?: InputMaybe<ConsentStatus_Comparison_Exp>;
  optionalConsentUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  passwordRecoveryStatus?: InputMaybe<PasswordRecoveryStatus_Comparison_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  requiredConsentStatus?: InputMaybe<ConsentStatus_Comparison_Exp>;
  requiredConsentUpdatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  solution_user_presences?: InputMaybe<Tenancy_Solution_User_Presence_Bool_Exp>;
  solution_user_presences_aggregate?: InputMaybe<Tenancy_Solution_User_Presence_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
  userName?: InputMaybe<String_Comparison_Exp>;
  user_accounts?: InputMaybe<Tenancy_User_Accounts_Bool_Exp>;
  user_accounts_aggregate?: InputMaybe<Tenancy_User_Accounts_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tenancy.users" */
export enum Tenancy_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenancy_Users_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenancy_Users_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenancy_Users_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "tenancy.users" */
export type Tenancy_Users_Insert_Input = {
  _user_teams?: InputMaybe<Tenancy__User_Teams_Arr_Rel_Insert_Input>;
  accounts?: InputMaybe<Tenancy_Accounts_Arr_Rel_Insert_Input>;
  audit_logs?: InputMaybe<Tenancy_Audit_Logs_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Tenancy_File_Arr_Rel_Insert_Input>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasActiveSessions?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  kratosId?: InputMaybe<Scalars['String']['input']>;
  lastActiveAt?: InputMaybe<Scalars['timestamp']['input']>;
  lastLoggedInAt?: InputMaybe<Scalars['timestamp']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  localization_settings?: InputMaybe<Tenancy_Localization_Settings_Arr_Rel_Insert_Input>;
  optionalConsentStatus?: InputMaybe<Scalars['ConsentStatus']['input']>;
  optionalConsentUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  passwordRecoveryStatus?: InputMaybe<Scalars['PasswordRecoveryStatus']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  requiredConsentStatus?: InputMaybe<Scalars['ConsentStatus']['input']>;
  requiredConsentUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  solution_user_presences?: InputMaybe<Tenancy_Solution_User_Presence_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  user_accounts?: InputMaybe<Tenancy_User_Accounts_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenancy_Users_Max_Fields = {
  __typename?: 'tenancy_users_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kratosId?: Maybe<Scalars['String']['output']>;
  lastActiveAt?: Maybe<Scalars['timestamp']['output']>;
  lastLoggedInAt?: Maybe<Scalars['timestamp']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  optionalConsentStatus?: Maybe<Scalars['ConsentStatus']['output']>;
  optionalConsentUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
  passwordRecoveryStatus?: Maybe<Scalars['PasswordRecoveryStatus']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  requiredConsentStatus?: Maybe<Scalars['ConsentStatus']['output']>;
  requiredConsentUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tenancy_Users_Min_Fields = {
  __typename?: 'tenancy_users_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kratosId?: Maybe<Scalars['String']['output']>;
  lastActiveAt?: Maybe<Scalars['timestamp']['output']>;
  lastLoggedInAt?: Maybe<Scalars['timestamp']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  optionalConsentStatus?: Maybe<Scalars['ConsentStatus']['output']>;
  optionalConsentUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
  passwordRecoveryStatus?: Maybe<Scalars['PasswordRecoveryStatus']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  requiredConsentStatus?: Maybe<Scalars['ConsentStatus']['output']>;
  requiredConsentUpdatedAt?: Maybe<Scalars['timestamp']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tenancy.users" */
export type Tenancy_Users_Mutation_Response = {
  __typename?: 'tenancy_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Users>;
};

/** input type for inserting object relation for remote table "tenancy.users" */
export type Tenancy_Users_Obj_Rel_Insert_Input = {
  data: Tenancy_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Users_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.users" */
export type Tenancy_Users_On_Conflict = {
  constraint: Tenancy_Users_Constraint;
  update_columns?: Array<Tenancy_Users_Update_Column>;
  where?: InputMaybe<Tenancy_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.users". */
export type Tenancy_Users_Order_By = {
  _user_teams_aggregate?: InputMaybe<Tenancy__User_Teams_Aggregate_Order_By>;
  accounts_aggregate?: InputMaybe<Tenancy_Accounts_Aggregate_Order_By>;
  audit_logs_aggregate?: InputMaybe<Tenancy_Audit_Logs_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Tenancy_File_Aggregate_Order_By>;
  firstName?: InputMaybe<Order_By>;
  hasActiveSessions?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isHidden?: InputMaybe<Order_By>;
  kratosId?: InputMaybe<Order_By>;
  lastActiveAt?: InputMaybe<Order_By>;
  lastLoggedInAt?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  localization_settings_aggregate?: InputMaybe<Tenancy_Localization_Settings_Aggregate_Order_By>;
  optionalConsentStatus?: InputMaybe<Order_By>;
  optionalConsentUpdatedAt?: InputMaybe<Order_By>;
  passwordRecoveryStatus?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  requiredConsentStatus?: InputMaybe<Order_By>;
  requiredConsentUpdatedAt?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  solution_user_presences_aggregate?: InputMaybe<Tenancy_Solution_User_Presence_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userName?: InputMaybe<Order_By>;
  user_accounts_aggregate?: InputMaybe<Tenancy_User_Accounts_Aggregate_Order_By>;
};

/** primary key columns input for table: tenancy.users */
export type Tenancy_Users_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenancy_Users_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenancy.users" */
export enum Tenancy_Users_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  HasActiveSessions = 'hasActiveSessions',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  KratosId = 'kratosId',
  /** column name */
  LastActiveAt = 'lastActiveAt',
  /** column name */
  LastLoggedInAt = 'lastLoggedInAt',
  /** column name */
  LastName = 'lastName',
  /** column name */
  OptionalConsentStatus = 'optionalConsentStatus',
  /** column name */
  OptionalConsentUpdatedAt = 'optionalConsentUpdatedAt',
  /** column name */
  PasswordRecoveryStatus = 'passwordRecoveryStatus',
  /** column name */
  Picture = 'picture',
  /** column name */
  RequiredConsentStatus = 'requiredConsentStatus',
  /** column name */
  RequiredConsentUpdatedAt = 'requiredConsentUpdatedAt',
  /** column name */
  Settings = 'settings',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UserName = 'userName'
}

/** input type for updating data in table "tenancy.users" */
export type Tenancy_Users_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasActiveSessions?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  kratosId?: InputMaybe<Scalars['String']['input']>;
  lastActiveAt?: InputMaybe<Scalars['timestamp']['input']>;
  lastLoggedInAt?: InputMaybe<Scalars['timestamp']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  optionalConsentStatus?: InputMaybe<Scalars['ConsentStatus']['input']>;
  optionalConsentUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  passwordRecoveryStatus?: InputMaybe<Scalars['PasswordRecoveryStatus']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  requiredConsentStatus?: InputMaybe<Scalars['ConsentStatus']['input']>;
  requiredConsentUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenancy_users" */
export type Tenancy_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Users_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasActiveSessions?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  kratosId?: InputMaybe<Scalars['String']['input']>;
  lastActiveAt?: InputMaybe<Scalars['timestamp']['input']>;
  lastLoggedInAt?: InputMaybe<Scalars['timestamp']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  optionalConsentStatus?: InputMaybe<Scalars['ConsentStatus']['input']>;
  optionalConsentUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  passwordRecoveryStatus?: InputMaybe<Scalars['PasswordRecoveryStatus']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  requiredConsentStatus?: InputMaybe<Scalars['ConsentStatus']['input']>;
  requiredConsentUpdatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenancy.users" */
export enum Tenancy_Users_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  HasActiveSessions = 'hasActiveSessions',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  KratosId = 'kratosId',
  /** column name */
  LastActiveAt = 'lastActiveAt',
  /** column name */
  LastLoggedInAt = 'lastLoggedInAt',
  /** column name */
  LastName = 'lastName',
  /** column name */
  OptionalConsentStatus = 'optionalConsentStatus',
  /** column name */
  OptionalConsentUpdatedAt = 'optionalConsentUpdatedAt',
  /** column name */
  PasswordRecoveryStatus = 'passwordRecoveryStatus',
  /** column name */
  Picture = 'picture',
  /** column name */
  RequiredConsentStatus = 'requiredConsentStatus',
  /** column name */
  RequiredConsentUpdatedAt = 'requiredConsentUpdatedAt',
  /** column name */
  Settings = 'settings',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UserName = 'userName'
}

export type Tenancy_Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenancy_Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenancy_Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenancy_Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenancy_Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenancy_Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Users_Bool_Exp;
};

/** columns and relationships of "tenancy.variable" */
export type Tenancy_Variable = {
  __typename?: 'tenancy_variable';
  /** An array relationship */
  _ProjectEnvironmentConfigToVariables: Array<Tenancy__ProjectEnvironmentConfigToVariable>;
  /** An aggregate relationship */
  _ProjectEnvironmentConfigToVariables_aggregate: Tenancy__ProjectEnvironmentConfigToVariable_Aggregate;
  /** An object relationship */
  account: Tenancy_Accounts;
  accountId: Scalars['String']['output'];
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  /** An object relationship */
  project: Tenancy_Projects;
  projectId: Scalars['String']['output'];
  updatedAt: Scalars['timestamp']['output'];
  updatedBy: Scalars['String']['output'];
  value: Scalars['String']['output'];
  variableAccessLevel: Scalars['VariableAccessLevel']['output'];
};


/** columns and relationships of "tenancy.variable" */
export type Tenancy_Variable_ProjectEnvironmentConfigToVariablesArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Order_By>>;
  where?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
};


/** columns and relationships of "tenancy.variable" */
export type Tenancy_Variable_ProjectEnvironmentConfigToVariables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenancy__ProjectEnvironmentConfigToVariable_Order_By>>;
  where?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
};

/** aggregated selection of "tenancy.variable" */
export type Tenancy_Variable_Aggregate = {
  __typename?: 'tenancy_variable_aggregate';
  aggregate?: Maybe<Tenancy_Variable_Aggregate_Fields>;
  nodes: Array<Tenancy_Variable>;
};

export type Tenancy_Variable_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tenancy_Variable_Aggregate_Bool_Exp_Count>;
};

export type Tenancy_Variable_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tenancy_Variable_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tenancy_Variable_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenancy.variable" */
export type Tenancy_Variable_Aggregate_Fields = {
  __typename?: 'tenancy_variable_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tenancy_Variable_Max_Fields>;
  min?: Maybe<Tenancy_Variable_Min_Fields>;
};


/** aggregate fields of "tenancy.variable" */
export type Tenancy_Variable_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenancy_Variable_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenancy.variable" */
export type Tenancy_Variable_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenancy_Variable_Max_Order_By>;
  min?: InputMaybe<Tenancy_Variable_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenancy.variable" */
export type Tenancy_Variable_Arr_Rel_Insert_Input = {
  data: Array<Tenancy_Variable_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Variable_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenancy.variable". All fields are combined with a logical 'AND'. */
export type Tenancy_Variable_Bool_Exp = {
  _ProjectEnvironmentConfigToVariables?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Bool_Exp>;
  _ProjectEnvironmentConfigToVariables_aggregate?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<Tenancy_Variable_Bool_Exp>>;
  _not?: InputMaybe<Tenancy_Variable_Bool_Exp>;
  _or?: InputMaybe<Array<Tenancy_Variable_Bool_Exp>>;
  account?: InputMaybe<Tenancy_Accounts_Bool_Exp>;
  accountId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Tenancy_Projects_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedBy?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  variableAccessLevel?: InputMaybe<VariableAccessLevel_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenancy.variable" */
export enum Tenancy_Variable_Constraint {
  /** unique or primary key constraint on columns "id" */
  VariablePkey = 'variable_pkey'
}

/** input type for inserting data into table "tenancy.variable" */
export type Tenancy_Variable_Insert_Input = {
  _ProjectEnvironmentConfigToVariables?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Arr_Rel_Insert_Input>;
  account?: InputMaybe<Tenancy_Accounts_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Tenancy_Projects_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  variableAccessLevel?: InputMaybe<Scalars['VariableAccessLevel']['input']>;
};

/** aggregate max on columns */
export type Tenancy_Variable_Max_Fields = {
  __typename?: 'tenancy_variable_max_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  variableAccessLevel?: Maybe<Scalars['VariableAccessLevel']['output']>;
};

/** order by max() on columns of table "tenancy.variable" */
export type Tenancy_Variable_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  variableAccessLevel?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tenancy_Variable_Min_Fields = {
  __typename?: 'tenancy_variable_min_fields';
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  variableAccessLevel?: Maybe<Scalars['VariableAccessLevel']['output']>;
};

/** order by min() on columns of table "tenancy.variable" */
export type Tenancy_Variable_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  variableAccessLevel?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenancy.variable" */
export type Tenancy_Variable_Mutation_Response = {
  __typename?: 'tenancy_variable_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenancy_Variable>;
};

/** input type for inserting object relation for remote table "tenancy.variable" */
export type Tenancy_Variable_Obj_Rel_Insert_Input = {
  data: Tenancy_Variable_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenancy_Variable_On_Conflict>;
};

/** on_conflict condition type for table "tenancy.variable" */
export type Tenancy_Variable_On_Conflict = {
  constraint: Tenancy_Variable_Constraint;
  update_columns?: Array<Tenancy_Variable_Update_Column>;
  where?: InputMaybe<Tenancy_Variable_Bool_Exp>;
};

/** Ordering options when selecting data from "tenancy.variable". */
export type Tenancy_Variable_Order_By = {
  _ProjectEnvironmentConfigToVariables_aggregate?: InputMaybe<Tenancy__ProjectEnvironmentConfigToVariable_Aggregate_Order_By>;
  account?: InputMaybe<Tenancy_Accounts_Order_By>;
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  project?: InputMaybe<Tenancy_Projects_Order_By>;
  projectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  variableAccessLevel?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenancy.variable */
export type Tenancy_Variable_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "tenancy.variable" */
export enum Tenancy_Variable_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Value = 'value',
  /** column name */
  VariableAccessLevel = 'variableAccessLevel'
}

/** input type for updating data in table "tenancy.variable" */
export type Tenancy_Variable_Set_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  variableAccessLevel?: InputMaybe<Scalars['VariableAccessLevel']['input']>;
};

/** Streaming cursor of the table "tenancy_variable" */
export type Tenancy_Variable_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenancy_Variable_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenancy_Variable_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  variableAccessLevel?: InputMaybe<Scalars['VariableAccessLevel']['input']>;
};

/** update columns of table "tenancy.variable" */
export enum Tenancy_Variable_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Value = 'value',
  /** column name */
  VariableAccessLevel = 'variableAccessLevel'
}

export type Tenancy_Variable_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenancy_Variable_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenancy_Variable_Bool_Exp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', currentUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, settings?: any, status: UserStatus, requiredConsentStatus?: ConsentStatusEnum, optionalConsentStatus?: ConsentStatusEnum, createdAt: any, updatedAt: any, profilePhoto?: string, email: string, defaultAccount?: { __typename?: 'Account', defaultOrgId?: string }, pictureFile?: { __typename?: 'File', url: string }, assignedRoles?: Array<{ __typename?: 'Role', id?: string, name?: string }>, assignedTeams?: Array<{ __typename?: 'Team', name?: string, id?: string, assignedRoles?: Array<{ __typename?: 'Role', id?: string, name?: string }>, assignedProjects?: Array<{ __typename?: 'Project', id: string }>, defaultAccount?: { __typename?: 'Account', id?: string, allChildAccounts?: Array<{ __typename?: 'Account', id?: string }> } }> } } };

export type ConnectAuthMethodMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  accountAuthMethodSettingsId: Scalars['String']['input'];
}>;


export type ConnectAuthMethodMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', connectAuthMethod?: boolean } };

export type GetAccountManagerInfoQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetAccountManagerInfoQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', userById?: { __typename?: 'User', picture?: string, firstName: string, lastName: string, userName: string } } };

export type GetOrganizationsMetadataQueryVariables = Exact<{
  accountIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetOrganizationsMetadataQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', organizationsMetadata: Array<{ __typename?: 'OrganizationMetadata', accountId?: string, canManageAccess?: boolean }> } };

export type GetUserSettingsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type GetUserSettingsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', userProductRoles?: { __typename?: 'UserProductRoles', hasAgentAssistRoles?: boolean, hasAnalyticsRoles?: boolean, hasOrganizationRoles?: boolean, hasProStudioRoles?: boolean, hasMaestroStudioRoles?: boolean, agentAssistRolesSource?: Array<{ __typename?: 'RoleSource', project?: { __typename?: 'Project', id: string, name: string, accountId: string } }>, analyticsRolesSource?: Array<{ __typename?: 'RoleSource', project?: { __typename?: 'Project', id: string, name: string, accountId: string } }>, organizationRolesSource?: Array<{ __typename?: 'RoleSource', project?: { __typename?: 'Project', id: string, name: string, accountId: string } }>, proStudioRolesSource?: Array<{ __typename?: 'RoleSource', project?: { __typename?: 'Project', id: string, name: string, accountId: string } }>, maestroStudioRolesSource?: Array<{ __typename?: 'RoleSource', project?: { __typename?: 'Project', id: string, name: string, accountId: string } }> }, organizationMetadata?: { __typename?: 'OrganizationMetadata', canManageAccess?: boolean }, currentUser?: { __typename?: 'User', settings?: any, status: UserStatus, listOfAuthMethods?: Array<{ __typename?: 'UserAuthMethodData', accountAuthMethodSettingsId?: string, isCreationOne?: boolean, isActive?: boolean, name?: string, providerId?: string, isCustom?: boolean, type?: AuthMethodTypeEnum }> } } };

export type GetMetabaseFoldersQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetMetabaseFoldersQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', getMetabaseFolders?: { __typename?: 'MetabaseFolders', datasets: Array<{ __typename?: 'MetabaseDatasetFolders', dataset: string, groups: Array<{ __typename?: 'MetabaseFolder', id: string, name: string, dashboardCount: number }> }> } } };

export type GetAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', currentUser?: { __typename?: 'User', defaultAccount?: { __typename?: 'Account', id?: string, allChildAccounts?: Array<{ __typename?: 'Account', id?: string }> } }, defaultAuthMethods?: Array<{ __typename?: 'AuthMethod', id?: string, name?: string, providerId?: string, description?: string }> } };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAccountQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', accountById?: { __typename?: 'Account', name?: string, parentId?: string, id?: string, status?: AccountStatus, accountManagerId?: string, settings?: any, pictureFile?: { __typename?: 'File', url: string }, accountAuthMethodSettings?: Array<{ __typename?: 'AccountAuthMethodSettings', id?: string, isActive?: boolean, isDefault?: boolean, authMethodId?: string, customAuthMethodId?: string }>, customAuthMethods?: Array<{ __typename?: 'CustomAuthMethod', id?: string, clientId?: string, clientSecret?: string, issuerURL?: string, type?: CustomAuthMethodTypeEnum, emailAttribute?: string, usernameAttribute?: string, entityIssuer?: string, settings?: any }> } } };

export type DeleteProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', deleteProject?: number } };

export type MakeDbSnapshotMutationVariables = Exact<{ [key: string]: never; }>;


export type MakeDbSnapshotMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', makeDbSnapshot?: boolean } };

export type GetProjectsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type GetProjectsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', projects?: { __typename?: 'PaginatedProjects', rows?: Array<{ __typename?: 'Project', accountId: string, updatedAt: any, createdAt: any, name: string, picture?: string, description?: string, projectId: string, pictureFile?: { __typename?: 'File', publicId: string, url: string }, projectProductSettings?: Array<{ __typename?: 'ProjectProductSetting', productId?: string, projectId?: string }>, users?: { __typename?: 'PaginatedUsers', rows?: Array<{ __typename?: 'User', firstName: string, lastName: string, picture?: string, email: string }> } }> }, userProjects?: { __typename?: 'PaginatedUserProjects', rows?: Array<{ __typename?: 'UserProject', project?: { __typename?: 'Project', id: string } }> } } };

export type GetProjectDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  withEnvironments: Scalars['Boolean']['input'];
}>;


export type GetProjectDetailsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', projectById?: { __typename?: 'Project', accountId: string, updatedAt: any, createdAt: any, name: string, picture?: string, description?: string, projectId: string, pictureFile?: { __typename?: 'File', publicId: string, url: string }, projectProductSettings?: Array<{ __typename?: 'ProjectProductSetting', productId?: string, projectId?: string }>, projectEnvironmentConfig?: Array<{ __typename?: 'ProjectEnvironmentConfig', environmentId?: string, status?: EnvironmentStatusEnum, description?: string, id?: string, projectId?: string, appletInstances?: Array<{ __typename?: 'AppletInstance', id: string, name?: string, projectEnvironmentConfigId: string, projectEnvironmentConfig: { __typename?: 'ProjectEnvironmentConfig', environmentId?: string } }>, environment?: { __typename?: 'Environment', name: string, id: string }, domains?: Array<{ __typename?: 'Domain', url?: string, id?: string, type?: DomainTypeEnum }> }>, localizationSettings?: { __typename?: 'LocalizationSettings', id: string, timeZone?: { __typename?: 'TimeZone', id: string, identifier: string, label: string } }, users?: { __typename?: 'PaginatedUsers', rows?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, picture?: string, email: string }> } } } };

export type GetAppletInstancesByProjectIdQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetAppletInstancesByProjectIdQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', projectById?: { __typename?: 'Project', projectId: string, projectEnvironmentConfig?: Array<{ __typename?: 'ProjectEnvironmentConfig', environmentId?: string, status?: EnvironmentStatusEnum, description?: string, id?: string, projectId?: string, appletInstances?: Array<{ __typename?: 'AppletInstance', id: string, projectEnvironmentConfigId: string, description?: string, name?: string, options?: any, status: AppletStatusEnum, updatedAt?: any, updatedByUser?: { __typename?: 'User', firstName: string, lastName: string, picture?: string }, applet: { __typename?: 'AppletVersion', id: string, applet: { __typename?: 'Applet', pkgName: string, appletType: AppletTypeEnum, id: string } }, triggers: Array<{ __typename?: 'Trigger', id: string, name: string, options?: any, packageId?: string, packageVersionId?: string, appletInstanceId: string, package?: { __typename?: 'Package', id: string, latestVersion?: { __typename?: 'PackageVersion', id: string, version: string, schema?: any }, versions?: Array<{ __typename?: 'PackageVersion', id: string, schema?: any, version: string, package: { __typename?: 'Package', id: string } }> }, packageVersion?: { __typename?: 'PackageVersion', id: string, version: string, package: { __typename?: 'Package', id: string, displayName?: string } } }>, actions: Array<{ __typename?: 'Action', id: string, name: string, options?: any, packageId?: string, packageVersionId?: string, appletInstanceId: string, package?: { __typename?: 'Package', id: string, latestVersion?: { __typename?: 'PackageVersion', id: string, version: string, schema?: any }, versions?: Array<{ __typename?: 'PackageVersion', id: string, schema?: any, version: string, package: { __typename?: 'Package', id: string } }> }, packageVersion?: { __typename?: 'PackageVersion', id: string, version: string, package: { __typename?: 'Package', id: string, displayName?: string } } }>, condition?: { __typename?: 'Condition', id: string, options?: any, appletInstanceId: string } }> }> } } };

export type GetProjectLandingPageApolloQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
}>;


export type GetProjectLandingPageApolloQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', userProjects?: { __typename?: 'PaginatedUserProjects', rows?: Array<{ __typename?: 'UserProject', project?: { __typename?: 'Project', createdAt: any, name: string, description?: string, projectId: string, pictureFile?: { __typename?: 'File', publicId: string, url: string }, projectProductSettings?: Array<{ __typename?: 'ProjectProductSetting', productId?: string, projectId?: string }>, users?: { __typename?: 'PaginatedUsers', count?: number, rows?: Array<{ __typename?: 'User', firstName: string, lastName: string, email: string }> } } }> } } };

export type GetProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', allToolProducts?: Array<{ __typename?: 'Product', name?: ProductName, id?: string, displayName?: string }>, allProducts?: Array<{ __typename?: 'Product', name?: ProductName, id?: string }> } };

export type CreateProjectMutationVariables = Exact<{
  productIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
  projectEnvironmentConfigs?: InputMaybe<Array<InputMaybe<ProjectEnvironmentConfigCreate>> | InputMaybe<ProjectEnvironmentConfigCreate>>;
  projectIconId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateProjectMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', createProject?: { __typename?: 'Project', updatedAt: any, accountId: string, name: string, picture?: string, id: string, description?: string, pictureFile?: { __typename?: 'File', url: string, publicId: string }, projectProductSettings?: Array<{ __typename?: 'ProjectProductSetting', productId?: string, projectId?: string }>, projectEnvironmentConfig?: Array<{ __typename?: 'ProjectEnvironmentConfig', environmentId?: string, status?: EnvironmentStatusEnum, description?: string, id?: string, projectId?: string, environment?: { __typename?: 'Environment', name: string, id: string }, domains?: Array<{ __typename?: 'Domain', url?: string, id?: string, type?: DomainTypeEnum }> }>, localizationSettings?: { __typename?: 'LocalizationSettings', id: string, timeZone?: { __typename?: 'TimeZone', id: string, identifier: string, label: string } }, users?: { __typename?: 'PaginatedUsers', rows?: Array<{ __typename?: 'User', firstName: string, lastName: string, picture?: string, email: string }> } } } };

export type UpdateProjectMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
  projectIconId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updateProject?: { __typename?: 'Project', accountId: string, updatedAt: any, createdAt: any, name: string, picture?: string, description?: string, projectId: string, pictureFile?: { __typename?: 'File', publicId: string, url: string }, projectProductSettings?: Array<{ __typename?: 'ProjectProductSetting', productId?: string, projectId?: string }>, projectEnvironmentConfig?: Array<{ __typename?: 'ProjectEnvironmentConfig', environmentId?: string, status?: EnvironmentStatusEnum, description?: string, id?: string, projectId?: string, environment?: { __typename?: 'Environment', name: string, id: string }, domains?: Array<{ __typename?: 'Domain', url?: string, id?: string, type?: DomainTypeEnum }> }>, localizationSettings?: { __typename?: 'LocalizationSettings', id: string, timeZone?: { __typename?: 'TimeZone', id: string, identifier: string, label: string } }, users?: { __typename?: 'PaginatedUsers', rows?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, picture?: string, email: string }> } } } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  requiredConsentStatus?: InputMaybe<ConsentStatusEnum>;
  optionalConsentStatus?: InputMaybe<ConsentStatusEnum>;
  requiredConsentUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optionalConsentUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  userIconId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updateUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, status: UserStatus, settings?: any, createdAt: any, updatedAt: any, email: string, pictureFile?: { __typename?: 'File', url: string } } } };

export type GetLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLanguagesQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', localizationSettingsConfig?: { __typename?: 'LocalizationSettingsConfig', user: { __typename?: 'LocalizationSettingsEntityConfig', supportedLanguageCodes: Array<string> }, project: { __typename?: 'LocalizationSettingsEntityConfig', supportedLanguageCodes: Array<string> } }, locales?: Array<{ __typename: 'Locale', id: string, name: string, locale: string, languageCode: string }> } };

export type GetTimeZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimeZonesQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', timeZones?: Array<{ __typename: 'TimeZone', identifier: string, label: string, id: string }> } };

export type ValidateProjectEnvironmentUrlsQueryVariables = Exact<{
  urls: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type ValidateProjectEnvironmentUrlsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', validateProjectEnvironmentUrls?: { __typename?: 'ValidatedEnvironmentDomainUrls', urls?: Array<{ __typename?: 'ValidatedEnvironmentDomainUrl', isValid: boolean, validationResult?: string, url: string, intersections?: Array<string> }> } } };

export type UpdateProjectEnvironmentConfigMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  projectEnvironmentConfigId: Scalars['String']['input'];
  domains?: InputMaybe<Array<InputMaybe<DomainInput>> | InputMaybe<DomainInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnvironmentStatusEnum>;
}>;


export type UpdateProjectEnvironmentConfigMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updateProjectEnvironmentConfig?: { __typename?: 'ProjectEnvironmentConfig', id?: string, projectId?: string, description?: string, status?: EnvironmentStatusEnum, environmentId?: string, domains?: Array<{ __typename?: 'Domain', id?: string, type?: DomainTypeEnum, url?: string }>, environment?: { __typename?: 'Environment', id: string, name: string } } } };

export type CreateAppletTemplateMutationVariables = Exact<{
  pkgName: Scalars['String']['input'];
  version: Scalars['String']['input'];
  appletType: AppletTypeEnum;
  appletCategory: AppletCategoryEnum;
  schema: Scalars['JSON']['input'];
}>;


export type CreateAppletTemplateMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', createApplet?: { __typename?: 'Applet', id: string, versions?: Array<{ __typename?: 'AppletVersion', id: string, description?: string }> } } };

export type GetAppletTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppletTemplatesQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', applets?: Array<{ __typename?: 'Applet', id: string, pkgName: string, displayName?: string, appletType: AppletTypeEnum, appletCategory: AppletCategoryEnum, description?: string, createdAt: any, latestVersion?: { __typename?: 'AppletVersion', schema: any, version: string, id: string } }> } };

export type CreatePackageMutationVariables = Exact<{
  pkgName: Scalars['String']['input'];
  version: Scalars['String']['input'];
  packageTypes: Array<PackageTypeEnum> | PackageTypeEnum;
  displayName: Scalars['String']['input'];
  packageJson: Scalars['JSON']['input'];
  schema: Scalars['JSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePackageMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', createPackage?: { __typename?: 'Package', id: string } } };

export type GetPackagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPackagesQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', packages?: Array<{ __typename?: 'Package', id: string, displayName?: string, pkgName: string, packageTypes?: Array<PackageTypeEnum>, latestVersion?: { __typename?: 'PackageVersion', schema?: any, version: string, id: string, packageJson?: any }, versions?: Array<{ __typename?: 'PackageVersion', id: string, package: { __typename?: 'Package', id: string } }> }> } };

export type UpdatePackageMutationVariables = Exact<{
  updatePackageId: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePackageMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updatePackage?: { __typename?: 'Package', id: string } } };

export type ProjectEnvironmentConfigByIdQueryVariables = Exact<{
  projectEnvironmentConfigByIdId: Scalars['String']['input'];
}>;


export type ProjectEnvironmentConfigByIdQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', projectEnvironmentConfigById?: { __typename?: 'ProjectEnvironmentConfig', appletInstances?: Array<{ __typename?: 'AppletInstance', id: string, projectEnvironmentConfigId: string, description?: string, name?: string, options?: any, status: AppletStatusEnum, applet: { __typename?: 'AppletVersion', id: string, applet: { __typename?: 'Applet', pkgName: string, appletType: AppletTypeEnum, id: string } }, triggers: Array<{ __typename?: 'Trigger', id: string, name: string, options?: any, packageId?: string, packageVersionId?: string, appletInstanceId: string, packageVersion?: { __typename?: 'PackageVersion', id: string, version: string, package: { __typename?: 'Package', id: string, displayName?: string } } }>, condition?: { __typename?: 'Condition', id: string, options?: any, appletInstanceId: string }, actions: Array<{ __typename?: 'Action', id: string, name: string, options?: any, packageId?: string, packageVersionId?: string, appletInstanceId: string, packageVersion?: { __typename?: 'PackageVersion', id: string, version: string, package: { __typename?: 'Package', id: string, displayName?: string } } }> }> } } };

export type CreateAppletVersionMutationVariables = Exact<{
  version: Scalars['String']['input'];
  appletId: Scalars['String']['input'];
  schema: Scalars['JSON']['input'];
}>;


export type CreateAppletVersionMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', createAppletVersion?: { __typename?: 'AppletVersion', id: string } } };

export type CreateAppletInstanceMutationVariables = Exact<{
  appletVersionId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  projectEnvironmentConfigId: Scalars['String']['input'];
  options?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<AppletStatusEnum>;
  triggers?: InputMaybe<Array<TriggerCreate> | TriggerCreate>;
  actions?: InputMaybe<Array<ActionCreate> | ActionCreate>;
  condition?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
}>;


export type CreateAppletInstanceMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', createAppletInstance?: { __typename?: 'AppletInstance', id: string, projectEnvironmentConfigId: string, description?: string, name?: string, options?: any, status: AppletStatusEnum, updatedByUser?: { __typename?: 'User', firstName: string, lastName: string, picture?: string }, applet: { __typename?: 'AppletVersion', id: string, applet: { __typename?: 'Applet', pkgName: string, appletType: AppletTypeEnum, id: string } }, triggers: Array<{ __typename?: 'Trigger', id: string, name: string, options?: any, packageId?: string, packageVersionId?: string, appletInstanceId: string, package?: { __typename?: 'Package', id: string, latestVersion?: { __typename?: 'PackageVersion', id: string, version: string, schema?: any }, versions?: Array<{ __typename?: 'PackageVersion', id: string, schema?: any, version: string, package: { __typename?: 'Package', id: string } }> }, packageVersion?: { __typename?: 'PackageVersion', id: string, version: string, package: { __typename?: 'Package', id: string, displayName?: string } } }>, actions: Array<{ __typename?: 'Action', id: string, name: string, options?: any, packageId?: string, packageVersionId?: string, appletInstanceId: string, package?: { __typename?: 'Package', id: string, latestVersion?: { __typename?: 'PackageVersion', id: string, version: string, schema?: any }, versions?: Array<{ __typename?: 'PackageVersion', id: string, schema?: any, version: string, package: { __typename?: 'Package', id: string } }> }, packageVersion?: { __typename?: 'PackageVersion', id: string, version: string, package: { __typename?: 'Package', id: string, displayName?: string } } }>, condition?: { __typename?: 'Condition', id: string, options?: any, appletInstanceId: string } } } };

export type AppletInstanceByIdQueryVariables = Exact<{
  appletInstanceById: Scalars['String']['input'];
}>;


export type AppletInstanceByIdQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', appletInstanceById?: { __typename?: 'AppletInstance', id: string } } };

export type UpdateAppletInstanceMutationVariables = Exact<{
  updateAppletInstanceId: Scalars['String']['input'];
  status?: InputMaybe<AppletStatusEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  triggers?: InputMaybe<Array<InputMaybe<TriggerCreate>> | InputMaybe<TriggerCreate>>;
  actions?: InputMaybe<Array<InputMaybe<ActionCreate>> | InputMaybe<ActionCreate>>;
  condition?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpdateAppletInstanceMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updateAppletInstance?: { __typename?: 'AppletInstance', id: string, projectEnvironmentConfigId: string, description?: string, name?: string, options?: any, status: AppletStatusEnum, updatedAt?: any, updatedByUser?: { __typename?: 'User', firstName: string, lastName: string, picture?: string }, applet: { __typename?: 'AppletVersion', id: string, applet: { __typename?: 'Applet', pkgName: string, appletType: AppletTypeEnum, id: string } }, triggers: Array<{ __typename?: 'Trigger', id: string, name: string, options?: any, packageId?: string, packageVersionId?: string, appletInstanceId: string, package?: { __typename?: 'Package', id: string, latestVersion?: { __typename?: 'PackageVersion', id: string, version: string, schema?: any }, versions?: Array<{ __typename?: 'PackageVersion', id: string, schema?: any, version: string, package: { __typename?: 'Package', id: string } }> }, packageVersion?: { __typename?: 'PackageVersion', id: string, version: string, package: { __typename?: 'Package', id: string, displayName?: string } } }>, actions: Array<{ __typename?: 'Action', id: string, name: string, options?: any, packageId?: string, packageVersionId?: string, appletInstanceId: string, package?: { __typename?: 'Package', id: string, latestVersion?: { __typename?: 'PackageVersion', id: string, version: string, schema?: any }, versions?: Array<{ __typename?: 'PackageVersion', id: string, schema?: any, version: string, package: { __typename?: 'Package', id: string } }> }, packageVersion?: { __typename?: 'PackageVersion', id: string, version: string, package: { __typename?: 'Package', id: string, displayName?: string } } }>, condition?: { __typename?: 'Condition', id: string, options?: any, appletInstanceId: string } } } };

export type DeleteAppletMutationVariables = Exact<{
  deleteAppletId: Scalars['String']['input'];
}>;


export type DeleteAppletMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', deleteApplet?: { __typename?: 'Applet', id: string } } };

export type DeletePackageMutationVariables = Exact<{
  deletePackageId: Scalars['String']['input'];
}>;


export type DeletePackageMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', deletePackage?: { __typename?: 'Package', id: string } } };

export type DeletePackageVersionIdMutationVariables = Exact<{
  deletePackageVersionId: Scalars['String']['input'];
}>;


export type DeletePackageVersionIdMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', deletePackageVersion?: { __typename?: 'PackageVersion', id: string } } };

export type DeleteAppletInstanceMutationVariables = Exact<{
  deleteAppletInstanceId: Scalars['String']['input'];
}>;


export type DeleteAppletInstanceMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', deleteAppletInstance?: { __typename?: 'AppletInstance', id: string } } };

export type GetUsersQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type GetUsersQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', users?: { __typename?: 'PaginatedUsers', rows?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, picture?: string, userName: string, createdAt: any, lastActiveAt: any, status: UserStatus, pictureFile?: { __typename?: 'File', url: string } }> } } };

export type GetTeamsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type GetTeamsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', teams?: { __typename?: 'PaginatedTeams', rows?: Array<{ __typename?: 'Team', id?: string, name?: string, description?: string, updatedAt?: any, assignedMembers?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, picture?: string }> }> } } };

export type CustomAuthMethodDetailsFragment = { __typename?: 'CustomAuthMethod', id?: string, clientId?: string, clientSecret?: string, issuerURL?: string, type?: CustomAuthMethodTypeEnum, emailAttribute?: string, usernameAttribute?: string, entityIssuer?: string, settings?: any };

export type AccountAuthMethodSettingsFragment = { __typename?: 'AccountAuthMethodSettings', id?: string, isActive?: boolean, isDefault?: boolean, authMethodId?: string, customAuthMethodId?: string };

export type GetChildAccountsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type GetChildAccountsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', accountById?: { __typename?: 'Account', id?: string, name?: string, parentId?: string, createdAt?: any, pictureFile?: { __typename?: 'File', url: string } }, accounts?: { __typename?: 'PaginatedAccounts', count?: number, rows?: Array<{ __typename?: 'Account', id?: string, name?: string, status?: AccountStatus, isManaged?: boolean, createdAt?: any, updatedAt?: any, pictureFile?: { __typename?: 'File', url: string }, allChildAccounts?: Array<{ __typename?: 'Account', id?: string, name?: string, parentId?: string }>, projects?: { __typename?: 'PaginatedProjects', rows?: Array<{ __typename?: 'Project', name: string, id: string }> }, teams?: { __typename?: 'PaginatedTeams', rows?: Array<{ __typename?: 'Team', name?: string, id?: string }> }, users?: { __typename?: 'PaginatedUsers', count?: number } }> } } };

export type GetAuditLogsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  queryMetadata: QueryMetadata;
}>;


export type GetAuditLogsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', auditLogs?: { __typename?: 'PaginatedAuditLogs', count?: number, rows?: Array<{ __typename?: 'AuditLog', id?: string, userId?: string, accountId?: string, productId?: string, applicationId?: string, createdAt?: any, user?: { __typename?: 'User', id: string, userName: string, firstName: string, lastName: string, picture?: string }, auditLogDetail?: { __typename?: 'AuditLogDetail', displayMessage?: string } }> } } };

export type CreateAccountMutationVariables = Exact<{
  parentAccountId: Scalars['String']['input'];
  accountName: Scalars['String']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  generalSettings?: InputMaybe<Scalars['JSON']['input']>;
  resourceLimitSettings?: InputMaybe<Scalars['JSON']['input']>;
  accountIconId?: InputMaybe<Scalars['String']['input']>;
  defaultAuthMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  customAuthMethods?: InputMaybe<Array<InputMaybe<CustomAuthMethodCreateInput>> | InputMaybe<CustomAuthMethodCreateInput>>;
}>;


export type CreateAccountMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', createAccount?: { __typename?: 'Account', id?: string, name?: string, status?: AccountStatus, createdAt?: any, updatedAt?: any, settings?: any, pictureFile?: { __typename?: 'File', url: string } } } };

export type UpdateAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  generalSettings?: InputMaybe<Scalars['JSON']['input']>;
  resourceLimitSettings?: InputMaybe<Scalars['JSON']['input']>;
  accountIconId?: InputMaybe<Scalars['String']['input']>;
  accountAuthMethodSettings?: InputMaybe<Array<InputMaybe<AccountAuthMethodSettingsInput>> | InputMaybe<AccountAuthMethodSettingsInput>>;
  customAuthMethods?: InputMaybe<Array<InputMaybe<CustomAuthMethodUpdateInput>> | InputMaybe<CustomAuthMethodUpdateInput>>;
}>;


export type UpdateAccountMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updateAccount?: { __typename?: 'Account', id?: string, parentId?: string, name?: string, accountManagerId?: string, settings?: any, createdAt?: any, updatedAt?: any, pictureFile?: { __typename?: 'File', url: string }, users?: { __typename?: 'PaginatedUsers', count?: number }, projects?: { __typename?: 'PaginatedProjects', count?: number }, customAuthMethods?: Array<{ __typename?: 'CustomAuthMethod', id?: string, clientId?: string, clientSecret?: string, issuerURL?: string, type?: CustomAuthMethodTypeEnum, emailAttribute?: string, usernameAttribute?: string, entityIssuer?: string, settings?: any }>, accountAuthMethodSettings?: Array<{ __typename?: 'AccountAuthMethodSettings', id?: string, isActive?: boolean, isDefault?: boolean, authMethodId?: string, customAuthMethodId?: string }> } } };

export type DeleteAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAccountMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', deleteAccount?: { __typename?: 'Account', id?: string } } };

export type GetAccountByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAccountByIdQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', accountById?: { __typename?: 'Account', id?: string, name?: string, createdAt?: any } } };

export type GetProjectByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProjectByIdQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', projectById?: { __typename?: 'Project', id: string, name: string, createdAt: any, accountId: string, projectProStudioSetting?: { __typename?: 'ProjectProStudioSetting', settings?: any, id?: string, customerId?: string, projectId?: string } } } };

export type GetTeamByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTeamByIdQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', teamById?: { __typename?: 'Team', id?: string, name?: string, createdAt?: any } } };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUserByIdQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', userById?: { __typename?: 'User', id: string, firstName: string, lastName: string, createdAt: any } } };

export type GetProjectEnvironmentConfigByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProjectEnvironmentConfigByIdQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', projectEnvironmentConfigById?: { __typename?: 'ProjectEnvironmentConfig', id?: string } } };

export type UserSessionSubscriptionSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UserSessionSubscriptionSubscription = { __typename?: 'subscription_root', tenancy_users: Array<{ __typename?: 'tenancy_users', id: string, userName: string, hasActiveSessions: boolean }> };

export type GetUserDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUserDetailsQuery = { __typename?: 'query_root', tenancy_users_by_pk?: { __typename?: 'tenancy_users', id: string, firstName: string, lastName: string, userName: string, picture?: string, settings?: any, requiredConsentStatus: any, optionalConsentStatus: any, files: Array<{ __typename?: 'tenancy_file', url: string }>, user_accounts: Array<{ __typename?: 'tenancy_user_accounts', id: string, accountId: string, isPrimaryAccount: boolean, user_account_projects: Array<{ __typename?: 'tenancy_user_account_projects', id: string, project: { __typename?: 'tenancy_projects', id: string, name: string, accountId: string, project_product_settings: Array<{ __typename?: 'tenancy_project_product_settings', settings?: any, product: { __typename?: 'tenancy_products', displayName?: string, name: string, id: string } }> }, _account_project_roles: Array<{ __typename?: 'tenancy__user_account_project_roles', role: { __typename?: 'tenancy_roles', id: string, name: string, productId: string, product: { __typename?: 'tenancy_products', id: string, displayName?: string, name: string } } }>, metabase_access: Array<{ __typename?: 'tenancy_user_account_project_metabase_access', dataset: string, collectionId: number, roleId: string }> }>, _user_account_roles: Array<{ __typename?: 'tenancy__user_account_roles', role: { __typename?: 'tenancy_roles', accountId: string, id: string, name: string, productId: string, product: { __typename?: 'tenancy_products', id: string, displayName?: string, name: string } } }> }>, _user_teams: Array<{ __typename?: 'tenancy__user_teams', team: { __typename?: 'tenancy_teams', id: string, name: string, team_accounts: Array<{ __typename?: 'tenancy_team_accounts', id: string, accountId: string, team_account_projects: Array<{ __typename?: 'tenancy_team_account_projects', project: { __typename?: 'tenancy_projects', id: string, name: string, accountId: string, project_product_settings: Array<{ __typename?: 'tenancy_project_product_settings', settings?: any, product: { __typename?: 'tenancy_products', displayName?: string, name: string, id: string } }> }, _team_account_project_roles: Array<{ __typename?: 'tenancy__team_account_project_roles', role: { __typename?: 'tenancy_roles', productId: string, id: string, name: string, product: { __typename?: 'tenancy_products', displayName?: string, name: string, id: string } } }> }>, _team_account_roles: Array<{ __typename?: 'tenancy__team_account_roles', role: { __typename?: 'tenancy_roles', productId: string, accountId: string, id: string, name: string, product: { __typename?: 'tenancy_products', displayName?: string, name: string, id: string } } }> }> } }> } };

export type GetUserAuthMethodsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUserAuthMethodsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', userById?: { __typename?: 'User', id: string, listOfAuthMethods?: Array<{ __typename?: 'UserAuthMethodData', accountAuthMethodSettingsId?: string, isCreationOne?: boolean, isActive?: boolean, name?: string, providerId?: string, isCustom?: boolean, type?: AuthMethodTypeEnum }> } } };

export type GetTeamDetailsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
}>;


export type GetTeamDetailsQuery = { __typename?: 'query_root', tenancy_teams_by_pk?: { __typename?: 'tenancy_teams', id: string, name: string, description?: string, usersFromCurrentOrg: Array<{ __typename?: 'tenancy__user_teams', user: { __typename?: 'tenancy_users', id: string, firstName: string, lastName: string, userName: string, lastActiveAt: any, picture?: string, status: string } }>, usersFromOtherOrgs: Array<{ __typename?: 'tenancy__user_teams', user: { __typename?: 'tenancy_users', id: string, firstName: string, lastName: string, userName: string, lastActiveAt: any, picture?: string, status: string } }>, team_accounts: Array<{ __typename?: 'tenancy_team_accounts', isPrimaryAccount: boolean, accountId: string, id: string, _team_account_roles: Array<{ __typename?: 'tenancy__team_account_roles', role: { __typename?: 'tenancy_roles', productId: string, accountId: string, id: string, name: string, product: { __typename?: 'tenancy_products', displayName?: string, name: string, id: string } } }>, team_account_projects: Array<{ __typename?: 'tenancy_team_account_projects', id: string, project: { __typename?: 'tenancy_projects', id: string, name: string, accountId: string, project_product_settings: Array<{ __typename?: 'tenancy_project_product_settings', product: { __typename?: 'tenancy_products', displayName?: string, name: string, id: string } }> }, _account_project_roles: Array<{ __typename?: 'tenancy__team_account_project_roles', role: { __typename?: 'tenancy_roles', productId: string, id: string, name: string, product: { __typename?: 'tenancy_products', displayName?: string, name: string, id: string } } }> }> }> }, tenancy_users: Array<{ __typename?: 'tenancy_users', id: string, firstName: string, lastName: string, userName: string, lastActiveAt: any, picture?: string, status: string }> };

export type GetNewTeamDetailsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type GetNewTeamDetailsQuery = { __typename?: 'query_root', tenancy_users: Array<{ __typename?: 'tenancy_users', id: string, firstName: string, lastName: string, userName: string, lastActiveAt: any, picture?: string, status: string }> };

export type UpdateTeamMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  projectIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  projectIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  roleIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  roleIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  userIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UpdateTeamMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updateTeam?: { __typename?: 'Team', id?: string, name?: string, description?: string, updatedAt?: any, assignedMembers?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, picture?: string, lastActiveAt: any, status: UserStatus }> } } };

export type CreateTeamMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  projectIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  projectIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  roleIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  roleIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  userIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateTeamMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', createTeam?: { __typename?: 'Team', id?: string, name?: string, description?: string, updatedAt?: any, assignedMembers?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, picture?: string, lastActiveAt: any, status: UserStatus }> } } };

export type DeleteTeamsMutationVariables = Exact<{
  teamIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteTeamsMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', deleteTeams?: Array<{ __typename?: 'OperationResult', succeeded?: boolean }> } };

export type SetTeamAccountProjectRolesMutationVariables = Exact<{
  teamId: Scalars['String']['input'];
  projectRolesUpdate: Array<InputMaybe<ProjectRolesUpdate>> | InputMaybe<ProjectRolesUpdate>;
}>;


export type SetTeamAccountProjectRolesMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', setTeamAccountProjectsRoles?: { __typename?: 'Team', id?: string } } };

export type SetUserAccountProjectsRolesMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  projectRolesUpdate: Array<InputMaybe<ProjectRolesUpdate>> | InputMaybe<ProjectRolesUpdate>;
  isConsolidatingDetails?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetUserAccountProjectsRolesMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', setUserAccountProjectsRoles?: { __typename?: 'User', id: string } } };

export type UpdateUserAccountRolesMutationVariables = Exact<{
  id: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  roleIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  roleIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  teamIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  teamIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  projectIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  projectIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  optionalConsentStatus?: InputMaybe<ConsentStatusEnum>;
  userIconId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserAccountRolesMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updateUser?: { __typename: 'User', id: string, userName: string, firstName: string, lastName: string, status: UserStatus, createdAt: any, updatedAt: any } } };

export type AddUserToAccountMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}>;


export type AddUserToAccountMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', addUserToAccount?: { __typename?: 'User', id: string, createdAt: any, lastActiveAt: any } } };

export type RemoveUserFromAccountMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  userIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveUserFromAccountMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', removeUsersFromAccount?: Array<{ __typename: 'OperationResult', entityId?: string, entityDisplayName?: string, succeeded?: boolean, errorDetails?: string }> } };

export type ShortProjectsFragmentFragment = { __typename?: 'PaginatedProjects', rows?: Array<{ __typename?: 'Project', id: string, accountId: string, name: string, projectProductSettings?: Array<{ __typename?: 'ProjectProductSetting', productId?: string, settings?: any, product?: { __typename?: 'Product', id?: string, displayName?: string, name?: ProductName } }> }> };

export type ShortTeamsFragmentFragment = { __typename?: 'PaginatedTeams', rows?: Array<{ __typename?: 'Team', id?: string, name?: string, assignedRoles?: Array<{ __typename?: 'Role', id?: string, name?: string, accountId?: string, productId?: string, product?: { __typename?: 'Product', displayName?: string, name?: ProductName, id?: string } }>, assignedProjects?: Array<{ __typename?: 'Project', id: string, name: string, accountId: string }> }> };

export type ShortRolesFragmentFragment = { __typename?: 'PaginatedRoles', rows?: Array<{ __typename?: 'Role', id?: string, name?: string, productId?: string, accountId?: string, product?: { __typename?: 'Product', id?: string, displayName?: string, name?: ProductName } }> };

export type ShortUsersFragmentFragment = { __typename?: 'tenancy_users', id: string, firstName: string, lastName: string, userName: string, lastActiveAt: any, picture?: string, status: string };

export type GetAccountDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAccountDetailsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', accountById?: { __typename?: 'Account', id?: string, name?: string, parentId?: string, allParentIds?: Array<string>, parentAccount?: { __typename?: 'Account', id?: string, name?: string, parentId?: string }, allChildAccounts?: Array<{ __typename?: 'Account', id?: string, name?: string, parentId?: string, allParentIds?: Array<string>, parentAccount?: { __typename?: 'Account', name?: string, id?: string, parentId?: string }, projects?: { __typename?: 'PaginatedProjects', rows?: Array<{ __typename?: 'Project', id: string, accountId: string, name: string, projectProductSettings?: Array<{ __typename?: 'ProjectProductSetting', productId?: string, settings?: any, product?: { __typename?: 'Product', id?: string, displayName?: string, name?: ProductName } }> }> }, teams?: { __typename?: 'PaginatedTeams', rows?: Array<{ __typename?: 'Team', id?: string, name?: string, assignedRoles?: Array<{ __typename?: 'Role', id?: string, name?: string, accountId?: string, productId?: string, product?: { __typename?: 'Product', displayName?: string, name?: ProductName, id?: string } }>, assignedProjects?: Array<{ __typename?: 'Project', id: string, name: string, accountId: string }> }> } }>, projects?: { __typename?: 'PaginatedProjects', rows?: Array<{ __typename?: 'Project', id: string, accountId: string, name: string, projectProductSettings?: Array<{ __typename?: 'ProjectProductSetting', productId?: string, settings?: any, product?: { __typename?: 'Product', id?: string, displayName?: string, name?: ProductName } }> }> }, teams?: { __typename?: 'PaginatedTeams', rows?: Array<{ __typename?: 'Team', id?: string, name?: string, assignedRoles?: Array<{ __typename?: 'Role', id?: string, name?: string, accountId?: string, productId?: string, product?: { __typename?: 'Product', displayName?: string, name?: ProductName, id?: string } }>, assignedProjects?: Array<{ __typename?: 'Project', id: string, name: string, accountId: string }> }> }, roles?: { __typename?: 'PaginatedRoles', rows?: Array<{ __typename?: 'Role', id?: string, name?: string, productId?: string, accountId?: string, product?: { __typename?: 'Product', id?: string, displayName?: string, name?: ProductName } }> } }, organizationMetadata?: { __typename?: 'OrganizationMetadata', canManageAccess?: boolean } } };

export type GetTeamProjectsDetailsQueryVariables = Exact<{
  teamId: Scalars['String']['input'];
}>;


export type GetTeamProjectsDetailsQuery = { __typename?: 'query_root', tenancy_teams_by_pk?: { __typename?: 'tenancy_teams', id: string, name: string, team_accounts: Array<{ __typename?: 'tenancy_team_accounts', accountId: string, id: string, _team_account_roles: Array<{ __typename?: 'tenancy__team_account_roles', role: { __typename?: 'tenancy_roles', productId: string, accountId: string, id: string, name: string, product: { __typename?: 'tenancy_products', displayName?: string, name: string, id: string } } }>, team_account_projects: Array<{ __typename?: 'tenancy_team_account_projects', project: { __typename?: 'tenancy_projects', id: string, name: string, accountId: string, project_product_settings: Array<{ __typename?: 'tenancy_project_product_settings', product: { __typename?: 'tenancy_products', displayName?: string, name: string, id: string } }> }, _team_account_project_roles: Array<{ __typename?: 'tenancy__team_account_project_roles', role: { __typename?: 'tenancy_roles', productId: string, id: string, name: string, product: { __typename?: 'tenancy_products', displayName?: string, name: string, id: string } } }> }> }> } };

export type ProjectDetailsFragmentFragment = { __typename?: 'tenancy_projects', accountId: string, name: string, picture?: string, id: string, description?: string, projectProductSettings: Array<{ __typename?: 'tenancy_project_product_settings', productId: string, projectId: string, settings?: any, product: { __typename?: 'tenancy_products', name: string, id: string } }> };

export type RoleDetailsFragment = { __typename?: 'tenancy_roles', productId: string, name: string, product: { __typename?: 'tenancy_products', name: string } };

export type GetUserProjectsHasuraQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
}>;


export type GetUserProjectsHasuraQuery = { __typename?: 'query_root', tenancy_user_accounts: Array<{ __typename?: 'tenancy_user_accounts', user_account_projects: Array<{ __typename?: 'tenancy_user_account_projects', project: { __typename?: 'tenancy_projects', updatedAt: any, accountId: string, name: string, picture?: string, id: string, description?: string, files: Array<{ __typename?: 'tenancy_file', url: string }>, projectProductSettings: Array<{ __typename?: 'tenancy_project_product_settings', productId: string, projectId: string, settings?: any, product: { __typename?: 'tenancy_products', name: string, id: string } }> }, _user_account_project_roles: Array<{ __typename?: 'tenancy__user_account_project_roles', role: { __typename?: 'tenancy_roles', productId: string, name: string, product: { __typename?: 'tenancy_products', name: string } } }> }>, user: { __typename?: 'tenancy_users', _user_teams: Array<{ __typename?: 'tenancy__user_teams', team: { __typename?: 'tenancy_teams', team_accounts: Array<{ __typename?: 'tenancy_team_accounts', team_account_projects: Array<{ __typename?: 'tenancy_team_account_projects', _team_account_project_roles: Array<{ __typename?: 'tenancy__team_account_project_roles', role: { __typename?: 'tenancy_roles', productId: string, name: string, product: { __typename?: 'tenancy_products', name: string } } }>, project: { __typename?: 'tenancy_projects', updatedAt: any, accountId: string, name: string, picture?: string, id: string, description?: string, files: Array<{ __typename?: 'tenancy_file', url: string }>, projectProductSettings: Array<{ __typename?: 'tenancy_project_product_settings', productId: string, projectId: string, settings?: any, product: { __typename?: 'tenancy_products', name: string, id: string } }> } }> }> } }> } }>, tenancy_products: Array<{ __typename?: 'tenancy_products', name: string, id: string, displayName?: string }> };

export type AgentManagerFileFieldsFragment = { __typename?: 'AgentManagerFile', path?: string, name?: string, sha?: string, size?: number, mimeType?: string, url?: string };

export type GetAssetsFilesQueryVariables = Exact<{
  solutionId: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
}>;


export type GetAssetsFilesQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', assetsFiles?: Array<{ __typename?: 'AgentManagerFile', path?: string, name?: string, sha?: string, size?: number, mimeType?: string, url?: string }> } };

export type GetConfigsFilesQueryVariables = Exact<{
  solutionId: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
}>;


export type GetConfigsFilesQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', configsFiles?: Array<{ __typename?: 'AgentManagerFile', path?: string, name?: string, sha?: string, size?: number, mimeType?: string, url?: string }> } };

export type GetScriptsFilesQueryVariables = Exact<{
  solutionId: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
}>;


export type GetScriptsFilesQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', scriptsFiles?: Array<{ __typename?: 'AgentManagerFile', path?: string, name?: string, sha?: string, size?: number, mimeType?: string, url?: string }> } };

export type GetCustomAssetsFilesQueryVariables = Exact<{
  solutionId: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
}>;


export type GetCustomAssetsFilesQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', customAssetsFiles?: Array<{ __typename?: 'AgentManagerFile', path?: string, name?: string, sha?: string, size?: number, mimeType?: string, url?: string }> } };

export type DeleteAgentManagerFileMutationVariables = Exact<{
  filePath: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
}>;


export type DeleteAgentManagerFileMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', deleteAgentManagerFile?: boolean } };

export type ChannelConfigurationFragment = { __typename?: 'CustomerChannelConfigResponse', analyticsApiHost?: string, analyticsApiKey?: string, analyticsDefault?: string, analyticsEnabled?: boolean, analyticsTranscriptEnabled?: boolean, endBot?: string, id?: string, lastUpdateBy?: string, lastUpdated?: string, name?: string, pypeId?: string, startBot?: string, type?: string, webhookUrl?: string, config?: { __typename?: 'CustomerChannelConfigResponseConfig', twilioVoiceId?: string, twilioVoiceConfig?: { __typename?: 'CustomerChannelConfigResponseTwilioConfig', accountSid?: string, authToken?: string, elevenlabsAudioModel?: string, elevenlabsSimilarity?: string, elevenlabsSpeed?: string, elevenlabsStability?: string, elevenlabsVoiceId?: string, handoffUrl?: string, initCallWebhookUrl?: string, language?: string, phoneNumber?: string, speechModel?: string, transcriptionProvider?: string, ttsProvider?: string, welcomeGreeting?: string, elevenlabsVoiceMetadataB64?: any, metadataIntegrationInfoB64?: string, voiceHandoffOptionsB64?: string } }, botRetry?: { __typename?: 'BotRetry', attempts?: number, timeout?: number } };

export type CreateChannelMutationVariables = Exact<{
  beta?: InputMaybe<Scalars['String']['input']>;
  botId?: InputMaybe<Scalars['String']['input']>;
  botName?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  customPypeCss?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  env?: InputMaybe<SolutionEnvironmentsEnum>;
  type?: InputMaybe<ChannelTypesEnum>;
  twilioParams?: InputMaybe<TwilioConfigInputBe>;
  config?: InputMaybe<DefaultChannelConfigInput>;
}>;


export type CreateChannelMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', createChannel?: { __typename?: 'ChannelCreationResponse', channelId?: string, channelName?: string, pypeId?: string, pypeName?: string, botPypes?: Array<{ __typename?: 'BotPypesResponseBE', agent_routing?: string, agent_routing_url?: string, agents_can_initiate_chats?: boolean, auto_joinable?: boolean, bot_url?: string, broadcast_stream_id?: string, chat_default_limit?: number, chat_log_http_headers?: string, chat_logs_email?: string, chat_logs_email_enabled?: boolean, chat_logs_end_point?: string, chat_logs_http_enabled?: boolean, checklist_complete?: boolean, company_type?: string, creation_date?: number, crm_enabled?: boolean, crm_label?: string, crm_url?: string, customer_id?: string, description?: string, email?: string, env?: SolutionEnvironmentsEnum, encrypted?: boolean, end_comment_display?: boolean, end_comment_required?: boolean, end_tags_display?: boolean, end_tags_required?: boolean, featured?: boolean, id?: string, last_updated?: number, logo?: string, logo_generated?: boolean, mode?: number, name?: string, phone?: string, reroute_limit?: number, sf_deployment?: string, slug?: string, status?: string, tags_categories?: any, tags_multiple?: boolean, tags_shortcuts?: boolean, url?: string, whitelist_domains?: string, widget_branding?: boolean, widget_gateway_identifier?: string, widget_version?: number, bot_retry?: { __typename?: 'BotRetryBE', attempts?: number, timeout?: number }, config?: { __typename?: 'PypeConfigBE', integration_headers?: any, integration_name?: string }, masking_rules?: Array<{ __typename?: 'SystemMaskingRulesBE', description?: string, name?: string, regex_patterns?: Array<string> }>, streams?: Array<{ __typename?: 'PypeStreamBE', abc_enabled?: boolean, abc_id?: string, analytics_api_host?: string, analytics_api_key?: string, analytics_default?: string, analytics_enabled?: boolean, analytics_transcript_enabled?: boolean, auto_joinable?: string, auto_start_with_bot?: boolean, awesome_font_icon?: string, bot_enabled?: boolean, bot_flag?: string, bot_id?: string, broadcast_channel?: string, broadcast_sms_limit?: string, creation_date?: number, csp_account_id?: string, csp_agent_bot_token?: string, csp_channel_type?: string, csp_enabled?: boolean, csp_id?: string, csp_inbox_id?: string, description?: string, end_chat_bot_enabled?: boolean, end_chat_bot_id?: string, fb_access_token?: string, fb_bot?: string, fb_enabled?: boolean, fb_id?: string, id?: string, is_default?: boolean, last_updated?: number, name?: string, priority?: string, pype_id?: string, sms_enabled?: boolean, sms_id?: string, sms_phone_id?: string, sms_phone_number?: string, sms_token?: string, start_chat_bot_enabled?: boolean, start_chat_bot_id?: string, status?: string, stream_name?: string, twilio_voice_config?: any, twilio_voice_enabled?: boolean, twilio_voice_id?: string, vaapi_config?: string, vaapi_enabled?: boolean, vaapi_id?: string, vaapi_integrator?: string, widgets?: Array<{ __typename?: 'PypeWidgetBE', beta?: string, created_by?: string, creation_date?: number, custom_pype_css?: string, enable_prechat?: string, id?: string, last_updated?: number, prechat_custom_field1_name?: string, prechat_custom_field1_value?: string, prechat_custom_field2_name?: string, prechat_custom_field2_value?: string, prechat_email?: string, prechat_firstname?: string, prechat_lastname?: string, prechat_msg?: string, prechat_phone?: string, pype_id?: string, stream_id?: string, style?: string, whitelist?: string, widget_name?: string }> }>, system_masking_rules?: Array<{ __typename?: 'SystemMaskingRulesBE', description?: string, name?: string, regex_patterns?: Array<string> }> }> } } };

export type PatchV3ConfigurationCustomersCustomerIdChannelChannelIdMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  v3ConfigurationCustomerChannelInput: V3ConfigurationCustomerChannelInput;
}>;


export type PatchV3ConfigurationCustomersCustomerIdChannelChannelIdMutation = { __typename?: 'mutation_root', patchV3ConfigurationCustomersCustomerIdChannelChannelId?: { __typename?: 'CustomerChannelConfigResponse', analyticsApiHost?: string, analyticsApiKey?: string, analyticsDefault?: string, analyticsEnabled?: boolean, analyticsTranscriptEnabled?: boolean, endBot?: string, id?: string, lastUpdateBy?: string, lastUpdated?: string, name?: string, pypeId?: string, startBot?: string, type?: string, webhookUrl?: string, config?: { __typename?: 'CustomerChannelConfigResponseConfig', twilioVoiceId?: string, twilioVoiceConfig?: { __typename?: 'CustomerChannelConfigResponseTwilioConfig', accountSid?: string, authToken?: string, elevenlabsAudioModel?: string, elevenlabsSimilarity?: string, elevenlabsSpeed?: string, elevenlabsStability?: string, elevenlabsVoiceId?: string, handoffUrl?: string, initCallWebhookUrl?: string, language?: string, phoneNumber?: string, speechModel?: string, transcriptionProvider?: string, ttsProvider?: string, welcomeGreeting?: string, elevenlabsVoiceMetadataB64?: any, metadataIntegrationInfoB64?: string, voiceHandoffOptionsB64?: string } }, botRetry?: { __typename?: 'BotRetry', attempts?: number, timeout?: number } } };

export type PatchV3ConfigurationCustomersCustomerIdChannelChannelIdSandboxMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  v3ConfigurationCustomerChannelInput: V3ConfigurationCustomerChannelInput;
}>;


export type PatchV3ConfigurationCustomersCustomerIdChannelChannelIdSandboxMutation = { __typename?: 'mutation_root', patchV3ConfigurationCustomersCustomerIdChannelChannelIdSandbox?: { __typename?: 'CustomerChannelConfigResponse', analyticsApiHost?: string, analyticsApiKey?: string, analyticsDefault?: string, analyticsEnabled?: boolean, analyticsTranscriptEnabled?: boolean, endBot?: string, id?: string, lastUpdateBy?: string, lastUpdated?: string, name?: string, pypeId?: string, startBot?: string, type?: string, webhookUrl?: string, config?: { __typename?: 'CustomerChannelConfigResponseConfig', twilioVoiceId?: string, twilioVoiceConfig?: { __typename?: 'CustomerChannelConfigResponseTwilioConfig', accountSid?: string, authToken?: string, elevenlabsAudioModel?: string, elevenlabsSimilarity?: string, elevenlabsSpeed?: string, elevenlabsStability?: string, elevenlabsVoiceId?: string, handoffUrl?: string, initCallWebhookUrl?: string, language?: string, phoneNumber?: string, speechModel?: string, transcriptionProvider?: string, ttsProvider?: string, welcomeGreeting?: string, elevenlabsVoiceMetadataB64?: any, metadataIntegrationInfoB64?: string, voiceHandoffOptionsB64?: string } }, botRetry?: { __typename?: 'BotRetry', attempts?: number, timeout?: number } } };

export type UpdateAnalyticsForChannelMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
  projectId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
  env: SolutionEnvironmentsEnum;
}>;


export type UpdateAnalyticsForChannelMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updateAnalyticsForChannel?: boolean } };

export type SolutionUserPresenceFieldsFragment = { __typename?: 'SolutionUserPresence', firstSeenAt?: any, id?: string, isActive?: boolean, lastSeenAt?: any, pageParams?: any, pagePath?: string, solutionId?: string };

export type SolutionUserPresenceSubscriptionSubscriptionVariables = Exact<{
  solutionId: Scalars['String']['input'];
}>;


export type SolutionUserPresenceSubscriptionSubscription = { __typename?: 'subscription_root', tenancy_solution_user_presence: Array<{ __typename?: 'tenancy_solution_user_presence', id: string, isActive: boolean, lastSeenAt: any, pagePath: string, pageParams?: any, userId: string, user: { __typename?: 'tenancy_users', firstName: string, lastName: string, picture?: string, id: string } }> };

export type UpsertSolutionUserPresenceMutationVariables = Exact<{
  solutionId: Scalars['String']['input'];
  pagePath: Scalars['String']['input'];
  pageParams?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpsertSolutionUserPresenceMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', upsertSolutionUserPresence?: { __typename?: 'SolutionUserPresence', firstSeenAt?: any, id?: string, isActive?: boolean, lastSeenAt?: any, pageParams?: any, pagePath?: string, solutionId?: string } } };

export type GetCredentialsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetCredentialsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', credentialsLimited?: Array<{ __typename?: 'LLMCredentialLimited', id?: string, name?: string, model?: string, llmProviderId?: string, llmProvider?: { __typename?: 'LLMProvider', name?: string } }> } };

export type CreateCredentialMutationVariables = Exact<{
  credential: LlmCredentialInput;
}>;


export type CreateCredentialMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', createCredential?: { __typename?: 'LLMCredential', id?: string } } };

export type PypeRuleGroupFieldsFragment = { __typename?: 'PypeRuleGroup', id?: string, name?: string, description?: string, type?: RuleCreationTypeEnum, pypes?: Array<{ __typename?: 'PypeRuleGroupPype', pypeId?: string, env?: SolutionEnvironmentsEnum }>, rules?: Array<{ __typename?: 'PypeRule', id?: string, name?: string, description?: string, type?: RuleCreationTypeEnum, rules?: Array<string> }> };

export type GetPypeRuleGroupsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetPypeRuleGroupsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', pypeRuleGroupsByProjectId?: Array<{ __typename?: 'PypeRuleGroup', id?: string, name?: string, description?: string, type?: RuleCreationTypeEnum, pypes?: Array<{ __typename?: 'PypeRuleGroupPype', pypeId?: string, env?: SolutionEnvironmentsEnum }>, rules?: Array<{ __typename?: 'PypeRule', id?: string, name?: string, description?: string, type?: RuleCreationTypeEnum, rules?: Array<string> }> }> } };

export type CreatePypeRuleGroupMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  rulesToAdd?: InputMaybe<Array<PypeRuleInput> | PypeRuleInput>;
}>;


export type CreatePypeRuleGroupMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', createPypeRuleGroup?: { __typename?: 'PypeRuleGroup', id?: string, name?: string, description?: string, type?: RuleCreationTypeEnum, pypes?: Array<{ __typename?: 'PypeRuleGroupPype', pypeId?: string, env?: SolutionEnvironmentsEnum }>, rules?: Array<{ __typename?: 'PypeRule', id?: string, name?: string, description?: string, type?: RuleCreationTypeEnum, rules?: Array<string> }> } } };

export type UpdatePypeRuleGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  rulesToAdd?: InputMaybe<Array<PypeRuleInput> | PypeRuleInput>;
  rulesToUpdate?: InputMaybe<Array<PypeRuleUpdateInput> | PypeRuleUpdateInput>;
  rulesToDelete?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdatePypeRuleGroupMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updatePypeRuleGroup?: { __typename?: 'PypeRuleGroup', id?: string, name?: string, description?: string, type?: RuleCreationTypeEnum, pypes?: Array<{ __typename?: 'PypeRuleGroupPype', pypeId?: string, env?: SolutionEnvironmentsEnum }>, rules?: Array<{ __typename?: 'PypeRule', id?: string, name?: string, description?: string, type?: RuleCreationTypeEnum, rules?: Array<string> }> } } };

export type DeletePypeRuleGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePypeRuleGroupMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', deletePypeRuleGroup?: boolean } };

export type AddPypeToPypeRuleGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  env: SolutionEnvironmentsEnum;
}>;


export type AddPypeToPypeRuleGroupMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', addPypeToPypeRuleGroup?: { __typename?: 'PypeRuleGroup', id?: string, name?: string, description?: string, type?: RuleCreationTypeEnum, pypes?: Array<{ __typename?: 'PypeRuleGroupPype', pypeId?: string, env?: SolutionEnvironmentsEnum }>, rules?: Array<{ __typename?: 'PypeRule', id?: string, name?: string, description?: string, type?: RuleCreationTypeEnum, rules?: Array<string> }> } } };

export type RemovePypeFromPypeRuleGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  env: SolutionEnvironmentsEnum;
}>;


export type RemovePypeFromPypeRuleGroupMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', removePypeFromPypeRuleGroup?: { __typename?: 'PypeRuleGroup', id?: string, name?: string, description?: string, type?: RuleCreationTypeEnum, pypes?: Array<{ __typename?: 'PypeRuleGroupPype', pypeId?: string, env?: SolutionEnvironmentsEnum }>, rules?: Array<{ __typename?: 'PypeRule', id?: string, name?: string, description?: string, type?: RuleCreationTypeEnum, rules?: Array<string> }> } } };

export type PypeConnectionFieldsFragment = { __typename?: 'PypeConnection', id?: string, name?: string, platformId?: string, environment?: SolutionEnvironmentsEnum, settings?: any, agentRouting?: string, agentRoutingUrl?: string, createdAt?: any, updatedAt?: any, pypes?: Array<{ __typename?: 'PypeConnectionPype', pypeId?: string, env?: SolutionEnvironmentsEnum }> };

export type GetPypeConnectionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetPypeConnectionsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', pypeConnectionsByProjectId?: Array<{ __typename?: 'PypeConnection', id?: string, name?: string, platformId?: string, environment?: SolutionEnvironmentsEnum, settings?: any, agentRouting?: string, agentRoutingUrl?: string, createdAt?: any, updatedAt?: any, pypes?: Array<{ __typename?: 'PypeConnectionPype', pypeId?: string, env?: SolutionEnvironmentsEnum }> }> } };

export type CreatePypeConnectionMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  platformId: Scalars['String']['input'];
  environment: SolutionEnvironmentsEnum;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  agentRouting?: InputMaybe<Scalars['String']['input']>;
  agentRoutingUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePypeConnectionMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', createPypeConnection?: { __typename?: 'PypeConnection', id?: string, name?: string, platformId?: string, environment?: SolutionEnvironmentsEnum, settings?: any, agentRouting?: string, agentRoutingUrl?: string, createdAt?: any, updatedAt?: any, pypes?: Array<{ __typename?: 'PypeConnectionPype', pypeId?: string, env?: SolutionEnvironmentsEnum }> } } };

export type UpdatePypeConnectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<SolutionEnvironmentsEnum>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  agentRouting?: InputMaybe<Scalars['String']['input']>;
  agentRoutingUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePypeConnectionMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updatePypeConnection?: { __typename?: 'PypeConnection', id?: string, name?: string, platformId?: string, environment?: SolutionEnvironmentsEnum, settings?: any, agentRouting?: string, agentRoutingUrl?: string, createdAt?: any, updatedAt?: any, pypes?: Array<{ __typename?: 'PypeConnectionPype', pypeId?: string, env?: SolutionEnvironmentsEnum }> } } };

export type DeletePypeConnectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePypeConnectionMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', deletePypeConnection?: boolean } };

export type AddPypeToPypeConnectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  env: SolutionEnvironmentsEnum;
}>;


export type AddPypeToPypeConnectionMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', addPypeToPypeConnection?: { __typename?: 'PypeConnection', id?: string, name?: string, platformId?: string, environment?: SolutionEnvironmentsEnum, settings?: any, agentRouting?: string, agentRoutingUrl?: string, createdAt?: any, updatedAt?: any, pypes?: Array<{ __typename?: 'PypeConnectionPype', pypeId?: string, env?: SolutionEnvironmentsEnum }> } } };

export type RemovePypeFromPypeConnectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  env: SolutionEnvironmentsEnum;
}>;


export type RemovePypeFromPypeConnectionMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', removePypeFromPypeConnection?: { __typename?: 'PypeConnection', id?: string, name?: string, platformId?: string, environment?: SolutionEnvironmentsEnum, settings?: any, agentRouting?: string, agentRoutingUrl?: string, createdAt?: any, updatedAt?: any, pypes?: Array<{ __typename?: 'PypeConnectionPype', pypeId?: string, env?: SolutionEnvironmentsEnum }> } } };

export type GetAgentRoutingSchemasQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type GetAgentRoutingSchemasQuery = { __typename?: 'query_root', externalLive?: { __typename?: 'PypeConfigurationExternalAgentSchema', integrations?: Array<{ __typename?: 'PypeConfigurationExternalAgentSchemaIntegrations', id?: string, integrationName?: string, callbackToken?: string, callbackURL?: string, integrationFields?: any }> }, externalSandbox?: { __typename?: 'PypeConfigurationExternalAgentSchema', integrations?: Array<{ __typename?: 'PypeConfigurationExternalAgentSchemaIntegrations', id?: string, integrationName?: string, callbackToken?: string, callbackURL?: string, integrationFields?: any }> }, internalLive?: { __typename?: 'AgentRoutingSchemas', data?: Array<{ __typename?: 'AgentRoutingSchema', agent_routing?: string, description?: string, label?: string, properties?: any }> }, internalSandbox?: { __typename?: 'AgentRoutingSchemas', data?: Array<{ __typename?: 'AgentRoutingSchema', agent_routing?: string, description?: string, label?: string, properties?: any }> } };

export type BulkUpdatePypesLiveMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  bulkPypeUpdateInput: BulkPypeUpdateInput;
}>;


export type BulkUpdatePypesLiveMutation = { __typename?: 'mutation_root', pypesPutCustomersPypes?: Array<{ __typename?: 'Pype', id?: string, name?: string }> };

export type BulkUpdatePypesSandboxMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  bulkPypeUpdateInput: BulkPypeUpdateInput;
}>;


export type BulkUpdatePypesSandboxMutation = { __typename?: 'mutation_root', pypesPutCustomersPypesSandbox?: Array<{ __typename?: 'Pype', id?: string, name?: string }> };

export type PutLiveAgentPypeLiveMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  pypeUpdateInput?: InputMaybe<PypeUpdateInput>;
}>;


export type PutLiveAgentPypeLiveMutation = { __typename?: 'mutation_root', pypesPutCutomerByIdPypesPypeById?: { __typename?: 'Pype', description?: string, id?: string, logo?: string, name?: string, agent_routing?: string, agent_routing_url?: string, agent_routing_config?: any, bot_retry?: { __typename?: 'BotRetry', timeout?: number, attempts?: number }, autoresponders?: { __typename?: 'Autoresponders', busy?: { __typename?: 'AutoresponderSetting', enable?: boolean, text?: string }, offline?: { __typename?: 'AutoresponderSetting', enable?: boolean, text?: string }, technical_error?: { __typename?: 'AutoresponderSetting', enable?: boolean, text?: string } } } };

export type PutLiveAgentPypeSandboxMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  pypeUpdateInput?: InputMaybe<PypeUpdateInput>;
}>;


export type PutLiveAgentPypeSandboxMutation = { __typename?: 'mutation_root', pypesPutCutomerByIdPypesPypeByIdSandbox?: { __typename?: 'Pype', description?: string, id?: string, logo?: string, name?: string, agent_routing?: string, agent_routing_url?: string, agent_routing_config?: any, bot_retry?: { __typename?: 'BotRetry', timeout?: number, attempts?: number }, autoresponders?: { __typename?: 'Autoresponders', busy?: { __typename?: 'AutoresponderSetting', enable?: boolean, text?: string }, offline?: { __typename?: 'AutoresponderSetting', enable?: boolean, text?: string }, technical_error?: { __typename?: 'AutoresponderSetting', enable?: boolean, text?: string } } } };

export type GetProStudioPerformanceMetricsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['timestamp']['input']>;
  to?: InputMaybe<Scalars['timestamp']['input']>;
}>;


export type GetProStudioPerformanceMetricsQuery = { __typename?: 'query_root', tenancy_pro_studio_performance_metrics: Array<{ __typename?: 'tenancy_pro_studio_performance_metrics', id: string, type: string, settings?: any, createdAt: any, updatedAt?: any }> };

export type GetProStudioPerformanceMetricByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProStudioPerformanceMetricByIdQuery = { __typename?: 'query_root', tenancy_pro_studio_performance_metrics_by_pk?: { __typename?: 'tenancy_pro_studio_performance_metrics', id: string, type: string, settings?: any, createdAt: any, updatedAt?: any } };

export type GetCustomersQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetCustomersQuery = { __typename?: 'query_root', gesGetCustomers?: Array<{ __typename?: 'Customer', avatar?: string, botLanguage?: string, description?: string, id?: string, isExternal?: boolean, name?: string }> };

export type GetEnvsListQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetEnvsListQuery = { __typename?: 'query_root', getListEnvs?: { __typename?: 'List', data?: Array<string> } };

export type GetProStudioVersionDataQueryVariables = Exact<{
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProStudioVersionDataQuery = { __typename?: 'query_root', tenancy_solution_versions_ps_by_pk?: { __typename?: 'tenancy_solution_versions_ps', solutionVersionId: string, lastServerSync?: any, lastServerSyncHash?: number, lastServerValidation?: any, lastServerValidationHash?: number, lastServerSyncError?: Array<string>, lastServerValidationMessages?: Array<string>, columnWidths?: any, columnPinningSettings?: any, columnWrapSettings?: any, solution_version_nodes_ps: Array<{ __typename?: 'tenancy_solution_version_nodes_ps', answerRequired: boolean, behaviors?: Array<string>, command?: string, decisionVariable?: string, cssClassname?: string, description?: string, id: string, intent?: string, lastModified?: any, message?: string, nextNodes?: Array<any>, nodeInput?: string, nluDisabled?: boolean, nodeName?: string, nodeNumber?: any, nodeTags?: string, nodeType: Tenancy_Node_Type_Enum_Ps_Enum, order: any, output?: Array<string>, parameterInput?: any, parameterInputMap?: any, richAssetContent?: any, richAssetContentMap?: any, analyticsEvent?: any, analyticsEventMap?: any, platformFlag?: string, richAssetType: Tenancy_Rich_Asset_Type_Enum_Ps_Enum, skillTag?: string, solutionVersionId: string, variables?: Array<string>, whatsNext?: Array<string>, utterances?: string, settings?: any }> } };

export type UpdateProStudioVersionSyncMutationVariables = Exact<{
  lastServerSync?: InputMaybe<Scalars['timestamp']['input']>;
  lastServerSyncHash?: InputMaybe<Scalars['Int']['input']>;
  lastServerSyncError?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  solutionVersionId?: Scalars['String']['input'];
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProStudioVersionSyncMutation = { __typename?: 'mutation_root', update_tenancy_solution_versions_ps_by_pk?: { __typename?: 'tenancy_solution_versions_ps', lastServerSync?: any, lastServerSyncHash?: number, lastServerSyncError?: Array<string>, lastServerValidation?: any, lastServerValidationHash?: number, lastServerValidationMessages?: Array<string> } };

export type UpdateProStudioVersionValidationMutationVariables = Exact<{
  solutionVersionId: Scalars['String']['input'];
  lastServerValidation?: InputMaybe<Scalars['timestamp']['input']>;
  lastServerValidationHash?: InputMaybe<Scalars['Int']['input']>;
  lastServerValidationMessages?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectProStudioSettingId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProStudioVersionValidationMutation = { __typename?: 'mutation_root', update_tenancy_solution_versions_ps_by_pk?: { __typename?: 'tenancy_solution_versions_ps', lastServerSync?: any, lastServerSyncHash?: number, lastServerSyncError?: Array<string>, lastServerValidation?: any, lastServerValidationHash?: number, lastServerValidationMessages?: Array<string> } };

export type GetProStudioNodeVersionsQueryVariables = Exact<{
  partialSolutionVersionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProStudioNodeVersionsQuery = { __typename?: 'query_root', tenancy_solution_version_nodes_ps: Array<{ __typename?: 'tenancy_solution_version_nodes_ps', solutionVersionId: string }> };

export type DeleteProStudioNodeMutationVariables = Exact<{
  nodeId?: InputMaybe<Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteProStudioNodeMutation = { __typename?: 'mutation_root', delete_tenancy_solution_version_nodes_ps?: { __typename?: 'tenancy_solution_version_nodes_ps_mutation_response', affected_rows: number } };

export type DeleteProStudioNodesMutationVariables = Exact<{
  nodeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteProStudioNodesMutation = { __typename?: 'mutation_root', delete_tenancy_solution_version_nodes_ps?: { __typename?: 'tenancy_solution_version_nodes_ps_mutation_response', affected_rows: number } };

export type DeleteAllProStudioNodesMutationVariables = Exact<{
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteAllProStudioNodesMutation = { __typename?: 'mutation_root', delete_tenancy_solution_version_nodes_ps?: { __typename?: 'tenancy_solution_version_nodes_ps_mutation_response', affected_rows: number } };

export type GetProStudioNodesQueryVariables = Exact<{
  solutionVersionId: Scalars['String']['input'];
}>;


export type GetProStudioNodesQuery = { __typename?: 'query_root', tenancy_solution_version_nodes_ps: Array<{ __typename?: 'tenancy_solution_version_nodes_ps', answerRequired: boolean, behaviors?: Array<string>, command?: string, cssClassname?: string, decisionVariable?: string, description?: string, id: string, intent?: string, lastModified?: any, message?: string, nextNodes?: Array<any>, nluDisabled?: boolean, nodeInput?: string, nodeName?: string, nodeNumber?: any, nodeTags?: string, nodeType: Tenancy_Node_Type_Enum_Ps_Enum, order: any, output?: Array<string>, parameterInput?: any, parameterInputMap?: any, platformFlag?: string, richAssetContent?: any, richAssetContentMap?: any, analyticsEvent?: any, analyticsEventMap?: any, richAssetType: Tenancy_Rich_Asset_Type_Enum_Ps_Enum, skillTag?: string, solutionVersionId: string, variables?: Array<string>, whatsNext?: Array<string>, utterances?: string, settings?: any }> };

export type UpdateProStudioNodeOrdersMutationVariables = Exact<{
  objects: Array<Tenancy_Solution_Version_Nodes_Ps_Insert_Input> | Tenancy_Solution_Version_Nodes_Ps_Insert_Input;
}>;


export type UpdateProStudioNodeOrdersMutation = { __typename?: 'mutation_root', insert_tenancy_solution_version_nodes_ps?: { __typename?: 'tenancy_solution_version_nodes_ps_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'tenancy_solution_version_nodes_ps', id: string, order: any }> } };

export type UpdateProStudioNodesMutationVariables = Exact<{
  objects: Array<Tenancy_Solution_Version_Nodes_Ps_Insert_Input> | Tenancy_Solution_Version_Nodes_Ps_Insert_Input;
}>;


export type UpdateProStudioNodesMutation = { __typename?: 'mutation_root', insert_tenancy_solution_version_nodes_ps?: { __typename?: 'tenancy_solution_version_nodes_ps_mutation_response', returning: Array<{ __typename?: 'tenancy_solution_version_nodes_ps', nodeType: Tenancy_Node_Type_Enum_Ps_Enum, nodeTags?: string, nodeNumber?: any, nodeName?: string, nodeInput?: string, nluDisabled?: boolean, nextNodes?: Array<any>, message?: string, lastModified?: any, intent?: string, id: string, description?: string, decisionVariable?: string, cssClassname?: string, behaviors?: Array<string>, command?: string, answerRequired: boolean, order: any, output?: Array<string>, platformFlag?: string, parameterInput?: any, parameterInputMap?: any, richAssetContent?: any, richAssetContentMap?: any, analyticsEvent?: any, analyticsEventMap?: any, richAssetType: Tenancy_Rich_Asset_Type_Enum_Ps_Enum, skillTag?: string, solutionVersionId: string, variables?: Array<string>, whatsNext?: Array<string>, utterances?: string, settings?: any }> } };

export type PostHistorySearchMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  searchBody?: InputMaybe<HistorySearchBody>;
}>;


export type PostHistorySearchMutation = { __typename?: 'mutation_root', postHistorySearch?: { __typename?: 'Version', data?: any } };

export type GetCustomerDataQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type GetCustomerDataQuery = { __typename?: 'query_root', getCustomerById?: { __typename?: 'BotManagerCustomer', data: any }, getCustomerBots?: { __typename?: 'List', data?: Array<string> }, getCustomerPackages?: { __typename?: 'BotManagerCustomer', data: any }, getCustomerResources?: { __typename?: 'BotManagerCustomer', data: any } };

export type GetBotByIdQueryVariables = Exact<{
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type GetBotByIdQuery = { __typename?: 'query_root', getBotById?: { __typename?: 'Bot', data: any } };

export type GetBotDataQueryVariables = Exact<{
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type GetBotDataQuery = { __typename?: 'query_root', getBotVersions?: { __typename?: 'List', data?: Array<string> }, getBotAssets?: { __typename?: 'List', data?: Array<string> }, getEntities?: { __typename?: 'Version', data?: any, messages?: string }, getIntents?: { __typename?: 'Version', data?: any, messages?: string }, getSupervisedLearning?: { __typename?: 'Version', data?: any, messages?: string }, getEnvBotVersions?: { __typename?: 'EnvBotVersionResponse', data?: any } };

export type GetVersionByIdQueryVariables = Exact<{
  versionId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type GetVersionByIdQuery = { __typename?: 'query_root', getVersionById?: { __typename?: 'Version', data?: any, messages?: string } };

export type ValidateVersionQueryVariables = Exact<{
  versionId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type ValidateVersionQuery = { __typename?: 'query_root', getVersionValidate?: { __typename?: 'VersionValidateResponse', data?: string } };

export type CreateCustomerBotMutationVariables = Exact<{
  botName: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  botType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCustomerBotMutation = { __typename?: 'mutation_root', postCustomerBots?: { __typename?: 'BotManagerCustomer', data: any } };

export type CreateBotVersionMutationVariables = Exact<{
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  basedOn?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateBotVersionMutation = { __typename?: 'mutation_root', postBotVersions?: { __typename?: 'Version', data?: any } };

export type DeleteBotMutationVariables = Exact<{
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type DeleteBotMutation = { __typename?: 'mutation_root', deleteBotById?: { __typename?: 'Bot', data: any } };

export type GetVersionFileQueryVariables = Exact<{
  filePath: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type GetVersionFileQuery = { __typename?: 'query_root', getVersionFile: string, getVersionGraph: string };

export type DeployBotVersionMutationVariables = Exact<{
  versionId: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  doVersionBump?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeployBotVersionMutation = { __typename?: 'mutation_root', putVersionDeploy?: { __typename?: 'Version', data?: any, messages?: string } };

export type PatchBotByIdMutationVariables = Exact<{
  botId: Scalars['String']['input'];
  botType: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type PatchBotByIdMutation = { __typename?: 'mutation_root', patchBotById?: { __typename?: 'Bot', data: any } };

export type PatchBotTranslationMutationVariables = Exact<{
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  translateInput: Scalars['Boolean']['input'];
  translateOutput: Scalars['Boolean']['input'];
}>;


export type PatchBotTranslationMutation = { __typename?: 'mutation_root', patchBotById?: { __typename?: 'Bot', data: any } };

export type PutVersionTrainMutationVariables = Exact<{
  versionId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type PutVersionTrainMutation = { __typename?: 'mutation_root', putVersionTrain?: { __typename?: 'Version', data?: any, messages?: string } };

export type GetAssetByIdQueryVariables = Exact<{
  assetId: Scalars['String']['input'];
  botId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type GetAssetByIdQuery = { __typename?: 'query_root', getBotAssetById?: { __typename?: 'Asset', data: any } };

export type DeleteBotAssetMutationVariables = Exact<{
  botId: Scalars['String']['input'];
  assetId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type DeleteBotAssetMutation = { __typename?: 'mutation_root', deleteBotAssetById?: { __typename?: 'Asset', data: any } };

export type DeleteScriptByIdMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  scriptId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
}>;


export type DeleteScriptByIdMutation = { __typename?: 'mutation_root', deleteVersionScriptById?: { __typename?: 'Version', data?: any, messages?: string } };

export type GetCustomerPypesV6QueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  botId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
}>;


export type GetCustomerPypesV6Query = { __typename?: 'query_root', pypesV6GetCustomersPypes?: { __typename?: 'V6CustomersResult', data?: Array<{ __typename?: 'V6CustomersInfo', id?: string, name?: string, status?: string, agent_routing?: string, agent_routing_url?: string, agent_routing_config?: any, description?: string, logo?: string, logo_generated?: boolean, bot_retry?: { __typename?: 'BotRetry', timeout?: number, attempts?: number }, streams?: Array<{ __typename?: 'V6Streams', id?: string, start_chat_bot_id?: string, start_chat_bot_enabled?: boolean, end_chat_bot_enabled?: boolean, end_chat_bot_id?: string, bot_enabled?: boolean, auto_start_with_bot?: boolean, name?: string, stream_name?: string, last_updated?: any, twilio_voice_config?: string, twilio_voice_enabled?: boolean, twilio_voice_id?: string, vaapi_enabled?: boolean, vaapi_config?: string, analytics_enabled?: boolean, widgets?: Array<{ __typename?: 'V6Widget', id?: string, style?: string, last_updated?: number, widget_name?: string, stream_id?: string, pype_id?: string, beta?: string, custom_pype_css?: string }> }> }> }, pypesV6GetCustomersPypesSandbox?: { __typename?: 'V6CustomersResult', data?: Array<{ __typename?: 'V6CustomersInfo', id?: string, name?: string, status?: string, agent_routing?: string, agent_routing_url?: string, agent_routing_config?: any, description?: string, logo?: string, logo_generated?: boolean, bot_retry?: { __typename?: 'BotRetry', timeout?: number, attempts?: number }, streams?: Array<{ __typename?: 'V6Streams', id?: string, start_chat_bot_id?: string, start_chat_bot_enabled?: boolean, end_chat_bot_enabled?: boolean, end_chat_bot_id?: string, bot_enabled?: boolean, auto_start_with_bot?: boolean, name?: string, stream_name?: string, last_updated?: any, twilio_voice_config?: string, twilio_voice_enabled?: boolean, twilio_voice_id?: string, vaapi_enabled?: boolean, vaapi_config?: string, analytics_enabled?: boolean, widgets?: Array<{ __typename?: 'V6Widget', id?: string, style?: string, last_updated?: number, widget_name?: string, stream_id?: string, pype_id?: string, beta?: string, custom_pype_css?: string }> }> }> } };

export type MutatePostWidgetLiveMutationVariables = Exact<{
  pypeId: Scalars['String']['input'];
  widgetId?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['String']['input'];
  requestAction: Scalars['String']['input'];
  widget_name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  custom_pype_css?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  beta?: InputMaybe<Scalars['String']['input']>;
  requestType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  authToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MutatePostWidgetLiveMutation = { __typename?: 'mutation_root', postV3BusinessWidget?: { __typename?: 'V3BusinessWidgetResponse', data?: { __typename?: 'V3BusinessWidgetDataResponse', id?: string, widget_name?: string, style?: string, pype_id?: string, stream_id?: string, last_updated?: any, custom_pype_css?: string, beta?: string, created_by?: string, creation_date?: any } } };

export type MutatePostWidgetSandboxMutationVariables = Exact<{
  pypeId: Scalars['String']['input'];
  widgetId?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['String']['input'];
  requestAction: Scalars['String']['input'];
  widget_name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  custom_pype_css?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  beta?: InputMaybe<Scalars['String']['input']>;
  requestType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  authToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MutatePostWidgetSandboxMutation = { __typename?: 'mutation_root', postV3BusinessWidgetSandbox?: { __typename?: 'V3BusinessWidgetResponse', data?: { __typename?: 'V3BusinessWidgetDataResponse', id?: string, widget_name?: string, style?: string, pype_id?: string, stream_id?: string, last_updated?: any, custom_pype_css?: string, beta?: string, created_by?: string, creation_date?: any } } };

export type MutatePutWidgetLiveMutationVariables = Exact<{
  pypeId: Scalars['String']['input'];
  widgetId?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['String']['input'];
  requestAction: Scalars['String']['input'];
  widget_name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  custom_pype_css?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  beta?: InputMaybe<Scalars['String']['input']>;
  requestType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  authToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MutatePutWidgetLiveMutation = { __typename?: 'mutation_root', putV3BusinessWidget?: { __typename?: 'V3BusinessWidgetResponse', data?: { __typename?: 'V3BusinessWidgetDataResponse', id?: string, widget_name?: string, style?: string, pype_id?: string, stream_id?: string, last_updated?: any, custom_pype_css?: string, beta?: string, created_by?: string, creation_date?: any } } };

export type MutatePutWidgetSandboxMutationVariables = Exact<{
  pypeId: Scalars['String']['input'];
  widgetId?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['String']['input'];
  requestAction: Scalars['String']['input'];
  widget_name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  custom_pype_css?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  beta?: InputMaybe<Scalars['String']['input']>;
  requestType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  authToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MutatePutWidgetSandboxMutation = { __typename?: 'mutation_root', putV3BusinessWidgetSandbox?: { __typename?: 'V3BusinessWidgetResponse', data?: { __typename?: 'V3BusinessWidgetDataResponse', id?: string, widget_name?: string, style?: string, pype_id?: string, stream_id?: string, last_updated?: any, custom_pype_css?: string, beta?: string, created_by?: string, creation_date?: any } } };

export type CreateStreamLiveMutationVariables = Exact<{
  pypeId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type CreateStreamLiveMutation = { __typename?: 'mutation_root', pypesPostCustomersPypesStreams?: { __typename?: 'Stream', id?: string } };

export type CreateStreamSandboxMutationVariables = Exact<{
  pypeId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type CreateStreamSandboxMutation = { __typename?: 'mutation_root', pypesPostCustomersPypesStreamsSandbox?: { __typename?: 'Stream', id?: string } };

export type UpdateStreamBotLiveMutationVariables = Exact<{
  pypeId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  startChatBotId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  endChatBotId?: InputMaybe<Scalars['String']['input']>;
  endChatBotEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  startChatBotEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateStreamBotLiveMutation = { __typename?: 'mutation_root', pypesPutCustomersPypesStreamsBot?: { __typename?: 'CustomerPypesStreamsBotResponse', id?: string, auto_start_with_bot?: boolean, bot_enabled?: boolean, end_chat_bot_enabled?: boolean, end_chat_bot_id?: string, start_chat_bot_enabled?: boolean, start_chat_bot_id?: string } };

export type UpdateStreamBotSandboxMutationVariables = Exact<{
  pypeId: Scalars['String']['input'];
  streamId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  startChatBotId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  endChatBotId?: InputMaybe<Scalars['String']['input']>;
  endChatBotEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  startChatBotEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateStreamBotSandboxMutation = { __typename?: 'mutation_root', pypesPutCustomersPypesStreamsBotSandbox?: { __typename?: 'CustomerPypesStreamsBotResponse', id?: string, auto_start_with_bot?: boolean, bot_enabled?: boolean, end_chat_bot_enabled?: boolean, end_chat_bot_id?: string, start_chat_bot_enabled?: boolean, start_chat_bot_id?: string } };

export type GetCustomersPypesAutorespondersQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type GetCustomersPypesAutorespondersQuery = { __typename?: 'query_root', pypesGetCustomersPypes?: Array<{ __typename?: 'Pype', id?: string, autoresponders?: { __typename?: 'Autoresponders', busy?: { __typename?: 'AutoresponderSetting', enable?: boolean, text?: string }, offline?: { __typename?: 'AutoresponderSetting', enable?: boolean, text?: string }, technical_error?: { __typename?: 'AutoresponderSetting', enable?: boolean, text?: string } } }>, pypesGetCustomersPypesSandbox?: Array<{ __typename?: 'Pype', id?: string, autoresponders?: { __typename?: 'Autoresponders', busy?: { __typename?: 'AutoresponderSetting', enable?: boolean, text?: string }, offline?: { __typename?: 'AutoresponderSetting', enable?: boolean, text?: string }, technical_error?: { __typename?: 'AutoresponderSetting', enable?: boolean, text?: string } } }> };

export type PutCustomerPypeLiveMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type PutCustomerPypeLiveMutation = { __typename?: 'mutation_root', pypesPutCutomerByIdPypesPypeById?: { __typename?: 'Pype', description?: string, id?: string, logo?: string, name?: string } };

export type PutCustomerPypeSandboxMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type PutCustomerPypeSandboxMutation = { __typename?: 'mutation_root', pypesPutCutomerByIdPypesPypeByIdSandbox?: { __typename?: 'Pype', description?: string, id?: string, logo?: string, name?: string } };

export type PatchPypeConfigLiveMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  agentRouting: AgentRouting;
  integrationHeaders?: InputMaybe<IntegrationHeadersInput>;
  integrationName?: InputMaybe<Scalars['String']['input']>;
  attempts?: InputMaybe<Scalars['Int']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PatchPypeConfigLiveMutation = { __typename?: 'mutation_root', patchV3ConfigurationPypePypeId?: { __typename?: 'PypeConfig', agent_routing?: string, bot_retry?: { __typename?: 'BotRetry', attempts?: number, timeout?: number }, config?: { __typename?: 'PypeConfigObject', integration_headers?: any, integration_name?: string } } };

export type PatchPypeConfigSandboxMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  agentRouting: AgentRouting;
  integrationHeaders?: InputMaybe<IntegrationHeadersInput>;
  integrationName?: InputMaybe<Scalars['String']['input']>;
  attempts?: InputMaybe<Scalars['Int']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PatchPypeConfigSandboxMutation = { __typename?: 'mutation_root', patchV3ConfigurationPypePypeIdSandbox?: { __typename?: 'PypeConfig', agent_routing?: string, bot_retry?: { __typename?: 'BotRetry', attempts?: number, timeout?: number }, config?: { __typename?: 'PypeConfigObject', integration_headers?: any, integration_name?: string } } };

export type GetPypeConfigLiveQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
}>;


export type GetPypeConfigLiveQuery = { __typename?: 'query_root', getV3ConfigurationPypePypeId?: { __typename?: 'PypeConfig', agent_routing?: string, bot_retry?: { __typename?: 'BotRetry', attempts?: number, timeout?: number }, config?: { __typename?: 'PypeConfigObject', integration_headers?: any, integration_name?: string } } };

export type GetPypeConfigSandboxQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
}>;


export type GetPypeConfigSandboxQuery = { __typename?: 'query_root', getV3ConfigurationPypePypeIdSandbox?: { __typename?: 'PypeConfig', agent_routing?: string, bot_retry?: { __typename?: 'BotRetry', attempts?: number, timeout?: number }, config?: { __typename?: 'PypeConfigObject', integration_headers?: any, integration_name?: string } } };

export type GetExternalAgentSchemasQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
}>;


export type GetExternalAgentSchemasQuery = { __typename?: 'query_root', getV3ConfigurationCustomersCustomerIdExternalAgentSchemas?: { __typename?: 'PypeConfigurationExternalAgentSchema', integrations?: Array<{ __typename?: 'PypeConfigurationExternalAgentSchemaIntegrations', callbackToken?: string, callbackURL?: string, id?: string, integrationFields?: any }> }, getV3ConfigurationCustomersCustomerIdExternalAgentSchemasSandbox?: { __typename?: 'PypeConfigurationExternalAgentSchema', integrations?: Array<{ __typename?: 'PypeConfigurationExternalAgentSchemaIntegrations', callbackToken?: string, callbackURL?: string, id?: string, integrationFields?: any }> } };

export type DeletePypeLiveMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type DeletePypeLiveMutation = { __typename?: 'mutation_root', pypesDeleteCustomersPypesById: string };

export type DeletePypeSandboxMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type DeletePypeSandboxMutation = { __typename?: 'mutation_root', pypesDeleteCustomersPypesByIdSandbox: string };

export type UploadBotAssetMutationVariables = Exact<{
  botId: Scalars['String']['input'];
  botAssetsInput?: BotAssetsInput;
  projectId: Scalars['String']['input'];
}>;


export type UploadBotAssetMutation = { __typename?: 'mutation_root', putBotAssets?: { __typename?: 'Asset', data: any } };

export type PostVersionsConfigMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
  configFile: Scalars['Upload']['input'];
}>;


export type PostVersionsConfigMutation = { __typename?: 'mutation_root', postVersionConfig?: { __typename?: 'Version', data?: any, messages?: string } };

export type PostVersionsScriptMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
  scriptFile: Array<InputMaybe<Scalars['Upload']['input']>> | InputMaybe<Scalars['Upload']['input']>;
}>;


export type PostVersionsScriptMutation = { __typename?: 'mutation_root', postVersionScript?: { __typename?: 'Version', data?: any, messages?: string } };

export type GetUserProjectsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserProjectsQuery = { __typename?: 'query_root', tenancy_users: Array<{ __typename?: 'tenancy_users', user_accounts: Array<{ __typename?: 'tenancy_user_accounts', user_account_projects: Array<{ __typename?: 'tenancy_user_account_projects', _user_account_project_roles: Array<{ __typename?: 'tenancy__user_account_project_roles', role: { __typename?: 'tenancy_roles', name: string, id: string, product: { __typename?: 'tenancy_products', name: string, id: string } } }>, project: { __typename?: 'tenancy_projects', id: string, name: string, accountId: string, project_product_settings: Array<{ __typename?: 'tenancy_project_product_settings', product: { __typename?: 'tenancy_products', id: string, name: string, displayName?: string } }> } }> }>, _user_teams: Array<{ __typename?: 'tenancy__user_teams', team: { __typename?: 'tenancy_teams', team_accounts: Array<{ __typename?: 'tenancy_team_accounts', team_account_projects: Array<{ __typename?: 'tenancy_team_account_projects', _team_account_project_roles: Array<{ __typename?: 'tenancy__team_account_project_roles', role: { __typename?: 'tenancy_roles', name: string, id: string, product: { __typename?: 'tenancy_products', name: string, id: string } } }>, project: { __typename?: 'tenancy_projects', id: string, name: string, accountId: string, project_product_settings: Array<{ __typename?: 'tenancy_project_product_settings', product: { __typename?: 'tenancy_products', id: string, name: string, displayName?: string } }> } }> }> } }> }> };

export type GetUserPictureByEmailQueryVariables = Exact<{
  userEmail: Scalars['String']['input'];
}>;


export type GetUserPictureByEmailQuery = { __typename?: 'query_root', tenancy_users: Array<{ __typename?: 'tenancy_users', picture?: string, files: Array<{ __typename?: 'tenancy_file', publicId: string, url: string }> }> };

export type UpdateColumnsWidthMutationVariables = Exact<{
  solutionVersionId?: Scalars['String']['input'];
  columnWidths?: Scalars['jsonb']['input'];
}>;


export type UpdateColumnsWidthMutation = { __typename?: 'mutation_root', update_tenancy_solution_versions_ps_by_pk?: { __typename?: 'tenancy_solution_versions_ps', columnWidths?: any } };

export type UpdateColumnPinningSettingsMutationVariables = Exact<{
  solutionVersionId?: Scalars['String']['input'];
  columnPinningSettings?: Scalars['jsonb']['input'];
}>;


export type UpdateColumnPinningSettingsMutation = { __typename?: 'mutation_root', update_tenancy_solution_versions_ps_by_pk?: { __typename?: 'tenancy_solution_versions_ps', columnPinningSettings?: any } };

export type UpdateColumnWrapSettingsMutationVariables = Exact<{
  solutionVersionId?: Scalars['String']['input'];
  columnWrapSettings?: Scalars['jsonb']['input'];
}>;


export type UpdateColumnWrapSettingsMutation = { __typename?: 'mutation_root', update_tenancy_solution_versions_ps_by_pk?: { __typename?: 'tenancy_solution_versions_ps', columnWrapSettings?: any } };

export type GetStudioResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudioResourcesQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', studioResources?: Array<{ __typename?: 'StudioResource', description?: string, endNodeNumber?: number, id?: string, name?: string, startNodeNumber?: number, type?: StudioResourceTypeEnum, nodes?: Array<{ __typename?: 'TemplateNode', answerRequired?: boolean, behaviors?: Array<string>, command?: string, cssClassname?: string, decisionVariable?: string, description?: string, id?: string, intent?: string, message?: string, nextNodes?: Array<number>, nluDisabled?: boolean, nodeInput?: string, nodeName?: string, nodeNumber?: number, nodeTags?: string, nodeType?: string, order?: number, output?: Array<string>, parameterInput?: any, platformFlag?: string, richAssetType?: string, skillTag?: string, studioResourceId?: string, utterances?: string, variables?: Array<string>, whatsNext?: Array<string> }> }> } };

export type GetActionNodeNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActionNodeNamesQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', getActionNodeNames: any } };

export type MutatePutWidgetAppDesignMutationVariables = Exact<{
  appId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  config: Scalars['JSON']['input'];
  schemaVersion?: Scalars['Int']['input'];
}>;


export type MutatePutWidgetAppDesignMutation = { __typename?: 'mutation_root', putWidgetAppDesign?: { __typename?: 'WidgetAppDesignResponse', config?: any, metadata?: { __typename?: 'WidgetAppDesignMetadata', revision?: string, schemaVersion?: number, updatedAt?: string, updatedBy?: { __typename?: 'WidgetAppDesignUpdatedBy', email?: string, id?: string } } } };

export type MutatePutWidgetAppDesignSandboxMutationVariables = Exact<{
  appId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  config: Scalars['JSON']['input'];
  schemaVersion?: Scalars['Int']['input'];
}>;


export type MutatePutWidgetAppDesignSandboxMutation = { __typename?: 'mutation_root', putWidgetAppDesignSandbox?: { __typename?: 'WidgetAppDesignResponse', config?: any, metadata?: { __typename?: 'WidgetAppDesignMetadata', revision?: string, schemaVersion?: number, updatedAt?: string, updatedBy?: { __typename?: 'WidgetAppDesignUpdatedBy', email?: string, id?: string } } } };

export type GetProjectUsersQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetProjectUsersQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', projectById?: { __typename?: 'Project', users?: { __typename?: 'PaginatedUsers', rows?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, picture?: string }> } } } };

export type AssignProjectProductAdminRolesMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type AssignProjectProductAdminRolesMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', assignProjectProductAdminRoles?: { __typename?: 'User', id: string } } };

export type GetProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProvidersQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', providers?: Array<{ __typename?: 'LLMProvider', id?: string, name?: string }> } };

export type GetPypeKeysLiveQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
}>;


export type GetPypeKeysLiveQuery = { __typename?: 'query_root', pypesGetCustomersPypesKeys?: { __typename?: 'ApiKeys', keys?: Array<{ __typename?: 'ApiKeyDetail', friendly_name?: string, description?: string, key?: string, date_created?: number, date_updated?: number }> } };

export type GetPypeKeysSandboxQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
}>;


export type GetPypeKeysSandboxQuery = { __typename?: 'query_root', pypesGetCustomersPypesKeysSandbox?: { __typename?: 'ApiKeys', keys?: Array<{ __typename?: 'ApiKeyDetail', friendly_name?: string, description?: string, key?: string, date_created?: number, date_updated?: number }> } };

export type PostPypeKeyLiveMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  apiKeyInput: ApiKeyInput;
}>;


export type PostPypeKeyLiveMutation = { __typename?: 'mutation_root', pypesPostCustomersPypesKeys?: { __typename?: 'ApiKey', friendly_name?: string, description?: string, key?: string, secret?: string } };

export type PostPypeKeySandboxMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  apiKeyInput: ApiKeyInput;
}>;


export type PostPypeKeySandboxMutation = { __typename?: 'mutation_root', pypesPostCustomersPypesKeysSandbox?: { __typename?: 'ApiKey', friendly_name?: string, description?: string, key?: string, secret?: string } };

export type PutPypeKeyLiveMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  apiKeyUpdateInput: ApiKeyUpdateInput;
}>;


export type PutPypeKeyLiveMutation = { __typename?: 'mutation_root', pypesPutCustomersPypesKeysById?: { __typename?: 'ApiKeyDetail', friendly_name?: string, description?: string, key?: string } };

export type PutPypeKeySandboxMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
  apiKeyUpdateInput: ApiKeyUpdateInput;
}>;


export type PutPypeKeySandboxMutation = { __typename?: 'mutation_root', pypesPutCustomersPypesKeysByIdSandbox?: { __typename?: 'ApiKeyDetail', friendly_name?: string, description?: string, key?: string } };

export type DeletePypeKeyLiveMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
}>;


export type DeletePypeKeyLiveMutation = { __typename?: 'mutation_root', pypesDeleteCustomersPypesKeysById: string };

export type DeletePypeKeySandboxMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  pypeId: Scalars['String']['input'];
}>;


export type DeletePypeKeySandboxMutation = { __typename?: 'mutation_root', pypesDeleteCustomersPypesKeysByIdSandbox: string };

export type LlmProviderFieldsFragment = { __typename?: 'LLMProvider', name?: string };

export type LlmCredentialFieldsFragment = { __typename?: 'LLMCredential', name?: string, model?: string, id?: string, llmProviderId?: string, llmProvider?: { __typename?: 'LLMProvider', name?: string } };

export type FileFieldsFragment = { __typename?: 'File', id: string, url: string, mimeType?: string, originalName?: string, publicId: string, size?: number };

export type SolutionVersionFieldsFragment = { __typename?: 'SolutionVersion', id?: string, name?: string, version?: number, isDraft?: boolean, botSolutionVersionId?: string, brandName?: string, status?: SolutionVersionStatusEnum, knowledgeAgentContext?: string, maxOutputTokens?: number, otherInformation?: string, solutionId?: string, supervisorName?: string, temperature?: number, tone?: string, topK?: number, topP?: number, files?: Array<{ __typename?: 'File', id: string, url: string, mimeType?: string, originalName?: string, publicId: string, size?: number }>, llmCredential?: { __typename?: 'LLMCredential', name?: string, model?: string, id?: string, llmProviderId?: string, llmProvider?: { __typename?: 'LLMProvider', name?: string } }, tasks?: Array<{ __typename?: 'SolutionTask', description?: string, id?: string, name?: string }> };

export type SolutionFieldsFragment = { __typename?: 'Solution', id?: string, name?: string, botSolutionId?: string, defaultDraftVersionId?: string, projectProStudioSettingId?: string, type?: SolutionTypeEnum, settings?: any, solutionVersions?: Array<{ __typename?: 'SolutionVersion', id?: string, name?: string, version?: number, isDraft?: boolean, botSolutionVersionId?: string, brandName?: string, status?: SolutionVersionStatusEnum, knowledgeAgentContext?: string, maxOutputTokens?: number, otherInformation?: string, solutionId?: string, supervisorName?: string, temperature?: number, tone?: string, topK?: number, topP?: number, files?: Array<{ __typename?: 'File', id: string, url: string, mimeType?: string, originalName?: string, publicId: string, size?: number }>, llmCredential?: { __typename?: 'LLMCredential', name?: string, model?: string, id?: string, llmProviderId?: string, llmProvider?: { __typename?: 'LLMProvider', name?: string } }, tasks?: Array<{ __typename?: 'SolutionTask', description?: string, id?: string, name?: string }> }> };

export type CreateSolutionMutationVariables = Exact<{
  projectProStudioSettingId: Scalars['String']['input'];
  solution: SolutionInput;
  version: SolutionVersionInput;
  createDefaultChannels?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateSolutionMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', createSolution?: { __typename?: 'Solution', id?: string, name?: string, botSolutionId?: string, defaultDraftVersionId?: string, projectProStudioSettingId?: string, type?: SolutionTypeEnum, settings?: any, solutionVersions?: Array<{ __typename?: 'SolutionVersion', id?: string, name?: string, version?: number, isDraft?: boolean, botSolutionVersionId?: string, brandName?: string, status?: SolutionVersionStatusEnum, knowledgeAgentContext?: string, maxOutputTokens?: number, otherInformation?: string, solutionId?: string, supervisorName?: string, temperature?: number, tone?: string, topK?: number, topP?: number, files?: Array<{ __typename?: 'File', id: string, url: string, mimeType?: string, originalName?: string, publicId: string, size?: number }>, llmCredential?: { __typename?: 'LLMCredential', name?: string, model?: string, id?: string, llmProviderId?: string, llmProvider?: { __typename?: 'LLMProvider', name?: string } }, tasks?: Array<{ __typename?: 'SolutionTask', description?: string, id?: string, name?: string }> }> } } };

export type UpdateSolutionVersionMutationVariables = Exact<{
  version: SolutionVersionInput;
}>;


export type UpdateSolutionVersionMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updateSolutionVersion?: { __typename?: 'SolutionVersion', id?: string, name?: string, version?: number, isDraft?: boolean, botSolutionVersionId?: string, brandName?: string, status?: SolutionVersionStatusEnum, knowledgeAgentContext?: string, maxOutputTokens?: number, otherInformation?: string, solutionId?: string, supervisorName?: string, temperature?: number, tone?: string, topK?: number, topP?: number, files?: Array<{ __typename?: 'File', id: string, url: string, mimeType?: string, originalName?: string, publicId: string, size?: number }>, llmCredential?: { __typename?: 'LLMCredential', name?: string, model?: string, id?: string, llmProviderId?: string, llmProvider?: { __typename?: 'LLMProvider', name?: string } }, tasks?: Array<{ __typename?: 'SolutionTask', description?: string, id?: string, name?: string }> } } };

export type UpdateSolutionDisplayNameMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
}>;


export type UpdateSolutionDisplayNameMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updateSolution?: { __typename?: 'Solution', displayName?: string, id?: string, name?: string, botSolutionId?: string } } };

export type UpdateSolutionTypeMutationVariables = Exact<{
  solutionId: Scalars['String']['input'];
  type: SolutionTypeEnum;
}>;


export type UpdateSolutionTypeMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updateSolution?: { __typename?: 'Solution', id?: string, type?: SolutionTypeEnum } } };

export type DeleteSolutionMutationVariables = Exact<{
  solutionId: Scalars['String']['input'];
}>;


export type DeleteSolutionMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', deleteSolution?: boolean } };

export type PublishSolutionVersionMutationVariables = Exact<{
  draftVersionId: Scalars['String']['input'];
  environment: SolutionEnvironmentsEnum;
  useBotCompiler?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PublishSolutionVersionMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', publishSolutionVersion?: boolean } };

export type RepublishSolutionDeploymentMutationVariables = Exact<{
  solutionDeploymentId: Scalars['String']['input'];
}>;


export type RepublishSolutionDeploymentMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', republishSolutionDeployment?: boolean } };

export type GetSolutionsQueryVariables = Exact<{
  projectProStudioSettingId: Scalars['String']['input'];
}>;


export type GetSolutionsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', solutions?: Array<{ __typename?: 'Solution', botSolutionId?: string, defaultDraftVersionId?: string, displayName?: string, id?: string, name?: string, type?: SolutionTypeEnum, settings?: any }> } };

export type GetSolutionVersionsQueryVariables = Exact<{
  solutionId: Scalars['String']['input'];
}>;


export type GetSolutionVersionsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', solutionVersions?: Array<{ __typename?: 'SolutionVersion', id?: string, name?: string, version?: number, isDraft?: boolean, botSolutionVersionId?: string, brandName?: string, status?: SolutionVersionStatusEnum, knowledgeAgentContext?: string, maxOutputTokens?: number, otherInformation?: string, solutionId?: string, supervisorName?: string, temperature?: number, tone?: string, topK?: number, topP?: number, files?: Array<{ __typename?: 'File', id: string, url: string, mimeType?: string, originalName?: string, publicId: string, size?: number }>, llmCredential?: { __typename?: 'LLMCredential', name?: string, model?: string, id?: string, llmProviderId?: string, llmProvider?: { __typename?: 'LLMProvider', name?: string } }, tasks?: Array<{ __typename?: 'SolutionTask', description?: string, id?: string, name?: string }> }> } };

export type GetSolutionVersionByIdQueryVariables = Exact<{
  solutionVersionByIdId: Scalars['String']['input'];
}>;


export type GetSolutionVersionByIdQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', solutionVersionById?: { __typename?: 'SolutionVersion', id?: string, name?: string, version?: number, isDraft?: boolean, botSolutionVersionId?: string, brandName?: string, status?: SolutionVersionStatusEnum, knowledgeAgentContext?: string, maxOutputTokens?: number, otherInformation?: string, solutionId?: string, supervisorName?: string, temperature?: number, tone?: string, topK?: number, topP?: number, files?: Array<{ __typename?: 'File', id: string, url: string, mimeType?: string, originalName?: string, publicId: string, size?: number }>, llmCredential?: { __typename?: 'LLMCredential', name?: string, model?: string, id?: string, llmProviderId?: string, llmProvider?: { __typename?: 'LLMProvider', name?: string } }, tasks?: Array<{ __typename?: 'SolutionTask', description?: string, id?: string, name?: string }> } } };

export type GetSolutionByIdQueryVariables = Exact<{
  solutionByIdId: Scalars['String']['input'];
}>;


export type GetSolutionByIdQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', solutionById?: { __typename?: 'Solution', id?: string, name?: string, botSolutionId?: string, defaultDraftVersionId?: string, projectProStudioSettingId?: string, type?: SolutionTypeEnum, settings?: any, live?: { __typename?: 'SolutionDeployment', deployedAt?: any, status?: string, deployedBy?: { __typename?: 'DeployedByUser', firstName?: string, lastName?: string, picture?: string }, solutionVersion?: { __typename?: 'SolutionVersion', id?: string, name?: string, version?: number } }, sandbox?: { __typename?: 'SolutionDeployment', deployedAt?: any, status?: string, deployedBy?: { __typename?: 'DeployedByUser', firstName?: string, lastName?: string, picture?: string }, solutionVersion?: { __typename?: 'SolutionVersion', id?: string, name?: string, version?: number } }, solutionVersions?: Array<{ __typename?: 'SolutionVersion', id?: string, name?: string, version?: number, isDraft?: boolean, botSolutionVersionId?: string, brandName?: string, status?: SolutionVersionStatusEnum, knowledgeAgentContext?: string, maxOutputTokens?: number, otherInformation?: string, solutionId?: string, supervisorName?: string, temperature?: number, tone?: string, topK?: number, topP?: number, files?: Array<{ __typename?: 'File', id: string, url: string, mimeType?: string, originalName?: string, publicId: string, size?: number }>, llmCredential?: { __typename?: 'LLMCredential', name?: string, model?: string, id?: string, llmProviderId?: string, llmProvider?: { __typename?: 'LLMProvider', name?: string } }, tasks?: Array<{ __typename?: 'SolutionTask', description?: string, id?: string, name?: string }> }> } } };

export type GetSolutionDeploymentHistoryQueryVariables = Exact<{
  solutionId: Scalars['String']['input'];
}>;


export type GetSolutionDeploymentHistoryQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', solutionById?: { __typename?: 'Solution', id?: string, solutionDeployments?: Array<{ __typename?: 'SolutionDeployment', id?: string, environment?: SolutionEnvironmentsEnum, status?: string, deployedAt?: any, isRepublish?: boolean, deployedBy?: { __typename?: 'DeployedByUser', firstName?: string, lastName?: string, picture?: string }, solutionVersion?: { __typename?: 'SolutionVersion', id?: string, name?: string, version?: number } }> } } };

export type GetSolutionVersionPsKeysQueryVariables = Exact<{
  keys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetSolutionVersionPsKeysQuery = { __typename?: 'query_root', tenancy_solution_versions_ps: Array<{ __typename?: 'tenancy_solution_versions_ps', solutionVersionId: string, isUsingUpdatedId: boolean }> };

export type SolutionDeploymentsSubscriptionSubscriptionVariables = Exact<{
  solutionId: Scalars['String']['input'];
}>;


export type SolutionDeploymentsSubscriptionSubscription = { __typename?: 'subscription_root', tenancy_solution_deployments: Array<{ __typename?: 'tenancy_solution_deployments', id: string, environment: string, status: string, deployedAt: any, deployedBy: string, isRepublish: boolean, isLatest: boolean, solutionVersionId: string, createdAt: any, updatedAt?: any, solution_version: { __typename?: 'tenancy_solution_versions', id: string, name?: string, version?: number }, solution_deployment_runs: Array<{ __typename?: 'tenancy_solution_deployment_runs', id: string, status: string, updatedAt?: any }> }> };

export type GetSolutionDeploymentForVersionQueryVariables = Exact<{
  solutionVersionId: Scalars['String']['input'];
  environment: Scalars['String']['input'];
}>;


export type GetSolutionDeploymentForVersionQuery = { __typename?: 'query_root', tenancy_solution_deployments: Array<{ __typename?: 'tenancy_solution_deployments', id: string }> };

export type GetSolutionPublishedEnvironmentsQueryVariables = Exact<{
  solutionId: Scalars['String']['input'];
}>;


export type GetSolutionPublishedEnvironmentsQuery = { __typename?: 'query_root', tenancy_solution_deployments: Array<{ __typename?: 'tenancy_solution_deployments', environment: string }> };

export type GetSolutionDeploymentLogsQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetSolutionDeploymentLogsQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', solutionDeploymentLogs?: { __typename?: 'SolutionDeploymentLogs', rawLogs?: string, structuredLogs?: Array<{ __typename?: 'SolutionDeploymentLogStep', name: string, status: SolutionDeploymentLogStepStatusEnum, lines: Array<string> }> } } };

export type SolutionPublishStatusSubscriptionSubscriptionVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SolutionPublishStatusSubscriptionSubscription = { __typename?: 'subscription_root', tenancy_solutions_by_pk?: { __typename?: 'tenancy_solutions', id: string, status: any, publishStartedAt?: any } };

export type SolutionVersionStatusSubscriptionSubscriptionVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SolutionVersionStatusSubscriptionSubscription = { __typename?: 'subscription_root', tenancy_solution_versions_by_pk?: { __typename?: 'tenancy_solution_versions', id: string, status: any } };

export type SolutionVersionSubscriptionSubscriptionVariables = Exact<{
  solutionVersionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SolutionVersionSubscriptionSubscription = { __typename?: 'subscription_root', tenancy_solution_versions_ps_by_pk?: { __typename?: 'tenancy_solution_versions_ps', solutionVersionId: string, lastServerSync?: any, lastServerSyncHash?: number, lastServerValidation?: any, lastServerValidationHash?: number, lastServerSyncError?: Array<string>, lastServerValidationMessages?: Array<string>, columnWidths?: any, columnPinningSettings?: any, columnWrapSettings?: any, solution_version_nodes_ps: Array<{ __typename?: 'tenancy_solution_version_nodes_ps', answerRequired: boolean, behaviors?: Array<string>, command?: string, decisionVariable?: string, cssClassname?: string, description?: string, id: string, intent?: string, lastModified?: any, message?: string, nextNodes?: Array<any>, nodeInput?: string, nluDisabled?: boolean, nodeName?: string, nodeNumber?: any, nodeTags?: string, nodeType: Tenancy_Node_Type_Enum_Ps_Enum, order: any, output?: Array<string>, parameterInput?: any, parameterInputMap?: any, richAssetContent?: any, richAssetContentMap?: any, analyticsEvent?: any, analyticsEventMap?: any, platformFlag?: string, richAssetType: Tenancy_Rich_Asset_Type_Enum_Ps_Enum, skillTag?: string, solutionVersionId: string, variables?: Array<string>, whatsNext?: Array<string>, utterances?: string, settings?: any }> } };

export type VoiceAiProviderFragment = { __typename?: 'VoiceAiProvider', free_users_allowed?: string, gender?: string, image_url?: string, instagram_username?: string, is_added_by_user?: boolean, accent?: string, age?: string, category?: string, cloned_by_count?: number, date_unix?: number, description?: string, descriptive?: string, featured?: boolean, fiat_rate?: number, language?: string, live_moderation_enabled?: boolean, locale?: string, name?: string, notice_period?: number, play_api_usage_character_count_1y?: number, preview_url?: string, public_owner_id?: string, rate?: number, tiktok_username?: string, twitter_username?: string, usage_character_count_1y?: number, usage_character_count_7d?: number, use_case?: string, voice_id?: string, youtube_username?: string, verified_languages?: Array<{ __typename?: 'VoiceAiProviderVerifiedLanguage', accent?: string, language?: string, locale?: string, model_id?: string, preview_url?: string }> };

export type VoiceAiProviderResultFragmentFragment = { __typename?: 'VoiceAiProviderResult', count?: number, current_page?: number, has_more?: boolean, voices?: Array<{ __typename?: 'VoiceAiProvider', free_users_allowed?: string, gender?: string, image_url?: string, instagram_username?: string, is_added_by_user?: boolean, accent?: string, age?: string, category?: string, cloned_by_count?: number, date_unix?: number, description?: string, descriptive?: string, featured?: boolean, fiat_rate?: number, language?: string, live_moderation_enabled?: boolean, locale?: string, name?: string, notice_period?: number, play_api_usage_character_count_1y?: number, preview_url?: string, public_owner_id?: string, rate?: number, tiktok_username?: string, twitter_username?: string, usage_character_count_1y?: number, usage_character_count_7d?: number, use_case?: string, voice_id?: string, youtube_username?: string, verified_languages?: Array<{ __typename?: 'VoiceAiProviderVerifiedLanguage', accent?: string, language?: string, locale?: string, model_id?: string, preview_url?: string }> }> };

export type GetVoiceAiProvidersQueryVariables = Exact<{
  args: GetVoiceAiProvidersInput;
}>;


export type GetVoiceAiProvidersQuery = { __typename?: 'query_root', getVoiceAiProviders?: { __typename?: 'VoiceAiProviderResult', count?: number, current_page?: number, has_more?: boolean, voices?: Array<{ __typename?: 'VoiceAiProvider', free_users_allowed?: string, gender?: string, image_url?: string, instagram_username?: string, is_added_by_user?: boolean, accent?: string, age?: string, category?: string, cloned_by_count?: number, date_unix?: number, description?: string, descriptive?: string, featured?: boolean, fiat_rate?: number, language?: string, live_moderation_enabled?: boolean, locale?: string, name?: string, notice_period?: number, play_api_usage_character_count_1y?: number, preview_url?: string, public_owner_id?: string, rate?: number, tiktok_username?: string, twitter_username?: string, usage_character_count_1y?: number, usage_character_count_7d?: number, use_case?: string, voice_id?: string, youtube_username?: string, verified_languages?: Array<{ __typename?: 'VoiceAiProviderVerifiedLanguage', accent?: string, language?: string, locale?: string, model_id?: string, preview_url?: string }> }> } };

export type GetVoiceAiProvidersSandboxQueryVariables = Exact<{
  args: GetVoiceAiProvidersInput;
}>;


export type GetVoiceAiProvidersSandboxQuery = { __typename?: 'query_root', getVoiceAiProvidersSandbox?: { __typename?: 'VoiceAiProviderResult', count?: number, current_page?: number, has_more?: boolean, voices?: Array<{ __typename?: 'VoiceAiProvider', free_users_allowed?: string, gender?: string, image_url?: string, instagram_username?: string, is_added_by_user?: boolean, accent?: string, age?: string, category?: string, cloned_by_count?: number, date_unix?: number, description?: string, descriptive?: string, featured?: boolean, fiat_rate?: number, language?: string, live_moderation_enabled?: boolean, locale?: string, name?: string, notice_period?: number, play_api_usage_character_count_1y?: number, preview_url?: string, public_owner_id?: string, rate?: number, tiktok_username?: string, twitter_username?: string, usage_character_count_1y?: number, usage_character_count_7d?: number, use_case?: string, voice_id?: string, youtube_username?: string, verified_languages?: Array<{ __typename?: 'VoiceAiProviderVerifiedLanguage', accent?: string, language?: string, locale?: string, model_id?: string, preview_url?: string }> }> } };

export type GetVoiceAiVoicesV2QueryVariables = Exact<{
  args: GetVoiceAiVoicesV2Input;
}>;


export type GetVoiceAiVoicesV2Query = { __typename?: 'query_root', getVoiceAiVoicesV2?: { __typename?: 'VoiceAiProviderResult', count?: number, current_page?: number, has_more?: boolean, voices?: Array<{ __typename?: 'VoiceAiProvider', free_users_allowed?: string, gender?: string, image_url?: string, instagram_username?: string, is_added_by_user?: boolean, accent?: string, age?: string, category?: string, cloned_by_count?: number, date_unix?: number, description?: string, descriptive?: string, featured?: boolean, fiat_rate?: number, language?: string, live_moderation_enabled?: boolean, locale?: string, name?: string, notice_period?: number, play_api_usage_character_count_1y?: number, preview_url?: string, public_owner_id?: string, rate?: number, tiktok_username?: string, twitter_username?: string, usage_character_count_1y?: number, usage_character_count_7d?: number, use_case?: string, voice_id?: string, youtube_username?: string, verified_languages?: Array<{ __typename?: 'VoiceAiProviderVerifiedLanguage', accent?: string, language?: string, locale?: string, model_id?: string, preview_url?: string }> }> } };

export type GetVoiceAiAccentsQueryVariables = Exact<{
  args: GetVoiceAiAccentsInput;
}>;


export type GetVoiceAiAccentsQuery = { __typename?: 'query_root', getVoiceAiAccents?: { __typename?: 'VoiceAiAccentsResult', language?: string, accents?: Array<string> } };

export type GetVoiceAiLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVoiceAiLanguagesQuery = { __typename?: 'query_root', getVoiceAiLanguages?: { __typename?: 'VoiceAiLanguagesResult', count?: number, languages?: Array<{ __typename?: 'VoiceAiLanguage', language?: string, name?: string, default_locale?: string, stt_providers?: Array<string>, locales?: Array<{ __typename?: 'VoiceAiLanguageLocale', locale?: string, stt_providers?: Array<string> }> }> } };

export type GetUserLoginInfoQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserLoginInfoQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', getUserLoginInfo?: { __typename?: 'UserLoginInfo', email?: string, passwordRecoveryStatus?: PasswordRecoveryStatusEnum, authMethods?: Array<{ __typename?: 'UserAuthMethod', isActive?: boolean, isCreationOne?: boolean, isCustom?: boolean, name?: string, providerId?: string, type?: AuthMethodTypeEnum }> } } };

export type SetUserPasswordRecoveryStatusMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  passwordRecoveryStatus: PasswordRecoveryStatusEnum;
}>;


export type SetUserPasswordRecoveryStatusMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', setUserPasswordRecoveryStatus?: { __typename?: 'User', status: UserStatus } } };

export type StartUserRecoveryProcessMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type StartUserRecoveryProcessMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', startUserRecoveryProcess?: boolean } };

export type FinishUserRecoveryProcessMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type FinishUserRecoveryProcessMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', finishUserRecoveryProcess?: boolean } };

export type CompleteLoginMutationVariables = Exact<{
  identityId: Scalars['String']['input'];
  loginChallenge: Scalars['String']['input'];
}>;


export type CompleteLoginMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', completeLogin?: string } };

export type GetConsentInfoQueryVariables = Exact<{
  consentChallenge: Scalars['String']['input'];
}>;


export type GetConsentInfoQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', getConsentInfo?: { __typename?: 'ConsentInfo', challenge?: string, skip?: boolean, client?: any, subject?: string, requestedScope?: Array<string>, requestedAccessTokenAudience?: Array<string>, requestUrl?: string } } };

export type HandleOAuth2ConsentMutationVariables = Exact<{
  consentChallenge: Scalars['String']['input'];
  grantScope: Array<Scalars['String']['input']> | Scalars['String']['input'];
  reject: Scalars['Boolean']['input'];
  remember: Scalars['Boolean']['input'];
  rememberFor?: InputMaybe<Scalars['Int']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  grantAudience?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type HandleOAuth2ConsentMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', handleConsent?: string } };

export type GetUserInfoLimitedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoLimitedQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', currentUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, picture?: string, settings?: any, status: UserStatus, requiredConsentStatus?: ConsentStatusEnum, optionalConsentStatus?: ConsentStatusEnum, email: string, defaultAccount?: { __typename?: 'Account', id?: string, name?: string, parentId?: string, status?: AccountStatus, accountManagerId?: string, pictureFile?: { __typename?: 'File', url: string }, allChildAccounts?: Array<{ __typename?: 'Account', name?: string, parentId?: string, id?: string, status?: AccountStatus, accountManagerId?: string, pictureFile?: { __typename?: 'File', url: string } }> }, pictureFile?: { __typename?: 'File', url: string }, assignedRoles?: Array<{ __typename?: 'Role', id?: string, name?: string }>, assignedTeams?: Array<{ __typename?: 'Team', name?: string, id?: string, assignedRoles?: Array<{ __typename?: 'Role', id?: string, name?: string }>, assignedProjects?: Array<{ __typename?: 'Project', id: string }> }> } } };

export type GetUserSettingsLimitedQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserSettingsLimitedQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', getLoginInfo?: { __typename?: 'LoginInfo', recommendedAuthMethod?: string } } };

export type UpdateUserLimitedMutationVariables = Exact<{
  id: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  requiredConsentStatus?: InputMaybe<ConsentStatusEnum>;
  optionalConsentStatus?: InputMaybe<ConsentStatusEnum>;
  requiredConsentUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optionalConsentUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  userIconId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserLimitedMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', updateUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, status: UserStatus, settings?: any, picture?: string, email: string, pictureFile?: { __typename?: 'File', url: string } } } };

export type GetLanguagesLimitedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLanguagesLimitedQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', localizationSettingsConfig?: { __typename?: 'LocalizationSettingsConfig', user: { __typename?: 'LocalizationSettingsEntityConfig', supportedLanguageCodes: Array<string> }, project: { __typename?: 'LocalizationSettingsEntityConfig', supportedLanguageCodes: Array<string> } }, locales?: Array<{ __typename: 'Locale', id: string, name: string, locale: string, languageCode: string }> } };

export type GetTimeZonesLimitedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimeZonesLimitedQuery = { __typename?: 'query_root', admin_?: { __typename?: 'admin_Query', timeZones?: Array<{ __typename: 'TimeZone', identifier: string, label: string, id: string }> } };

export type FalsifyUserActiveSessionsLimitedMutationVariables = Exact<{ [key: string]: never; }>;


export type FalsifyUserActiveSessionsLimitedMutation = { __typename?: 'mutation_root', admin_?: { __typename?: 'admin_Mutation', falsifyUserActiveSessions?: { __typename?: 'User', id: string } } };

export type ProjectDetailsFragment = { __typename?: 'tenancy_projects', accountId: string, name: string, id: string, description?: string, files: Array<{ __typename?: 'tenancy_file', url: string }>, projectProductSettings: Array<{ __typename?: 'tenancy_project_product_settings', productId: string, projectId: string, settings?: any, product: { __typename?: 'tenancy_products', name: string, id: string } }> };

export type UserAssignedProjectsFragment = { __typename?: 'tenancy_users', user_accounts: Array<{ __typename?: 'tenancy_user_accounts', user_account_projects: Array<{ __typename?: 'tenancy_user_account_projects', _user_account_project_roles: Array<{ __typename?: 'tenancy__user_account_project_roles', role: { __typename?: 'tenancy_roles', productId: string, name: string, product: { __typename?: 'tenancy_products', name: string } } }>, project: { __typename?: 'tenancy_projects', accountId: string, name: string, id: string, description?: string, files: Array<{ __typename?: 'tenancy_file', url: string }>, projectProductSettings: Array<{ __typename?: 'tenancy_project_product_settings', productId: string, projectId: string, settings?: any, product: { __typename?: 'tenancy_products', name: string, id: string } }> } }> }>, _user_teams: Array<{ __typename?: 'tenancy__user_teams', team: { __typename?: 'tenancy_teams', team_accounts: Array<{ __typename?: 'tenancy_team_accounts', team_account_projects: Array<{ __typename?: 'tenancy_team_account_projects', _team_account_project_roles: Array<{ __typename?: 'tenancy__team_account_project_roles', role: { __typename?: 'tenancy_roles', productId: string, name: string, product: { __typename?: 'tenancy_products', name: string } } }>, project: { __typename?: 'tenancy_projects', accountId: string, name: string, id: string, description?: string, files: Array<{ __typename?: 'tenancy_file', url: string }>, projectProductSettings: Array<{ __typename?: 'tenancy_project_product_settings', productId: string, projectId: string, settings?: any, product: { __typename?: 'tenancy_products', name: string, id: string } }> } }> }> } }> };

export type ProjectsSubscriptionLimitedSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ProjectsSubscriptionLimitedSubscription = { __typename?: 'subscription_root', tenancy_users_by_pk?: { __typename?: 'tenancy_users', user_accounts: Array<{ __typename?: 'tenancy_user_accounts', user_account_projects: Array<{ __typename?: 'tenancy_user_account_projects', _user_account_project_roles: Array<{ __typename?: 'tenancy__user_account_project_roles', role: { __typename?: 'tenancy_roles', productId: string, name: string, product: { __typename?: 'tenancy_products', name: string } } }>, project: { __typename?: 'tenancy_projects', accountId: string, name: string, id: string, description?: string, files: Array<{ __typename?: 'tenancy_file', url: string }>, projectProductSettings: Array<{ __typename?: 'tenancy_project_product_settings', productId: string, projectId: string, settings?: any, product: { __typename?: 'tenancy_products', name: string, id: string } }> } }> }>, _user_teams: Array<{ __typename?: 'tenancy__user_teams', team: { __typename?: 'tenancy_teams', team_accounts: Array<{ __typename?: 'tenancy_team_accounts', team_account_projects: Array<{ __typename?: 'tenancy_team_account_projects', _team_account_project_roles: Array<{ __typename?: 'tenancy__team_account_project_roles', role: { __typename?: 'tenancy_roles', productId: string, name: string, product: { __typename?: 'tenancy_products', name: string } } }>, project: { __typename?: 'tenancy_projects', accountId: string, name: string, id: string, description?: string, files: Array<{ __typename?: 'tenancy_file', url: string }>, projectProductSettings: Array<{ __typename?: 'tenancy_project_product_settings', productId: string, projectId: string, settings?: any, product: { __typename?: 'tenancy_products', name: string, id: string } }> } }> }> } }> } };

export type GetUserProjectsLimitedQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserProjectsLimitedQuery = { __typename?: 'query_root', tenancy_users_by_pk?: { __typename?: 'tenancy_users', user_accounts: Array<{ __typename?: 'tenancy_user_accounts', user_account_projects: Array<{ __typename?: 'tenancy_user_account_projects', _user_account_project_roles: Array<{ __typename?: 'tenancy__user_account_project_roles', role: { __typename?: 'tenancy_roles', productId: string, name: string, product: { __typename?: 'tenancy_products', name: string } } }>, project: { __typename?: 'tenancy_projects', accountId: string, name: string, id: string, description?: string, files: Array<{ __typename?: 'tenancy_file', url: string }>, projectProductSettings: Array<{ __typename?: 'tenancy_project_product_settings', productId: string, projectId: string, settings?: any, product: { __typename?: 'tenancy_products', name: string, id: string } }> } }> }>, _user_teams: Array<{ __typename?: 'tenancy__user_teams', team: { __typename?: 'tenancy_teams', team_accounts: Array<{ __typename?: 'tenancy_team_accounts', team_account_projects: Array<{ __typename?: 'tenancy_team_account_projects', _team_account_project_roles: Array<{ __typename?: 'tenancy__team_account_project_roles', role: { __typename?: 'tenancy_roles', productId: string, name: string, product: { __typename?: 'tenancy_products', name: string } } }>, project: { __typename?: 'tenancy_projects', accountId: string, name: string, id: string, description?: string, files: Array<{ __typename?: 'tenancy_file', url: string }>, projectProductSettings: Array<{ __typename?: 'tenancy_project_product_settings', productId: string, projectId: string, settings?: any, product: { __typename?: 'tenancy_products', name: string, id: string } }> } }> }> } }> }, tenancy_products: Array<{ __typename?: 'tenancy_products', name: string, id: string, displayName?: string }> };

export const CustomAuthMethodDetailsFragmentDoc = gql`
    fragment CustomAuthMethodDetails on CustomAuthMethod {
  id
  clientId
  clientSecret
  issuerURL
  type
  emailAttribute
  usernameAttribute
  entityIssuer
  settings
}
    `;
export const AccountAuthMethodSettingsFragmentDoc = gql`
    fragment AccountAuthMethodSettings on AccountAuthMethodSettings {
  id
  isActive
  isDefault
  authMethodId
  customAuthMethodId
}
    `;
export const ShortProjectsFragmentFragmentDoc = gql`
    fragment ShortProjectsFragment on PaginatedProjects {
  rows {
    id
    accountId
    name
    projectProductSettings {
      productId
      settings
      product {
        id
        displayName
        name
      }
    }
  }
}
    `;
export const ShortTeamsFragmentFragmentDoc = gql`
    fragment ShortTeamsFragment on PaginatedTeams {
  rows {
    id
    name
    assignedRoles {
      id
      name
      accountId
      productId
      product {
        displayName
        name
        id
      }
    }
    assignedProjects {
      id
      name
      accountId
    }
  }
}
    `;
export const ShortRolesFragmentFragmentDoc = gql`
    fragment ShortRolesFragment on PaginatedRoles {
  rows {
    id
    name
    productId
    product {
      id
      displayName
      name
    }
    accountId
  }
}
    `;
export const ShortUsersFragmentFragmentDoc = gql`
    fragment ShortUsersFragment on tenancy_users {
  id
  firstName
  lastName
  userName
  lastActiveAt
  picture
  status
}
    `;
export const ProjectDetailsFragmentFragmentDoc = gql`
    fragment ProjectDetailsFragment on tenancy_projects {
  accountId
  name
  picture
  id
  description
  projectProductSettings: project_product_settings {
    product {
      name
      id
    }
    productId
    projectId
    settings
  }
}
    `;
export const RoleDetailsFragmentDoc = gql`
    fragment RoleDetails on tenancy_roles {
  productId
  name
  product {
    name
  }
}
    `;
export const AgentManagerFileFieldsFragmentDoc = gql`
    fragment AgentManagerFileFields on AgentManagerFile {
  path
  name
  sha
  size
  mimeType
  url
}
    `;
export const ChannelConfigurationFragmentDoc = gql`
    fragment ChannelConfiguration on CustomerChannelConfigResponse {
  config {
    twilioVoiceConfig {
      accountSid
      authToken
      elevenlabsAudioModel
      elevenlabsSimilarity
      elevenlabsSpeed
      elevenlabsStability
      elevenlabsVoiceId
      handoffUrl
      initCallWebhookUrl
      language
      phoneNumber
      speechModel
      transcriptionProvider
      ttsProvider
      welcomeGreeting
      elevenlabsVoiceMetadataB64
      metadataIntegrationInfoB64
      voiceHandoffOptionsB64
    }
    twilioVoiceId
  }
  analyticsApiHost
  analyticsApiKey
  analyticsDefault
  analyticsEnabled
  analyticsTranscriptEnabled
  botRetry {
    attempts
    timeout
  }
  endBot
  id
  lastUpdateBy
  lastUpdated
  name
  pypeId
  startBot
  type
  webhookUrl
}
    `;
export const SolutionUserPresenceFieldsFragmentDoc = gql`
    fragment SolutionUserPresenceFields on SolutionUserPresence {
  firstSeenAt
  id
  isActive
  lastSeenAt
  pageParams
  pagePath
  solutionId
}
    `;
export const PypeRuleGroupFieldsFragmentDoc = gql`
    fragment PypeRuleGroupFields on PypeRuleGroup {
  id
  name
  description
  type
  pypes {
    pypeId
    env
  }
  rules {
    id
    name
    description
    type
    rules
  }
}
    `;
export const PypeConnectionFieldsFragmentDoc = gql`
    fragment PypeConnectionFields on PypeConnection {
  id
  name
  platformId
  environment
  settings
  agentRouting
  agentRoutingUrl
  createdAt
  updatedAt
  pypes {
    pypeId
    env
  }
}
    `;
export const FileFieldsFragmentDoc = gql`
    fragment FileFields on File {
  id
  url
  mimeType
  originalName
  publicId
  size
}
    `;
export const LlmProviderFieldsFragmentDoc = gql`
    fragment LLMProviderFields on LLMProvider {
  name
}
    `;
export const LlmCredentialFieldsFragmentDoc = gql`
    fragment LLMCredentialFields on LLMCredential {
  name
  model
  id
  llmProviderId
  llmProvider {
    ...LLMProviderFields
  }
}
    ${LlmProviderFieldsFragmentDoc}`;
export const SolutionVersionFieldsFragmentDoc = gql`
    fragment SolutionVersionFields on SolutionVersion {
  id
  name
  version
  isDraft
  botSolutionVersionId
  brandName
  status
  files {
    ...FileFields
  }
  knowledgeAgentContext
  llmCredential {
    ...LLMCredentialFields
  }
  maxOutputTokens
  otherInformation
  solutionId
  supervisorName
  tasks {
    description
    id
    name
  }
  temperature
  tone
  topK
  topP
}
    ${FileFieldsFragmentDoc}
${LlmCredentialFieldsFragmentDoc}`;
export const SolutionFieldsFragmentDoc = gql`
    fragment SolutionFields on Solution {
  id
  name
  botSolutionId
  defaultDraftVersionId
  solutionVersions {
    ...SolutionVersionFields
  }
  projectProStudioSettingId
  type
  settings
}
    ${SolutionVersionFieldsFragmentDoc}`;
export const VoiceAiProviderFragmentDoc = gql`
    fragment VoiceAiProvider on VoiceAiProvider {
  free_users_allowed
  gender
  image_url
  instagram_username
  is_added_by_user
  accent
  age
  category
  cloned_by_count
  date_unix
  description
  descriptive
  featured
  fiat_rate
  language
  live_moderation_enabled
  locale
  name
  notice_period
  play_api_usage_character_count_1y
  preview_url
  public_owner_id
  rate
  tiktok_username
  twitter_username
  usage_character_count_1y
  usage_character_count_7d
  use_case
  voice_id
  youtube_username
  verified_languages {
    accent
    language
    locale
    model_id
    preview_url
  }
}
    `;
export const VoiceAiProviderResultFragmentFragmentDoc = gql`
    fragment VoiceAiProviderResultFragment on VoiceAiProviderResult {
  count
  current_page
  has_more
  voices {
    ...VoiceAiProvider
  }
}
    ${VoiceAiProviderFragmentDoc}`;
export const ProjectDetailsFragmentDoc = gql`
    fragment ProjectDetails on tenancy_projects {
  accountId
  name
  files {
    url
  }
  id
  description
  projectProductSettings: project_product_settings {
    product {
      name
      id
    }
    productId
    projectId
    settings
  }
}
    `;
export const UserAssignedProjectsFragmentDoc = gql`
    fragment UserAssignedProjects on tenancy_users {
  user_accounts {
    user_account_projects(order_by: {project: {name: asc}}) {
      _user_account_project_roles {
        role {
          productId
          name
          product {
            name
          }
        }
      }
      project {
        ...ProjectDetails
      }
    }
  }
  _user_teams {
    team {
      team_accounts {
        team_account_projects(order_by: {project: {name: asc}}) {
          _team_account_project_roles {
            role {
              productId
              name
              product {
                name
              }
            }
          }
          project {
            ...ProjectDetails
          }
        }
      }
    }
  }
}
    ${ProjectDetailsFragmentDoc}`;
export const GetUserInfoDocument = gql`
    query GetUserInfo {
  admin_ {
    currentUser {
      defaultAccount {
        defaultOrgId: id
      }
      id
      firstName
      lastName
      profilePhoto: picture
      pictureFile {
        url
      }
      email: userName
      settings
      status
      requiredConsentStatus
      optionalConsentStatus
      createdAt
      updatedAt
      assignedRoles {
        id
        name
      }
      assignedTeams {
        name
        id
        assignedRoles {
          id
          name
        }
        assignedProjects {
          id
        }
        defaultAccount {
          id
          allChildAccounts {
            id
          }
        }
      }
    }
  }
}
    `;
export const ConnectAuthMethodDocument = gql`
    mutation ConnectAuthMethod($userId: String!, $accountAuthMethodSettingsId: String!) {
  admin_ {
    connectAuthMethod(
      userId: $userId
      accountAuthMethodSettingsId: $accountAuthMethodSettingsId
    )
  }
}
    `;
export const GetAccountManagerInfoDocument = gql`
    query GetAccountManagerInfo($userId: String!) {
  admin_ {
    userById(id: $userId) {
      picture
      firstName
      lastName
      userName
    }
  }
}
    `;
export const GetOrganizationsMetadataDocument = gql`
    query GetOrganizationsMetadata($accountIds: [String!]!) {
  admin_ {
    organizationsMetadata(accountIds: $accountIds) {
      accountId
      canManageAccess
    }
  }
}
    `;
export const GetUserSettingsDocument = gql`
    query GetUserSettings($accountId: String!, $userId: String!) {
  admin_ {
    userProductRoles(accountId: $accountId, userId: $userId) {
      hasAgentAssistRoles
      hasAnalyticsRoles
      hasOrganizationRoles
      hasProStudioRoles
      hasMaestroStudioRoles
      agentAssistRolesSource {
        project {
          id
          name
          accountId
        }
      }
      analyticsRolesSource {
        project {
          id
          name
          accountId
        }
      }
      organizationRolesSource {
        project {
          id
          name
          accountId
        }
      }
      proStudioRolesSource {
        project {
          id
          name
          accountId
        }
      }
      maestroStudioRolesSource {
        project {
          id
          name
          accountId
        }
      }
    }
    organizationMetadata(accountId: $accountId) {
      canManageAccess
    }
    currentUser {
      settings
      status
      listOfAuthMethods {
        accountAuthMethodSettingsId
        isCreationOne
        isActive
        name
        providerId
        isCustom
        type
      }
    }
  }
}
    `;
export const GetMetabaseFoldersDocument = gql`
    query GetMetabaseFolders($projectId: String!) {
  admin_ {
    getMetabaseFolders(projectId: $projectId) {
      datasets {
        dataset
        groups {
          id
          name
          dashboardCount
        }
      }
    }
  }
}
    `;
export const GetAccountsDocument = gql`
    query GetAccounts {
  admin_ {
    currentUser {
      defaultAccount {
        id
        allChildAccounts {
          id
        }
      }
    }
    defaultAuthMethods {
      id
      name
      providerId
      description
      providerId
    }
  }
}
    `;
export const GetAccountDocument = gql`
    query GetAccount($id: String!) {
  admin_ {
    accountById(id: $id) {
      name
      parentId
      id
      pictureFile {
        url
      }
      status
      accountManagerId
      settings
      accountAuthMethodSettings {
        ...AccountAuthMethodSettings
      }
      customAuthMethods {
        ...CustomAuthMethodDetails
      }
    }
  }
}
    ${AccountAuthMethodSettingsFragmentDoc}
${CustomAuthMethodDetailsFragmentDoc}`;
export const DeleteProjectDocument = gql`
    mutation deleteProject($projectId: String!) {
  admin_ {
    deleteProject(id: $projectId)
  }
}
    `;
export const MakeDbSnapshotDocument = gql`
    mutation MakeDbSnapshot {
  admin_ {
    makeDbSnapshot
  }
}
    `;
export const GetProjectsDocument = gql`
    query GetProjects($accountId: String!, $userId: String!) {
  admin_ {
    projects(
      filterCriteria: {accountId: $accountId}
      queryMetadata: {orderBy: {columnName: "name", direction: "asc"}}
    ) {
      rows {
        accountId
        updatedAt
        createdAt
        name
        picture
        projectId: id
        description
        pictureFile {
          publicId
          url
        }
        projectProductSettings {
          productId
          projectId
        }
        users {
          rows {
            firstName
            lastName
            email: userName
            picture
          }
        }
      }
    }
    userProjects(
      filterCriteria: {userId: $userId, includeUnassigned: false, accountId: $accountId}
      queryMetadata: {orderBy: {columnName: "createdAt", direction: "desc"}}
    ) {
      rows {
        project {
          id
        }
      }
    }
  }
}
    `;
export const GetProjectDetailsDocument = gql`
    query GetProjectDetails($id: String!, $withEnvironments: Boolean!) {
  admin_ {
    projectById(id: $id) {
      accountId
      updatedAt
      createdAt
      name
      picture
      projectId: id
      description
      pictureFile {
        publicId
        url
      }
      projectProductSettings {
        productId
        projectId
      }
      projectEnvironmentConfig @include(if: $withEnvironments) {
        environmentId
        status
        description
        id
        projectId
        appletInstances {
          id
          name
          projectEnvironmentConfigId
          projectEnvironmentConfig {
            environmentId
          }
        }
        environment {
          name
          id
        }
        domains {
          url
          id
          type
        }
      }
      localizationSettings {
        id
        timeZone {
          id
          identifier
          label
        }
      }
      users {
        rows {
          id
          firstName
          lastName
          email: userName
          picture
        }
      }
    }
  }
}
    `;
export const GetAppletInstancesByProjectIdDocument = gql`
    query GetAppletInstancesByProjectId($projectId: String!) {
  admin_ {
    projectById(id: $projectId) {
      projectId: id
      projectEnvironmentConfig {
        environmentId
        status
        description
        id
        projectId
        appletInstances {
          id
          projectEnvironmentConfigId
          description
          name
          options
          status
          updatedAt
          updatedByUser {
            firstName
            lastName
            picture
          }
          applet {
            id
            applet {
              pkgName
              appletType
              id
            }
          }
          triggers {
            id
            name
            options
            packageId
            packageVersionId
            appletInstanceId
            package {
              id
              latestVersion {
                id
                version
                schema
              }
              versions {
                id
                schema
                version
                package {
                  id
                }
              }
            }
            packageVersion {
              id
              version
              package {
                id
                displayName
              }
            }
          }
          actions {
            id
            name
            options
            packageId
            packageVersionId
            appletInstanceId
            package {
              id
              latestVersion {
                id
                version
                schema
              }
              versions {
                id
                schema
                version
                package {
                  id
                }
              }
            }
            packageVersion {
              id
              version
              package {
                id
                displayName
              }
            }
          }
          condition {
            id
            options
            appletInstanceId
          }
        }
      }
    }
  }
}
    `;
export const GetProjectLandingPageApolloDocument = gql`
    query getProjectLandingPageApollo($accountId: String, $userId: String!) @cached {
  admin_ {
    userProjects(
      filterCriteria: {userId: $userId, includeUnassigned: true, accountId: $accountId}
      queryMetadata: {orderBy: {columnName: "createdAt", direction: "desc"}}
    ) {
      rows {
        project {
          createdAt
          name
          projectId: id
          description
          pictureFile {
            publicId
            url
          }
          projectProductSettings {
            productId
            projectId
          }
          users {
            count
            rows {
              firstName
              lastName
              email: userName
            }
          }
        }
      }
    }
  }
}
    `;
export const GetProductsDocument = gql`
    query GetProducts {
  admin_ {
    allToolProducts {
      name
      id
      displayName
    }
    allProducts {
      name
      id
    }
  }
}
    `;
export const CreateProjectDocument = gql`
    mutation CreateProject($productIds: [String]!, $name: String!, $accountId: String!, $description: String, $timeZoneId: String, $projectEnvironmentConfigs: [ProjectEnvironmentConfigCreate], $projectIconId: String) {
  admin_ {
    createProject(
      projectIconId: $projectIconId
      name: $name
      productIds: $productIds
      description: $description
      accountId: $accountId
      timeZoneId: $timeZoneId
      projectEnvironmentConfigs: $projectEnvironmentConfigs
    ) {
      updatedAt
      accountId
      name
      picture
      pictureFile {
        url
        publicId
      }
      id
      description
      projectProductSettings {
        productId
        projectId
      }
      projectEnvironmentConfig {
        environmentId
        status
        description
        id
        projectId
        environment {
          name
          id
        }
        domains {
          url
          id
          type
        }
      }
      localizationSettings {
        id
        timeZone {
          id
          identifier
          label
        }
      }
      users {
        rows {
          firstName
          lastName
          email: userName
          picture
        }
      }
    }
  }
}
    `;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($name: String!, $description: String, $projectId: String!, $productIds: [String], $timeZoneId: String, $projectIconId: String) {
  admin_ {
    updateProject(
      name: $name
      description: $description
      id: $projectId
      productIds: $productIds
      timeZoneId: $timeZoneId
      projectIconId: $projectIconId
    ) {
      accountId
      updatedAt
      createdAt
      name
      picture
      projectId: id
      description
      pictureFile {
        publicId
        url
      }
      projectProductSettings {
        productId
        projectId
      }
      projectEnvironmentConfig {
        environmentId
        status
        description
        id
        projectId
        environment {
          name
          id
        }
        domains {
          url
          id
          type
        }
      }
      localizationSettings {
        id
        timeZone {
          id
          identifier
          label
        }
      }
      users {
        rows {
          id
          firstName
          lastName
          email: userName
          picture
        }
      }
    }
  }
}
    `;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: String!, $accountId: String!, $firstName: String!, $lastName: String!, $picture: String, $status: UserStatus, $requiredConsentStatus: ConsentStatusEnum, $optionalConsentStatus: ConsentStatusEnum, $requiredConsentUpdatedAt: DateTime, $optionalConsentUpdatedAt: DateTime, $settings: JSON, $userIconId: String) {
  admin_ {
    updateUser(
      id: $id
      accountId: $accountId
      firstName: $firstName
      lastName: $lastName
      picture: $picture
      settings: $settings
      requiredConsentStatus: $requiredConsentStatus
      optionalConsentStatus: $optionalConsentStatus
      requiredConsentUpdatedAt: $requiredConsentUpdatedAt
      optionalConsentUpdatedAt: $optionalConsentUpdatedAt
      status: $status
      userIconId: $userIconId
    ) {
      id
      firstName
      lastName
      status
      settings
      email: userName
      createdAt
      updatedAt
      pictureFile {
        url
      }
    }
  }
}
    `;
export const GetLanguagesDocument = gql`
    query GetLanguages @cached {
  admin_ {
    localizationSettingsConfig {
      user {
        supportedLanguageCodes
      }
      project {
        supportedLanguageCodes
      }
    }
    locales {
      __typename
      id
      name
      locale
      languageCode
    }
  }
}
    `;
export const GetTimeZonesDocument = gql`
    query GetTimeZones @cached {
  admin_ {
    timeZones {
      __typename
      identifier
      label
      id
    }
  }
}
    `;
export const ValidateProjectEnvironmentUrlsDocument = gql`
    query ValidateProjectEnvironmentUrls($urls: [String]!) {
  admin_ {
    validateProjectEnvironmentUrls(urls: $urls) {
      urls {
        isValid
        validationResult
        url
        intersections
      }
    }
  }
}
    `;
export const UpdateProjectEnvironmentConfigDocument = gql`
    mutation UpdateProjectEnvironmentConfig($projectId: String!, $projectEnvironmentConfigId: String!, $domains: [DomainInput], $description: String, $status: EnvironmentStatusEnum) {
  admin_ {
    updateProjectEnvironmentConfig(
      projectId: $projectId
      projectEnvironmentConfigId: $projectEnvironmentConfigId
      domains: $domains
      description: $description
      status: $status
    ) {
      id
      projectId
      description
      status
      environmentId
      domains {
        id
        type
        url
      }
      environment {
        id
        name
      }
    }
  }
}
    `;
export const CreateAppletTemplateDocument = gql`
    mutation CreateAppletTemplate($pkgName: String!, $version: String!, $appletType: AppletTypeEnum!, $appletCategory: AppletCategoryEnum!, $schema: JSON!) {
  admin_ {
    createApplet(
      pkgName: $pkgName
      version: $version
      appletType: $appletType
      appletCategory: $appletCategory
      schema: $schema
    ) {
      id
      versions {
        id
        description
      }
    }
  }
}
    `;
export const GetAppletTemplatesDocument = gql`
    query GetAppletTemplates {
  admin_ {
    applets {
      id
      pkgName
      displayName
      appletType
      appletCategory
      description
      createdAt
      latestVersion {
        schema
        version
        id
      }
    }
  }
}
    `;
export const CreatePackageDocument = gql`
    mutation CreatePackage($pkgName: String!, $version: String!, $packageTypes: [PackageTypeEnum!]!, $displayName: String!, $packageJson: JSON!, $schema: JSON!, $description: String) {
  admin_ {
    createPackage(
      pkgName: $pkgName
      version: $version
      packageTypes: $packageTypes
      packageJson: $packageJson
      schema: $schema
      description: $description
      displayName: $displayName
    ) {
      id
    }
  }
}
    `;
export const GetPackagesDocument = gql`
    query GetPackages {
  admin_ {
    packages {
      id
      displayName
      pkgName
      packageTypes
      latestVersion {
        schema
        version
        id
        packageJson
      }
      versions {
        id
        package {
          id
        }
      }
    }
  }
}
    `;
export const UpdatePackageDocument = gql`
    mutation UpdatePackage($updatePackageId: String!, $displayName: String, $description: String) {
  admin_ {
    updatePackage(
      id: $updatePackageId
      displayName: $displayName
      description: $description
    ) {
      id
    }
  }
}
    `;
export const ProjectEnvironmentConfigByIdDocument = gql`
    query ProjectEnvironmentConfigById($projectEnvironmentConfigByIdId: String!) {
  admin_ {
    projectEnvironmentConfigById(id: $projectEnvironmentConfigByIdId) {
      appletInstances {
        id
        projectEnvironmentConfigId
        description
        name
        options
        status
        applet {
          id
          applet {
            pkgName
            appletType
            id
          }
        }
        triggers {
          id
          name
          options
          packageId
          packageVersionId
          appletInstanceId
          packageVersion {
            id
            version
            package {
              id
              displayName
            }
          }
        }
        condition {
          id
          options
          appletInstanceId
        }
        actions {
          id
          name
          options
          packageId
          packageVersionId
          appletInstanceId
          packageVersion {
            id
            version
            package {
              id
              displayName
            }
          }
        }
      }
    }
  }
}
    `;
export const CreateAppletVersionDocument = gql`
    mutation CreateAppletVersion($version: String!, $appletId: String!, $schema: JSON!) {
  admin_ {
    createAppletVersion(version: $version, appletId: $appletId, schema: $schema) {
      id
    }
  }
}
    `;
export const CreateAppletInstanceDocument = gql`
    mutation CreateAppletInstance($appletVersionId: String!, $description: String, $projectEnvironmentConfigId: String!, $options: JSON, $status: AppletStatusEnum, $triggers: [TriggerCreate!], $actions: [ActionCreate!], $condition: JSON, $name: String!) {
  admin_ {
    createAppletInstance(
      name: $name
      description: $description
      appletVersionId: $appletVersionId
      projectEnvironmentConfigId: $projectEnvironmentConfigId
      options: $options
      status: $status
      triggers: $triggers
      actions: $actions
      condition: $condition
    ) {
      id
      projectEnvironmentConfigId
      description
      name
      options
      updatedByUser {
        firstName
        lastName
        picture
      }
      status
      applet {
        id
        applet {
          pkgName
          appletType
          id
        }
      }
      triggers {
        id
        name
        options
        packageId
        packageVersionId
        appletInstanceId
        package {
          id
          latestVersion {
            id
            version
            schema
          }
          versions {
            id
            schema
            version
            package {
              id
            }
          }
        }
        packageVersion {
          id
          version
          package {
            id
            displayName
          }
        }
      }
      actions {
        id
        name
        options
        packageId
        packageVersionId
        appletInstanceId
        package {
          id
          latestVersion {
            id
            version
            schema
          }
          versions {
            id
            schema
            version
            package {
              id
            }
          }
        }
        packageVersion {
          id
          version
          package {
            id
            displayName
          }
        }
      }
      condition {
        id
        options
        appletInstanceId
      }
    }
  }
}
    `;
export const AppletInstanceByIdDocument = gql`
    query AppletInstanceById($appletInstanceById: String!) {
  admin_ {
    appletInstanceById(appletInstanceId: $appletInstanceById) {
      id
    }
  }
}
    `;
export const UpdateAppletInstanceDocument = gql`
    mutation updateAppletInstance($updateAppletInstanceId: String!, $status: AppletStatusEnum, $description: String, $name: String, $options: JSON, $triggers: [TriggerCreate], $actions: [ActionCreate], $condition: JSON) {
  admin_ {
    updateAppletInstance(
      id: $updateAppletInstanceId
      description: $description
      name: $name
      status: $status
      options: $options
      triggers: $triggers
      actions: $actions
      condition: $condition
    ) {
      id
      projectEnvironmentConfigId
      description
      name
      options
      status
      updatedAt
      updatedByUser {
        firstName
        lastName
        picture
      }
      applet {
        id
        applet {
          pkgName
          appletType
          id
        }
      }
      triggers {
        id
        name
        options
        packageId
        packageVersionId
        appletInstanceId
        package {
          id
          latestVersion {
            id
            version
            schema
          }
          versions {
            id
            schema
            version
            package {
              id
            }
          }
        }
        packageVersion {
          id
          version
          package {
            id
            displayName
          }
        }
      }
      actions {
        id
        name
        options
        packageId
        packageVersionId
        appletInstanceId
        package {
          id
          latestVersion {
            id
            version
            schema
          }
          versions {
            id
            schema
            version
            package {
              id
            }
          }
        }
        packageVersion {
          id
          version
          package {
            id
            displayName
          }
        }
      }
      condition {
        id
        options
        appletInstanceId
      }
    }
  }
}
    `;
export const DeleteAppletDocument = gql`
    mutation DeleteApplet($deleteAppletId: String!) {
  admin_ {
    deleteApplet(id: $deleteAppletId) {
      id
    }
  }
}
    `;
export const DeletePackageDocument = gql`
    mutation DeletePackage($deletePackageId: String!) {
  admin_ {
    deletePackage(id: $deletePackageId) {
      id
    }
  }
}
    `;
export const DeletePackageVersionIdDocument = gql`
    mutation DeletePackageVersionId($deletePackageVersionId: String!) {
  admin_ {
    deletePackageVersion(id: $deletePackageVersionId) {
      id
    }
  }
}
    `;
export const DeleteAppletInstanceDocument = gql`
    mutation DeleteAppletInstance($deleteAppletInstanceId: String!) {
  admin_ {
    deleteAppletInstance(id: $deleteAppletInstanceId) {
      id
    }
  }
}
    `;
export const GetUsersDocument = gql`
    query GetUsers($accountId: String!) {
  admin_ {
    users(
      filterCriteria: {accountId: $accountId}
      queryMetadata: {orderBy: {columnName: "firstName", direction: "asc"}}
    ) {
      rows {
        id
        firstName
        lastName
        picture
        pictureFile {
          url
        }
        userName
        createdAt
        lastActiveAt
        status
      }
    }
  }
}
    `;
export const GetTeamsDocument = gql`
    query GetTeams($accountId: String!) {
  admin_ {
    teams(
      filterCriteria: {accountId: $accountId}
      queryMetadata: {orderBy: {columnName: "name", direction: "asc"}}
    ) {
      rows {
        assignedMembers {
          id
          firstName
          lastName
          picture
        }
        id
        name
        description
        updatedAt
      }
    }
  }
}
    `;
export const GetChildAccountsDocument = gql`
    query GetChildAccounts($accountId: String!) {
  admin_ {
    accountById(id: $accountId) {
      id
      name
      parentId
      pictureFile {
        url
      }
      createdAt
    }
    accounts(
      filterCriteria: {parentId: $accountId}
      queryMetadata: {orderBy: {columnName: "name", direction: "asc"}}
    ) {
      count
      rows {
        id
        name
        pictureFile {
          url
        }
        status
        isManaged
        createdAt
        updatedAt
        allChildAccounts {
          id
          name
          parentId
        }
        projects {
          rows {
            name
            id
          }
        }
        teams {
          rows {
            name
            id
          }
        }
        users {
          count
        }
      }
    }
  }
}
    `;
export const GetAuditLogsDocument = gql`
    query GetAuditLogs($accountId: String!, $queryMetadata: QueryMetadata!) {
  admin_ {
    auditLogs(
      filterCriteria: {accountId: $accountId}
      queryMetadata: $queryMetadata
    ) {
      count
      rows {
        id
        userId
        accountId
        productId
        applicationId
        createdAt
        user {
          id
          userName
          firstName
          lastName
          picture
        }
        auditLogDetail {
          displayMessage
        }
      }
    }
  }
}
    `;
export const CreateAccountDocument = gql`
    mutation CreateAccount($parentAccountId: String!, $accountName: String!, $picture: String, $accountManagerId: String, $generalSettings: JSON, $resourceLimitSettings: JSON, $accountIconId: String, $defaultAuthMethods: [String], $customAuthMethods: [CustomAuthMethodCreateInput]) {
  admin_ {
    createAccount(
      parentAccountId: $parentAccountId
      accountName: $accountName
      picture: $picture
      accountManagerId: $accountManagerId
      generalSettings: $generalSettings
      resourceLimitSettings: $resourceLimitSettings
      accountIconId: $accountIconId
      customAuthMethods: $customAuthMethods
      defaultAuthMethods: $defaultAuthMethods
    ) {
      id
      name
      status
      createdAt
      updatedAt
      settings
      pictureFile {
        url
      }
    }
  }
}
    `;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($id: ID!, $name: String!, $picture: String, $accountManagerId: String, $generalSettings: JSON, $resourceLimitSettings: JSON, $accountIconId: String, $accountAuthMethodSettings: [AccountAuthMethodSettingsInput], $customAuthMethods: [CustomAuthMethodUpdateInput]) {
  admin_ {
    updateAccount(
      id: $id
      name: $name
      accountManagerId: $accountManagerId
      generalSettings: $generalSettings
      resourceLimitSettings: $resourceLimitSettings
      picture: $picture
      accountIconId: $accountIconId
      accountAuthMethodSettings: $accountAuthMethodSettings
      customAuthMethods: $customAuthMethods
    ) {
      id
      parentId
      name
      accountManagerId
      pictureFile {
        url
      }
      settings
      createdAt
      updatedAt
      users {
        count
      }
      projects {
        count
      }
      customAuthMethods {
        ...CustomAuthMethodDetails
      }
      accountAuthMethodSettings {
        ...AccountAuthMethodSettings
      }
    }
  }
}
    ${CustomAuthMethodDetailsFragmentDoc}
${AccountAuthMethodSettingsFragmentDoc}`;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($id: ID!) {
  admin_ {
    deleteAccount(id: $id) {
      id
    }
  }
}
    `;
export const GetAccountByIdDocument = gql`
    query GetAccountById($id: String!) {
  admin_ {
    accountById(id: $id) {
      id
      name
      createdAt
    }
  }
}
    `;
export const GetProjectByIdDocument = gql`
    query GetProjectById($id: String!) {
  admin_ {
    projectById(id: $id) {
      id
      name
      createdAt
      projectProStudioSetting {
        settings
        id
        customerId
        projectId
      }
      accountId
    }
  }
}
    `;
export const GetTeamByIdDocument = gql`
    query GetTeamById($id: String!) {
  admin_ {
    teamById(id: $id) {
      id
      name
      createdAt
    }
  }
}
    `;
export const GetUserByIdDocument = gql`
    query GetUserById($id: String!) {
  admin_ {
    userById(id: $id) {
      id
      firstName
      lastName
      createdAt
    }
  }
}
    `;
export const GetProjectEnvironmentConfigByIdDocument = gql`
    query GetProjectEnvironmentConfigById($id: String!) {
  admin_ {
    projectEnvironmentConfigById(id: $id) {
      id
    }
  }
}
    `;
export const UserSessionSubscriptionDocument = gql`
    subscription UserSessionSubscription($userId: String!) {
  tenancy_users(where: {id: {_eq: $userId}}) {
    id
    userName
    hasActiveSessions
  }
}
    `;
export const GetUserDetailsDocument = gql`
    query GetUserDetails($id: String!) {
  tenancy_users_by_pk(id: $id) {
    id
    firstName
    lastName
    userName
    picture
    settings
    requiredConsentStatus
    optionalConsentStatus
    files {
      url
    }
    user_accounts {
      id
      accountId
      isPrimaryAccount
      user_account_projects {
        id
        project {
          id
          name
          accountId
          project_product_settings {
            settings
            product {
              displayName
              name
              id
            }
          }
        }
        _account_project_roles: _user_account_project_roles {
          role {
            id
            name
            productId
            product {
              id
              displayName
              name
            }
          }
        }
        metabase_access {
          dataset
          collectionId
          roleId
        }
      }
      _user_account_roles {
        role {
          accountId
          id
          name
          productId
          product {
            id
            displayName
            name
          }
        }
      }
    }
    _user_teams {
      team {
        id
        name
        team_accounts {
          id
          accountId
          team_account_projects {
            project {
              id
              name
              accountId
              project_product_settings {
                settings
                product {
                  displayName
                  name
                  id
                }
              }
            }
            _team_account_project_roles {
              role {
                productId
                id
                name
                product {
                  displayName
                  name
                  id
                }
              }
            }
          }
          _team_account_roles {
            role {
              productId
              accountId
              id
              name
              product {
                displayName
                name
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetUserAuthMethodsDocument = gql`
    query GetUserAuthMethods($id: String!) {
  admin_ {
    userById(id: $id) {
      id
      listOfAuthMethods {
        accountAuthMethodSettingsId
        isCreationOne
        isActive
        name
        providerId
        isCustom
        type
      }
    }
  }
}
    `;
export const GetTeamDetailsDocument = gql`
    query GetTeamDetails($accountId: String!, $teamId: String!) {
  tenancy_teams_by_pk(id: $teamId) {
    id
    name
    description
    usersFromCurrentOrg: _user_teams(
      where: {user: {user_accounts: {accountId: {_eq: $accountId}}}}
    ) {
      user {
        ...ShortUsersFragment
      }
    }
    usersFromOtherOrgs: _user_teams(
      where: {user: {user_accounts: {accountId: {_neq: $accountId}}}}
    ) {
      user {
        ...ShortUsersFragment
      }
    }
    team_accounts {
      isPrimaryAccount
      accountId
      id
      _team_account_roles {
        role {
          productId
          accountId
          id
          name
          product {
            displayName
            name
            id
          }
        }
      }
      team_account_projects {
        id
        project {
          id
          name
          accountId
          project_product_settings {
            product {
              displayName
              name
              id
            }
          }
        }
        _account_project_roles: _team_account_project_roles {
          role {
            productId
            id
            name
            product {
              displayName
              name
              id
            }
          }
        }
      }
    }
  }
  tenancy_users(where: {user_accounts: {accountId: {_eq: $accountId}}}) {
    ...ShortUsersFragment
  }
}
    ${ShortUsersFragmentFragmentDoc}`;
export const GetNewTeamDetailsDocument = gql`
    query GetNewTeamDetails($accountId: String!) {
  tenancy_users(where: {user_accounts: {accountId: {_eq: $accountId}}}) {
    ...ShortUsersFragment
  }
}
    ${ShortUsersFragmentFragmentDoc}`;
export const UpdateTeamDocument = gql`
    mutation UpdateTeam($id: ID!, $name: String!, $description: String, $projectIdsToAdd: [String], $projectIdsToRemove: [String], $roleIdsToAdd: [String], $roleIdsToRemove: [String], $userIdsToAdd: [String], $userIdsToRemove: [String]) {
  admin_ {
    updateTeam(
      id: $id
      name: $name
      description: $description
      projectIdsToAdd: $projectIdsToAdd
      projectIdsToRemove: $projectIdsToRemove
      roleIdsToAdd: $roleIdsToAdd
      roleIdsToRemove: $roleIdsToRemove
      userIdsToAdd: $userIdsToAdd
      userIdsToRemove: $userIdsToRemove
    ) {
      id
      name
      description
      updatedAt
      assignedMembers {
        id
        firstName
        lastName
        picture
        lastActiveAt
        status
      }
    }
  }
}
    `;
export const CreateTeamDocument = gql`
    mutation CreateTeam($accountId: String!, $name: String!, $description: String, $projectIdsToAdd: [String], $projectIdsToRemove: [String], $roleIdsToAdd: [String], $roleIdsToRemove: [String], $userIdsToAdd: [String], $userIdsToRemove: [String]) {
  admin_ {
    createTeam(
      accountId: $accountId
      name: $name
      description: $description
      projectIdsToAdd: $projectIdsToAdd
      projectIdsToRemove: $projectIdsToRemove
      roleIdsToAdd: $roleIdsToAdd
      roleIdsToRemove: $roleIdsToRemove
      userIdsToAdd: $userIdsToAdd
      userIdsToRemove: $userIdsToRemove
    ) {
      id
      name
      description
      updatedAt
      assignedMembers {
        id
        firstName
        lastName
        picture
        lastActiveAt
        status
      }
    }
  }
}
    `;
export const DeleteTeamsDocument = gql`
    mutation deleteTeams($teamIds: [String]!) {
  admin_ {
    deleteTeams(teamIds: $teamIds) {
      succeeded
    }
  }
}
    `;
export const SetTeamAccountProjectRolesDocument = gql`
    mutation SetTeamAccountProjectRoles($teamId: String!, $projectRolesUpdate: [ProjectRolesUpdate]!) {
  admin_ {
    setTeamAccountProjectsRoles(
      teamId: $teamId
      projectRolesUpdate: $projectRolesUpdate
    ) {
      id
    }
  }
}
    `;
export const SetUserAccountProjectsRolesDocument = gql`
    mutation setUserAccountProjectsRoles($userId: String!, $projectRolesUpdate: [ProjectRolesUpdate]!, $isConsolidatingDetails: Boolean) {
  admin_ {
    setUserAccountProjectsRoles(
      userId: $userId
      projectRolesUpdate: $projectRolesUpdate
      isConsolidatingDetails: $isConsolidatingDetails
    ) {
      id
    }
  }
}
    `;
export const UpdateUserAccountRolesDocument = gql`
    mutation UpdateUserAccountRoles($id: String!, $accountId: String!, $firstName: String!, $lastName: String!, $roleIdsToAdd: [String], $roleIdsToRemove: [String], $teamIdsToAdd: [String], $teamIdsToRemove: [String], $projectIdsToAdd: [String], $projectIdsToRemove: [String], $settings: JSON, $optionalConsentStatus: ConsentStatusEnum, $userIconId: String) {
  admin_ {
    updateUser(
      id: $id
      accountId: $accountId
      firstName: $firstName
      lastName: $lastName
      roleIdsToAdd: $roleIdsToAdd
      roleIdsToRemove: $roleIdsToRemove
      teamIdsToAdd: $teamIdsToAdd
      teamIdsToRemove: $teamIdsToRemove
      projectIdsToAdd: $projectIdsToAdd
      projectIdsToRemove: $projectIdsToRemove
      settings: $settings
      optionalConsentStatus: $optionalConsentStatus
      userIconId: $userIconId
    ) {
      id
      userName
      firstName
      lastName
      status
      createdAt
      updatedAt
      __typename
    }
  }
}
    `;
export const AddUserToAccountDocument = gql`
    mutation AddUserToAccount($accountId: String!, $userName: String!, $firstName: String!, $lastName: String!) {
  admin_ {
    addUserToAccount(
      accountId: $accountId
      userName: $userName
      firstName: $firstName
      lastName: $lastName
    ) {
      id
      createdAt
      lastActiveAt
    }
  }
}
    `;
export const RemoveUserFromAccountDocument = gql`
    mutation RemoveUserFromAccount($accountId: String!, $userIds: [String]!) {
  admin_ {
    removeUsersFromAccount(accountId: $accountId, userIds: $userIds) {
      entityId
      entityDisplayName
      succeeded
      errorDetails
      __typename
    }
  }
}
    `;
export const GetAccountDetailsDocument = gql`
    query GetAccountDetails($id: String!) {
  admin_ {
    accountById(id: $id) {
      id
      name
      parentId
      parentAccount {
        id
        name
        parentId
      }
      allChildAccounts {
        id
        name
        parentId
        parentAccount {
          name
          id
          parentId
        }
        projects {
          ...ShortProjectsFragment
        }
        teams {
          ...ShortTeamsFragment
        }
        allParentIds
      }
      projects {
        ...ShortProjectsFragment
      }
      teams {
        ...ShortTeamsFragment
      }
      roles {
        ...ShortRolesFragment
      }
      allParentIds
    }
    organizationMetadata(accountId: $id) {
      canManageAccess
    }
  }
}
    ${ShortProjectsFragmentFragmentDoc}
${ShortTeamsFragmentFragmentDoc}
${ShortRolesFragmentFragmentDoc}`;
export const GetTeamProjectsDetailsDocument = gql`
    query GetTeamProjectsDetails($teamId: String!) {
  tenancy_teams_by_pk(id: $teamId) {
    id
    name
    team_accounts {
      accountId
      id
      _team_account_roles {
        role {
          productId
          accountId
          id
          name
          product {
            displayName
            name
            id
          }
        }
      }
      team_account_projects {
        project {
          id
          name
          accountId
          project_product_settings {
            product {
              displayName
              name
              id
            }
          }
        }
        _team_account_project_roles {
          role {
            productId
            id
            name
            product {
              displayName
              name
              id
            }
          }
        }
      }
    }
  }
}
    `;
export const GetUserProjectsHasuraDocument = gql`
    query GetUserProjectsHasura($userId: String!, $accountId: String!) {
  tenancy_user_accounts(where: {userId: {_eq: $userId}}) {
    user_account_projects(
      where: {project: {accountId: {_eq: $accountId}}}
      order_by: {project: {name: asc}}
    ) {
      project {
        ...ProjectDetailsFragment
        files {
          url
        }
        updatedAt
      }
      _user_account_project_roles {
        role {
          ...RoleDetails
        }
      }
    }
    user {
      _user_teams {
        team {
          team_accounts {
            team_account_projects(
              order_by: {project: {name: asc}}
              where: {project: {accountId: {_eq: $accountId}}}
            ) {
              _team_account_project_roles {
                role {
                  ...RoleDetails
                }
              }
              project {
                ...ProjectDetailsFragment
                files {
                  url
                }
                updatedAt
              }
            }
          }
        }
      }
    }
  }
  tenancy_products {
    name
    id
    displayName
  }
}
    ${ProjectDetailsFragmentFragmentDoc}
${RoleDetailsFragmentDoc}`;
export const GetAssetsFilesDocument = gql`
    query GetAssetsFiles($solutionId: String!, $versionName: String!) {
  admin_ {
    assetsFiles(solutionId: $solutionId, versionName: $versionName) {
      ...AgentManagerFileFields
    }
  }
}
    ${AgentManagerFileFieldsFragmentDoc}`;
export const GetConfigsFilesDocument = gql`
    query GetConfigsFiles($solutionId: String!, $versionName: String!) {
  admin_ {
    configsFiles(solutionId: $solutionId, versionName: $versionName) {
      ...AgentManagerFileFields
    }
  }
}
    ${AgentManagerFileFieldsFragmentDoc}`;
export const GetScriptsFilesDocument = gql`
    query GetScriptsFiles($solutionId: String!, $versionName: String!) {
  admin_ {
    scriptsFiles(solutionId: $solutionId, versionName: $versionName) {
      ...AgentManagerFileFields
    }
  }
}
    ${AgentManagerFileFieldsFragmentDoc}`;
export const GetCustomAssetsFilesDocument = gql`
    query GetCustomAssetsFiles($solutionId: String!, $versionName: String!) {
  admin_ {
    customAssetsFiles(solutionId: $solutionId, versionName: $versionName) {
      ...AgentManagerFileFields
    }
  }
}
    ${AgentManagerFileFieldsFragmentDoc}`;
export const DeleteAgentManagerFileDocument = gql`
    mutation DeleteAgentManagerFile($filePath: String!, $solutionId: String!, $versionName: String!) {
  admin_ {
    deleteAgentManagerFile(
      filePath: $filePath
      solutionId: $solutionId
      versionName: $versionName
    )
  }
}
    `;
export const CreateChannelDocument = gql`
    mutation CreateChannel($beta: String = "", $botId: String = "", $botName: String = "", $customerId: String = "", $customPypeCss: String = "", $name: String = "", $style: String = "", $env: SolutionEnvironmentsEnum = live, $type: ChannelTypesEnum = Default, $twilioParams: TwilioConfigInputBE, $config: DefaultChannelConfigInput) {
  admin_ {
    createChannel(
      beta: $beta
      botId: $botId
      botName: $botName
      customerId: $customerId
      customPypeCss: $customPypeCss
      name: $name
      style: $style
      type: $type
      config: $config
      twilioParams: $twilioParams
      env: $env
    ) {
      channelId
      channelName
      pypeId
      pypeName
      botPypes {
        agent_routing
        agent_routing_url
        agents_can_initiate_chats
        auto_joinable
        bot_retry {
          attempts
          timeout
        }
        bot_url
        broadcast_stream_id
        chat_default_limit
        chat_log_http_headers
        chat_logs_email
        chat_logs_email_enabled
        chat_logs_end_point
        chat_logs_http_enabled
        checklist_complete
        company_type
        config {
          integration_headers
          integration_name
        }
        creation_date
        crm_enabled
        crm_label
        crm_url
        customer_id
        description
        email
        env
        encrypted
        end_comment_display
        end_comment_required
        end_tags_display
        end_tags_required
        featured
        id
        last_updated
        logo
        logo_generated
        masking_rules {
          description
          name
          regex_patterns
        }
        mode
        name
        phone
        reroute_limit
        sf_deployment
        slug
        status
        streams {
          widgets {
            beta
            created_by
            creation_date
            custom_pype_css
            enable_prechat
            id
            last_updated
            prechat_custom_field1_name
            prechat_custom_field1_value
            prechat_custom_field2_name
            prechat_custom_field2_value
            prechat_email
            prechat_firstname
            prechat_lastname
            prechat_msg
            prechat_phone
            pype_id
            stream_id
            style
            whitelist
            widget_name
          }
          abc_enabled
          abc_id
          analytics_api_host
          analytics_api_key
          analytics_default
          analytics_enabled
          analytics_transcript_enabled
          auto_joinable
          auto_start_with_bot
          awesome_font_icon
          bot_enabled
          bot_flag
          bot_id
          broadcast_channel
          broadcast_sms_limit
          creation_date
          csp_account_id
          csp_agent_bot_token
          csp_channel_type
          csp_enabled
          csp_id
          csp_inbox_id
          description
          end_chat_bot_enabled
          end_chat_bot_id
          fb_access_token
          fb_bot
          fb_enabled
          fb_id
          id
          is_default
          last_updated
          name
          priority
          pype_id
          sms_enabled
          sms_id
          sms_phone_id
          sms_phone_number
          sms_token
          start_chat_bot_enabled
          start_chat_bot_id
          status
          stream_name
          twilio_voice_config
          twilio_voice_enabled
          twilio_voice_id
          vaapi_config
          vaapi_enabled
          vaapi_id
          vaapi_integrator
        }
        tags_categories
        tags_multiple
        tags_shortcuts
        url
        whitelist_domains
        widget_branding
        widget_gateway_identifier
        widget_version
        system_masking_rules {
          description
          name
          regex_patterns
        }
      }
    }
  }
}
    `;
export const PatchV3ConfigurationCustomersCustomerIdChannelChannelIdDocument = gql`
    mutation PatchV3ConfigurationCustomersCustomerIdChannelChannelId($projectId: String!, $customerId: String!, $channelId: String!, $v3ConfigurationCustomerChannelInput: V3ConfigurationCustomerChannelInput!) {
  patchV3ConfigurationCustomersCustomerIdChannelChannelId(
    projectId: $projectId
    customerId: $customerId
    channelId: $channelId
    v3ConfigurationCustomerChannelInput: $v3ConfigurationCustomerChannelInput
  ) {
    ...ChannelConfiguration
  }
}
    ${ChannelConfigurationFragmentDoc}`;
export const PatchV3ConfigurationCustomersCustomerIdChannelChannelIdSandboxDocument = gql`
    mutation PatchV3ConfigurationCustomersCustomerIdChannelChannelIdSandbox($projectId: String!, $customerId: String!, $channelId: String!, $v3ConfigurationCustomerChannelInput: V3ConfigurationCustomerChannelInput!) {
  patchV3ConfigurationCustomersCustomerIdChannelChannelIdSandbox(
    projectId: $projectId
    customerId: $customerId
    channelId: $channelId
    v3ConfigurationCustomerChannelInput: $v3ConfigurationCustomerChannelInput
  ) {
    ...ChannelConfiguration
  }
}
    ${ChannelConfigurationFragmentDoc}`;
export const UpdateAnalyticsForChannelDocument = gql`
    mutation UpdateAnalyticsForChannel($enabled: Boolean!, $projectId: String!, $streamId: String!, $env: SolutionEnvironmentsEnum!) {
  admin_ {
    updateAnalyticsForChannel(
      enabled: $enabled
      env: $env
      projectId: $projectId
      streamId: $streamId
    )
  }
}
    `;
export const SolutionUserPresenceSubscriptionDocument = gql`
    subscription SolutionUserPresenceSubscription($solutionId: String!) {
  tenancy_solution_user_presence(where: {solutionId: {_eq: $solutionId}}) {
    id
    isActive
    lastSeenAt
    pagePath
    pageParams
    userId
    user {
      firstName
      lastName
      picture
      id
    }
  }
}
    `;
export const UpsertSolutionUserPresenceDocument = gql`
    mutation upsertSolutionUserPresence($solutionId: String!, $pagePath: String!, $pageParams: JSON) {
  admin_ {
    upsertSolutionUserPresence(
      solutionId: $solutionId
      pagePath: $pagePath
      pageParams: $pageParams
    ) {
      ...SolutionUserPresenceFields
    }
  }
}
    ${SolutionUserPresenceFieldsFragmentDoc}`;
export const GetCredentialsDocument = gql`
    query GetCredentials($projectId: String!) {
  admin_ {
    credentialsLimited(projectId: $projectId) {
      id
      name
      model
      llmProvider {
        name
      }
      llmProviderId
    }
  }
}
    `;
export const CreateCredentialDocument = gql`
    mutation CreateCredential($credential: LLMCredentialInput!) {
  admin_ {
    createCredential(credential: $credential) {
      id
    }
  }
}
    `;
export const GetPypeRuleGroupsDocument = gql`
    query GetPypeRuleGroups($projectId: String!) {
  admin_ {
    pypeRuleGroupsByProjectId(projectId: $projectId) {
      ...PypeRuleGroupFields
    }
  }
}
    ${PypeRuleGroupFieldsFragmentDoc}`;
export const CreatePypeRuleGroupDocument = gql`
    mutation CreatePypeRuleGroup($projectId: String!, $name: String!, $description: String, $rulesToAdd: [PypeRuleInput!]) {
  admin_ {
    createPypeRuleGroup(
      projectId: $projectId
      name: $name
      description: $description
      rulesToAdd: $rulesToAdd
    ) {
      ...PypeRuleGroupFields
    }
  }
}
    ${PypeRuleGroupFieldsFragmentDoc}`;
export const UpdatePypeRuleGroupDocument = gql`
    mutation UpdatePypeRuleGroup($id: String!, $name: String!, $description: String, $rulesToAdd: [PypeRuleInput!], $rulesToUpdate: [PypeRuleUpdateInput!], $rulesToDelete: [String!]) {
  admin_ {
    updatePypeRuleGroup(
      id: $id
      name: $name
      description: $description
      rulesToAdd: $rulesToAdd
      rulesToUpdate: $rulesToUpdate
      rulesToDelete: $rulesToDelete
    ) {
      ...PypeRuleGroupFields
    }
  }
}
    ${PypeRuleGroupFieldsFragmentDoc}`;
export const DeletePypeRuleGroupDocument = gql`
    mutation DeletePypeRuleGroup($id: String!) {
  admin_ {
    deletePypeRuleGroup(id: $id)
  }
}
    `;
export const AddPypeToPypeRuleGroupDocument = gql`
    mutation AddPypeToPypeRuleGroup($id: String!, $pypeId: String!, $env: SolutionEnvironmentsEnum!) {
  admin_ {
    addPypeToPypeRuleGroup(id: $id, pypeId: $pypeId, env: $env) {
      ...PypeRuleGroupFields
    }
  }
}
    ${PypeRuleGroupFieldsFragmentDoc}`;
export const RemovePypeFromPypeRuleGroupDocument = gql`
    mutation RemovePypeFromPypeRuleGroup($id: String!, $pypeId: String!, $env: SolutionEnvironmentsEnum!) {
  admin_ {
    removePypeFromPypeRuleGroup(id: $id, pypeId: $pypeId, env: $env) {
      ...PypeRuleGroupFields
    }
  }
}
    ${PypeRuleGroupFieldsFragmentDoc}`;
export const GetPypeConnectionsDocument = gql`
    query GetPypeConnections($projectId: String!) {
  admin_ {
    pypeConnectionsByProjectId(projectId: $projectId) {
      ...PypeConnectionFields
    }
  }
}
    ${PypeConnectionFieldsFragmentDoc}`;
export const CreatePypeConnectionDocument = gql`
    mutation CreatePypeConnection($projectId: String!, $name: String!, $platformId: String!, $environment: SolutionEnvironmentsEnum!, $settings: JSON, $agentRouting: String, $agentRoutingUrl: String) {
  admin_ {
    createPypeConnection(
      projectId: $projectId
      name: $name
      platformId: $platformId
      environment: $environment
      settings: $settings
      agentRouting: $agentRouting
      agentRoutingUrl: $agentRoutingUrl
    ) {
      ...PypeConnectionFields
    }
  }
}
    ${PypeConnectionFieldsFragmentDoc}`;
export const UpdatePypeConnectionDocument = gql`
    mutation UpdatePypeConnection($id: String!, $name: String, $platformId: String, $environment: SolutionEnvironmentsEnum, $settings: JSON, $agentRouting: String, $agentRoutingUrl: String) {
  admin_ {
    updatePypeConnection(
      id: $id
      name: $name
      platformId: $platformId
      environment: $environment
      settings: $settings
      agentRouting: $agentRouting
      agentRoutingUrl: $agentRoutingUrl
    ) {
      ...PypeConnectionFields
    }
  }
}
    ${PypeConnectionFieldsFragmentDoc}`;
export const DeletePypeConnectionDocument = gql`
    mutation DeletePypeConnection($id: String!) {
  admin_ {
    deletePypeConnection(id: $id)
  }
}
    `;
export const AddPypeToPypeConnectionDocument = gql`
    mutation AddPypeToPypeConnection($id: String!, $pypeId: String!, $env: SolutionEnvironmentsEnum!) {
  admin_ {
    addPypeToPypeConnection(id: $id, pypeId: $pypeId, env: $env) {
      ...PypeConnectionFields
    }
  }
}
    ${PypeConnectionFieldsFragmentDoc}`;
export const RemovePypeFromPypeConnectionDocument = gql`
    mutation RemovePypeFromPypeConnection($id: String!, $pypeId: String!, $env: SolutionEnvironmentsEnum!) {
  admin_ {
    removePypeFromPypeConnection(id: $id, pypeId: $pypeId, env: $env) {
      ...PypeConnectionFields
    }
  }
}
    ${PypeConnectionFieldsFragmentDoc}`;
export const GetAgentRoutingSchemasDocument = gql`
    query GetAgentRoutingSchemas($customerId: String!, $projectId: String!) {
  externalLive: pypesGetCustomersPypesExternalAgentSchemas(
    customerId: $customerId
    projectId: $projectId
  ) {
    integrations {
      id
      integrationName
      callbackToken
      callbackURL
      integrationFields
    }
  }
  externalSandbox: pypesGetCustomersPypesExternalAgentSchemasSandbox(
    customerId: $customerId
    projectId: $projectId
  ) {
    integrations {
      id
      integrationName
      callbackToken
      callbackURL
      integrationFields
    }
  }
  internalLive: pypesGetCustomersPypesInternalAgentSchemas(
    customerId: $customerId
    projectId: $projectId
  ) {
    data {
      agent_routing
      description
      label
      properties
    }
  }
  internalSandbox: pypesGetCustomersPypesInternalAgentSchemasSandbox(
    customerId: $customerId
    projectId: $projectId
  ) {
    data {
      agent_routing
      description
      label
      properties
    }
  }
}
    `;
export const BulkUpdatePypesLiveDocument = gql`
    mutation BulkUpdatePypesLive($projectId: String!, $customerId: String!, $bulkPypeUpdateInput: BulkPypeUpdateInput!) {
  pypesPutCustomersPypes(
    projectId: $projectId
    customerId: $customerId
    bulkPypeUpdateInput: $bulkPypeUpdateInput
  ) {
    id
    name
  }
}
    `;
export const BulkUpdatePypesSandboxDocument = gql`
    mutation BulkUpdatePypesSandbox($projectId: String!, $customerId: String!, $bulkPypeUpdateInput: BulkPypeUpdateInput!) {
  pypesPutCustomersPypesSandbox(
    projectId: $projectId
    customerId: $customerId
    bulkPypeUpdateInput: $bulkPypeUpdateInput
  ) {
    id
    name
  }
}
    `;
export const PutLiveAgentPypeLiveDocument = gql`
    mutation PutLiveAgentPypeLive($projectId: String!, $customerId: String!, $id: String!, $pypeUpdateInput: PypeUpdateInput) {
  pypesPutCutomerByIdPypesPypeById(
    customerId: $customerId
    id: $id
    projectId: $projectId
    pypeUpdateInput: $pypeUpdateInput
  ) {
    description
    id
    logo
    name
    agent_routing
    agent_routing_url
    agent_routing_config
    bot_retry {
      timeout
      attempts
    }
    autoresponders {
      busy {
        enable
        text
      }
      offline {
        enable
        text
      }
      technical_error {
        enable
        text
      }
    }
  }
}
    `;
export const PutLiveAgentPypeSandboxDocument = gql`
    mutation PutLiveAgentPypeSandbox($projectId: String!, $customerId: String!, $id: String!, $pypeUpdateInput: PypeUpdateInput) {
  pypesPutCutomerByIdPypesPypeByIdSandbox(
    customerId: $customerId
    id: $id
    projectId: $projectId
    pypeUpdateInput: $pypeUpdateInput
  ) {
    description
    id
    logo
    name
    agent_routing
    agent_routing_url
    agent_routing_config
    bot_retry {
      timeout
      attempts
    }
    autoresponders {
      busy {
        enable
        text
      }
      offline {
        enable
        text
      }
      technical_error {
        enable
        text
      }
    }
  }
}
    `;
export const GetProStudioPerformanceMetricsDocument = gql`
    query GetProStudioPerformanceMetrics($limit: Int = 1000, $type: String = "workflows-table-bench", $from: timestamp, $to: timestamp) {
  tenancy_pro_studio_performance_metrics(
    where: {type: {_eq: $type}, createdAt: {_gte: $from, _lte: $to}}
    order_by: {createdAt: desc}
    limit: $limit
  ) {
    id
    type
    settings
    createdAt
    updatedAt
  }
}
    `;
export const GetProStudioPerformanceMetricByIdDocument = gql`
    query GetProStudioPerformanceMetricById($id: String!) {
  tenancy_pro_studio_performance_metrics_by_pk(id: $id) {
    id
    type
    settings
    createdAt
    updatedAt
  }
}
    `;
export const GetCustomersDocument = gql`
    query GetCustomers($projectId: String!) {
  gesGetCustomers(projectId: $projectId) {
    avatar
    botLanguage
    description
    id
    isExternal
    name
  }
}
    `;
export const GetEnvsListDocument = gql`
    query GetEnvsList($projectId: String!) {
  getListEnvs(projectId: $projectId) {
    data
  }
}
    `;
export const GetProStudioVersionDataDocument = gql`
    query GetProStudioVersionData($solutionVersionId: String = "") {
  tenancy_solution_versions_ps_by_pk(solutionVersionId: $solutionVersionId) {
    solutionVersionId
    lastServerSync
    lastServerSyncHash
    lastServerValidation
    lastServerValidationHash
    lastServerSyncError
    lastServerValidationMessages
    columnWidths
    columnPinningSettings
    columnWrapSettings
    solution_version_nodes_ps {
      answerRequired
      behaviors
      command
      decisionVariable
      cssClassname
      description
      id
      intent
      lastModified
      message
      nextNodes
      nodeInput
      nluDisabled
      nodeName
      nodeNumber
      nodeTags
      nodeType
      order
      output
      parameterInput
      parameterInputMap
      richAssetContent
      richAssetContentMap
      analyticsEvent
      analyticsEventMap
      platformFlag
      richAssetType
      skillTag
      solutionVersionId
      variables
      whatsNext
      utterances
      settings
    }
  }
}
    `;
export const UpdateProStudioVersionSyncDocument = gql`
    mutation UpdateProStudioVersionSync($lastServerSync: timestamp, $lastServerSyncHash: Int, $lastServerSyncError: [String!], $solutionVersionId: String! = "", $projectProStudioSettingId: String) {
  update_tenancy_solution_versions_ps_by_pk(
    pk_columns: {solutionVersionId: $solutionVersionId}
    _set: {projectProStudioSettingId: $projectProStudioSettingId, lastServerSyncHash: $lastServerSyncHash, lastServerSync: $lastServerSync, lastServerSyncError: $lastServerSyncError}
  ) {
    lastServerSync
    lastServerSyncHash
    lastServerSyncError
    lastServerValidation
    lastServerValidationHash
    lastServerValidationMessages
  }
}
    `;
export const UpdateProStudioVersionValidationDocument = gql`
    mutation UpdateProStudioVersionValidation($solutionVersionId: String!, $lastServerValidation: timestamp, $lastServerValidationHash: Int, $lastServerValidationMessages: [String!] = [], $projectProStudioSettingId: String) {
  update_tenancy_solution_versions_ps_by_pk(
    pk_columns: {solutionVersionId: $solutionVersionId}
    _set: {projectProStudioSettingId: $projectProStudioSettingId, lastServerValidation: $lastServerValidation, lastServerValidationHash: $lastServerValidationHash, lastServerValidationMessages: $lastServerValidationMessages}
  ) {
    lastServerSync
    lastServerSyncHash
    lastServerSyncError
    lastServerValidation
    lastServerValidationHash
    lastServerValidationMessages
  }
}
    `;
export const GetProStudioNodeVersionsDocument = gql`
    query GetProStudioNodeVersions($partialSolutionVersionId: String = "") {
  tenancy_solution_version_nodes_ps(
    where: {solutionVersionId: {_like: $partialSolutionVersionId}}
    distinct_on: solutionVersionId
  ) {
    solutionVersionId
  }
}
    `;
export const DeleteProStudioNodeDocument = gql`
    mutation DeleteProStudioNode($nodeId: String = "", $solutionVersionId: String = "") {
  delete_tenancy_solution_version_nodes_ps(
    where: {id: {_eq: $nodeId}, _and: {solutionVersionId: {_eq: $solutionVersionId}}}
  ) {
    affected_rows
  }
}
    `;
export const DeleteProStudioNodesDocument = gql`
    mutation DeleteProStudioNodes($nodeIds: [String!] = [], $solutionVersionId: String = "") {
  delete_tenancy_solution_version_nodes_ps(
    where: {id: {_in: $nodeIds}, _and: {solutionVersionId: {_eq: $solutionVersionId}}}
  ) {
    affected_rows
  }
}
    `;
export const DeleteAllProStudioNodesDocument = gql`
    mutation DeleteAllProStudioNodes($solutionVersionId: String = "") {
  delete_tenancy_solution_version_nodes_ps(
    where: {solutionVersionId: {_eq: $solutionVersionId}}
  ) {
    affected_rows
  }
}
    `;
export const GetProStudioNodesDocument = gql`
    query GetProStudioNodes($solutionVersionId: String!) {
  tenancy_solution_version_nodes_ps(
    where: {solutionVersionId: {_eq: $solutionVersionId}}
  ) {
    answerRequired
    behaviors
    command
    cssClassname
    decisionVariable
    description
    id
    intent
    lastModified
    message
    nextNodes
    nluDisabled
    nodeInput
    nodeName
    nodeNumber
    nodeTags
    nodeType
    order
    output
    parameterInput
    parameterInputMap
    platformFlag
    richAssetContent
    richAssetContentMap
    analyticsEvent
    analyticsEventMap
    richAssetType
    skillTag
    solutionVersionId
    variables
    whatsNext
    utterances
    settings
  }
}
    `;
export const UpdateProStudioNodeOrdersDocument = gql`
    mutation UpdateProStudioNodeOrders($objects: [tenancy_solution_version_nodes_ps_insert_input!]!) {
  insert_tenancy_solution_version_nodes_ps(
    objects: $objects
    on_conflict: {constraint: solution_version_nodes_ps_pkey, update_columns: [order]}
  ) {
    affected_rows
    returning {
      id
      order
    }
  }
}
    `;
export const UpdateProStudioNodesDocument = gql`
    mutation UpdateProStudioNodes($objects: [tenancy_solution_version_nodes_ps_insert_input!]!) {
  insert_tenancy_solution_version_nodes_ps(
    objects: $objects
    on_conflict: {constraint: solution_version_nodes_ps_pkey, update_columns: [order, answerRequired, behaviors, command, decisionVariable, cssClassname, description, intent, message, nextNodes, nodeInput, nluDisabled, nodeName, nodeNumber, nodeTags, nodeType, output, parameterInput, parameterInputMap, richAssetContent, richAssetContentMap, analyticsEvent, analyticsEventMap, platformFlag, richAssetType, skillTag, solutionVersionId, variables, whatsNext, utterances, settings]}
  ) {
    returning {
      nodeType
      nodeTags
      nodeNumber
      nodeName
      nodeInput
      nluDisabled
      nextNodes
      message
      lastModified
      intent
      id
      description
      decisionVariable
      cssClassname
      behaviors
      command
      answerRequired
      order
      output
      platformFlag
      parameterInput
      parameterInputMap
      richAssetContent
      richAssetContentMap
      analyticsEvent
      analyticsEventMap
      richAssetType
      skillTag
      solutionVersionId
      variables
      whatsNext
      utterances
      settings
    }
  }
}
    `;
export const PostHistorySearchDocument = gql`
    mutation PostHistorySearch($customerId: String!, $projectId: String!, $searchBody: HistorySearchBody) {
  postHistorySearch(
    customerId: $customerId
    projectId: $projectId
    searchBody: $searchBody
  ) {
    data
  }
}
    `;
export const GetCustomerDataDocument = gql`
    query GetCustomerData($customerId: String!, $projectId: String!) {
  getCustomerById(customerId: $customerId, projectId: $projectId) {
    data
  }
  getCustomerBots(customerId: $customerId, projectId: $projectId) {
    data
  }
  getCustomerPackages(customerId: $customerId, projectId: $projectId) {
    data
  }
  getCustomerResources(customerId: $customerId, projectId: $projectId) {
    data
  }
}
    `;
export const GetBotByIdDocument = gql`
    query GetBotById($botId: String!, $projectId: String!) {
  getBotById(botId: $botId, projectId: $projectId) {
    data
  }
}
    `;
export const GetBotDataDocument = gql`
    query GetBotData($botId: String!, $projectId: String!) {
  getBotVersions(botId: $botId, projectId: $projectId) {
    data
  }
  getBotAssets(botId: $botId, projectId: $projectId) {
    data
  }
  getEntities(botId: $botId, projectId: $projectId) {
    data
    messages
  }
  getIntents(botId: $botId, projectId: $projectId) {
    data
    messages
  }
  getSupervisedLearning(botId: $botId, projectId: $projectId) {
    data
    messages
  }
  getEnvBotVersions(botId: $botId, projectId: $projectId) {
    data
  }
}
    `;
export const GetVersionByIdDocument = gql`
    query GetVersionById($versionId: String!, $projectId: String!) {
  getVersionById(versionId: $versionId, projectId: $projectId) {
    data
    messages
  }
}
    `;
export const ValidateVersionDocument = gql`
    query ValidateVersion($versionId: String!, $projectId: String!) {
  getVersionValidate(versionId: $versionId, projectId: $projectId) {
    data
  }
}
    `;
export const CreateCustomerBotDocument = gql`
    mutation CreateCustomerBot($botName: String!, $customerId: String!, $projectId: String!, $botType: String = "") {
  postCustomerBots(
    customerBotsInput: {botName: $botName, botType: $botType}
    customerId: $customerId
    projectId: $projectId
  ) {
    data
  }
}
    `;
export const CreateBotVersionDocument = gql`
    mutation CreateBotVersion($botId: String!, $projectId: String!, $basedOn: String = "") {
  postBotVersions(
    botId: $botId
    botVersionsInput: {basedOn: $basedOn}
    projectId: $projectId
  ) {
    data
  }
}
    `;
export const DeleteBotDocument = gql`
    mutation DeleteBot($botId: String!, $projectId: String!) {
  deleteBotById(botId: $botId, projectId: $projectId) {
    data
  }
}
    `;
export const GetVersionFileDocument = gql`
    query GetVersionFile($filePath: String!, $versionId: String!, $projectId: String!) {
  getVersionFile(
    filePath: $filePath
    projectId: $projectId
    versionId: $versionId
  )
  getVersionGraph(projectId: $projectId, versionId: $versionId)
}
    `;
export const DeployBotVersionDocument = gql`
    mutation DeployBotVersion($versionId: String!, $environment: String!, $projectId: String!, $doVersionBump: Boolean = false) {
  putVersionDeploy(
    projectId: $projectId
    versionId: $versionId
    versionDeployInput: {environment: $environment, doVersionBump: $doVersionBump}
  ) {
    data
    messages
  }
}
    `;
export const PatchBotByIdDocument = gql`
    mutation PatchBotById($botId: String!, $botType: String!, $projectId: String!) {
  patchBotById(
    bot2Input: {botType: $botType}
    botId: $botId
    projectId: $projectId
  ) {
    data
  }
}
    `;
export const PatchBotTranslationDocument = gql`
    mutation PatchBotTranslation($botId: String!, $projectId: String!, $translateInput: Boolean!, $translateOutput: Boolean!) {
  patchBotById(
    bot2Input: {translateInput: $translateInput, translateOutput: $translateOutput}
    botId: $botId
    projectId: $projectId
  ) {
    data
  }
}
    `;
export const PutVersionTrainDocument = gql`
    mutation PutVersionTrain($versionId: String!, $projectId: String!) {
  putVersionTrain(projectId: $projectId, versionId: $versionId) {
    data
    messages
  }
}
    `;
export const GetAssetByIdDocument = gql`
    query GetAssetById($assetId: String!, $botId: String!, $projectId: String!) {
  getBotAssetById(assetId: $assetId, botId: $botId, projectId: $projectId) {
    data
  }
}
    `;
export const DeleteBotAssetDocument = gql`
    mutation DeleteBotAsset($botId: String!, $assetId: String!, $projectId: String!) {
  deleteBotAssetById(assetId: $assetId, botId: $botId, projectId: $projectId) {
    data
  }
}
    `;
export const DeleteScriptByIdDocument = gql`
    mutation DeleteScriptById($projectId: String!, $scriptId: String!, $versionId: String!) {
  deleteVersionScriptById(
    projectId: $projectId
    scriptId: $scriptId
    versionId: $versionId
  ) {
    data
    messages
  }
}
    `;
export const GetCustomerPypesV6Document = gql`
    query GetCustomerPypesV6($customerId: String!, $botId: String, $projectId: String!) {
  pypesV6GetCustomersPypes(
    customerId: $customerId
    botId: $botId
    projectId: $projectId
  ) {
    data {
      id
      name
      status
      agent_routing
      agent_routing_url
      agent_routing_config
      bot_retry {
        timeout
        attempts
      }
      description
      logo
      logo_generated
      streams {
        id
        start_chat_bot_id
        start_chat_bot_enabled
        end_chat_bot_enabled
        end_chat_bot_id
        bot_enabled
        auto_start_with_bot
        name
        stream_name
        widgets {
          id
          style
          last_updated
          widget_name
          stream_id
          pype_id
          beta
          custom_pype_css
        }
        last_updated
        twilio_voice_config
        twilio_voice_enabled
        twilio_voice_id
        vaapi_enabled
        vaapi_config
        analytics_enabled
      }
    }
  }
  pypesV6GetCustomersPypesSandbox(
    customerId: $customerId
    botId: $botId
    projectId: $projectId
  ) {
    data {
      id
      name
      status
      agent_routing
      agent_routing_url
      agent_routing_config
      bot_retry {
        timeout
        attempts
      }
      description
      logo
      logo_generated
      streams {
        id
        start_chat_bot_id
        start_chat_bot_enabled
        end_chat_bot_enabled
        end_chat_bot_id
        bot_enabled
        auto_start_with_bot
        name
        stream_name
        widgets {
          id
          style
          last_updated
          widget_name
          stream_id
          pype_id
          beta
          custom_pype_css
        }
        last_updated
        twilio_voice_config
        twilio_voice_enabled
        twilio_voice_id
        vaapi_enabled
        vaapi_config
        analytics_enabled
      }
    }
  }
}
    `;
export const MutatePostWidgetLiveDocument = gql`
    mutation MutatePostWidgetLive($pypeId: String!, $widgetId: String, $streamId: String!, $requestAction: String!, $widget_name: String!, $projectId: String!, $custom_pype_css: String = "", $style: String = "", $beta: String = "", $requestType: String = "x_widget", $type: String = "request", $version: Int = 1, $authToken: String = "", $userId: String = "", $correlationId: String = "") {
  postV3BusinessWidget(
    projectId: $projectId
    v3BusinessWidgetInput: {data: {pype_id: $pypeId, id: $widgetId, stream_id: $streamId, style: $style, widget_name: $widget_name, beta: $beta, custom_pype_css: $custom_pype_css}, authToken: $authToken, correlationId: $correlationId, replyTo: $pypeId, requestAction: $requestAction, requestType: $requestType, type: $type, userId: $userId, version: $version}
  ) {
    data {
      id
      widget_name
      style
      pype_id
      stream_id
      last_updated
      custom_pype_css
      beta
      created_by
      creation_date
    }
  }
}
    `;
export const MutatePostWidgetSandboxDocument = gql`
    mutation MutatePostWidgetSandbox($pypeId: String!, $widgetId: String, $streamId: String!, $requestAction: String!, $widget_name: String!, $projectId: String!, $custom_pype_css: String = "", $style: String = "", $beta: String = "", $requestType: String = "x_widget", $type: String = "request", $version: Int = 1, $authToken: String = "", $userId: String = "", $correlationId: String = "") {
  postV3BusinessWidgetSandbox(
    projectId: $projectId
    v3BusinessWidgetInput: {data: {pype_id: $pypeId, id: $widgetId, stream_id: $streamId, style: $style, widget_name: $widget_name, beta: $beta, custom_pype_css: $custom_pype_css}, authToken: $authToken, correlationId: $correlationId, replyTo: $pypeId, requestAction: $requestAction, requestType: $requestType, type: $type, userId: $userId, version: $version}
  ) {
    data {
      id
      widget_name
      style
      pype_id
      stream_id
      last_updated
      custom_pype_css
      beta
      created_by
      creation_date
    }
  }
}
    `;
export const MutatePutWidgetLiveDocument = gql`
    mutation MutatePutWidgetLive($pypeId: String!, $widgetId: String, $streamId: String!, $requestAction: String!, $widget_name: String!, $projectId: String!, $custom_pype_css: String = "", $style: String = "", $beta: String = "", $requestType: String = "x_widget", $type: String = "request", $version: Int = 1, $authToken: String = "", $userId: String = "", $correlationId: String = "") {
  putV3BusinessWidget(
    projectId: $projectId
    v3BusinessWidgetInput: {data: {pype_id: $pypeId, id: $widgetId, stream_id: $streamId, style: $style, widget_name: $widget_name, beta: $beta, custom_pype_css: $custom_pype_css}, authToken: $authToken, correlationId: $correlationId, replyTo: $pypeId, requestAction: $requestAction, requestType: $requestType, type: $type, userId: $userId, version: $version}
  ) {
    data {
      id
      widget_name
      style
      pype_id
      stream_id
      last_updated
      custom_pype_css
      beta
      created_by
      creation_date
    }
  }
}
    `;
export const MutatePutWidgetSandboxDocument = gql`
    mutation MutatePutWidgetSandbox($pypeId: String!, $widgetId: String, $streamId: String!, $requestAction: String!, $widget_name: String!, $projectId: String!, $custom_pype_css: String = "", $style: String = "", $beta: String = "", $requestType: String = "x_widget", $type: String = "request", $version: Int = 1, $authToken: String = "", $userId: String = "", $correlationId: String = "") {
  putV3BusinessWidgetSandbox(
    projectId: $projectId
    v3BusinessWidgetInput: {data: {pype_id: $pypeId, id: $widgetId, stream_id: $streamId, style: $style, widget_name: $widget_name, beta: $beta, custom_pype_css: $custom_pype_css}, authToken: $authToken, correlationId: $correlationId, replyTo: $pypeId, requestAction: $requestAction, requestType: $requestType, type: $type, userId: $userId, version: $version}
  ) {
    data {
      id
      widget_name
      style
      pype_id
      stream_id
      last_updated
      custom_pype_css
      beta
      created_by
      creation_date
    }
  }
}
    `;
export const CreateStreamLiveDocument = gql`
    mutation CreateStreamLive($pypeId: String!, $customerId: String!, $name: String!, $projectId: String!) {
  pypesPostCustomersPypesStreams(
    customerId: $customerId
    pypeId: $pypeId
    streamInput: {name: $name}
    projectId: $projectId
  ) {
    id
  }
}
    `;
export const CreateStreamSandboxDocument = gql`
    mutation CreateStreamSandbox($pypeId: String!, $customerId: String!, $name: String!, $projectId: String!) {
  pypesPostCustomersPypesStreamsSandbox(
    customerId: $customerId
    pypeId: $pypeId
    streamInput: {name: $name}
    projectId: $projectId
  ) {
    id
  }
}
    `;
export const UpdateStreamBotLiveDocument = gql`
    mutation UpdateStreamBotLive($pypeId: String!, $streamId: String!, $customerId: String!, $startChatBotId: String!, $projectId: String!, $endChatBotId: String = "", $endChatBotEnabled: Boolean = true, $startChatBotEnabled: Boolean = true) {
  pypesPutCustomersPypesStreamsBot(
    pypeId: $pypeId
    streamId: $streamId
    customerId: $customerId
    projectId: $projectId
    botInput: {autoStartWithBot: true, botEnabled: true, endChatBotEnabled: $endChatBotEnabled, endChatBotId: $endChatBotId, startChatBotEnabled: $startChatBotEnabled, startChatBotId: $startChatBotId}
  ) {
    id
    auto_start_with_bot
    bot_enabled
    end_chat_bot_enabled
    end_chat_bot_id
    start_chat_bot_enabled
    start_chat_bot_id
  }
}
    `;
export const UpdateStreamBotSandboxDocument = gql`
    mutation UpdateStreamBotSandbox($pypeId: String!, $streamId: String!, $customerId: String!, $startChatBotId: String!, $projectId: String!, $endChatBotId: String = "", $endChatBotEnabled: Boolean = true, $startChatBotEnabled: Boolean = true) {
  pypesPutCustomersPypesStreamsBotSandbox(
    pypeId: $pypeId
    streamId: $streamId
    customerId: $customerId
    projectId: $projectId
    botInput: {autoStartWithBot: true, botEnabled: true, endChatBotEnabled: $endChatBotEnabled, endChatBotId: $endChatBotId, startChatBotEnabled: $startChatBotEnabled, startChatBotId: $startChatBotId}
  ) {
    id
    auto_start_with_bot
    bot_enabled
    end_chat_bot_enabled
    end_chat_bot_id
    start_chat_bot_enabled
    start_chat_bot_id
  }
}
    `;
export const GetCustomersPypesAutorespondersDocument = gql`
    query GetCustomersPypesAutoresponders($customerId: String!, $projectId: String!) {
  pypesGetCustomersPypes(customerId: $customerId, projectId: $projectId) {
    id
    autoresponders {
      busy {
        enable
        text
      }
      offline {
        enable
        text
      }
      technical_error {
        enable
        text
      }
    }
  }
  pypesGetCustomersPypesSandbox(customerId: $customerId, projectId: $projectId) {
    id
    autoresponders {
      busy {
        enable
        text
      }
      offline {
        enable
        text
      }
      technical_error {
        enable
        text
      }
    }
  }
}
    `;
export const PutCustomerPypeLiveDocument = gql`
    mutation PutCustomerPypeLive($projectId: String!, $customerId: String!, $id: String!) {
  pypesPutCutomerByIdPypesPypeById(
    customerId: $customerId
    id: $id
    projectId: $projectId
  ) {
    description
    id
    logo
    name
  }
}
    `;
export const PutCustomerPypeSandboxDocument = gql`
    mutation PutCustomerPypeSandbox($projectId: String!, $customerId: String!, $id: String!) {
  pypesPutCutomerByIdPypesPypeByIdSandbox(
    customerId: $customerId
    id: $id
    projectId: $projectId
  ) {
    description
    id
    logo
    name
  }
}
    `;
export const PatchPypeConfigLiveDocument = gql`
    mutation PatchPypeConfigLive($projectId: String!, $pypeId: String!, $agentRouting: AgentRouting!, $integrationHeaders: IntegrationHeadersInput, $integrationName: String = "", $attempts: Int = 3, $timeout: Int = 35000) {
  patchV3ConfigurationPypePypeId(
    projectId: $projectId
    pypeId: $pypeId
    v3ConfigurationPypeInput: {agentRouting: $agentRouting, config: {integrationHeaders: $integrationHeaders, integrationName: $integrationName}}
  ) {
    agent_routing
    bot_retry {
      attempts
      timeout
    }
    config {
      integration_headers
      integration_name
    }
  }
}
    `;
export const PatchPypeConfigSandboxDocument = gql`
    mutation PatchPypeConfigSandbox($projectId: String!, $pypeId: String!, $agentRouting: AgentRouting!, $integrationHeaders: IntegrationHeadersInput, $integrationName: String = "", $attempts: Int = 3, $timeout: Int = 35000) {
  patchV3ConfigurationPypePypeIdSandbox(
    projectId: $projectId
    pypeId: $pypeId
    v3ConfigurationPypeInput: {agentRouting: $agentRouting, config: {integrationHeaders: $integrationHeaders, integrationName: $integrationName}}
  ) {
    agent_routing
    bot_retry {
      attempts
      timeout
    }
    config {
      integration_headers
      integration_name
    }
  }
}
    `;
export const GetPypeConfigLiveDocument = gql`
    query GetPypeConfigLive($projectId: String!, $pypeId: String!) {
  getV3ConfigurationPypePypeId(projectId: $projectId, pypeId: $pypeId) {
    agent_routing
    bot_retry {
      attempts
      timeout
    }
    config {
      integration_headers
      integration_name
    }
  }
}
    `;
export const GetPypeConfigSandboxDocument = gql`
    query GetPypeConfigSandbox($projectId: String!, $pypeId: String!) {
  getV3ConfigurationPypePypeIdSandbox(projectId: $projectId, pypeId: $pypeId) {
    agent_routing
    bot_retry {
      attempts
      timeout
    }
    config {
      integration_headers
      integration_name
    }
  }
}
    `;
export const GetExternalAgentSchemasDocument = gql`
    query GetExternalAgentSchemas($customerId: String!, $projectId: String!) {
  getV3ConfigurationCustomersCustomerIdExternalAgentSchemas(
    customerId: $customerId
    projectId: $projectId
  ) {
    integrations {
      callbackToken
      callbackURL
      id
      integrationFields
    }
  }
  getV3ConfigurationCustomersCustomerIdExternalAgentSchemasSandbox(
    customerId: $customerId
    projectId: $projectId
  ) {
    integrations {
      callbackToken
      callbackURL
      id
      integrationFields
    }
  }
}
    `;
export const DeletePypeLiveDocument = gql`
    mutation DeletePypeLive($projectId: String!, $customerId: String!, $id: String!) {
  pypesDeleteCustomersPypesById(
    customerId: $customerId
    id: $id
    projectId: $projectId
  )
}
    `;
export const DeletePypeSandboxDocument = gql`
    mutation DeletePypeSandbox($projectId: String!, $customerId: String!, $id: String!) {
  pypesDeleteCustomersPypesByIdSandbox(
    customerId: $customerId
    id: $id
    projectId: $projectId
  )
}
    `;
export const UploadBotAssetDocument = gql`
    mutation UploadBotAsset($botId: String!, $botAssetsInput: BotAssetsInput! = {assetData: ""}, $projectId: String!) {
  putBotAssets(
    botAssetsInput: $botAssetsInput
    botId: $botId
    projectId: $projectId
  ) {
    data
  }
}
    `;
export const PostVersionsConfigDocument = gql`
    mutation PostVersionsConfig($projectId: String!, $versionId: String!, $configFile: Upload!) {
  postVersionConfig(
    projectId: $projectId
    versionConfigInput: {configFile: $configFile}
    versionId: $versionId
  ) {
    data
    messages
  }
}
    `;
export const PostVersionsScriptDocument = gql`
    mutation PostVersionsScript($projectId: String!, $versionId: String!, $scriptFile: [Upload]!) {
  postVersionScript(
    projectId: $projectId
    versionId: $versionId
    versionScriptsInput: {scriptFile: $scriptFile}
  ) {
    data
    messages
  }
}
    `;
export const GetUserProjectsDocument = gql`
    query GetUserProjects($userId: String!) {
  tenancy_users(where: {id: {_eq: $userId}}) {
    user_accounts {
      user_account_projects(order_by: {project: {name: asc}}) {
        _user_account_project_roles {
          role {
            name
            id
            product {
              name
              id
            }
          }
        }
        project {
          id
          name
          accountId
          project_product_settings {
            product {
              id
              name
              displayName
            }
          }
        }
      }
    }
    _user_teams {
      team {
        team_accounts {
          team_account_projects(order_by: {project: {name: asc}}) {
            _team_account_project_roles {
              role {
                name
                id
                product {
                  name
                  id
                }
              }
            }
            project {
              id
              name
              accountId
              project_product_settings {
                product {
                  id
                  name
                  displayName
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetUserPictureByEmailDocument = gql`
    query GetUserPictureByEmail($userEmail: String!) {
  tenancy_users(where: {userName: {_eq: $userEmail}}) {
    picture
    files {
      publicId
      url
    }
  }
}
    `;
export const UpdateColumnsWidthDocument = gql`
    mutation UpdateColumnsWidth($solutionVersionId: String! = "", $columnWidths: jsonb! = {}) {
  update_tenancy_solution_versions_ps_by_pk(
    pk_columns: {solutionVersionId: $solutionVersionId}
    _set: {columnWidths: $columnWidths}
  ) {
    columnWidths
  }
}
    `;
export const UpdateColumnPinningSettingsDocument = gql`
    mutation UpdateColumnPinningSettings($solutionVersionId: String! = "", $columnPinningSettings: jsonb! = {}) {
  update_tenancy_solution_versions_ps_by_pk(
    pk_columns: {solutionVersionId: $solutionVersionId}
    _set: {columnPinningSettings: $columnPinningSettings}
  ) {
    columnPinningSettings
  }
}
    `;
export const UpdateColumnWrapSettingsDocument = gql`
    mutation UpdateColumnWrapSettings($solutionVersionId: String! = "", $columnWrapSettings: jsonb! = {}) {
  update_tenancy_solution_versions_ps_by_pk(
    pk_columns: {solutionVersionId: $solutionVersionId}
    _set: {columnWrapSettings: $columnWrapSettings}
  ) {
    columnWrapSettings
  }
}
    `;
export const GetStudioResourcesDocument = gql`
    query GetStudioResources {
  admin_ {
    studioResources {
      description
      endNodeNumber
      id
      name
      nodes {
        answerRequired
        behaviors
        command
        cssClassname
        decisionVariable
        description
        id
        intent
        message
        nextNodes
        nluDisabled
        nodeInput
        nodeName
        nodeNumber
        nodeTags
        nodeType
        order
        output
        parameterInput
        platformFlag
        richAssetType
        skillTag
        studioResourceId
        utterances
        variables
        whatsNext
      }
      startNodeNumber
      type
    }
  }
}
    `;
export const GetActionNodeNamesDocument = gql`
    query GetActionNodeNames {
  admin_ {
    getActionNodeNames
  }
}
    `;
export const MutatePutWidgetAppDesignDocument = gql`
    mutation MutatePutWidgetAppDesign($appId: String!, $projectId: String!, $config: JSON!, $schemaVersion: Int! = 1) {
  putWidgetAppDesign(
    appId: $appId
    projectId: $projectId
    widgetAppDesignInput: {config: $config, schemaVersion: $schemaVersion}
  ) {
    config
    metadata {
      revision
      schemaVersion
      updatedAt
      updatedBy {
        email
        id
      }
    }
  }
}
    `;
export const MutatePutWidgetAppDesignSandboxDocument = gql`
    mutation MutatePutWidgetAppDesignSandbox($appId: String!, $projectId: String!, $config: JSON!, $schemaVersion: Int! = 1) {
  putWidgetAppDesignSandbox(
    appId: $appId
    projectId: $projectId
    widgetAppDesignInput: {config: $config, schemaVersion: $schemaVersion}
  ) {
    config
    metadata {
      revision
      schemaVersion
      updatedAt
      updatedBy {
        email
        id
      }
    }
  }
}
    `;
export const GetProjectUsersDocument = gql`
    query GetProjectUsers($projectId: String!) {
  admin_ {
    projectById(id: $projectId) {
      users {
        rows {
          id
          firstName
          lastName
          picture
        }
      }
    }
  }
}
    `;
export const AssignProjectProductAdminRolesDocument = gql`
    mutation AssignProjectProductAdminRoles($projectId: String!) {
  admin_ {
    assignProjectProductAdminRoles(projectId: $projectId) {
      id
    }
  }
}
    `;
export const GetProvidersDocument = gql`
    query GetProviders {
  admin_ {
    providers {
      id
      name
    }
  }
}
    `;
export const GetPypeKeysLiveDocument = gql`
    query GetPypeKeysLive($projectId: String!, $customerId: String!, $pypeId: String!) {
  pypesGetCustomersPypesKeys(
    projectId: $projectId
    customerId: $customerId
    pypeId: $pypeId
  ) {
    keys {
      friendly_name
      description
      key
      date_created
      date_updated
    }
  }
}
    `;
export const GetPypeKeysSandboxDocument = gql`
    query GetPypeKeysSandbox($projectId: String!, $customerId: String!, $pypeId: String!) {
  pypesGetCustomersPypesKeysSandbox(
    projectId: $projectId
    customerId: $customerId
    pypeId: $pypeId
  ) {
    keys {
      friendly_name
      description
      key
      date_created
      date_updated
    }
  }
}
    `;
export const PostPypeKeyLiveDocument = gql`
    mutation PostPypeKeyLive($projectId: String!, $customerId: String!, $pypeId: String!, $apiKeyInput: ApiKeyInput!) {
  pypesPostCustomersPypesKeys(
    projectId: $projectId
    customerId: $customerId
    pypeId: $pypeId
    apiKeyInput: $apiKeyInput
  ) {
    friendly_name
    description
    key
    secret
  }
}
    `;
export const PostPypeKeySandboxDocument = gql`
    mutation PostPypeKeySandbox($projectId: String!, $customerId: String!, $pypeId: String!, $apiKeyInput: ApiKeyInput!) {
  pypesPostCustomersPypesKeysSandbox(
    projectId: $projectId
    customerId: $customerId
    pypeId: $pypeId
    apiKeyInput: $apiKeyInput
  ) {
    friendly_name
    description
    key
    secret
  }
}
    `;
export const PutPypeKeyLiveDocument = gql`
    mutation PutPypeKeyLive($projectId: String!, $customerId: String!, $id: String!, $pypeId: String!, $apiKeyUpdateInput: ApiKeyUpdateInput!) {
  pypesPutCustomersPypesKeysById(
    projectId: $projectId
    customerId: $customerId
    id: $id
    pypeId: $pypeId
    apiKeyUpdateInput: $apiKeyUpdateInput
  ) {
    friendly_name
    description
    key
  }
}
    `;
export const PutPypeKeySandboxDocument = gql`
    mutation PutPypeKeySandbox($projectId: String!, $customerId: String!, $id: String!, $pypeId: String!, $apiKeyUpdateInput: ApiKeyUpdateInput!) {
  pypesPutCustomersPypesKeysByIdSandbox(
    projectId: $projectId
    customerId: $customerId
    id: $id
    pypeId: $pypeId
    apiKeyUpdateInput: $apiKeyUpdateInput
  ) {
    friendly_name
    description
    key
  }
}
    `;
export const DeletePypeKeyLiveDocument = gql`
    mutation DeletePypeKeyLive($projectId: String!, $customerId: String!, $id: String!, $pypeId: String!) {
  pypesDeleteCustomersPypesKeysById(
    projectId: $projectId
    customerId: $customerId
    id: $id
    pypeId: $pypeId
  )
}
    `;
export const DeletePypeKeySandboxDocument = gql`
    mutation DeletePypeKeySandbox($projectId: String!, $customerId: String!, $id: String!, $pypeId: String!) {
  pypesDeleteCustomersPypesKeysByIdSandbox(
    projectId: $projectId
    customerId: $customerId
    id: $id
    pypeId: $pypeId
  )
}
    `;
export const CreateSolutionDocument = gql`
    mutation CreateSolution($projectProStudioSettingId: String!, $solution: SolutionInput!, $version: SolutionVersionInput!, $createDefaultChannels: Boolean = true) {
  admin_ {
    createSolution(
      projectProStudioSettingId: $projectProStudioSettingId
      solution: $solution
      version: $version
      createDefaultChannels: $createDefaultChannels
    ) {
      ...SolutionFields
    }
  }
}
    ${SolutionFieldsFragmentDoc}`;
export const UpdateSolutionVersionDocument = gql`
    mutation UpdateSolutionVersion($version: SolutionVersionInput!) {
  admin_ {
    updateSolutionVersion(version: $version) {
      ...SolutionVersionFields
    }
  }
}
    ${SolutionVersionFieldsFragmentDoc}`;
export const UpdateSolutionDisplayNameDocument = gql`
    mutation UpdateSolutionDisplayName($displayName: String!, $solutionId: String!) {
  admin_ {
    updateSolution(displayName: $displayName, solutionId: $solutionId) {
      displayName
      id
      name
      botSolutionId
    }
  }
}
    `;
export const UpdateSolutionTypeDocument = gql`
    mutation UpdateSolutionType($solutionId: String!, $type: SolutionTypeEnum!) {
  admin_ {
    updateSolution(solutionId: $solutionId, type: $type) {
      id
      type
    }
  }
}
    `;
export const DeleteSolutionDocument = gql`
    mutation DeleteSolution($solutionId: String!) {
  admin_ {
    deleteSolution(solutionId: $solutionId)
  }
}
    `;
export const PublishSolutionVersionDocument = gql`
    mutation PublishSolutionVersion($draftVersionId: String!, $environment: SolutionEnvironmentsEnum!, $useBotCompiler: Boolean) {
  admin_ {
    publishSolutionVersion(
      draftVersionId: $draftVersionId
      environment: $environment
      useBotCompiler: $useBotCompiler
    )
  }
}
    `;
export const RepublishSolutionDeploymentDocument = gql`
    mutation RepublishSolutionDeployment($solutionDeploymentId: String!) {
  admin_ {
    republishSolutionDeployment(solutionDeploymentId: $solutionDeploymentId)
  }
}
    `;
export const GetSolutionsDocument = gql`
    query GetSolutions($projectProStudioSettingId: String!) {
  admin_ {
    solutions(projectProStudioSettingId: $projectProStudioSettingId) {
      botSolutionId
      defaultDraftVersionId
      displayName
      id
      name
      type
      settings
    }
  }
}
    `;
export const GetSolutionVersionsDocument = gql`
    query GetSolutionVersions($solutionId: String!) {
  admin_ {
    solutionVersions(solutionId: $solutionId) {
      ...SolutionVersionFields
    }
  }
}
    ${SolutionVersionFieldsFragmentDoc}`;
export const GetSolutionVersionByIdDocument = gql`
    query GetSolutionVersionById($solutionVersionByIdId: String!) {
  admin_ {
    solutionVersionById(id: $solutionVersionByIdId) {
      ...SolutionVersionFields
    }
  }
}
    ${SolutionVersionFieldsFragmentDoc}`;
export const GetSolutionByIdDocument = gql`
    query GetSolutionById($solutionByIdId: String!) {
  admin_ {
    solutionById(id: $solutionByIdId) {
      ...SolutionFields
      live: latestSolutionDeployment(status: "finished", environment: live) {
        deployedAt
        status
        deployedBy {
          firstName
          lastName
          picture
        }
        solutionVersion {
          id
          name
          version
        }
      }
      sandbox: latestSolutionDeployment(status: "finished", environment: sandbox) {
        deployedAt
        status
        deployedBy {
          firstName
          lastName
          picture
        }
        solutionVersion {
          id
          name
          version
        }
      }
    }
  }
}
    ${SolutionFieldsFragmentDoc}`;
export const GetSolutionDeploymentHistoryDocument = gql`
    query GetSolutionDeploymentHistory($solutionId: String!) {
  admin_ {
    solutionById(id: $solutionId) {
      id
      solutionDeployments {
        id
        environment
        status
        deployedAt
        isRepublish
        deployedBy {
          firstName
          lastName
          picture
        }
        solutionVersion {
          id
          name
          version
        }
      }
    }
  }
}
    `;
export const GetSolutionVersionPsKeysDocument = gql`
    query GetSolutionVersionPsKeys($keys: [String!]) {
  tenancy_solution_versions_ps(where: {solutionVersionId: {_in: $keys}}) {
    solutionVersionId
    isUsingUpdatedId
  }
}
    `;
export const SolutionDeploymentsSubscriptionDocument = gql`
    subscription SolutionDeploymentsSubscription($solutionId: String!) {
  tenancy_solution_deployments(
    where: {solutionId: {_eq: $solutionId}}
    order_by: {createdAt: desc}
    limit: 20
  ) {
    id
    environment
    status
    deployedAt
    deployedBy
    isRepublish
    isLatest
    solutionVersionId
    createdAt
    updatedAt
    solution_version {
      id
      name
      version
    }
    solution_deployment_runs(order_by: {createdAt: asc}) {
      id
      status
      updatedAt
    }
  }
}
    `;
export const GetSolutionDeploymentForVersionDocument = gql`
    query GetSolutionDeploymentForVersion($solutionVersionId: String!, $environment: String!) {
  tenancy_solution_deployments(
    where: {solutionVersionId: {_eq: $solutionVersionId}, environment: {_eq: $environment}}
    limit: 1
  ) {
    id
  }
}
    `;
export const GetSolutionPublishedEnvironmentsDocument = gql`
    query GetSolutionPublishedEnvironments($solutionId: String!) {
  tenancy_solution_deployments(
    where: {solutionId: {_eq: $solutionId}, status: {_eq: "finished"}}
    distinct_on: environment
  ) {
    environment
  }
}
    `;
export const GetSolutionDeploymentLogsDocument = gql`
    query GetSolutionDeploymentLogs($deploymentId: String!) {
  admin_ {
    solutionDeploymentLogs(deploymentId: $deploymentId) {
      rawLogs
      structuredLogs {
        name
        status
        lines
      }
    }
  }
}
    `;
export const SolutionPublishStatusSubscriptionDocument = gql`
    subscription SolutionPublishStatusSubscription($id: String!) {
  tenancy_solutions_by_pk(id: $id) {
    id
    status
    publishStartedAt
  }
}
    `;
export const SolutionVersionStatusSubscriptionDocument = gql`
    subscription SolutionVersionStatusSubscription($id: String!) {
  tenancy_solution_versions_by_pk(id: $id) {
    id
    status
  }
}
    `;
export const SolutionVersionSubscriptionDocument = gql`
    subscription SolutionVersionSubscription($solutionVersionId: String = "") {
  tenancy_solution_versions_ps_by_pk(solutionVersionId: $solutionVersionId) {
    solutionVersionId
    lastServerSync
    lastServerSyncHash
    lastServerValidation
    lastServerValidationHash
    lastServerSyncError
    lastServerValidationMessages
    columnWidths
    columnPinningSettings
    columnWrapSettings
    solution_version_nodes_ps {
      answerRequired
      behaviors
      command
      decisionVariable
      cssClassname
      description
      id
      intent
      lastModified
      message
      nextNodes
      nodeInput
      nluDisabled
      nodeName
      nodeNumber
      nodeTags
      nodeType
      order
      output
      parameterInput
      parameterInputMap
      richAssetContent
      richAssetContentMap
      analyticsEvent
      analyticsEventMap
      platformFlag
      richAssetType
      skillTag
      solutionVersionId
      variables
      whatsNext
      utterances
      settings
    }
  }
}
    `;
export const GetVoiceAiProvidersDocument = gql`
    query GetVoiceAiProviders($args: GetVoiceAiProvidersInput!) {
  getVoiceAiProviders(args: $args) {
    ...VoiceAiProviderResultFragment
  }
}
    ${VoiceAiProviderResultFragmentFragmentDoc}`;
export const GetVoiceAiProvidersSandboxDocument = gql`
    query GetVoiceAiProvidersSandbox($args: GetVoiceAiProvidersInput!) {
  getVoiceAiProvidersSandbox(args: $args) {
    ...VoiceAiProviderResultFragment
  }
}
    ${VoiceAiProviderResultFragmentFragmentDoc}`;
export const GetVoiceAiVoicesV2Document = gql`
    query GetVoiceAiVoicesV2($args: GetVoiceAiVoicesV2Input!) {
  getVoiceAiVoicesV2(args: $args) {
    ...VoiceAiProviderResultFragment
  }
}
    ${VoiceAiProviderResultFragmentFragmentDoc}`;
export const GetVoiceAiAccentsDocument = gql`
    query GetVoiceAiAccents($args: GetVoiceAiAccentsInput!) {
  getVoiceAiAccents(args: $args) {
    language
    accents
  }
}
    `;
export const GetVoiceAiLanguagesDocument = gql`
    query GetVoiceAiLanguages {
  getVoiceAiLanguages {
    count
    languages {
      language
      name
      default_locale
      stt_providers
      locales {
        locale
        stt_providers
      }
    }
  }
}
    `;
export const GetUserLoginInfoDocument = gql`
    query GetUserLoginInfo($email: String!) {
  admin_ {
    getUserLoginInfo(email: $email) {
      authMethods {
        isActive
        isCreationOne
        isCustom
        name
        providerId
        type
      }
      email
      passwordRecoveryStatus
    }
  }
}
    `;
export const SetUserPasswordRecoveryStatusDocument = gql`
    mutation SetUserPasswordRecoveryStatus($userId: String!, $passwordRecoveryStatus: PasswordRecoveryStatusEnum!) {
  admin_ {
    setUserPasswordRecoveryStatus(
      passwordRecoveryStatus: $passwordRecoveryStatus
      userId: $userId
    ) {
      status
    }
  }
}
    `;
export const StartUserRecoveryProcessDocument = gql`
    mutation StartUserRecoveryProcess($email: String!) {
  admin_ {
    startUserRecoveryProcess(email: $email)
  }
}
    `;
export const FinishUserRecoveryProcessDocument = gql`
    mutation FinishUserRecoveryProcess($email: String!) {
  admin_ {
    finishUserRecoveryProcess(email: $email)
  }
}
    `;
export const CompleteLoginDocument = gql`
    mutation CompleteLogin($identityId: String!, $loginChallenge: String!) {
  admin_ {
    completeLogin(identityId: $identityId, loginChallenge: $loginChallenge)
  }
}
    `;
export const GetConsentInfoDocument = gql`
    query getConsentInfo($consentChallenge: String!) {
  admin_ {
    getConsentInfo(consentChallenge: $consentChallenge) {
      challenge
      skip
      client
      subject
      requestedScope
      requestedAccessTokenAudience
      requestUrl
    }
  }
}
    `;
export const HandleOAuth2ConsentDocument = gql`
    mutation handleOAuth2Consent($consentChallenge: String!, $grantScope: [String!]!, $reject: Boolean!, $remember: Boolean!, $rememberFor: Int, $userEmail: String, $grantAudience: [String]) {
  admin_ {
    handleConsent(
      consentChallenge: $consentChallenge
      grantScope: $grantScope
      reject: $reject
      remember: $remember
      rememberFor: $rememberFor
      userEmail: $userEmail
      grantAudience: $grantAudience
    )
  }
}
    `;
export const GetUserInfoLimitedDocument = gql`
    query GetUserInfoLimited {
  admin_ {
    currentUser {
      defaultAccount {
        id
        name
        parentId
        pictureFile {
          url
        }
        status
        accountManagerId
        allChildAccounts {
          name
          parentId
          id
          pictureFile {
            url
          }
          status
          accountManagerId
        }
      }
      id
      firstName
      lastName
      picture
      pictureFile {
        url
      }
      email: userName
      settings
      status
      requiredConsentStatus
      optionalConsentStatus
      assignedRoles {
        id
        name
      }
      assignedTeams {
        name
        id
        assignedRoles {
          id
          name
        }
        assignedProjects {
          id
        }
      }
    }
  }
}
    `;
export const GetUserSettingsLimitedDocument = gql`
    query GetUserSettingsLimited($email: String!) {
  admin_ {
    getLoginInfo(email: $email) {
      recommendedAuthMethod
    }
  }
}
    `;
export const UpdateUserLimitedDocument = gql`
    mutation UpdateUserLimited($id: String!, $accountId: String!, $firstName: String!, $lastName: String!, $picture: String, $status: UserStatus, $requiredConsentStatus: ConsentStatusEnum, $optionalConsentStatus: ConsentStatusEnum, $requiredConsentUpdatedAt: DateTime, $optionalConsentUpdatedAt: DateTime, $settings: JSON, $userIconId: String) {
  admin_ {
    updateUser(
      id: $id
      accountId: $accountId
      firstName: $firstName
      lastName: $lastName
      picture: $picture
      settings: $settings
      requiredConsentStatus: $requiredConsentStatus
      optionalConsentStatus: $optionalConsentStatus
      requiredConsentUpdatedAt: $requiredConsentUpdatedAt
      optionalConsentUpdatedAt: $optionalConsentUpdatedAt
      status: $status
      userIconId: $userIconId
    ) {
      id
      firstName
      lastName
      status
      settings
      picture
      pictureFile {
        url
      }
      email: userName
    }
  }
}
    `;
export const GetLanguagesLimitedDocument = gql`
    query GetLanguagesLimited @cached {
  admin_ {
    localizationSettingsConfig {
      user {
        supportedLanguageCodes
      }
      project {
        supportedLanguageCodes
      }
    }
    locales {
      __typename
      id
      name
      locale
      languageCode
    }
  }
}
    `;
export const GetTimeZonesLimitedDocument = gql`
    query GetTimeZonesLimited @cached {
  admin_ {
    timeZones {
      __typename
      identifier
      label
      id
    }
  }
}
    `;
export const FalsifyUserActiveSessionsLimitedDocument = gql`
    mutation FalsifyUserActiveSessionsLimited {
  admin_ {
    falsifyUserActiveSessions {
      id
    }
  }
}
    `;
export const ProjectsSubscriptionLimitedDocument = gql`
    subscription ProjectsSubscriptionLimited($userId: String!) {
  tenancy_users_by_pk(id: $userId) {
    ...UserAssignedProjects
  }
}
    ${UserAssignedProjectsFragmentDoc}`;
export const GetUserProjectsLimitedDocument = gql`
    query GetUserProjectsLimited($userId: String!) @cached {
  tenancy_users_by_pk(id: $userId) {
    ...UserAssignedProjects
  }
  tenancy_products {
    name
    id
    displayName
  }
}
    ${UserAssignedProjectsFragmentDoc}`;
export const getSdk = (client: Client) => ({
      getUserInfo(variables: GetUserInfoQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, variables, context);
      },
connectAuthMethod(variables: ConnectAuthMethodMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<ConnectAuthMethodMutation, ConnectAuthMethodMutationVariables>(ConnectAuthMethodDocument, variables, context);
      },
getAccountManagerInfo(variables: GetAccountManagerInfoQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetAccountManagerInfoQuery, GetAccountManagerInfoQueryVariables>(GetAccountManagerInfoDocument, variables, context);
      },
getOrganizationsMetadata(variables: GetOrganizationsMetadataQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetOrganizationsMetadataQuery, GetOrganizationsMetadataQueryVariables>(GetOrganizationsMetadataDocument, variables, context);
      },
getUserSettings(variables: GetUserSettingsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetUserSettingsQuery, GetUserSettingsQueryVariables>(GetUserSettingsDocument, variables, context);
      },
getMetabaseFolders(variables: GetMetabaseFoldersQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetMetabaseFoldersQuery, GetMetabaseFoldersQueryVariables>(GetMetabaseFoldersDocument, variables, context);
      },
getAccounts(variables: GetAccountsQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, variables, context);
      },
getAccount(variables: GetAccountQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, variables, context);
      },
deleteProject(variables: DeleteProjectMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, variables, context);
      },
makeDbSnapshot(variables: MakeDbSnapshotMutationVariables = {}, context?: Partial<OperationContext>) {
          return client.mutation<MakeDbSnapshotMutation, MakeDbSnapshotMutationVariables>(MakeDbSnapshotDocument, variables, context);
      },
getProjects(variables: GetProjectsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, variables, context);
      },
getProjectDetails(variables: GetProjectDetailsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetProjectDetailsQuery, GetProjectDetailsQueryVariables>(GetProjectDetailsDocument, variables, context);
      },
getAppletInstancesByProjectId(variables: GetAppletInstancesByProjectIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetAppletInstancesByProjectIdQuery, GetAppletInstancesByProjectIdQueryVariables>(GetAppletInstancesByProjectIdDocument, variables, context);
      },
getProjectLandingPageApollo(variables: GetProjectLandingPageApolloQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetProjectLandingPageApolloQuery, GetProjectLandingPageApolloQueryVariables>(GetProjectLandingPageApolloDocument, variables, context);
      },
getProducts(variables: GetProductsQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, variables, context);
      },
createProject(variables: CreateProjectMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, variables, context);
      },
updateProject(variables: UpdateProjectMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, variables, context);
      },
updateUser(variables: UpdateUserMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, variables, context);
      },
getLanguages(variables: GetLanguagesQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, variables, context);
      },
getTimeZones(variables: GetTimeZonesQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, variables, context);
      },
validateProjectEnvironmentUrls(variables: ValidateProjectEnvironmentUrlsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<ValidateProjectEnvironmentUrlsQuery, ValidateProjectEnvironmentUrlsQueryVariables>(ValidateProjectEnvironmentUrlsDocument, variables, context);
      },
updateProjectEnvironmentConfig(variables: UpdateProjectEnvironmentConfigMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateProjectEnvironmentConfigMutation, UpdateProjectEnvironmentConfigMutationVariables>(UpdateProjectEnvironmentConfigDocument, variables, context);
      },
createAppletTemplate(variables: CreateAppletTemplateMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreateAppletTemplateMutation, CreateAppletTemplateMutationVariables>(CreateAppletTemplateDocument, variables, context);
      },
getAppletTemplates(variables: GetAppletTemplatesQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetAppletTemplatesQuery, GetAppletTemplatesQueryVariables>(GetAppletTemplatesDocument, variables, context);
      },
createPackage(variables: CreatePackageMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreatePackageMutation, CreatePackageMutationVariables>(CreatePackageDocument, variables, context);
      },
getPackages(variables: GetPackagesQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetPackagesQuery, GetPackagesQueryVariables>(GetPackagesDocument, variables, context);
      },
updatePackage(variables: UpdatePackageMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdatePackageMutation, UpdatePackageMutationVariables>(UpdatePackageDocument, variables, context);
      },
projectEnvironmentConfigById(variables: ProjectEnvironmentConfigByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<ProjectEnvironmentConfigByIdQuery, ProjectEnvironmentConfigByIdQueryVariables>(ProjectEnvironmentConfigByIdDocument, variables, context);
      },
createAppletVersion(variables: CreateAppletVersionMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreateAppletVersionMutation, CreateAppletVersionMutationVariables>(CreateAppletVersionDocument, variables, context);
      },
createAppletInstance(variables: CreateAppletInstanceMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreateAppletInstanceMutation, CreateAppletInstanceMutationVariables>(CreateAppletInstanceDocument, variables, context);
      },
appletInstanceById(variables: AppletInstanceByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<AppletInstanceByIdQuery, AppletInstanceByIdQueryVariables>(AppletInstanceByIdDocument, variables, context);
      },
updateAppletInstance(variables: UpdateAppletInstanceMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateAppletInstanceMutation, UpdateAppletInstanceMutationVariables>(UpdateAppletInstanceDocument, variables, context);
      },
deleteApplet(variables: DeleteAppletMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeleteAppletMutation, DeleteAppletMutationVariables>(DeleteAppletDocument, variables, context);
      },
deletePackage(variables: DeletePackageMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeletePackageMutation, DeletePackageMutationVariables>(DeletePackageDocument, variables, context);
      },
deletePackageVersionId(variables: DeletePackageVersionIdMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeletePackageVersionIdMutation, DeletePackageVersionIdMutationVariables>(DeletePackageVersionIdDocument, variables, context);
      },
deleteAppletInstance(variables: DeleteAppletInstanceMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeleteAppletInstanceMutation, DeleteAppletInstanceMutationVariables>(DeleteAppletInstanceDocument, variables, context);
      },
getUsers(variables: GetUsersQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, variables, context);
      },
getTeams(variables: GetTeamsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, variables, context);
      },
getChildAccounts(variables: GetChildAccountsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetChildAccountsQuery, GetChildAccountsQueryVariables>(GetChildAccountsDocument, variables, context);
      },
getAuditLogs(variables: GetAuditLogsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, variables, context);
      },
createAccount(variables: CreateAccountMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, variables, context);
      },
updateAccount(variables: UpdateAccountMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, variables, context);
      },
deleteAccount(variables: DeleteAccountMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, variables, context);
      },
getAccountById(variables: GetAccountByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetAccountByIdQuery, GetAccountByIdQueryVariables>(GetAccountByIdDocument, variables, context);
      },
getProjectById(variables: GetProjectByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, variables, context);
      },
getTeamById(variables: GetTeamByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetTeamByIdQuery, GetTeamByIdQueryVariables>(GetTeamByIdDocument, variables, context);
      },
getUserById(variables: GetUserByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, variables, context);
      },
getProjectEnvironmentConfigById(variables: GetProjectEnvironmentConfigByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetProjectEnvironmentConfigByIdQuery, GetProjectEnvironmentConfigByIdQueryVariables>(GetProjectEnvironmentConfigByIdDocument, variables, context);
      },
userSessionSubscription(variables: UserSessionSubscriptionSubscriptionVariables, context?: Partial<OperationContext>) {
          return client.subscription<UserSessionSubscriptionSubscription, UserSessionSubscriptionSubscriptionVariables>(UserSessionSubscriptionDocument, variables, context);
      },
getUserDetails(variables: GetUserDetailsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, variables, context);
      },
getUserAuthMethods(variables: GetUserAuthMethodsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetUserAuthMethodsQuery, GetUserAuthMethodsQueryVariables>(GetUserAuthMethodsDocument, variables, context);
      },
getTeamDetails(variables: GetTeamDetailsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetTeamDetailsQuery, GetTeamDetailsQueryVariables>(GetTeamDetailsDocument, variables, context);
      },
getNewTeamDetails(variables: GetNewTeamDetailsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetNewTeamDetailsQuery, GetNewTeamDetailsQueryVariables>(GetNewTeamDetailsDocument, variables, context);
      },
updateTeam(variables: UpdateTeamMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, variables, context);
      },
createTeam(variables: CreateTeamMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, variables, context);
      },
deleteTeams(variables: DeleteTeamsMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeleteTeamsMutation, DeleteTeamsMutationVariables>(DeleteTeamsDocument, variables, context);
      },
setTeamAccountProjectRoles(variables: SetTeamAccountProjectRolesMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<SetTeamAccountProjectRolesMutation, SetTeamAccountProjectRolesMutationVariables>(SetTeamAccountProjectRolesDocument, variables, context);
      },
setUserAccountProjectsRoles(variables: SetUserAccountProjectsRolesMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<SetUserAccountProjectsRolesMutation, SetUserAccountProjectsRolesMutationVariables>(SetUserAccountProjectsRolesDocument, variables, context);
      },
updateUserAccountRoles(variables: UpdateUserAccountRolesMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateUserAccountRolesMutation, UpdateUserAccountRolesMutationVariables>(UpdateUserAccountRolesDocument, variables, context);
      },
addUserToAccount(variables: AddUserToAccountMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<AddUserToAccountMutation, AddUserToAccountMutationVariables>(AddUserToAccountDocument, variables, context);
      },
removeUserFromAccount(variables: RemoveUserFromAccountMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<RemoveUserFromAccountMutation, RemoveUserFromAccountMutationVariables>(RemoveUserFromAccountDocument, variables, context);
      },
getAccountDetails(variables: GetAccountDetailsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>(GetAccountDetailsDocument, variables, context);
      },
getTeamProjectsDetails(variables: GetTeamProjectsDetailsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetTeamProjectsDetailsQuery, GetTeamProjectsDetailsQueryVariables>(GetTeamProjectsDetailsDocument, variables, context);
      },
getUserProjectsHasura(variables: GetUserProjectsHasuraQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetUserProjectsHasuraQuery, GetUserProjectsHasuraQueryVariables>(GetUserProjectsHasuraDocument, variables, context);
      },
getAssetsFiles(variables: GetAssetsFilesQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetAssetsFilesQuery, GetAssetsFilesQueryVariables>(GetAssetsFilesDocument, variables, context);
      },
getConfigsFiles(variables: GetConfigsFilesQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetConfigsFilesQuery, GetConfigsFilesQueryVariables>(GetConfigsFilesDocument, variables, context);
      },
getScriptsFiles(variables: GetScriptsFilesQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetScriptsFilesQuery, GetScriptsFilesQueryVariables>(GetScriptsFilesDocument, variables, context);
      },
getCustomAssetsFiles(variables: GetCustomAssetsFilesQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetCustomAssetsFilesQuery, GetCustomAssetsFilesQueryVariables>(GetCustomAssetsFilesDocument, variables, context);
      },
deleteAgentManagerFile(variables: DeleteAgentManagerFileMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeleteAgentManagerFileMutation, DeleteAgentManagerFileMutationVariables>(DeleteAgentManagerFileDocument, variables, context);
      },
createChannel(variables: CreateChannelMutationVariables = {}, context?: Partial<OperationContext>) {
          return client.mutation<CreateChannelMutation, CreateChannelMutationVariables>(CreateChannelDocument, variables, context);
      },
patchV3ConfigurationCustomersCustomerIdChannelChannelId(variables: PatchV3ConfigurationCustomersCustomerIdChannelChannelIdMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PatchV3ConfigurationCustomersCustomerIdChannelChannelIdMutation, PatchV3ConfigurationCustomersCustomerIdChannelChannelIdMutationVariables>(PatchV3ConfigurationCustomersCustomerIdChannelChannelIdDocument, variables, context);
      },
patchV3ConfigurationCustomersCustomerIdChannelChannelIdSandbox(variables: PatchV3ConfigurationCustomersCustomerIdChannelChannelIdSandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PatchV3ConfigurationCustomersCustomerIdChannelChannelIdSandboxMutation, PatchV3ConfigurationCustomersCustomerIdChannelChannelIdSandboxMutationVariables>(PatchV3ConfigurationCustomersCustomerIdChannelChannelIdSandboxDocument, variables, context);
      },
updateAnalyticsForChannel(variables: UpdateAnalyticsForChannelMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateAnalyticsForChannelMutation, UpdateAnalyticsForChannelMutationVariables>(UpdateAnalyticsForChannelDocument, variables, context);
      },
solutionUserPresenceSubscription(variables: SolutionUserPresenceSubscriptionSubscriptionVariables, context?: Partial<OperationContext>) {
          return client.subscription<SolutionUserPresenceSubscriptionSubscription, SolutionUserPresenceSubscriptionSubscriptionVariables>(SolutionUserPresenceSubscriptionDocument, variables, context);
      },
upsertSolutionUserPresence(variables: UpsertSolutionUserPresenceMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpsertSolutionUserPresenceMutation, UpsertSolutionUserPresenceMutationVariables>(UpsertSolutionUserPresenceDocument, variables, context);
      },
getCredentials(variables: GetCredentialsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetCredentialsQuery, GetCredentialsQueryVariables>(GetCredentialsDocument, variables, context);
      },
createCredential(variables: CreateCredentialMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreateCredentialMutation, CreateCredentialMutationVariables>(CreateCredentialDocument, variables, context);
      },
getPypeRuleGroups(variables: GetPypeRuleGroupsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetPypeRuleGroupsQuery, GetPypeRuleGroupsQueryVariables>(GetPypeRuleGroupsDocument, variables, context);
      },
createPypeRuleGroup(variables: CreatePypeRuleGroupMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreatePypeRuleGroupMutation, CreatePypeRuleGroupMutationVariables>(CreatePypeRuleGroupDocument, variables, context);
      },
updatePypeRuleGroup(variables: UpdatePypeRuleGroupMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdatePypeRuleGroupMutation, UpdatePypeRuleGroupMutationVariables>(UpdatePypeRuleGroupDocument, variables, context);
      },
deletePypeRuleGroup(variables: DeletePypeRuleGroupMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeletePypeRuleGroupMutation, DeletePypeRuleGroupMutationVariables>(DeletePypeRuleGroupDocument, variables, context);
      },
addPypeToPypeRuleGroup(variables: AddPypeToPypeRuleGroupMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<AddPypeToPypeRuleGroupMutation, AddPypeToPypeRuleGroupMutationVariables>(AddPypeToPypeRuleGroupDocument, variables, context);
      },
removePypeFromPypeRuleGroup(variables: RemovePypeFromPypeRuleGroupMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<RemovePypeFromPypeRuleGroupMutation, RemovePypeFromPypeRuleGroupMutationVariables>(RemovePypeFromPypeRuleGroupDocument, variables, context);
      },
getPypeConnections(variables: GetPypeConnectionsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetPypeConnectionsQuery, GetPypeConnectionsQueryVariables>(GetPypeConnectionsDocument, variables, context);
      },
createPypeConnection(variables: CreatePypeConnectionMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreatePypeConnectionMutation, CreatePypeConnectionMutationVariables>(CreatePypeConnectionDocument, variables, context);
      },
updatePypeConnection(variables: UpdatePypeConnectionMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdatePypeConnectionMutation, UpdatePypeConnectionMutationVariables>(UpdatePypeConnectionDocument, variables, context);
      },
deletePypeConnection(variables: DeletePypeConnectionMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeletePypeConnectionMutation, DeletePypeConnectionMutationVariables>(DeletePypeConnectionDocument, variables, context);
      },
addPypeToPypeConnection(variables: AddPypeToPypeConnectionMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<AddPypeToPypeConnectionMutation, AddPypeToPypeConnectionMutationVariables>(AddPypeToPypeConnectionDocument, variables, context);
      },
removePypeFromPypeConnection(variables: RemovePypeFromPypeConnectionMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<RemovePypeFromPypeConnectionMutation, RemovePypeFromPypeConnectionMutationVariables>(RemovePypeFromPypeConnectionDocument, variables, context);
      },
getAgentRoutingSchemas(variables: GetAgentRoutingSchemasQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetAgentRoutingSchemasQuery, GetAgentRoutingSchemasQueryVariables>(GetAgentRoutingSchemasDocument, variables, context);
      },
bulkUpdatePypesLive(variables: BulkUpdatePypesLiveMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<BulkUpdatePypesLiveMutation, BulkUpdatePypesLiveMutationVariables>(BulkUpdatePypesLiveDocument, variables, context);
      },
bulkUpdatePypesSandbox(variables: BulkUpdatePypesSandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<BulkUpdatePypesSandboxMutation, BulkUpdatePypesSandboxMutationVariables>(BulkUpdatePypesSandboxDocument, variables, context);
      },
putLiveAgentPypeLive(variables: PutLiveAgentPypeLiveMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PutLiveAgentPypeLiveMutation, PutLiveAgentPypeLiveMutationVariables>(PutLiveAgentPypeLiveDocument, variables, context);
      },
putLiveAgentPypeSandbox(variables: PutLiveAgentPypeSandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PutLiveAgentPypeSandboxMutation, PutLiveAgentPypeSandboxMutationVariables>(PutLiveAgentPypeSandboxDocument, variables, context);
      },
getProStudioPerformanceMetrics(variables: GetProStudioPerformanceMetricsQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetProStudioPerformanceMetricsQuery, GetProStudioPerformanceMetricsQueryVariables>(GetProStudioPerformanceMetricsDocument, variables, context);
      },
getProStudioPerformanceMetricById(variables: GetProStudioPerformanceMetricByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetProStudioPerformanceMetricByIdQuery, GetProStudioPerformanceMetricByIdQueryVariables>(GetProStudioPerformanceMetricByIdDocument, variables, context);
      },
getCustomers(variables: GetCustomersQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, variables, context);
      },
getEnvsList(variables: GetEnvsListQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetEnvsListQuery, GetEnvsListQueryVariables>(GetEnvsListDocument, variables, context);
      },
getProStudioVersionData(variables: GetProStudioVersionDataQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetProStudioVersionDataQuery, GetProStudioVersionDataQueryVariables>(GetProStudioVersionDataDocument, variables, context);
      },
updateProStudioVersionSync(variables: UpdateProStudioVersionSyncMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateProStudioVersionSyncMutation, UpdateProStudioVersionSyncMutationVariables>(UpdateProStudioVersionSyncDocument, variables, context);
      },
updateProStudioVersionValidation(variables: UpdateProStudioVersionValidationMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateProStudioVersionValidationMutation, UpdateProStudioVersionValidationMutationVariables>(UpdateProStudioVersionValidationDocument, variables, context);
      },
getProStudioNodeVersions(variables: GetProStudioNodeVersionsQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetProStudioNodeVersionsQuery, GetProStudioNodeVersionsQueryVariables>(GetProStudioNodeVersionsDocument, variables, context);
      },
deleteProStudioNode(variables: DeleteProStudioNodeMutationVariables = {}, context?: Partial<OperationContext>) {
          return client.mutation<DeleteProStudioNodeMutation, DeleteProStudioNodeMutationVariables>(DeleteProStudioNodeDocument, variables, context);
      },
deleteProStudioNodes(variables: DeleteProStudioNodesMutationVariables = {}, context?: Partial<OperationContext>) {
          return client.mutation<DeleteProStudioNodesMutation, DeleteProStudioNodesMutationVariables>(DeleteProStudioNodesDocument, variables, context);
      },
deleteAllProStudioNodes(variables: DeleteAllProStudioNodesMutationVariables = {}, context?: Partial<OperationContext>) {
          return client.mutation<DeleteAllProStudioNodesMutation, DeleteAllProStudioNodesMutationVariables>(DeleteAllProStudioNodesDocument, variables, context);
      },
getProStudioNodes(variables: GetProStudioNodesQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetProStudioNodesQuery, GetProStudioNodesQueryVariables>(GetProStudioNodesDocument, variables, context);
      },
updateProStudioNodeOrders(variables: UpdateProStudioNodeOrdersMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateProStudioNodeOrdersMutation, UpdateProStudioNodeOrdersMutationVariables>(UpdateProStudioNodeOrdersDocument, variables, context);
      },
updateProStudioNodes(variables: UpdateProStudioNodesMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateProStudioNodesMutation, UpdateProStudioNodesMutationVariables>(UpdateProStudioNodesDocument, variables, context);
      },
postHistorySearch(variables: PostHistorySearchMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PostHistorySearchMutation, PostHistorySearchMutationVariables>(PostHistorySearchDocument, variables, context);
      },
getCustomerData(variables: GetCustomerDataQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetCustomerDataQuery, GetCustomerDataQueryVariables>(GetCustomerDataDocument, variables, context);
      },
getBotById(variables: GetBotByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetBotByIdQuery, GetBotByIdQueryVariables>(GetBotByIdDocument, variables, context);
      },
getBotData(variables: GetBotDataQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetBotDataQuery, GetBotDataQueryVariables>(GetBotDataDocument, variables, context);
      },
getVersionById(variables: GetVersionByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetVersionByIdQuery, GetVersionByIdQueryVariables>(GetVersionByIdDocument, variables, context);
      },
validateVersion(variables: ValidateVersionQueryVariables, context?: Partial<OperationContext>) {
          return client.query<ValidateVersionQuery, ValidateVersionQueryVariables>(ValidateVersionDocument, variables, context);
      },
createCustomerBot(variables: CreateCustomerBotMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreateCustomerBotMutation, CreateCustomerBotMutationVariables>(CreateCustomerBotDocument, variables, context);
      },
createBotVersion(variables: CreateBotVersionMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreateBotVersionMutation, CreateBotVersionMutationVariables>(CreateBotVersionDocument, variables, context);
      },
deleteBot(variables: DeleteBotMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeleteBotMutation, DeleteBotMutationVariables>(DeleteBotDocument, variables, context);
      },
getVersionFile(variables: GetVersionFileQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetVersionFileQuery, GetVersionFileQueryVariables>(GetVersionFileDocument, variables, context);
      },
deployBotVersion(variables: DeployBotVersionMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeployBotVersionMutation, DeployBotVersionMutationVariables>(DeployBotVersionDocument, variables, context);
      },
patchBotById(variables: PatchBotByIdMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PatchBotByIdMutation, PatchBotByIdMutationVariables>(PatchBotByIdDocument, variables, context);
      },
patchBotTranslation(variables: PatchBotTranslationMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PatchBotTranslationMutation, PatchBotTranslationMutationVariables>(PatchBotTranslationDocument, variables, context);
      },
putVersionTrain(variables: PutVersionTrainMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PutVersionTrainMutation, PutVersionTrainMutationVariables>(PutVersionTrainDocument, variables, context);
      },
getAssetById(variables: GetAssetByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetAssetByIdQuery, GetAssetByIdQueryVariables>(GetAssetByIdDocument, variables, context);
      },
deleteBotAsset(variables: DeleteBotAssetMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeleteBotAssetMutation, DeleteBotAssetMutationVariables>(DeleteBotAssetDocument, variables, context);
      },
deleteScriptById(variables: DeleteScriptByIdMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeleteScriptByIdMutation, DeleteScriptByIdMutationVariables>(DeleteScriptByIdDocument, variables, context);
      },
getCustomerPypesV6(variables: GetCustomerPypesV6QueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetCustomerPypesV6Query, GetCustomerPypesV6QueryVariables>(GetCustomerPypesV6Document, variables, context);
      },
mutatePostWidgetLive(variables: MutatePostWidgetLiveMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<MutatePostWidgetLiveMutation, MutatePostWidgetLiveMutationVariables>(MutatePostWidgetLiveDocument, variables, context);
      },
mutatePostWidgetSandbox(variables: MutatePostWidgetSandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<MutatePostWidgetSandboxMutation, MutatePostWidgetSandboxMutationVariables>(MutatePostWidgetSandboxDocument, variables, context);
      },
mutatePutWidgetLive(variables: MutatePutWidgetLiveMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<MutatePutWidgetLiveMutation, MutatePutWidgetLiveMutationVariables>(MutatePutWidgetLiveDocument, variables, context);
      },
mutatePutWidgetSandbox(variables: MutatePutWidgetSandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<MutatePutWidgetSandboxMutation, MutatePutWidgetSandboxMutationVariables>(MutatePutWidgetSandboxDocument, variables, context);
      },
createStreamLive(variables: CreateStreamLiveMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreateStreamLiveMutation, CreateStreamLiveMutationVariables>(CreateStreamLiveDocument, variables, context);
      },
createStreamSandbox(variables: CreateStreamSandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreateStreamSandboxMutation, CreateStreamSandboxMutationVariables>(CreateStreamSandboxDocument, variables, context);
      },
updateStreamBotLive(variables: UpdateStreamBotLiveMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateStreamBotLiveMutation, UpdateStreamBotLiveMutationVariables>(UpdateStreamBotLiveDocument, variables, context);
      },
updateStreamBotSandbox(variables: UpdateStreamBotSandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateStreamBotSandboxMutation, UpdateStreamBotSandboxMutationVariables>(UpdateStreamBotSandboxDocument, variables, context);
      },
getCustomersPypesAutoresponders(variables: GetCustomersPypesAutorespondersQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetCustomersPypesAutorespondersQuery, GetCustomersPypesAutorespondersQueryVariables>(GetCustomersPypesAutorespondersDocument, variables, context);
      },
putCustomerPypeLive(variables: PutCustomerPypeLiveMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PutCustomerPypeLiveMutation, PutCustomerPypeLiveMutationVariables>(PutCustomerPypeLiveDocument, variables, context);
      },
putCustomerPypeSandbox(variables: PutCustomerPypeSandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PutCustomerPypeSandboxMutation, PutCustomerPypeSandboxMutationVariables>(PutCustomerPypeSandboxDocument, variables, context);
      },
patchPypeConfigLive(variables: PatchPypeConfigLiveMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PatchPypeConfigLiveMutation, PatchPypeConfigLiveMutationVariables>(PatchPypeConfigLiveDocument, variables, context);
      },
patchPypeConfigSandbox(variables: PatchPypeConfigSandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PatchPypeConfigSandboxMutation, PatchPypeConfigSandboxMutationVariables>(PatchPypeConfigSandboxDocument, variables, context);
      },
getPypeConfigLive(variables: GetPypeConfigLiveQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetPypeConfigLiveQuery, GetPypeConfigLiveQueryVariables>(GetPypeConfigLiveDocument, variables, context);
      },
getPypeConfigSandbox(variables: GetPypeConfigSandboxQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetPypeConfigSandboxQuery, GetPypeConfigSandboxQueryVariables>(GetPypeConfigSandboxDocument, variables, context);
      },
getExternalAgentSchemas(variables: GetExternalAgentSchemasQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetExternalAgentSchemasQuery, GetExternalAgentSchemasQueryVariables>(GetExternalAgentSchemasDocument, variables, context);
      },
deletePypeLive(variables: DeletePypeLiveMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeletePypeLiveMutation, DeletePypeLiveMutationVariables>(DeletePypeLiveDocument, variables, context);
      },
deletePypeSandbox(variables: DeletePypeSandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeletePypeSandboxMutation, DeletePypeSandboxMutationVariables>(DeletePypeSandboxDocument, variables, context);
      },
uploadBotAsset(variables: UploadBotAssetMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UploadBotAssetMutation, UploadBotAssetMutationVariables>(UploadBotAssetDocument, variables, context);
      },
postVersionsConfig(variables: PostVersionsConfigMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PostVersionsConfigMutation, PostVersionsConfigMutationVariables>(PostVersionsConfigDocument, variables, context);
      },
postVersionsScript(variables: PostVersionsScriptMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PostVersionsScriptMutation, PostVersionsScriptMutationVariables>(PostVersionsScriptDocument, variables, context);
      },
getUserProjects(variables: GetUserProjectsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetUserProjectsQuery, GetUserProjectsQueryVariables>(GetUserProjectsDocument, variables, context);
      },
getUserPictureByEmail(variables: GetUserPictureByEmailQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetUserPictureByEmailQuery, GetUserPictureByEmailQueryVariables>(GetUserPictureByEmailDocument, variables, context);
      },
updateColumnsWidth(variables: UpdateColumnsWidthMutationVariables = {}, context?: Partial<OperationContext>) {
          return client.mutation<UpdateColumnsWidthMutation, UpdateColumnsWidthMutationVariables>(UpdateColumnsWidthDocument, variables, context);
      },
updateColumnPinningSettings(variables: UpdateColumnPinningSettingsMutationVariables = {}, context?: Partial<OperationContext>) {
          return client.mutation<UpdateColumnPinningSettingsMutation, UpdateColumnPinningSettingsMutationVariables>(UpdateColumnPinningSettingsDocument, variables, context);
      },
updateColumnWrapSettings(variables: UpdateColumnWrapSettingsMutationVariables = {}, context?: Partial<OperationContext>) {
          return client.mutation<UpdateColumnWrapSettingsMutation, UpdateColumnWrapSettingsMutationVariables>(UpdateColumnWrapSettingsDocument, variables, context);
      },
getStudioResources(variables: GetStudioResourcesQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetStudioResourcesQuery, GetStudioResourcesQueryVariables>(GetStudioResourcesDocument, variables, context);
      },
getActionNodeNames(variables: GetActionNodeNamesQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetActionNodeNamesQuery, GetActionNodeNamesQueryVariables>(GetActionNodeNamesDocument, variables, context);
      },
mutatePutWidgetAppDesign(variables: MutatePutWidgetAppDesignMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<MutatePutWidgetAppDesignMutation, MutatePutWidgetAppDesignMutationVariables>(MutatePutWidgetAppDesignDocument, variables, context);
      },
mutatePutWidgetAppDesignSandbox(variables: MutatePutWidgetAppDesignSandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<MutatePutWidgetAppDesignSandboxMutation, MutatePutWidgetAppDesignSandboxMutationVariables>(MutatePutWidgetAppDesignSandboxDocument, variables, context);
      },
getProjectUsers(variables: GetProjectUsersQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetProjectUsersQuery, GetProjectUsersQueryVariables>(GetProjectUsersDocument, variables, context);
      },
assignProjectProductAdminRoles(variables: AssignProjectProductAdminRolesMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<AssignProjectProductAdminRolesMutation, AssignProjectProductAdminRolesMutationVariables>(AssignProjectProductAdminRolesDocument, variables, context);
      },
getProviders(variables: GetProvidersQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetProvidersQuery, GetProvidersQueryVariables>(GetProvidersDocument, variables, context);
      },
getPypeKeysLive(variables: GetPypeKeysLiveQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetPypeKeysLiveQuery, GetPypeKeysLiveQueryVariables>(GetPypeKeysLiveDocument, variables, context);
      },
getPypeKeysSandbox(variables: GetPypeKeysSandboxQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetPypeKeysSandboxQuery, GetPypeKeysSandboxQueryVariables>(GetPypeKeysSandboxDocument, variables, context);
      },
postPypeKeyLive(variables: PostPypeKeyLiveMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PostPypeKeyLiveMutation, PostPypeKeyLiveMutationVariables>(PostPypeKeyLiveDocument, variables, context);
      },
postPypeKeySandbox(variables: PostPypeKeySandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PostPypeKeySandboxMutation, PostPypeKeySandboxMutationVariables>(PostPypeKeySandboxDocument, variables, context);
      },
putPypeKeyLive(variables: PutPypeKeyLiveMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PutPypeKeyLiveMutation, PutPypeKeyLiveMutationVariables>(PutPypeKeyLiveDocument, variables, context);
      },
putPypeKeySandbox(variables: PutPypeKeySandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PutPypeKeySandboxMutation, PutPypeKeySandboxMutationVariables>(PutPypeKeySandboxDocument, variables, context);
      },
deletePypeKeyLive(variables: DeletePypeKeyLiveMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeletePypeKeyLiveMutation, DeletePypeKeyLiveMutationVariables>(DeletePypeKeyLiveDocument, variables, context);
      },
deletePypeKeySandbox(variables: DeletePypeKeySandboxMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeletePypeKeySandboxMutation, DeletePypeKeySandboxMutationVariables>(DeletePypeKeySandboxDocument, variables, context);
      },
createSolution(variables: CreateSolutionMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CreateSolutionMutation, CreateSolutionMutationVariables>(CreateSolutionDocument, variables, context);
      },
updateSolutionVersion(variables: UpdateSolutionVersionMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateSolutionVersionMutation, UpdateSolutionVersionMutationVariables>(UpdateSolutionVersionDocument, variables, context);
      },
updateSolutionDisplayName(variables: UpdateSolutionDisplayNameMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateSolutionDisplayNameMutation, UpdateSolutionDisplayNameMutationVariables>(UpdateSolutionDisplayNameDocument, variables, context);
      },
updateSolutionType(variables: UpdateSolutionTypeMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateSolutionTypeMutation, UpdateSolutionTypeMutationVariables>(UpdateSolutionTypeDocument, variables, context);
      },
deleteSolution(variables: DeleteSolutionMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<DeleteSolutionMutation, DeleteSolutionMutationVariables>(DeleteSolutionDocument, variables, context);
      },
publishSolutionVersion(variables: PublishSolutionVersionMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<PublishSolutionVersionMutation, PublishSolutionVersionMutationVariables>(PublishSolutionVersionDocument, variables, context);
      },
republishSolutionDeployment(variables: RepublishSolutionDeploymentMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<RepublishSolutionDeploymentMutation, RepublishSolutionDeploymentMutationVariables>(RepublishSolutionDeploymentDocument, variables, context);
      },
getSolutions(variables: GetSolutionsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetSolutionsQuery, GetSolutionsQueryVariables>(GetSolutionsDocument, variables, context);
      },
getSolutionVersions(variables: GetSolutionVersionsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetSolutionVersionsQuery, GetSolutionVersionsQueryVariables>(GetSolutionVersionsDocument, variables, context);
      },
getSolutionVersionById(variables: GetSolutionVersionByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetSolutionVersionByIdQuery, GetSolutionVersionByIdQueryVariables>(GetSolutionVersionByIdDocument, variables, context);
      },
getSolutionById(variables: GetSolutionByIdQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetSolutionByIdQuery, GetSolutionByIdQueryVariables>(GetSolutionByIdDocument, variables, context);
      },
getSolutionDeploymentHistory(variables: GetSolutionDeploymentHistoryQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetSolutionDeploymentHistoryQuery, GetSolutionDeploymentHistoryQueryVariables>(GetSolutionDeploymentHistoryDocument, variables, context);
      },
getSolutionVersionPsKeys(variables: GetSolutionVersionPsKeysQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetSolutionVersionPsKeysQuery, GetSolutionVersionPsKeysQueryVariables>(GetSolutionVersionPsKeysDocument, variables, context);
      },
solutionDeploymentsSubscription(variables: SolutionDeploymentsSubscriptionSubscriptionVariables, context?: Partial<OperationContext>) {
          return client.subscription<SolutionDeploymentsSubscriptionSubscription, SolutionDeploymentsSubscriptionSubscriptionVariables>(SolutionDeploymentsSubscriptionDocument, variables, context);
      },
getSolutionDeploymentForVersion(variables: GetSolutionDeploymentForVersionQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetSolutionDeploymentForVersionQuery, GetSolutionDeploymentForVersionQueryVariables>(GetSolutionDeploymentForVersionDocument, variables, context);
      },
getSolutionPublishedEnvironments(variables: GetSolutionPublishedEnvironmentsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetSolutionPublishedEnvironmentsQuery, GetSolutionPublishedEnvironmentsQueryVariables>(GetSolutionPublishedEnvironmentsDocument, variables, context);
      },
getSolutionDeploymentLogs(variables: GetSolutionDeploymentLogsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetSolutionDeploymentLogsQuery, GetSolutionDeploymentLogsQueryVariables>(GetSolutionDeploymentLogsDocument, variables, context);
      },
solutionPublishStatusSubscription(variables: SolutionPublishStatusSubscriptionSubscriptionVariables, context?: Partial<OperationContext>) {
          return client.subscription<SolutionPublishStatusSubscriptionSubscription, SolutionPublishStatusSubscriptionSubscriptionVariables>(SolutionPublishStatusSubscriptionDocument, variables, context);
      },
solutionVersionStatusSubscription(variables: SolutionVersionStatusSubscriptionSubscriptionVariables, context?: Partial<OperationContext>) {
          return client.subscription<SolutionVersionStatusSubscriptionSubscription, SolutionVersionStatusSubscriptionSubscriptionVariables>(SolutionVersionStatusSubscriptionDocument, variables, context);
      },
solutionVersionSubscription(variables: SolutionVersionSubscriptionSubscriptionVariables = {}, context?: Partial<OperationContext>) {
          return client.subscription<SolutionVersionSubscriptionSubscription, SolutionVersionSubscriptionSubscriptionVariables>(SolutionVersionSubscriptionDocument, variables, context);
      },
getVoiceAiProviders(variables: GetVoiceAiProvidersQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetVoiceAiProvidersQuery, GetVoiceAiProvidersQueryVariables>(GetVoiceAiProvidersDocument, variables, context);
      },
getVoiceAiProvidersSandbox(variables: GetVoiceAiProvidersSandboxQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetVoiceAiProvidersSandboxQuery, GetVoiceAiProvidersSandboxQueryVariables>(GetVoiceAiProvidersSandboxDocument, variables, context);
      },
getVoiceAiVoicesV2(variables: GetVoiceAiVoicesV2QueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetVoiceAiVoicesV2Query, GetVoiceAiVoicesV2QueryVariables>(GetVoiceAiVoicesV2Document, variables, context);
      },
getVoiceAiAccents(variables: GetVoiceAiAccentsQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetVoiceAiAccentsQuery, GetVoiceAiAccentsQueryVariables>(GetVoiceAiAccentsDocument, variables, context);
      },
getVoiceAiLanguages(variables: GetVoiceAiLanguagesQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetVoiceAiLanguagesQuery, GetVoiceAiLanguagesQueryVariables>(GetVoiceAiLanguagesDocument, variables, context);
      },
getUserLoginInfo(variables: GetUserLoginInfoQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetUserLoginInfoQuery, GetUserLoginInfoQueryVariables>(GetUserLoginInfoDocument, variables, context);
      },
setUserPasswordRecoveryStatus(variables: SetUserPasswordRecoveryStatusMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<SetUserPasswordRecoveryStatusMutation, SetUserPasswordRecoveryStatusMutationVariables>(SetUserPasswordRecoveryStatusDocument, variables, context);
      },
startUserRecoveryProcess(variables: StartUserRecoveryProcessMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<StartUserRecoveryProcessMutation, StartUserRecoveryProcessMutationVariables>(StartUserRecoveryProcessDocument, variables, context);
      },
finishUserRecoveryProcess(variables: FinishUserRecoveryProcessMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<FinishUserRecoveryProcessMutation, FinishUserRecoveryProcessMutationVariables>(FinishUserRecoveryProcessDocument, variables, context);
      },
completeLogin(variables: CompleteLoginMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<CompleteLoginMutation, CompleteLoginMutationVariables>(CompleteLoginDocument, variables, context);
      },
getConsentInfo(variables: GetConsentInfoQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetConsentInfoQuery, GetConsentInfoQueryVariables>(GetConsentInfoDocument, variables, context);
      },
handleOAuth2Consent(variables: HandleOAuth2ConsentMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<HandleOAuth2ConsentMutation, HandleOAuth2ConsentMutationVariables>(HandleOAuth2ConsentDocument, variables, context);
      },
getUserInfoLimited(variables: GetUserInfoLimitedQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetUserInfoLimitedQuery, GetUserInfoLimitedQueryVariables>(GetUserInfoLimitedDocument, variables, context);
      },
getUserSettingsLimited(variables: GetUserSettingsLimitedQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetUserSettingsLimitedQuery, GetUserSettingsLimitedQueryVariables>(GetUserSettingsLimitedDocument, variables, context);
      },
updateUserLimited(variables: UpdateUserLimitedMutationVariables, context?: Partial<OperationContext>) {
          return client.mutation<UpdateUserLimitedMutation, UpdateUserLimitedMutationVariables>(UpdateUserLimitedDocument, variables, context);
      },
getLanguagesLimited(variables: GetLanguagesLimitedQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetLanguagesLimitedQuery, GetLanguagesLimitedQueryVariables>(GetLanguagesLimitedDocument, variables, context);
      },
getTimeZonesLimited(variables: GetTimeZonesLimitedQueryVariables = {}, context?: Partial<OperationContext>) {
          return client.query<GetTimeZonesLimitedQuery, GetTimeZonesLimitedQueryVariables>(GetTimeZonesLimitedDocument, variables, context);
      },
falsifyUserActiveSessionsLimited(variables: FalsifyUserActiveSessionsLimitedMutationVariables = {}, context?: Partial<OperationContext>) {
          return client.mutation<FalsifyUserActiveSessionsLimitedMutation, FalsifyUserActiveSessionsLimitedMutationVariables>(FalsifyUserActiveSessionsLimitedDocument, variables, context);
      },
projectsSubscriptionLimited(variables: ProjectsSubscriptionLimitedSubscriptionVariables, context?: Partial<OperationContext>) {
          return client.subscription<ProjectsSubscriptionLimitedSubscription, ProjectsSubscriptionLimitedSubscriptionVariables>(ProjectsSubscriptionLimitedDocument, variables, context);
      },
getUserProjectsLimited(variables: GetUserProjectsLimitedQueryVariables, context?: Partial<OperationContext>) {
          return client.query<GetUserProjectsLimitedQuery, GetUserProjectsLimitedQueryVariables>(GetUserProjectsLimitedDocument, variables, context);
      }
    });
    export type SdkType = ReturnType<typeof getSdk>
